/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		168707334958949:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + window["webpackManifest"][chunkId];
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// expose the chunks object
/******/ 	__webpack_require__.s = installedChunks;
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1049);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1743)();
	}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _grid = __webpack_require__(16);
	
	Object.defineProperty(exports, 'Flex', {
	  enumerable: true,
	  get: function get() {
	    return _grid.Flex;
	  }
	});
	Object.defineProperty(exports, 'Box', {
	  enumerable: true,
	  get: function get() {
	    return _grid.Box;
	  }
	});
	
	var _theme = __webpack_require__(122);
	
	Object.defineProperty(exports, 'theme', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_theme).default;
	  }
	});
	
	var _colors = __webpack_require__(121);
	
	Object.defineProperty(exports, 'colors', {
	  enumerable: true,
	  get: function get() {
	    return _colors.colors;
	  }
	});
	Object.defineProperty(exports, 'createColors', {
	  enumerable: true,
	  get: function get() {
	    return _colors.createColors;
	  }
	});
	
	var _Base = __webpack_require__(2052);
	
	Object.defineProperty(exports, 'Base', {
	  enumerable: true,
	  get: function get() {
	    return _Base.Base;
	  }
	});
	
	var _CSS = __webpack_require__(2058);
	
	Object.defineProperty(exports, 'CSS', {
	  enumerable: true,
	  get: function get() {
	    return _CSS.CSS;
	  }
	});
	
	var _Root = __webpack_require__(197);
	
	Object.defineProperty(exports, 'Root', {
	  enumerable: true,
	  get: function get() {
	    return _Root.Root;
	  }
	});
	
	var _Provider = __webpack_require__(2088);
	
	Object.defineProperty(exports, 'Provider', {
	  enumerable: true,
	  get: function get() {
	    return _Provider.Provider;
	  }
	});
	
	var _DarkMode = __webpack_require__(2067);
	
	Object.defineProperty(exports, 'DarkMode', {
	  enumerable: true,
	  get: function get() {
	    return _DarkMode.DarkMode;
	  }
	});
	Object.defineProperty(exports, 'invertTheme', {
	  enumerable: true,
	  get: function get() {
	    return _DarkMode.invertTheme;
	  }
	});
	
	var _Button = __webpack_require__(80);
	
	Object.defineProperty(exports, 'Button', {
	  enumerable: true,
	  get: function get() {
	    return _Button.Button;
	  }
	});
	
	var _ButtonOutline = __webpack_require__(2057);
	
	Object.defineProperty(exports, 'ButtonOutline', {
	  enumerable: true,
	  get: function get() {
	    return _ButtonOutline.ButtonOutline;
	  }
	});
	
	var _ButtonCircle = __webpack_require__(2056);
	
	Object.defineProperty(exports, 'ButtonCircle', {
	  enumerable: true,
	  get: function get() {
	    return _ButtonCircle.ButtonCircle;
	  }
	});
	
	var _ButtonTransparent = __webpack_require__(194);
	
	Object.defineProperty(exports, 'ButtonTransparent', {
	  enumerable: true,
	  get: function get() {
	    return _ButtonTransparent.ButtonTransparent;
	  }
	});
	
	var _Link = __webpack_require__(2079);
	
	Object.defineProperty(exports, 'Link', {
	  enumerable: true,
	  get: function get() {
	    return _Link.Link;
	  }
	});
	
	var _NavLink = __webpack_require__(2083);
	
	Object.defineProperty(exports, 'NavLink', {
	  enumerable: true,
	  get: function get() {
	    return _NavLink.NavLink;
	  }
	});
	
	var _BlockLink = __webpack_require__(2053);
	
	Object.defineProperty(exports, 'BlockLink', {
	  enumerable: true,
	  get: function get() {
	    return _BlockLink.BlockLink;
	  }
	});
	
	var _Close = __webpack_require__(2064);
	
	Object.defineProperty(exports, 'Close', {
	  enumerable: true,
	  get: function get() {
	    return _Close.Close;
	  }
	});
	
	var _Text = __webpack_require__(37);
	
	Object.defineProperty(exports, 'Text', {
	  enumerable: true,
	  get: function get() {
	    return _Text.Text;
	  }
	});
	
	var _Heading = __webpack_require__(196);
	
	Object.defineProperty(exports, 'Heading', {
	  enumerable: true,
	  get: function get() {
	    return _Heading.Heading;
	  }
	});
	
	var _Subhead = __webpack_require__(2095);
	
	Object.defineProperty(exports, 'Subhead', {
	  enumerable: true,
	  get: function get() {
	    return _Subhead.Subhead;
	  }
	});
	
	var _Caps = __webpack_require__(2059);
	
	Object.defineProperty(exports, 'Caps', {
	  enumerable: true,
	  get: function get() {
	    return _Caps.Caps;
	  }
	});
	
	var _Small = __webpack_require__(2094);
	
	Object.defineProperty(exports, 'Small', {
	  enumerable: true,
	  get: function get() {
	    return _Small.Small;
	  }
	});
	
	var _Lead = __webpack_require__(2078);
	
	Object.defineProperty(exports, 'Lead', {
	  enumerable: true,
	  get: function get() {
	    return _Lead.Lead;
	  }
	});
	
	var _Truncate = __webpack_require__(2102);
	
	Object.defineProperty(exports, 'Truncate', {
	  enumerable: true,
	  get: function get() {
	    return _Truncate.Truncate;
	  }
	});
	
	var _Blockquote = __webpack_require__(2054);
	
	Object.defineProperty(exports, 'Blockquote', {
	  enumerable: true,
	  get: function get() {
	    return _Blockquote.Blockquote;
	  }
	});
	
	var _Divider = __webpack_require__(2068);
	
	Object.defineProperty(exports, 'Divider', {
	  enumerable: true,
	  get: function get() {
	    return _Divider.Divider;
	  }
	});
	
	var _Pre = __webpack_require__(2086);
	
	Object.defineProperty(exports, 'Pre', {
	  enumerable: true,
	  get: function get() {
	    return _Pre.Pre;
	  }
	});
	
	var _Code = __webpack_require__(195);
	
	Object.defineProperty(exports, 'Code', {
	  enumerable: true,
	  get: function get() {
	    return _Code.Code;
	  }
	});
	
	var _Samp = __webpack_require__(2091);
	
	Object.defineProperty(exports, 'Samp', {
	  enumerable: true,
	  get: function get() {
	    return _Samp.Samp;
	  }
	});
	
	var _Measure = __webpack_require__(2080);
	
	Object.defineProperty(exports, 'Measure', {
	  enumerable: true,
	  get: function get() {
	    return _Measure.Measure;
	  }
	});
	
	var _Label = __webpack_require__(2077);
	
	Object.defineProperty(exports, 'Label', {
	  enumerable: true,
	  get: function get() {
	    return _Label.Label;
	  }
	});
	
	var _Input = __webpack_require__(2076);
	
	Object.defineProperty(exports, 'Input', {
	  enumerable: true,
	  get: function get() {
	    return _Input.Input;
	  }
	});
	
	var _Select = __webpack_require__(2092);
	
	Object.defineProperty(exports, 'Select', {
	  enumerable: true,
	  get: function get() {
	    return _Select.Select;
	  }
	});
	
	var _Textarea = __webpack_require__(2099);
	
	Object.defineProperty(exports, 'Textarea', {
	  enumerable: true,
	  get: function get() {
	    return _Textarea.Textarea;
	  }
	});
	
	var _Radio = __webpack_require__(2089);
	
	Object.defineProperty(exports, 'Radio', {
	  enumerable: true,
	  get: function get() {
	    return _Radio.Radio;
	  }
	});
	
	var _Checkbox = __webpack_require__(2062);
	
	Object.defineProperty(exports, 'Checkbox', {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox.Checkbox;
	  }
	});
	
	var _Slider = __webpack_require__(2093);
	
	Object.defineProperty(exports, 'Slider', {
	  enumerable: true,
	  get: function get() {
	    return _Slider.Slider;
	  }
	});
	
	var _Switch = __webpack_require__(2096);
	
	Object.defineProperty(exports, 'Switch', {
	  enumerable: true,
	  get: function get() {
	    return _Switch.Switch;
	  }
	});
	
	var _Image = __webpack_require__(2075);
	
	Object.defineProperty(exports, 'Image', {
	  enumerable: true,
	  get: function get() {
	    return _Image.Image;
	  }
	});
	
	var _BackgroundImage = __webpack_require__(2050);
	
	Object.defineProperty(exports, 'BackgroundImage', {
	  enumerable: true,
	  get: function get() {
	    return _BackgroundImage.BackgroundImage;
	  }
	});
	
	var _Avatar = __webpack_require__(2049);
	
	Object.defineProperty(exports, 'Avatar', {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.Avatar;
	  }
	});
	
	var _Embed = __webpack_require__(2072);
	
	Object.defineProperty(exports, 'Embed', {
	  enumerable: true,
	  get: function get() {
	    return _Embed.Embed;
	  }
	});
	
	var _Container = __webpack_require__(2066);
	
	Object.defineProperty(exports, 'Container', {
	  enumerable: true,
	  get: function get() {
	    return _Container.Container;
	  }
	});
	
	var _Group = __webpack_require__(2073);
	
	Object.defineProperty(exports, 'Group', {
	  enumerable: true,
	  get: function get() {
	    return _Group.Group;
	  }
	});
	
	var _Row = __webpack_require__(2090);
	
	Object.defineProperty(exports, 'Row', {
	  enumerable: true,
	  get: function get() {
	    return _Row.Row;
	  }
	});
	
	var _Column = __webpack_require__(2065);
	
	Object.defineProperty(exports, 'Column', {
	  enumerable: true,
	  get: function get() {
	    return _Column.Column;
	  }
	});
	
	var _Border = __webpack_require__(2055);
	
	Object.defineProperty(exports, 'Border', {
	  enumerable: true,
	  get: function get() {
	    return _Border.Border;
	  }
	});
	
	var _Card = __webpack_require__(2060);
	
	Object.defineProperty(exports, 'Card', {
	  enumerable: true,
	  get: function get() {
	    return _Card.Card;
	  }
	});
	
	var _Panel = __webpack_require__(2084);
	
	Object.defineProperty(exports, 'Panel', {
	  enumerable: true,
	  get: function get() {
	    return _Panel.Panel;
	  }
	});
	
	var _Progress = __webpack_require__(2087);
	
	Object.defineProperty(exports, 'Progress', {
	  enumerable: true,
	  get: function get() {
	    return _Progress.Progress;
	  }
	});
	
	var _Banner = __webpack_require__(2051);
	
	Object.defineProperty(exports, 'Banner', {
	  enumerable: true,
	  get: function get() {
	    return _Banner.Banner;
	  }
	});
	
	var _Message = __webpack_require__(2081);
	
	Object.defineProperty(exports, 'Message', {
	  enumerable: true,
	  get: function get() {
	    return _Message.Message;
	  }
	});
	
	var _Toolbar = __webpack_require__(2100);
	
	Object.defineProperty(exports, 'Toolbar', {
	  enumerable: true,
	  get: function get() {
	    return _Toolbar.Toolbar;
	  }
	});
	
	var _Tabs = __webpack_require__(2098);
	
	Object.defineProperty(exports, 'Tabs', {
	  enumerable: true,
	  get: function get() {
	    return _Tabs.Tabs;
	  }
	});
	
	var _Tab = __webpack_require__(2097);
	
	Object.defineProperty(exports, 'Tab', {
	  enumerable: true,
	  get: function get() {
	    return _Tab.Tab;
	  }
	});
	
	var _Badge = __webpack_require__(193);
	
	Object.defineProperty(exports, 'Badge', {
	  enumerable: true,
	  get: function get() {
	    return _Badge.Badge;
	  }
	});
	
	var _Circle = __webpack_require__(2063);
	
	Object.defineProperty(exports, 'Circle', {
	  enumerable: true,
	  get: function get() {
	    return _Circle.Circle;
	  }
	});
	
	var _Dot = __webpack_require__(2070);
	
	Object.defineProperty(exports, 'Dot', {
	  enumerable: true,
	  get: function get() {
	    return _Dot.Dot;
	  }
	});
	
	var _Arrow = __webpack_require__(2048);
	
	Object.defineProperty(exports, 'Arrow', {
	  enumerable: true,
	  get: function get() {
	    return _Arrow.Arrow;
	  }
	});
	
	var _Donut = __webpack_require__(2069);
	
	Object.defineProperty(exports, 'Donut', {
	  enumerable: true,
	  get: function get() {
	    return _Donut.Donut;
	  }
	});
	
	var _Position = __webpack_require__(2085);
	
	Object.defineProperty(exports, 'Position', {
	  enumerable: true,
	  get: function get() {
	    return _Position.Position;
	  }
	});
	Object.defineProperty(exports, 'Relative', {
	  enumerable: true,
	  get: function get() {
	    return _Position.Relative;
	  }
	});
	Object.defineProperty(exports, 'Absolute', {
	  enumerable: true,
	  get: function get() {
	    return _Position.Absolute;
	  }
	});
	Object.defineProperty(exports, 'Fixed', {
	  enumerable: true,
	  get: function get() {
	    return _Position.Fixed;
	  }
	});
	Object.defineProperty(exports, 'Sticky', {
	  enumerable: true,
	  get: function get() {
	    return _Position.Sticky;
	  }
	});
	
	var _Modal = __webpack_require__(2082);
	
	Object.defineProperty(exports, 'Modal', {
	  enumerable: true,
	  get: function get() {
	    return _Modal.Modal;
	  }
	});
	
	var _Drawer = __webpack_require__(2071);
	
	Object.defineProperty(exports, 'Drawer', {
	  enumerable: true,
	  get: function get() {
	    return _Drawer.Drawer;
	  }
	});
	
	var _Carousel = __webpack_require__(2061);
	
	Object.defineProperty(exports, 'Carousel', {
	  enumerable: true,
	  get: function get() {
	    return _Carousel.Carousel;
	  }
	});
	
	var _Tooltip = __webpack_require__(2101);
	
	Object.defineProperty(exports, 'Tooltip', {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip.Tooltip;
	  }
	});
	
	var _Hide = __webpack_require__(2074);
	
	Object.defineProperty(exports, 'Hide', {
	  enumerable: true,
	  get: function get() {
	    return _Hide.Hide;
	  }
	});
	Object.defineProperty(exports, 'Overlay', {
	  enumerable: true,
	  get: function get() {
	    return _Modal.Modal;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var Stylis = _interopDefault(__webpack_require__(2114));
	var _insertRulePlugin = _interopDefault(__webpack_require__(2113));
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var unitless = _interopDefault(__webpack_require__(202));
	var reactIs = __webpack_require__(183);
	var memoize = _interopDefault(__webpack_require__(1688));
	var PropTypes = _interopDefault(__webpack_require__(3));
	var validAttr = _interopDefault(__webpack_require__(200));
	var merge = _interopDefault(__webpack_require__(1689));
	
	// 
	
	var interleave = (function (strings, interpolations) {
	  var result = [strings[0]];
	
	  for (var i = 0, len = interpolations.length; i < len; i += 1) {
	    result.push(interpolations[i], strings[i + 1]);
	  }
	
	  return result;
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	// 
	var isPlainObject = (function (x) {
	  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
	});
	
	// 
	var EMPTY_ARRAY = Object.freeze([]);
	var EMPTY_OBJECT = Object.freeze({});
	
	// 
	function isFunction(test) {
	  return typeof test === 'function';
	}
	
	// 
	
	function getComponentName(target) {
	  return ( false ? typeof target === 'string' && target : false) || target.displayName || target.name || 'Component';
	}
	
	// 
	function isStatelessFunction(test) {
	  return typeof test === 'function' && !(test.prototype && test.prototype.isReactComponent);
	}
	
	// 
	function isStyledComponent(target) {
	  return target && typeof target.styledComponentId === 'string';
	}
	
	// 
	
	var SC_ATTR = typeof process !== 'undefined' && (({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public","GATSBY_TELEMETRY_DISABLED":"1"}).REACT_APP_SC_ATTR || ({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public","GATSBY_TELEMETRY_DISABLED":"1"}).SC_ATTR) || 'data-styled';
	
	var SC_VERSION_ATTR = 'data-styled-version';
	
	var SC_STREAM_ATTR = 'data-styled-streamed';
	
	var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
	
	var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || typeof process !== 'undefined' && (({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public","GATSBY_TELEMETRY_DISABLED":"1"}).REACT_APP_SC_DISABLE_SPEEDY || ({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public","GATSBY_TELEMETRY_DISABLED":"1"}).SC_DISABLE_SPEEDY) || ("production") !== 'production';
	
	// Shared empty execution context when generating static styles
	var STATIC_EXECUTION_CONTEXT = {};
	
	// 
	
	
	/**
	 * Parse errors.md and turn it into a simple hash of code: message
	 */
	var ERRORS =  false ? {
	  "1": "Cannot create styled-component for component: %s.\n\n",
	  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
	  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
	  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
	  "5": "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
	  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
	  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
	  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
	  "9": "Missing document `<head>`\n\n",
	  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
	  "11": "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
	  "12": "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
	  "13": "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n"
	} : {};
	
	/**
	 * super basic version of sprintf
	 */
	function format() {
	  var a = arguments.length <= 0 ? undefined : arguments[0];
	  var b = [];
	
	  for (var c = 1, len = arguments.length; c < len; c += 1) {
	    b.push(arguments.length <= c ? undefined : arguments[c]);
	  }
	
	  b.forEach(function (d) {
	    a = a.replace(/%[a-z]/, d);
	  });
	
	  return a;
	}
	
	/**
	 * Create an error file out of errors.md for development and a simple web link to the full errors
	 * in production mode.
	 */
	
	var StyledComponentsError = function (_Error) {
	  inherits(StyledComponentsError, _Error);
	
	  function StyledComponentsError(code) {
	    classCallCheck(this, StyledComponentsError);
	
	    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    if (true) {
	      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#' + code + ' for more information.' + (interpolations.length > 0 ? ' Additional arguments: ' + interpolations.join(', ') : '')));
	    } else {
	      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations)).trim()));
	    }
	    return possibleConstructorReturn(_this);
	  }
	
	  return StyledComponentsError;
	}(Error);
	
	// 
	var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
	
	var extractComps = (function (maybeCSS) {
	  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
	  var existingComponents = [];
	  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
	    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
	    return match;
	  });
	  return existingComponents.map(function (_ref, i) {
	    var componentId = _ref.componentId,
	        matchIndex = _ref.matchIndex;
	
	    var nextComp = existingComponents[i + 1];
	    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
	    return { componentId: componentId, cssFromDOM: cssFromDOM };
	  });
	});
	
	// 
	
	var COMMENT_REGEX = /^\s*\/\/.*$/gm;
	
	// NOTE: This stylis instance is only used to split rules from SSR'd style tags
	var stylisSplitter = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: false,
	  compress: false,
	  semicolon: true
	});
	
	var stylis = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: true,
	  compress: false,
	  semicolon: false // NOTE: This means "autocomplete missing semicolons"
	});
	
	// Wrap `insertRulePlugin to build a list of rules,
	// and then make our own plugin to return the rules. This
	// makes it easier to hook into the existing SSR architecture
	
	var parsingRules = [];
	
	// eslint-disable-next-line consistent-return
	var returnRulesPlugin = function returnRulesPlugin(context) {
	  if (context === -2) {
	    var parsedRules = parsingRules;
	    parsingRules = [];
	    return parsedRules;
	  }
	};
	
	var parseRulesPlugin = _insertRulePlugin(function (rule) {
	  parsingRules.push(rule);
	});
	
	var _componentId = void 0;
	var _selector = void 0;
	var _selectorRegexp = void 0;
	
	var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
	  if (
	  // the first self-ref is always untouched
	  offset > 0 &&
	  // there should be at least two self-refs to do a replacement (.b > .b)
	  string.slice(0, offset).indexOf(_selector) !== -1 &&
	  // no consecutive self refs (.b.b); that is a precedence boost and treated differently
	  string.slice(offset - _selector.length, offset) !== _selector) {
	    return '.' + _componentId;
	  }
	
	  return match;
	};
	
	/**
	 * When writing a style like
	 *
	 * & + & {
	 *   color: red;
	 * }
	 *
	 * The second ampersand should be a reference to the static component class. stylis
	 * has no knowledge of static class so we have to intelligently replace the base selector.
	 */
	var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
	  if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
	    // eslint-disable-next-line no-param-reassign
	    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
	  }
	};
	
	stylis.use([selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]);
	stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);
	
	var splitByRules = function splitByRules(css) {
	  return stylisSplitter('', css);
	};
	
	function stringifyRules(rules, selector, prefix) {
	  var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&';
	
	  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments
	
	  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
	
	  // stylis has no concept of state to be passed to plugins
	  // but since JS is single=threaded, we can rely on that to ensure
	  // these properties stay in sync with the current stylis run
	  _componentId = componentId;
	  _selector = selector;
	  _selectorRegexp = new RegExp('\\' + _selector + '\\b', 'g');
	
	  return stylis(prefix || !selector ? '' : selector, cssStr);
	}
	
	// 
	/* eslint-disable camelcase, no-undef */
	
	var getNonce = (function () {
	  return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
	});
	
	// 
	/* These are helpers for the StyleTags to keep track of the injected
	 * rule names for each (component) ID that they're keeping track of.
	 * They're crucial for detecting whether a name has already been
	 * injected.
	 * (This excludes rehydrated names) */
	
	/* adds a new ID:name pairing to a names dictionary */
	var addNameForId = function addNameForId(names, id, name) {
	  if (name) {
	    // eslint-disable-next-line no-param-reassign
	    var namesForId = names[id] || (names[id] = Object.create(null));
	    namesForId[name] = true;
	  }
	};
	
	/* resets an ID entirely by overwriting it in the dictionary */
	var resetIdNames = function resetIdNames(names, id) {
	  // eslint-disable-next-line no-param-reassign
	  names[id] = Object.create(null);
	};
	
	/* factory for a names dictionary checking the existance of an ID:name pairing */
	var hasNameForId = function hasNameForId(names) {
	  return function (id, name) {
	    return names[id] !== undefined && names[id][name];
	  };
	};
	
	/* stringifies names for the html/element output */
	var stringifyNames = function stringifyNames(names) {
	  var str = '';
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    str += Object.keys(names[id]).join(' ') + ' ';
	  }
	  return str.trim();
	};
	
	/* clones the nested names dictionary */
	var cloneNames = function cloneNames(names) {
	  var clone = Object.create(null);
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    clone[id] = _extends({}, names[id]);
	  }
	  return clone;
	};
	
	// 
	
	/* These are helpers that deal with the insertRule (aka speedy) API
	 * They are used in the StyleTags and specifically the speedy tag
	 */
	
	/* retrieve a sheet for a given style tag */
	var sheetForTag = function sheetForTag(tag) {
	  // $FlowFixMe
	  if (tag.sheet) return tag.sheet;
	
	  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
	  var size = tag.ownerDocument.styleSheets.length;
	  for (var i = 0; i < size; i += 1) {
	    var sheet = tag.ownerDocument.styleSheets[i];
	    // $FlowFixMe
	    if (sheet.ownerNode === tag) return sheet;
	  }
	
	  /* we should always be able to find a tag */
	  throw new StyledComponentsError(10);
	};
	
	/* insert a rule safely and return whether it was actually injected */
	var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
	  /* abort early if cssRule string is falsy */
	  if (!cssRule) return false;
	
	  var maxIndex = sheet.cssRules.length;
	
	  try {
	    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
	    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
	  } catch (err) {
	    /* any error indicates an invalid rule */
	    return false;
	  }
	
	  return true;
	};
	
	/* deletes `size` rules starting from `removalIndex` */
	var deleteRules = function deleteRules(sheet, removalIndex, size) {
	  var lowerBound = removalIndex - size;
	  for (var i = removalIndex; i > lowerBound; i -= 1) {
	    sheet.deleteRule(i);
	  }
	};
	
	// 
	
	/* this marker separates component styles and is important for rehydration */
	var makeTextMarker = function makeTextMarker(id) {
	  return '\n/* sc-component-id: ' + id + ' */\n';
	};
	
	/* add up all numbers in array up until and including the index */
	var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
	  var totalUpToIndex = 0;
	  for (var i = 0; i <= index; i += 1) {
	    totalUpToIndex += sizes[i];
	  }
	
	  return totalUpToIndex;
	};
	
	/* create a new style tag after lastEl */
	var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
	  var targetDocument = document;
	  if (target) targetDocument = target.ownerDocument;else if (tagEl) targetDocument = tagEl.ownerDocument;
	
	  var el = targetDocument.createElement('style');
	  el.setAttribute(SC_ATTR, '');
	  el.setAttribute(SC_VERSION_ATTR, "4.4.1");
	
	  var nonce = getNonce();
	  if (nonce) {
	    el.setAttribute('nonce', nonce);
	  }
	
	  /* Work around insertRule quirk in EdgeHTML */
	  el.appendChild(targetDocument.createTextNode(''));
	
	  if (target && !tagEl) {
	    /* Append to target when no previous element was passed */
	    target.appendChild(el);
	  } else {
	    if (!tagEl || !target || !tagEl.parentNode) {
	      throw new StyledComponentsError(6);
	    }
	
	    /* Insert new style tag after the previous one */
	    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
	  }
	
	  return el;
	};
	
	/* takes a css factory function and outputs an html styled tag factory */
	var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
	  return function (additionalAttrs) {
	    var nonce = getNonce();
	    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', SC_VERSION_ATTR + '="' + "4.4.1" + '"', additionalAttrs];
	
	    var htmlAttr = attrs.filter(Boolean).join(' ');
	    return '<style ' + htmlAttr + '>' + css() + '</style>';
	  };
	};
	
	/* takes a css factory function and outputs an element factory */
	var wrapAsElement = function wrapAsElement(css, names) {
	  return function () {
	    var _props;
	
	    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.4.1", _props);
	
	    var nonce = getNonce();
	    if (nonce) {
	      // $FlowFixMe
	      props.nonce = nonce;
	    }
	
	    // eslint-disable-next-line react/no-danger
	    return React__default.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
	  };
	};
	
	var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
	  return function () {
	    return Object.keys(markers);
	  };
	};
	
	/* speedy tags utilise insertRule */
	var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	  var sizes = [];
	
	  var extractImport = getImportRuleTag !== undefined;
	  /* indicates whether getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = sizes.length;
	    sizes.push(0);
	    resetIdNames(names, id);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var sheet = sheetForTag(el);
	    var insertIndex = addUpUntilIndex(sizes, marker);
	
	    var injectedRules = 0;
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var cssRule = cssRules[i];
	      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
	      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
	        importRules.push(cssRule);
	      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
	        mayHaveImport = false;
	        injectedRules += 1;
	      }
	    }
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	
	    sizes[marker] += injectedRules; /* add up no of injected rules */
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	    // $FlowFixMe
	    if (el.isConnected === false) return;
	
	    var size = sizes[marker];
	    var sheet = sheetForTag(el);
	    var removalIndex = addUpUntilIndex(sizes, marker) - 1;
	    deleteRules(sheet, removalIndex, size);
	    sizes[marker] = 0;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var _sheetForTag = sheetForTag(el),
	        cssRules = _sheetForTag.cssRules;
	
	    var str = '';
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += makeTextMarker(id);
	      var marker = markers[id];
	      var end = addUpUntilIndex(sizes, marker);
	      var size = sizes[marker];
	      for (var i = end - size; i < end; i += 1) {
	        var rule = cssRules[i];
	        if (rule !== undefined) {
	          str += rule.cssText;
	        }
	      }
	    }
	
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeTextNode = function makeTextNode(targetDocument, id) {
	  return targetDocument.createTextNode(makeTextMarker(id));
	};
	
	var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	
	  var extractImport = getImportRuleTag !== undefined;
	
	  /* indicates whether getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = makeTextNode(el.ownerDocument, id);
	    el.appendChild(markers[id]);
	    names[id] = Object.create(null);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var rule = cssRules[i];
	      var mayHaveImport = extractImport;
	      if (mayHaveImport && rule.indexOf('@import') !== -1) {
	        importRules.push(rule);
	      } else {
	        mayHaveImport = false;
	        var separator = i === cssRulesSize - 1 ? '' : ' ';
	        marker.appendData('' + rule + separator);
	      }
	    }
	
	    addNameForId(names, id, name);
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	
	    /* create new empty text node and replace the current one */
	    var newMarker = makeTextNode(el.ownerDocument, id);
	    el.replaceChild(newMarker, marker);
	    markers[id] = newMarker;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var str = '';
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += markers[id].data;
	    }
	
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeServerTag = function makeServerTag(namesArg, markersArg) {
	  var names = namesArg === undefined ? Object.create(null) : namesArg;
	  var markers = markersArg === undefined ? Object.create(null) : markersArg;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    return markers[id] = [''];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    marker[0] += cssRules.join(' ');
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	    marker[0] = '';
	    resetIdNames(names, id);
	  };
	
	  var css = function css() {
	    var str = '';
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      var cssForId = markers[id][0];
	      if (cssForId) {
	        str += makeTextMarker(id) + cssForId;
	      }
	    }
	    return str;
	  };
	
	  var clone = function clone() {
	    var namesClone = cloneNames(names);
	    var markersClone = Object.create(null);
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      markersClone[id] = [markers[id][0]];
	    }
	
	    return makeServerTag(namesClone, markersClone);
	  };
	
	  var tag = {
	    clone: clone,
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: null,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	
	  return tag;
	};
	
	var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
	  if (IS_BROWSER && !forceServer) {
	    var el = makeStyleTag(target, tagEl, insertBefore);
	
	    if (DISABLE_SPEEDY) {
	      return makeBrowserTag(el, getImportRuleTag);
	    } else {
	      return makeSpeedyTag(el, getImportRuleTag);
	    }
	  }
	
	  return makeServerTag();
	};
	
	var rehydrate = function rehydrate(tag, els, extracted) {
	  /* add all extracted components to the new tag */
	  for (var i = 0, len = extracted.length; i < len; i += 1) {
	    var _extracted$i = extracted[i],
	        componentId = _extracted$i.componentId,
	        cssFromDOM = _extracted$i.cssFromDOM;
	
	    var cssRules = splitByRules(cssFromDOM);
	    tag.insertRules(componentId, cssRules);
	  }
	
	  /* remove old HTMLStyleElements, since they have been rehydrated */
	  for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
	    var el = els[_i];
	    if (el.parentNode) {
	      el.parentNode.removeChild(el);
	    }
	  }
	};
	
	// 
	
	var SPLIT_REGEX = /\s+/;
	
	/* determine the maximum number of components before tags are sharded */
	var MAX_SIZE = void 0;
	if (IS_BROWSER) {
	  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
	  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
	} else {
	  /* for servers we do not need to shard at all */
	  MAX_SIZE = -1;
	}
	
	var sheetRunningId = 0;
	var master = void 0;
	
	var StyleSheet = function () {
	
	  /* a map from ids to tags */
	
	  /* deferred rules for a given id */
	
	  /* this is used for not reinjecting rules via hasNameForId() */
	
	  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
	
	  /* a list of tags belonging to this StyleSheet */
	
	  /* a tag for import rules */
	
	  /* current capacity until a new tag must be created */
	
	  /* children (aka clones) of this StyleSheet inheriting all and future injections */
	
	  function StyleSheet() {
	    var _this = this;
	
	    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
	    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    classCallCheck(this, StyleSheet);
	
	    this.getImportRuleTag = function () {
	      var importRuleTag = _this.importRuleTag;
	
	      if (importRuleTag !== undefined) {
	        return importRuleTag;
	      }
	
	      var firstTag = _this.tags[0];
	      var insertBefore = true;
	
	      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
	    };
	
	    sheetRunningId += 1;
	    this.id = sheetRunningId;
	    this.forceServer = forceServer;
	    this.target = forceServer ? null : target;
	    this.tagMap = {};
	    this.deferred = {};
	    this.rehydratedNames = {};
	    this.ignoreRehydratedNames = {};
	    this.tags = [];
	    this.capacity = 1;
	    this.clones = [];
	  }
	
	  /* rehydrate all SSR'd style tags */
	
	
	  StyleSheet.prototype.rehydrate = function rehydrate$$1() {
	    if (!IS_BROWSER || this.forceServer) return this;
	
	    var els = [];
	    var extracted = [];
	    var isStreamed = false;
	
	    /* retrieve all of our SSR style elements from the DOM */
	    var nodes = document.querySelectorAll('style[' + SC_ATTR + '][' + SC_VERSION_ATTR + '="' + "4.4.1" + '"]');
	
	    var nodesSize = nodes.length;
	
	    /* abort rehydration if no previous style tags were found */
	    if (!nodesSize) return this;
	
	    for (var i = 0; i < nodesSize; i += 1) {
	      var el = nodes[i];
	
	      /* check if style tag is a streamed tag */
	      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);
	
	      /* retrieve all component names */
	      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
	      var elNamesSize = elNames.length;
	      for (var j = 0, name; j < elNamesSize; j += 1) {
	        name = elNames[j];
	        /* add rehydrated name to sheet to avoid re-adding styles */
	        this.rehydratedNames[name] = true;
	      }
	
	      /* extract all components and their CSS */
	      extracted.push.apply(extracted, extractComps(el.textContent));
	
	      /* store original HTMLStyleElement */
	      els.push(el);
	    }
	
	    /* abort rehydration if nothing was extracted */
	    var extractedSize = extracted.length;
	    if (!extractedSize) return this;
	
	    /* create a tag to be used for rehydration */
	    var tag = this.makeTag(null);
	
	    rehydrate(tag, els, extracted);
	
	    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
	    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
	    this.tags.push(tag);
	
	    /* retrieve all component ids */
	    for (var _j = 0; _j < extractedSize; _j += 1) {
	      this.tagMap[extracted[_j].componentId] = tag;
	    }
	
	    return this;
	  };
	
	  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
	   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
	    * StyleSheetManager's context */
	
	
	  /* reset the internal "master" instance */
	  StyleSheet.reset = function reset() {
	    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    master = new StyleSheet(undefined, forceServer).rehydrate();
	  };
	
	  /* adds "children" to the StyleSheet that inherit all of the parents' rules
	   * while their own rules do not affect the parent */
	
	
	  StyleSheet.prototype.clone = function clone() {
	    var sheet = new StyleSheet(this.target, this.forceServer);
	
	    /* add to clone array */
	    this.clones.push(sheet);
	
	    /* clone all tags */
	    sheet.tags = this.tags.map(function (tag) {
	      var ids = tag.getIds();
	      var newTag = tag.clone();
	
	      /* reconstruct tagMap */
	      for (var i = 0; i < ids.length; i += 1) {
	        sheet.tagMap[ids[i]] = newTag;
	      }
	
	      return newTag;
	    });
	
	    /* clone other maps */
	    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
	    sheet.deferred = _extends({}, this.deferred);
	
	    return sheet;
	  };
	
	  /* force StyleSheet to create a new tag on the next injection */
	
	
	  StyleSheet.prototype.sealAllTags = function sealAllTags() {
	    this.capacity = 1;
	
	    this.tags.forEach(function (tag) {
	      // eslint-disable-next-line no-param-reassign
	      tag.sealed = true;
	    });
	  };
	
	  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
	    var lastEl = tag ? tag.styleTag : null;
	    var insertBefore = false;
	
	    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
	  };
	
	  /* get a tag for a given componentId, assign the componentId to one, or shard */
	  StyleSheet.prototype.getTagForId = function getTagForId(id) {
	    /* simply return a tag, when the componentId was already assigned one */
	    var prev = this.tagMap[id];
	    if (prev !== undefined && !prev.sealed) {
	      return prev;
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
	    this.capacity -= 1;
	
	    if (this.capacity === 0) {
	      this.capacity = MAX_SIZE;
	      tag = this.makeTag(tag);
	      this.tags.push(tag);
	    }
	
	    return this.tagMap[id] = tag;
	  };
	
	  /* mainly for createGlobalStyle to check for its id */
	
	
	  StyleSheet.prototype.hasId = function hasId(id) {
	    return this.tagMap[id] !== undefined;
	  };
	
	  /* caching layer checking id+name to already have a corresponding tag and injected rules */
	
	
	  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
	    /* exception for rehydrated names which are checked separately */
	    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
	      return true;
	    }
	
	    var tag = this.tagMap[id];
	    return tag !== undefined && tag.hasNameForId(id, name);
	  };
	
	  /* registers a componentId and registers it on its tag */
	
	
	  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
	    /* don't inject when the id is already registered */
	    if (this.tagMap[id] !== undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].deferredInject(id, cssRules);
	    }
	
	    this.getTagForId(id).insertMarker(id);
	    this.deferred[id] = cssRules;
	  };
	
	  /* injects rules for a given id with a name that will need to be cached */
	
	
	  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
	    var clones = this.clones;
	
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].inject(id, cssRules, name);
	    }
	
	    var tag = this.getTagForId(id);
	
	    /* add deferred rules for component */
	    if (this.deferred[id] !== undefined) {
	      // Combine passed cssRules with previously deferred CSS rules
	      // NOTE: We cannot mutate the deferred array itself as all clones
	      // do the same (see clones[i].inject)
	      var rules = this.deferred[id].concat(cssRules);
	      tag.insertRules(id, rules, name);
	
	      this.deferred[id] = undefined;
	    } else {
	      tag.insertRules(id, cssRules, name);
	    }
	  };
	
	  /* removes all rules for a given id, which doesn't remove its marker but resets it */
	
	
	  StyleSheet.prototype.remove = function remove(id) {
	    var tag = this.tagMap[id];
	    if (tag === undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].remove(id);
	    }
	
	    /* remove all rules from the tag */
	    tag.removeRules(id);
	
	    /* ignore possible rehydrated names */
	    this.ignoreRehydratedNames[id] = true;
	
	    /* delete possible deferred rules */
	    this.deferred[id] = undefined;
	  };
	
	  StyleSheet.prototype.toHTML = function toHTML() {
	    return this.tags.map(function (tag) {
	      return tag.toHTML();
	    }).join('');
	  };
	
	  StyleSheet.prototype.toReactElements = function toReactElements() {
	    var id = this.id;
	
	
	    return this.tags.map(function (tag, i) {
	      var key = 'sc-' + id + '-' + i;
	      return React.cloneElement(tag.toElement(), { key: key });
	    });
	  };
	
	  createClass(StyleSheet, null, [{
	    key: 'master',
	    get: function get$$1() {
	      return master || (master = new StyleSheet().rehydrate());
	    }
	
	    /* NOTE: This is just for backwards-compatibility with jest-styled-components */
	
	  }, {
	    key: 'instance',
	    get: function get$$1() {
	      return StyleSheet.master;
	    }
	  }]);
	  return StyleSheet;
	}();
	
	// 
	
	var Keyframes = function () {
	  function Keyframes(name, rules) {
	    var _this = this;
	
	    classCallCheck(this, Keyframes);
	
	    this.inject = function (styleSheet) {
	      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
	        styleSheet.inject(_this.id, _this.rules, _this.name);
	      }
	    };
	
	    this.toString = function () {
	      throw new StyledComponentsError(12, String(_this.name));
	    };
	
	    this.name = name;
	    this.rules = rules;
	
	    this.id = 'sc-keyframes-' + name;
	  }
	
	  Keyframes.prototype.getName = function getName() {
	    return this.name;
	  };
	
	  return Keyframes;
	}();
	
	// 
	
	/**
	 * inlined version of
	 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
	 */
	
	var uppercasePattern = /([A-Z])/g;
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
	}
	
	// 
	
	// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
	function addUnitIfNeeded(name, value) {
	  // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
	  // $FlowFixMe
	  if (value == null || typeof value === 'boolean' || value === '') {
	    return '';
	  }
	
	  if (typeof value === 'number' && value !== 0 && !(name in unitless)) {
	    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
	  }
	
	  return String(value).trim();
	}
	
	// 
	
	/**
	 * It's falsish not falsy because 0 is allowed.
	 */
	var isFalsish = function isFalsish(chunk) {
	  return chunk === undefined || chunk === null || chunk === false || chunk === '';
	};
	
	var objToCssArray = function objToCssArray(obj, prevKey) {
	  var rules = [];
	  var keys = Object.keys(obj);
	
	  keys.forEach(function (key) {
	    if (!isFalsish(obj[key])) {
	      if (isPlainObject(obj[key])) {
	        rules.push.apply(rules, objToCssArray(obj[key], key));
	
	        return rules;
	      } else if (isFunction(obj[key])) {
	        rules.push(hyphenateStyleName(key) + ':', obj[key], ';');
	
	        return rules;
	      }
	      rules.push(hyphenateStyleName(key) + ': ' + addUnitIfNeeded(key, obj[key]) + ';');
	    }
	    return rules;
	  });
	
	  return prevKey ? [prevKey + ' {'].concat(rules, ['}']) : rules;
	};
	
	function flatten(chunk, executionContext, styleSheet) {
	  if (Array.isArray(chunk)) {
	    var ruleSet = [];
	
	    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
	      result = flatten(chunk[i], executionContext, styleSheet);
	
	      if (result === null) continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
	    }
	
	    return ruleSet;
	  }
	
	  if (isFalsish(chunk)) {
	    return null;
	  }
	
	  /* Handle other components */
	  if (isStyledComponent(chunk)) {
	    return '.' + chunk.styledComponentId;
	  }
	
	  /* Either execute or defer the function */
	  if (isFunction(chunk)) {
	    if (isStatelessFunction(chunk) && executionContext) {
	      var _result = chunk(executionContext);
	
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn(getComponentName(chunk) + ' is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.');
	      }
	
	      return flatten(_result, executionContext, styleSheet);
	    } else return chunk;
	  }
	
	  if (chunk instanceof Keyframes) {
	    if (styleSheet) {
	      chunk.inject(styleSheet);
	      return chunk.getName();
	    } else return chunk;
	  }
	
	  /* Handle objects */
	  return isPlainObject(chunk) ? objToCssArray(chunk) : chunk.toString();
	}
	
	// 
	
	function css(styles) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  if (isFunction(styles) || isPlainObject(styles)) {
	    // $FlowFixMe
	    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
	  }
	
	  // $FlowFixMe
	  return flatten(interleave(styles, interpolations));
	}
	
	// 
	
	function constructWithOptions(componentConstructor, tag) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
	
	  if (!reactIs.isValidElementType(tag)) {
	    throw new StyledComponentsError(1, String(tag));
	  }
	
	  /* This is callable directly as a template function */
	  // $FlowFixMe: Not typed to avoid destructuring arguments
	  var templateFunction = function templateFunction() {
	    return componentConstructor(tag, options, css.apply(undefined, arguments));
	  };
	
	  /* If config methods are called, wrap up a new template function and merge options */
	  templateFunction.withConfig = function (config) {
	    return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
	  };
	
	  /* Modify/inject new props at runtime */
	  templateFunction.attrs = function (attrs) {
	    return constructWithOptions(componentConstructor, tag, _extends({}, options, {
	      attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
	    }));
	  };
	
	  return templateFunction;
	}
	
	// 
	// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash(c) {
	  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
	    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
	  }
	  switch (e) {
	    case 3:
	      a ^= (c.charCodeAt(d + 2) & 255) << 16;
	    case 2:
	      a ^= (c.charCodeAt(d + 1) & 255) << 8;
	    case 1:
	      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
	  }
	  a ^= a >>> 13;
	  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
	  return (a ^ a >>> 15) >>> 0;
	}
	
	// 
	/* eslint-disable no-bitwise */
	
	/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
	 * counterparts */
	var charsLength = 52;
	
	/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
	var getAlphabeticChar = function getAlphabeticChar(code) {
	  return String.fromCharCode(code + (code > 25 ? 39 : 97));
	};
	
	/* input a number, usually a hash and convert it to base-52 */
	function generateAlphabeticName(code) {
	  var name = '';
	  var x = void 0;
	
	  /* get a char and divide by alphabet-length */
	  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
	    name = getAlphabeticChar(x % charsLength) + name;
	  }
	
	  return getAlphabeticChar(x % charsLength) + name;
	}
	
	// 
	
	function hasFunctionObjectKey(obj) {
	  // eslint-disable-next-line guard-for-in, no-restricted-syntax
	  for (var key in obj) {
	    if (isFunction(obj[key])) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function isStaticRules(rules, attrs) {
	  for (var i = 0; i < rules.length; i += 1) {
	    var rule = rules[i];
	
	    // recursive case
	    if (Array.isArray(rule) && !isStaticRules(rule, attrs)) {
	      return false;
	    } else if (isFunction(rule) && !isStyledComponent(rule)) {
	      // functions are allowed to be static if they're just being
	      // used to get the classname of a nested styled component
	      return false;
	    }
	  }
	
	  if (attrs.some(function (x) {
	    return isFunction(x) || hasFunctionObjectKey(x);
	  })) return false;
	
	  return true;
	}
	
	// 
	
	/* combines hashStr (murmurhash) and nameGenerator for convenience */
	var hasher = function hasher(str) {
	  return generateAlphabeticName(murmurhash(str));
	};
	
	/*
	 ComponentStyle is all the CSS-specific stuff, not
	 the React-specific stuff.
	 */
	
	var ComponentStyle = function () {
	  function ComponentStyle(rules, attrs, componentId) {
	    classCallCheck(this, ComponentStyle);
	
	    this.rules = rules;
	    this.isStatic = ("production") === 'production' && isStaticRules(rules, attrs);
	    this.componentId = componentId;
	
	    if (!StyleSheet.master.hasId(componentId)) {
	      StyleSheet.master.deferredInject(componentId, []);
	    }
	  }
	
	  /*
	   * Flattens a rule set into valid CSS
	   * Hashes it, wraps the whole chunk in a .hash1234 {}
	   * Returns the hash to be injected on render()
	   * */
	
	
	  ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
	    var isStatic = this.isStatic,
	        componentId = this.componentId,
	        lastClassName = this.lastClassName;
	
	    if (IS_BROWSER && isStatic && typeof lastClassName === 'string' && styleSheet.hasNameForId(componentId, lastClassName)) {
	      return lastClassName;
	    }
	
	    var flatCSS = flatten(this.rules, executionContext, styleSheet);
	    var name = hasher(this.componentId + flatCSS.join(''));
	    if (!styleSheet.hasNameForId(componentId, name)) {
	      styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name, undefined, componentId), name);
	    }
	
	    this.lastClassName = name;
	    return name;
	  };
	
	  ComponentStyle.generateName = function generateName(str) {
	    return hasher(str);
	  };
	
	  return ComponentStyle;
	}();
	
	// 
	
	var LIMIT = 200;
	
	var createWarnTooManyClasses = (function (displayName) {
	  var generatedClasses = {};
	  var warningSeen = false;
	
	  return function (className) {
	    if (!warningSeen) {
	      generatedClasses[className] = true;
	      if (Object.keys(generatedClasses).length >= LIMIT) {
	        // Unable to find latestRule in test environment.
	        /* eslint-disable no-console, prefer-template */
	        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs(props => ({\n' + '    style: {\n' + '      background: props.background,\n' + '    },\n' + '  }))`width: 100%;`\n\n' + '  <Component />');
	        warningSeen = true;
	        generatedClasses = {};
	      }
	    }
	  };
	});
	
	// 
	
	var determineTheme = (function (props, fallbackTheme) {
	  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
	
	  // Props should take precedence over ThemeProvider, which should take precedence over
	  // defaultProps, but React automatically puts defaultProps on props.
	
	  /* eslint-disable react/prop-types, flowtype-errors/show-errors */
	  var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
	  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
	  /* eslint-enable */
	
	  return theme;
	});
	
	// 
	var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
	var dashesAtEnds = /(^-|-$)/g;
	
	/**
	 * TODO: Explore using CSS.escape when it becomes more available
	 * in evergreen browsers.
	 */
	function escape(str) {
	  return str
	  // Replace all possible CSS selectors
	  .replace(escapeRegex, '-')
	
	  // Remove extraneous hyphens at the start and end
	  .replace(dashesAtEnds, '');
	}
	
	// 
	
	function isTag(target) {
	  return typeof target === 'string' && ( false ? target.charAt(0) === target.charAt(0).toLowerCase() : true);
	}
	
	// 
	
	function generateDisplayName(target) {
	  // $FlowFixMe
	  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
	}
	
	var _TYPE_STATICS;
	
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDerivedStateFromProps: true,
	  propTypes: true,
	  type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[reactIs.ForwardRef] = {
	  $$typeof: true,
	  render: true
	}, _TYPE_STATICS);
	
	var defineProperty$1 = Object.defineProperty,
	    getOwnPropertyNames = Object.getOwnPropertyNames,
	    _Object$getOwnPropert = Object.getOwnPropertySymbols,
	    getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function () {
	  return [];
	} : _Object$getOwnPropert,
	    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
	    getPrototypeOf = Object.getPrototypeOf,
	    objectPrototype = Object.prototype;
	var arrayPrototype = Array.prototype;
	
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	
	    var inheritedComponent = getPrototypeOf(sourceComponent);
	
	    if (inheritedComponent && inheritedComponent !== objectPrototype) {
	      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	    }
	
	    var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent),
	    // $FlowFixMe
	    getOwnPropertySymbols(sourceComponent));
	
	    var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;
	
	    var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;
	
	    var i = keys.length;
	    var descriptor = void 0;
	    var key = void 0;
	
	    // eslint-disable-next-line no-plusplus
	    while (i--) {
	      key = keys[i];
	
	      if (
	      // $FlowFixMe
	      !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) &&
	      // $FlowFixMe
	      !(targetStatics && targetStatics[key])) {
	        descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        if (descriptor) {
	          try {
	            // Avoid failures from read-only properties
	            defineProperty$1(targetComponent, key, descriptor);
	          } catch (e) {
	            /* fail silently */
	          }
	        }
	      }
	    }
	
	    return targetComponent;
	  }
	
	  return targetComponent;
	}
	
	// 
	function isDerivedReactComponent(fn) {
	  return !!(fn && fn.prototype && fn.prototype.isReactComponent);
	}
	
	// 
	// Helper to call a given function, only once
	var once = (function (cb) {
	  var called = false;
	
	  return function () {
	    if (!called) {
	      called = true;
	      cb.apply(undefined, arguments);
	    }
	  };
	});
	
	// 
	
	var ThemeContext = React.createContext();
	
	var ThemeConsumer = ThemeContext.Consumer;
	
	/**
	 * Provide a theme to an entire react component tree via context
	 */
	
	var ThemeProvider = function (_Component) {
	  inherits(ThemeProvider, _Component);
	
	  function ThemeProvider(props) {
	    classCallCheck(this, ThemeProvider);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.getContext = memoize(_this.getContext.bind(_this));
	    _this.renderInner = _this.renderInner.bind(_this);
	    return _this;
	  }
	
	  ThemeProvider.prototype.render = function render() {
	    if (!this.props.children) return null;
	
	    return React__default.createElement(
	      ThemeContext.Consumer,
	      null,
	      this.renderInner
	    );
	  };
	
	  ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
	    var context = this.getContext(this.props.theme, outerTheme);
	
	    return React__default.createElement(
	      ThemeContext.Provider,
	      { value: context },
	      this.props.children
	    );
	  };
	
	  /**
	   * Get the theme from the props, supporting both (outerTheme) => {}
	   * as well as object notation
	   */
	
	
	  ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
	    if (isFunction(theme)) {
	      var mergedTheme = theme(outerTheme);
	
	      if (false) {
	        throw new StyledComponentsError(7);
	      }
	
	      return mergedTheme;
	    }
	
	    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
	      throw new StyledComponentsError(8);
	    }
	
	    return _extends({}, outerTheme, theme);
	  };
	
	  ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
	    return this.getTheme(theme, outerTheme);
	  };
	
	  return ThemeProvider;
	}(React.Component);
	
	// 
	
	var CLOSING_TAG_R = /^\s*<\/[a-z]/i;
	
	var ServerStyleSheet = function () {
	  function ServerStyleSheet() {
	    classCallCheck(this, ServerStyleSheet);
	
	    /* The master sheet might be reset, so keep a reference here */
	    this.masterSheet = StyleSheet.master;
	    this.instance = this.masterSheet.clone();
	    this.sealed = false;
	  }
	
	  /**
	   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
	   * StyleSheet singleton.
	   */
	
	
	  ServerStyleSheet.prototype.seal = function seal() {
	    if (!this.sealed) {
	      /* Remove sealed StyleSheets from the master sheet */
	      var index = this.masterSheet.clones.indexOf(this.instance);
	      this.masterSheet.clones.splice(index, 1);
	      this.sealed = true;
	    }
	  };
	
	  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
	    if (this.sealed) {
	      throw new StyledComponentsError(2);
	    }
	
	    return React__default.createElement(
	      StyleSheetManager,
	      { sheet: this.instance },
	      children
	    );
	  };
	
	  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
	    this.seal();
	    return this.instance.toHTML();
	  };
	
	  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
	    this.seal();
	    return this.instance.toReactElements();
	  };
	
	  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
	    var _this = this;
	
	    {
	      throw new StyledComponentsError(3);
	    }
	
	    /* the tag index keeps track of which tags have already been emitted */
	    var instance = this.instance;
	
	    var instanceTagIndex = 0;
	
	    var streamAttr = SC_STREAM_ATTR + '="true"';
	
	    var transformer = new stream.Transform({
	      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
	        var tags = instance.tags;
	
	        var html = '';
	
	        /* retrieve html for each new style tag */
	        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
	          var tag = tags[instanceTagIndex];
	          html += tag.toHTML(streamAttr);
	        }
	
	        /* force our StyleSheets to emit entirely new tags */
	        instance.sealAllTags();
	
	        var renderedHtml = chunk.toString();
	
	        /* prepend style html to chunk, unless the start of the chunk is a closing tag in which case append right after that */
	        if (CLOSING_TAG_R.test(renderedHtml)) {
	          var endOfClosingTag = renderedHtml.indexOf('>');
	
	          this.push(renderedHtml.slice(0, endOfClosingTag + 1) + html + renderedHtml.slice(endOfClosingTag + 1));
	        } else this.push(html + renderedHtml);
	
	        callback();
	      }
	    });
	
	    readableStream.on('end', function () {
	      return _this.seal();
	    });
	
	    readableStream.on('error', function (err) {
	      _this.seal();
	
	      // forward the error to the transform stream
	      transformer.emit('error', err);
	    });
	
	    return readableStream.pipe(transformer);
	  };
	
	  return ServerStyleSheet;
	}();
	
	// 
	
	var StyleSheetContext = React.createContext();
	var StyleSheetConsumer = StyleSheetContext.Consumer;
	
	var StyleSheetManager = function (_Component) {
	  inherits(StyleSheetManager, _Component);
	
	  function StyleSheetManager(props) {
	    classCallCheck(this, StyleSheetManager);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.getContext = memoize(_this.getContext);
	    return _this;
	  }
	
	  StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
	    if (sheet) {
	      return sheet;
	    } else if (target) {
	      return new StyleSheet(target);
	    } else {
	      throw new StyledComponentsError(4);
	    }
	  };
	
	  StyleSheetManager.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        sheet = _props.sheet,
	        target = _props.target;
	
	
	    return React__default.createElement(
	      StyleSheetContext.Provider,
	      { value: this.getContext(sheet, target) },
	       false ? React__default.Children.only(children) : children
	    );
	  };
	
	  return StyleSheetManager;
	}(React.Component);
	 false ? StyleSheetManager.propTypes = {
	  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
	
	  target: PropTypes.shape({
	    appendChild: PropTypes.func.isRequired
	  })
	} : void 0;
	
	// 
	
	var identifiers = {};
	
	/* We depend on components having unique IDs */
	function generateId(_ComponentStyle, _displayName, parentComponentId) {
	  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);
	
	  /**
	   * This ensures uniqueness if two components happen to share
	   * the same displayName.
	   */
	  var nr = (identifiers[displayName] || 0) + 1;
	  identifiers[displayName] = nr;
	
	  var componentId = displayName + '-' + _ComponentStyle.generateName(displayName + nr);
	
	  return parentComponentId ? parentComponentId + '-' + componentId : componentId;
	}
	
	// $FlowFixMe
	
	var StyledComponent = function (_Component) {
	  inherits(StyledComponent, _Component);
	
	  function StyledComponent() {
	    classCallCheck(this, StyledComponent);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this));
	
	    _this.attrs = {};
	
	    _this.renderOuter = _this.renderOuter.bind(_this);
	    _this.renderInner = _this.renderInner.bind(_this);
	
	    if (false) {
	      _this.warnInnerRef = once(function (displayName) {
	        return (
	          // eslint-disable-next-line no-console
	          console.warn('The "innerRef" API has been removed in styled-components v4 in favor of React 16 ref forwarding, use "ref" instead like a typical component. "innerRef" was detected on component "' + displayName + '".')
	        );
	      });
	
	      _this.warnAttrsFnObjectKeyDeprecated = once(function (key, displayName) {
	        return (
	          // eslint-disable-next-line no-console
	          console.warn('Functions as object-form attrs({}) keys are now deprecated and will be removed in a future version of styled-components. Switch to the new attrs(props => ({})) syntax instead for easier and more powerful composition. The attrs key in question is "' + key + '" on component "' + displayName + '".', '\n ' + new Error().stack)
	        );
	      });
	
	      _this.warnNonStyledComponentAttrsObjectKey = once(function (key, displayName) {
	        return (
	          // eslint-disable-next-line no-console
	          console.warn('It looks like you\'ve used a non styled-component as the value for the "' + key + '" prop in an object-form attrs constructor of "' + displayName + '".\n' + 'You should use the new function-form attrs constructor which avoids this issue: attrs(props => ({ yourStuff }))\n' + "To continue using the deprecated object syntax, you'll need to wrap your component prop in a function to make it available inside the styled component (you'll still get the deprecation warning though.)\n" + ('For example, { ' + key + ': () => InnerComponent } instead of { ' + key + ': InnerComponent }'))
	        );
	      });
	    }
	    return _this;
	  }
	
	  StyledComponent.prototype.render = function render() {
	    return React__default.createElement(
	      StyleSheetConsumer,
	      null,
	      this.renderOuter
	    );
	  };
	
	  StyledComponent.prototype.renderOuter = function renderOuter() {
	    var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;
	
	    this.styleSheet = styleSheet;
	
	    // No need to subscribe a static component to theme changes, it won't change anything
	    if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();
	
	    return React__default.createElement(
	      ThemeConsumer,
	      null,
	      this.renderInner
	    );
	  };
	
	  StyledComponent.prototype.renderInner = function renderInner(theme) {
	    var _props$forwardedCompo = this.props.forwardedComponent,
	        componentStyle = _props$forwardedCompo.componentStyle,
	        defaultProps = _props$forwardedCompo.defaultProps,
	        displayName = _props$forwardedCompo.displayName,
	        foldedComponentIds = _props$forwardedCompo.foldedComponentIds,
	        styledComponentId = _props$forwardedCompo.styledComponentId,
	        target = _props$forwardedCompo.target;
	
	
	    var generatedClassName = void 0;
	    if (componentStyle.isStatic) {
	      generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
	    } else {
	      generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps) || EMPTY_OBJECT, this.props);
	    }
	
	    var elementToBeCreated = this.props.as || this.attrs.as || target;
	    var isTargetTag = isTag(elementToBeCreated);
	
	    var propsForElement = {};
	    var computedProps = _extends({}, this.props, this.attrs);
	
	    var key = void 0;
	    // eslint-disable-next-line guard-for-in
	    for (key in computedProps) {
	      if (false) {
	        this.warnInnerRef(displayName);
	      }
	
	      if (key === 'forwardedComponent' || key === 'as') {
	        continue;
	      } else if (key === 'forwardedRef') propsForElement.ref = computedProps[key];else if (key === 'forwardedAs') propsForElement.as = computedProps[key];else if (!isTargetTag || validAttr(key)) {
	        // Don't pass through non HTML tags through to HTML elements
	        propsForElement[key] = computedProps[key];
	      }
	    }
	
	    if (this.props.style && this.attrs.style) {
	      propsForElement.style = _extends({}, this.attrs.style, this.props.style);
	    }
	
	    propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, this.props.className, this.attrs.className).filter(Boolean).join(' ');
	
	    return React.createElement(elementToBeCreated, propsForElement);
	  };
	
	  StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
	    var _this2 = this;
	
	    var context = _extends({}, props, { theme: theme });
	
	    if (!attrs.length) return context;
	
	    this.attrs = {};
	
	    attrs.forEach(function (attrDef) {
	      var resolvedAttrDef = attrDef;
	      var attrDefWasFn = false;
	      var attr = void 0;
	      var key = void 0;
	
	      if (isFunction(resolvedAttrDef)) {
	        // $FlowFixMe
	        resolvedAttrDef = resolvedAttrDef(context);
	        attrDefWasFn = true;
	      }
	
	      /* eslint-disable guard-for-in */
	      // $FlowFixMe
	      for (key in resolvedAttrDef) {
	        attr = resolvedAttrDef[key];
	
	        if (!attrDefWasFn) {
	          if (isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) {
	            if (false) {
	              _this2.warnAttrsFnObjectKeyDeprecated(key, props.forwardedComponent.displayName);
	            }
	
	            attr = attr(context);
	
	            if (false) {
	              _this2.warnNonStyledComponentAttrsObjectKey(key, props.forwardedComponent.displayName);
	            }
	          }
	        }
	
	        _this2.attrs[key] = attr;
	        context[key] = attr;
	      }
	      /* eslint-enable */
	    });
	
	    return context;
	  };
	
	  StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
	    var _props$forwardedCompo2 = props.forwardedComponent,
	        attrs = _props$forwardedCompo2.attrs,
	        componentStyle = _props$forwardedCompo2.componentStyle,
	        warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;
	
	    // statically styled-components don't need to build an execution context object,
	    // and shouldn't be increasing the number of class names
	
	    if (componentStyle.isStatic && !attrs.length) {
	      return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
	    }
	
	    var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);
	
	    if (false) warnTooManyClasses(className);
	
	    return className;
	  };
	
	  return StyledComponent;
	}(React.Component);
	
	function createStyledComponent(target, options, rules) {
	  var isTargetStyledComp = isStyledComponent(target);
	  var isClass = !isTag(target);
	
	  var _options$displayName = options.displayName,
	      displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
	      _options$componentId = options.componentId,
	      componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
	      _options$ParentCompon = options.ParentComponent,
	      ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon,
	      _options$attrs = options.attrs,
	      attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;
	
	
	  var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;
	
	  // fold the underlying StyledComponent attrs up (implicit extend)
	  var finalAttrs =
	  // $FlowFixMe
	  isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;
	
	  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
	  // $FlowFixMe
	  target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);
	
	  /**
	   * forwardRef creates a new interim component, which we'll take advantage of
	   * instead of extending ParentComponent to create _another_ interim class
	   */
	  var WrappedStyledComponent = void 0;
	  var forwardRef = function forwardRef(props, ref) {
	    return React__default.createElement(ParentComponent, _extends({}, props, { forwardedComponent: WrappedStyledComponent, forwardedRef: ref }));
	  };
	  forwardRef.displayName = displayName;
	  WrappedStyledComponent = React__default.forwardRef(forwardRef);
	  WrappedStyledComponent.displayName = displayName;
	
	  // $FlowFixMe
	  WrappedStyledComponent.attrs = finalAttrs;
	  // $FlowFixMe
	  WrappedStyledComponent.componentStyle = componentStyle;
	
	  // $FlowFixMe
	  WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? // $FlowFixMe
	  Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;
	
	  // $FlowFixMe
	  WrappedStyledComponent.styledComponentId = styledComponentId;
	
	  // fold the underlying StyledComponent target up since we folded the styles
	  // $FlowFixMe
	  WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;
	
	  // $FlowFixMe
	  WrappedStyledComponent.withComponent = function withComponent(tag) {
	    var previousComponentId = options.componentId,
	        optionsToCopy = objectWithoutProperties(options, ['componentId']);
	
	
	    var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));
	
	    var newOptions = _extends({}, optionsToCopy, {
	      attrs: finalAttrs,
	      componentId: newComponentId,
	      ParentComponent: ParentComponent
	    });
	
	    return createStyledComponent(tag, newOptions, rules);
	  };
	
	  // $FlowFixMe
	  Object.defineProperty(WrappedStyledComponent, 'defaultProps', {
	    get: function get$$1() {
	      return this._foldedDefaultProps;
	    },
	    set: function set$$1(obj) {
	      // $FlowFixMe
	      this._foldedDefaultProps = isTargetStyledComp ? merge(target.defaultProps, obj) : obj;
	    }
	  });
	
	  if (false) {
	    // $FlowFixMe
	    WrappedStyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
	  }
	
	  // $FlowFixMe
	  WrappedStyledComponent.toString = function () {
	    return '.' + WrappedStyledComponent.styledComponentId;
	  };
	
	  if (isClass) {
	    hoistNonReactStatics(WrappedStyledComponent, target, {
	      // all SC-specific things should not be hoisted
	      attrs: true,
	      componentStyle: true,
	      displayName: true,
	      foldedComponentIds: true,
	      styledComponentId: true,
	      target: true,
	      withComponent: true
	    });
	  }
	
	  return WrappedStyledComponent;
	}
	
	// 
	// Thanks to ReactDOMFactories for this handy list!
	
	var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
	
	// SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'marker', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	
	// 
	
	var styled = function styled(tag) {
	  return constructWithOptions(createStyledComponent, tag);
	};
	
	// Shorthands for all valid HTML Elements
	domElements.forEach(function (domElement) {
	  styled[domElement] = styled(domElement);
	});
	
	// 
	
	var GlobalStyle = function () {
	  function GlobalStyle(rules, componentId) {
	    classCallCheck(this, GlobalStyle);
	
	    this.rules = rules;
	    this.componentId = componentId;
	    this.isStatic = isStaticRules(rules, EMPTY_ARRAY);
	
	    if (!StyleSheet.master.hasId(componentId)) {
	      StyleSheet.master.deferredInject(componentId, []);
	    }
	  }
	
	  GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
	    var flatCSS = flatten(this.rules, executionContext, styleSheet);
	    var css = stringifyRules(flatCSS, '');
	
	    styleSheet.inject(this.componentId, css);
	  };
	
	  GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
	    var componentId = this.componentId;
	
	    if (styleSheet.hasId(componentId)) {
	      styleSheet.remove(componentId);
	    }
	  };
	
	  // TODO: overwrite in-place instead of remove+create?
	
	
	  GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
	    this.removeStyles(styleSheet);
	    this.createStyles(executionContext, styleSheet);
	  };
	
	  return GlobalStyle;
	}();
	
	// 
	
	// place our cache into shared context so it'll persist between HMRs
	if (IS_BROWSER) {
	  window.scCGSHMRCache = {};
	}
	
	function createGlobalStyle(strings) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  var rules = css.apply(undefined, [strings].concat(interpolations));
	  var id = 'sc-global-' + murmurhash(JSON.stringify(rules));
	  var style = new GlobalStyle(rules, id);
	
	  var GlobalStyleComponent = function (_React$Component) {
	    inherits(GlobalStyleComponent, _React$Component);
	
	    function GlobalStyleComponent(props) {
	      classCallCheck(this, GlobalStyleComponent);
	
	      var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	      var _this$constructor = _this.constructor,
	          globalStyle = _this$constructor.globalStyle,
	          styledComponentId = _this$constructor.styledComponentId;
	
	
	      if (IS_BROWSER) {
	        window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
	      }
	
	      /**
	       * This fixes HMR compatibility. Don't ask me why, but this combination of
	       * caching the closure variables via statics and then persisting the statics in
	       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
	       */
	      _this.state = {
	        globalStyle: globalStyle,
	        styledComponentId: styledComponentId
	      };
	      return _this;
	    }
	
	    GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (window.scCGSHMRCache[this.state.styledComponentId]) {
	        window.scCGSHMRCache[this.state.styledComponentId] -= 1;
	      }
	      /**
	       * Depending on the order "render" is called this can cause the styles to be lost
	       * until the next render pass of the remaining instance, which may
	       * not be immediate.
	       */
	      if (window.scCGSHMRCache[this.state.styledComponentId] === 0) {
	        this.state.globalStyle.removeStyles(this.styleSheet);
	      }
	    };
	
	    GlobalStyleComponent.prototype.render = function render() {
	      var _this2 = this;
	
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn('The global style component ' + this.state.styledComponentId + ' was given child JSX. createGlobalStyle does not render children.');
	      }
	
	      return React__default.createElement(
	        StyleSheetConsumer,
	        null,
	        function (styleSheet) {
	          _this2.styleSheet = styleSheet || StyleSheet.master;
	
	          var globalStyle = _this2.state.globalStyle;
	
	
	          if (globalStyle.isStatic) {
	            globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);
	
	            return null;
	          } else {
	            return React__default.createElement(
	              ThemeConsumer,
	              null,
	              function (theme) {
	                // $FlowFixMe
	                var defaultProps = _this2.constructor.defaultProps;
	
	
	                var context = _extends({}, _this2.props);
	
	                if (typeof theme !== 'undefined') {
	                  context.theme = determineTheme(_this2.props, theme, defaultProps);
	                }
	
	                globalStyle.renderStyles(context, _this2.styleSheet);
	
	                return null;
	              }
	            );
	          }
	        }
	      );
	    };
	
	    return GlobalStyleComponent;
	  }(React__default.Component);
	
	  GlobalStyleComponent.globalStyle = style;
	  GlobalStyleComponent.styledComponentId = id;
	
	
	  return GlobalStyleComponent;
	}
	
	// 
	
	var replaceWhitespace = function replaceWhitespace(str) {
	  return str.replace(/\s|\\n/g, '');
	};
	
	function keyframes(strings) {
	  /* Warning if you've used keyframes on React Native */
	  if (false) {
	    // eslint-disable-next-line no-console
	    console.warn('`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.');
	  }
	
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  var rules = css.apply(undefined, [strings].concat(interpolations));
	
	  var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));
	
	  return new Keyframes(name, stringifyRules(rules, name, '@keyframes'));
	}
	
	// 
	
	var withTheme = (function (Component) {
	  var WithTheme = React__default.forwardRef(function (props, ref) {
	    return React__default.createElement(
	      ThemeConsumer,
	      null,
	      function (theme) {
	        // $FlowFixMe
	        var defaultProps = Component.defaultProps;
	
	        var themeProp = determineTheme(props, theme, defaultProps);
	
	        if (false) {
	          // eslint-disable-next-line no-console
	          console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + getComponentName(Component) + '"');
	        }
	
	        return React__default.createElement(Component, _extends({}, props, { theme: themeProp, ref: ref }));
	      }
	    );
	  });
	
	  hoistNonReactStatics(WithTheme, Component);
	
	  WithTheme.displayName = 'WithTheme(' + getComponentName(Component) + ')';
	
	  return WithTheme;
	});
	
	// 
	
	/* eslint-disable */
	var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
	  StyleSheet: StyleSheet
	};
	
	// 
	
	/* Warning if you've imported this file on React Native */
	if (false) {
	  // eslint-disable-next-line no-console
	  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
	}
	
	/* Warning if there are several instances of styled-components */
	if (false) {
	  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;
	
	  if (window['__styled-components-init__'] === 1) {
	    // eslint-disable-next-line no-console
	    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
	  }
	
	  window['__styled-components-init__'] += 1;
	}
	
	//
	
	exports.default = styled;
	exports.createGlobalStyle = createGlobalStyle;
	exports.css = css;
	exports.isStyledComponent = isStyledComponent;
	exports.keyframes = keyframes;
	exports.ServerStyleSheet = ServerStyleSheet;
	exports.StyleSheetConsumer = StyleSheetConsumer;
	exports.StyleSheetContext = StyleSheetContext;
	exports.StyleSheetManager = StyleSheetManager;
	exports.ThemeConsumer = ThemeConsumer;
	exports.ThemeContext = ThemeContext;
	exports.ThemeProvider = ThemeProvider;
	exports.withTheme = withTheme;
	exports.__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS;
	//# sourceMappingURL=styled-components.browser.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledSystem = __webpack_require__(11);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var css = function css(props) {
	  return props.css;
	};
	
	var omit = function omit(obj, blacklist) {
	  var next = {};
	  for (var key in obj) {
	    if (blacklist.indexOf(key) > -1) continue;
	    next[key] = obj[key];
	  }
	  return next;
	};
	
	var styleKeys = Object.keys(_styledSystem.styles).filter(function (key) {
	  return typeof _styledSystem.styles[key] === 'function';
	});
	
	var propNames = styleKeys.reduce(function (a, key) {
	  var names = Object.keys(_styledSystem.styles[key].propTypes);
	  return [].concat(_toConsumableArray(a), _toConsumableArray(names));
	}, []);
	
	// private blacklist
	var _blacklist = ['css', 'is', 'tag', 'extend'].concat(_toConsumableArray(propNames));
	
	var tag = _react2.default.forwardRef(function (_ref, ref) {
	  var _ref$blacklist = _ref.blacklist,
	      blacklist = _ref$blacklist === undefined ? [] : _ref$blacklist,
	      props = _objectWithoutProperties(_ref, ['blacklist']);
	
	  var Base = props.extend || props.tag || props.is || 'div';
	  var next = omit(props, typeof Base === 'string' ? [].concat(_toConsumableArray(_blacklist), _toConsumableArray(blacklist)) : ['extend']);
	  return _react2.default.createElement(Base, _extends({}, next, { ref: ref }));
	});
	
	var getPropTypes = function getPropTypes(funcs) {
	  return funcs.filter(function (fn) {
	    return typeof fn === 'function' && _typeof(fn.propTypes) === 'object';
	  }).reduce(function (a, fn) {
	    return _extends({}, a, fn.propTypes);
	  }, {});
	};
	
	var system = function system() {
	  for (var _len = arguments.length, keysOrStyles = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    keysOrStyles[_key - 1] = arguments[_key];
	  }
	
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var funcs = keysOrStyles.map(function (key) {
	    return _styledSystem.styles[key] || key;
	  });
	  var propTypes = getPropTypes(funcs);
	
	  var Component = (0, _styledComponents2.default)(tag).apply(undefined, [[]].concat(_toConsumableArray(funcs), [css]));
	
	  var baseProps = _styledSystem.util.get(props, 'extend.defaultProps') || {};
	
	  Component.defaultProps = _extends({}, baseProps, props);
	
	  Component.propTypes = getPropTypes(funcs);
	  Component.systemComponent = true;
	
	  return Component;
	};
	
	exports.default = system;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.MobileBar = exports.TinyTile = exports.Textarea = exports.Input = exports.Accordion = exports.UpdateMeta = exports.StaffProfile = exports.PageContent = exports.PageSidebar = exports.ImageSlice = exports.BlockQuote = exports.SearchResult = exports.CalloutContainer = exports.CalloutCard = exports.CampaignCard = exports.InstitutionCard = exports.RegionCard = exports.TagList = exports.Tag = exports.OverlayImage = exports.Main = exports.PageSection = exports.PageHeader = exports.FilterBar = exports.GradientHeader = exports.GradientCard = exports.Article = exports.DropdownMenu = exports.UpdateCard = exports.ExternalUpdateCard = exports.ResourceCard = exports.LazyImage = exports.Text = exports.Search = exports.Select = exports.Logo = exports.Head = exports.Header = exports.Footer = exports.CardLayout = exports.Card = undefined;
	
	var _Buttons = __webpack_require__(223);
	
	Object.keys(_Buttons).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Buttons[key];
	    }
	  });
	});
	
	var _Headings = __webpack_require__(235);
	
	Object.keys(_Headings).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Headings[key];
	    }
	  });
	});
	
	var _Icons = __webpack_require__(138);
	
	Object.keys(_Icons).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Icons[key];
	    }
	  });
	});
	
	var _SliceZone = __webpack_require__(257);
	
	Object.keys(_SliceZone).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SliceZone[key];
	    }
	  });
	});
	
	var _Card2 = __webpack_require__(227);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardLayout2 = __webpack_require__(228);
	
	var _CardLayout3 = _interopRequireDefault(_CardLayout2);
	
	var _Footer2 = __webpack_require__(232);
	
	var _Footer3 = _interopRequireDefault(_Footer2);
	
	var _Header2 = __webpack_require__(234);
	
	var _Header3 = _interopRequireDefault(_Header2);
	
	var _Head2 = __webpack_require__(233);
	
	var _Head3 = _interopRequireDefault(_Head2);
	
	var _Logo2 = __webpack_require__(248);
	
	var _Logo3 = _interopRequireDefault(_Logo2);
	
	var _Select2 = __webpack_require__(255);
	
	var _Select3 = _interopRequireDefault(_Select2);
	
	var _Search2 = __webpack_require__(254);
	
	var _Search3 = _interopRequireDefault(_Search2);
	
	var _Text2 = __webpack_require__(17);
	
	var _Text3 = _interopRequireDefault(_Text2);
	
	var _LazyImage2 = __webpack_require__(247);
	
	var _LazyImage3 = _interopRequireDefault(_LazyImage2);
	
	var _ResourceCard2 = __webpack_require__(253);
	
	var _ResourceCard3 = _interopRequireDefault(_ResourceCard2);
	
	var _ExternalUpdateCard2 = __webpack_require__(230);
	
	var _ExternalUpdateCard3 = _interopRequireDefault(_ExternalUpdateCard2);
	
	var _UpdateCard2 = __webpack_require__(262);
	
	var _UpdateCard3 = _interopRequireDefault(_UpdateCard2);
	
	var _DropdownMenu2 = __webpack_require__(229);
	
	var _DropdownMenu3 = _interopRequireDefault(_DropdownMenu2);
	
	var _Article2 = __webpack_require__(84);
	
	var _Article3 = _interopRequireDefault(_Article2);
	
	var _GradientCard2 = __webpack_require__(134);
	
	var _GradientCard3 = _interopRequireDefault(_GradientCard2);
	
	var _GradientHeader2 = __webpack_require__(135);
	
	var _GradientHeader3 = _interopRequireDefault(_GradientHeader2);
	
	var _FilterBar2 = __webpack_require__(231);
	
	var _FilterBar3 = _interopRequireDefault(_FilterBar2);
	
	var _PageHeader2 = __webpack_require__(250);
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	var _PageSection2 = __webpack_require__(251);
	
	var _PageSection3 = _interopRequireDefault(_PageSection2);
	
	var _Main2 = __webpack_require__(249);
	
	var _Main3 = _interopRequireDefault(_Main2);
	
	var _OverlayImage2 = __webpack_require__(42);
	
	var _OverlayImage3 = _interopRequireDefault(_OverlayImage2);
	
	var _Tag2 = __webpack_require__(258);
	
	var _Tag3 = _interopRequireDefault(_Tag2);
	
	var _TagList2 = __webpack_require__(259);
	
	var _TagList3 = _interopRequireDefault(_TagList2);
	
	var _RegionCard2 = __webpack_require__(252);
	
	var _RegionCard3 = _interopRequireDefault(_RegionCard2);
	
	var _InstitutionCard2 = __webpack_require__(246);
	
	var _InstitutionCard3 = _interopRequireDefault(_InstitutionCard2);
	
	var _CampaignCard2 = __webpack_require__(226);
	
	var _CampaignCard3 = _interopRequireDefault(_CampaignCard2);
	
	var _CalloutCard2 = __webpack_require__(224);
	
	var _CalloutCard3 = _interopRequireDefault(_CalloutCard2);
	
	var _CalloutContainer2 = __webpack_require__(225);
	
	var _CalloutContainer3 = _interopRequireDefault(_CalloutContainer2);
	
	var _SearchResult2 = __webpack_require__(143);
	
	var _SearchResult3 = _interopRequireDefault(_SearchResult2);
	
	var _BlockQuote2 = __webpack_require__(132);
	
	var _BlockQuote3 = _interopRequireDefault(_BlockQuote2);
	
	var _ImageSlice2 = __webpack_require__(139);
	
	var _ImageSlice3 = _interopRequireDefault(_ImageSlice2);
	
	var _PageSidebar2 = __webpack_require__(142);
	
	var _PageSidebar3 = _interopRequireDefault(_PageSidebar2);
	
	var _PageContent2 = __webpack_require__(141);
	
	var _PageContent3 = _interopRequireDefault(_PageContent2);
	
	var _StaffProfile2 = __webpack_require__(144);
	
	var _StaffProfile3 = _interopRequireDefault(_StaffProfile2);
	
	var _UpdateMeta2 = __webpack_require__(263);
	
	var _UpdateMeta3 = _interopRequireDefault(_UpdateMeta2);
	
	var _Accordion2 = __webpack_require__(222);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	var _Input2 = __webpack_require__(245);
	
	var _Input3 = _interopRequireDefault(_Input2);
	
	var _Textarea2 = __webpack_require__(260);
	
	var _Textarea3 = _interopRequireDefault(_Textarea2);
	
	var _TinyTile2 = __webpack_require__(261);
	
	var _TinyTile3 = _interopRequireDefault(_TinyTile2);
	
	var _MobileBar2 = __webpack_require__(140);
	
	var _MobileBar3 = _interopRequireDefault(_MobileBar2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Card = _Card3.default;
	exports.CardLayout = _CardLayout3.default;
	exports.Footer = _Footer3.default;
	exports.Header = _Header3.default;
	exports.Head = _Head3.default;
	exports.Logo = _Logo3.default;
	exports.Select = _Select3.default;
	exports.Search = _Search3.default;
	exports.Text = _Text3.default;
	exports.LazyImage = _LazyImage3.default;
	exports.ResourceCard = _ResourceCard3.default;
	exports.ExternalUpdateCard = _ExternalUpdateCard3.default;
	exports.UpdateCard = _UpdateCard3.default;
	exports.DropdownMenu = _DropdownMenu3.default;
	exports.Article = _Article3.default;
	exports.GradientCard = _GradientCard3.default;
	exports.GradientHeader = _GradientHeader3.default;
	exports.FilterBar = _FilterBar3.default;
	exports.PageHeader = _PageHeader3.default;
	exports.PageSection = _PageSection3.default;
	exports.Main = _Main3.default;
	exports.OverlayImage = _OverlayImage3.default;
	exports.Tag = _Tag3.default;
	exports.TagList = _TagList3.default;
	exports.RegionCard = _RegionCard3.default;
	exports.InstitutionCard = _InstitutionCard3.default;
	exports.CampaignCard = _CampaignCard3.default;
	exports.CalloutCard = _CalloutCard3.default;
	exports.CalloutContainer = _CalloutContainer3.default;
	exports.SearchResult = _SearchResult3.default;
	exports.BlockQuote = _BlockQuote3.default;
	exports.ImageSlice = _ImageSlice3.default;
	exports.PageSidebar = _PageSidebar3.default;
	exports.PageContent = _PageContent3.default;
	exports.StaffProfile = _StaffProfile3.default;
	exports.UpdateMeta = _UpdateMeta3.default;
	exports.Accordion = _Accordion3.default;
	exports.Input = _Input3.default;
	exports.Textarea = _Textarea3.default;
	exports.TinyTile = _TinyTile3.default;
	exports.MobileBar = _MobileBar3.default;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.wordWrap = exports.triangle = exports.transparentize = exports.transitions = exports.toColorString = exports.tint = exports.timingFunctions = exports.textInputs = exports.stripUnit = exports.size = exports.shade = exports.setSaturation = exports.setLightness = exports.setHue = exports.selection = exports.saturate = exports.rgba = exports.rgb = exports.retinaImage = exports.rem = exports.readableColor = exports.radialGradient = exports.position = exports.placeholder = exports.parseToRgb = exports.parseToHsl = exports.padding = exports.opacify = exports.normalize = exports.modularScale = exports.mix = exports.margin = exports.lighten = exports.hsla = exports.hsl = exports.hiDPI = exports.hideVisually = exports.hideText = exports.invert = exports.grayscale = exports.getLuminance = exports.fontFace = exports.em = exports.ellipsis = exports.directionalProperty = exports.desaturate = exports.darken = exports.complement = exports.clearFix = exports.buttons = exports.borderWidth = exports.borderStyle = exports.borderRadius = exports.borderColor = exports.backgrounds = exports.backgroundImages = exports.animation = exports.adjustHue = undefined;
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(35);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	var _em = /*#__PURE__*/__webpack_require__(1710);
	
	var _em2 = /*#__PURE__*/_interopRequireDefault(_em);
	
	var _modularScale = /*#__PURE__*/__webpack_require__(1711);
	
	var _modularScale2 = /*#__PURE__*/_interopRequireDefault(_modularScale);
	
	var _rem = /*#__PURE__*/__webpack_require__(1712);
	
	var _rem2 = /*#__PURE__*/_interopRequireDefault(_rem);
	
	var _stripUnit = /*#__PURE__*/__webpack_require__(115);
	
	var _stripUnit2 = /*#__PURE__*/_interopRequireDefault(_stripUnit);
	
	var _clearFix = /*#__PURE__*/__webpack_require__(1716);
	
	var _clearFix2 = /*#__PURE__*/_interopRequireDefault(_clearFix);
	
	var _ellipsis = /*#__PURE__*/__webpack_require__(1717);
	
	var _ellipsis2 = /*#__PURE__*/_interopRequireDefault(_ellipsis);
	
	var _fontFace = /*#__PURE__*/__webpack_require__(1718);
	
	var _fontFace2 = /*#__PURE__*/_interopRequireDefault(_fontFace);
	
	var _hideText = /*#__PURE__*/__webpack_require__(1719);
	
	var _hideText2 = /*#__PURE__*/_interopRequireDefault(_hideText);
	
	var _hideVisually = /*#__PURE__*/__webpack_require__(1720);
	
	var _hideVisually2 = /*#__PURE__*/_interopRequireDefault(_hideVisually);
	
	var _hiDPI = /*#__PURE__*/__webpack_require__(179);
	
	var _hiDPI2 = /*#__PURE__*/_interopRequireDefault(_hiDPI);
	
	var _normalize = /*#__PURE__*/__webpack_require__(1721);
	
	var _normalize2 = /*#__PURE__*/_interopRequireDefault(_normalize);
	
	var _placeholder = /*#__PURE__*/__webpack_require__(1722);
	
	var _placeholder2 = /*#__PURE__*/_interopRequireDefault(_placeholder);
	
	var _radialGradient = /*#__PURE__*/__webpack_require__(1723);
	
	var _radialGradient2 = /*#__PURE__*/_interopRequireDefault(_radialGradient);
	
	var _retinaImage = /*#__PURE__*/__webpack_require__(1724);
	
	var _retinaImage2 = /*#__PURE__*/_interopRequireDefault(_retinaImage);
	
	var _selection = /*#__PURE__*/__webpack_require__(1725);
	
	var _selection2 = /*#__PURE__*/_interopRequireDefault(_selection);
	
	var _timingFunctions = /*#__PURE__*/__webpack_require__(1726);
	
	var _timingFunctions2 = /*#__PURE__*/_interopRequireDefault(_timingFunctions);
	
	var _triangle = /*#__PURE__*/__webpack_require__(1727);
	
	var _triangle2 = /*#__PURE__*/_interopRequireDefault(_triangle);
	
	var _wordWrap = /*#__PURE__*/__webpack_require__(1728);
	
	var _wordWrap2 = /*#__PURE__*/_interopRequireDefault(_wordWrap);
	
	var _adjustHue = /*#__PURE__*/__webpack_require__(1694);
	
	var _adjustHue2 = /*#__PURE__*/_interopRequireDefault(_adjustHue);
	
	var _complement = /*#__PURE__*/__webpack_require__(1695);
	
	var _complement2 = /*#__PURE__*/_interopRequireDefault(_complement);
	
	var _darken = /*#__PURE__*/__webpack_require__(1696);
	
	var _darken2 = /*#__PURE__*/_interopRequireDefault(_darken);
	
	var _desaturate = /*#__PURE__*/__webpack_require__(1697);
	
	var _desaturate2 = /*#__PURE__*/_interopRequireDefault(_desaturate);
	
	var _getLuminance = /*#__PURE__*/__webpack_require__(170);
	
	var _getLuminance2 = /*#__PURE__*/_interopRequireDefault(_getLuminance);
	
	var _grayscale = /*#__PURE__*/__webpack_require__(1698);
	
	var _grayscale2 = /*#__PURE__*/_interopRequireDefault(_grayscale);
	
	var _hsl = /*#__PURE__*/__webpack_require__(171);
	
	var _hsl2 = /*#__PURE__*/_interopRequireDefault(_hsl);
	
	var _hsla = /*#__PURE__*/__webpack_require__(172);
	
	var _hsla2 = /*#__PURE__*/_interopRequireDefault(_hsla);
	
	var _invert = /*#__PURE__*/__webpack_require__(1699);
	
	var _invert2 = /*#__PURE__*/_interopRequireDefault(_invert);
	
	var _lighten = /*#__PURE__*/__webpack_require__(1700);
	
	var _lighten2 = /*#__PURE__*/_interopRequireDefault(_lighten);
	
	var _mix = /*#__PURE__*/__webpack_require__(113);
	
	var _mix2 = /*#__PURE__*/_interopRequireDefault(_mix);
	
	var _opacify = /*#__PURE__*/__webpack_require__(1701);
	
	var _opacify2 = /*#__PURE__*/_interopRequireDefault(_opacify);
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(21);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(28);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _readableColor = /*#__PURE__*/__webpack_require__(1702);
	
	var _readableColor2 = /*#__PURE__*/_interopRequireDefault(_readableColor);
	
	var _rgb = /*#__PURE__*/__webpack_require__(114);
	
	var _rgb2 = /*#__PURE__*/_interopRequireDefault(_rgb);
	
	var _rgba = /*#__PURE__*/__webpack_require__(63);
	
	var _rgba2 = /*#__PURE__*/_interopRequireDefault(_rgba);
	
	var _saturate = /*#__PURE__*/__webpack_require__(1703);
	
	var _saturate2 = /*#__PURE__*/_interopRequireDefault(_saturate);
	
	var _setHue = /*#__PURE__*/__webpack_require__(1704);
	
	var _setHue2 = /*#__PURE__*/_interopRequireDefault(_setHue);
	
	var _setLightness = /*#__PURE__*/__webpack_require__(1705);
	
	var _setLightness2 = /*#__PURE__*/_interopRequireDefault(_setLightness);
	
	var _setSaturation = /*#__PURE__*/__webpack_require__(1706);
	
	var _setSaturation2 = /*#__PURE__*/_interopRequireDefault(_setSaturation);
	
	var _shade = /*#__PURE__*/__webpack_require__(1707);
	
	var _shade2 = /*#__PURE__*/_interopRequireDefault(_shade);
	
	var _tint = /*#__PURE__*/__webpack_require__(1708);
	
	var _tint2 = /*#__PURE__*/_interopRequireDefault(_tint);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(20);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _transparentize = /*#__PURE__*/__webpack_require__(1709);
	
	var _transparentize2 = /*#__PURE__*/_interopRequireDefault(_transparentize);
	
	var _animation = /*#__PURE__*/__webpack_require__(1729);
	
	var _animation2 = /*#__PURE__*/_interopRequireDefault(_animation);
	
	var _backgroundImages = /*#__PURE__*/__webpack_require__(1730);
	
	var _backgroundImages2 = /*#__PURE__*/_interopRequireDefault(_backgroundImages);
	
	var _backgrounds = /*#__PURE__*/__webpack_require__(1731);
	
	var _backgrounds2 = /*#__PURE__*/_interopRequireDefault(_backgrounds);
	
	var _borderColor = /*#__PURE__*/__webpack_require__(1732);
	
	var _borderColor2 = /*#__PURE__*/_interopRequireDefault(_borderColor);
	
	var _borderRadius = /*#__PURE__*/__webpack_require__(1733);
	
	var _borderRadius2 = /*#__PURE__*/_interopRequireDefault(_borderRadius);
	
	var _borderStyle = /*#__PURE__*/__webpack_require__(1734);
	
	var _borderStyle2 = /*#__PURE__*/_interopRequireDefault(_borderStyle);
	
	var _borderWidth = /*#__PURE__*/__webpack_require__(1735);
	
	var _borderWidth2 = /*#__PURE__*/_interopRequireDefault(_borderWidth);
	
	var _buttons = /*#__PURE__*/__webpack_require__(1736);
	
	var _buttons2 = /*#__PURE__*/_interopRequireDefault(_buttons);
	
	var _margin = /*#__PURE__*/__webpack_require__(1737);
	
	var _margin2 = /*#__PURE__*/_interopRequireDefault(_margin);
	
	var _padding = /*#__PURE__*/__webpack_require__(1738);
	
	var _padding2 = /*#__PURE__*/_interopRequireDefault(_padding);
	
	var _position = /*#__PURE__*/__webpack_require__(1739);
	
	var _position2 = /*#__PURE__*/_interopRequireDefault(_position);
	
	var _size = /*#__PURE__*/__webpack_require__(1740);
	
	var _size2 = /*#__PURE__*/_interopRequireDefault(_size);
	
	var _textInputs = /*#__PURE__*/__webpack_require__(1741);
	
	var _textInputs2 = /*#__PURE__*/_interopRequireDefault(_textInputs);
	
	var _transitions = /*#__PURE__*/__webpack_require__(1742);
	
	var _transitions2 = /*#__PURE__*/_interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Shorthands
	
	// Helpers
	exports.adjustHue = _adjustHue2.default;
	exports.animation = _animation2.default;
	exports.backgroundImages = _backgroundImages2.default;
	exports.backgrounds = _backgrounds2.default;
	exports.borderColor = _borderColor2.default;
	exports.borderRadius = _borderRadius2.default;
	exports.borderStyle = _borderStyle2.default;
	exports.borderWidth = _borderWidth2.default;
	exports.buttons = _buttons2.default;
	exports.clearFix = _clearFix2.default;
	exports.complement = _complement2.default;
	exports.darken = _darken2.default;
	exports.desaturate = _desaturate2.default;
	exports.directionalProperty = _directionalProperty2.default;
	exports.ellipsis = _ellipsis2.default;
	exports.em = _em2.default;
	exports.fontFace = _fontFace2.default;
	exports.getLuminance = _getLuminance2.default;
	exports.grayscale = _grayscale2.default;
	exports.invert = _invert2.default;
	exports.hideText = _hideText2.default;
	exports.hideVisually = _hideVisually2.default;
	exports.hiDPI = _hiDPI2.default;
	exports.hsl = _hsl2.default;
	exports.hsla = _hsla2.default;
	exports.lighten = _lighten2.default;
	exports.margin = _margin2.default;
	exports.mix = _mix2.default;
	exports.modularScale = _modularScale2.default;
	exports.normalize = _normalize2.default;
	exports.opacify = _opacify2.default;
	exports.padding = _padding2.default;
	exports.parseToHsl = _parseToHsl2.default;
	exports.parseToRgb = _parseToRgb2.default;
	exports.placeholder = _placeholder2.default;
	exports.position = _position2.default;
	exports.radialGradient = _radialGradient2.default;
	exports.readableColor = _readableColor2.default;
	exports.rem = _rem2.default;
	exports.retinaImage = _retinaImage2.default;
	exports.rgb = _rgb2.default;
	exports.rgba = _rgba2.default;
	exports.saturate = _saturate2.default;
	exports.selection = _selection2.default;
	exports.setHue = _setHue2.default;
	exports.setLightness = _setLightness2.default;
	exports.setSaturation = _setSaturation2.default;
	exports.shade = _shade2.default;
	exports.size = _size2.default;
	exports.stripUnit = _stripUnit2.default;
	exports.textInputs = _textInputs2.default;
	exports.timingFunctions = _timingFunctions2.default;
	exports.tint = _tint2.default;
	exports.toColorString = _toColorString2.default;
	exports.transitions = _transitions2.default;
	exports.transparentize = _transparentize2.default;
	exports.triangle = _triangle2.default;
	exports.wordWrap = _wordWrap2.default;
	
	// Color
	
	
	// Mixins

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.navigateTo = exports.replace = exports.push = undefined;
	
	var _extends2 = __webpack_require__(313);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(309);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(314);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(65);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(86);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(85);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.withPrefix = withPrefix;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(79);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*global __PREFIX_PATHS__, __PATH_PREFIX__ */
	var pathPrefix = "/";
	if (false) {
	  pathPrefix = __PATH_PREFIX__;
	}
	
	function withPrefix(path) {
	  return normalizePath(pathPrefix + path);
	}
	
	function normalizePath(path) {
	  return path.replace(/^\/\//g, "/");
	}
	
	function createLocation(path, history) {
	  var location = (0, _history.createLocation)(path, null, null, history.location);
	  location.pathname = withPrefix(location.pathname);
	  return location;
	}
	
	var NavLinkPropTypes = {
	  activeClassName: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  isActive: _propTypes2.default.func,
	  location: _propTypes2.default.object
	
	  // Set up IntersectionObserver
	};var handleIntersection = function handleIntersection(el, cb) {
	  var io = new window.IntersectionObserver(function (entries) {
	    entries.forEach(function (entry) {
	      if (el === entry.target) {
	        // Check if element is within viewport, remove listener, destroy observer, and run link callback.
	        // MSEdge doesn't currently support isIntersecting, so also test for  an intersectionRatio > 0
	        if (entry.isIntersecting || entry.intersectionRatio > 0) {
	          io.unobserve(el);
	          io.disconnect();
	          cb();
	        }
	      }
	    });
	  });
	  // Add element to the observer
	  io.observe(el);
	};
	
	/* eslint-disable react/no-deprecated */
	
	var GatsbyLink = function (_React$Component) {
	  (0, _inherits3.default)(GatsbyLink, _React$Component);
	
	  function GatsbyLink(props, context) {
	    (0, _classCallCheck3.default)(this, GatsbyLink);
	
	    // Default to no support for IntersectionObserver
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	    var IOSupported = false;
	    if (typeof window !== "undefined" && window.IntersectionObserver) {
	      IOSupported = true;
	    }
	
	    var history = context.router.history;
	
	    var to = createLocation(props.to, history);
	
	    _this.state = {
	      path: (0, _history.createPath)(to),
	      to: to,
	      IOSupported: IOSupported
	    };
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  GatsbyLink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.to !== nextProps.to) {
	      var to = createLocation(nextProps.to, history);
	      this.setState({
	        path: (0, _history.createPath)(to),
	        to: to
	      });
	      // Preserve non IO functionality if no support
	      if (!this.state.IOSupported) {
	        ___loader.enqueue(this.state.to.pathname);
	      }
	    }
	  };
	
	  GatsbyLink.prototype.componentDidMount = function componentDidMount() {
	    // Preserve non IO functionality if no support
	    if (!this.state.IOSupported) {
	      ___loader.enqueue(this.state.to.pathname);
	    }
	  };
	
	  GatsbyLink.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    this.props.innerRef && this.props.innerRef(ref);
	
	    if (this.state.IOSupported && ref) {
	      // If IO supported and element reference found, setup Observer functionality
	      handleIntersection(ref, function () {
	        ___loader.enqueue(_this2.state.to.pathname);
	      });
	    }
	  };
	
	  GatsbyLink.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        _onClick = _props.onClick,
	        rest = (0, _objectWithoutProperties3.default)(_props, ["onClick"]);
	
	    var El = void 0;
	    if ((0, _keys2.default)(NavLinkPropTypes).some(function (propName) {
	      return _this3.props[propName];
	    })) {
	      El = _reactRouterDom.NavLink;
	    } else {
	      El = _reactRouterDom.Link;
	    }
	
	    return _react2.default.createElement(El, (0, _extends3.default)({
	      onClick: function onClick(e) {
	        // eslint-disable-line
	        _onClick && _onClick(e);
	
	        if (e.button === 0 && // ignore right clicks
	        !_this3.props.target && // let browser handle "target=_blank"
	        !e.defaultPrevented && // onClick prevented default
	        !e.metaKey && // ignore clicks with modifier keys...
	        !e.altKey && !e.ctrlKey && !e.shiftKey) {
	          // Is this link pointing to a hash on the same page? If so,
	          // just scroll there.
	          var pathname = _this3.state.path;
	          if (pathname.split("#").length > 1) {
	            pathname = pathname.split("#").slice(0, -1).join("");
	          }
	          if (pathname === window.location.pathname) {
	            var hashFragment = _this3.state.path.split("#").slice(1).join("#");
	            var element = document.getElementById(hashFragment);
	            if (element !== null) {
	              element.scrollIntoView();
	              return true;
	            } else {
	              // This is just a normal link to the current page so let's emulate default
	              // browser behavior by scrolling now to the top of the page.
	              window.scrollTo(0, 0);
	              return true;
	            }
	          }
	
	          // In production, make sure the necessary scripts are
	          // loaded before continuing.
	          if (true) {
	            e.preventDefault();
	            window.___push(_this3.state.to);
	          }
	        }
	
	        return true;
	      }
	    }, rest, {
	      to: this.state.to,
	      innerRef: this.handleRef
	    }));
	  };
	
	  return GatsbyLink;
	}(_react2.default.Component);
	/* eslint-enable */
	
	GatsbyLink.propTypes = (0, _extends3.default)({}, NavLinkPropTypes, {
	  innerRef: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	});
	
	GatsbyLink.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	exports.default = GatsbyLink;
	var push = exports.push = function push(to) {
	  window.___push(to);
	};
	
	var replace = exports.replace = function replace(to) {
	  window.___replace(to);
	};
	
	var navigateTo = exports.navigateTo = push;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("PrismicDOM",[],t):"object"==typeof exports?exports.PrismicDOM=t():e.PrismicDOM=t()}("undefined"!=typeof self?self:this,(function(){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=1)}([function(e,t,n){"undefined"!=typeof self&&self,e.exports=function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=0)}([function(e,t,n){e.exports=n(1)},function(e,t,n){var r=n(2),o=n(3);e.exports={Link:r,Date:o}},function(e,t,n){e.exports={url:function(e,t){var n=e&&e.value?e.value.document:e;if(e&&[e.type,e.link_type,e._linkType,e.linkType].some((function(e){return e&&["Document","Link.Document","Link.document"].includes(e)}))&&t&&"function"==typeof t){var r=t(n);if(r)return r}return n&&n.url?n.url:""}}},function(e,t){e.exports=function(e){if(!e)return null;var t=24==e.length?"".concat(e.substring(0,22),":").concat(e.substring(22,24)):e;return new Date(t)}}])},function(e,t,n){e.exports=n(2)},function(e,t,n){var r=n(0),o=n(3),i=r.Date,u=r.Link;e.exports={Date:i,Link:u,RichText:o}},function(e,t,n){var r=n(4),o=n(0).Link,i=n(5),u=r.Elements;function c(e,t,n,r,c){switch(t){case u.heading1:return l("h1",n,c);case u.heading2:return l("h2",n,c);case u.heading3:return l("h3",n,c);case u.heading4:return l("h4",n,c);case u.heading5:return l("h5",n,c);case u.heading6:return l("h6",n,c);case u.paragraph:return l("p",n,c);case u.preformatted:return function(e){return"<pre".concat(a(e),">").concat(i(e.text),"</pre>")}(n);case u.strong:return l("strong",n,c);case u.em:return l("em",n,c);case u.listItem:case u.oListItem:return l("li",n,c);case u.list:return l("ul",n,c);case u.oList:return l("ol",n,c);case u.image:return function(e,t){var n=t.linkTo?o.url(t.linkTo,e):null,r=t.linkTo&&t.linkTo.target?'target="'.concat(t.linkTo.target,'" rel="noopener"'):"",u=[t.label||"","block-img"],c='<img src="'.concat(t.url,'" alt="').concat(t.alt?i(t.alt):"",'" copyright="').concat(t.copyright?i(t.copyright):"",'" />');return'\n    <p class="'.concat(u.join(" "),'">\n      ').concat(n?"<a ".concat(r,' href="').concat(n,'">').concat(c,"</a>"):c,"\n    </p>\n  ")}(e,n);case u.embed:return function(e){return'\n    <div data-oembed="'.concat(e.oembed.embed_url,'"\n      data-oembed-type="').concat(e.oembed.type,'"\n      data-oembed-provider="').concat(e.oembed.provider_name,'"\n      ').concat(a(e),">\n\n      ").concat(e.oembed.html,"\n    </div>\n  ")}(n);case u.hyperlink:return function(e,t,n){var r=t.data.target?'target="'.concat(t.data.target,'" rel="noopener"'):"",u=i(o.url(t.data,e));return"<a ".concat(r,' href="').concat(u,'">').concat(n.join(""),"</a>")}(e,n,c);case u.label:return function(e,t){return"<span ".concat(a(e.data),">").concat(t.join(""),"</span>")}(n,c);case u.span:return function(e){return e?i(e).replace(/\n/g,"<br />"):""}(r);default:return""}}function a(e){return e.label?' class="'.concat(e.label,'"'):""}function l(e,t,n){return"<".concat(e).concat(a(t),">").concat(n.join(""),"</").concat(e,">")}e.exports={asText:function(e,t){return r.asText(e,t)},asHtml:function(e,t,n){return r.serialize(e,c.bind(null,t),n).join("")},Elements:u}},function(e,t,n){"undefined"!=typeof self&&self,e.exports=function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=4)}([function(e,t,n){"use strict";var r;function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}Object.defineProperty(t,"__esModule",{value:!0}),t.PRIORITIES=t.NODE_TYPES=void 0;var i={heading1:"heading1",heading2:"heading2",heading3:"heading3",heading4:"heading4",heading5:"heading5",heading6:"heading6",paragraph:"paragraph",preformatted:"preformatted",strong:"strong",em:"em",listItem:"list-item",oListItem:"o-list-item",list:"group-list-item",oList:"group-o-list-item",image:"image",embed:"embed",hyperlink:"hyperlink",label:"label",span:"span"};t.NODE_TYPES=i;var u=(o(r={},i.heading1,4),o(r,i.heading2,4),o(r,i.heading3,4),o(r,i.heading4,4),o(r,i.heading5,4),o(r,i.heading6,4),o(r,i.paragraph,3),o(r,i.preformatted,5),o(r,i.strong,6),o(r,i.em,6),o(r,i.oList,1),o(r,i.list,1),o(r,i.listItem,1),o(r,i.oListItem,1),o(r,i.image,1),o(r,i.embed,1),o(r,i.hyperlink,3),o(r,i.label,4),o(r,i.span,7),r);t.PRIORITIES=u},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r,o=n(7),i=n(2),u=n(8),c=n(0),a=(r=n(3))&&r.__esModule?r:{default:r};function l(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function s(e){if(0===e.length)throw new Error("Unable to elect node on empty list");var t=function(e){return function(e){if(Array.isArray(e))return e}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}(e.sort((function(e,t){if(e.isParentOf(t))return-1;if(t.isParentOf(e))return 1;var n=c.PRIORITIES[e.type]-c.PRIORITIES[t.type];return 0===n?e.text.length-t.text.length:n})));return{elected:t[0],others:t.slice(1)}}function f(e,t,n){if(t.length>0)return function(e,t,n){return t.reduce((function(r,o,u){var c=[],a=0===u&&o.start>n.lower,l=u===t.length-1&&n.upper>o.end;if(a){var s=new i.TextNode(n.lower,o.start,e.slice(n.lower,o.start));c=c.concat(s)}else{var f=t[u-1];if(f&&o.start>f.end){var d=e.slice(f.end,o.start),p=new i.TextNode(f.end,o.start,d);c=c.concat(p)}}if(c=c.concat(o),l){var y=new i.TextNode(o.end,n.upper,e.slice(o.end,n.upper));c=c.concat(y)}return r.concat(c)}),[])}(e,d(e,t),n);var r=e.slice(n.lower,n.upper);return[new i.TextNode(n.lower,n.upper,r)]}function d(e,t){var n=function(e){return function(e,t){return t.reduce((function(e,t){var n=(0,o.last)(e);if(n){if(n.some((function(e){return e.isParentOf(t)})))return(0,o.init)(e).concat([n.concat(t)]);var r=(0,o.last)(n);return r&&function(e,t){return e.end>=t.start}(r,t)?(0,o.init)(e).concat([n.concat(t)]):e.concat([[t]])}return[[t]]}),[])}(0,(0,o.sort)(e,(function(e,t){return n=t,e.start-n.start||function(e,t){return e.end-t.end}(e,t);var n})))}((0,o.sort)(t,(function(e,t){return e.start-t.start}))).map(s),r=(0,o.flatten)(n.map((function(t){return function(e,t){var n=t.others.reduce((function(n,r){var o=n.inner,u=n.outer,c=function(e,t,n){return n.start<t.start?{inner:i.SpanNode.slice(n,t.start,n.end,e),outer:i.SpanNode.slice(n,n.start,t.start,e)}:n.end>t.end?{inner:i.SpanNode.slice(n,n.start,t.end,e),outer:i.SpanNode.slice(n,t.end,n.end,e)}:{inner:n}}(e,t.elected,r);return{inner:o.concat(c.inner),outer:c.outer?u.concat(c.outer):u}}),{inner:[],outer:[]}),r=n.inner,o=n.outer;return[t.elected.setChildren(f(e,r,t.elected.boundaries()))].concat(d(e,o))}(e,t)})));return(0,o.sort)(r,(function(e,t){return e.start-t.start}))}var p=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e)}var t,n;return t=e,(n=[{key:"fromRichText",value:function(e){return{key:(0,a.default)(),children:e.reduce((function(e,t,n){if(u.RichTextBlock.isEmbedBlock(t.type)||u.RichTextBlock.isImageBlock(t.type))return e.concat(new i.BlockNode(t.type,t));var r=function(e){var t=(e.spans||[]).map((function(t){var n=e.text.slice(t.start,t.end);return new i.SpanNode(t.start,t.end,t.type,n,[],t)})),n={lower:0,upper:e.text.length};return f(e.text,t,n)}(t),c=e[e.length-1];if(u.RichTextBlock.isListItem(t.type)&&c&&c instanceof i.ListBlockNode){var a=new i.ListItemBlockNode(t,r),l=c.addChild(a);return(0,o.init)(e).concat(l)}if(u.RichTextBlock.isOrderedListItem(t.type)&&c&&c instanceof i.OrderedListBlockNode){var s=new i.OrderedListItemBlockNode(t,r),d=c.addChild(s);return(0,o.init)(e).concat(d)}if(u.RichTextBlock.isListItem(t.type)){var p=new i.ListItemBlockNode(t,r),y=new i.ListBlockNode(u.RichTextBlock.emptyList(),[p]);return e.concat(y)}if(u.RichTextBlock.isOrderedListItem(t.type)){var h=new i.OrderedListItemBlockNode(t,r),v=new i.OrderedListBlockNode(u.RichTextBlock.emptyOrderedList(),[h]);return e.concat(v)}return e.concat(new i.BlockNode(t.type,t,r))}),[])}}}])&&l(t,n),e}();t.default=p},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.ListBlockNode=t.OrderedListBlockNode=t.OrderedListItemBlockNode=t.ListItemBlockNode=t.BlockNode=t.TextNode=t.SpanNode=t.Node=void 0;var r,o=(r=n(3))&&r.__esModule?r:{default:r},i=n(0);function u(e){return(u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function c(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function a(e,t,n){return t&&c(e.prototype,t),n&&c(e,n),e}function l(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&function(e,t){(Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}(e,t)}function s(e){return function(){var t,n=f(e);if(function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}()){var r=f(this).constructor;t=Reflect.construct(n,arguments,r)}else t=n.apply(this,arguments);return function(e,t){return!t||"object"!==u(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}(this,t)}}function f(e){return(f=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function d(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var p=function e(t,n,r){d(this,e),this.key=(0,o.default)(),this.type=t,this.element=n,this.children=r};t.Node=p;var y=function(e){l(n,p);var t=s(n);function n(e,r,o,i,u,c){var a;return d(this,n),(a=t.call(this,o,c,u)).start=e,a.end=r,a.text=i,a.children=u,a}return a(n,[{key:"boundaries",value:function(){return{lower:this.start,upper:this.end}}},{key:"isParentOf",value:function(e){return this.start<=e.start&&this.end>=e.end}},{key:"setChildren",value:function(e){return new n(this.start,this.end,this.type,this.text,e,this.element)}}],[{key:"slice",value:function(e,t,r,o){return new n(t,r,e.type,o.slice(t,r),e.children,e.element)}}]),n}();t.SpanNode=y;var h=function(e){l(n,y);var t=s(n);function n(e,r,o){d(this,n);var u={type:i.NODE_TYPES.span,start:e,end:r,text:o};return t.call(this,e,r,i.NODE_TYPES.span,o,[],u)}return n}();t.TextNode=h;var v=function(e){l(n,p);var t=s(n);function n(e,r){var o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[];return d(this,n),t.call(this,e,r,o)}return n}();t.BlockNode=v;var m=function(e){l(n,v);var t=s(n);function n(e,r){return d(this,n),t.call(this,i.NODE_TYPES.listItem,e,r)}return n}();t.ListItemBlockNode=m;var b=function(e){l(n,v);var t=s(n);function n(e,r){return d(this,n),t.call(this,i.NODE_TYPES.oListItem,e,r)}return n}();t.OrderedListItemBlockNode=b;var g=function(e){l(n,v);var t=s(n);function n(e,r){return d(this,n),t.call(this,i.NODE_TYPES.oList,e,r)}return a(n,[{key:"addChild",value:function(e){var t=this.children.concat(e);return new n(this.element,t)}}]),n}();t.OrderedListBlockNode=g;var x=function(e){l(n,v);var t=s(n);function n(e,r){return d(this,n),t.call(this,i.NODE_TYPES.list,e,r)}return a(n,[{key:"addChild",value:function(e){var t=this.children.concat(e);return new n(this.element,t)}}]),n}();t.ListBlockNode=x},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(){var e=(new Date).getTime();return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(function(t){var n=(e+16*Math.random())%16|0;return e=Math.floor(e/16),("x"==t?n:3&n|8).toString(16)}))}},function(e,t,n){e.exports=n(5)},function(e,t,n){"use strict";var r=c(n(6)),o=c(n(1)),i=c(n(9)),u=n(0);function c(e){return e&&e.__esModule?e:{default:e}}e.exports={asText:r.default,asTree:o.default.fromRichText,serialize:i.default,Elements:u.NODE_TYPES}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0,t.default=function(e,t){var n="string"==typeof t?t:" ";return e.map((function(e){return e.text})).join(n)}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.init=function(e){return e.slice(0,-1)},t.last=function(e){return e[e.length-1]},t.flatten=function(e){var t=[],n=!0,r=!1,o=void 0;try{for(var i,u=e[Symbol.iterator]();!(n=(i=u.next()).done);n=!0){var c=i.value;Array.isArray(c)?t.push.apply(t,c):t.push(c)}}catch(e){r=!0,o=e}finally{try{n||null==u.return||u.return()}finally{if(r)throw o}}return t},t.sort=function(e,t){return function(e){return function(e){if(Array.isArray(e)){for(var t=0,n=new Array(e.length);t<e.length;t++)n[t]=e[t];return n}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}(e).sort(t)}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.RichTextBlock=void 0;var r=n(0);function o(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var i=function(){function e(t,n,r){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.type=t,this.text=n,this.spans=r}var t,n;return t=e,(n=[{key:"isEmbedBlock",value:function(e){return e===r.NODE_TYPES.embed}},{key:"isImageBlock",value:function(e){return e===r.NODE_TYPES.image}},{key:"isList",value:function(e){return e===r.NODE_TYPES.list}},{key:"isOrderedList",value:function(e){return e===r.NODE_TYPES.oList}},{key:"isListItem",value:function(e){return e===r.NODE_TYPES.listItem}},{key:"isOrderedListItem",value:function(e){return e===r.NODE_TYPES.oListItem}},{key:"emptyList",value:function(){return{type:r.NODE_TYPES.list,spans:[],text:""}}},{key:"emptyOrderedList",value:function(){return{type:r.NODE_TYPES.oList,spans:[],text:""}}}])&&o(t,n),e}();t.RichTextBlock=i},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var r,o=(r=n(1))&&r.__esModule?r:{default:r},i=n(2);t.default=function(e,t,n){return o.default.fromRichText(e).children.map((function(e,r){return function(e,t,n,r){return function e(n,o){var u=n instanceof i.SpanNode?n.text:null,c=n.children.reduce((function(t,n,r){return t.concat([e(n,r)])}),[]);return r&&r(n.type,n.element,u,c,o)||t(n.type,n.element,u,c,o)}(e,n)}(e,t,r,n)}))}}])},function(e,t,n){"use strict";
	/*!
	 * escape-html
	 * Copyright(c) 2012-2013 TJ Holowaychuk
	 * Copyright(c) 2015 Andreas Lubbe
	 * Copyright(c) 2015 Tiancheng "Timothy" Gu
	 * MIT Licensed
	 */var r=/["'&<>]/;e.exports=function(e){var t,n=""+e,o=r.exec(n);if(!o)return n;var i="",u=0,c=0;for(u=o.index;u<n.length;u++){switch(n.charCodeAt(u)){case 34:t="&quot;";break;case 38:t="&amp;";break;case 39:t="&#39;";break;case 60:t="&lt;";break;case 62:t="&gt;";break;default:continue}c!==u&&(i+=n.substring(c,u)),c=u+1,i+=t}return c!==u?i+n.substring(c,u):i}}])}));

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.propTypes = exports.util = exports.theme = exports.themeGet = exports.complexStyle = exports.responsiveStyle = exports.pseudoStyle = exports.style = exports.borderWidth = exports.buttonStyle = exports.colorStyle = exports.textStyle = exports.disabled = exports.active = exports.focus = exports.hover = exports.left = exports.bottom = exports.right = exports.top = exports.zIndex = exports.position = exports.opacity = exports.backgroundRepeat = exports.backgroundPosition = exports.backgroundSize = exports.backgroundImage = exports.background = exports.boxShadow = exports.borderRadius = exports.borderColor = exports.borders = exports.borderLeft = exports.borderBottom = exports.borderRight = exports.borderTop = exports.border = exports.gridTemplateRows = exports.gridTemplateColumns = exports.gridAutoRows = exports.gridAutoColumns = exports.gridAutoFlow = exports.gridRow = exports.gridColumn = exports.gridRowGap = exports.gridColumnGap = exports.gridGap = exports.order = exports.alignSelf = exports.justifySelf = exports.flexBasis = exports.flex = exports.flexDirection = exports.flexWrap = exports.justifyContent = exports.alignContent = exports.alignItems = exports.verticalAlign = exports.ratio = exports.size = exports.minHeight = exports.maxHeight = exports.height = exports.minWidth = exports.maxWidth = exports.display = exports.letterSpacing = exports.fontWeight = exports.lineHeight = exports.textAlign = exports.fontFamily = exports.color = exports.bgColor = exports.textColor = exports.fontSize = exports.width = exports.space = exports.styles = undefined;
	
	var _styles2 = __webpack_require__(2112);
	
	Object.defineProperty(exports, 'space', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.space;
	  }
	});
	Object.defineProperty(exports, 'width', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.width;
	  }
	});
	Object.defineProperty(exports, 'fontSize', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.fontSize;
	  }
	});
	Object.defineProperty(exports, 'textColor', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.textColor;
	  }
	});
	Object.defineProperty(exports, 'bgColor', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.bgColor;
	  }
	});
	Object.defineProperty(exports, 'color', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.color;
	  }
	});
	Object.defineProperty(exports, 'fontFamily', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.fontFamily;
	  }
	});
	Object.defineProperty(exports, 'textAlign', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.textAlign;
	  }
	});
	Object.defineProperty(exports, 'lineHeight', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.lineHeight;
	  }
	});
	Object.defineProperty(exports, 'fontWeight', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.fontWeight;
	  }
	});
	Object.defineProperty(exports, 'letterSpacing', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.letterSpacing;
	  }
	});
	Object.defineProperty(exports, 'display', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.display;
	  }
	});
	Object.defineProperty(exports, 'maxWidth', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.maxWidth;
	  }
	});
	Object.defineProperty(exports, 'minWidth', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.minWidth;
	  }
	});
	Object.defineProperty(exports, 'height', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.height;
	  }
	});
	Object.defineProperty(exports, 'maxHeight', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.maxHeight;
	  }
	});
	Object.defineProperty(exports, 'minHeight', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.minHeight;
	  }
	});
	Object.defineProperty(exports, 'size', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.size;
	  }
	});
	Object.defineProperty(exports, 'ratio', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.ratio;
	  }
	});
	Object.defineProperty(exports, 'verticalAlign', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.verticalAlign;
	  }
	});
	Object.defineProperty(exports, 'alignItems', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.alignItems;
	  }
	});
	Object.defineProperty(exports, 'alignContent', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.alignContent;
	  }
	});
	Object.defineProperty(exports, 'justifyContent', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.justifyContent;
	  }
	});
	Object.defineProperty(exports, 'flexWrap', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.flexWrap;
	  }
	});
	Object.defineProperty(exports, 'flexDirection', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.flexDirection;
	  }
	});
	Object.defineProperty(exports, 'flex', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.flex;
	  }
	});
	Object.defineProperty(exports, 'flexBasis', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.flexBasis;
	  }
	});
	Object.defineProperty(exports, 'justifySelf', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.justifySelf;
	  }
	});
	Object.defineProperty(exports, 'alignSelf', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.alignSelf;
	  }
	});
	Object.defineProperty(exports, 'order', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.order;
	  }
	});
	Object.defineProperty(exports, 'gridGap', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.gridGap;
	  }
	});
	Object.defineProperty(exports, 'gridColumnGap', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.gridColumnGap;
	  }
	});
	Object.defineProperty(exports, 'gridRowGap', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.gridRowGap;
	  }
	});
	Object.defineProperty(exports, 'gridColumn', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.gridColumn;
	  }
	});
	Object.defineProperty(exports, 'gridRow', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.gridRow;
	  }
	});
	Object.defineProperty(exports, 'gridAutoFlow', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.gridAutoFlow;
	  }
	});
	Object.defineProperty(exports, 'gridAutoColumns', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.gridAutoColumns;
	  }
	});
	Object.defineProperty(exports, 'gridAutoRows', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.gridAutoRows;
	  }
	});
	Object.defineProperty(exports, 'gridTemplateColumns', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.gridTemplateColumns;
	  }
	});
	Object.defineProperty(exports, 'gridTemplateRows', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.gridTemplateRows;
	  }
	});
	Object.defineProperty(exports, 'border', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.border;
	  }
	});
	Object.defineProperty(exports, 'borderTop', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.borderTop;
	  }
	});
	Object.defineProperty(exports, 'borderRight', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.borderRight;
	  }
	});
	Object.defineProperty(exports, 'borderBottom', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.borderBottom;
	  }
	});
	Object.defineProperty(exports, 'borderLeft', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.borderLeft;
	  }
	});
	Object.defineProperty(exports, 'borders', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.borders;
	  }
	});
	Object.defineProperty(exports, 'borderColor', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.borderColor;
	  }
	});
	Object.defineProperty(exports, 'borderRadius', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.borderRadius;
	  }
	});
	Object.defineProperty(exports, 'boxShadow', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.boxShadow;
	  }
	});
	Object.defineProperty(exports, 'background', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.background;
	  }
	});
	Object.defineProperty(exports, 'backgroundImage', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.backgroundImage;
	  }
	});
	Object.defineProperty(exports, 'backgroundSize', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.backgroundSize;
	  }
	});
	Object.defineProperty(exports, 'backgroundPosition', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.backgroundPosition;
	  }
	});
	Object.defineProperty(exports, 'backgroundRepeat', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.backgroundRepeat;
	  }
	});
	Object.defineProperty(exports, 'opacity', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.opacity;
	  }
	});
	Object.defineProperty(exports, 'position', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.position;
	  }
	});
	Object.defineProperty(exports, 'zIndex', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.zIndex;
	  }
	});
	Object.defineProperty(exports, 'top', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.top;
	  }
	});
	Object.defineProperty(exports, 'right', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.right;
	  }
	});
	Object.defineProperty(exports, 'bottom', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.bottom;
	  }
	});
	Object.defineProperty(exports, 'left', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.left;
	  }
	});
	Object.defineProperty(exports, 'hover', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.hover;
	  }
	});
	Object.defineProperty(exports, 'focus', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.focus;
	  }
	});
	Object.defineProperty(exports, 'active', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.active;
	  }
	});
	Object.defineProperty(exports, 'disabled', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.disabled;
	  }
	});
	Object.defineProperty(exports, 'textStyle', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.textStyle;
	  }
	});
	Object.defineProperty(exports, 'colorStyle', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.colorStyle;
	  }
	});
	Object.defineProperty(exports, 'buttonStyle', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.buttonStyle;
	  }
	});
	Object.defineProperty(exports, 'borderWidth', {
	  enumerable: true,
	  get: function get() {
	    return _styles2.borderWidth;
	  }
	});
	
	var _util2 = __webpack_require__(123);
	
	Object.defineProperty(exports, 'style', {
	  enumerable: true,
	  get: function get() {
	    return _util2.style;
	  }
	});
	Object.defineProperty(exports, 'pseudoStyle', {
	  enumerable: true,
	  get: function get() {
	    return _util2.pseudoStyle;
	  }
	});
	Object.defineProperty(exports, 'responsiveStyle', {
	  enumerable: true,
	  get: function get() {
	    return _util2.responsiveStyle;
	  }
	});
	Object.defineProperty(exports, 'complexStyle', {
	  enumerable: true,
	  get: function get() {
	    return _util2.complexStyle;
	  }
	});
	Object.defineProperty(exports, 'themeGet', {
	  enumerable: true,
	  get: function get() {
	    return _util2.themeGet;
	  }
	});
	Object.defineProperty(exports, 'theme', {
	  enumerable: true,
	  get: function get() {
	    return _util2.themeGet;
	  }
	});
	
	var styles = _interopRequireWildcard(_styles2);
	
	var _styles = _interopRequireWildcard(_styles2);
	
	var _util = _interopRequireWildcard(_util2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.styles = _styles;
	exports.util = _util;
	var propTypes = exports.propTypes = {};
	
	Object.keys(styles).forEach(function (key) {
	  propTypes[key] = styles[key].propTypes;
	});
	
	styles.propTypes = propTypes;
	
	exports.default = styles;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _polished = __webpack_require__(8);
	
	// invertTheme.js
	
	var colors = {
	  text: "#fff",
	  violet: "#7673c0",
	  ash: "#363636",
	  blue: "#4698CB",
	  green: "#1CAB42",
	  pink: "#E56DB1",
	  orange: "#DF4A17",
	  yellow: "#ED8B00",
	  lightgrey: "#EBEBEB",
	  dark: {
	    violet: (0, _polished.shade)(0.75, "#7673c0"),
	    blue: (0, _polished.shade)(0.75, "#4698CB"),
	    green: (0, _polished.shade)(0.75, "#1CAB42"),
	    pink: (0, _polished.shade)(0.75, "#E56DB1"),
	    orange: (0, _polished.shade)(0.75, "#DF4A17"),
	    yellow: (0, _polished.shade)(0.75, "#ED8B00")
	  },
	  light: {
	    violet: (0, _polished.tint)(0.75, "#7673c0"),
	    blue: (0, _polished.tint)(0.75, "#4698CB"),
	    green: (0, _polished.tint)(0.75, "#1CAB42"),
	    pink: (0, _polished.tint)(0.75, "#E56DB1"),
	    orange: (0, _polished.tint)(0.75, "#DF4A17"),
	    yellow: (0, _polished.tint)(0.75, "#ED8B00")
	  },
	  grey: ["#fff", (0, _polished.invert)("#EBEBEB"), "#363636"]
	};
	
	var shadows = ["0 1px 2px 0 " + colors.text, "0 1px 4px 0 " + colors.text];
	
	var invertTheme = {
	  colors: colors,
	  shadows: shadows
	};
	
	exports.default = invertTheme;
	module.exports = exports["default"];

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _polished = __webpack_require__(8);
	
	// theme.js
	
	// breakpoint values
	// any array length works with styled-system
	var breakpoints = ["40em", "52em", "64em"];
	
	var colors = {
	  text: "#363636",
	  violet: "#7673c0",
	  ash: "#363636",
	  blue: "#4698CB",
	  green: "#1CAB42",
	  pink: "#E56DB1",
	  orange: "#DF4A17",
	  yellow: "#ED8B00",
	  lightgrey: "#EBEBEB",
	  dark: {
	    violet: (0, _polished.shade)(0.75, "#7673c0"),
	    blue: (0, _polished.shade)(0.75, "#4698CB"),
	    green: (0, _polished.shade)(0.75, "#1CAB42"),
	    pink: (0, _polished.shade)(0.75, "#E56DB1"),
	    orange: (0, _polished.shade)(0.75, "#DF4A17"),
	    yellow: (0, _polished.shade)(0.75, "#ED8B00")
	  },
	  light: {
	    violet: (0, _polished.tint)(0.75, "#7673c0"),
	    blue: (0, _polished.tint)(0.75, "#4698CB"),
	    green: (0, _polished.tint)(0.75, "#1CAB42"),
	    pink: (0, _polished.tint)(0.75, "#E56DB1"),
	    orange: (0, _polished.tint)(0.75, "#DF4A17"),
	    yellow: (0, _polished.tint)(0.75, "#ED8B00")
	  },
	  grey: ["#363636", "#EBEBEB", "#fff"]
	};
	
	// space is used for margin and padding scales
	// it's recommended to use powers of two to ensure alignment
	// when used in nested elements
	// numbers are converted to px
	var space = [0, 4, 8, 16, 24, 32, 48, 64, 96, 128, 256, 512];
	
	var fonts = {
	  sans: "'Noto Sans', system-ui, sans-serif",
	  mono: "monospace"
	};
	
	// typographic scale
	var fontSizes = [11, 14, 16, 20, 24, 30, 44, 64, 96, 128];
	
	// for any scale, either array or objects will work
	var lineHeights = [1, 1.125, 1.25, 1.5];
	
	var fontWeights = {
	  normal: 500,
	  bold: 700
	};
	
	var letterSpacings = {
	  normal: "normal",
	  headings: "-0.025em",
	  caps: "0.075em"
	};
	
	// border-radius
	var radii = [0, 2, 4, 8];
	
	var borders = [0, "1px solid", "2px solid"];
	
	var shadows = ["0 1px 2px 0 " + colors.text, "0 1px 4px 0 " + colors.text];
	
	var theme = {
	  breakpoints: breakpoints,
	  colors: colors,
	  space: space,
	  fonts: fonts,
	  fontSizes: fontSizes,
	  lineHeights: lineHeights,
	  fontWeights: fontWeights,
	  letterSpacings: letterSpacings,
	  radii: radii,
	  borders: borders,
	  shadows: shadows
	};
	
	exports.default = theme;
	module.exports = exports["default"];

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = curry;
	
	
	// eslint-disable-next-line no-unused-vars
	function curried(f, length, acc) {
	  return function fn() {
	    // eslint-disable-next-line prefer-rest-params
	    var combined = acc.concat(Array.prototype.slice.call(arguments));
	    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
	  };
	}
	
	// eslint-disable-next-line no-redeclare
	
	// eslint-disable-next-line no-redeclare
	
	// eslint-disable-next-line no-unused-vars
	
	
	// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
	function curry(f) {
	  // eslint-disable-line no-redeclare
	  return curried(f, f.length, []);
	}
	module.exports = exports["default"];

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Flex = exports.Box = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Box = exports.Box = (0, _components2.default)({}, {
	  boxSizing: 'border-box'
	}, 'width', 'space', 'fontSize', 'color', 'flex', 'order', 'alignSelf');
	
	Box.displayName = 'Box';
	
	var Flex = exports.Flex = (0, _components2.default)({
	  extend: Box
	}, { display: 'flex' }, 'flexWrap', 'flexDirection', 'alignItems', 'justifyContent');
	
	Flex.displayName = 'Flex';

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  > strong,\n  > b {\n    font-weight: ", ";\n  }\n  > a {\n    color: ", ";\n    text-decoration: none;\n    box-shadow: inset 0 -1px 0 ", ";\n    transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n      box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: color, box-shadow;\n    &:hover {\n      color: #fff;\n      box-shadow: inset 0 -1.5em 0 ", ";\n    }\n    &:active {\n      color: #fff;\n      box-shadow: inset 0 -1.5em 0 ", ";\n    }\n  }\n"], ["\n  > strong,\n  > b {\n    font-weight: ", ";\n  }\n  > a {\n    color: ", ";\n    text-decoration: none;\n    box-shadow: inset 0 -1px 0 ", ";\n    transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n      box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: color, box-shadow;\n    &:hover {\n      color: #fff;\n      box-shadow: inset 0 -1.5em 0 ", ";\n    }\n    &:active {\n      color: #fff;\n      box-shadow: inset 0 -1.5em 0 ", ";\n    }\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(8);
	
	var _rebass = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Text = (0, _styledComponents2.default)(_rebass.Text)(_templateObject, function (props) {
	  return props.theme.fontWeights.bold;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet && (0, _polished.shade)(0.75, props.theme.colors.violet);
	});
	
	Text.defaultProps = {
	  is: "p",
	  m: 0,
	  color: "text",
	  fontSize: 2,
	  lineHeight: 3
	};
	
	exports.default = Text;
	module.exports = exports["default"];

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(106)('wks');
	var uid = __webpack_require__(109);
	var Symbol = __webpack_require__(18).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rgb = /*#__PURE__*/__webpack_require__(114);
	
	var _rgb2 = /*#__PURE__*/_interopRequireDefault(_rgb);
	
	var _rgba = /*#__PURE__*/__webpack_require__(63);
	
	var _rgba2 = /*#__PURE__*/_interopRequireDefault(_rgba);
	
	var _hsl = /*#__PURE__*/__webpack_require__(171);
	
	var _hsl2 = /*#__PURE__*/_interopRequireDefault(_hsl);
	
	var _hsla = /*#__PURE__*/__webpack_require__(172);
	
	var _hsla2 = /*#__PURE__*/_interopRequireDefault(_hsla);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isRgb = function isRgb(color) {
	  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
	};
	
	var isRgba = function isRgba(color) {
	  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
	};
	
	var isHsl = function isHsl(color) {
	  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
	};
	
	var isHsla = function isHsla(color) {
	  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
	};
	
	var errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';
	
	/**
	 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
	 * This util is useful in case you only know on runtime which color object is
	 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
	 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
	 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
	 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
	 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
	 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
	 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#ffcd64";
	 *   background: "rgba(255,205,100,0.72)";
	 *   background: "#00f";
	 *   background: "rgba(179,25,25,0.72)";
	 * }
	 */
	
	function toColorString(color) {
	  if (typeof color !== 'object') throw new Error(errMsg);
	  if (isRgba(color)) return (0, _rgba2.default)(color);
	  if (isRgb(color)) return (0, _rgb2.default)(color);
	  if (isHsla(color)) return (0, _hsla2.default)(color);
	  if (isHsl(color)) return (0, _hsl2.default)(color);
	
	  throw new Error(errMsg);
	}
	
	exports.default = toColorString;
	module.exports = exports['default'];

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(28);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _rgbToHsl = /*#__PURE__*/__webpack_require__(1715);
	
	var _rgbToHsl2 = /*#__PURE__*/_interopRequireDefault(_rgbToHsl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns an HslColor or HslaColor object. This utility function is only useful
	 * if want to extract a color component. With the color util `toColorString` you
	 * can convert a HslColor or HslaColor object back to a string.
	 *
	 * @example
	 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
	 * const color1 = 'rgb(255, 0, 0)';
	 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
	 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
	 */
	function parseToHsl(color) {
	  // Note: At a later stage we can optimize this function as right now a hsl
	  // color would be parsed converted to rgb values and converted back to hsl.
	  return (0, _rgbToHsl2.default)((0, _parseToRgb2.default)(color));
	}
	
	exports.default = parseToHsl;
	module.exports = exports['default'];

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.4
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        return name.match('^[^/\\\\]*$') != null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.4';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(199)(module)))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1056);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports = function clone(obj) {
	  return JSON.parse(JSON.stringify(obj));
	};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hslToRgb = /*#__PURE__*/__webpack_require__(116);
	
	var _hslToRgb2 = /*#__PURE__*/_interopRequireDefault(_hslToRgb);
	
	var _nameToHex = /*#__PURE__*/__webpack_require__(1714);
	
	var _nameToHex2 = /*#__PURE__*/_interopRequireDefault(_nameToHex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexRegex = /^#[a-fA-F0-9]{6}$/;
	var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
	var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
	var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
	var hslRegex = /^hsl\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
	var hslaRegex = /^hsla\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
	
	/**
	 * Returns an RgbColor or RgbaColor object. This utility function is only useful
	 * if want to extract a color component. With the color util `toColorString` you
	 * can convert a RgbColor or RgbaColor object back to a string.
	 *
	 * @example
	 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
	 * const color1 = 'rgb(255, 0, 0)';
	 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
	 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
	 */
	function parseToRgb(color) {
	  if (typeof color !== 'string') {
	    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
	  }
	  var normalizedColor = (0, _nameToHex2.default)(color);
	  if (normalizedColor.match(hexRegex)) {
	    return {
	      red: parseInt('' + normalizedColor[1] + normalizedColor[2], 16),
	      green: parseInt('' + normalizedColor[3] + normalizedColor[4], 16),
	      blue: parseInt('' + normalizedColor[5] + normalizedColor[6], 16)
	    };
	  }
	  if (normalizedColor.match(reducedHexRegex)) {
	    return {
	      red: parseInt('' + normalizedColor[1] + normalizedColor[1], 16),
	      green: parseInt('' + normalizedColor[2] + normalizedColor[2], 16),
	      blue: parseInt('' + normalizedColor[3] + normalizedColor[3], 16)
	    };
	  }
	  var rgbMatched = rgbRegex.exec(normalizedColor);
	  if (rgbMatched) {
	    return {
	      red: parseInt('' + rgbMatched[1], 10),
	      green: parseInt('' + rgbMatched[2], 10),
	      blue: parseInt('' + rgbMatched[3], 10)
	    };
	  }
	  var rgbaMatched = rgbaRegex.exec(normalizedColor);
	  if (rgbaMatched) {
	    return {
	      red: parseInt('' + rgbaMatched[1], 10),
	      green: parseInt('' + rgbaMatched[2], 10),
	      blue: parseInt('' + rgbaMatched[3], 10),
	      alpha: parseFloat('' + rgbaMatched[4])
	    };
	  }
	  var hslMatched = hslRegex.exec(normalizedColor);
	  if (hslMatched) {
	    var hue = parseInt('' + hslMatched[1], 10);
	    var saturation = parseInt('' + hslMatched[2], 10) / 100;
	    var lightness = parseInt('' + hslMatched[3], 10) / 100;
	    var rgbColorString = 'rgb(' + (0, _hslToRgb2.default)(hue, saturation, lightness) + ')';
	    var hslRgbMatched = rgbRegex.exec(rgbColorString);
	    if (!hslRgbMatched) {
	      throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + rgbColorString + '.');
	    }
	    return {
	      red: parseInt('' + hslRgbMatched[1], 10),
	      green: parseInt('' + hslRgbMatched[2], 10),
	      blue: parseInt('' + hslRgbMatched[3], 10)
	    };
	  }
	  var hslaMatched = hslaRegex.exec(normalizedColor);
	  if (hslaMatched) {
	    var _hue = parseInt('' + hslaMatched[1], 10);
	    var _saturation = parseInt('' + hslaMatched[2], 10) / 100;
	    var _lightness = parseInt('' + hslaMatched[3], 10) / 100;
	    var _rgbColorString = 'rgb(' + (0, _hslToRgb2.default)(_hue, _saturation, _lightness) + ')';
	    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
	    if (!_hslRgbMatched) {
	      throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + _rgbColorString + '.');
	    }
	    return {
	      red: parseInt('' + _hslRgbMatched[1], 10),
	      green: parseInt('' + _hslRgbMatched[2], 10),
	      blue: parseInt('' + _hslRgbMatched[3], 10),
	      alpha: parseFloat('' + hslaMatched[4])
	    };
	  }
	  throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
	}
	
	exports.default = parseToRgb;
	module.exports = exports['default'];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ZoomOut = exports.ZoomIn = exports.Zap = exports.ZapOff = exports.Youtube = exports.X = exports.XSquare = exports.XCircle = exports.Wind = exports.Wifi = exports.WifiOff = exports.Watch = exports.Volume = exports.VolumeX = exports.Volume2 = exports.Volume1 = exports.Voicemail = exports.Video = exports.VideoOff = exports.Users = exports.User = exports.UserX = exports.UserPlus = exports.UserMinus = exports.UserCheck = exports.Upload = exports.UploadCloud = exports.Unlock = exports.Underline = exports.Umbrella = exports.Type = exports.Twitter = exports.Tv = exports.Truck = exports.Triangle = exports.TrendingUp = exports.TrendingDown = exports.Trello = exports.Trash = exports.Trash2 = exports.ToggleRight = exports.ToggleLeft = exports.ThumbsUp = exports.ThumbsDown = exports.Thermometer = exports.Terminal = exports.Target = exports.Tag = exports.Tablet = exports.Sunset = exports.Sunrise = exports.Sun = exports.StopCircle = exports.Star = exports.Square = exports.Speaker = exports.Smile = exports.Smartphone = exports.Sliders = exports.Slash = exports.Slack = exports.SkipForward = exports.SkipBack = exports.Sidebar = exports.Shuffle = exports.ShoppingCart = exports.ShoppingBag = exports.Shield = exports.ShieldOff = exports.Share = exports.Share2 = exports.Settings = undefined;
	exports.Server = exports.Send = exports.Search = exports.Scissors = exports.Save = exports.Rss = exports.RotateCw = exports.RotateCcw = exports.Rewind = exports.Repeat = exports.RefreshCw = exports.RefreshCcw = exports.Radio = exports.Printer = exports.Power = exports.Pocket = exports.Plus = exports.PlusSquare = exports.PlusCircle = exports.Play = exports.PlayCircle = exports.PieChart = exports.Phone = exports.PhoneOutgoing = exports.PhoneOff = exports.PhoneMissed = exports.PhoneIncoming = exports.PhoneForwarded = exports.PhoneCall = exports.Percent = exports.Pause = exports.PauseCircle = exports.Paperclip = exports.Package = exports.Octagon = exports.Navigation = exports.Navigation2 = exports.Music = exports.Move = exports.MoreVertical = exports.MoreHorizontal = exports.Moon = exports.Monitor = exports.Minus = exports.MinusSquare = exports.MinusCircle = exports.Minimize = exports.Minimize2 = exports.Mic = exports.MicOff = exports.MessageSquare = exports.MessageCircle = exports.Menu = exports.Meh = exports.Maximize = exports.Maximize2 = exports.Map = exports.MapPin = exports.Mail = exports.LogOut = exports.LogIn = exports.Lock = exports.Loader = exports.List = exports.Linkedin = exports.Link = exports.Link2 = exports.LifeBuoy = exports.Layout = exports.Layers = exports.Key = exports.Italic = exports.Instagram = exports.Info = exports.Inbox = exports.Image = exports.Home = exports.HelpCircle = exports.Heart = exports.Headphones = exports.Hash = exports.HardDrive = exports.Grid = exports.Globe = exports.Gitlab = exports.GitHub = exports.GitPullRequest = exports.GitMerge = exports.GitCommit = exports.GitBranch = exports.Gift = exports.Frown = exports.Folder = exports.FolderPlus = exports.FolderMinus = exports.Flag = exports.Filter = exports.Film = exports.File = exports.FileText = undefined;
	exports.FilePlus = exports.FileMinus = exports.Feather = exports.FastForward = exports.Facebook = exports.Eye = exports.EyeOff = exports.ExternalLink = exports.Edit = exports.Edit3 = exports.Edit2 = exports.Droplet = exports.Download = exports.DownloadCloud = exports.DollarSign = exports.Disc = exports.Delete = exports.Database = exports.Crosshair = exports.Crop = exports.CreditCard = exports.Cpu = exports.CornerUpRight = exports.CornerUpLeft = exports.CornerRightUp = exports.CornerRightDown = exports.CornerLeftUp = exports.CornerLeftDown = exports.CornerDownRight = exports.CornerDownLeft = exports.Copy = exports.Compass = exports.Command = exports.Coffee = exports.Codepen = exports.Code = exports.Cloud = exports.CloudSnow = exports.CloudRain = exports.CloudOff = exports.CloudLightning = exports.CloudDrizzle = exports.Clock = exports.Clipboard = exports.Circle = exports.Chrome = exports.ChevronsUp = exports.ChevronsRight = exports.ChevronsLeft = exports.ChevronsDown = exports.ChevronUp = exports.ChevronRight = exports.ChevronLeft = exports.ChevronDown = exports.Check = exports.CheckSquare = exports.CheckCircle = exports.Cast = exports.Camera = exports.CameraOff = exports.Calendar = exports.Briefcase = exports.Box = exports.Bookmark = exports.Book = exports.BookOpen = exports.Bold = exports.Bluetooth = exports.Bell = exports.BellOff = exports.Battery = exports.BatteryCharging = exports.BarChart = exports.BarChart2 = exports.Award = exports.AtSign = exports.ArrowUp = exports.ArrowUpRight = exports.ArrowUpLeft = exports.ArrowUpCircle = exports.ArrowRight = exports.ArrowRightCircle = exports.ArrowLeft = exports.ArrowLeftCircle = exports.ArrowDown = exports.ArrowDownRight = exports.ArrowDownLeft = exports.ArrowDownCircle = exports.Archive = exports.Aperture = exports.Anchor = exports.AlignRight = exports.AlignLeft = exports.AlignJustify = exports.AlignCenter = exports.AlertTriangle = exports.AlertOctagon = exports.AlertCircle = exports.Airplay = exports.Activity = undefined;
	
	var _activity = __webpack_require__(1749);
	
	var _activity2 = _interopRequireDefault(_activity);
	
	var _airplay = __webpack_require__(1750);
	
	var _airplay2 = _interopRequireDefault(_airplay);
	
	var _alertCircle = __webpack_require__(1751);
	
	var _alertCircle2 = _interopRequireDefault(_alertCircle);
	
	var _alertOctagon = __webpack_require__(1752);
	
	var _alertOctagon2 = _interopRequireDefault(_alertOctagon);
	
	var _alertTriangle = __webpack_require__(1753);
	
	var _alertTriangle2 = _interopRequireDefault(_alertTriangle);
	
	var _alignCenter = __webpack_require__(1754);
	
	var _alignCenter2 = _interopRequireDefault(_alignCenter);
	
	var _alignJustify = __webpack_require__(1755);
	
	var _alignJustify2 = _interopRequireDefault(_alignJustify);
	
	var _alignLeft = __webpack_require__(1756);
	
	var _alignLeft2 = _interopRequireDefault(_alignLeft);
	
	var _alignRight = __webpack_require__(1757);
	
	var _alignRight2 = _interopRequireDefault(_alignRight);
	
	var _anchor = __webpack_require__(1758);
	
	var _anchor2 = _interopRequireDefault(_anchor);
	
	var _aperture = __webpack_require__(1759);
	
	var _aperture2 = _interopRequireDefault(_aperture);
	
	var _archive = __webpack_require__(1760);
	
	var _archive2 = _interopRequireDefault(_archive);
	
	var _arrowDownCircle = __webpack_require__(1761);
	
	var _arrowDownCircle2 = _interopRequireDefault(_arrowDownCircle);
	
	var _arrowDownLeft = __webpack_require__(1762);
	
	var _arrowDownLeft2 = _interopRequireDefault(_arrowDownLeft);
	
	var _arrowDownRight = __webpack_require__(1763);
	
	var _arrowDownRight2 = _interopRequireDefault(_arrowDownRight);
	
	var _arrowDown = __webpack_require__(1764);
	
	var _arrowDown2 = _interopRequireDefault(_arrowDown);
	
	var _arrowLeftCircle = __webpack_require__(1765);
	
	var _arrowLeftCircle2 = _interopRequireDefault(_arrowLeftCircle);
	
	var _arrowLeft = __webpack_require__(1766);
	
	var _arrowLeft2 = _interopRequireDefault(_arrowLeft);
	
	var _arrowRightCircle = __webpack_require__(1767);
	
	var _arrowRightCircle2 = _interopRequireDefault(_arrowRightCircle);
	
	var _arrowRight = __webpack_require__(1768);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	var _arrowUpCircle = __webpack_require__(1769);
	
	var _arrowUpCircle2 = _interopRequireDefault(_arrowUpCircle);
	
	var _arrowUpLeft = __webpack_require__(1770);
	
	var _arrowUpLeft2 = _interopRequireDefault(_arrowUpLeft);
	
	var _arrowUpRight = __webpack_require__(1771);
	
	var _arrowUpRight2 = _interopRequireDefault(_arrowUpRight);
	
	var _arrowUp = __webpack_require__(1772);
	
	var _arrowUp2 = _interopRequireDefault(_arrowUp);
	
	var _atSign = __webpack_require__(1773);
	
	var _atSign2 = _interopRequireDefault(_atSign);
	
	var _award = __webpack_require__(1774);
	
	var _award2 = _interopRequireDefault(_award);
	
	var _barChart = __webpack_require__(1775);
	
	var _barChart2 = _interopRequireDefault(_barChart);
	
	var _barChart3 = __webpack_require__(1776);
	
	var _barChart4 = _interopRequireDefault(_barChart3);
	
	var _batteryCharging = __webpack_require__(1777);
	
	var _batteryCharging2 = _interopRequireDefault(_batteryCharging);
	
	var _battery = __webpack_require__(1778);
	
	var _battery2 = _interopRequireDefault(_battery);
	
	var _bellOff = __webpack_require__(1779);
	
	var _bellOff2 = _interopRequireDefault(_bellOff);
	
	var _bell = __webpack_require__(1780);
	
	var _bell2 = _interopRequireDefault(_bell);
	
	var _bluetooth = __webpack_require__(1781);
	
	var _bluetooth2 = _interopRequireDefault(_bluetooth);
	
	var _bold = __webpack_require__(1782);
	
	var _bold2 = _interopRequireDefault(_bold);
	
	var _bookOpen = __webpack_require__(1783);
	
	var _bookOpen2 = _interopRequireDefault(_bookOpen);
	
	var _book = __webpack_require__(1784);
	
	var _book2 = _interopRequireDefault(_book);
	
	var _bookmark = __webpack_require__(1785);
	
	var _bookmark2 = _interopRequireDefault(_bookmark);
	
	var _box = __webpack_require__(1786);
	
	var _box2 = _interopRequireDefault(_box);
	
	var _briefcase = __webpack_require__(1787);
	
	var _briefcase2 = _interopRequireDefault(_briefcase);
	
	var _calendar = __webpack_require__(1788);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _cameraOff = __webpack_require__(1789);
	
	var _cameraOff2 = _interopRequireDefault(_cameraOff);
	
	var _camera = __webpack_require__(1790);
	
	var _camera2 = _interopRequireDefault(_camera);
	
	var _cast = __webpack_require__(1791);
	
	var _cast2 = _interopRequireDefault(_cast);
	
	var _checkCircle = __webpack_require__(1792);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _checkSquare = __webpack_require__(1793);
	
	var _checkSquare2 = _interopRequireDefault(_checkSquare);
	
	var _check = __webpack_require__(1794);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _chevronDown = __webpack_require__(1795);
	
	var _chevronDown2 = _interopRequireDefault(_chevronDown);
	
	var _chevronLeft = __webpack_require__(1796);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(1797);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _chevronUp = __webpack_require__(1798);
	
	var _chevronUp2 = _interopRequireDefault(_chevronUp);
	
	var _chevronsDown = __webpack_require__(1799);
	
	var _chevronsDown2 = _interopRequireDefault(_chevronsDown);
	
	var _chevronsLeft = __webpack_require__(1800);
	
	var _chevronsLeft2 = _interopRequireDefault(_chevronsLeft);
	
	var _chevronsRight = __webpack_require__(1801);
	
	var _chevronsRight2 = _interopRequireDefault(_chevronsRight);
	
	var _chevronsUp = __webpack_require__(1802);
	
	var _chevronsUp2 = _interopRequireDefault(_chevronsUp);
	
	var _chrome = __webpack_require__(1803);
	
	var _chrome2 = _interopRequireDefault(_chrome);
	
	var _circle = __webpack_require__(1804);
	
	var _circle2 = _interopRequireDefault(_circle);
	
	var _clipboard = __webpack_require__(1805);
	
	var _clipboard2 = _interopRequireDefault(_clipboard);
	
	var _clock = __webpack_require__(1806);
	
	var _clock2 = _interopRequireDefault(_clock);
	
	var _cloudDrizzle = __webpack_require__(1807);
	
	var _cloudDrizzle2 = _interopRequireDefault(_cloudDrizzle);
	
	var _cloudLightning = __webpack_require__(1808);
	
	var _cloudLightning2 = _interopRequireDefault(_cloudLightning);
	
	var _cloudOff = __webpack_require__(1809);
	
	var _cloudOff2 = _interopRequireDefault(_cloudOff);
	
	var _cloudRain = __webpack_require__(1810);
	
	var _cloudRain2 = _interopRequireDefault(_cloudRain);
	
	var _cloudSnow = __webpack_require__(1811);
	
	var _cloudSnow2 = _interopRequireDefault(_cloudSnow);
	
	var _cloud = __webpack_require__(1812);
	
	var _cloud2 = _interopRequireDefault(_cloud);
	
	var _code = __webpack_require__(1813);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _codepen = __webpack_require__(1814);
	
	var _codepen2 = _interopRequireDefault(_codepen);
	
	var _coffee = __webpack_require__(1815);
	
	var _coffee2 = _interopRequireDefault(_coffee);
	
	var _command = __webpack_require__(1816);
	
	var _command2 = _interopRequireDefault(_command);
	
	var _compass = __webpack_require__(1817);
	
	var _compass2 = _interopRequireDefault(_compass);
	
	var _copy = __webpack_require__(1818);
	
	var _copy2 = _interopRequireDefault(_copy);
	
	var _cornerDownLeft = __webpack_require__(1819);
	
	var _cornerDownLeft2 = _interopRequireDefault(_cornerDownLeft);
	
	var _cornerDownRight = __webpack_require__(1820);
	
	var _cornerDownRight2 = _interopRequireDefault(_cornerDownRight);
	
	var _cornerLeftDown = __webpack_require__(1821);
	
	var _cornerLeftDown2 = _interopRequireDefault(_cornerLeftDown);
	
	var _cornerLeftUp = __webpack_require__(1822);
	
	var _cornerLeftUp2 = _interopRequireDefault(_cornerLeftUp);
	
	var _cornerRightDown = __webpack_require__(1823);
	
	var _cornerRightDown2 = _interopRequireDefault(_cornerRightDown);
	
	var _cornerRightUp = __webpack_require__(1824);
	
	var _cornerRightUp2 = _interopRequireDefault(_cornerRightUp);
	
	var _cornerUpLeft = __webpack_require__(1825);
	
	var _cornerUpLeft2 = _interopRequireDefault(_cornerUpLeft);
	
	var _cornerUpRight = __webpack_require__(1826);
	
	var _cornerUpRight2 = _interopRequireDefault(_cornerUpRight);
	
	var _cpu = __webpack_require__(1827);
	
	var _cpu2 = _interopRequireDefault(_cpu);
	
	var _creditCard = __webpack_require__(1828);
	
	var _creditCard2 = _interopRequireDefault(_creditCard);
	
	var _crop = __webpack_require__(1829);
	
	var _crop2 = _interopRequireDefault(_crop);
	
	var _crosshair = __webpack_require__(1830);
	
	var _crosshair2 = _interopRequireDefault(_crosshair);
	
	var _database = __webpack_require__(1831);
	
	var _database2 = _interopRequireDefault(_database);
	
	var _delete = __webpack_require__(1832);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _disc = __webpack_require__(1833);
	
	var _disc2 = _interopRequireDefault(_disc);
	
	var _dollarSign = __webpack_require__(1834);
	
	var _dollarSign2 = _interopRequireDefault(_dollarSign);
	
	var _downloadCloud = __webpack_require__(1835);
	
	var _downloadCloud2 = _interopRequireDefault(_downloadCloud);
	
	var _download = __webpack_require__(1836);
	
	var _download2 = _interopRequireDefault(_download);
	
	var _droplet = __webpack_require__(1837);
	
	var _droplet2 = _interopRequireDefault(_droplet);
	
	var _edit = __webpack_require__(1838);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _edit3 = __webpack_require__(1839);
	
	var _edit4 = _interopRequireDefault(_edit3);
	
	var _edit5 = __webpack_require__(1840);
	
	var _edit6 = _interopRequireDefault(_edit5);
	
	var _externalLink = __webpack_require__(1841);
	
	var _externalLink2 = _interopRequireDefault(_externalLink);
	
	var _eyeOff = __webpack_require__(1842);
	
	var _eyeOff2 = _interopRequireDefault(_eyeOff);
	
	var _eye = __webpack_require__(1843);
	
	var _eye2 = _interopRequireDefault(_eye);
	
	var _facebook = __webpack_require__(1844);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _fastForward = __webpack_require__(1845);
	
	var _fastForward2 = _interopRequireDefault(_fastForward);
	
	var _feather = __webpack_require__(1846);
	
	var _feather2 = _interopRequireDefault(_feather);
	
	var _fileMinus = __webpack_require__(1847);
	
	var _fileMinus2 = _interopRequireDefault(_fileMinus);
	
	var _filePlus = __webpack_require__(1848);
	
	var _filePlus2 = _interopRequireDefault(_filePlus);
	
	var _fileText = __webpack_require__(1849);
	
	var _fileText2 = _interopRequireDefault(_fileText);
	
	var _file = __webpack_require__(1850);
	
	var _file2 = _interopRequireDefault(_file);
	
	var _film = __webpack_require__(1851);
	
	var _film2 = _interopRequireDefault(_film);
	
	var _filter = __webpack_require__(1852);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _flag = __webpack_require__(1853);
	
	var _flag2 = _interopRequireDefault(_flag);
	
	var _folderMinus = __webpack_require__(1854);
	
	var _folderMinus2 = _interopRequireDefault(_folderMinus);
	
	var _folderPlus = __webpack_require__(1855);
	
	var _folderPlus2 = _interopRequireDefault(_folderPlus);
	
	var _folder = __webpack_require__(1856);
	
	var _folder2 = _interopRequireDefault(_folder);
	
	var _frown = __webpack_require__(1857);
	
	var _frown2 = _interopRequireDefault(_frown);
	
	var _gift = __webpack_require__(1858);
	
	var _gift2 = _interopRequireDefault(_gift);
	
	var _gitBranch = __webpack_require__(1859);
	
	var _gitBranch2 = _interopRequireDefault(_gitBranch);
	
	var _gitCommit = __webpack_require__(1860);
	
	var _gitCommit2 = _interopRequireDefault(_gitCommit);
	
	var _gitMerge = __webpack_require__(1861);
	
	var _gitMerge2 = _interopRequireDefault(_gitMerge);
	
	var _gitPullRequest = __webpack_require__(1862);
	
	var _gitPullRequest2 = _interopRequireDefault(_gitPullRequest);
	
	var _github = __webpack_require__(1863);
	
	var _github2 = _interopRequireDefault(_github);
	
	var _gitlab = __webpack_require__(1864);
	
	var _gitlab2 = _interopRequireDefault(_gitlab);
	
	var _globe = __webpack_require__(1865);
	
	var _globe2 = _interopRequireDefault(_globe);
	
	var _grid = __webpack_require__(1866);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _hardDrive = __webpack_require__(1867);
	
	var _hardDrive2 = _interopRequireDefault(_hardDrive);
	
	var _hash = __webpack_require__(1868);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _headphones = __webpack_require__(1869);
	
	var _headphones2 = _interopRequireDefault(_headphones);
	
	var _heart = __webpack_require__(1870);
	
	var _heart2 = _interopRequireDefault(_heart);
	
	var _helpCircle = __webpack_require__(1871);
	
	var _helpCircle2 = _interopRequireDefault(_helpCircle);
	
	var _home = __webpack_require__(1872);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _image = __webpack_require__(1873);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _inbox = __webpack_require__(1874);
	
	var _inbox2 = _interopRequireDefault(_inbox);
	
	var _info = __webpack_require__(1875);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _instagram = __webpack_require__(1876);
	
	var _instagram2 = _interopRequireDefault(_instagram);
	
	var _italic = __webpack_require__(1877);
	
	var _italic2 = _interopRequireDefault(_italic);
	
	var _key = __webpack_require__(1878);
	
	var _key2 = _interopRequireDefault(_key);
	
	var _layers = __webpack_require__(1879);
	
	var _layers2 = _interopRequireDefault(_layers);
	
	var _layout = __webpack_require__(1880);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _lifeBuoy = __webpack_require__(1881);
	
	var _lifeBuoy2 = _interopRequireDefault(_lifeBuoy);
	
	var _link = __webpack_require__(1882);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _link3 = __webpack_require__(1883);
	
	var _link4 = _interopRequireDefault(_link3);
	
	var _linkedin = __webpack_require__(1884);
	
	var _linkedin2 = _interopRequireDefault(_linkedin);
	
	var _list = __webpack_require__(1885);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _loader = __webpack_require__(1886);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _lock = __webpack_require__(1887);
	
	var _lock2 = _interopRequireDefault(_lock);
	
	var _logIn = __webpack_require__(1888);
	
	var _logIn2 = _interopRequireDefault(_logIn);
	
	var _logOut = __webpack_require__(1889);
	
	var _logOut2 = _interopRequireDefault(_logOut);
	
	var _mail = __webpack_require__(1890);
	
	var _mail2 = _interopRequireDefault(_mail);
	
	var _mapPin = __webpack_require__(1891);
	
	var _mapPin2 = _interopRequireDefault(_mapPin);
	
	var _map = __webpack_require__(1892);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _maximize = __webpack_require__(1893);
	
	var _maximize2 = _interopRequireDefault(_maximize);
	
	var _maximize3 = __webpack_require__(1894);
	
	var _maximize4 = _interopRequireDefault(_maximize3);
	
	var _meh = __webpack_require__(1895);
	
	var _meh2 = _interopRequireDefault(_meh);
	
	var _menu = __webpack_require__(1896);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _messageCircle = __webpack_require__(1897);
	
	var _messageCircle2 = _interopRequireDefault(_messageCircle);
	
	var _messageSquare = __webpack_require__(1898);
	
	var _messageSquare2 = _interopRequireDefault(_messageSquare);
	
	var _micOff = __webpack_require__(1899);
	
	var _micOff2 = _interopRequireDefault(_micOff);
	
	var _mic = __webpack_require__(1900);
	
	var _mic2 = _interopRequireDefault(_mic);
	
	var _minimize = __webpack_require__(1901);
	
	var _minimize2 = _interopRequireDefault(_minimize);
	
	var _minimize3 = __webpack_require__(1902);
	
	var _minimize4 = _interopRequireDefault(_minimize3);
	
	var _minusCircle = __webpack_require__(1903);
	
	var _minusCircle2 = _interopRequireDefault(_minusCircle);
	
	var _minusSquare = __webpack_require__(1904);
	
	var _minusSquare2 = _interopRequireDefault(_minusSquare);
	
	var _minus = __webpack_require__(1905);
	
	var _minus2 = _interopRequireDefault(_minus);
	
	var _monitor = __webpack_require__(1906);
	
	var _monitor2 = _interopRequireDefault(_monitor);
	
	var _moon = __webpack_require__(1907);
	
	var _moon2 = _interopRequireDefault(_moon);
	
	var _moreHorizontal = __webpack_require__(1908);
	
	var _moreHorizontal2 = _interopRequireDefault(_moreHorizontal);
	
	var _moreVertical = __webpack_require__(1909);
	
	var _moreVertical2 = _interopRequireDefault(_moreVertical);
	
	var _move = __webpack_require__(1910);
	
	var _move2 = _interopRequireDefault(_move);
	
	var _music = __webpack_require__(1911);
	
	var _music2 = _interopRequireDefault(_music);
	
	var _navigation = __webpack_require__(1912);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _navigation3 = __webpack_require__(1913);
	
	var _navigation4 = _interopRequireDefault(_navigation3);
	
	var _octagon = __webpack_require__(1914);
	
	var _octagon2 = _interopRequireDefault(_octagon);
	
	var _package = __webpack_require__(1915);
	
	var _package2 = _interopRequireDefault(_package);
	
	var _paperclip = __webpack_require__(1916);
	
	var _paperclip2 = _interopRequireDefault(_paperclip);
	
	var _pauseCircle = __webpack_require__(1917);
	
	var _pauseCircle2 = _interopRequireDefault(_pauseCircle);
	
	var _pause = __webpack_require__(1918);
	
	var _pause2 = _interopRequireDefault(_pause);
	
	var _percent = __webpack_require__(1919);
	
	var _percent2 = _interopRequireDefault(_percent);
	
	var _phoneCall = __webpack_require__(1920);
	
	var _phoneCall2 = _interopRequireDefault(_phoneCall);
	
	var _phoneForwarded = __webpack_require__(1921);
	
	var _phoneForwarded2 = _interopRequireDefault(_phoneForwarded);
	
	var _phoneIncoming = __webpack_require__(1922);
	
	var _phoneIncoming2 = _interopRequireDefault(_phoneIncoming);
	
	var _phoneMissed = __webpack_require__(1923);
	
	var _phoneMissed2 = _interopRequireDefault(_phoneMissed);
	
	var _phoneOff = __webpack_require__(1924);
	
	var _phoneOff2 = _interopRequireDefault(_phoneOff);
	
	var _phoneOutgoing = __webpack_require__(1925);
	
	var _phoneOutgoing2 = _interopRequireDefault(_phoneOutgoing);
	
	var _phone = __webpack_require__(1926);
	
	var _phone2 = _interopRequireDefault(_phone);
	
	var _pieChart = __webpack_require__(1927);
	
	var _pieChart2 = _interopRequireDefault(_pieChart);
	
	var _playCircle = __webpack_require__(1928);
	
	var _playCircle2 = _interopRequireDefault(_playCircle);
	
	var _play = __webpack_require__(1929);
	
	var _play2 = _interopRequireDefault(_play);
	
	var _plusCircle = __webpack_require__(1930);
	
	var _plusCircle2 = _interopRequireDefault(_plusCircle);
	
	var _plusSquare = __webpack_require__(1931);
	
	var _plusSquare2 = _interopRequireDefault(_plusSquare);
	
	var _plus = __webpack_require__(1932);
	
	var _plus2 = _interopRequireDefault(_plus);
	
	var _pocket = __webpack_require__(1933);
	
	var _pocket2 = _interopRequireDefault(_pocket);
	
	var _power = __webpack_require__(1934);
	
	var _power2 = _interopRequireDefault(_power);
	
	var _printer = __webpack_require__(1935);
	
	var _printer2 = _interopRequireDefault(_printer);
	
	var _radio = __webpack_require__(1936);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _refreshCcw = __webpack_require__(1937);
	
	var _refreshCcw2 = _interopRequireDefault(_refreshCcw);
	
	var _refreshCw = __webpack_require__(1938);
	
	var _refreshCw2 = _interopRequireDefault(_refreshCw);
	
	var _repeat = __webpack_require__(1939);
	
	var _repeat2 = _interopRequireDefault(_repeat);
	
	var _rewind = __webpack_require__(1940);
	
	var _rewind2 = _interopRequireDefault(_rewind);
	
	var _rotateCcw = __webpack_require__(1941);
	
	var _rotateCcw2 = _interopRequireDefault(_rotateCcw);
	
	var _rotateCw = __webpack_require__(1942);
	
	var _rotateCw2 = _interopRequireDefault(_rotateCw);
	
	var _rss = __webpack_require__(1943);
	
	var _rss2 = _interopRequireDefault(_rss);
	
	var _save = __webpack_require__(1944);
	
	var _save2 = _interopRequireDefault(_save);
	
	var _scissors = __webpack_require__(1945);
	
	var _scissors2 = _interopRequireDefault(_scissors);
	
	var _search = __webpack_require__(1946);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _send = __webpack_require__(1947);
	
	var _send2 = _interopRequireDefault(_send);
	
	var _server = __webpack_require__(1948);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _settings = __webpack_require__(1949);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _share = __webpack_require__(1950);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _share3 = __webpack_require__(1951);
	
	var _share4 = _interopRequireDefault(_share3);
	
	var _shieldOff = __webpack_require__(1952);
	
	var _shieldOff2 = _interopRequireDefault(_shieldOff);
	
	var _shield = __webpack_require__(1953);
	
	var _shield2 = _interopRequireDefault(_shield);
	
	var _shoppingBag = __webpack_require__(1954);
	
	var _shoppingBag2 = _interopRequireDefault(_shoppingBag);
	
	var _shoppingCart = __webpack_require__(1955);
	
	var _shoppingCart2 = _interopRequireDefault(_shoppingCart);
	
	var _shuffle = __webpack_require__(1956);
	
	var _shuffle2 = _interopRequireDefault(_shuffle);
	
	var _sidebar = __webpack_require__(1957);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _skipBack = __webpack_require__(1958);
	
	var _skipBack2 = _interopRequireDefault(_skipBack);
	
	var _skipForward = __webpack_require__(1959);
	
	var _skipForward2 = _interopRequireDefault(_skipForward);
	
	var _slack = __webpack_require__(1960);
	
	var _slack2 = _interopRequireDefault(_slack);
	
	var _slash = __webpack_require__(1961);
	
	var _slash2 = _interopRequireDefault(_slash);
	
	var _sliders = __webpack_require__(1962);
	
	var _sliders2 = _interopRequireDefault(_sliders);
	
	var _smartphone = __webpack_require__(1963);
	
	var _smartphone2 = _interopRequireDefault(_smartphone);
	
	var _smile = __webpack_require__(1964);
	
	var _smile2 = _interopRequireDefault(_smile);
	
	var _speaker = __webpack_require__(1965);
	
	var _speaker2 = _interopRequireDefault(_speaker);
	
	var _square = __webpack_require__(1966);
	
	var _square2 = _interopRequireDefault(_square);
	
	var _star = __webpack_require__(1967);
	
	var _star2 = _interopRequireDefault(_star);
	
	var _stopCircle = __webpack_require__(1968);
	
	var _stopCircle2 = _interopRequireDefault(_stopCircle);
	
	var _sun = __webpack_require__(1969);
	
	var _sun2 = _interopRequireDefault(_sun);
	
	var _sunrise = __webpack_require__(1970);
	
	var _sunrise2 = _interopRequireDefault(_sunrise);
	
	var _sunset = __webpack_require__(1971);
	
	var _sunset2 = _interopRequireDefault(_sunset);
	
	var _tablet = __webpack_require__(1972);
	
	var _tablet2 = _interopRequireDefault(_tablet);
	
	var _tag = __webpack_require__(1973);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _target = __webpack_require__(1974);
	
	var _target2 = _interopRequireDefault(_target);
	
	var _terminal = __webpack_require__(1975);
	
	var _terminal2 = _interopRequireDefault(_terminal);
	
	var _thermometer = __webpack_require__(1976);
	
	var _thermometer2 = _interopRequireDefault(_thermometer);
	
	var _thumbsDown = __webpack_require__(1977);
	
	var _thumbsDown2 = _interopRequireDefault(_thumbsDown);
	
	var _thumbsUp = __webpack_require__(1978);
	
	var _thumbsUp2 = _interopRequireDefault(_thumbsUp);
	
	var _toggleLeft = __webpack_require__(1979);
	
	var _toggleLeft2 = _interopRequireDefault(_toggleLeft);
	
	var _toggleRight = __webpack_require__(1980);
	
	var _toggleRight2 = _interopRequireDefault(_toggleRight);
	
	var _trash = __webpack_require__(1981);
	
	var _trash2 = _interopRequireDefault(_trash);
	
	var _trash3 = __webpack_require__(1982);
	
	var _trash4 = _interopRequireDefault(_trash3);
	
	var _trello = __webpack_require__(1983);
	
	var _trello2 = _interopRequireDefault(_trello);
	
	var _trendingDown = __webpack_require__(1984);
	
	var _trendingDown2 = _interopRequireDefault(_trendingDown);
	
	var _trendingUp = __webpack_require__(1985);
	
	var _trendingUp2 = _interopRequireDefault(_trendingUp);
	
	var _triangle = __webpack_require__(1986);
	
	var _triangle2 = _interopRequireDefault(_triangle);
	
	var _truck = __webpack_require__(1987);
	
	var _truck2 = _interopRequireDefault(_truck);
	
	var _tv = __webpack_require__(1988);
	
	var _tv2 = _interopRequireDefault(_tv);
	
	var _twitter = __webpack_require__(1989);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _type = __webpack_require__(1990);
	
	var _type2 = _interopRequireDefault(_type);
	
	var _umbrella = __webpack_require__(1991);
	
	var _umbrella2 = _interopRequireDefault(_umbrella);
	
	var _underline = __webpack_require__(1992);
	
	var _underline2 = _interopRequireDefault(_underline);
	
	var _unlock = __webpack_require__(1993);
	
	var _unlock2 = _interopRequireDefault(_unlock);
	
	var _uploadCloud = __webpack_require__(1994);
	
	var _uploadCloud2 = _interopRequireDefault(_uploadCloud);
	
	var _upload = __webpack_require__(1995);
	
	var _upload2 = _interopRequireDefault(_upload);
	
	var _userCheck = __webpack_require__(1996);
	
	var _userCheck2 = _interopRequireDefault(_userCheck);
	
	var _userMinus = __webpack_require__(1997);
	
	var _userMinus2 = _interopRequireDefault(_userMinus);
	
	var _userPlus = __webpack_require__(1998);
	
	var _userPlus2 = _interopRequireDefault(_userPlus);
	
	var _userX = __webpack_require__(1999);
	
	var _userX2 = _interopRequireDefault(_userX);
	
	var _user = __webpack_require__(2000);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _users = __webpack_require__(2001);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _videoOff = __webpack_require__(2002);
	
	var _videoOff2 = _interopRequireDefault(_videoOff);
	
	var _video = __webpack_require__(2003);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _voicemail = __webpack_require__(2004);
	
	var _voicemail2 = _interopRequireDefault(_voicemail);
	
	var _volume = __webpack_require__(2005);
	
	var _volume2 = _interopRequireDefault(_volume);
	
	var _volume3 = __webpack_require__(2006);
	
	var _volume4 = _interopRequireDefault(_volume3);
	
	var _volumeX = __webpack_require__(2007);
	
	var _volumeX2 = _interopRequireDefault(_volumeX);
	
	var _volume5 = __webpack_require__(2008);
	
	var _volume6 = _interopRequireDefault(_volume5);
	
	var _watch = __webpack_require__(2009);
	
	var _watch2 = _interopRequireDefault(_watch);
	
	var _wifiOff = __webpack_require__(2010);
	
	var _wifiOff2 = _interopRequireDefault(_wifiOff);
	
	var _wifi = __webpack_require__(2011);
	
	var _wifi2 = _interopRequireDefault(_wifi);
	
	var _wind = __webpack_require__(2012);
	
	var _wind2 = _interopRequireDefault(_wind);
	
	var _xCircle = __webpack_require__(2013);
	
	var _xCircle2 = _interopRequireDefault(_xCircle);
	
	var _xSquare = __webpack_require__(2014);
	
	var _xSquare2 = _interopRequireDefault(_xSquare);
	
	var _x = __webpack_require__(2015);
	
	var _x2 = _interopRequireDefault(_x);
	
	var _youtube = __webpack_require__(2016);
	
	var _youtube2 = _interopRequireDefault(_youtube);
	
	var _zapOff = __webpack_require__(2017);
	
	var _zapOff2 = _interopRequireDefault(_zapOff);
	
	var _zap = __webpack_require__(2018);
	
	var _zap2 = _interopRequireDefault(_zap);
	
	var _zoomIn = __webpack_require__(2019);
	
	var _zoomIn2 = _interopRequireDefault(_zoomIn);
	
	var _zoomOut = __webpack_require__(2020);
	
	var _zoomOut2 = _interopRequireDefault(_zoomOut);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Activity = _activity2.default;
	exports.Airplay = _airplay2.default;
	exports.AlertCircle = _alertCircle2.default;
	exports.AlertOctagon = _alertOctagon2.default;
	exports.AlertTriangle = _alertTriangle2.default;
	exports.AlignCenter = _alignCenter2.default;
	exports.AlignJustify = _alignJustify2.default;
	exports.AlignLeft = _alignLeft2.default;
	exports.AlignRight = _alignRight2.default;
	exports.Anchor = _anchor2.default;
	exports.Aperture = _aperture2.default;
	exports.Archive = _archive2.default;
	exports.ArrowDownCircle = _arrowDownCircle2.default;
	exports.ArrowDownLeft = _arrowDownLeft2.default;
	exports.ArrowDownRight = _arrowDownRight2.default;
	exports.ArrowDown = _arrowDown2.default;
	exports.ArrowLeftCircle = _arrowLeftCircle2.default;
	exports.ArrowLeft = _arrowLeft2.default;
	exports.ArrowRightCircle = _arrowRightCircle2.default;
	exports.ArrowRight = _arrowRight2.default;
	exports.ArrowUpCircle = _arrowUpCircle2.default;
	exports.ArrowUpLeft = _arrowUpLeft2.default;
	exports.ArrowUpRight = _arrowUpRight2.default;
	exports.ArrowUp = _arrowUp2.default;
	exports.AtSign = _atSign2.default;
	exports.Award = _award2.default;
	exports.BarChart2 = _barChart2.default;
	exports.BarChart = _barChart4.default;
	exports.BatteryCharging = _batteryCharging2.default;
	exports.Battery = _battery2.default;
	exports.BellOff = _bellOff2.default;
	exports.Bell = _bell2.default;
	exports.Bluetooth = _bluetooth2.default;
	exports.Bold = _bold2.default;
	exports.BookOpen = _bookOpen2.default;
	exports.Book = _book2.default;
	exports.Bookmark = _bookmark2.default;
	exports.Box = _box2.default;
	exports.Briefcase = _briefcase2.default;
	exports.Calendar = _calendar2.default;
	exports.CameraOff = _cameraOff2.default;
	exports.Camera = _camera2.default;
	exports.Cast = _cast2.default;
	exports.CheckCircle = _checkCircle2.default;
	exports.CheckSquare = _checkSquare2.default;
	exports.Check = _check2.default;
	exports.ChevronDown = _chevronDown2.default;
	exports.ChevronLeft = _chevronLeft2.default;
	exports.ChevronRight = _chevronRight2.default;
	exports.ChevronUp = _chevronUp2.default;
	exports.ChevronsDown = _chevronsDown2.default;
	exports.ChevronsLeft = _chevronsLeft2.default;
	exports.ChevronsRight = _chevronsRight2.default;
	exports.ChevronsUp = _chevronsUp2.default;
	exports.Chrome = _chrome2.default;
	exports.Circle = _circle2.default;
	exports.Clipboard = _clipboard2.default;
	exports.Clock = _clock2.default;
	exports.CloudDrizzle = _cloudDrizzle2.default;
	exports.CloudLightning = _cloudLightning2.default;
	exports.CloudOff = _cloudOff2.default;
	exports.CloudRain = _cloudRain2.default;
	exports.CloudSnow = _cloudSnow2.default;
	exports.Cloud = _cloud2.default;
	exports.Code = _code2.default;
	exports.Codepen = _codepen2.default;
	exports.Coffee = _coffee2.default;
	exports.Command = _command2.default;
	exports.Compass = _compass2.default;
	exports.Copy = _copy2.default;
	exports.CornerDownLeft = _cornerDownLeft2.default;
	exports.CornerDownRight = _cornerDownRight2.default;
	exports.CornerLeftDown = _cornerLeftDown2.default;
	exports.CornerLeftUp = _cornerLeftUp2.default;
	exports.CornerRightDown = _cornerRightDown2.default;
	exports.CornerRightUp = _cornerRightUp2.default;
	exports.CornerUpLeft = _cornerUpLeft2.default;
	exports.CornerUpRight = _cornerUpRight2.default;
	exports.Cpu = _cpu2.default;
	exports.CreditCard = _creditCard2.default;
	exports.Crop = _crop2.default;
	exports.Crosshair = _crosshair2.default;
	exports.Database = _database2.default;
	exports.Delete = _delete2.default;
	exports.Disc = _disc2.default;
	exports.DollarSign = _dollarSign2.default;
	exports.DownloadCloud = _downloadCloud2.default;
	exports.Download = _download2.default;
	exports.Droplet = _droplet2.default;
	exports.Edit2 = _edit2.default;
	exports.Edit3 = _edit4.default;
	exports.Edit = _edit6.default;
	exports.ExternalLink = _externalLink2.default;
	exports.EyeOff = _eyeOff2.default;
	exports.Eye = _eye2.default;
	exports.Facebook = _facebook2.default;
	exports.FastForward = _fastForward2.default;
	exports.Feather = _feather2.default;
	exports.FileMinus = _fileMinus2.default;
	exports.FilePlus = _filePlus2.default;
	exports.FileText = _fileText2.default;
	exports.File = _file2.default;
	exports.Film = _film2.default;
	exports.Filter = _filter2.default;
	exports.Flag = _flag2.default;
	exports.FolderMinus = _folderMinus2.default;
	exports.FolderPlus = _folderPlus2.default;
	exports.Folder = _folder2.default;
	exports.Frown = _frown2.default;
	exports.Gift = _gift2.default;
	exports.GitBranch = _gitBranch2.default;
	exports.GitCommit = _gitCommit2.default;
	exports.GitMerge = _gitMerge2.default;
	exports.GitPullRequest = _gitPullRequest2.default;
	exports.GitHub = _github2.default;
	exports.Gitlab = _gitlab2.default;
	exports.Globe = _globe2.default;
	exports.Grid = _grid2.default;
	exports.HardDrive = _hardDrive2.default;
	exports.Hash = _hash2.default;
	exports.Headphones = _headphones2.default;
	exports.Heart = _heart2.default;
	exports.HelpCircle = _helpCircle2.default;
	exports.Home = _home2.default;
	exports.Image = _image2.default;
	exports.Inbox = _inbox2.default;
	exports.Info = _info2.default;
	exports.Instagram = _instagram2.default;
	exports.Italic = _italic2.default;
	exports.Key = _key2.default;
	exports.Layers = _layers2.default;
	exports.Layout = _layout2.default;
	exports.LifeBuoy = _lifeBuoy2.default;
	exports.Link2 = _link2.default;
	exports.Link = _link4.default;
	exports.Linkedin = _linkedin2.default;
	exports.List = _list2.default;
	exports.Loader = _loader2.default;
	exports.Lock = _lock2.default;
	exports.LogIn = _logIn2.default;
	exports.LogOut = _logOut2.default;
	exports.Mail = _mail2.default;
	exports.MapPin = _mapPin2.default;
	exports.Map = _map2.default;
	exports.Maximize2 = _maximize2.default;
	exports.Maximize = _maximize4.default;
	exports.Meh = _meh2.default;
	exports.Menu = _menu2.default;
	exports.MessageCircle = _messageCircle2.default;
	exports.MessageSquare = _messageSquare2.default;
	exports.MicOff = _micOff2.default;
	exports.Mic = _mic2.default;
	exports.Minimize2 = _minimize2.default;
	exports.Minimize = _minimize4.default;
	exports.MinusCircle = _minusCircle2.default;
	exports.MinusSquare = _minusSquare2.default;
	exports.Minus = _minus2.default;
	exports.Monitor = _monitor2.default;
	exports.Moon = _moon2.default;
	exports.MoreHorizontal = _moreHorizontal2.default;
	exports.MoreVertical = _moreVertical2.default;
	exports.Move = _move2.default;
	exports.Music = _music2.default;
	exports.Navigation2 = _navigation2.default;
	exports.Navigation = _navigation4.default;
	exports.Octagon = _octagon2.default;
	exports.Package = _package2.default;
	exports.Paperclip = _paperclip2.default;
	exports.PauseCircle = _pauseCircle2.default;
	exports.Pause = _pause2.default;
	exports.Percent = _percent2.default;
	exports.PhoneCall = _phoneCall2.default;
	exports.PhoneForwarded = _phoneForwarded2.default;
	exports.PhoneIncoming = _phoneIncoming2.default;
	exports.PhoneMissed = _phoneMissed2.default;
	exports.PhoneOff = _phoneOff2.default;
	exports.PhoneOutgoing = _phoneOutgoing2.default;
	exports.Phone = _phone2.default;
	exports.PieChart = _pieChart2.default;
	exports.PlayCircle = _playCircle2.default;
	exports.Play = _play2.default;
	exports.PlusCircle = _plusCircle2.default;
	exports.PlusSquare = _plusSquare2.default;
	exports.Plus = _plus2.default;
	exports.Pocket = _pocket2.default;
	exports.Power = _power2.default;
	exports.Printer = _printer2.default;
	exports.Radio = _radio2.default;
	exports.RefreshCcw = _refreshCcw2.default;
	exports.RefreshCw = _refreshCw2.default;
	exports.Repeat = _repeat2.default;
	exports.Rewind = _rewind2.default;
	exports.RotateCcw = _rotateCcw2.default;
	exports.RotateCw = _rotateCw2.default;
	exports.Rss = _rss2.default;
	exports.Save = _save2.default;
	exports.Scissors = _scissors2.default;
	exports.Search = _search2.default;
	exports.Send = _send2.default;
	exports.Server = _server2.default;
	exports.Settings = _settings2.default;
	exports.Share2 = _share2.default;
	exports.Share = _share4.default;
	exports.ShieldOff = _shieldOff2.default;
	exports.Shield = _shield2.default;
	exports.ShoppingBag = _shoppingBag2.default;
	exports.ShoppingCart = _shoppingCart2.default;
	exports.Shuffle = _shuffle2.default;
	exports.Sidebar = _sidebar2.default;
	exports.SkipBack = _skipBack2.default;
	exports.SkipForward = _skipForward2.default;
	exports.Slack = _slack2.default;
	exports.Slash = _slash2.default;
	exports.Sliders = _sliders2.default;
	exports.Smartphone = _smartphone2.default;
	exports.Smile = _smile2.default;
	exports.Speaker = _speaker2.default;
	exports.Square = _square2.default;
	exports.Star = _star2.default;
	exports.StopCircle = _stopCircle2.default;
	exports.Sun = _sun2.default;
	exports.Sunrise = _sunrise2.default;
	exports.Sunset = _sunset2.default;
	exports.Tablet = _tablet2.default;
	exports.Tag = _tag2.default;
	exports.Target = _target2.default;
	exports.Terminal = _terminal2.default;
	exports.Thermometer = _thermometer2.default;
	exports.ThumbsDown = _thumbsDown2.default;
	exports.ThumbsUp = _thumbsUp2.default;
	exports.ToggleLeft = _toggleLeft2.default;
	exports.ToggleRight = _toggleRight2.default;
	exports.Trash2 = _trash2.default;
	exports.Trash = _trash4.default;
	exports.Trello = _trello2.default;
	exports.TrendingDown = _trendingDown2.default;
	exports.TrendingUp = _trendingUp2.default;
	exports.Triangle = _triangle2.default;
	exports.Truck = _truck2.default;
	exports.Tv = _tv2.default;
	exports.Twitter = _twitter2.default;
	exports.Type = _type2.default;
	exports.Umbrella = _umbrella2.default;
	exports.Underline = _underline2.default;
	exports.Unlock = _unlock2.default;
	exports.UploadCloud = _uploadCloud2.default;
	exports.Upload = _upload2.default;
	exports.UserCheck = _userCheck2.default;
	exports.UserMinus = _userMinus2.default;
	exports.UserPlus = _userPlus2.default;
	exports.UserX = _userX2.default;
	exports.User = _user2.default;
	exports.Users = _users2.default;
	exports.VideoOff = _videoOff2.default;
	exports.Video = _video2.default;
	exports.Voicemail = _voicemail2.default;
	exports.Volume1 = _volume2.default;
	exports.Volume2 = _volume4.default;
	exports.VolumeX = _volumeX2.default;
	exports.Volume = _volume6.default;
	exports.Watch = _watch2.default;
	exports.WifiOff = _wifiOff2.default;
	exports.Wifi = _wifi2.default;
	exports.Wind = _wind2.default;
	exports.XCircle = _xCircle2.default;
	exports.XSquare = _xSquare2.default;
	exports.X = _x2.default;
	exports.Youtube = _youtube2.default;
	exports.ZapOff = _zapOff2.default;
	exports.Zap = _zap2.default;
	exports.ZoomIn = _zoomIn2.default;
	exports.ZoomOut = _zoomOut2.default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(44)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(58);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _capitalizeString = /*#__PURE__*/__webpack_require__(173);
	
	var _capitalizeString2 = /*#__PURE__*/_interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var positionMap = ['Top', 'Right', 'Bottom', 'Left'];
	
	
	function generateProperty(property, position) {
	  if (!property) return position.toLowerCase();
	  var splitProperty = property.split('-');
	  if (splitProperty.length > 1) {
	    splitProperty.splice(1, 0, position);
	    return splitProperty.reduce(function (acc, val) {
	      return '' + acc + (0, _capitalizeString2.default)(val);
	    });
	  }
	  var joinedProperty = property.replace(/([a-z])([A-Z])/g, '$1' + position + '$2');
	  return property === joinedProperty ? '' + property + position : joinedProperty;
	}
	
	function generateStyles(property, valuesWithDefaults) {
	  var styles = {};
	  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
	    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
	      styles[generateProperty(property, positionMap[i])] = valuesWithDefaults[i];
	    }
	  }
	  return styles;
	}
	
	/**
	 * A helper that enables shorthand for direction based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'paddingTop': '12px',
	 *   'paddingRight': '24px',
	 *   'paddingBottom': '36px',
	 *   'paddingLeft': '48px'
	 * }
	 */
	
	function directionalProperty(property) {
	  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    values[_key - 1] = arguments[_key];
	  }
	
	  //  prettier-ignore
	  var firstValue = values[0],
	      _values$ = values[1],
	      secondValue = _values$ === undefined ? firstValue : _values$,
	      _values$2 = values[2],
	      thirdValue = _values$2 === undefined ? firstValue : _values$2,
	      _values$3 = values[3],
	      fourthValue = _values$3 === undefined ? secondValue : _values$3;
	
	  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
	  return generateStyles(property, valuesWithDefaults);
	}
	
	exports.default = directionalProperty;
	module.exports = exports['default'];

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e(__webpack_require__(385)):"function"==typeof define&&define.amd?define("PrismicJS",["cross-fetch/polyfill"],e):"object"==typeof exports?exports.PrismicJS=e(require("cross-fetch/polyfill")):t.PrismicJS=e(t["cross-fetch/polyfill"])}("undefined"!=typeof self?self:this,function(t){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=20)}([function(t,e,n){"use strict";e.a=function(t){var e=this.constructor;return this.then(function(n){return e.resolve(t()).then(function(){return n})},function(n){return e.resolve(t()).then(function(){return e.reject(n)})})}},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){"use strict";e.__esModule=!0;var r=n(5),o=n(4),i=n(6),u=n(12);e.PREVIEW_COOKIE="io.prismic.preview",e.EXPERIMENT_COOKIE="io.prismic.experiment";var a=function(){function t(t,e,n){this.data=t,this.masterRef=t.refs.filter(function(t){return t.isMasterRef})[0],this.experiments=new r.Experiments(t.experiments),this.bookmarks=t.bookmarks,this.httpClient=e,this.options=n,this.refs=t.refs,this.tags=t.tags,this.types=t.types}return t.prototype.form=function(t){var e=this.data.forms[t];return e?new o.SearchForm(e,this.httpClient):null},t.prototype.everything=function(){var t=this.form("everything");if(!t)throw new Error("Missing everything form");return t},t.prototype.master=function(){return this.masterRef.ref},t.prototype.ref=function(t){var e=this.data.refs.filter(function(e){return e.label===t})[0];return e?e.ref:null},t.prototype.currentExperiment=function(){return this.experiments.current()},t.prototype.query=function(t,n,r){void 0===r&&(r=function(){});var o="function"==typeof n?{options:{},callback:n}:{options:n||{},callback:r},i=o.options,a=o.callback,s=this.everything();for(var f in i)s=s.set(f,i[f]);if(!i.ref){var c="";this.options.req?c=this.options.req.headers.cookie||"":"undefined"!=typeof window&&window.document&&(c=window.document.cookie||"");var l=u.default.parse(c),h=l[e.PREVIEW_COOKIE],p=this.experiments.refFromCookie(l[e.EXPERIMENT_COOKIE]);s=s.ref(h||p||this.masterRef.ref)}return t&&s.query(t),s.submit(a)},t.prototype.queryFirst=function(t,e,n){var r="function"==typeof e?{options:{},callback:e}:{options:e||{},callback:n||function(){}},o=r.options,i=r.callback;return o.page=1,o.pageSize=1,this.query(t,o).then(function(t){var e=t&&t.results&&t.results[0];return i(null,e),e}).catch(function(t){throw i(t),t})},t.prototype.getByID=function(t,e,n){var r=e||{};return r.lang||(r.lang="*"),this.queryFirst(i.default.at("document.id",t),r,n)},t.prototype.getByIDs=function(t,e,n){var r=e||{};return r.lang||(r.lang="*"),this.query(i.default.in("document.id",t),r,n)},t.prototype.getByUID=function(t,e,n,r){var o=n||{};return o.lang||(o.lang="*"),this.queryFirst(i.default.at("my."+t+".uid",e),o,r)},t.prototype.getSingle=function(t,e,n){var r=e||{};return this.queryFirst(i.default.at("document.type",t),r,n)},t.prototype.getBookmark=function(t,e,n){var r=this.data.bookmarks[t];return r?this.getByID(r,e,n):Promise.reject("Error retrieving bookmarked id")},t.prototype.previewSession=function(t,e,n,r){var o=this;return new Promise(function(i,u){o.httpClient.request(t,function(a,s){if(a)r&&r(a),u(a);else if(s){if(s.mainDocument)return o.getByID(s.mainDocument,{ref:t}).then(function(t){if(t){var o=e(t);r&&r(null,o),i(o)}else r&&r(null,n),i(n)}).catch(u);r&&r(null,n),i(n)}})})},t}();e.default=a},function(t,e,n){"use strict";e.__esModule=!0;var r=n(2),o=n(11),i=function(){function t(t,e){if(this.options=e||{},this.url=t,this.options.accessToken){var n="access_token="+this.options.accessToken;this.url+=(t.indexOf("?")>-1?"&":"?")+n}this.apiDataTTL=this.options.apiDataTTL||5,this.httpClient=new o.default(this.options.requestHandler,this.options.apiCache,this.options.proxyAgent)}return t.prototype.get=function(t){var e=this;return this.httpClient.cachedRequest(this.url,{ttl:this.apiDataTTL}).then(function(n){var o=new r.default(n,e.httpClient,e.options);return t&&t(null,o),o}).catch(function(e){throw t&&t(e),e})},t}();e.default=i},function(t,e,n){"use strict";e.__esModule=!0;var r=function(){function t(t,e){this.id=t,this.api=e,this.fields={}}return t.prototype.set=function(t,e){return this.fields[t]=e,this},t.prototype.ref=function(t){return this.set("ref",t)},t.prototype.query=function(t){return this.set("q",t)},t.prototype.pageSize=function(t){return this.set("pageSize",t)},t.prototype.fetch=function(t){return this.set("fetch",t)},t.prototype.fetchLinks=function(t){return this.set("fetchLinks",t)},t.prototype.lang=function(t){return this.set("lang",t)},t.prototype.page=function(t){return this.set("page",t)},t.prototype.after=function(t){return this.set("after",t)},t.prototype.orderings=function(t){return this.set("orderings",t)},t.prototype.url=function(){var e=this;return this.api.get().then(function(n){return t.toSearchForm(e,n).url()})},t.prototype.submit=function(e){var n=this;return this.api.get().then(function(r){return t.toSearchForm(n,r).submit(e)})},t.toSearchForm=function(t,e){var n=e.form(t.id);if(n)return Object.keys(t.fields).reduce(function(e,n){var r=t.fields[n];return"q"===n?e.query(r):"pageSize"===n?e.pageSize(r):"fetch"===n?e.fetch(r):"fetchLinks"===n?e.fetchLinks(r):"lang"===n?e.lang(r):"page"===n?e.page(r):"after"===n?e.after(r):"orderings"===n?e.orderings(r):e.set(n,r)},n);throw new Error("Unable to access to form "+t.id)},t}();e.LazySearchForm=r;var o=function(){function t(t,e){for(var n in this.httpClient=e,this.form=t,this.data={},t.fields)t.fields[n].default&&(this.data[n]=[t.fields[n].default])}return t.prototype.set=function(t,e){var n=this.form.fields[t];if(!n)throw new Error("Unknown field "+t);var r=""===e||void 0===e?null:e,o=this.data[t]||[];return o=n.multiple?r?o.concat([r]):o:r?[r]:o,this.data[t]=o,this},t.prototype.ref=function(t){return this.set("ref",t)},t.prototype.query=function(t){if("string"==typeof t)return this.query([t]);if(t instanceof Array)return this.set("q","["+t.join("")+"]");throw new Error("Invalid query : "+t)},t.prototype.pageSize=function(t){return this.set("pageSize",t)},t.prototype.fetch=function(t){var e=t instanceof Array?t.join(","):t;return this.set("fetch",e)},t.prototype.fetchLinks=function(t){var e=t instanceof Array?t.join(","):t;return this.set("fetchLinks",e)},t.prototype.lang=function(t){return this.set("lang",t)},t.prototype.page=function(t){return this.set("page",t)},t.prototype.after=function(t){return this.set("after",t)},t.prototype.orderings=function(t){return t?this.set("orderings","["+t.join(",")+"]"):this},t.prototype.url=function(){var t=this.form.action;if(this.data){var e=t.indexOf("?")>-1?"&":"?";for(var n in this.data)if(this.data.hasOwnProperty(n)){var r=this.data[n];if(r)for(var o=0;o<r.length;o++)t+=e+n+"="+encodeURIComponent(r[o]),e="&"}}return t},t.prototype.submit=function(t){return this.httpClient.cachedRequest(this.url()).then(function(e){return t&&t(null,e),e}).catch(function(e){throw t&&t(e),e})},t}();e.SearchForm=o},function(t,e,n){"use strict";e.__esModule=!0;var r=function(){function t(t){this.data={},this.data=t}return t.prototype.id=function(){return this.data.id},t.prototype.ref=function(){return this.data.ref},t.prototype.label=function(){return this.data.label},t}();e.Variation=r;var o=function(){function t(t){this.data={},this.data=t,this.variations=(t.variations||[]).map(function(t){return new r(t)})}return t.prototype.id=function(){return this.data.id},t.prototype.googleId=function(){return this.data.googleId},t.prototype.name=function(){return this.data.name},t}();e.Experiment=o;var i=function(){function t(t){t&&(this.drafts=(t.drafts||[]).map(function(t){return new o(t)}),this.running=(t.running||[]).map(function(t){return new o(t)}))}return t.prototype.current=function(){return this.running.length>0?this.running[0]:null},t.prototype.refFromCookie=function(t){if(!t||""===t.trim())return null;var e=t.trim().split(" ");if(e.length<2)return null;var n=e[0],r=parseInt(e[1],10),o=this.running.filter(function(t){return t.googleId()===n&&t.variations.length>r})[0];return o?o.variations[r].ref():null},t}();e.Experiments=i},function(t,e,n){"use strict";e.__esModule=!0;var r="at",o="not",i="missing",u="has",a="any",s="in",f="fulltext",c="similar",l="number.gt",h="number.lt",p="number.inRange",d="date.before",y="date.after",m="date.between",v="date.day-of-month",g="date.day-of-month-after",w="date.day-of-month-before",_="date.day-of-week",b="date.day-of-week-after",k="date.day-of-week-before",T="date.month",I="date.month-before",E="date.month-after",O="date.year",x="date.hour",A="date.hour-before",M="date.hour-after",j="geopoint.near";function q(t){if("string"==typeof t)return'"'+t+'"';if("number"==typeof t)return t.toString();if(t instanceof Date)return t.getTime().toString();if(t instanceof Array)return"["+t.map(function(t){return q(t)}).join(",")+"]";throw new Error("Unable to encode "+t+" of type "+typeof t)}var S={near:function(t,e,n,r){return"["+j+"("+t+", "+e+", "+n+", "+r+")]"}},C={before:function(t,e){return"["+d+"("+t+", "+q(e)+")]"},after:function(t,e){return"["+y+"("+t+", "+q(e)+")]"},between:function(t,e,n){return"["+m+"("+t+", "+q(e)+", "+q(n)+")]"},dayOfMonth:function(t,e){return"["+v+"("+t+", "+e+")]"},dayOfMonthAfter:function(t,e){return"["+g+"("+t+", "+e+")]"},dayOfMonthBefore:function(t,e){return"["+w+"("+t+", "+e+")]"},dayOfWeek:function(t,e){return"["+_+"("+t+", "+q(e)+")]"},dayOfWeekAfter:function(t,e){return"["+b+"("+t+", "+q(e)+")]"},dayOfWeekBefore:function(t,e){return"["+k+"("+t+", "+q(e)+")]"},month:function(t,e){return"["+T+"("+t+", "+q(e)+")]"},monthBefore:function(t,e){return"["+I+"("+t+", "+q(e)+")]"},monthAfter:function(t,e){return"["+E+"("+t+", "+q(e)+")]"},year:function(t,e){return"["+O+"("+t+", "+e+")]"},hour:function(t,e){return"["+x+"("+t+", "+e+")]"},hourBefore:function(t,e){return"["+A+"("+t+", "+e+")]"},hourAfter:function(t,e){return"["+M+"("+t+", "+e+")]"}},P={gt:function(t,e){return"["+l+"("+t+", "+e+")]"},lt:function(t,e){return"["+h+"("+t+", "+e+")]"},inRange:function(t,e,n){return"["+p+"("+t+", "+e+", "+n+")]"}};e.default={at:function(t,e){return"["+r+"("+t+", "+q(e)+")]"},not:function(t,e){return"["+o+"("+t+", "+q(e)+")]"},missing:function(t){return"["+i+"("+t+")]"},has:function(t){return"["+u+"("+t+")]"},any:function(t,e){return"["+a+"("+t+", "+q(e)+")]"},in:function(t,e){return"["+s+"("+t+", "+q(e)+")]"},fulltext:function(t,e){return"["+f+"("+t+", "+q(e)+")]"},similar:function(t,e){return"["+c+'("'+t+'", '+e+")]"},date:C,dateBefore:C.before,dateAfter:C.after,dateBetween:C.between,dayOfMonth:C.dayOfMonth,dayOfMonthAfter:C.dayOfMonthAfter,dayOfMonthBefore:C.dayOfMonthBefore,dayOfWeek:C.dayOfWeek,dayOfWeekAfter:C.dayOfWeekAfter,dayOfWeekBefore:C.dayOfWeekBefore,month:C.month,monthBefore:C.monthBefore,monthAfter:C.monthAfter,year:C.year,hour:C.hour,hourBefore:C.hourBefore,hourAfter:C.hourAfter,number:P,gt:P.gt,lt:P.lt,inRange:P.inRange,near:S.near,geopoint:S}},function(t,e,n){"use strict";(function(t){var r=n(0),o=setTimeout;function i(){}function u(t){if(!(this instanceof u))throw new TypeError("Promises must be constructed via new");if("function"!=typeof t)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],l(t,this)}function a(t,e){for(;3===t._state;)t=t._value;0!==t._state?(t._handled=!0,u._immediateFn(function(){var n=1===t._state?e.onFulfilled:e.onRejected;if(null!==n){var r;try{r=n(t._value)}catch(t){return void f(e.promise,t)}s(e.promise,r)}else(1===t._state?s:f)(e.promise,t._value)})):t._deferreds.push(e)}function s(t,e){try{if(e===t)throw new TypeError("A promise cannot be resolved with itself.");if(e&&("object"==typeof e||"function"==typeof e)){var n=e.then;if(e instanceof u)return t._state=3,t._value=e,void c(t);if("function"==typeof n)return void l(function(t,e){return function(){t.apply(e,arguments)}}(n,e),t)}t._state=1,t._value=e,c(t)}catch(e){f(t,e)}}function f(t,e){t._state=2,t._value=e,c(t)}function c(t){2===t._state&&0===t._deferreds.length&&u._immediateFn(function(){t._handled||u._unhandledRejectionFn(t._value)});for(var e=0,n=t._deferreds.length;e<n;e++)a(t,t._deferreds[e]);t._deferreds=null}function l(t,e){var n=!1;try{t(function(t){n||(n=!0,s(e,t))},function(t){n||(n=!0,f(e,t))})}catch(t){if(n)return;n=!0,f(e,t)}}u.prototype.catch=function(t){return this.then(null,t)},u.prototype.then=function(t,e){var n=new this.constructor(i);return a(this,new function(t,e,n){this.onFulfilled="function"==typeof t?t:null,this.onRejected="function"==typeof e?e:null,this.promise=n}(t,e,n)),n},u.prototype.finally=r.a,u.all=function(t){return new u(function(e,n){if(!t||void 0===t.length)throw new TypeError("Promise.all accepts an array");var r=Array.prototype.slice.call(t);if(0===r.length)return e([]);var o=r.length;function i(t,u){try{if(u&&("object"==typeof u||"function"==typeof u)){var a=u.then;if("function"==typeof a)return void a.call(u,function(e){i(t,e)},n)}r[t]=u,0==--o&&e(r)}catch(t){n(t)}}for(var u=0;u<r.length;u++)i(u,r[u])})},u.resolve=function(t){return t&&"object"==typeof t&&t.constructor===u?t:new u(function(e){e(t)})},u.reject=function(t){return new u(function(e,n){n(t)})},u.race=function(t){return new u(function(e,n){for(var r=0,o=t.length;r<o;r++)t[r].then(e,n)})},u._immediateFn="function"==typeof t&&function(e){t(e)}||function(t){o(t,0)},u._unhandledRejectionFn=function(t){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",t)},e.a=u}).call(this,n(18).setImmediate)},function(t,e,n){"use strict";e.__esModule=!0;var r=20,o=0,i=[];function u(t){if(i.length>0&&o<r){o++;var e=i.shift();e&&function(t,e,n){var r={headers:{Accept:"application/json"}};e&&e.proxyAgent&&(r.agent=e.proxyAgent),fetch(t,r).then(function(e){return~~(e.status/100!=2)?e.text().then(function(){var n=new Error("Unexpected status code ["+e.status+"] on URL "+t);throw n.status=e.status,n}):e.json().then(function(t){var r=e.headers.get("cache-control"),o=r?/max-age=(\d+)/.exec(r):null,i=o?parseInt(o[1],10):void 0;n(null,t,e,i)})}).catch(n)}(e.url,t,function(n,r,i,a){o--,e.callback(n,r,i,a),u(t)})}}var a=function(){function t(t){this.options=t||{}}return t.prototype.request=function(t,e){i.push({url:t,callback:e}),u(this.options)},t}();e.DefaultRequestHandler=a},function(t,e,n){"use strict";function r(t){this.size=0,this.limit=t,this._keymap={}}e.__esModule=!0,e.MakeLRUCache=function(t){return new r(t)},r.prototype.put=function(t,e){var n={key:t,value:e};if(this._keymap[t]=n,this.tail?(this.tail.newer=n,n.older=this.tail):this.head=n,this.tail=n,this.size===this.limit)return this.shift();this.size++},r.prototype.shift=function(){var t=this.head;return t&&(this.head.newer?(this.head=this.head.newer,this.head.older=void 0):this.head=void 0,t.newer=t.older=void 0,delete this._keymap[t.key]),console.log("purging ",t.key),t},r.prototype.get=function(t,e){var n=this._keymap[t];if(void 0!==n)return n===this.tail?e?n:n.value:(n.newer&&(n===this.head&&(this.head=n.newer),n.newer.older=n.older),n.older&&(n.older.newer=n.newer),n.newer=void 0,n.older=this.tail,this.tail&&(this.tail.newer=n),this.tail=n,e?n:n.value)},r.prototype.find=function(t){return this._keymap[t]},r.prototype.set=function(t,e){var n,r=this.get(t,!0);return r?(n=r.value,r.value=e):(n=this.put(t,e))&&(n=n.value),n},r.prototype.remove=function(t){var e=this._keymap[t];if(e)return delete this._keymap[e.key],e.newer&&e.older?(e.older.newer=e.newer,e.newer.older=e.older):e.newer?(e.newer.older=void 0,this.head=e.newer):e.older?(e.older.newer=void 0,this.tail=e.older):this.head=this.tail=void 0,this.size--,e.value},r.prototype.removeAll=function(){this.head=this.tail=void 0,this.size=0,this._keymap={}},"function"==typeof Object.keys?r.prototype.keys=function(){return Object.keys(this._keymap)}:r.prototype.keys=function(){var t=[];for(var e in this._keymap)t.push(e);return t},r.prototype.forEach=function(t,e,n){var r;if(!0===e?(n=!0,e=void 0):"object"!=typeof e&&(e=this),n)for(r=this.tail;r;)t.call(e,r.key,r.value,this),r=r.older;else for(r=this.head;r;)t.call(e,r.key,r.value,this),r=r.newer},r.prototype.toString=function(){for(var t="",e=this.head;e;)t+=String(e.key)+":"+e.value,(e=e.newer)&&(t+=" < ");return t}},function(t,e,n){"use strict";e.__esModule=!0;var r=n(9),o=function(){function t(t){void 0===t&&(t=1e3),this.lru=r.MakeLRUCache(t)}return t.prototype.isExpired=function(t){var e=this.lru.get(t,!1);return!!e&&(0!==e.expiredIn&&e.expiredIn<Date.now())},t.prototype.get=function(t,e){var n=this.lru.get(t,!1);n&&!this.isExpired(t)?e(null,n.data):e&&e(null)},t.prototype.set=function(t,e,n,r){this.lru.remove(t),this.lru.put(t,{data:e,expiredIn:n?Date.now()+1e3*n:0}),r&&r(null)},t.prototype.remove=function(t,e){this.lru.remove(t),e&&e(null)},t.prototype.clear=function(t){this.lru.removeAll(),t&&t(null)},t}();e.DefaultApiCache=o},function(t,e,n){"use strict";e.__esModule=!0;var r=n(10),o=n(8),i=function(){function t(t,e,n){this.requestHandler=t||new o.DefaultRequestHandler({proxyAgent:n}),this.cache=e||new r.DefaultApiCache}return t.prototype.request=function(t,e){this.requestHandler.request(t,function(t,n,r,o){t?e&&e(t,null,r,o):n&&e&&e(null,n,r,o)})},t.prototype.cachedRequest=function(t,e){var n=this,r=e||{};return new Promise(function(e,o){!function(e){var o=r.cacheKey||t;n.cache.get(o,function(i,u){i||u?e(i,u):n.request(t,function(t,i,u,a){if(t)e(t,null);else{var s=a||r.ttl;s&&n.cache.set(o,i,s,e),e(null,i)}})})}(function(t,n){t&&o(t),n&&e(n)})})},t}();e.default=i},function(t,e,n){"use strict";e.__esModule=!0;var r=decodeURIComponent;e.default={parse:function(t,e){if("string"!=typeof t)throw new TypeError("argument str must be a string");var n={},o=e||{},i=t.split(/; */),u=o.decode||r;return i.forEach(function(t){var e=t.indexOf("=");if(!(e<0)){var r=t.substr(0,e).trim(),o=t.substr(++e,t.length).trim();'"'==o[0]&&(o=o.slice(1,-1)),void 0==n[r]&&(n[r]=function(t,e){try{return e(t)}catch(e){return t}}(o,u))}}),n}}},function(t,e,n){"use strict";e.__esModule=!0;var r=n(4),o=n(3),i=function(){function t(t,e){this.api=new o.default(t,e)}return t.prototype.getApi=function(){return this.api.get()},t.prototype.everything=function(){return this.form("everything")},t.prototype.form=function(t){return new r.LazySearchForm(t,this.api)},t.prototype.query=function(t,e,n){return this.getApi().then(function(r){return r.query(t,e,n)})},t.prototype.queryFirst=function(t,e,n){return this.getApi().then(function(r){return r.queryFirst(t,e,n)})},t.prototype.getByID=function(t,e,n){return this.getApi().then(function(r){return r.getByID(t,e,n)})},t.prototype.getByIDs=function(t,e,n){return this.getApi().then(function(r){return r.getByIDs(t,e,n)})},t.prototype.getByUID=function(t,e,n,r){return this.getApi().then(function(o){return o.getByUID(t,e,n,r)})},t.prototype.getSingle=function(t,e,n){return this.getApi().then(function(r){return r.getSingle(t,e,n)})},t.prototype.getBookmark=function(t,e,n){return this.getApi().then(function(r){return r.getBookmark(t,e,n)})},t.prototype.previewSession=function(t,e,n,r){return this.getApi().then(function(o){return o.previewSession(t,e,n,r)})},t.getApi=function(t,e){return new o.default(t,e).get()},t}();e.DefaultClient=i},function(t,e,n){"use strict";var r,o=n(6),i=n(5),u=n(13),a=n(3),s=n(2);!function(t){function e(t,e){return u.DefaultClient.getApi(t,e)}t.experimentCookie=s.EXPERIMENT_COOKIE,t.previewCookie=s.PREVIEW_COOKIE,t.Predicates=o.default,t.Experiments=i.Experiments,t.Api=a.default,t.client=function(t,e){return new u.DefaultClient(t,e)},t.getApi=e,t.api=function(t,n){return e(t,n)}}(r||(r={})),t.exports=r},function(e,n){e.exports=t},function(t,e){var n,r,o=t.exports={};function i(){throw new Error("setTimeout has not been defined")}function u(){throw new Error("clearTimeout has not been defined")}function a(t){if(n===setTimeout)return setTimeout(t,0);if((n===i||!n)&&setTimeout)return n=setTimeout,setTimeout(t,0);try{return n(t,0)}catch(e){try{return n.call(null,t,0)}catch(e){return n.call(this,t,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:i}catch(t){n=i}try{r="function"==typeof clearTimeout?clearTimeout:u}catch(t){r=u}}();var s,f=[],c=!1,l=-1;function h(){c&&s&&(c=!1,s.length?f=s.concat(f):l=-1,f.length&&p())}function p(){if(!c){var t=a(h);c=!0;for(var e=f.length;e;){for(s=f,f=[];++l<e;)s&&s[l].run();l=-1,e=f.length}s=null,c=!1,function(t){if(r===clearTimeout)return clearTimeout(t);if((r===u||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(t);try{r(t)}catch(e){try{return r.call(null,t)}catch(e){return r.call(this,t)}}}(t)}}function d(t,e){this.fun=t,this.array=e}function y(){}o.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];f.push(new d(t,e)),1!==f.length||c||a(p)},d.prototype.run=function(){this.fun.apply(null,this.array)},o.title="browser",o.browser=!0,o.env={},o.argv=[],o.version="",o.versions={},o.on=y,o.addListener=y,o.once=y,o.off=y,o.removeListener=y,o.removeAllListeners=y,o.emit=y,o.prependListener=y,o.prependOnceListener=y,o.listeners=function(t){return[]},o.binding=function(t){throw new Error("process.binding is not supported")},o.cwd=function(){return"/"},o.chdir=function(t){throw new Error("process.chdir is not supported")},o.umask=function(){return 0}},function(t,e,n){(function(t,e){!function(t,n){"use strict";if(!t.setImmediate){var r,o=1,i={},u=!1,a=t.document,s=Object.getPrototypeOf&&Object.getPrototypeOf(t);s=s&&s.setTimeout?s:t,"[object process]"==={}.toString.call(t.process)?r=function(t){e.nextTick(function(){c(t)})}:function(){if(t.postMessage&&!t.importScripts){var e=!0,n=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage("","*"),t.onmessage=n,e}}()?function(){var e="setImmediate$"+Math.random()+"$",n=function(n){n.source===t&&"string"==typeof n.data&&0===n.data.indexOf(e)&&c(+n.data.slice(e.length))};t.addEventListener?t.addEventListener("message",n,!1):t.attachEvent("onmessage",n),r=function(n){t.postMessage(e+n,"*")}}():t.MessageChannel?function(){var t=new MessageChannel;t.port1.onmessage=function(t){c(t.data)},r=function(e){t.port2.postMessage(e)}}():a&&"onreadystatechange"in a.createElement("script")?function(){var t=a.documentElement;r=function(e){var n=a.createElement("script");n.onreadystatechange=function(){c(e),n.onreadystatechange=null,t.removeChild(n),n=null},t.appendChild(n)}}():r=function(t){setTimeout(c,0,t)},s.setImmediate=function(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),n=0;n<e.length;n++)e[n]=arguments[n+1];var u={callback:t,args:e};return i[o]=u,r(o),o++},s.clearImmediate=f}function f(t){delete i[t]}function c(t){if(u)setTimeout(c,0,t);else{var e=i[t];if(e){u=!0;try{!function(t){var e=t.callback,r=t.args;switch(r.length){case 0:e();break;case 1:e(r[0]);break;case 2:e(r[0],r[1]);break;case 3:e(r[0],r[1],r[2]);break;default:e.apply(n,r)}}(e)}finally{f(t),u=!1}}}}}("undefined"==typeof self?void 0===t?this:t:self)}).call(this,n(1),n(16))},function(t,e,n){(function(t){var r=void 0!==t&&t||"undefined"!=typeof self&&self||window,o=Function.prototype.apply;function i(t,e){this._id=t,this._clearFn=e}e.setTimeout=function(){return new i(o.call(setTimeout,r,arguments),clearTimeout)},e.setInterval=function(){return new i(o.call(setInterval,r,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},i.prototype.unref=i.prototype.ref=function(){},i.prototype.close=function(){this._clearFn.call(r,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout(function(){t._onTimeout&&t._onTimeout()},e))},n(17),e.setImmediate="undefined"!=typeof self&&self.setImmediate||void 0!==t&&t.setImmediate||this&&this.setImmediate,e.clearImmediate="undefined"!=typeof self&&self.clearImmediate||void 0!==t&&t.clearImmediate||this&&this.clearImmediate}).call(this,n(1))},function(t,e,n){"use strict";n.r(e),function(t){var e=n(7),r=n(0),o=function(){if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if(void 0!==t)return t;throw new Error("unable to locate global object")}();o.Promise?o.Promise.prototype.finally||(o.Promise.prototype.finally=r.a):o.Promise=e.a}.call(this,n(1))},function(t,e,n){n(19),n(15),t.exports=n(14)}])});

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Text = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Text = exports.Text = (0, _components2.default)({
	  m: 0
	}, 'space', 'color', 'fontFamily', 'fontSize', 'fontWeight', 'textAlign', 'lineHeight');
	
	Text.displayName = 'Text';
	
	exports.default = Text;

/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// This file hosts our error definitions
	// We use custom error "types" so that we can act on them when we need it
	// e.g.: if error instanceof errors.UnparsableJSON then..
	
	var inherits = __webpack_require__(62);
	
	function AlgoliaSearchError(message, extraProperties) {
	  var forEach = __webpack_require__(51);
	
	  var error = this;
	
	  // try to get a stacktrace
	  if (typeof Error.captureStackTrace === 'function') {
	    Error.captureStackTrace(this, this.constructor);
	  } else {
	    error.stack = (new Error()).stack || 'Cannot get a stacktrace, browser is too old';
	  }
	
	  this.name = 'AlgoliaSearchError';
	  this.message = message || 'Unknown error';
	
	  if (extraProperties) {
	    forEach(extraProperties, function addToErrorObject(value, key) {
	      error[key] = value;
	    });
	  }
	}
	
	inherits(AlgoliaSearchError, Error);
	
	function createCustomError(name, message) {
	  function AlgoliaSearchCustomError() {
	    var args = Array.prototype.slice.call(arguments, 0);
	
	    // custom message not set, use default
	    if (typeof args[0] !== 'string') {
	      args.unshift(message);
	    }
	
	    AlgoliaSearchError.apply(this, args);
	    this.name = 'AlgoliaSearch' + name + 'Error';
	  }
	
	  inherits(AlgoliaSearchCustomError, AlgoliaSearchError);
	
	  return AlgoliaSearchCustomError;
	}
	
	// late exports to let various fn defs and inherits take place
	module.exports = {
	  AlgoliaSearchError: AlgoliaSearchError,
	  UnparsableJSON: createCustomError(
	    'UnparsableJSON',
	    'Could not parse the incoming response as JSON, see err.more for details'
	  ),
	  RequestTimeout: createCustomError(
	    'RequestTimeout',
	    'Request timed out before getting a response'
	  ),
	  Network: createCustomError(
	    'Network',
	    'Network issue, see err.more for details'
	  ),
	  JSONPScriptFail: createCustomError(
	    'JSONPScriptFail',
	    '<script> was loaded but did not call our provided callback'
	  ),
	  ValidUntilNotFound: createCustomError(
	    'ValidUntilNotFound',
	    'The SecuredAPIKey does not have a validUntil parameter.'
	  ),
	  JSONPScriptError: createCustomError(
	    'JSONPScriptError',
	    '<script> unable to load due to an `error` event on it'
	  ),
	  ObjectNotFound: createCustomError(
	    'ObjectNotFound',
	    'Object not found'
	  ),
	  Unknown: createCustomError(
	    'Unknown',
	    'Unknown error occured'
	  )
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var foreach = __webpack_require__(51);
	
	module.exports = function map(arr, fn) {
	  var newArr = [];
	  foreach(arr, function(item, itemIndex) {
	    newArr.push(fn(item, itemIndex, arr));
	  });
	  return newArr;
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  ", ";\n  text-transform: uppercase;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n"], ["\n  ", ";\n  text-transform: uppercase;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledSystem = __webpack_require__(11);
	
	var _rebass = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var H4 = (0, _styledComponents2.default)(_rebass.Text)(_templateObject, _styledSystem.letterSpacing);
	
	H4.defaultProps = {
	  is: "h4",
	  m: 0,
	  color: "text",
	  fontSize: 0,
	  fontWeight: "bold",
	  lineHeight: 3,
	  letterSpacing: "caps"
	};
	
	exports.default = H4;
	module.exports = exports["default"];

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 0.75;\n  background: transparent;\n  mix-blend-mode: screen;\n\n  &:after {\n    position: absolute;\n    content: \"\";\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: rgba(0, 0, 0, 0.2);\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 0.75;\n  background: transparent;\n  mix-blend-mode: screen;\n\n  &:after {\n    position: absolute;\n    content: \"\";\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: rgba(0, 0, 0, 0.2);\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  mix-blend-mode: multiply;\n  filter: grayscale(1) contrast(1.3);\n  opacity: 0.9;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position-x: center;\n\n  /* Fallback */\n  background-image: ", ";\n\n  /* Webkit fallback */\n  background-image: ", ";\n\n  /* Regular imageset */\n  background-image: ", ";\n\n  @media (min-width: 52em) {\n    /* Fallback */\n    background-image: ", ";\n\n    /* Webkit fallback */\n    background-image: ", ";\n\n    /* Regular imageset */\n    background-image: ", ";\n  }\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    background-image: ", ";\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  mix-blend-mode: multiply;\n  filter: grayscale(1) contrast(1.3);\n  opacity: 0.9;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position-x: center;\n\n  /* Fallback */\n  background-image: ", ";\n\n  /* Webkit fallback */\n  background-image: ", ";\n\n  /* Regular imageset */\n  background-image: ", ";\n\n  @media (min-width: 52em) {\n    /* Fallback */\n    background-image: ", ";\n\n    /* Webkit fallback */\n    background-image: ", ";\n\n    /* Regular imageset */\n    background-image: ", ";\n  }\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    background-image: ", ";\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(8);
	
	var _rebass = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ImageContainer = (0, _styledComponents2.default)(_rebass.Box)(_templateObject);
	
	var Image = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2, function (props) {
	  return "url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ")";
	}, function (props) {
	  return "-webkit-image-set(url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x)";
	}, function (props) {
	  return "image-set(url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x)";
	}, function (props) {
	  return "url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ")";
	}, function (props) {
	  return "-webkit-image-set(url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x, url(" + (props.backgroundImage ? props.backgroundImage[0] : "") + ") 3x)";
	}, function (props) {
	  return "image-set(url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x, url(" + (props.backgroundImage ? props.backgroundImage[0] : "") + ") 3x)";
	}, function (props) {
	  return props.theme.colors[props.imageColor] && "linear-gradient(to bottom, " + (props.imageColor ? (0, _polished.rgba)(props.theme.colors[props.imageColor], 0.66) : "") + ", " + (props.imageColor ? (0, _polished.rgba)(props.theme.colors[props.imageColor], 0.66) : "") + "), url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ")";
	});
	
	var OverlayImage = function OverlayImage(props) {
	  return _react2.default.createElement(
	    ImageContainer,
	    null,
	    _react2.default.createElement(Image, {
	      imageColor: props.imageColor,
	      backgroundImage: props.backgroundImage
	    })
	  );
	};
	
	OverlayImage.defaultProps = {};
	
	exports.default = OverlayImage;
	module.exports = exports["default"];

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(26);
	var core = __webpack_require__(22);
	var ctx = __webpack_require__(147);
	var hide = __webpack_require__(45);
	var has = __webpack_require__(32);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(47);
	var createDesc = __webpack_require__(68);
	module.exports = __webpack_require__(31) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(55);
	var IE8_DOM_DEFINE = __webpack_require__(149);
	var toPrimitive = __webpack_require__(96);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(31) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(150);
	var defined = __webpack_require__(87);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(94)('wks');
	var uid = __webpack_require__(70);
	var Symbol = __webpack_require__(26).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(76);
	var createDesc = __webpack_require__(163);
	module.exports = __webpack_require__(57) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	module.exports = function forEach (obj, fn, ctx) {
	    if (toString.call(fn) !== '[object Function]') {
	        throw new TypeError('iterator must be a function');
	    }
	    var l = obj.length;
	    if (l === +l) {
	        for (var i = 0; i < l; i++) {
	            fn.call(ctx, obj[i], i, obj);
	        }
	    } else {
	        for (var k in obj) {
	            if (hasOwn.call(obj, k)) {
	                fn.call(ctx, obj[k], k, obj);
	            }
	        }
	    }
	};
	


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function guard(lowerBoundary, upperBoundary, value) {
	  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
	}
	
	exports.default = guard;
	module.exports = exports["default"];

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  ", ";\n  background: transparent;\n  border: ", ";\n  border-color: ", ";\n  cursor: pointer;\n  transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    background-color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    border-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: color, background-color;\n  user-select: none;\n\n  &:hover {\n    color: ", ";\n    background: ", ";\n    border-color: ", ";\n  }\n\n  &:focus {\n    color: ", ";\n    background: ", ";\n    border-color: ", ";\n    outline: 4px solid\n      ", ";\n    box-shadow: none;\n  }\n\n  &:active {\n    color: ", ";\n    background: ", ";\n    border-color: ", ";\n  }\n"], ["\n  color: ", ";\n  ", ";\n  background: transparent;\n  border: ", ";\n  border-color: ", ";\n  cursor: pointer;\n  transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    background-color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    border-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: color, background-color;\n  user-select: none;\n\n  &:hover {\n    color: ", ";\n    background: ", ";\n    border-color: ", ";\n  }\n\n  &:focus {\n    color: ", ";\n    background: ", ";\n    border-color: ", ";\n    outline: 4px solid\n      ", ";\n    box-shadow: none;\n  }\n\n  &:active {\n    color: ", ";\n    background: ", ";\n    border-color: ", ";\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(8);
	
	var _rebass = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Button = (0, _styledComponents2.default)(_rebass.Button)(_templateObject, function (props) {
	  return props.theme.colors.grey[0];
	}, (0, _polished.ellipsis)(), function (props) {
	  return props.theme.borders[1];
	}, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.text && (0, _polished.rgba)(props.theme.colors.grey[0], 0.5);
	}, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.text && (0, _polished.shade)(0.875, props.theme.colors.grey[0]);
	}, function (props) {
	  return props.theme.colors.text && (0, _polished.shade)(0.875, props.theme.colors.grey[0]);
	});
	
	Button.defaultProps = {
	  is: "button",
	  m: 0,
	  px: 16,
	  py: 13,
	  fontSize: 16,
	  fontWeight: "normal",
	  lineHeight: 0,
	  borderRadius: 0
	};
	
	exports.default = Button;
	module.exports = exports["default"];

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n"], ["\n  ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledSystem = __webpack_require__(11);
	
	var _rebass = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var H2 = (0, _styledComponents2.default)(_rebass.Text)(_templateObject, _styledSystem.letterSpacing);
	
	H2.defaultProps = {
	  is: "h2",
	  m: 0,
	  color: "text",
	  fontSize: 5,
	  fontWeight: "bold",
	  lineHeight: 2,
	  letterSpacing: "headings"
	};
	
	exports.default = H2;
	module.exports = exports["default"];

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(46);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(154);
	var enumBugKeys = __webpack_require__(88);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(157)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var hide = __webpack_require__(50);
	var has = __webpack_require__(75);
	var SRC = __webpack_require__(109)('src');
	var $toString = __webpack_require__(356);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(34).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(1048);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ }),
/* 62 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rgb = /*#__PURE__*/__webpack_require__(114);
	
	var _rgb2 = /*#__PURE__*/_interopRequireDefault(_rgb);
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(28);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
	 *
	 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: rgba(255, 205, 100, 0.7),
	 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
	 *   background: rgba(255, 205, 100, 1),
	 *   background: rgba('#ffffff', 0.4),
	 *   background: rgba('black', 0.7),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${rgba(255, 205, 100, 0.7)};
	 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
	 *   background: ${rgba(255, 205, 100, 1)};
	 *   background: ${rgba('#ffffff', 0.4)};
	 *   background: ${rgba('black', 0.7)};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "rgba(255,205,100,0.7)";
	 *   background: "rgba(255,205,100,0.7)";
	 *   background: "#ffcd64";
	 *   background: "rgba(255,255,255,0.4)";
	 *   background: "rgba(0,0,0,0.7)";
	 * }
	 */
	function rgba(firstValue, secondValue, thirdValue, fourthValue) {
	  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
	    var rgbValue = (0, _parseToRgb2.default)(firstValue);
	    return 'rgba(' + rgbValue.red + ',' + rgbValue.green + ',' + rgbValue.blue + ',' + secondValue + ')';
	  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
	    return fourthValue >= 1 ? (0, _rgb2.default)(firstValue, secondValue, thirdValue) : 'rgba(' + firstValue + ',' + secondValue + ',' + thirdValue + ',' + fourthValue + ')';
	  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
	    return firstValue.alpha >= 1 ? (0, _rgb2.default)(firstValue.red, firstValue.green, firstValue.blue) : 'rgba(' + firstValue.red + ',' + firstValue.green + ',' + firstValue.blue + ',' + firstValue.alpha + ')';
	  }
	
	  throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
	}
	
	exports.default = rgba;
	module.exports = exports['default'];

/***/ }),
/* 64 */,
/* 65 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(87);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(71);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var core = __webpack_require__(34);
	var hide = __webpack_require__(50);
	var redefine = __webpack_require__(60);
	var ctx = __webpack_require__(73);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(33);
	var IE8_DOM_DEFINE = __webpack_require__(357);
	var toPrimitive = __webpack_require__(375);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(57) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(386);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public","GATSBY_TELEMETRY_DISABLED":"1"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78)))

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.generatePath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(2025);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(2026);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(185);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(2027);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(2028);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(2029);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(2030);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(186);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(118);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(2031);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(2032);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _generatePath2 = __webpack_require__(2033);
	
	var _generatePath3 = _interopRequireDefault(_generatePath2);
	
	var _matchPath2 = __webpack_require__(2034);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(2035);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.generatePath = _generatePath3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Button = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _styledSystem = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = exports.Button = (0, _components2.default)({
	  is: 'button',
	  fontSize: 1,
	  fontWeight: 'bold',
	  lineHeight: 16 / 14,
	  m: 0,
	  px: 3,
	  py: 2,
	  color: 'white',
	  bg: 'blue',
	  borderRadius: 2,
	  border: 0
	}, function (props) {
	  return {
	    fontFamily: 'inherit',
	    WebkitFontSmoothing: 'antialiased',
	    display: 'inline-block',
	    verticalAlign: 'middle',
	    textAlign: 'center',
	    textDecoration: 'none',
	    appearance: 'none',
	    '&:disabled': {
	      opacity: 1 / 4
	    }
	  };
	}, function (props) {
	  return {
	    '&:focus': {
	      outline: 'none',
	      boxShadow: '0 0 0 2px ' + (0, _styledSystem.themeGet)('colors.' + props.bg, props.bg)(props)
	    }
	  };
	}, 'fontSize', 'fontWeight', 'lineHeight', 'space', 'color', 'borderRadius', 'borders');
	
	Button.displayName = 'Button';
	
	exports.default = Button;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	module.exports = function deprecate(fn, message) {
	  var warned = false;
	
	  function deprecated() {
	    if (!warned) {
	      /* eslint no-console:0 */
	      console.warn(message);
	      warned = true;
	    }
	
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

	module.exports = function deprecatedMessage(previousUsage, newUsage) {
	  var githubAnchorLink = previousUsage.toLowerCase()
	    .replace(/[\.\(\)]/g, '');
	
	  return 'algoliasearch: `' + previousUsage + '` was replaced by `' + newUsage +
	    '`. Please see https://github.com/algolia/algoliasearch-client-javascript/wiki/Deprecated#' + githubAnchorLink;
	};


/***/ }),
/* 83 */,
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  &:not(:last-child) {\n    margin-bottom: 24px;\n  }\n  * {\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n  p {\n    margin: 0;\n    margin-bottom: ", "px;\n    font-size: ", "px;\n    font-weight: 400;\n    line-height: 1.75;\n    color: ", ";\n    font-kerning: normal;\n    font-variant-ligatures: common-ligatures;\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    -webkit-hyphens: auto;\n    -ms-hyphens: auto;\n    -moz-hyphens: auto;\n    hyphens: auto;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n  li strong,\n  p strong,\n  p b {\n    font-weight: ", ";\n  }\n  li a,\n  p a {\n    color: ", ";\n    text-decoration: none;\n    box-shadow: inset 0 -1px 0 ", ";\n    transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n      box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: color, box-shadow;\n\n    &:hover {\n      color: #fff;\n      box-shadow: inset 0 -1.5em 0 ", ";\n    }\n    &:active {\n      color: #fff;\n      box-shadow: inset 0 -1.5em 0 ", ";\n    }\n  }\n  p.block-img img {\n    width: 50%;\n    margin: 0;\n    margin-left: ", "px;\n    margin-right: 0;\n    margin-bottom: ", "px;\n    float: right;\n    clear: right;\n\n    @media (max-width: 40em) {\n      width: 100%;\n      float: none;\n      clear: both;\n      margin-right: 0;\n      margin-left: 0;\n      margin-bottom: 0;\n    }\n  }\n  ul,\n  ol {\n    margin-bottom: ", "px;\n    font-size: ", "px;\n    color: ", ";\n  }\n  li {\n    margin-bottom: 8px;\n    line-height: 1.5;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n  pre {\n    width: 100%;\n    margin-bottom: ", "px;\n    padding: ", "px;\n    font-size: 14px;\n    background-color: ", ";\n    overflow: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    margin: 0;\n    margin-bottom: ", "px;\n    font-weight: 700;\n    line-height: 1.25;\n    letter-spacing: -0.025em;\n    color: ", ";\n    font-kerning: normal;\n\n    a {\n      color: ", ";\n      text-decoration: none;\n      box-shadow: inset 0 -1px 0 ", ";\n      transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n        box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n      will-change: color, box-shadow;\n\n      &:hover {\n        color: #fff;\n        box-shadow: inset 0 -1.5em 0 ", ";\n      }\n      &:active {\n        color: #fff;\n        box-shadow: inset 0 -1.5em 0 ", ";\n      }\n    }\n  }\n  h1 {\n    font-size: 30px;\n  }\n  h2 {\n    font-size: 24px;\n  }\n  h3 {\n    font-size: 20px;\n  }\n  h4 {\n    font-size: 16px;\n  }\n  h5 {\n    font-size: 14px;\n  }\n  h6 {\n    text-transform: uppercase;\n    letter-spacing: 0.075em;\n    font-size: 11px;\n  }\n  > *[data-oembed-type=\"video\"] {\n    position: relative;\n    width: 100%;\n    margin-bottom: 24px;\n    padding-bottom: ", ";\n    > iframe {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n  }\n"], ["\n  overflow: hidden;\n  &:not(:last-child) {\n    margin-bottom: 24px;\n  }\n  * {\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n  p {\n    margin: 0;\n    margin-bottom: ", "px;\n    font-size: ", "px;\n    font-weight: 400;\n    line-height: 1.75;\n    color: ", ";\n    font-kerning: normal;\n    font-variant-ligatures: common-ligatures;\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    -webkit-hyphens: auto;\n    -ms-hyphens: auto;\n    -moz-hyphens: auto;\n    hyphens: auto;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n  li strong,\n  p strong,\n  p b {\n    font-weight: ", ";\n  }\n  li a,\n  p a {\n    color: ", ";\n    text-decoration: none;\n    box-shadow: inset 0 -1px 0 ", ";\n    transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n      box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: color, box-shadow;\n\n    &:hover {\n      color: #fff;\n      box-shadow: inset 0 -1.5em 0 ", ";\n    }\n    &:active {\n      color: #fff;\n      box-shadow: inset 0 -1.5em 0 ", ";\n    }\n  }\n  p.block-img img {\n    width: 50%;\n    margin: 0;\n    margin-left: ", "px;\n    margin-right: 0;\n    margin-bottom: ", "px;\n    float: right;\n    clear: right;\n\n    @media (max-width: 40em) {\n      width: 100%;\n      float: none;\n      clear: both;\n      margin-right: 0;\n      margin-left: 0;\n      margin-bottom: 0;\n    }\n  }\n  ul,\n  ol {\n    margin-bottom: ", "px;\n    font-size: ", "px;\n    color: ", ";\n  }\n  li {\n    margin-bottom: 8px;\n    line-height: 1.5;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n  pre {\n    width: 100%;\n    margin-bottom: ", "px;\n    padding: ", "px;\n    font-size: 14px;\n    background-color: ", ";\n    overflow: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    margin: 0;\n    margin-bottom: ", "px;\n    font-weight: 700;\n    line-height: 1.25;\n    letter-spacing: -0.025em;\n    color: ", ";\n    font-kerning: normal;\n\n    a {\n      color: ", ";\n      text-decoration: none;\n      box-shadow: inset 0 -1px 0 ", ";\n      transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n        box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n      will-change: color, box-shadow;\n\n      &:hover {\n        color: #fff;\n        box-shadow: inset 0 -1.5em 0 ", ";\n      }\n      &:active {\n        color: #fff;\n        box-shadow: inset 0 -1.5em 0 ", ";\n      }\n    }\n  }\n  h1 {\n    font-size: 30px;\n  }\n  h2 {\n    font-size: 24px;\n  }\n  h3 {\n    font-size: 20px;\n  }\n  h4 {\n    font-size: 16px;\n  }\n  h5 {\n    font-size: 14px;\n  }\n  h6 {\n    text-transform: uppercase;\n    letter-spacing: 0.075em;\n    font-size: 11px;\n  }\n  > *[data-oembed-type=\"video\"] {\n    position: relative;\n    width: 100%;\n    margin-bottom: 24px;\n    padding-bottom: ", ";\n    > iframe {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _polished = __webpack_require__(8);
	
	var _rebass = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Article = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.space[4];
	}, function (props) {
	  return props.theme.fontSizes[2];
	}, function (props) {
	  return props.theme.colors.text;
	}, function (props) {
	  return props.theme.fontWeights.bold;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet && (0, _polished.shade)(0.75, props.theme.colors.violet);
	}, function (props) {
	  return props.theme.space[5];
	}, function (props) {
	  return props.theme.space[5];
	}, function (props) {
	  return props.theme.space[5];
	}, function (props) {
	  return props.theme.fontSizes[2];
	}, function (props) {
	  return props.theme.colors.text;
	}, function (props) {
	  return props.theme.space[5];
	}, function (props) {
	  return props.theme.space[5];
	}, function (props) {
	  return props.theme.colors.grey[1];
	}, function (props) {
	  return props.theme.space[4];
	}, function (props) {
	  return props.theme.colors.text;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet && (0, _polished.shade)(0.75, props.theme.colors.violet);
	}, 270 / 480 * 100 + "%");
	
	Article.defaultProps = {
	  is: "article"
	};
	
	exports.default = Article;
	module.exports = exports["default"];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(310);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(308);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(145);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(145);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(55);
	var dPs = __webpack_require__(333);
	var enumBugKeys = __webpack_require__(88);
	var IE_PROTO = __webpack_require__(93)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(148)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(327).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(47).f;
	var has = __webpack_require__(32);
	var TAG = __webpack_require__(49)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(94)('keys');
	var uid = __webpack_require__(70);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(22);
	var global = __webpack_require__(26);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(66) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(46);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(26);
	var core = __webpack_require__(22);
	var LIBRARY = __webpack_require__(66);
	var wksExt = __webpack_require__(98);
	var defineProperty = __webpack_require__(47).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(49);


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(72);
	var TAG = __webpack_require__(19)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(58);
	var document = __webpack_require__(18).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 102 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(71);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(76).f;
	var has = __webpack_require__(75);
	var TAG = __webpack_require__(19)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(106)('keys');
	var uid = __webpack_require__(109);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(34);
	var global = __webpack_require__(18);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(102) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 107 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(359);
	var defined = __webpack_require__(100);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 110 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 111 */,
/* 112 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rgba = /*#__PURE__*/__webpack_require__(63);
	
	var _rgba2 = /*#__PURE__*/_interopRequireDefault(_rgba);
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(28);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _curry = /*#__PURE__*/__webpack_require__(15);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Mixes two colors together by calculating the average of each of the RGB components.
	 *
	 * By default the weight is 0.5 meaning that half of the first color and half the second
	 * color should be used. Optionally the weight can be modified by providing a number
	 * as the first argument. 0.25 means that a quarter of the first color and three quarters
	 * of the second color should be used.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: mix(0.5, '#f00', '#00f')
	 *   background: mix(0.25, '#f00', '#00f')
	 *   background: mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${mix(0.5, '#f00', '#00f')};
	 *   background: ${mix(0.25, '#f00', '#00f')};
	 *   background: ${mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#7f007f";
	 *   background: "#3f00bf";
	 *   background: "rgba(63, 0, 191, 0.75)";
	 * }
	 */
	function mix() {
	  var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
	  var color = arguments[1];
	  var otherColor = arguments[2];
	
	  var parsedColor1 = (0, _parseToRgb2.default)(color);
	  var color1 = _extends({}, parsedColor1, {
	    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
	  });
	
	  var parsedColor2 = (0, _parseToRgb2.default)(otherColor);
	  var color2 = _extends({}, parsedColor2, {
	    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
	
	    // The formular is copied from the original Sass implementation:
	    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
	  });var alphaDelta = color1.alpha - color2.alpha;
	  var x = weight * 2 - 1;
	  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
	  var z = 1 + x * alphaDelta;
	  var weight1 = (y / z + 1) / 2.0;
	  var weight2 = 1 - weight1;
	
	  var mixedColor = {
	    red: Math.floor(color1.red * weight1 + color2.red * weight2),
	    green: Math.floor(color1.green * weight1 + color2.green * weight2),
	    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
	    alpha: color1.alpha + (color2.alpha - color1.alpha) * (weight / 1.0)
	  };
	
	  return (0, _rgba2.default)(mixedColor);
	}
	
	var curriedMix = /*#__PURE__*/(0, _curry2.default)(mix);
	exports.default = curriedMix;
	module.exports = exports['default'];

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduceHexValue = /*#__PURE__*/__webpack_require__(177);
	
	var _reduceHexValue2 = /*#__PURE__*/_interopRequireDefault(_reduceHexValue);
	
	var _numberToHex = /*#__PURE__*/__webpack_require__(175);
	
	var _numberToHex2 = /*#__PURE__*/_interopRequireDefault(_numberToHex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the color. The returned result is the smallest possible hex notation.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: rgb(255, 205, 100),
	 *   background: rgb({ red: 255, green: 205, blue: 100 }),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${rgb(255, 205, 100)};
	 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#ffcd64";
	 *   background: "#ffcd64";
	 * }
	 */
	function rgb(value, green, blue) {
	  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
	    return (0, _reduceHexValue2.default)('#' + (0, _numberToHex2.default)(value) + (0, _numberToHex2.default)(green) + (0, _numberToHex2.default)(blue));
	  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
	    return (0, _reduceHexValue2.default)('#' + (0, _numberToHex2.default)(value.red) + (0, _numberToHex2.default)(value.green) + (0, _numberToHex2.default)(value.blue));
	  }
	
	  throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
	}
	
	exports.default = rgb;
	module.exports = exports['default'];

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Strip the unit from a given CSS value, returning just the number. (or the original value if an invalid string was passed)
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   '--dimension': stripUnit('100px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   --dimension: ${stripUnit('100px')}
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   '--dimension': 100
	 * }
	 */
	
	function stripUnit(value) {
	  var unitlessValue = parseFloat(value);
	  if (isNaN(unitlessValue)) return value;
	  return unitlessValue;
	}
	
	exports.default = stripUnit;
	module.exports = exports["default"];

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function colorToInt(color) {
	  return Math.round(color * 255);
	}
	
	function convertToInt(red, green, blue) {
	  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
	}
	
	function hslToRgb(hue, saturation, lightness) {
	  var convert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : convertToInt;
	
	  if (saturation === 0) {
	    // achromatic
	    return convert(lightness, lightness, lightness);
	  }
	
	  // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
	  var huePrime = hue % 360 / 60;
	  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
	  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
	
	  var red = 0;
	  var green = 0;
	  var blue = 0;
	
	  if (huePrime >= 0 && huePrime < 1) {
	    red = chroma;
	    green = secondComponent;
	  } else if (huePrime >= 1 && huePrime < 2) {
	    red = secondComponent;
	    green = chroma;
	  } else if (huePrime >= 2 && huePrime < 3) {
	    green = chroma;
	    blue = secondComponent;
	  } else if (huePrime >= 3 && huePrime < 4) {
	    green = secondComponent;
	    blue = chroma;
	  } else if (huePrime >= 4 && huePrime < 5) {
	    red = secondComponent;
	    blue = chroma;
	  } else if (huePrime >= 5 && huePrime < 6) {
	    red = chroma;
	    blue = secondComponent;
	  }
	
	  var lightnessModification = lightness - chroma / 2;
	  var finalRed = red + lightnessModification;
	  var finalGreen = green + lightnessModification;
	  var finalBlue = blue + lightnessModification;
	  return convert(finalRed, finalGreen, finalBlue);
	}
	
	exports.default = hslToRgb;
	module.exports = exports["default"];

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(2043);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _reactFastCompare = __webpack_require__(1748);
	
	var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);
	
	var _HelmetUtils = __webpack_require__(2023);
	
	var _HelmetConstants = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _reactFastCompare2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} defer: true
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(119);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(30);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(27);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: "/",
	      url: "/",
	      params: {},
	      isExact: pathname === "/"
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, "A <Router> may have only one child element");
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, "You cannot change <Router history>");
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(189);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = "" + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var parent = arguments[2];
	
	  if (typeof options === "string") options = { path: options };
	
	  var _options = options,
	      path = _options.path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	
	  if (path == null) return parent;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.colors = exports.invertLuminance = exports.createColors = undefined;
	
	var _polished = __webpack_require__(8);
	
	var names = ['red', // 0
	'orange', // 30
	'yellow', // 60
	'lime', // 90
	'green', // 120
	'teal', // 150
	'cyan', // 180
	'blue', // 210
	'indigo', // 240
	'violet', // 270
	'fuchsia', // 300
	'pink', // 330
	'red'];
	
	var hueName = function hueName(h) {
	  var i = Math.round((h - 2) / 30);
	  var name = names[i];
	  return name;
	};
	
	var createHues = function createHues(h) {
	  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function (n) {
	    return Math.floor((h + n * 360 / 12) % 360);
	  });
	};
	
	var createColors = exports.createColors = function createColors(base) {
	  var colors = {
	    black: '#000',
	    white: '#fff',
	    darken: 'rgba(0, 0, 0, 0.25)',
	    gray: '#eee'
	  };
	
	  var _parseToHsl = (0, _polished.parseToHsl)(base),
	      hue = _parseToHsl.hue,
	      saturation = _parseToHsl.saturation,
	      lightness = _parseToHsl.lightness;
	
	  var hues = createHues(hue);
	  hues.forEach(function (h) {
	    var name = hueName(h);
	    colors[name] = (0, _polished.hsl)(h, saturation, lightness);
	  });
	
	  return colors;
	};
	
	var invertLuminance = exports.invertLuminance = function invertLuminance(base) {
	  var luminance = (0, _polished.getLuminance)(base);
	
	  var _parseToHsl2 = (0, _polished.parseToHsl)(base),
	      hue = _parseToHsl2.hue,
	      saturation = _parseToHsl2.saturation;
	
	  return (0, _polished.hsl)(hue, saturation, 1 - luminance);
	};
	
	var colors = exports.colors = createColors('#06e');
	
	exports.default = colors;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shadows = exports.fonts = exports.radii = exports.colors = exports.fontWeights = exports.fontSizes = exports.space = exports.breakpoints = undefined;
	
	var _colors = __webpack_require__(121);
	
	Object.defineProperty(exports, 'colors', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_colors).default;
	  }
	});
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var breakpoints = exports.breakpoints = [32, 48, 64, 80].map(function (n) {
	  return n + 'em';
	});
	
	var space = exports.space = [0, 4, 8, 16, 32, 64, 128];
	
	var fontSizes = exports.fontSizes = [12, 14, 16, 20, 24, 32, 48, 64, 72, 96];
	
	var fontWeights = exports.fontWeights = {
	  normal: 400,
	  bold: 700
	};
	
	var radii = exports.radii = [0, 2, 4];
	
	var fonts = exports.fonts = {
	  0: 'system-ui, sans-serif',
	  sans: 'system-ui, sans-serif',
	  mono: '"SF Mono", "Roboto Mono", Menlo, monospace'
	};
	
	var shadows = exports.shadows = ['none', 'inset 0 0 0 1px ' + _colors2.default.gray, 'inset 0 0 0 1px ' + _colors2.default.gray + ', 0 0 4px ' + _colors2.default.gray];
	
	exports.default = {
	  breakpoints: breakpoints,
	  space: space,
	  fontSizes: fontSizes,
	  fontWeights: fontWeights,
	  fonts: fonts,
	  colors: _colors2.default,
	  radii: radii,
	  shadows: shadows
	};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.complexStyle = exports.themeGet = exports.pseudoStyle = exports.responsiveStyle = exports.style = exports.cloneFunc = exports.getValue = exports.merge = exports.media = exports.dec = exports.breaks = exports.fallbackTheme = exports.mq = exports.get = exports.getWidth = exports.arr = exports.neg = exports.px = exports.num = exports.is = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(198);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var propTypes = {
	  responsive: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]),
	  numberOrString: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	};
	
	var is = exports.is = function is(n) {
	  return n !== undefined && n !== null;
	};
	var num = exports.num = function num(n) {
	  return typeof n === 'number' && !isNaN(n);
	};
	var px = exports.px = function px(n) {
	  return num(n) ? n + 'px' : n;
	};
	var neg = exports.neg = function neg(n) {
	  return n < 0;
	};
	var arr = exports.arr = function arr(n) {
	  return Array.isArray(n) ? n : [n];
	};
	
	var getWidth = exports.getWidth = function getWidth(n) {
	  return !num(n) || n > 1 ? px(n) : n * 100 + '%';
	};
	var get = exports.get = function get(obj, path, fallback) {
	  return path.split('.').reduce(function (a, b) {
	    return a && a[b] ? a[b] : null;
	  }, obj) || fallback;
	};
	
	var mq = exports.mq = function mq(n) {
	  return '@media screen and (min-width: ' + px(n) + ')';
	};
	
	var fallbackTheme = exports.fallbackTheme = function fallbackTheme(props) {
	  return _extends({}, _constants2.default, get(props, 'theme'));
	};
	
	var breaks = exports.breaks = function breaks(props) {
	  return [null].concat(_toConsumableArray(get(props, 'theme.breakpoints', _constants.breakpoints).map(mq)));
	};
	
	var dec = exports.dec = function dec(props) {
	  return function (val) {
	    return arr(props).reduce(function (acc, prop) {
	      return acc[prop] = val, acc;
	    }, {});
	  };
	};
	
	var media = exports.media = function media(bp) {
	  return function (d, i) {
	    return is(d) ? bp[i] ? _defineProperty({}, bp[i], d) : d : null;
	  };
	};
	
	var merge = exports.merge = function merge(a, b) {
	  return Object.assign({}, a, b, Object.keys(b || {}).reduce(function (obj, key) {
	    return Object.assign(obj, _defineProperty({}, key, a[key] !== null && _typeof(a[key]) === 'object' ? merge(a[key], b[key]) : b[key]));
	  }, {}));
	};
	
	var getValue = exports.getValue = function getValue(val, getter, toPx) {
	  return typeof getter === 'function' ? getter(val) : toPx ? px(val) : val;
	};
	
	var cloneFunc = exports.cloneFunc = function cloneFunc(fn) {
	  return function () {
	    return fn.apply(undefined, arguments);
	  };
	};
	
	var style = exports.style = function style(_ref2) {
	  var prop = _ref2.prop,
	      cssProperty = _ref2.cssProperty,
	      alias = _ref2.alias,
	      key = _ref2.key,
	      getter = _ref2.getter,
	      numberToPx = _ref2.numberToPx;
	
	  var fn = function fn(props) {
	    cssProperty = cssProperty || prop;
	    var n = is(props[prop]) ? props[prop] : props[alias];
	    var th = fallbackTheme(props);
	    if (!is(n)) return null;
	    var value = getValue(get(th, [key, n].join('.'), n), getter, numberToPx);
	
	    return _defineProperty({}, cssProperty, value);
	  };
	  fn.propTypes = _defineProperty({}, prop, cloneFunc(propTypes.numberOrString));
	  if (alias) {
	    fn.propTypes[alias] = propTypes.numberOrString;
	  }
	  fn.propTypes[prop].meta = {
	    prop: prop,
	    themeKey: key,
	    styleType: 'default'
	  };
	  return fn;
	};
	
	var responsiveStyle = exports.responsiveStyle = function responsiveStyle(_ref4) {
	  var prop = _ref4.prop,
	      cssProperty = _ref4.cssProperty,
	      alias = _ref4.alias,
	      key = _ref4.key,
	      getter = _ref4.getter,
	      numberToPx = _ref4.numberToPx;
	
	  var fn = function fn(props) {
	    cssProperty = cssProperty || prop;
	    var n = is(props[prop]) ? props[prop] : props[alias];
	    if (!is(n)) return null;
	
	    var bp = breaks(props);
	    var th = fallbackTheme(props);
	    var sx = function sx(n) {
	      return getValue(get(th, [key || prop, n].join('.'), n), getter, numberToPx);
	    };
	
	    if (!Array.isArray(n)) {
	      return _defineProperty({}, cssProperty, sx(n));
	    }
	
	    var val = arr(n);
	    return val.map(sx).map(dec(cssProperty)).map(media(bp)).reduce(merge, {});
	  };
	
	  // add propTypes object to returned function
	  fn.propTypes = _defineProperty({}, prop, cloneFunc(propTypes.responsive));
	  if (alias) {
	    fn.propTypes[alias] = propTypes.responsive;
	  }
	
	  fn.propTypes[prop].meta = {
	    prop: prop,
	    themeKey: key,
	    responsive: true,
	    styleType: 'responsive'
	  };
	
	  return fn;
	};
	
	var pseudoStyle = exports.pseudoStyle = function pseudoStyle(_ref6) {
	  var prop = _ref6.prop,
	      alias = _ref6.alias,
	      pseudoclass = _ref6.pseudoclass,
	      _ref6$keys = _ref6.keys,
	      keys = _ref6$keys === undefined ? {} : _ref6$keys,
	      _ref6$getters = _ref6.getters,
	      getters = _ref6$getters === undefined ? {} : _ref6$getters,
	      _ref6$numberToPx = _ref6.numberToPx,
	      numberToPx = _ref6$numberToPx === undefined ? {} : _ref6$numberToPx;
	
	  var fn = function fn(props) {
	    var style = props[prop] || props[alias];
	    pseudoclass = pseudoclass || prop;
	    var th = fallbackTheme(props);
	    for (var key in style) {
	      var toPx = numberToPx[key];
	      if (!keys[key] && !getters[key] && !toPx) continue;
	      var themeKey = [keys[key], style[key]].join('.');
	      style[key] = getValue(get(th, themeKey, style[key]), getters[key], toPx);
	    }
	
	    return _defineProperty({}, '&:' + pseudoclass, style);
	  };
	  fn.propTypes = _defineProperty({}, prop, cloneFunc(_propTypes2.default.object));
	
	  fn.propTypes[prop].meta = {
	    prop: prop,
	    pseudo: true,
	    styleType: 'pseudo'
	  };
	  return fn;
	};
	
	// todo: consider alternative names
	var themeGet = exports.themeGet = function themeGet(keys, fallback) {
	  return function (props) {
	    return get(props.theme, keys, fallback);
	  };
	};
	
	var getBooleans = function getBooleans(props) {
	  var bools = [];
	  for (var key in props) {
	    if (props[key] !== true) continue;
	    bools.push(key);
	  }
	  return bools;
	};
	
	var complexStyle = exports.complexStyle = function complexStyle(_ref8) {
	  var prop = _ref8.prop,
	      key = _ref8.key,
	      alias = _ref8.alias;
	
	  var fn = function fn(props) {
	    var style = get(props, ['theme', key, get(props, prop, props[alias])].join('.'), {});
	    var bools = getBooleans(props);
	    bools.forEach(function (name) {
	      style = _extends({}, style, get(props, ['theme', key, name].join('.'), {}));
	    });
	    return style;
	  };
	
	  fn.propTypes = _defineProperty({}, prop, _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]));
	
	  if (alias) {
	    fn.propTypes[alias] = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]);
	  }
	
	  fn.propTypes[prop].meta = {
	    prop: prop,
	    themeKey: key,
	    complex: true,
	    styleType: 'complex'
	  };
	
	  return fn;
	};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var buildSearchMethod = __webpack_require__(126);
	var deprecate = __webpack_require__(81);
	var deprecatedMessage = __webpack_require__(82);
	
	module.exports = IndexCore;
	
	/*
	* Index class constructor.
	* You should not use this method directly but use initIndex() function
	*/
	function IndexCore(algoliasearch, indexName) {
	  this.indexName = indexName;
	  this.as = algoliasearch;
	  this.typeAheadArgs = null;
	  this.typeAheadValueOption = null;
	
	  // make sure every index instance has it's own cache
	  this.cache = {};
	}
	
	/*
	* Clear all queries in cache
	*/
	IndexCore.prototype.clearCache = function() {
	  this.cache = {};
	};
	
	/*
	* Search inside the index using XMLHttpRequest request (Using a POST query to
	* minimize number of OPTIONS queries: Cross-Origin Resource Sharing).
	*
	* @param {string} [query] the full text query
	* @param {object} [args] (optional) if set, contains an object with query parameters:
	* - page: (integer) Pagination parameter used to select the page to retrieve.
	*                   Page is zero-based and defaults to 0. Thus,
	*                   to retrieve the 10th page you need to set page=9
	* - hitsPerPage: (integer) Pagination parameter used to select the number of hits per page. Defaults to 20.
	* - attributesToRetrieve: a string that contains the list of object attributes
	* you want to retrieve (let you minimize the answer size).
	*   Attributes are separated with a comma (for example "name,address").
	*   You can also use an array (for example ["name","address"]).
	*   By default, all attributes are retrieved. You can also use '*' to retrieve all
	*   values when an attributesToRetrieve setting is specified for your index.
	* - attributesToHighlight: a string that contains the list of attributes you
	*   want to highlight according to the query.
	*   Attributes are separated by a comma. You can also use an array (for example ["name","address"]).
	*   If an attribute has no match for the query, the raw value is returned.
	*   By default all indexed text attributes are highlighted.
	*   You can use `*` if you want to highlight all textual attributes.
	*   Numerical attributes are not highlighted.
	*   A matchLevel is returned for each highlighted attribute and can contain:
	*      - full: if all the query terms were found in the attribute,
	*      - partial: if only some of the query terms were found,
	*      - none: if none of the query terms were found.
	* - attributesToSnippet: a string that contains the list of attributes to snippet alongside
	* the number of words to return (syntax is `attributeName:nbWords`).
	*    Attributes are separated by a comma (Example: attributesToSnippet=name:10,content:10).
	*    You can also use an array (Example: attributesToSnippet: ['name:10','content:10']).
	*    By default no snippet is computed.
	* - minWordSizefor1Typo: the minimum number of characters in a query word to accept one typo in this word.
	* Defaults to 3.
	* - minWordSizefor2Typos: the minimum number of characters in a query word
	* to accept two typos in this word. Defaults to 7.
	* - getRankingInfo: if set to 1, the result hits will contain ranking
	* information in _rankingInfo attribute.
	* - aroundLatLng: search for entries around a given
	* latitude/longitude (specified as two floats separated by a comma).
	*   For example aroundLatLng=47.316669,5.016670).
	*   You can specify the maximum distance in meters with the aroundRadius parameter (in meters)
	*   and the precision for ranking with aroundPrecision
	*   (for example if you set aroundPrecision=100, two objects that are distant of
	*   less than 100m will be considered as identical for "geo" ranking parameter).
	*   At indexing, you should specify geoloc of an object with the _geoloc attribute
	*   (in the form {"_geoloc":{"lat":48.853409, "lng":2.348800}})
	* - insideBoundingBox: search entries inside a given area defined by the two extreme points
	* of a rectangle (defined by 4 floats: p1Lat,p1Lng,p2Lat,p2Lng).
	*   For example insideBoundingBox=47.3165,4.9665,47.3424,5.0201).
	*   At indexing, you should specify geoloc of an object with the _geoloc attribute
	*   (in the form {"_geoloc":{"lat":48.853409, "lng":2.348800}})
	* - numericFilters: a string that contains the list of numeric filters you want to
	* apply separated by a comma.
	*   The syntax of one filter is `attributeName` followed by `operand` followed by `value`.
	*   Supported operands are `<`, `<=`, `=`, `>` and `>=`.
	*   You can have multiple conditions on one attribute like for example numericFilters=price>100,price<1000.
	*   You can also use an array (for example numericFilters: ["price>100","price<1000"]).
	* - tagFilters: filter the query by a set of tags. You can AND tags by separating them by commas.
	*   To OR tags, you must add parentheses. For example, tags=tag1,(tag2,tag3) means tag1 AND (tag2 OR tag3).
	*   You can also use an array, for example tagFilters: ["tag1",["tag2","tag3"]]
	*   means tag1 AND (tag2 OR tag3).
	*   At indexing, tags should be added in the _tags** attribute
	*   of objects (for example {"_tags":["tag1","tag2"]}).
	* - facetFilters: filter the query by a list of facets.
	*   Facets are separated by commas and each facet is encoded as `attributeName:value`.
	*   For example: `facetFilters=category:Book,author:John%20Doe`.
	*   You can also use an array (for example `["category:Book","author:John%20Doe"]`).
	* - facets: List of object attributes that you want to use for faceting.
	*   Comma separated list: `"category,author"` or array `['category','author']`
	*   Only attributes that have been added in **attributesForFaceting** index setting
	*   can be used in this parameter.
	*   You can also use `*` to perform faceting on all attributes specified in **attributesForFaceting**.
	* - queryType: select how the query words are interpreted, it can be one of the following value:
	*    - prefixAll: all query words are interpreted as prefixes,
	*    - prefixLast: only the last word is interpreted as a prefix (default behavior),
	*    - prefixNone: no query word is interpreted as a prefix. This option is not recommended.
	* - optionalWords: a string that contains the list of words that should
	* be considered as optional when found in the query.
	*   Comma separated and array are accepted.
	* - distinct: If set to 1, enable the distinct feature (disabled by default)
	* if the attributeForDistinct index setting is set.
	*   This feature is similar to the SQL "distinct" keyword: when enabled
	*   in a query with the distinct=1 parameter,
	*   all hits containing a duplicate value for the attributeForDistinct attribute are removed from results.
	*   For example, if the chosen attribute is show_name and several hits have
	*   the same value for show_name, then only the best
	*   one is kept and others are removed.
	* - restrictSearchableAttributes: List of attributes you want to use for
	* textual search (must be a subset of the attributesToIndex index setting)
	* either comma separated or as an array
	* @param {function} [callback] the result callback called with two arguments:
	*  error: null or Error('message'). If false, the content contains the error.
	*  content: the server answer that contains the list of results.
	*/
	IndexCore.prototype.search = buildSearchMethod('query');
	
	/*
	* -- BETA --
	* Search a record similar to the query inside the index using XMLHttpRequest request (Using a POST query to
	* minimize number of OPTIONS queries: Cross-Origin Resource Sharing).
	*
	* @param {string} [query] the similar query
	* @param {object} [args] (optional) if set, contains an object with query parameters.
	*   All search parameters are supported (see search function), restrictSearchableAttributes and facetFilters
	*   are the two most useful to restrict the similar results and get more relevant content
	*/
	IndexCore.prototype.similarSearch = deprecate(
	  buildSearchMethod('similarQuery'),
	  deprecatedMessage(
	    'index.similarSearch(query[, callback])',
	    'index.search({ similarQuery: query }[, callback])'
	  )
	);
	
	/*
	* Browse index content. The response content will have a `cursor` property that you can use
	* to browse subsequent pages for this query. Use `index.browseFrom(cursor)` when you want.
	*
	* @param {string} query - The full text query
	* @param {Object} [queryParameters] - Any search query parameter
	* @param {Function} [callback] - The result callback called with two arguments
	*   error: null or Error('message')
	*   content: the server answer with the browse result
	* @return {Promise|undefined} Returns a promise if no callback given
	* @example
	* index.browse('cool songs', {
	*   tagFilters: 'public,comments',
	*   hitsPerPage: 500
	* }, callback);
	* @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
	*/
	IndexCore.prototype.browse = function(query, queryParameters, callback) {
	  var merge = __webpack_require__(128);
	
	  var indexObj = this;
	
	  var page;
	  var hitsPerPage;
	
	  // we check variadic calls that are not the one defined
	  // .browse()/.browse(fn)
	  // => page = 0
	  if (arguments.length === 0 || arguments.length === 1 && typeof arguments[0] === 'function') {
	    page = 0;
	    callback = arguments[0];
	    query = undefined;
	  } else if (typeof arguments[0] === 'number') {
	    // .browse(2)/.browse(2, 10)/.browse(2, fn)/.browse(2, 10, fn)
	    page = arguments[0];
	    if (typeof arguments[1] === 'number') {
	      hitsPerPage = arguments[1];
	    } else if (typeof arguments[1] === 'function') {
	      callback = arguments[1];
	      hitsPerPage = undefined;
	    }
	    query = undefined;
	    queryParameters = undefined;
	  } else if (typeof arguments[0] === 'object') {
	    // .browse(queryParameters)/.browse(queryParameters, cb)
	    if (typeof arguments[1] === 'function') {
	      callback = arguments[1];
	    }
	    queryParameters = arguments[0];
	    query = undefined;
	  } else if (typeof arguments[0] === 'string' && typeof arguments[1] === 'function') {
	    // .browse(query, cb)
	    callback = arguments[1];
	    queryParameters = undefined;
	  }
	
	  // otherwise it's a .browse(query)/.browse(query, queryParameters)/.browse(query, queryParameters, cb)
	
	  // get search query parameters combining various possible calls
	  // to .browse();
	  queryParameters = merge({}, queryParameters || {}, {
	    page: page,
	    hitsPerPage: hitsPerPage,
	    query: query
	  });
	
	  var params = this.as._getSearchParams(queryParameters, '');
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/browse',
	    body: {params: params},
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	* Continue browsing from a previous position (cursor), obtained via a call to `.browse()`.
	*
	* @param {string} query - The full text query
	* @param {Object} [queryParameters] - Any search query parameter
	* @param {Function} [callback] - The result callback called with two arguments
	*   error: null or Error('message')
	*   content: the server answer with the browse result
	* @return {Promise|undefined} Returns a promise if no callback given
	* @example
	* index.browseFrom('14lkfsakl32', callback);
	* @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
	*/
	IndexCore.prototype.browseFrom = function(cursor, callback) {
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/browse',
	    body: {cursor: cursor},
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	* Search for facet values
	* https://www.algolia.com/doc/rest-api/search#search-for-facet-values
	*
	* @param {string} params.facetName Facet name, name of the attribute to search for values in.
	* Must be declared as a facet
	* @param {string} params.facetQuery Query for the facet search
	* @param {string} [params.*] Any search parameter of Algolia,
	* see https://www.algolia.com/doc/api-client/javascript/search#search-parameters
	* Pagination is not supported. The page and hitsPerPage parameters will be ignored.
	* @param callback (optional)
	*/
	IndexCore.prototype.searchForFacetValues = function(params, callback) {
	  var clone = __webpack_require__(25);
	  var omit = __webpack_require__(129);
	  var usage = 'Usage: index.searchForFacetValues({facetName, facetQuery, ...params}[, callback])';
	
	  if (params.facetName === undefined || params.facetQuery === undefined) {
	    throw new Error(usage);
	  }
	
	  var facetName = params.facetName;
	  var filteredParams = omit(clone(params), function(keyName) {
	    return keyName === 'facetName';
	  });
	  var searchParameters = this.as._getSearchParams(filteredParams, '');
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' +
	      encodeURIComponent(this.indexName) + '/facets/' + encodeURIComponent(facetName) + '/query',
	    hostType: 'read',
	    body: {params: searchParameters},
	    callback: callback
	  });
	};
	
	IndexCore.prototype.searchFacet = deprecate(function(params, callback) {
	  return this.searchForFacetValues(params, callback);
	}, deprecatedMessage(
	  'index.searchFacet(params[, callback])',
	  'index.searchForFacetValues(params[, callback])'
	));
	
	IndexCore.prototype._search = function(params, url, callback, additionalUA) {
	  return this.as._jsonRequest({
	    cache: this.cache,
	    method: 'POST',
	    url: url || '/1/indexes/' + encodeURIComponent(this.indexName) + '/query',
	    body: {params: params},
	    hostType: 'read',
	    fallback: {
	      method: 'GET',
	      url: '/1/indexes/' + encodeURIComponent(this.indexName),
	      body: {params: params}
	    },
	    callback: callback,
	    additionalUA: additionalUA
	  });
	};
	
	/*
	* Get an object from this index
	*
	* @param objectID the unique identifier of the object to retrieve
	* @param attrs (optional) if set, contains the array of attribute names to retrieve
	* @param callback (optional) the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the object to retrieve or the error message if a failure occurred
	*/
	IndexCore.prototype.getObject = function(objectID, attrs, callback) {
	  var indexObj = this;
	
	  if (arguments.length === 1 || typeof attrs === 'function') {
	    callback = attrs;
	    attrs = undefined;
	  }
	
	  var params = '';
	  if (attrs !== undefined) {
	    params = '?attributes=';
	    for (var i = 0; i < attrs.length; ++i) {
	      if (i !== 0) {
	        params += ',';
	      }
	      params += attrs[i];
	    }
	  }
	
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(objectID) + params,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	* Get several objects from this index
	*
	* @param objectIDs the array of unique identifier of objects to retrieve
	*/
	IndexCore.prototype.getObjects = function(objectIDs, attributesToRetrieve, callback) {
	  var isArray = __webpack_require__(14);
	  var map = __webpack_require__(40);
	
	  var usage = 'Usage: index.getObjects(arrayOfObjectIDs[, callback])';
	
	  if (!isArray(objectIDs)) {
	    throw new Error(usage);
	  }
	
	  var indexObj = this;
	
	  if (arguments.length === 1 || typeof attributesToRetrieve === 'function') {
	    callback = attributesToRetrieve;
	    attributesToRetrieve = undefined;
	  }
	
	  var body = {
	    requests: map(objectIDs, function prepareRequest(objectID) {
	      var request = {
	        indexName: indexObj.indexName,
	        objectID: objectID
	      };
	
	      if (attributesToRetrieve) {
	        request.attributesToRetrieve = attributesToRetrieve.join(',');
	      }
	
	      return request;
	    })
	  };
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/*/objects',
	    hostType: 'read',
	    body: body,
	    callback: callback
	  });
	};
	
	IndexCore.prototype.as = null;
	IndexCore.prototype.indexName = null;
	IndexCore.prototype.typeAheadArgs = null;
	IndexCore.prototype.typeAheadValueOption = null;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var AlgoliaSearch = __webpack_require__(203);
	var createAlgoliasearch = __webpack_require__(207);
	
	module.exports = createAlgoliasearch(AlgoliaSearch, 'Browser');


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = buildSearchMethod;
	
	var errors = __webpack_require__(39);
	
	/**
	 * Creates a search method to be used in clients
	 * @param {string} queryParam the name of the attribute used for the query
	 * @param {string} url the url
	 * @return {function} the search method
	 */
	function buildSearchMethod(queryParam, url) {
	  /**
	   * The search method. Prepares the data and send the query to Algolia.
	   * @param {string} query the string used for query search
	   * @param {object} args additional parameters to send with the search
	   * @param {function} [callback] the callback to be called with the client gets the answer
	   * @return {undefined|Promise} If the callback is not provided then this methods returns a Promise
	   */
	  return function search(query, args, callback) {
	    // warn V2 users on how to search
	    if (typeof query === 'function' && typeof args === 'object' ||
	      typeof callback === 'object') {
	      // .search(query, params, cb)
	      // .search(cb, params)
	      throw new errors.AlgoliaSearchError('index.search usage is index.search(query, params, cb)');
	    }
	
	    // Normalizing the function signature
	    if (arguments.length === 0 || typeof query === 'function') {
	      // Usage : .search(), .search(cb)
	      callback = query;
	      query = '';
	    } else if (arguments.length === 1 || typeof args === 'function') {
	      // Usage : .search(query/args), .search(query, cb)
	      callback = args;
	      args = undefined;
	    }
	    // At this point we have 3 arguments with values
	
	    // Usage : .search(args) // careful: typeof null === 'object'
	    if (typeof query === 'object' && query !== null) {
	      args = query;
	      query = undefined;
	    } else if (query === undefined || query === null) { // .search(undefined/null)
	      query = '';
	    }
	
	    var params = '';
	
	    if (query !== undefined) {
	      params += queryParam + '=' + encodeURIComponent(query);
	    }
	
	    var additionalUA;
	    if (args !== undefined) {
	      if (args.additionalUA) {
	        additionalUA = args.additionalUA;
	        delete args.additionalUA;
	      }
	      // `_getSearchParams` will augment params, do not be fooled by the = versus += from previous if
	      params = this.as._getSearchParams(args, params);
	    }
	
	
	    return this._search(params, url, callback, additionalUA);
	  };
	}


/***/ }),
/* 127 */
/***/ (function(module, exports) {

	// Parse cloud does not supports setTimeout
	// We do not store a setTimeout reference in the client everytime
	// We only fallback to a fake setTimeout when not available
	// setTimeout cannot be override globally sadly
	module.exports = function exitPromise(fn, _setTimeout) {
	  _setTimeout(fn, 0);
	};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var foreach = __webpack_require__(51);
	
	module.exports = function merge(destination/* , sources */) {
	  var sources = Array.prototype.slice.call(arguments);
	
	  foreach(sources, function(source) {
	    for (var keyName in source) {
	      if (source.hasOwnProperty(keyName)) {
	        if (typeof destination[keyName] === 'object' && typeof source[keyName] === 'object') {
	          destination[keyName] = merge({}, destination[keyName], source[keyName]);
	        } else if (source[keyName] !== undefined) {
	          destination[keyName] = source[keyName];
	        }
	      }
	    }
	  });
	
	  return destination;
	};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function omit(obj, test) {
	  var keys = __webpack_require__(1693);
	  var foreach = __webpack_require__(51);
	
	  var filtered = {};
	
	  foreach(keys(obj), function doFilter(keyName) {
	    if (test(keyName) !== true) {
	      filtered[keyName] = obj[keyName];
	    }
	  });
	
	  return filtered;
	};


/***/ }),
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  &:not(:lang(ar)) {\n    padding-left: 32px;\n    border-left: 1px solid ", ";\n  }\n  &:lang(ar) {\n    padding-right: 32px;\n    border-right: 1px solid ", ";\n  }\n"], ["\n  &:not(:lang(ar)) {\n    padding-left: 32px;\n    border-left: 1px solid ", ";\n  }\n  &:lang(ar) {\n    padding-right: 32px;\n    border-right: 1px solid ", ";\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  font-weight: 400;\n  color: ", ";\n  color: ", ";\n  line-height: 1.25;\n\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  font-weight: 400;\n  color: ", ";\n  color: ", ";\n  line-height: 1.25;\n\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n  font-size: 14px;\n  font-weight: 600;\n  color: ", ";\n  line-height: 1.5;\n\n  &:before {\n    content: ", ";\n  }\n\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  margin-top: 16px;\n  font-size: 14px;\n  font-weight: 600;\n  color: ", ";\n  line-height: 1.5;\n\n  &:before {\n    content: ", ";\n  }\n\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(4);
	
	var _Text = __webpack_require__(17);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	});
	
	Wrapper.defaultProps = {
	  is: "figure",
	  mx: [0, 7],
	  my: [5, 7]
	};
	
	var Quote = (0, _styledComponents2.default)(_Text2.default)(_templateObject2, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.violet;
	});
	
	Quote.defaultProps = {
	  is: "blockquote",
	  fontSize: [4, 5]
	};
	
	var Attribution = (0, _styledComponents2.default)(_Text2.default)(_templateObject3, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.attribution ? "— " : "";
	}, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.violet;
	});
	
	Attribution.defaultProps = {
	  is: "figcaption"
	};
	
	var BlockQuote = function BlockQuote(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(Quote, { children: props.quote }),
	    _react2.default.createElement(Attribution, { children: props.attribution })
	  );
	};
	
	BlockQuote.defaultProps = {};
	
	exports.default = BlockQuote;
	module.exports = exports["default"];

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  ", ";\n  background: transparent;\n  border: ", ";\n  border-color: ", ";\n  cursor: pointer;\n  transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    background-color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    border-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: color, background-color;\n  user-select: none;\n\n  &:hover {\n    color: #fff;\n    background: ", ";\n    border-color: ", ";\n  }\n\n  &:focus {\n    color: #fff;\n    background: ", ";\n    border-color: ", ";\n    outline: 4px solid\n      ", ";\n    box-shadow: none;\n  }\n\n  &:active {\n    color: #fff;\n    background: ", ";\n    border-color: ", ";\n  }\n"], ["\n  color: ", ";\n  ", ";\n  background: transparent;\n  border: ", ";\n  border-color: ", ";\n  cursor: pointer;\n  transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    background-color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    border-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: color, background-color;\n  user-select: none;\n\n  &:hover {\n    color: #fff;\n    background: ", ";\n    border-color: ", ";\n  }\n\n  &:focus {\n    color: #fff;\n    background: ", ";\n    border-color: ", ";\n    outline: 4px solid\n      ", ";\n    box-shadow: none;\n  }\n\n  &:active {\n    color: #fff;\n    background: ", ";\n    border-color: ", ";\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(8);
	
	var _rebass = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var PrimaryButton = (0, _styledComponents2.default)(_rebass.Button)(_templateObject, function (props) {
	  return props.theme.colors.grey[0];
	}, (0, _polished.ellipsis)(), function (props) {
	  return props.theme.borders[1];
	}, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.text && (0, _polished.rgba)(props.theme.colors.violet, 0.5);
	}, function (props) {
	  return props.theme.colors.text && (0, _polished.shade)(0.875, props.theme.colors.violet);
	}, function (props) {
	  return props.theme.colors.text && (0, _polished.shade)(0.875, props.theme.colors.violet);
	});
	
	PrimaryButton.defaultProps = {
	  is: "button",
	  m: 0,
	  px: 16,
	  py: 13,
	  fontSize: 16,
	  fontWeight: "normal",
	  lineHeight: 0,
	  borderRadius: 0
	};
	
	exports.default = PrimaryButton;
	module.exports = exports["default"];

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: 100%;\n  background-color: ", ";\n  &:not(:lang(ar)) {\n    &:before,\n    &:after {\n      right: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n  &:lang(ar) {\n    &:before,\n    &:after {\n      left: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n    background-image: ", ";\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    filter: grayscale(1);\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n  }\n"], ["\n  position: relative;\n  height: 100%;\n  background-color: ", ";\n  &:not(:lang(ar)) {\n    &:before,\n    &:after {\n      right: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n  &:lang(ar) {\n    &:before,\n    &:after {\n      left: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n    background-image: ", ";\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    filter: grayscale(1);\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  z-index: 1;\n  height: 100%;\n"], ["\n  position: relative;\n  z-index: 1;\n  height: 100%;\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _polished = __webpack_require__(8);
	
	var _rebass = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.noColor ? "" : props.theme.colors.grey[1];
	}, function (props) {
	  return props.noColor ? "" : props.theme.colors.grey[1] && "linear-gradient(to right, " + (0, _polished.rgba)(props.theme.colors.grey[1], 1) + ", " + (0, _polished.rgba)(props.theme.colors.grey[1], 0.75) + ")";
	}, function (props) {
	  return props.noColor ? "" : props.theme.colors.grey[1] && "linear-gradient(to left, " + (0, _polished.rgba)(props.theme.colors.grey[1], 1) + ", " + (0, _polished.rgba)(props.theme.colors.grey[1], 0.75) + ")";
	}, function (props) {
	  return "url(" + props.image + ")";
	});
	
	var Container = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2);
	
	var GradientCard = function GradientCard(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    {
	      className: props.className,
	      noColor: props.noColor,
	      style: props.style,
	      image: props.image,
	      px: 4,
	      py: 5
	    },
	    _react2.default.createElement(
	      Container,
	      { className: "gradient-card__container" },
	      props.children
	    )
	  );
	};
	
	GradientCard.defaultProps = {};
	
	exports.default = GradientCard;
	module.exports = exports["default"];

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  background-color: ", ";\n  overflow: hidden;\n"], ["\n  position: relative;\n  background-color: ", ";\n  overflow: hidden;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 0;\n  width: 75%;\n  height: 100%;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  filter: grayscale(1);\n  user-select: none;\n\n  /* Fallback */\n  background-image: ", ";\n\n  /* Webkit fallback */\n  background-image: ", ";\n\n  /* Regular imageset */\n  background-image: ", ";\n\n  @media (min-width: 52em) {\n    /* Fallback */\n    background-image: ", ";\n\n    /* Webkit fallback */\n    background-image: ", ";\n\n    /* Regular imageset */\n    background-image: ", ";\n  }\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    background-image: ", ";\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 0;\n  width: 75%;\n  height: 100%;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  filter: grayscale(1);\n  user-select: none;\n\n  /* Fallback */\n  background-image: ", ";\n\n  /* Webkit fallback */\n  background-image: ", ";\n\n  /* Regular imageset */\n  background-image: ", ";\n\n  @media (min-width: 52em) {\n    /* Fallback */\n    background-image: ", ";\n\n    /* Webkit fallback */\n    background-image: ", ";\n\n    /* Regular imageset */\n    background-image: ", ";\n  }\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    background-image: ", ";\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  user-select: none;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    z-index: 0;\n    width: 75%;\n    height: 100%;\n    background: ", ";\n    user-select: none;\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    height: 100%;\n    background: ", ";\n    user-select: none;\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  user-select: none;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    z-index: 0;\n    width: 75%;\n    height: 100%;\n    background: ", ";\n    user-select: none;\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    height: 100%;\n    background: ", ";\n    user-select: none;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  z-index: 1;\n"], ["\n  position: relative;\n  z-index: 1;\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _polished = __webpack_require__(8);
	
	var _rebass = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.theme.colors[props.color];
	});
	
	var Image = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2, function (props) {
	  return "url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ")";
	}, function (props) {
	  return "-webkit-image-set(url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x)";
	}, function (props) {
	  return "image-set(url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x)";
	}, function (props) {
	  return "url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ")";
	}, function (props) {
	  return "-webkit-image-set(url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x, url(" + (props.backgroundImage ? props.backgroundImage[0] : "") + ") 3x)";
	}, function (props) {
	  return "image-set(url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x, url(" + (props.backgroundImage ? props.backgroundImage[0] : "") + ") 3x)";
	}, function (props) {
	  return props.theme.colors[props.imageColor] && "linear-gradient(to bottom, " + (props.imageColor ? (0, _polished.rgba)(props.theme.colors[props.imageColor], 0.66) : "") + ", " + (props.imageColor ? (0, _polished.rgba)(props.theme.colors[props.imageColor], 0.66) : "") + "), url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ")";
	});
	
	var Overlay = (0, _styledComponents2.default)(_rebass.Box)(_templateObject3, function (props) {
	  return props.theme.colors[props.color] && "linear-gradient(to right, " + (0, _polished.rgba)(props.theme.colors[props.color], 1) + ", " + (0, _polished.rgba)(props.theme.colors[props.color], 0.5) + ")";
	}, function (props) {
	  return props.theme.colors[props.color] && "linear-gradient(to bottom, " + (0, _polished.rgba)(props.theme.colors[props.color], 1) + ", " + (0, _polished.rgba)(props.theme.colors[props.color], 0.5) + ")";
	});
	
	var Container = (0, _styledComponents2.default)(_rebass.Box)(_templateObject4);
	
	var GradientHeader = function GradientHeader(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    _extends({}, props, {
	      className: props.className,
	      style: props.style,
	      color: props.color,
	      is: "header",
	      pt: [137, 80]
	    }),
	    _react2.default.createElement(Image, { backgroundImage: props.image }),
	    _react2.default.createElement(Overlay, { color: props.color }),
	    _react2.default.createElement(
	      Container,
	      { className: "gradient-header__container" },
	      _react2.default.createElement(
	        _rebass.Box,
	        {
	          w: "100%",
	          pt: [5, 7],
	          pb: [5, 7],
	          mx: "auto",
	          px: [4, 5, 6, 8],
	          style: { maxWidth: "90em" }
	        },
	        props.children
	      )
	    )
	  );
	};
	
	GradientHeader.defaultProps = {
	  image: []
	};
	
	exports.default = GradientHeader;
	module.exports = exports["default"];

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n"], ["\n  ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledSystem = __webpack_require__(11);
	
	var _rebass = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var H1 = (0, _styledComponents2.default)(_rebass.Text)(_templateObject, _styledSystem.letterSpacing);
	
	H1.defaultProps = {
	  is: "h1",
	  m: 0,
	  color: "text",
	  fontSize: 6,
	  fontWeight: "bold",
	  lineHeight: 1,
	  letterSpacing: "headings"
	};
	
	exports.default = H1;
	module.exports = exports["default"];

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n"], ["\n  ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledSystem = __webpack_require__(11);
	
	var _rebass = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var H3 = (0, _styledComponents2.default)(_rebass.Text)(_templateObject, _styledSystem.letterSpacing);
	
	H3.defaultProps = {
	  is: "h3",
	  m: 0,
	  color: "text",
	  fontSize: 4,
	  fontWeight: "bold",
	  lineHeight: 2,
	  letterSpacing: "headings"
	};
	
	exports.default = H3;
	module.exports = exports["default"];

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.TwitterIcon = exports.GooglePlusIcon = exports.YouTubeIcon = exports.FacebookIcon = exports.CloseIcon = exports.ArrowRightIcon = exports.SearchIcon = exports.HamburgerMenuIcon = exports.ChevronDownIcon = undefined;
	
	var _ChevronDownIcon2 = __webpack_require__(237);
	
	var _ChevronDownIcon3 = _interopRequireDefault(_ChevronDownIcon2);
	
	var _HamburgerMenuIcon2 = __webpack_require__(241);
	
	var _HamburgerMenuIcon3 = _interopRequireDefault(_HamburgerMenuIcon2);
	
	var _SearchIcon2 = __webpack_require__(242);
	
	var _SearchIcon3 = _interopRequireDefault(_SearchIcon2);
	
	var _ArrowRightIcon2 = __webpack_require__(236);
	
	var _ArrowRightIcon3 = _interopRequireDefault(_ArrowRightIcon2);
	
	var _CloseIcon2 = __webpack_require__(238);
	
	var _CloseIcon3 = _interopRequireDefault(_CloseIcon2);
	
	var _FacebookIcon2 = __webpack_require__(239);
	
	var _FacebookIcon3 = _interopRequireDefault(_FacebookIcon2);
	
	var _YouTubeIcon2 = __webpack_require__(244);
	
	var _YouTubeIcon3 = _interopRequireDefault(_YouTubeIcon2);
	
	var _GooglePlusIcon2 = __webpack_require__(240);
	
	var _GooglePlusIcon3 = _interopRequireDefault(_GooglePlusIcon2);
	
	var _TwitterIcon2 = __webpack_require__(243);
	
	var _TwitterIcon3 = _interopRequireDefault(_TwitterIcon2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ChevronDownIcon = _ChevronDownIcon3.default;
	exports.HamburgerMenuIcon = _HamburgerMenuIcon3.default;
	exports.SearchIcon = _SearchIcon3.default;
	exports.ArrowRightIcon = _ArrowRightIcon3.default;
	exports.CloseIcon = _CloseIcon3.default;
	exports.FacebookIcon = _FacebookIcon3.default;
	exports.YouTubeIcon = _YouTubeIcon3.default;
	exports.GooglePlusIcon = _GooglePlusIcon3.default;
	exports.TwitterIcon = _TwitterIcon3.default;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  padding: 0;\n  &:first-child {\n    margin-top: 0;\n  }\n"], ["\n  padding: 0;\n  &:first-child {\n    margin-top: 0;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  width: 100%;\n\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  text-align: center;\n"], ["\n  width: 100%;\n  text-align: center;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  max-width: 60rem;\n  margin-top: 16px;\n  text-align: initial;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n  p {\n    margin: 0;\n    margin-bottom: ", "px;\n    font-weight: 400;\n    line-height: 1.5;\n    color: ", ";\n    font-kerning: normal;\n    font-variant-ligatures: common-ligatures;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n  p strong,\n  p b {\n    font-weight: ", ";\n  }\n  p a {\n    color: ", ";\n    text-decoration: none;\n    box-shadow: inset 0 -1px 0 ", ";\n    transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n      box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: color, box-shadow;\n\n    &:hover {\n      color: #fff;\n      box-shadow: inset 0 -1.5em 0 ", ";\n    }\n    &:active {\n      color: #fff;\n      box-shadow: inset 0 -1.5em 0 ", ";\n    }\n  }\n"], ["\n  display: inline-block;\n  max-width: 60rem;\n  margin-top: 16px;\n  text-align: initial;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n  p {\n    margin: 0;\n    margin-bottom: ", "px;\n    font-weight: 400;\n    line-height: 1.5;\n    color: ", ";\n    font-kerning: normal;\n    font-variant-ligatures: common-ligatures;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n  p strong,\n  p b {\n    font-weight: ", ";\n  }\n  p a {\n    color: ", ";\n    text-decoration: none;\n    box-shadow: inset 0 -1px 0 ", ";\n    transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n      box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: color, box-shadow;\n\n    &:hover {\n      color: #fff;\n      box-shadow: inset 0 -1.5em 0 ", ";\n    }\n    &:active {\n      color: #fff;\n      box-shadow: inset 0 -1.5em 0 ", ";\n    }\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _polished = __webpack_require__(8);
	
	var _prismicDom = __webpack_require__(10);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(4);
	
	var _Text = __webpack_require__(17);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject);
	
	Wrapper.defaultProps = {
	  is: "figure",
	  mx: [-24, -32, 0],
	  mt: [5, 7],
	  mb: [5, 7]
	};
	
	var Image = (0, _styledComponents2.default)(_rebass.Image)(_templateObject2, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.violet;
	});
	
	Image.defaultProps = {};
	
	var CaptionContainer = (0, _styledComponents2.default)(_rebass.Box)(_templateObject3);
	
	CaptionContainer.defaultProps = {
	  is: "figcaption",
	  px: [4, 5, 6, 8]
	};
	
	var Caption = (0, _styledComponents2.default)(_Text2.default)(_templateObject4, function (props) {
	  return props.theme.space[5];
	}, function (props) {
	  return props.theme.colors.text;
	}, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.fontWeights.bold;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet && (0, _polished.shade)(0.75, props.theme.colors.violet);
	});
	
	Caption.defaultProps = {
	  is: "p"
	};
	
	var linkResolver = function linkResolver(doc) {
	  return "/" + doc.type;
	};
	
	var ImageSlice = function ImageSlice(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(Image, {
	      srcSet: props.imageSet[2] + " 1000w, " + props.imageSet[1] + " 2000w, " + props.imageSet[0] + " 2500w",
	      alt: props.alt
	    }),
	    _react2.default.createElement(
	      CaptionContainer,
	      null,
	      _react2.default.createElement(
	        Caption,
	        null,
	        props.caption && _react2.default.createElement("span", {
	          dangerouslySetInnerHTML: {
	            __html: _prismicDom.RichText.asHtml(props.caption, linkResolver)
	          }
	        })
	      )
	    )
	  );
	};
	
	ImageSlice.defaultProps = {
	  image: "https://bankinformationcenter.cdn.prismic.io/bankinformationcenter/96772987cca22889439e3130b7c2525326fecbf9_child-labor11.jpg"
	};
	
	exports.default = ImageSlice;
	module.exports = exports["default"];

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  width: 100%;\n  background-color: #363636;\n  box-shadow: 0 -1px 4px 0 ", ";\n\n  @media (min-width: 512px) {\n    display: none;\n  }\n"], ["\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  width: 100%;\n  background-color: #363636;\n  box-shadow: 0 -1px 4px 0 ", ";\n\n  @media (min-width: 512px) {\n    display: none;\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _polished = __webpack_require__(8);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(4);
	
	var _Text = __webpack_require__(17);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _reactFeather = __webpack_require__(29);
	
	var Icon = _interopRequireWildcard(_reactFeather);
	
	var _invertTheme = __webpack_require__(12);
	
	var _invertTheme2 = _interopRequireDefault(_invertTheme);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div(_templateObject, (0, _polished.rgba)("#363636", 1 / 10));
	
	var MobileBar = function MobileBar(props) {
	  return _react2.default.createElement(
	    _styledComponents.ThemeProvider,
	    { theme: _invertTheme2.default },
	    _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(
	        _rebass.Box,
	        { mx: 4, my: 3 },
	        _react2.default.createElement(
	          _rebass.Flex,
	          { justify: "space-around" },
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:" + props.emailAddress },
	            _react2.default.createElement(
	              _rebass.Flex,
	              null,
	              _react2.default.createElement(Icon.Phone, { size: 24, color: "#fff", strokeWidth: 1.5 }),
	              _react2.default.createElement(_Text2.default, {
	                children: props.windowLang === "en-us" ? "Call us" : props.windowLang === "es-mx" ? "Llámenos" : "اتصل بنا",
	                ml: 2
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "tel:" + props.phoneNumber },
	            _react2.default.createElement(
	              _rebass.Flex,
	              null,
	              _react2.default.createElement(Icon.Mail, { size: 24, color: "#fff", strokeWidth: 1.5 }),
	              _react2.default.createElement(_Text2.default, {
	                children: props.windowLang === "en-us" ? "Email us" : props.windowLang === "es-mx" ? "Email" : "أرسل لنا",
	                ml: 2
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = MobileBar;
	module.exports = exports["default"];

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  width: 100%;\n"], ["\n  flex: 1;\n  width: 100%;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose([""], [""]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject);
	
	Wrapper.defaultProps = {};
	
	var Container = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2);
	
	Container.defaultProps = {};
	
	var PageContent = function PageContent(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      Container,
	      null,
	      props.children
	    )
	  );
	};
	
	PageContent.defaultProps = {};
	
	exports.default = PageContent;
	module.exports = exports["default"];

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  width: 30%;\n  min-width: 336px;\n  border-width: 0;\n  border-color: ", ";\n  /* border-style: solid; */\n\n  &:not(:lang(ar)) {\n    width: 30%;\n    min-width: 336px;\n    order: 1;\n    margin-right: 0;\n    margin-left: 48px;\n    padding-right: 0;\n    padding-left: 48px;\n    border-left-width: 1px;\n    @media only screen and (max-width: 72em) {\n      margin-left: 32px;\n      padding-left: 32px;\n    }\n  }\n  &:lang(ar) {\n    width: 30%;\n    min-width: 336px;\n    order: -1;\n    margin-right: 48px;\n    margin-left: 0;\n    padding-right: 48px;\n    padding-left: 48px;\n    border-right-width: 1px;\n    @media only screen and (max-width: 72em) {\n      margin-right: 32px;\n      padding-right: 32px;\n    }\n  }\n\n  @media only screen and (max-width: 64em) {\n    order: 1 !important;\n    width: 100% !important;\n    min-width: initial !important;\n    margin-top: 64px;\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n    border-width: 0 !important;\n  }\n\n  ", ";\n"], ["\n  width: 30%;\n  min-width: 336px;\n  border-width: 0;\n  border-color: ", ";\n  /* border-style: solid; */\n\n  &:not(:lang(ar)) {\n    width: 30%;\n    min-width: 336px;\n    order: 1;\n    margin-right: 0;\n    margin-left: 48px;\n    padding-right: 0;\n    padding-left: 48px;\n    border-left-width: 1px;\n    @media only screen and (max-width: 72em) {\n      margin-left: 32px;\n      padding-left: 32px;\n    }\n  }\n  &:lang(ar) {\n    width: 30%;\n    min-width: 336px;\n    order: -1;\n    margin-right: 48px;\n    margin-left: 0;\n    padding-right: 48px;\n    padding-left: 48px;\n    border-right-width: 1px;\n    @media only screen and (max-width: 72em) {\n      margin-right: 32px;\n      padding-right: 32px;\n    }\n  }\n\n  @media only screen and (max-width: 64em) {\n    order: 1 !important;\n    width: 100% !important;\n    min-width: initial !important;\n    margin-top: 64px;\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n    border-width: 0 !important;\n  }\n\n  ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n      @media only screen and (max-width: 64em) {\n        order: -1 !important;\n        margin-top: 0 !important;\n        margin-bottom: 48px !important;\n      }\n    "], ["\n      @media only screen and (max-width: 64em) {\n        order: -1 !important;\n        margin-top: 0 !important;\n        margin-bottom: 48px !important;\n      }\n    "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"], ["\n  width: 100%;\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _polished = __webpack_require__(8);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject, function (props) {
	  return props.theme.colors.grey[1] && (0, _polished.shade)(0.875, props.theme.colors.grey[1]);
	}, function (props) {
	  return props.mobileTop && (0, _styledComponents.css)(_templateObject2);
	});
	
	Wrapper.defaultProps = {
	  is: "aside"
	};
	
	var Container = (0, _styledComponents2.default)(_rebass.Box)(_templateObject3);
	
	Container.defaultProps = {};
	
	var PageSidebar = function PageSidebar(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    { mobileTop: props.mobileTop },
	    _react2.default.createElement(
	      Container,
	      null,
	      props.children
	    )
	  );
	};
	
	PageSidebar.defaultProps = {};
	
	exports.default = PageSidebar;
	module.exports = exports["default"];

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: block;\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n  transition: background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  cursor: pointer;\n  user-select: none;\n  &:last-child {\n    border-bottom: 0;\n  }\n  &:hover {\n    background-color: ", ";\n    .action-icon {\n      opacity: 1;\n    }\n  }\n  &:focus {\n    z-index: 1;\n    background-color: ", ";\n    outline: 4px solid ", ";\n    box-shadow: none;\n    .action-icon {\n      opacity: 1;\n    }\n  }\n\n  &:active {\n    background-color: ", ";\n    .action-icon {\n      opacity: 0.5;\n    }\n  }\n"], ["\n  position: relative;\n  display: block;\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n  transition: background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  cursor: pointer;\n  user-select: none;\n  &:last-child {\n    border-bottom: 0;\n  }\n  &:hover {\n    background-color: ", ";\n    .action-icon {\n      opacity: 1;\n    }\n  }\n  &:focus {\n    z-index: 1;\n    background-color: ", ";\n    outline: 4px solid ", ";\n    box-shadow: none;\n    .action-icon {\n      opacity: 1;\n    }\n  }\n\n  &:active {\n    background-color: ", ";\n    .action-icon {\n      opacity: 0.5;\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n"], ["\n  position: relative;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 50%;\n  width: 24px;\n  height: 24px;\n  transform: translateY(-50%);\n  opacity: 0.5;\n  &:not(:lang(ar)) {\n    left: 16px;\n  }\n  &:lang(ar) {\n    right: 16px;\n  }\n"], ["\n  position: absolute;\n  top: 50%;\n  width: 24px;\n  height: 24px;\n  transform: translateY(-50%);\n  opacity: 0.5;\n  &:not(:lang(ar)) {\n    left: 16px;\n  }\n  &:lang(ar) {\n    right: 16px;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  padding-right: ", "px;\n  padding-left: ", "px;\n  ", ";\n"], ["\n  width: 100%;\n  padding-right: ", "px;\n  padding-left: ", "px;\n  ", ";\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 50%;\n  width: 24px;\n  height: 24px;\n  opacity: 0;\n  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  transform: translateY(-50%);\n  &:not(:lang(ar)) {\n    right: 16px;\n  }\n  &:lang(ar) {\n    left: 16px;\n  }\n"], ["\n  position: absolute;\n  top: 50%;\n  width: 24px;\n  height: 24px;\n  opacity: 0;\n  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  transform: translateY(-50%);\n  &:not(:lang(ar)) {\n    right: 16px;\n  }\n  &:lang(ar) {\n    left: 16px;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  opacity: 0.5;\n"], ["\n  opacity: 0.5;\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _polished = __webpack_require__(8);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _rebass = __webpack_require__(4);
	
	var _reactFeather = __webpack_require__(29);
	
	var Icon = _interopRequireWildcard(_reactFeather);
	
	var _Text = __webpack_require__(17);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _H = __webpack_require__(41);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.grey[1];
	}, function (props) {
	  return props.theme.colors.grey[1];
	}, function (props) {
	  return props.theme.colors.grey[1];
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.grey[1] && (0, _polished.rgba)(props.theme.colors.grey[1], 0.5);
	});
	
	Wrapper.defaultProps = {
	  is: _gatsbyLink2.default,
	  to: "/",
	  py: 3
	};
	
	var Container = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2);
	
	Container.defaultProps = {
	  px: 3
	};
	
	var IconContainer = (0, _styledComponents2.default)(_rebass.Box)(_templateObject3);
	
	var TextResult = (0, _styledComponents2.default)(_Text2.default)(_templateObject4, 24 + 16, 24 + 16, (0, _polished.ellipsis)());
	
	var ActionContainer = (0, _styledComponents2.default)(_rebass.Box)(_templateObject5);
	
	var Metadata = (0, _styledComponents2.default)(_rebass.Box)(_templateObject6);
	
	Metadata.defaultProps = {
	  px: 56,
	  pt: 1
	};
	
	var SearchResult = function SearchResult(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    {
	      to: "/" + props.result.url,
	      onClick: props.result.url ? props.onClick : "",
	      is: props.result.url ? props.result.url.indexOf("http") !== -1 ? "a" : _gatsbyLink2.default : "div",
	      href: props.result.url,
	      target: props.result.url ? props.result.url.indexOf("http") !== -1 ? "_blank" : "" : "",
	      onKeyDown: props.onKeyDown,
	      role: "option",
	      "aria-labell": props.result.name,
	      tabIndex: 1
	    },
	    _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(
	        IconContainer,
	        null,
	        props.result.type === "region" && _react2.default.createElement(Icon.Globe, { size: 24, strokeWidth: 1.5, stroke: "#363636" }),
	        props.result.type.indexOf("• Document") !== -1 && _react2.default.createElement(Icon.Book, { size: 24, strokeWidth: 1.5, stroke: "#363636" }),
	        props.result.type.indexOf("resource") !== -1 && props.result.type.indexOf("• Audio") === -1 && props.result.type.indexOf("• Video") === -1 && props.result.type.indexOf("• Document") === -1 && _react2.default.createElement(Icon.Link, { size: 24, strokeWidth: 1.5, stroke: "#363636" }),
	        props.result.type.indexOf("• Audio") !== -1 && _react2.default.createElement(Icon.Volume2, { size: 24, strokeWidth: 1.5, stroke: "#363636" }),
	        props.result.type.indexOf("• Video") !== -1 && _react2.default.createElement(Icon.Video, { size: 24, strokeWidth: 1.5, stroke: "#363636" }),
	        props.result.type === "update" && _react2.default.createElement(Icon.BookOpen, { size: 24, strokeWidth: 1.5, stroke: "#363636" }),
	        props.result.type === "institution" && _react2.default.createElement(Icon.Briefcase, { size: 24, strokeWidth: 1.5, stroke: "#363636" }),
	        props.result.type === "member" && _react2.default.createElement(Icon.User, { size: 24, strokeWidth: 1.5, stroke: "#363636" }),
	        props.result.type === "projec" && _react2.default.createElement(Icon.Flag, { size: 24, strokeWidth: 1.5, stroke: "#363636" })
	      ),
	      _react2.default.createElement(TextResult, {
	        children: props.result.type === "Algolia" ? _react2.default.createElement("img", { src: "https://res.cloudinary.com/hilnmyskv/image/upload/q_auto/v1587462408/Algolia_com_Website_assets/images/shared/algolia_logo/search-by-algolia-light-background.svg" }) : props.result.name,
	        id: "result-label" + props.index,
	        style: { lineHeight: 1 }
	      })
	    ),
	    props.result.type !== "Algolia" && props.result.type !== "noresults" && _react2.default.createElement(
	      Metadata,
	      null,
	      _react2.default.createElement(_H2.default, {
	        children: props.result.type === "projec" ? props.windowLang === "en-us" ? "project" : props.windowLang === "es-mx" ? "Proyecto" : "مشروع" : props.result.type === "member" ? props.windowLang === "en-us" ? "staff" : props.windowLang === "es-mx" ? "Equipo" : "الفريق" : props.result.type === "Algolia" ? "" : props.result.type === "region" ? props.windowLang === "en-us" ? "region" : props.windowLang === "es-mx" ? "regione" : "مشروع" : props.result.type === "institution" ? props.windowLang === "en-us" ? "institution" : props.windowLang === "es-mx" ? "Institucione" : "مؤسسات" : props.result.type === "team" ? props.windowLang === "en-us" ? "team" : props.windowLang === "es-mx" ? "Directorio del equipo" : "دليل فريق المركز" : props.result.type === "update" ? props.windowLang === "en-us" ? "update" : props.windowLang === "es-mx" ? "Noticia" : "تحديث" : props.result.type.indexOf("• Document") ? props.windowLang === "en-us" ? props.result.type : props.windowLang === "es-mx" ? "Documento" : "وثيقة" : props.result.type.indexOf("• Audio") ? props.windowLang === "en-us" ? props.result.type : props.windowLang === "es-mx" ? "audio" : "صوت" : props.result.type.indexOf("• Video") ? props.windowLang === "en-us" ? props.result.type : props.windowLang === "es-mx" ? "video" : "فيديو" : "",
	        is: "div"
	      })
	    ),
	    props.result.type !== "" && props.result.type !== "Algolia" && _react2.default.createElement(
	      ActionContainer,
	      { className: "action-icon" },
	      _react2.default.createElement(Icon.ArrowRight, { size: 24, strokeWidth: 1.5, stroke: "#363636" })
	    )
	  );
	};
	
	SearchResult.defaultProps = {};
	
	exports.default = SearchResult;
	module.exports = exports["default"];

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: block;\n  cursor: pointer;\n  text-decoration: none;\n"], ["\n  display: block;\n  cursor: pointer;\n  text-decoration: none;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  align-items: center;\n"], ["\n  align-items: center;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  width: 96px;\n  min-width: 96px;\n  height: 96px;\n  min-height: 96px;\n  border-radius: 9999px;\n  border: 1px solid ", ";\n  background: ", ";\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: ", ";\n"], ["\n  width: 96px;\n  min-width: 96px;\n  height: 96px;\n  min-height: 96px;\n  border-radius: 9999px;\n  border: 1px solid ", ";\n  background: ", ";\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  font-weight: 400;\n  color: ", ";\n  line-height: 1.25;\n\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  font-size: ", ";\n  font-weight: 400;\n  color: ", ";\n  line-height: 1.25;\n\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  line-height: 1.5;\n\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  line-height: 1.5;\n\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _rebass = __webpack_require__(4);
	
	var _Text = __webpack_require__(17);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject);
	
	Wrapper.defaultProps = {
	  is: _gatsbyLink2.default,
	  to: "/"
	};
	
	var Container = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject2);
	
	var Avatar = (0, _styledComponents2.default)(_rebass.Box)(_templateObject3, function (props) {
	  return props.theme.colors.grey[1];
	}, function (props) {
	  return props.theme.colors.grey[1];
	}, function (props) {
	  return "url(" + props.image + ")";
	});
	
	Avatar.defaultProps = {
	  mr: 3
	};
	
	var Authorship = (0, _styledComponents2.default)(_Text2.default)(_templateObject4, function (props) {
	  return props.theme.fontSizes[2];
	}, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.violet;
	});
	
	var Name = (0, _styledComponents2.default)(_Text2.default)(_templateObject5, function (props) {
	  return props.theme.fontSizes[2];
	}, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.violet;
	});
	
	var StaffProfile = function StaffProfile(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    { to: "/" + props.to, is: _gatsbyLink2.default },
	    _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(Avatar, { image: props.image }),
	      _react2.default.createElement(
	        _rebass.Box,
	        null,
	        _react2.default.createElement(Authorship, {
	          children: props.attributionText ? props.attributionText : "Written by"
	        }),
	        _react2.default.createElement(Name, { children: props.name })
	      )
	    )
	  );
	};
	
	StaffProfile.defaultProps = {
	  image: "https://sidewalklabs.com/assets/uploads/2018/04/bowden-copy.jpg",
	  name: "John Doe"
	};
	
	exports.default = StaffProfile;
	module.exports = exports["default"];

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(312);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(311);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(323);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(46);
	var document = __webpack_require__(26).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(31) && !__webpack_require__(44)(function () {
	  return Object.defineProperty(__webpack_require__(148)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(146);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(66);
	var $export = __webpack_require__(43);
	var redefine = __webpack_require__(155);
	var hide = __webpack_require__(45);
	var Iterators = __webpack_require__(89);
	var $iterCreate = __webpack_require__(329);
	var setToStringTag = __webpack_require__(92);
	var getPrototypeOf = __webpack_require__(335);
	var ITERATOR = __webpack_require__(49)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(67);
	var createDesc = __webpack_require__(68);
	var toIObject = __webpack_require__(48);
	var toPrimitive = __webpack_require__(96);
	var has = __webpack_require__(32);
	var IE8_DOM_DEFINE = __webpack_require__(149);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(31) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(154);
	var hiddenKeys = __webpack_require__(88).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(32);
	var toIObject = __webpack_require__(48);
	var arrayIndexOf = __webpack_require__(325)(false);
	var IE_PROTO = __webpack_require__(93)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(45);


/***/ }),
/* 156 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 157 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(18).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(102);
	var $export = __webpack_require__(74);
	var redefine = __webpack_require__(60);
	var hide = __webpack_require__(50);
	var Iterators = __webpack_require__(59);
	var $iterCreate = __webpack_require__(362);
	var setToStringTag = __webpack_require__(104);
	var getPrototypeOf = __webpack_require__(368);
	var ITERATOR = __webpack_require__(19)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(369);
	var enumBugKeys = __webpack_require__(156);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 161 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(33);
	var isObject = __webpack_require__(58);
	var newPromiseCapability = __webpack_require__(103);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 163 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(33);
	var aFunction = __webpack_require__(71);
	var SPECIES = __webpack_require__(19)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(73);
	var invoke = __webpack_require__(358);
	var html = __webpack_require__(158);
	var cel = __webpack_require__(101);
	var global = __webpack_require__(18);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(72)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(107);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 167 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(1057)('createBrowserHistory');
	module.exports = __webpack_require__(24).createBrowserHistory;


/***/ }),
/* 169 */
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(28);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a number (float) representing the luminance of a color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
	 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
	 *                             'rgba(58, 133, 255, 1)' :
	 *                             'rgba(255, 57, 149, 1)',
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
	 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
	 *                             'rgba(58, 133, 255, 1)' :
	 *                             'rgba(255, 57, 149, 1)'};
	 *
	 * // CSS in JS Output
	 *
	 * div {
	 *   background: "#CCCD64";
	 *   background: "rgba(58, 133, 255, 1)";
	 * }
	 */
	function getLuminance(color) {
	  var rgbColor = (0, _parseToRgb2.default)(color);
	
	  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
	    var channel = rgbColor[key] / 255;
	    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
	  }),
	      r = _Object$keys$map[0],
	      g = _Object$keys$map[1],
	      b = _Object$keys$map[2];
	
	  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
	}
	exports.default = getLuminance;
	module.exports = exports['default'];

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hslToHex = /*#__PURE__*/__webpack_require__(174);
	
	var _hslToHex2 = /*#__PURE__*/_interopRequireDefault(_hslToHex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the color. The returned result is the smallest possible hex notation.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: hsl(359, 0.75, 0.4),
	 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${hsl(359, 0.75, 0.4)};
	 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#b3191c";
	 *   background: "#b3191c";
	 * }
	 */
	function hsl(value, saturation, lightness) {
	  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
	    return (0, _hslToHex2.default)(value, saturation, lightness);
	  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
	    return (0, _hslToHex2.default)(value.hue, value.saturation, value.lightness);
	  }
	
	  throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
	}
	
	exports.default = hsl;
	module.exports = exports['default'];

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hslToHex = /*#__PURE__*/__webpack_require__(174);
	
	var _hslToHex2 = /*#__PURE__*/_interopRequireDefault(_hslToHex);
	
	var _hslToRgb = /*#__PURE__*/__webpack_require__(116);
	
	var _hslToRgb2 = /*#__PURE__*/_interopRequireDefault(_hslToRgb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: hsla(359, 0.75, 0.4, 0.7),
	 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
	 *   background: hsla(359, 0.75, 0.4, 1),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
	 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
	 *   background: ${hsla(359, 0.75, 0.4, 1)};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "rgba(179,25,28,0.7)";
	 *   background: "rgba(179,25,28,0.7)";
	 *   background: "#b3191c";
	 * }
	 */
	function hsla(value, saturation, lightness, alpha) {
	  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
	    return alpha >= 1 ? (0, _hslToHex2.default)(value, saturation, lightness) : 'rgba(' + (0, _hslToRgb2.default)(value, saturation, lightness) + ',' + alpha + ')';
	  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
	    return value.alpha >= 1 ? (0, _hslToHex2.default)(value.hue, value.saturation, value.lightness) : 'rgba(' + (0, _hslToRgb2.default)(value.hue, value.saturation, value.lightness) + ',' + value.alpha + ')';
	  }
	
	  throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
	}
	
	exports.default = hsla;
	module.exports = exports['default'];

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	// @private
	function capitalizeString(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	exports.default = capitalizeString;
	module.exports = exports["default"];

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hslToRgb = /*#__PURE__*/__webpack_require__(116);
	
	var _hslToRgb2 = /*#__PURE__*/_interopRequireDefault(_hslToRgb);
	
	var _reduceHexValue = /*#__PURE__*/__webpack_require__(177);
	
	var _reduceHexValue2 = /*#__PURE__*/_interopRequireDefault(_reduceHexValue);
	
	var _numberToHex = /*#__PURE__*/__webpack_require__(175);
	
	var _numberToHex2 = /*#__PURE__*/_interopRequireDefault(_numberToHex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function colorToHex(color) {
	  return (0, _numberToHex2.default)(Math.round(color * 255));
	}
	
	
	function convertToHex(red, green, blue) {
	  return (0, _reduceHexValue2.default)('#' + colorToHex(red) + colorToHex(green) + colorToHex(blue));
	}
	
	function hslToHex(hue, saturation, lightness) {
	  return (0, _hslToRgb2.default)(hue, saturation, lightness, convertToHex);
	}
	
	exports.default = hslToHex;
	module.exports = exports['default'];

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function numberToHex(value) {
	  var hex = value.toString(16);
	  return hex.length === 1 ? "0" + hex : hex;
	}
	
	exports.default = numberToHex;
	module.exports = exports["default"];

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _endsWith = /*#__PURE__*/__webpack_require__(1713);
	
	var _endsWith2 = /*#__PURE__*/_interopRequireDefault(_endsWith);
	
	var _stripUnit = /*#__PURE__*/__webpack_require__(115);
	
	var _stripUnit2 = /*#__PURE__*/_interopRequireDefault(_stripUnit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Factory function that creates pixel-to-x converters
	 * @private
	 */
	var pxtoFactory = function pxtoFactory(to) {
	  return function (pxval) {
	    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '16px';
	
	    var newPxval = pxval;
	    var newBase = base;
	    if (typeof pxval === 'string') {
	      if (!(0, _endsWith2.default)(pxval, 'px')) {
	        throw new Error('Expected a string ending in "px" or a number passed as the first argument to ' + to + '(), got "' + pxval + '" instead.');
	      }
	      newPxval = (0, _stripUnit2.default)(pxval);
	    }
	
	    if (typeof base === 'string') {
	      if (!(0, _endsWith2.default)(base, 'px')) {
	        throw new Error('Expected a string ending in "px" or a number passed as the second argument to ' + to + '(), got "' + base + '" instead.');
	      }
	      newBase = (0, _stripUnit2.default)(base);
	    }
	
	    if (typeof newPxval === 'string') {
	      throw new Error('Passed invalid pixel value ("' + pxval + '") to ' + to + '(), please pass a value like "12px" or 12.');
	    }
	
	    if (typeof newBase === 'string') {
	      throw new Error('Passed invalid base value ("' + base + '") to ' + to + '(), please pass a value like "12px" or 12.');
	    }
	
	    return '' + newPxval / newBase + to;
	  };
	};
	
	exports.default = pxtoFactory;
	module.exports = exports['default'];

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Reduces hex values if possible e.g. #ff8866 to #f86
	 * @private
	 */
	var reduceHexValue = function reduceHexValue(value) {
	  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
	    return "#" + value[1] + value[3] + value[5];
	  }
	  return value;
	};
	
	exports.default = reduceHexValue;
	module.exports = exports["default"];

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function generateSelectors(template, state) {
	  var stateSuffix = state ? ':' + state : '';
	  return template(stateSuffix);
	}
	
	/**
	 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
	 * @private
	 */
	
	function statefulSelectors(states, template, stateMap) {
	  if (!template) throw new Error('You must provide a template to this method.');
	  if (states.length === 0) return generateSelectors(template, null);
	  var selectors = [];
	  for (var i = 0; i < states.length; i += 1) {
	    if (stateMap && stateMap.indexOf(states[i]) < 0) {
	      throw new Error('You passed an unsupported selector state to this method.');
	    }
	    selectors.push(generateSelectors(template, states[i]));
	  }
	  selectors = selectors.join(',');
	  return selectors;
	}
	
	exports.default = statefulSelectors;
	module.exports = exports['default'];

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Generates a media query to target HiDPI devices.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *  [hiDPI(1.5)]: {
	 *    width: 200px;
	 *  }
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${hiDPI(1.5)} {
	 *     width: 200px;
	 *   }
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
	 *  only screen and (min--moz-device-pixel-ratio: 1.5),
	 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
	 *  only screen and (min-resolution: 144dpi),
	 *  only screen and (min-resolution: 1.5dppx)': {
	 *   'width': '200px',
	 * }
	 */
	
	function hiDPI() {
	  var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.3;
	
	  return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
	}
	
	exports.default = hiDPI;
	module.exports = exports["default"];

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return map(objectKeys(obj), function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (isArray(obj[k])) {
	        return map(obj[k], function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};
	
	var isArray = Array.isArray || function (xs) {
	  return Object.prototype.toString.call(xs) === '[object Array]';
	};
	
	function map (xs, f) {
	  if (xs.map) return xs.map(f);
	  var res = [];
	  for (var i = 0; i < xs.length; i++) {
	    res.push(f(xs[i], i));
	  }
	  return res;
	}
	
	var objectKeys = Object.keys || function (obj) {
	  var res = [];
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
	  }
	  return res;
	};


/***/ }),
/* 181 */,
/* 182 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2024);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(27);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore everything but left clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, "You should not use <Link> outside a <Router>");
	
	    (0, _invariant2.default)(to !== undefined, 'You must specify the "to" property');
	
	    var history = this.context.router.history;
	
	    var location = typeof to === "string" ? (0, _history.createLocation)(to, null, null, history.location) : to;
	
	    var href = history.createHref(location);
	    return _react2.default.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(187);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(30);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(27);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(120);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, "You should not use <Route> or withRouter() outside a <Router>");
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    if (component) return match ? _react2.default.createElement(component, props) : null;
	
	    if (render) return match ? render(props) : null;
	
	    if (typeof children === "function") return children(props);
	
	    if (children && !isEmptyChildren(children)) return _react2.default.Children.only(children);
	
	    return null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(189);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compileGenerator = function compileGenerator(pattern) {
	  var cacheKey = pattern;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var compiledGenerator = _pathToRegexp2.default.compile(pattern);
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledGenerator;
	    cacheCount++;
	  }
	
	  return compiledGenerator;
	};
	
	/**
	 * Public API for generating a URL pathname from a pattern and parameters.
	 */
	var generatePath = function generatePath() {
	  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (pattern === "/") {
	    return pattern;
	  }
	  var generator = compileGenerator(pattern);
	  return generator(params, { pretty: true });
	};
	
	exports.default = generatePath;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(14)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ }),
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Badge = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Badge = exports.Badge = (0, _components2.default)({
	  fontSize: 0,
	  px: 2,
	  py: 1,
	  mx: 1,
	  color: 'white',
	  bg: 'blue',
	  fontWeight: 'bold',
	  borderRadius: 2
	}, {
	  WebkitFontSmoothing: 'antialiased',
	  display: 'inline-block',
	  verticalAlign: 'middle'
	}, 'space', 'color', 'fontSize', 'fontWeight', 'borderRadius');
	
	Badge.displayName = 'Badge';
	
	exports.default = Badge;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ButtonTransparent = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _Button = __webpack_require__(80);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonTransparent = exports.ButtonTransparent = (0, _components2.default)({
	  extend: _Button2.default,
	  bg: 'transparent',
	  color: 'inherit'
	});
	
	ButtonTransparent.displayName = 'ButtonTransparent';
	
	exports.default = ButtonTransparent;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Code = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Code = exports.Code = (0, _components2.default)({
	  is: 'code',
	  fontSize: 1,
	  fontFamily: 'mono'
	}, 'fontFamily', 'fontSize', 'space', 'color');
	
	Code.displayName = 'Code';
	
	exports.default = Code;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Heading = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Heading = exports.Heading = (0, _components2.default)({
	  is: 'h2',
	  fontSize: 5,
	  fontWeight: 'bold',
	  lineHeight: 1.25,
	  m: 0
	}, 'fontFamily', 'fontSize', 'fontWeight', 'lineHeight', 'space', 'color', 'textAlign');
	
	Heading.displayName = 'Heading';
	
	Heading.h1 = function (props) {
	  return _react2.default.createElement(Heading, _extends({}, props, { is: 'h1' }));
	};
	Heading.h2 = function (props) {
	  return _react2.default.createElement(Heading, _extends({}, props, { is: 'h2' }));
	};
	Heading.h3 = function (props) {
	  return _react2.default.createElement(Heading, _extends({}, props, { is: 'h3' }));
	};
	Heading.h4 = function (props) {
	  return _react2.default.createElement(Heading, _extends({}, props, { is: 'h4' }));
	};
	Heading.h5 = function (props) {
	  return _react2.default.createElement(Heading, _extends({}, props, { is: 'h5' }));
	};
	Heading.h6 = function (props) {
	  return _react2.default.createElement(Heading, _extends({}, props, { is: 'h6' }));
	};
	
	exports.default = Heading;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Root = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Root = exports.Root = (0, _components2.default)({
	  fontFamily: 'sans'
	}, 'fontFamily', {
	  '& *': {
	    boxSizing: 'border-box'
	  }
	}, 'space', 'color');
	
	Root.displayName = 'Root';
	
	exports.default = Root;

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var breakpoints = exports.breakpoints = ['40em', '52em', '64em'];
	
	var space = exports.space = [0, 4, 8, 16, 32, 64, 128, 256, 512];
	
	var fontSizes = exports.fontSizes = [12, 14, 16, 20, 24, 32, 48, 64, 72];
	
	exports.default = {
	  breakpoints: breakpoints,
	  space: space,
	  fontSizes: fontSizes
	};

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var memoize = _interopDefault(__webpack_require__(201));
	
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
	
	var index = memoize(function (prop) {
	  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
	  /* o */
	  && prop.charCodeAt(1) === 110
	  /* n */
	  && prop.charCodeAt(2) < 91;
	}
	/* Z+1 */
	);
	
	exports.default = index;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	exports.default = memoize;


/***/ }),
/* 202 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  msGridRow: 1,
	  msGridRowSpan: 1,
	  msGridColumn: 1,
	  msGridColumnSpan: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	exports.default = unitlessKeys;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = AlgoliaSearch;
	
	var Index = __webpack_require__(205);
	var deprecate = __webpack_require__(81);
	var deprecatedMessage = __webpack_require__(82);
	var AlgoliaSearchCore = __webpack_require__(204);
	var inherits = __webpack_require__(62);
	var errors = __webpack_require__(39);
	
	function AlgoliaSearch() {
	  AlgoliaSearchCore.apply(this, arguments);
	}
	
	inherits(AlgoliaSearch, AlgoliaSearchCore);
	
	/*
	 * Delete an index
	 *
	 * @param indexName the name of index to delete
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer that contains the task ID
	 */
	AlgoliaSearch.prototype.deleteIndex = function(indexName, callback) {
	  return this._jsonRequest({
	    method: 'DELETE',
	    url: '/1/indexes/' + encodeURIComponent(indexName),
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * Move an existing index.
	 * @param srcIndexName the name of index to copy.
	 * @param dstIndexName the new index name that will contains a copy of
	 * srcIndexName (destination will be overriten if it already exist).
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer that contains the task ID
	 */
	AlgoliaSearch.prototype.moveIndex = function(srcIndexName, dstIndexName, callback) {
	  var postObj = {
	    operation: 'move', destination: dstIndexName
	  };
	  return this._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(srcIndexName) + '/operation',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * Copy an existing index.
	 * @param srcIndexName the name of index to copy.
	 * @param dstIndexName the new index name that will contains a copy
	 * of srcIndexName (destination will be overriten if it already exist).
	 * @param scope an array of scopes to copy: ['settings', 'synonyms', 'rules']
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer that contains the task ID
	 */
	AlgoliaSearch.prototype.copyIndex = function(srcIndexName, dstIndexName, scopeOrCallback, _callback) {
	  var postObj = {
	    operation: 'copy',
	    destination: dstIndexName
	  };
	  var callback = _callback;
	  if (typeof scopeOrCallback === 'function') {
	    // oops, old behaviour of third argument being a function
	    callback = scopeOrCallback;
	  } else if (Array.isArray(scopeOrCallback) && scopeOrCallback.length > 0) {
	    postObj.scope = scopeOrCallback;
	  } else if (typeof scopeOrCallback !== 'undefined') {
	    throw new Error('the scope given to `copyIndex` was not an array with settings, synonyms or rules');
	  }
	  return this._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(srcIndexName) + '/operation',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * Return last log entries.
	 * @param offset Specify the first entry to retrieve (0-based, 0 is the most recent log entry).
	 * @param length Specify the maximum number of entries to retrieve starting
	 * at offset. Maximum allowed value: 1000.
	 * @param type Specify the maximum number of entries to retrieve starting
	 * at offset. Maximum allowed value: 1000.
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer that contains the task ID
	 */
	AlgoliaSearch.prototype.getLogs = function(offset, length, callback) {
	  var clone = __webpack_require__(25);
	  var params = {};
	  if (typeof offset === 'object') {
	    // getLogs(params)
	    params = clone(offset);
	    callback = length;
	  } else if (arguments.length === 0 || typeof offset === 'function') {
	    // getLogs([cb])
	    callback = offset;
	  } else if (arguments.length === 1 || typeof length === 'function') {
	    // getLogs(1, [cb)]
	    callback = length;
	    params.offset = offset;
	  } else {
	    // getLogs(1, 2, [cb])
	    params.offset = offset;
	    params.length = length;
	  }
	
	  if (params.offset === undefined) params.offset = 0;
	  if (params.length === undefined) params.length = 10;
	
	  return this._jsonRequest({
	    method: 'GET',
	    url: '/1/logs?' + this._getSearchParams(params, ''),
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	 * List all existing indexes (paginated)
	 *
	 * @param page The page to retrieve, starting at 0.
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer with index list
	 */
	AlgoliaSearch.prototype.listIndexes = function(page, callback) {
	  var params = '';
	
	  if (page === undefined || typeof page === 'function') {
	    callback = page;
	  } else {
	    params = '?page=' + page;
	  }
	
	  return this._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes' + params,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	 * Get the index object initialized
	 *
	 * @param indexName the name of index
	 * @param callback the result callback with one argument (the Index instance)
	 */
	AlgoliaSearch.prototype.initIndex = function(indexName) {
	  return new Index(this, indexName);
	};
	
	AlgoliaSearch.prototype.initAnalytics = function(opts) {
	  // the actual require must be inside the function, when put outside then you have a cyclic dependency
	  // not well resolved that ends up making the main "./index.js" (main module, the agloliasearch function)
	  // export an object instead of a function
	  // Other workarounds:
	  // - rewrite the lib in ES6, cyclic dependencies may be better supported
	  // - move initAnalytics to a property on the main module (algoliasearch.initAnalytics),
	  // same as places.
	  // The current API was made mostly to mimic the one made in PHP
	  var createAnalyticsClient = __webpack_require__(210);
	  return createAnalyticsClient(this.applicationID, this.apiKey, opts);
	};
	
	/*
	 * @deprecated use client.listApiKeys
	 */
	AlgoliaSearch.prototype.listUserKeys = deprecate(function(callback) {
	  return this.listApiKeys(callback);
	}, deprecatedMessage('client.listUserKeys()', 'client.listApiKeys()'));
	
	/*
	 * List all existing api keys with their associated ACLs
	 *
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer with api keys list
	 */
	AlgoliaSearch.prototype.listApiKeys = function(callback) {
	  return this._jsonRequest({
	    method: 'GET',
	    url: '/1/keys',
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	 * @deprecated see client.getApiKey
	 */
	AlgoliaSearch.prototype.getUserKeyACL = deprecate(function(key, callback) {
	  return this.getApiKey(key, callback);
	}, deprecatedMessage('client.getUserKeyACL()', 'client.getApiKey()'));
	
	/*
	 * Get an API key
	 *
	 * @param key
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer with the right API key
	 */
	AlgoliaSearch.prototype.getApiKey = function(key, callback) {
	  return this._jsonRequest({
	    method: 'GET',
	    url: '/1/keys/' + key,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/*
	 * @deprecated see client.deleteApiKey
	 */
	AlgoliaSearch.prototype.deleteUserKey = deprecate(function(key, callback) {
	  return this.deleteApiKey(key, callback);
	}, deprecatedMessage('client.deleteUserKey()', 'client.deleteApiKey()'));
	
	/*
	 * Delete an existing API key
	 * @param key
	 * @param callback the result callback called with two arguments
	 *  error: null or Error('message')
	 *  content: the server answer with the date of deletion
	 */
	AlgoliaSearch.prototype.deleteApiKey = function(key, callback) {
	  return this._jsonRequest({
	    method: 'DELETE',
	    url: '/1/keys/' + key,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * Restore a deleted API key
	 *
	 * @param {String} key - The key to restore
	 * @param {Function} callback - The result callback called with two arguments
	 *   error: null or Error('message')
	 *   content: the server answer with the restored API key
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.restoreApiKey('APIKEY')
	 * @see {@link https://www.algolia.com/doc/rest-api/search/#restore-api-key|Algolia REST API Documentation}
	 */
	AlgoliaSearch.prototype.restoreApiKey = function(key, callback) {
	  return this._jsonRequest({
	    method: 'POST',
	    url: '/1/keys/' + key + '/restore',
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	 @deprecated see client.addApiKey
	 */
	AlgoliaSearch.prototype.addUserKey = deprecate(function(acls, params, callback) {
	  return this.addApiKey(acls, params, callback);
	}, deprecatedMessage('client.addUserKey()', 'client.addApiKey()'));
	
	/*
	 * Add a new global API key
	 *
	 * @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
	 *   can contains the following values:
	 *     - search: allow to search (https and http)
	 *     - addObject: allows to add/update an object in the index (https only)
	 *     - deleteObject : allows to delete an existing object (https only)
	 *     - deleteIndex : allows to delete index content (https only)
	 *     - settings : allows to get index settings (https only)
	 *     - editSettings : allows to change index settings (https only)
	 * @param {Object} [params] - Optionnal parameters to set for the key
	 * @param {number} params.validity - Number of seconds after which the key will be automatically removed (0 means no time limit for this key)
	 * @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
	 * @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
	 * @param {string[]} params.indexes - Allowed targeted indexes for this key
	 * @param {string} params.description - A description for your key
	 * @param {string[]} params.referers - A list of authorized referers
	 * @param {Object} params.queryParameters - Force the key to use specific query parameters
	 * @param {Function} callback - The result callback called with two arguments
	 *   error: null or Error('message')
	 *   content: the server answer with the added API key
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.addApiKey(['search'], {
	 *   validity: 300,
	 *   maxQueriesPerIPPerHour: 2000,
	 *   maxHitsPerQuery: 3,
	 *   indexes: ['fruits'],
	 *   description: 'Eat three fruits',
	 *   referers: ['*.algolia.com'],
	 *   queryParameters: {
	 *     tagFilters: ['public'],
	 *   }
	 * })
	 * @see {@link https://www.algolia.com/doc/rest_api#AddKey|Algolia REST API Documentation}
	 */
	AlgoliaSearch.prototype.addApiKey = function(acls, params, callback) {
	  var isArray = __webpack_require__(14);
	  var usage = 'Usage: client.addApiKey(arrayOfAcls[, params, callback])';
	
	  if (!isArray(acls)) {
	    throw new Error(usage);
	  }
	
	  if (arguments.length === 1 || typeof params === 'function') {
	    callback = params;
	    params = null;
	  }
	
	  var postObj = {
	    acl: acls
	  };
	
	  if (params) {
	    postObj.validity = params.validity;
	    postObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
	    postObj.maxHitsPerQuery = params.maxHitsPerQuery;
	    postObj.indexes = params.indexes;
	    postObj.description = params.description;
	
	    if (params.queryParameters) {
	      postObj.queryParameters = this._getSearchParams(params.queryParameters, '');
	    }
	
	    postObj.referers = params.referers;
	  }
	
	  return this._jsonRequest({
	    method: 'POST',
	    url: '/1/keys',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * @deprecated Please use client.addApiKey()
	 */
	AlgoliaSearch.prototype.addUserKeyWithValidity = deprecate(function(acls, params, callback) {
	  return this.addApiKey(acls, params, callback);
	}, deprecatedMessage('client.addUserKeyWithValidity()', 'client.addApiKey()'));
	
	/**
	 * @deprecated Please use client.updateApiKey()
	 */
	AlgoliaSearch.prototype.updateUserKey = deprecate(function(key, acls, params, callback) {
	  return this.updateApiKey(key, acls, params, callback);
	}, deprecatedMessage('client.updateUserKey()', 'client.updateApiKey()'));
	
	/**
	 * Update an existing API key
	 * @param {string} key - The key to update
	 * @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
	 *   can contains the following values:
	 *     - search: allow to search (https and http)
	 *     - addObject: allows to add/update an object in the index (https only)
	 *     - deleteObject : allows to delete an existing object (https only)
	 *     - deleteIndex : allows to delete index content (https only)
	 *     - settings : allows to get index settings (https only)
	 *     - editSettings : allows to change index settings (https only)
	 * @param {Object} [params] - Optionnal parameters to set for the key
	 * @param {number} params.validity - Number of seconds after which the key will be automatically removed (0 means no time limit for this key)
	 * @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
	 * @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
	 * @param {string[]} params.indexes - Allowed targeted indexes for this key
	 * @param {string} params.description - A description for your key
	 * @param {string[]} params.referers - A list of authorized referers
	 * @param {Object} params.queryParameters - Force the key to use specific query parameters
	 * @param {Function} callback - The result callback called with two arguments
	 *   error: null or Error('message')
	 *   content: the server answer with the modified API key
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.updateApiKey('APIKEY', ['search'], {
	 *   validity: 300,
	 *   maxQueriesPerIPPerHour: 2000,
	 *   maxHitsPerQuery: 3,
	 *   indexes: ['fruits'],
	 *   description: 'Eat three fruits',
	 *   referers: ['*.algolia.com'],
	 *   queryParameters: {
	 *     tagFilters: ['public'],
	 *   }
	 * })
	 * @see {@link https://www.algolia.com/doc/rest_api#UpdateIndexKey|Algolia REST API Documentation}
	 */
	AlgoliaSearch.prototype.updateApiKey = function(key, acls, params, callback) {
	  var isArray = __webpack_require__(14);
	  var usage = 'Usage: client.updateApiKey(key, arrayOfAcls[, params, callback])';
	
	  if (!isArray(acls)) {
	    throw new Error(usage);
	  }
	
	  if (arguments.length === 2 || typeof params === 'function') {
	    callback = params;
	    params = null;
	  }
	
	  var putObj = {
	    acl: acls
	  };
	
	  if (params) {
	    putObj.validity = params.validity;
	    putObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
	    putObj.maxHitsPerQuery = params.maxHitsPerQuery;
	    putObj.indexes = params.indexes;
	    putObj.description = params.description;
	
	    if (params.queryParameters) {
	      putObj.queryParameters = this._getSearchParams(params.queryParameters, '');
	    }
	
	    putObj.referers = params.referers;
	  }
	
	  return this._jsonRequest({
	    method: 'PUT',
	    url: '/1/keys/' + key,
	    body: putObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * Initialize a new batch of search queries
	 * @deprecated use client.search()
	 */
	AlgoliaSearch.prototype.startQueriesBatch = deprecate(function startQueriesBatchDeprecated() {
	  this._batch = [];
	}, deprecatedMessage('client.startQueriesBatch()', 'client.search()'));
	
	/**
	 * Add a search query in the batch
	 * @deprecated use client.search()
	 */
	AlgoliaSearch.prototype.addQueryInBatch = deprecate(function addQueryInBatchDeprecated(indexName, query, args) {
	  this._batch.push({
	    indexName: indexName,
	    query: query,
	    params: args
	  });
	}, deprecatedMessage('client.addQueryInBatch()', 'client.search()'));
	
	/**
	 * Launch the batch of queries using XMLHttpRequest.
	 * @deprecated use client.search()
	 */
	AlgoliaSearch.prototype.sendQueriesBatch = deprecate(function sendQueriesBatchDeprecated(callback) {
	  return this.search(this._batch, callback);
	}, deprecatedMessage('client.sendQueriesBatch()', 'client.search()'));
	
	/**
	 * Perform write operations across multiple indexes.
	 *
	 * To reduce the amount of time spent on network round trips,
	 * you can create, update, or delete several objects in one call,
	 * using the batch endpoint (all operations are done in the given order).
	 *
	 * Available actions:
	 *   - addObject
	 *   - updateObject
	 *   - partialUpdateObject
	 *   - partialUpdateObjectNoCreate
	 *   - deleteObject
	 *
	 * https://www.algolia.com/doc/rest_api#Indexes
	 * @param  {Object[]} operations An array of operations to perform
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.batch([{
	 *   action: 'addObject',
	 *   indexName: 'clients',
	 *   body: {
	 *     name: 'Bill'
	 *   }
	 * }, {
	 *   action: 'udpateObject',
	 *   indexName: 'fruits',
	 *   body: {
	 *     objectID: '29138',
	 *     name: 'banana'
	 *   }
	 * }], cb)
	 */
	AlgoliaSearch.prototype.batch = function(operations, callback) {
	  var isArray = __webpack_require__(14);
	  var usage = 'Usage: client.batch(operations[, callback])';
	
	  if (!isArray(operations)) {
	    throw new Error(usage);
	  }
	
	  return this._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/*/batch',
	    body: {
	      requests: operations
	    },
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * Assign or Move a userID to a cluster
	 *
	 * @param {string} data.userID The userID to assign to a new cluster
	 * @param {string} data.cluster The cluster to assign the user to
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.assignUserID({ cluster: 'c1-test', userID: 'some-user' });
	 */
	AlgoliaSearch.prototype.assignUserID = function(data, callback) {
	  if (!data.userID || !data.cluster) {
	    throw new errors.AlgoliaSearchError('You have to provide both a userID and cluster', data);
	  }
	  return this._jsonRequest({
	    method: 'POST',
	    url: '/1/clusters/mapping',
	    hostType: 'write',
	    body: {cluster: data.cluster},
	    callback: callback,
	    headers: {
	      'x-algolia-user-id': data.userID
	    }
	  });
	};
	
	/**
	 * Assign a array of userIDs to a cluster.
	 *
	 * @param {Array} data.userIDs The array of userIDs to assign to a new cluster
	 * @param {string} data.cluster The cluster to assign the user to
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.assignUserIDs({ cluster: 'c1-test', userIDs: ['some-user-1', 'some-user-2'] });
	 */
	AlgoliaSearch.prototype.assignUserIDs = function(data, callback) {
	  if (!data.userIDs || !data.cluster) {
	    throw new errors.AlgoliaSearchError('You have to provide both an array of userIDs and cluster', data);
	  }
	  return this._jsonRequest({
	    method: 'POST',
	    url: '/1/clusters/mapping/batch',
	    hostType: 'write',
	    body: {
	      cluster: data.cluster,
	      users: data.userIDs
	    },
	    callback: callback
	  });
	};
	
	/**
	 * Get the top userIDs
	 *
	 * (the callback is the second argument)
	 *
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.getTopUserID();
	 */
	AlgoliaSearch.prototype.getTopUserID = function(callback) {
	  return this._jsonRequest({
	    method: 'GET',
	    url: '/1/clusters/mapping/top',
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/**
	 * Get userID
	 *
	 * @param {string} data.userID The userID to get info about
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.getUserID({ userID: 'some-user' });
	 */
	AlgoliaSearch.prototype.getUserID = function(data, callback) {
	  if (!data.userID) {
	    throw new errors.AlgoliaSearchError('You have to provide a userID', {debugData: data});
	  }
	  return this._jsonRequest({
	    method: 'GET',
	    url: '/1/clusters/mapping/' + data.userID,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/**
	 * List all the clusters
	 *
	 * (the callback is the second argument)
	 *
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.listClusters();
	 */
	AlgoliaSearch.prototype.listClusters = function(callback) {
	  return this._jsonRequest({
	    method: 'GET',
	    url: '/1/clusters',
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/**
	 * List the userIDs
	 *
	 * (the callback is the second argument)
	 *
	 * @param {string} data.hitsPerPage How many hits on every page
	 * @param {string} data.page The page to retrieve
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.listClusters();
	 * client.listClusters({ page: 3, hitsPerPage: 30});
	 */
	AlgoliaSearch.prototype.listUserIDs = function(data, callback) {
	  return this._jsonRequest({
	    method: 'GET',
	    url: '/1/clusters/mapping',
	    body: data,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/**
	 * Remove an userID
	 *
	 * @param {string} data.userID The userID to assign to a new cluster
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.removeUserID({ userID: 'some-user' });
	 */
	AlgoliaSearch.prototype.removeUserID = function(data, callback) {
	  if (!data.userID) {
	    throw new errors.AlgoliaSearchError('You have to provide a userID', {debugData: data});
	  }
	  return this._jsonRequest({
	    method: 'DELETE',
	    url: '/1/clusters/mapping',
	    hostType: 'write',
	    callback: callback,
	    headers: {
	      'x-algolia-user-id': data.userID
	    }
	  });
	};
	
	/**
	 * Search for userIDs
	 *
	 * @param {string} data.cluster The cluster to target
	 * @param {string} data.query The query to execute
	 * @param {string} data.hitsPerPage How many hits on every page
	 * @param {string} data.page The page to retrieve
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.searchUserIDs({ cluster: 'c1-test', query: 'some-user' });
	 * client.searchUserIDs({
	 *   cluster: "c1-test",
	 *   query: "some-user",
	 *   page: 3,
	 *   hitsPerPage: 2
	 * });
	 */
	AlgoliaSearch.prototype.searchUserIDs = function(data, callback) {
	  return this._jsonRequest({
	    method: 'POST',
	    url: '/1/clusters/mapping/search',
	    body: data,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	/**
	 * Set strategy for personalization
	 *
	 * @param {Object} data
	 * @param {Object} data.eventsScoring Associate a score to an event
	 * @param {Object} data.eventsScoring.<eventName> The name of the event
	 * @param {Number} data.eventsScoring.<eventName>.score The score to associate to <eventName>
	 * @param {String} data.eventsScoring.<eventName>.type Either "click", "conversion" or "view"
	 * @param {Object} data.facetsScoring Associate a score to a facet
	 * @param {Object} data.facetsScoring.<facetName> The name of the facet
	 * @param {Number} data.facetsScoring.<facetName>.score The score to associate to <facetName>
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.setPersonalizationStrategy({
	 *   eventsScoring: {
	 *      "Add to cart": { score: 50, type: "conversion" },
	 *      Purchase: { score: 100, type: "conversion" }
	 *   },
	 *   facetsScoring: {
	 *      brand: { score: 100 },
	 *      categories: { score: 10 }
	 *   }
	 * });
	 */
	AlgoliaSearch.prototype.setPersonalizationStrategy = function(data, callback) {
	  return this._jsonRequest({
	    method: 'POST',
	    url: '/1/recommendation/personalization/strategy',
	    body: data,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/**
	 * Get strategy for personalization
	 *
	 * @return {Promise|undefined} Returns a promise if no callback given
	 * @example
	 * client.getPersonalizationStrategy();
	 */
	
	AlgoliaSearch.prototype.getPersonalizationStrategy = function(callback) {
	  return this._jsonRequest({
	    method: 'GET',
	    url: '/1/recommendation/personalization/strategy',
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	// environment specific methods
	AlgoliaSearch.prototype.destroy = notImplemented;
	AlgoliaSearch.prototype.enableRateLimitForward = notImplemented;
	AlgoliaSearch.prototype.disableRateLimitForward = notImplemented;
	AlgoliaSearch.prototype.useSecuredAPIKey = notImplemented;
	AlgoliaSearch.prototype.disableSecuredAPIKey = notImplemented;
	AlgoliaSearch.prototype.generateSecuredApiKey = notImplemented;
	AlgoliaSearch.prototype.getSecuredApiKeyRemainingValidity = notImplemented;
	
	function notImplemented() {
	  var message = 'Not implemented in this environment.\n' +
	    'If you feel this is a mistake, write to support@algolia.com';
	
	  throw new errors.AlgoliaSearchError(message);
	}


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = AlgoliaSearchCore;
	
	var errors = __webpack_require__(39);
	var exitPromise = __webpack_require__(127);
	var IndexCore = __webpack_require__(124);
	var store = __webpack_require__(212);
	
	// We will always put the API KEY in the JSON body in case of too long API KEY,
	// to avoid query string being too long and failing in various conditions (our server limit, browser limit,
	// proxies limit)
	var MAX_API_KEY_LENGTH = 500;
	var RESET_APP_DATA_TIMER =
	  ({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public","GATSBY_TELEMETRY_DISABLED":"1"}).RESET_APP_DATA_TIMER && parseInt(({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public","GATSBY_TELEMETRY_DISABLED":"1"}).RESET_APP_DATA_TIMER, 10) ||
	  60 * 2 * 1000; // after 2 minutes reset to first host
	
	/*
	 * Algolia Search library initialization
	 * https://www.algolia.com/
	 *
	 * @param {string} applicationID - Your applicationID, found in your dashboard
	 * @param {string} apiKey - Your API key, found in your dashboard
	 * @param {Object} [opts]
	 * @param {number} [opts.timeout=2000] - The request timeout set in milliseconds,
	 * another request will be issued after this timeout
	 * @param {string} [opts.protocol='https:'] - The protocol used to query Algolia Search API.
	 *                                        Set to 'http:' to force using http.
	 * @param {Object|Array} [opts.hosts={
	 *           read: [this.applicationID + '-dsn.algolia.net'].concat([
	 *             this.applicationID + '-1.algolianet.com',
	 *             this.applicationID + '-2.algolianet.com',
	 *             this.applicationID + '-3.algolianet.com']
	 *           ]),
	 *           write: [this.applicationID + '.algolia.net'].concat([
	 *             this.applicationID + '-1.algolianet.com',
	 *             this.applicationID + '-2.algolianet.com',
	 *             this.applicationID + '-3.algolianet.com']
	 *           ]) - The hosts to use for Algolia Search API.
	 *           If you provide them, you will less benefit from our HA implementation
	 */
	function AlgoliaSearchCore(applicationID, apiKey, opts) {
	  var debug = __webpack_require__(77)('algoliasearch');
	
	  var clone = __webpack_require__(25);
	  var isArray = __webpack_require__(14);
	  var map = __webpack_require__(40);
	
	  var usage = 'Usage: algoliasearch(applicationID, apiKey, opts)';
	
	  if (opts._allowEmptyCredentials !== true && !applicationID) {
	    throw new errors.AlgoliaSearchError('Please provide an application ID. ' + usage);
	  }
	
	  if (opts._allowEmptyCredentials !== true && !apiKey) {
	    throw new errors.AlgoliaSearchError('Please provide an API key. ' + usage);
	  }
	
	  this.applicationID = applicationID;
	  this.apiKey = apiKey;
	
	  this.hosts = {
	    read: [],
	    write: []
	  };
	
	  opts = opts || {};
	
	  this._timeouts = opts.timeouts || {
	    connect: 1 * 1000, // 500ms connect is GPRS latency
	    read: 2 * 1000,
	    write: 30 * 1000
	  };
	
	  // backward compat, if opts.timeout is passed, we use it to configure all timeouts like before
	  if (opts.timeout) {
	    this._timeouts.connect = this._timeouts.read = this._timeouts.write = opts.timeout;
	  }
	
	  var protocol = opts.protocol || 'https:';
	  // while we advocate for colon-at-the-end values: 'http:' for `opts.protocol`
	  // we also accept `http` and `https`. It's a common error.
	  if (!/:$/.test(protocol)) {
	    protocol = protocol + ':';
	  }
	
	  if (protocol !== 'http:' && protocol !== 'https:') {
	    throw new errors.AlgoliaSearchError('protocol must be `http:` or `https:` (was `' + opts.protocol + '`)');
	  }
	
	  this._checkAppIdData();
	
	  if (!opts.hosts) {
	    var defaultHosts = map(this._shuffleResult, function(hostNumber) {
	      return applicationID + '-' + hostNumber + '.algolianet.com';
	    });
	
	    // no hosts given, compute defaults
	    var mainSuffix = (opts.dsn === false ? '' : '-dsn') + '.algolia.net';
	    this.hosts.read = [this.applicationID + mainSuffix].concat(defaultHosts);
	    this.hosts.write = [this.applicationID + '.algolia.net'].concat(defaultHosts);
	  } else if (isArray(opts.hosts)) {
	    // when passing custom hosts, we need to have a different host index if the number
	    // of write/read hosts are different.
	    this.hosts.read = clone(opts.hosts);
	    this.hosts.write = clone(opts.hosts);
	  } else {
	    this.hosts.read = clone(opts.hosts.read);
	    this.hosts.write = clone(opts.hosts.write);
	  }
	
	  // add protocol and lowercase hosts
	  this.hosts.read = map(this.hosts.read, prepareHost(protocol));
	  this.hosts.write = map(this.hosts.write, prepareHost(protocol));
	
	  this.extraHeaders = {};
	
	  // In some situations you might want to warm the cache
	  this.cache = opts._cache || {};
	
	  this._ua = opts._ua;
	  this._useCache = opts._useCache === undefined || opts._cache ? true : opts._useCache;
	  this._useRequestCache = this._useCache && opts._useRequestCache;
	  this._useFallback = opts.useFallback === undefined ? true : opts.useFallback;
	
	  this._setTimeout = opts._setTimeout;
	
	  debug('init done, %j', this);
	}
	
	/*
	 * Get the index object initialized
	 *
	 * @param indexName the name of index
	 * @param callback the result callback with one argument (the Index instance)
	 */
	AlgoliaSearchCore.prototype.initIndex = function(indexName) {
	  return new IndexCore(this, indexName);
	};
	
	/**
	* Add an extra field to the HTTP request
	*
	* @param name the header field name
	* @param value the header field value
	*/
	AlgoliaSearchCore.prototype.setExtraHeader = function(name, value) {
	  this.extraHeaders[name.toLowerCase()] = value;
	};
	
	/**
	* Get the value of an extra HTTP header
	*
	* @param name the header field name
	*/
	AlgoliaSearchCore.prototype.getExtraHeader = function(name) {
	  return this.extraHeaders[name.toLowerCase()];
	};
	
	/**
	* Remove an extra field from the HTTP request
	*
	* @param name the header field name
	*/
	AlgoliaSearchCore.prototype.unsetExtraHeader = function(name) {
	  delete this.extraHeaders[name.toLowerCase()];
	};
	
	/**
	* Augment sent x-algolia-agent with more data, each agent part
	* is automatically separated from the others by a semicolon;
	*
	* @param algoliaAgent the agent to add
	*/
	AlgoliaSearchCore.prototype.addAlgoliaAgent = function(algoliaAgent) {
	  var algoliaAgentWithDelimiter = '; ' + algoliaAgent;
	
	  if (this._ua.indexOf(algoliaAgentWithDelimiter) === -1) {
	    this._ua += algoliaAgentWithDelimiter;
	  }
	};
	
	/*
	 * Wrapper that try all hosts to maximize the quality of service
	 */
	AlgoliaSearchCore.prototype._jsonRequest = function(initialOpts) {
	  this._checkAppIdData();
	
	  var requestDebug = __webpack_require__(77)('algoliasearch:' + initialOpts.url);
	
	
	  var body;
	  var cacheID;
	  var additionalUA = initialOpts.additionalUA || '';
	  var cache = initialOpts.cache;
	  var client = this;
	  var tries = 0;
	  var usingFallback = false;
	  var hasFallback = client._useFallback && client._request.fallback && initialOpts.fallback;
	  var headers;
	
	  if (
	    this.apiKey.length > MAX_API_KEY_LENGTH &&
	    initialOpts.body !== undefined &&
	    (initialOpts.body.params !== undefined || // index.search()
	    initialOpts.body.requests !== undefined) // client.search()
	  ) {
	    initialOpts.body.apiKey = this.apiKey;
	    headers = this._computeRequestHeaders({
	      additionalUA: additionalUA,
	      withApiKey: false,
	      headers: initialOpts.headers
	    });
	  } else {
	    headers = this._computeRequestHeaders({
	      additionalUA: additionalUA,
	      headers: initialOpts.headers
	    });
	  }
	
	  if (initialOpts.body !== undefined) {
	    body = safeJSONStringify(initialOpts.body);
	  }
	
	  requestDebug('request start');
	  var debugData = [];
	
	
	  function doRequest(requester, reqOpts) {
	    client._checkAppIdData();
	
	    var startTime = new Date();
	
	    if (client._useCache && !client._useRequestCache) {
	      cacheID = initialOpts.url;
	    }
	
	    // as we sometime use POST requests to pass parameters (like query='aa'),
	    // the cacheID must also include the body to be different between calls
	    if (client._useCache && !client._useRequestCache && body) {
	      cacheID += '_body_' + reqOpts.body;
	    }
	
	    // handle cache existence
	    if (isCacheValidWithCurrentID(!client._useRequestCache, cache, cacheID)) {
	      requestDebug('serving response from cache');
	
	      var responseText = cache[cacheID];
	
	      // Cache response must match the type of the original one
	      return client._promise.resolve({
	        body: JSON.parse(responseText),
	        responseText: responseText
	      });
	    }
	
	    // if we reached max tries
	    if (tries >= client.hosts[initialOpts.hostType].length) {
	      if (!hasFallback || usingFallback) {
	        requestDebug('could not get any response');
	        // then stop
	        return client._promise.reject(new errors.AlgoliaSearchError(
	          'Cannot connect to the AlgoliaSearch API.' +
	          ' Send an email to support@algolia.com to report and resolve the issue.' +
	          ' Application id was: ' + client.applicationID, {debugData: debugData}
	        ));
	      }
	
	      requestDebug('switching to fallback');
	
	      // let's try the fallback starting from here
	      tries = 0;
	
	      // method, url and body are fallback dependent
	      reqOpts.method = initialOpts.fallback.method;
	      reqOpts.url = initialOpts.fallback.url;
	      reqOpts.jsonBody = initialOpts.fallback.body;
	      if (reqOpts.jsonBody) {
	        reqOpts.body = safeJSONStringify(reqOpts.jsonBody);
	      }
	      // re-compute headers, they could be omitting the API KEY
	      headers = client._computeRequestHeaders({
	        additionalUA: additionalUA,
	        headers: initialOpts.headers
	      });
	
	      reqOpts.timeouts = client._getTimeoutsForRequest(initialOpts.hostType);
	      client._setHostIndexByType(0, initialOpts.hostType);
	      usingFallback = true; // the current request is now using fallback
	      return doRequest(client._request.fallback, reqOpts);
	    }
	
	    var currentHost = client._getHostByType(initialOpts.hostType);
	
	    var url = currentHost + reqOpts.url;
	    var options = {
	      body: reqOpts.body,
	      jsonBody: reqOpts.jsonBody,
	      method: reqOpts.method,
	      headers: headers,
	      timeouts: reqOpts.timeouts,
	      debug: requestDebug,
	      forceAuthHeaders: reqOpts.forceAuthHeaders
	    };
	
	    requestDebug('method: %s, url: %s, headers: %j, timeouts: %d',
	      options.method, url, options.headers, options.timeouts);
	
	    if (requester === client._request.fallback) {
	      requestDebug('using fallback');
	    }
	
	    // `requester` is any of this._request or this._request.fallback
	    // thus it needs to be called using the client as context
	    return requester.call(client, url, options).then(success, tryFallback);
	
	    function success(httpResponse) {
	      // compute the status of the response,
	      //
	      // When in browser mode, using XDR or JSONP, we have no statusCode available
	      // So we rely on our API response `status` property.
	      // But `waitTask` can set a `status` property which is not the statusCode (it's the task status)
	      // So we check if there's a `message` along `status` and it means it's an error
	      //
	      // That's the only case where we have a response.status that's not the http statusCode
	      var status = httpResponse && httpResponse.body && httpResponse.body.message && httpResponse.body.status ||
	
	        // this is important to check the request statusCode AFTER the body eventual
	        // statusCode because some implementations (jQuery XDomainRequest transport) may
	        // send statusCode 200 while we had an error
	        httpResponse.statusCode ||
	
	        // When in browser mode, using XDR or JSONP
	        // we default to success when no error (no response.status && response.message)
	        // If there was a JSON.parse() error then body is null and it fails
	        httpResponse && httpResponse.body && 200;
	
	      requestDebug('received response: statusCode: %s, computed statusCode: %d, headers: %j',
	        httpResponse.statusCode, status, httpResponse.headers);
	
	      var httpResponseOk = Math.floor(status / 100) === 2;
	
	      var endTime = new Date();
	      debugData.push({
	        currentHost: currentHost,
	        headers: removeCredentials(headers),
	        content: body || null,
	        contentLength: body !== undefined ? body.length : null,
	        method: reqOpts.method,
	        timeouts: reqOpts.timeouts,
	        url: reqOpts.url,
	        startTime: startTime,
	        endTime: endTime,
	        duration: endTime - startTime,
	        statusCode: status
	      });
	
	      if (httpResponseOk) {
	        if (client._useCache && !client._useRequestCache && cache) {
	          cache[cacheID] = httpResponse.responseText;
	        }
	
	        return {
	          responseText: httpResponse.responseText,
	          body: httpResponse.body
	        };
	      }
	
	      var shouldRetry = Math.floor(status / 100) !== 4;
	
	      if (shouldRetry) {
	        tries += 1;
	        return retryRequest();
	      }
	
	      requestDebug('unrecoverable error');
	
	      // no success and no retry => fail
	      var unrecoverableError = new errors.AlgoliaSearchError(
	        httpResponse.body && httpResponse.body.message, {debugData: debugData, statusCode: status}
	      );
	
	      return client._promise.reject(unrecoverableError);
	    }
	
	    function tryFallback(err) {
	      // error cases:
	      //  While not in fallback mode:
	      //    - CORS not supported
	      //    - network error
	      //  While in fallback mode:
	      //    - timeout
	      //    - network error
	      //    - badly formatted JSONP (script loaded, did not call our callback)
	      //  In both cases:
	      //    - uncaught exception occurs (TypeError)
	      requestDebug('error: %s, stack: %s', err.message, err.stack);
	
	      var endTime = new Date();
	      debugData.push({
	        currentHost: currentHost,
	        headers: removeCredentials(headers),
	        content: body || null,
	        contentLength: body !== undefined ? body.length : null,
	        method: reqOpts.method,
	        timeouts: reqOpts.timeouts,
	        url: reqOpts.url,
	        startTime: startTime,
	        endTime: endTime,
	        duration: endTime - startTime
	      });
	
	      if (!(err instanceof errors.AlgoliaSearchError)) {
	        err = new errors.Unknown(err && err.message, err);
	      }
	
	      tries += 1;
	
	      // stop the request implementation when:
	      if (
	        // we did not generate this error,
	        // it comes from a throw in some other piece of code
	        err instanceof errors.Unknown ||
	
	        // server sent unparsable JSON
	        err instanceof errors.UnparsableJSON ||
	
	        // max tries and already using fallback or no fallback
	        tries >= client.hosts[initialOpts.hostType].length &&
	        (usingFallback || !hasFallback)) {
	        // stop request implementation for this command
	        err.debugData = debugData;
	        return client._promise.reject(err);
	      }
	
	      // When a timeout occurred, retry by raising timeout
	      if (err instanceof errors.RequestTimeout) {
	        return retryRequestWithHigherTimeout();
	      }
	
	      return retryRequest();
	    }
	
	    function retryRequest() {
	      requestDebug('retrying request');
	      client._incrementHostIndex(initialOpts.hostType);
	      return doRequest(requester, reqOpts);
	    }
	
	    function retryRequestWithHigherTimeout() {
	      requestDebug('retrying request with higher timeout');
	      client._incrementHostIndex(initialOpts.hostType);
	      client._incrementTimeoutMultipler();
	      reqOpts.timeouts = client._getTimeoutsForRequest(initialOpts.hostType);
	      return doRequest(requester, reqOpts);
	    }
	  }
	
	  function isCacheValidWithCurrentID(
	    useRequestCache,
	    currentCache,
	    currentCacheID
	  ) {
	    return (
	      client._useCache &&
	      useRequestCache &&
	      currentCache &&
	      currentCache[currentCacheID] !== undefined
	    );
	  }
	
	
	  function interopCallbackReturn(request, callback) {
	    if (isCacheValidWithCurrentID(client._useRequestCache, cache, cacheID)) {
	      request.catch(function() {
	        // Release the cache on error
	        delete cache[cacheID];
	      });
	    }
	
	    if (typeof initialOpts.callback === 'function') {
	      // either we have a callback
	      request.then(function okCb(content) {
	        exitPromise(function() {
	          initialOpts.callback(null, callback(content));
	        }, client._setTimeout || setTimeout);
	      }, function nookCb(err) {
	        exitPromise(function() {
	          initialOpts.callback(err);
	        }, client._setTimeout || setTimeout);
	      });
	    } else {
	      // either we are using promises
	      return request.then(callback);
	    }
	  }
	
	  if (client._useCache && client._useRequestCache) {
	    cacheID = initialOpts.url;
	  }
	
	  // as we sometime use POST requests to pass parameters (like query='aa'),
	  // the cacheID must also include the body to be different between calls
	  if (client._useCache && client._useRequestCache && body) {
	    cacheID += '_body_' + body;
	  }
	
	  if (isCacheValidWithCurrentID(client._useRequestCache, cache, cacheID)) {
	    requestDebug('serving request from cache');
	
	    var maybePromiseForCache = cache[cacheID];
	
	    // In case the cache is warmup with value that is not a promise
	    var promiseForCache = typeof maybePromiseForCache.then !== 'function'
	      ? client._promise.resolve({responseText: maybePromiseForCache})
	      : maybePromiseForCache;
	
	    return interopCallbackReturn(promiseForCache, function(content) {
	      // In case of the cache request, return the original value
	      return JSON.parse(content.responseText);
	    });
	  }
	
	  var request = doRequest(
	    client._request, {
	      url: initialOpts.url,
	      method: initialOpts.method,
	      body: body,
	      jsonBody: initialOpts.body,
	      timeouts: client._getTimeoutsForRequest(initialOpts.hostType),
	      forceAuthHeaders: initialOpts.forceAuthHeaders
	    }
	  );
	
	  if (client._useCache && client._useRequestCache && cache) {
	    cache[cacheID] = request;
	  }
	
	  return interopCallbackReturn(request, function(content) {
	    // In case of the first request, return the JSON value
	    return content.body;
	  });
	};
	
	/*
	* Transform search param object in query string
	* @param {object} args arguments to add to the current query string
	* @param {string} params current query string
	* @return {string} the final query string
	*/
	AlgoliaSearchCore.prototype._getSearchParams = function(args, params) {
	  if (args === undefined || args === null) {
	    return params;
	  }
	  for (var key in args) {
	    if (key !== null && args[key] !== undefined && args.hasOwnProperty(key)) {
	      params += params === '' ? '' : '&';
	      params += key + '=' + encodeURIComponent(Object.prototype.toString.call(args[key]) === '[object Array]' ? safeJSONStringify(args[key]) : args[key]);
	    }
	  }
	  return params;
	};
	
	/**
	 * Compute the headers for a request
	 *
	 * @param [string] options.additionalUA semi-colon separated string with other user agents to add
	 * @param [boolean=true] options.withApiKey Send the api key as a header
	 * @param [Object] options.headers Extra headers to send
	 */
	AlgoliaSearchCore.prototype._computeRequestHeaders = function(options) {
	  var forEach = __webpack_require__(51);
	
	  var ua = options.additionalUA ?
	    this._ua + '; ' + options.additionalUA :
	    this._ua;
	
	  var requestHeaders = {
	    'x-algolia-agent': ua,
	    'x-algolia-application-id': this.applicationID
	  };
	
	  // browser will inline headers in the url, node.js will use http headers
	  // but in some situations, the API KEY will be too long (big secured API keys)
	  // so if the request is a POST and the KEY is very long, we will be asked to not put
	  // it into headers but in the JSON body
	  if (options.withApiKey !== false) {
	    requestHeaders['x-algolia-api-key'] = this.apiKey;
	  }
	
	  if (this.userToken) {
	    requestHeaders['x-algolia-usertoken'] = this.userToken;
	  }
	
	  if (this.securityTags) {
	    requestHeaders['x-algolia-tagfilters'] = this.securityTags;
	  }
	
	  forEach(this.extraHeaders, function addToRequestHeaders(value, key) {
	    requestHeaders[key] = value;
	  });
	
	  if (options.headers) {
	    forEach(options.headers, function addToRequestHeaders(value, key) {
	      requestHeaders[key] = value;
	    });
	  }
	
	  return requestHeaders;
	};
	
	/**
	 * Search through multiple indices at the same time
	 * @param  {Object[]}   queries  An array of queries you want to run.
	 * @param {string} queries[].indexName The index name you want to target
	 * @param {string} [queries[].query] The query to issue on this index. Can also be passed into `params`
	 * @param {Object} queries[].params Any search param like hitsPerPage, ..
	 * @param  {Function} callback Callback to be called
	 * @return {Promise|undefined} Returns a promise if no callback given
	 */
	AlgoliaSearchCore.prototype.search = function(queries, opts, callback) {
	  var isArray = __webpack_require__(14);
	  var map = __webpack_require__(40);
	
	  var usage = 'Usage: client.search(arrayOfQueries[, callback])';
	
	  if (!isArray(queries)) {
	    throw new Error(usage);
	  }
	
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  var client = this;
	
	  var postObj = {
	    requests: map(queries, function prepareRequest(query) {
	      var params = '';
	
	      // allow query.query
	      // so we are mimicing the index.search(query, params) method
	      // {indexName:, query:, params:}
	      if (query.query !== undefined) {
	        params += 'query=' + encodeURIComponent(query.query);
	      }
	
	      return {
	        indexName: query.indexName,
	        params: client._getSearchParams(query.params, params)
	      };
	    })
	  };
	
	  var JSONPParams = map(postObj.requests, function prepareJSONPParams(request, requestId) {
	    return requestId + '=' +
	      encodeURIComponent(
	        '/1/indexes/' + encodeURIComponent(request.indexName) + '?' +
	        request.params
	      );
	  }).join('&');
	
	  var url = '/1/indexes/*/queries';
	
	  if (opts.strategy !== undefined) {
	    postObj.strategy = opts.strategy;
	  }
	
	  return this._jsonRequest({
	    cache: this.cache,
	    method: 'POST',
	    url: url,
	    body: postObj,
	    hostType: 'read',
	    fallback: {
	      method: 'GET',
	      url: '/1/indexes/*',
	      body: {
	        params: JSONPParams
	      }
	    },
	    callback: callback
	  });
	};
	
	/**
	* Search for facet values
	* https://www.algolia.com/doc/rest-api/search#search-for-facet-values
	* This is the top-level API for SFFV.
	*
	* @param {object[]} queries An array of queries to run.
	* @param {string} queries[].indexName Index name, name of the index to search.
	* @param {object} queries[].params Query parameters.
	* @param {string} queries[].params.facetName Facet name, name of the attribute to search for values in.
	* Must be declared as a facet
	* @param {string} queries[].params.facetQuery Query for the facet search
	* @param {string} [queries[].params.*] Any search parameter of Algolia,
	* see https://www.algolia.com/doc/api-client/javascript/search#search-parameters
	* Pagination is not supported. The page and hitsPerPage parameters will be ignored.
	*/
	AlgoliaSearchCore.prototype.searchForFacetValues = function(queries) {
	  var isArray = __webpack_require__(14);
	  var map = __webpack_require__(40);
	
	  var usage = 'Usage: client.searchForFacetValues([{indexName, params: {facetName, facetQuery, ...params}}, ...queries])'; // eslint-disable-line max-len
	
	  if (!isArray(queries)) {
	    throw new Error(usage);
	  }
	
	  var client = this;
	
	  return client._promise.all(map(queries, function performQuery(query) {
	    if (
	      !query ||
	      query.indexName === undefined ||
	      query.params.facetName === undefined ||
	      query.params.facetQuery === undefined
	    ) {
	      throw new Error(usage);
	    }
	
	    var clone = __webpack_require__(25);
	    var omit = __webpack_require__(129);
	
	    var indexName = query.indexName;
	    var params = query.params;
	
	    var facetName = params.facetName;
	    var filteredParams = omit(clone(params), function(keyName) {
	      return keyName === 'facetName';
	    });
	    var searchParameters = client._getSearchParams(filteredParams, '');
	
	    return client._jsonRequest({
	      cache: client.cache,
	      method: 'POST',
	      url:
	        '/1/indexes/' +
	        encodeURIComponent(indexName) +
	        '/facets/' +
	        encodeURIComponent(facetName) +
	        '/query',
	      hostType: 'read',
	      body: {params: searchParameters}
	    });
	  }));
	};
	
	/**
	 * Set the extra security tagFilters header
	 * @param {string|array} tags The list of tags defining the current security filters
	 */
	AlgoliaSearchCore.prototype.setSecurityTags = function(tags) {
	  if (Object.prototype.toString.call(tags) === '[object Array]') {
	    var strTags = [];
	    for (var i = 0; i < tags.length; ++i) {
	      if (Object.prototype.toString.call(tags[i]) === '[object Array]') {
	        var oredTags = [];
	        for (var j = 0; j < tags[i].length; ++j) {
	          oredTags.push(tags[i][j]);
	        }
	        strTags.push('(' + oredTags.join(',') + ')');
	      } else {
	        strTags.push(tags[i]);
	      }
	    }
	    tags = strTags.join(',');
	  }
	
	  this.securityTags = tags;
	};
	
	/**
	 * Set the extra user token header
	 * @param {string} userToken The token identifying a uniq user (used to apply rate limits)
	 */
	AlgoliaSearchCore.prototype.setUserToken = function(userToken) {
	  this.userToken = userToken;
	};
	
	/**
	 * Clear all queries in client's cache
	 * @return undefined
	 */
	AlgoliaSearchCore.prototype.clearCache = function() {
	  this.cache = {};
	};
	
	/**
	* Set the number of milliseconds a request can take before automatically being terminated.
	* @deprecated
	* @param {Number} milliseconds
	*/
	AlgoliaSearchCore.prototype.setRequestTimeout = function(milliseconds) {
	  if (milliseconds) {
	    this._timeouts.connect = this._timeouts.read = this._timeouts.write = milliseconds;
	  }
	};
	
	/**
	* Set the three different (connect, read, write) timeouts to be used when requesting
	* @param {Object} timeouts
	*/
	AlgoliaSearchCore.prototype.setTimeouts = function(timeouts) {
	  this._timeouts = timeouts;
	};
	
	/**
	* Get the three different (connect, read, write) timeouts to be used when requesting
	* @param {Object} timeouts
	*/
	AlgoliaSearchCore.prototype.getTimeouts = function() {
	  return this._timeouts;
	};
	
	AlgoliaSearchCore.prototype._getAppIdData = function() {
	  var data = store.get(this.applicationID);
	  if (data !== null) this._cacheAppIdData(data);
	  return data;
	};
	
	AlgoliaSearchCore.prototype._setAppIdData = function(data) {
	  data.lastChange = (new Date()).getTime();
	  this._cacheAppIdData(data);
	  return store.set(this.applicationID, data);
	};
	
	AlgoliaSearchCore.prototype._checkAppIdData = function() {
	  var data = this._getAppIdData();
	  var now = (new Date()).getTime();
	  if (data === null || now - data.lastChange > RESET_APP_DATA_TIMER) {
	    return this._resetInitialAppIdData(data);
	  }
	
	  return data;
	};
	
	AlgoliaSearchCore.prototype._resetInitialAppIdData = function(data) {
	  var newData = data || {};
	  newData.hostIndexes = {read: 0, write: 0};
	  newData.timeoutMultiplier = 1;
	  newData.shuffleResult = newData.shuffleResult || shuffle([1, 2, 3]);
	  return this._setAppIdData(newData);
	};
	
	AlgoliaSearchCore.prototype._cacheAppIdData = function(data) {
	  this._hostIndexes = data.hostIndexes;
	  this._timeoutMultiplier = data.timeoutMultiplier;
	  this._shuffleResult = data.shuffleResult;
	};
	
	AlgoliaSearchCore.prototype._partialAppIdDataUpdate = function(newData) {
	  var foreach = __webpack_require__(51);
	  var currentData = this._getAppIdData();
	  foreach(newData, function(value, key) {
	    currentData[key] = value;
	  });
	
	  return this._setAppIdData(currentData);
	};
	
	AlgoliaSearchCore.prototype._getHostByType = function(hostType) {
	  return this.hosts[hostType][this._getHostIndexByType(hostType)];
	};
	
	AlgoliaSearchCore.prototype._getTimeoutMultiplier = function() {
	  return this._timeoutMultiplier;
	};
	
	AlgoliaSearchCore.prototype._getHostIndexByType = function(hostType) {
	  return this._hostIndexes[hostType];
	};
	
	AlgoliaSearchCore.prototype._setHostIndexByType = function(hostIndex, hostType) {
	  var clone = __webpack_require__(25);
	  var newHostIndexes = clone(this._hostIndexes);
	  newHostIndexes[hostType] = hostIndex;
	  this._partialAppIdDataUpdate({hostIndexes: newHostIndexes});
	  return hostIndex;
	};
	
	AlgoliaSearchCore.prototype._incrementHostIndex = function(hostType) {
	  return this._setHostIndexByType(
	    (this._getHostIndexByType(hostType) + 1) % this.hosts[hostType].length, hostType
	  );
	};
	
	AlgoliaSearchCore.prototype._incrementTimeoutMultipler = function() {
	  var timeoutMultiplier = Math.max(this._timeoutMultiplier + 1, 4);
	  return this._partialAppIdDataUpdate({timeoutMultiplier: timeoutMultiplier});
	};
	
	AlgoliaSearchCore.prototype._getTimeoutsForRequest = function(hostType) {
	  return {
	    connect: this._timeouts.connect * this._timeoutMultiplier,
	    complete: this._timeouts[hostType] * this._timeoutMultiplier
	  };
	};
	
	function prepareHost(protocol) {
	  return function prepare(host) {
	    return protocol + '//' + host.toLowerCase();
	  };
	}
	
	// Prototype.js < 1.7, a widely used library, defines a weird
	// Array.prototype.toJSON function that will fail to stringify our content
	// appropriately
	// refs:
	//   - https://groups.google.com/forum/#!topic/prototype-core/E-SAVvV_V9Q
	//   - https://github.com/sstephenson/prototype/commit/038a2985a70593c1a86c230fadbdfe2e4898a48c
	//   - http://stackoverflow.com/a/3148441/147079
	function safeJSONStringify(obj) {
	  /* eslint no-extend-native:0 */
	
	  if (Array.prototype.toJSON === undefined) {
	    return JSON.stringify(obj);
	  }
	
	  var toJSON = Array.prototype.toJSON;
	  delete Array.prototype.toJSON;
	  var out = JSON.stringify(obj);
	  Array.prototype.toJSON = toJSON;
	
	  return out;
	}
	
	function shuffle(array) {
	  var currentIndex = array.length;
	  var temporaryValue;
	  var randomIndex;
	
	  // While there remain elements to shuffle...
	  while (currentIndex !== 0) {
	    // Pick a remaining element...
	    randomIndex = Math.floor(Math.random() * currentIndex);
	    currentIndex -= 1;
	
	    // And swap it with the current element.
	    temporaryValue = array[currentIndex];
	    array[currentIndex] = array[randomIndex];
	    array[randomIndex] = temporaryValue;
	  }
	
	  return array;
	}
	
	function removeCredentials(headers) {
	  var newHeaders = {};
	
	  for (var headerName in headers) {
	    if (Object.prototype.hasOwnProperty.call(headers, headerName)) {
	      var value;
	
	      if (headerName === 'x-algolia-api-key' || headerName === 'x-algolia-application-id') {
	        value = '**hidden for security purposes**';
	      } else {
	        value = headers[headerName];
	      }
	
	      newHeaders[headerName] = value;
	    }
	  }
	
	  return newHeaders;
	}


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(62);
	var IndexCore = __webpack_require__(124);
	var deprecate = __webpack_require__(81);
	var deprecatedMessage = __webpack_require__(82);
	var exitPromise = __webpack_require__(127);
	var errors = __webpack_require__(39);
	
	var deprecateForwardToSlaves = deprecate(
	  function() {},
	  deprecatedMessage('forwardToSlaves', 'forwardToReplicas')
	);
	
	module.exports = Index;
	
	function Index() {
	  IndexCore.apply(this, arguments);
	}
	
	inherits(Index, IndexCore);
	
	/*
	* Add an object in this index
	*
	* @param content contains the javascript object to add inside the index
	* @param objectID (optional) an objectID you want to attribute to this object
	* (if the attribute already exist the old object will be overwrite)
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that contains 3 elements: createAt, taskId and objectID
	*/
	Index.prototype.addObject = function(content, objectID, callback) {
	  var indexObj = this;
	
	  if (arguments.length === 1 || typeof objectID === 'function') {
	    callback = objectID;
	    objectID = undefined;
	  }
	
	  return this.as._jsonRequest({
	    method: objectID !== undefined ?
	    'PUT' : // update or create
	    'POST', // create (API generates an objectID)
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + // create
	    (objectID !== undefined ? '/' + encodeURIComponent(objectID) : ''), // update or create
	    body: content,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Add several objects
	*
	* @param objects contains an array of objects to add
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that updateAt and taskID
	*/
	Index.prototype.addObjects = function(objects, callback) {
	  var isArray = __webpack_require__(14);
	  var usage = 'Usage: index.addObjects(arrayOfObjects[, callback])';
	
	  if (!isArray(objects)) {
	    throw new Error(usage);
	  }
	
	  var indexObj = this;
	  var postObj = {
	    requests: []
	  };
	  for (var i = 0; i < objects.length; ++i) {
	    var request = {
	      action: 'addObject',
	      body: objects[i]
	    };
	    postObj.requests.push(request);
	  }
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Update partially an object (only update attributes passed in argument)
	*
	* @param partialObject contains the javascript attributes to override, the
	*  object must contains an objectID attribute
	* @param createIfNotExists (optional) if false, avoid an automatic creation of the object
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that contains 3 elements: createAt, taskId and objectID
	*/
	Index.prototype.partialUpdateObject = function(partialObject, createIfNotExists, callback) {
	  if (arguments.length === 1 || typeof createIfNotExists === 'function') {
	    callback = createIfNotExists;
	    createIfNotExists = undefined;
	  }
	
	  var indexObj = this;
	  var url = '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(partialObject.objectID) + '/partial';
	  if (createIfNotExists === false) {
	    url += '?createIfNotExists=false';
	  }
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: url,
	    body: partialObject,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Partially Override the content of several objects
	*
	* @param objects contains an array of objects to update (each object must contains a objectID attribute)
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that updateAt and taskID
	*/
	Index.prototype.partialUpdateObjects = function(objects, createIfNotExists, callback) {
	  if (arguments.length === 1 || typeof createIfNotExists === 'function') {
	    callback = createIfNotExists;
	    createIfNotExists = true;
	  }
	
	  var isArray = __webpack_require__(14);
	  var usage = 'Usage: index.partialUpdateObjects(arrayOfObjects[, callback])';
	
	  if (!isArray(objects)) {
	    throw new Error(usage);
	  }
	
	  var indexObj = this;
	  var postObj = {
	    requests: []
	  };
	  for (var i = 0; i < objects.length; ++i) {
	    var request = {
	      action: createIfNotExists === true ? 'partialUpdateObject' : 'partialUpdateObjectNoCreate',
	      objectID: objects[i].objectID,
	      body: objects[i]
	    };
	    postObj.requests.push(request);
	  }
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Override the content of object
	*
	* @param object contains the javascript object to save, the object must contains an objectID attribute
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that updateAt and taskID
	*/
	Index.prototype.saveObject = function(object, callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'PUT',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(object.objectID),
	    body: object,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Override the content of several objects
	*
	* @param objects contains an array of objects to update (each object must contains a objectID attribute)
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that updateAt and taskID
	*/
	Index.prototype.saveObjects = function(objects, callback) {
	  var isArray = __webpack_require__(14);
	  var usage = 'Usage: index.saveObjects(arrayOfObjects[, callback])';
	
	  if (!isArray(objects)) {
	    throw new Error(usage);
	  }
	
	  var indexObj = this;
	  var postObj = {
	    requests: []
	  };
	  for (var i = 0; i < objects.length; ++i) {
	    var request = {
	      action: 'updateObject',
	      objectID: objects[i].objectID,
	      body: objects[i]
	    };
	    postObj.requests.push(request);
	  }
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Delete an object from the index
	*
	* @param objectID the unique identifier of object to delete
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that contains 3 elements: createAt, taskId and objectID
	*/
	Index.prototype.deleteObject = function(objectID, callback) {
	  if (typeof objectID === 'function' || typeof objectID !== 'string' && typeof objectID !== 'number') {
	    var err = new errors.AlgoliaSearchError(
	      objectID && typeof objectID !== 'function'
	      ? 'ObjectID must be a string'
	      : 'Cannot delete an object without an objectID'
	    );
	    callback = objectID;
	    if (typeof callback === 'function') {
	      return callback(err);
	    }
	
	    return this.as._promise.reject(err);
	  }
	
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'DELETE',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(objectID),
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Delete several objects from an index
	*
	* @param objectIDs contains an array of objectID to delete
	* @param callback (optional) the result callback called with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that contains 3 elements: createAt, taskId and objectID
	*/
	Index.prototype.deleteObjects = function(objectIDs, callback) {
	  var isArray = __webpack_require__(14);
	  var map = __webpack_require__(40);
	
	  var usage = 'Usage: index.deleteObjects(arrayOfObjectIDs[, callback])';
	
	  if (!isArray(objectIDs)) {
	    throw new Error(usage);
	  }
	
	  var indexObj = this;
	  var postObj = {
	    requests: map(objectIDs, function prepareRequest(objectID) {
	      return {
	        action: 'deleteObject',
	        objectID: objectID,
	        body: {
	          objectID: objectID
	        }
	      };
	    })
	  };
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Delete all objects matching a query
	*
	* @param query the query string
	* @param params the optional query parameters
	* @param callback (optional) the result callback called with one argument
	*  error: null or Error('message')
	* @deprecated see index.deleteBy
	*/
	Index.prototype.deleteByQuery = deprecate(function(query, params, callback) {
	  var clone = __webpack_require__(25);
	  var map = __webpack_require__(40);
	
	  var indexObj = this;
	  var client = indexObj.as;
	
	  if (arguments.length === 1 || typeof params === 'function') {
	    callback = params;
	    params = {};
	  } else {
	    params = clone(params);
	  }
	
	  params.attributesToRetrieve = 'objectID';
	  params.hitsPerPage = 1000;
	  params.distinct = false;
	
	  // when deleting, we should never use cache to get the
	  // search results
	  this.clearCache();
	
	  // there's a problem in how we use the promise chain,
	  // see how waitTask is done
	  var promise = this
	  .search(query, params)
	  .then(stopOrDelete);
	
	  function stopOrDelete(searchContent) {
	    // stop here
	    if (searchContent.nbHits === 0) {
	      // return indexObj.as._request.resolve();
	      return searchContent;
	    }
	
	    // continue and do a recursive call
	    var objectIDs = map(searchContent.hits, function getObjectID(object) {
	      return object.objectID;
	    });
	
	    return indexObj
	    .deleteObjects(objectIDs)
	    .then(waitTask)
	    .then(doDeleteByQuery);
	  }
	
	  function waitTask(deleteObjectsContent) {
	    return indexObj.waitTask(deleteObjectsContent.taskID);
	  }
	
	  function doDeleteByQuery() {
	    return indexObj.deleteByQuery(query, params);
	  }
	
	  if (!callback) {
	    return promise;
	  }
	
	  promise.then(success, failure);
	
	  function success() {
	    exitPromise(function exit() {
	      callback(null);
	    }, client._setTimeout || setTimeout);
	  }
	
	  function failure(err) {
	    exitPromise(function exit() {
	      callback(err);
	    }, client._setTimeout || setTimeout);
	  }
	}, deprecatedMessage('index.deleteByQuery()', 'index.deleteBy()'));
	
	/**
	* Delete all objects matching a query
	*
	* the query parameters that can be used are:
	* - filters (numeric, facet, tag)
	* - geo
	*
	* you can not send an empty query or filters
	*
	* @param params the optional query parameters
	* @param callback (optional) the result callback called with one argument
	*  error: null or Error('message')
	*/
	Index.prototype.deleteBy = function(params, callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/deleteByQuery',
	    body: {params: indexObj.as._getSearchParams(params, '')},
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Browse all content from an index using events. Basically this will do
	* .browse() -> .browseFrom -> .browseFrom -> .. until all the results are returned
	*
	* @param {string} query - The full text query
	* @param {Object} [queryParameters] - Any search query parameter
	* @return {EventEmitter}
	* @example
	* var browser = index.browseAll('cool songs', {
	*   tagFilters: 'public,comments',
	*   hitsPerPage: 500
	* });
	*
	* browser.on('result', function resultCallback(content) {
	*   console.log(content.hits);
	* });
	*
	* // if any error occurs, you get it
	* browser.on('error', function(err) {
	*   throw err;
	* });
	*
	* // when you have browsed the whole index, you get this event
	* browser.on('end', function() {
	*   console.log('finished');
	* });
	*
	* // at any point if you want to stop the browsing process, you can stop it manually
	* // otherwise it will go on and on
	* browser.stop();
	*
	* @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
	*/
	Index.prototype.browseAll = function(query, queryParameters) {
	  if (typeof query === 'object') {
	    queryParameters = query;
	    query = undefined;
	  }
	
	  var merge = __webpack_require__(128);
	
	  var IndexBrowser = __webpack_require__(206);
	
	  var browser = new IndexBrowser();
	  var client = this.as;
	  var index = this;
	  var params = client._getSearchParams(
	    merge({}, queryParameters || {}, {
	      query: query
	    }), ''
	  );
	
	  // start browsing
	  browseLoop();
	
	  function browseLoop(cursor) {
	    if (browser._stopped) {
	      return;
	    }
	
	    var body;
	
	    if (cursor !== undefined) {
	      body = {
	        cursor: cursor
	      };
	    } else {
	      body = {
	        params: params
	      };
	    }
	
	    client._jsonRequest({
	      method: 'POST',
	      url: '/1/indexes/' + encodeURIComponent(index.indexName) + '/browse',
	      hostType: 'read',
	      body: body,
	      callback: browseCallback
	    });
	  }
	
	  function browseCallback(err, content) {
	    if (browser._stopped) {
	      return;
	    }
	
	    if (err) {
	      browser._error(err);
	      return;
	    }
	
	    browser._result(content);
	
	    // no cursor means we are finished browsing
	    if (content.cursor === undefined) {
	      browser._end();
	      return;
	    }
	
	    browseLoop(content.cursor);
	  }
	
	  return browser;
	};
	
	/*
	* Get a Typeahead.js adapter
	* @param searchParams contains an object with query parameters (see search for details)
	*/
	Index.prototype.ttAdapter = deprecate(function(params) {
	  var self = this;
	  return function ttAdapter(query, syncCb, asyncCb) {
	    var cb;
	
	    if (typeof asyncCb === 'function') {
	      // typeahead 0.11
	      cb = asyncCb;
	    } else {
	      // pre typeahead 0.11
	      cb = syncCb;
	    }
	
	    self.search(query, params, function searchDone(err, content) {
	      if (err) {
	        cb(err);
	        return;
	      }
	
	      cb(content.hits);
	    });
	  };
	},
	'ttAdapter is not necessary anymore and will be removed in the next version,\n' +
	'have a look at autocomplete.js (https://github.com/algolia/autocomplete.js)');
	
	/*
	* Wait the publication of a task on the server.
	* All server task are asynchronous and you can check with this method that the task is published.
	*
	* @param taskID the id of the task returned by server
	* @param callback the result callback with with two arguments:
	*  error: null or Error('message')
	*  content: the server answer that contains the list of results
	*/
	Index.prototype.waitTask = function(taskID, callback) {
	  // wait minimum 100ms before retrying
	  var baseDelay = 100;
	  // wait maximum 5s before retrying
	  var maxDelay = 5000;
	  var loop = 0;
	
	  // waitTask() must be handled differently from other methods,
	  // it's a recursive method using a timeout
	  var indexObj = this;
	  var client = indexObj.as;
	
	  var promise = retryLoop();
	
	  function retryLoop() {
	    return client._jsonRequest({
	      method: 'GET',
	      hostType: 'read',
	      url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/task/' + taskID
	    }).then(function success(content) {
	      loop++;
	      var delay = baseDelay * loop * loop;
	      if (delay > maxDelay) {
	        delay = maxDelay;
	      }
	
	      if (content.status !== 'published') {
	        return client._promise.delay(delay).then(retryLoop);
	      }
	
	      return content;
	    });
	  }
	
	  if (!callback) {
	    return promise;
	  }
	
	  promise.then(successCb, failureCb);
	
	  function successCb(content) {
	    exitPromise(function exit() {
	      callback(null, content);
	    }, client._setTimeout || setTimeout);
	  }
	
	  function failureCb(err) {
	    exitPromise(function exit() {
	      callback(err);
	    }, client._setTimeout || setTimeout);
	  }
	};
	
	/*
	* This function deletes the index content. Settings and index specific API keys are kept untouched.
	*
	* @param callback (optional) the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the settings object or the error message if a failure occurred
	*/
	Index.prototype.clearIndex = function(callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/clear',
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	/*
	* Get settings of this index
	*
	* @param opts an object of options to add
	* @param opts.advanced get more settings like nbShards (useful for Enterprise)
	* @param callback (optional) the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the settings object or the error message if a failure occurred
	*/
	Index.prototype.getSettings = function(opts, callback) {
	  if (arguments.length === 1 && typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  opts = opts || {};
	
	  var indexName = encodeURIComponent(this.indexName);
	  return this.as._jsonRequest({
	    method: 'GET',
	    url:
	      '/1/indexes/' +
	      indexName +
	      '/settings?getVersion=2' +
	      (opts.advanced ? '&advanced=' + opts.advanced : ''),
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	Index.prototype.searchSynonyms = function(params, callback) {
	  if (typeof params === 'function') {
	    callback = params;
	    params = {};
	  } else if (params === undefined) {
	    params = {};
	  }
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/search',
	    body: params,
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	function exportData(method, _hitsPerPage, callback) {
	  function search(page, _previous) {
	    var options = {
	      page: page || 0,
	      hitsPerPage: _hitsPerPage || 100
	    };
	    var previous = _previous || [];
	
	    return method(options).then(function(result) {
	      var hits = result.hits;
	      var nbHits = result.nbHits;
	      var current = hits.map(function(s) {
	        delete s._highlightResult;
	        return s;
	      });
	      var synonyms = previous.concat(current);
	      if (synonyms.length < nbHits) {
	        return search(options.page + 1, synonyms);
	      }
	      return synonyms;
	    });
	  }
	  return search().then(function(data) {
	    if (typeof callback === 'function') {
	      callback(data);
	      return undefined;
	    }
	    return data;
	  });
	}
	
	/**
	 * Retrieve all the synonyms in an index
	 * @param [number=100] hitsPerPage The amount of synonyms to retrieve per batch
	 * @param [function] callback will be called after all synonyms are retrieved
	 */
	Index.prototype.exportSynonyms = function(hitsPerPage, callback) {
	  return exportData(this.searchSynonyms.bind(this), hitsPerPage, callback);
	};
	
	Index.prototype.saveSynonym = function(synonym, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  if (opts.forwardToSlaves !== undefined) deprecateForwardToSlaves();
	  var forwardToReplicas = (opts.forwardToSlaves || opts.forwardToReplicas) ? 'true' : 'false';
	
	  return this.as._jsonRequest({
	    method: 'PUT',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/' + encodeURIComponent(synonym.objectID) +
	      '?forwardToReplicas=' + forwardToReplicas,
	    body: synonym,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	Index.prototype.getSynonym = function(objectID, callback) {
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/' + encodeURIComponent(objectID),
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	Index.prototype.deleteSynonym = function(objectID, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  if (opts.forwardToSlaves !== undefined) deprecateForwardToSlaves();
	  var forwardToReplicas = (opts.forwardToSlaves || opts.forwardToReplicas) ? 'true' : 'false';
	
	  return this.as._jsonRequest({
	    method: 'DELETE',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/' + encodeURIComponent(objectID) +
	      '?forwardToReplicas=' + forwardToReplicas,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	Index.prototype.clearSynonyms = function(opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  if (opts.forwardToSlaves !== undefined) deprecateForwardToSlaves();
	  var forwardToReplicas = (opts.forwardToSlaves || opts.forwardToReplicas) ? 'true' : 'false';
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/clear' +
	      '?forwardToReplicas=' + forwardToReplicas,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	Index.prototype.batchSynonyms = function(synonyms, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  if (opts.forwardToSlaves !== undefined) deprecateForwardToSlaves();
	  var forwardToReplicas = (opts.forwardToSlaves || opts.forwardToReplicas) ? 'true' : 'false';
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/batch' +
	      '?forwardToReplicas=' + forwardToReplicas +
	      '&replaceExistingSynonyms=' + (opts.replaceExistingSynonyms ? 'true' : 'false'),
	    hostType: 'write',
	    body: synonyms,
	    callback: callback
	  });
	};
	
	Index.prototype.searchRules = function(params, callback) {
	  if (typeof params === 'function') {
	    callback = params;
	    params = {};
	  } else if (params === undefined) {
	    params = {};
	  }
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/search',
	    body: params,
	    hostType: 'read',
	    callback: callback
	  });
	};
	/**
	 * Retrieve all the query rules in an index
	 * @param [number=100] hitsPerPage The amount of query rules to retrieve per batch
	 * @param [function] callback will be called after all query rules are retrieved
	 *  error: null or Error('message')
	 */
	Index.prototype.exportRules = function(hitsPerPage, callback) {
	  return exportData(this.searchRules.bind(this), hitsPerPage, callback);
	};
	
	Index.prototype.saveRule = function(rule, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  if (!rule.objectID) {
	    throw new errors.AlgoliaSearchError('Missing or empty objectID field for rule');
	  }
	
	  var forwardToReplicas = opts.forwardToReplicas === true ? 'true' : 'false';
	
	  return this.as._jsonRequest({
	    method: 'PUT',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/' + encodeURIComponent(rule.objectID) +
	      '?forwardToReplicas=' + forwardToReplicas,
	    body: rule,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	Index.prototype.getRule = function(objectID, callback) {
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/' + encodeURIComponent(objectID),
	    hostType: 'read',
	    callback: callback
	  });
	};
	
	Index.prototype.deleteRule = function(objectID, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  var forwardToReplicas = opts.forwardToReplicas === true ? 'true' : 'false';
	
	  return this.as._jsonRequest({
	    method: 'DELETE',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/' + encodeURIComponent(objectID) +
	      '?forwardToReplicas=' + forwardToReplicas,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	Index.prototype.clearRules = function(opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  var forwardToReplicas = opts.forwardToReplicas === true ? 'true' : 'false';
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/clear' +
	      '?forwardToReplicas=' + forwardToReplicas,
	    hostType: 'write',
	    callback: callback
	  });
	};
	
	Index.prototype.batchRules = function(rules, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  } else if (opts === undefined) {
	    opts = {};
	  }
	
	  var forwardToReplicas = opts.forwardToReplicas === true ? 'true' : 'false';
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/batch' +
	      '?forwardToReplicas=' + forwardToReplicas +
	      '&clearExistingRules=' + (opts.clearExistingRules === true ? 'true' : 'false'),
	    hostType: 'write',
	    body: rules,
	    callback: callback
	  });
	};
	
	Index.prototype.exists = function(callback) {
	  var result = this.getSettings().then(function() {
	    return true;
	  }).catch(function(err) {
	    if (err instanceof errors.AlgoliaSearchError && err.statusCode === 404) {
	      return false;
	    }
	
	    throw err;
	  });
	
	  if (typeof callback !== 'function') {
	    return result;
	  }
	
	  result.then(function(res) {
	    callback(null, res);
	  }).catch(function(err) {
	    callback(err);
	  });
	};
	
	Index.prototype.findObject = function(findCallback, requestOptions, callback) {
	  requestOptions = requestOptions === undefined ? {} : requestOptions;
	  var paginate = requestOptions.paginate !== undefined ? requestOptions.paginate : true;
	  var query = requestOptions.query !== undefined ? requestOptions.query : '';
	
	  var that = this;
	  var page = 0;
	
	  var paginateLoop = function() {
	    requestOptions.page = page;
	
	    return that.search(query, requestOptions).then(function(result) {
	      var hits = result.hits;
	
	      for (var position = 0; position < hits.length; position++) {
	        var hit = hits[position];
	        if (findCallback(hit)) {
	          return {
	            object: hit,
	            position: position,
	            page: page
	          };
	        }
	      }
	
	      page += 1;
	
	      // paginate if option was set and has next page
	      if (!paginate || page >= result.nbPages) {
	        throw new errors.ObjectNotFound('Object not found');
	      }
	
	      return paginateLoop();
	    });
	  };
	
	  var promise = paginateLoop(page);
	
	  if (callback === undefined) {
	    return promise;
	  }
	
	  promise
	    .then(function(res) {
	      callback(null, res);
	    })
	    .catch(function(err) {
	      callback(err);
	    });
	};
	
	Index.prototype.getObjectPosition = function(result, objectID) {
	  var hits = result.hits;
	
	  for (var position = 0; position < hits.length; position++) {
	    if (hits[position].objectID === objectID) {
	      return position;
	    }
	  }
	
	  return -1;
	};
	
	/*
	* Set settings for this index
	*
	* @param settings the settings object that can contains :
	* - minWordSizefor1Typo: (integer) the minimum number of characters to accept one typo (default = 3).
	* - minWordSizefor2Typos: (integer) the minimum number of characters to accept two typos (default = 7).
	* - hitsPerPage: (integer) the number of hits per page (default = 10).
	* - attributesToRetrieve: (array of strings) default list of attributes to retrieve in objects.
	*   If set to null, all attributes are retrieved.
	* - attributesToHighlight: (array of strings) default list of attributes to highlight.
	*   If set to null, all indexed attributes are highlighted.
	* - attributesToSnippet**: (array of strings) default list of attributes to snippet alongside the number
	* of words to return (syntax is attributeName:nbWords).
	*   By default no snippet is computed. If set to null, no snippet is computed.
	* - attributesToIndex: (array of strings) the list of fields you want to index.
	*   If set to null, all textual and numerical attributes of your objects are indexed,
	*   but you should update it to get optimal results.
	*   This parameter has two important uses:
	*     - Limit the attributes to index: For example if you store a binary image in base64,
	*     you want to store it and be able to
	*       retrieve it but you don't want to search in the base64 string.
	*     - Control part of the ranking*: (see the ranking parameter for full explanation)
	*     Matches in attributes at the beginning of
	*       the list will be considered more important than matches in attributes further down the list.
	*       In one attribute, matching text at the beginning of the attribute will be
	*       considered more important than text after, you can disable
	*       this behavior if you add your attribute inside `unordered(AttributeName)`,
	*       for example attributesToIndex: ["title", "unordered(text)"].
	* - attributesForFaceting: (array of strings) The list of fields you want to use for faceting.
	*   All strings in the attribute selected for faceting are extracted and added as a facet.
	*   If set to null, no attribute is used for faceting.
	* - attributeForDistinct: (string) The attribute name used for the Distinct feature.
	* This feature is similar to the SQL "distinct" keyword: when enabled
	*   in query with the distinct=1 parameter, all hits containing a duplicate
	*   value for this attribute are removed from results.
	*   For example, if the chosen attribute is show_name and several hits have
	*   the same value for show_name, then only the best one is kept and others are removed.
	* - ranking: (array of strings) controls the way results are sorted.
	*   We have six available criteria:
	*    - typo: sort according to number of typos,
	*    - geo: sort according to decreassing distance when performing a geo-location based search,
	*    - proximity: sort according to the proximity of query words in hits,
	*    - attribute: sort according to the order of attributes defined by attributesToIndex,
	*    - exact:
	*        - if the user query contains one word: sort objects having an attribute
	*        that is exactly the query word before others.
	*          For example if you search for the "V" TV show, you want to find it
	*          with the "V" query and avoid to have all popular TV
	*          show starting by the v letter before it.
	*        - if the user query contains multiple words: sort according to the
	*        number of words that matched exactly (and not as a prefix).
	*    - custom: sort according to a user defined formula set in **customRanking** attribute.
	*   The standard order is ["typo", "geo", "proximity", "attribute", "exact", "custom"]
	* - customRanking: (array of strings) lets you specify part of the ranking.
	*   The syntax of this condition is an array of strings containing attributes
	*   prefixed by asc (ascending order) or desc (descending order) operator.
	*   For example `"customRanking" => ["desc(population)", "asc(name)"]`
	* - queryType: Select how the query words are interpreted, it can be one of the following value:
	*   - prefixAll: all query words are interpreted as prefixes,
	*   - prefixLast: only the last word is interpreted as a prefix (default behavior),
	*   - prefixNone: no query word is interpreted as a prefix. This option is not recommended.
	* - highlightPreTag: (string) Specify the string that is inserted before
	* the highlighted parts in the query result (default to "<em>").
	* - highlightPostTag: (string) Specify the string that is inserted after
	* the highlighted parts in the query result (default to "</em>").
	* - optionalWords: (array of strings) Specify a list of words that should
	* be considered as optional when found in the query.
	* @param callback (optional) the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the server answer or the error message if a failure occurred
	*/
	Index.prototype.setSettings = function(settings, opts, callback) {
	  if (arguments.length === 1 || typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	
	  if (opts.forwardToSlaves !== undefined) deprecateForwardToSlaves();
	  var forwardToReplicas = (opts.forwardToSlaves || opts.forwardToReplicas) ? 'true' : 'false';
	
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'PUT',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/settings?forwardToReplicas='
	      + forwardToReplicas,
	    hostType: 'write',
	    body: settings,
	    callback: callback
	  });
	};
	
	/*
	* @deprecated see client.listApiKeys()
	*/
	Index.prototype.listUserKeys = deprecate(function(callback) {
	  return this.listApiKeys(callback);
	}, deprecatedMessage('index.listUserKeys()', 'client.listApiKeys()'));
	
	/*
	* List all existing API keys to this index
	*
	* @param callback the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the server answer with API keys belonging to the index
	*
	* @deprecated see client.listApiKeys()
	*/
	Index.prototype.listApiKeys = deprecate(function(callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/keys',
	    hostType: 'read',
	    callback: callback
	  });
	}, deprecatedMessage('index.listApiKeys()', 'client.listApiKeys()'));
	
	/*
	* @deprecated see client.getApiKey()
	*/
	Index.prototype.getUserKeyACL = deprecate(function(key, callback) {
	  return this.getApiKey(key, callback);
	}, deprecatedMessage('index.getUserKeyACL()', 'client.getApiKey()'));
	
	
	/*
	* Get an API key from this index
	*
	* @param key
	* @param callback the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the server answer with the right API key
	*
	* @deprecated see client.getApiKey()
	*/
	Index.prototype.getApiKey = deprecate(function(key, callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'GET',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/keys/' + key,
	    hostType: 'read',
	    callback: callback
	  });
	}, deprecatedMessage('index.getApiKey()', 'client.getApiKey()'));
	
	/*
	* @deprecated see client.deleteApiKey()
	*/
	Index.prototype.deleteUserKey = deprecate(function(key, callback) {
	  return this.deleteApiKey(key, callback);
	}, deprecatedMessage('index.deleteUserKey()', 'client.deleteApiKey()'));
	
	/*
	* Delete an existing API key associated to this index
	*
	* @param key
	* @param callback the result callback called with two arguments
	*  error: null or Error('message')
	*  content: the server answer with the deletion date
	*
	* @deprecated see client.deleteApiKey()
	*/
	Index.prototype.deleteApiKey = deprecate(function(key, callback) {
	  var indexObj = this;
	  return this.as._jsonRequest({
	    method: 'DELETE',
	    url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/keys/' + key,
	    hostType: 'write',
	    callback: callback
	  });
	}, deprecatedMessage('index.deleteApiKey()', 'client.deleteApiKey()'));
	
	/*
	* @deprecated see client.addApiKey()
	*/
	Index.prototype.addUserKey = deprecate(function(acls, params, callback) {
	  return this.addApiKey(acls, params, callback);
	}, deprecatedMessage('index.addUserKey()', 'client.addApiKey()'));
	
	/*
	* Add a new API key to this index
	*
	* @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
	*   can contains the following values:
	*     - search: allow to search (https and http)
	*     - addObject: allows to add/update an object in the index (https only)
	*     - deleteObject : allows to delete an existing object (https only)
	*     - deleteIndex : allows to delete index content (https only)
	*     - settings : allows to get index settings (https only)
	*     - editSettings : allows to change index settings (https only)
	* @param {Object} [params] - Optionnal parameters to set for the key
	* @param {number} params.validity - Number of seconds after which the key will
	* be automatically removed (0 means no time limit for this key)
	* @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
	* @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
	* @param {string} params.description - A description for your key
	* @param {string[]} params.referers - A list of authorized referers
	* @param {Object} params.queryParameters - Force the key to use specific query parameters
	* @param {Function} callback - The result callback called with two arguments
	*   error: null or Error('message')
	*   content: the server answer with the added API key
	* @return {Promise|undefined} Returns a promise if no callback given
	* @example
	* index.addUserKey(['search'], {
	*   validity: 300,
	*   maxQueriesPerIPPerHour: 2000,
	*   maxHitsPerQuery: 3,
	*   description: 'Eat three fruits',
	*   referers: ['*.algolia.com'],
	*   queryParameters: {
	*     tagFilters: ['public'],
	*   }
	* })
	* @see {@link https://www.algolia.com/doc/rest_api#AddIndexKey|Algolia REST API Documentation}
	*
	* @deprecated see client.addApiKey()
	*/
	Index.prototype.addApiKey = deprecate(function(acls, params, callback) {
	  var isArray = __webpack_require__(14);
	  var usage = 'Usage: index.addApiKey(arrayOfAcls[, params, callback])';
	
	  if (!isArray(acls)) {
	    throw new Error(usage);
	  }
	
	  if (arguments.length === 1 || typeof params === 'function') {
	    callback = params;
	    params = null;
	  }
	
	  var postObj = {
	    acl: acls
	  };
	
	  if (params) {
	    postObj.validity = params.validity;
	    postObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
	    postObj.maxHitsPerQuery = params.maxHitsPerQuery;
	    postObj.description = params.description;
	
	    if (params.queryParameters) {
	      postObj.queryParameters = this.as._getSearchParams(params.queryParameters, '');
	    }
	
	    postObj.referers = params.referers;
	  }
	
	  return this.as._jsonRequest({
	    method: 'POST',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/keys',
	    body: postObj,
	    hostType: 'write',
	    callback: callback
	  });
	}, deprecatedMessage('index.addApiKey()', 'client.addApiKey()'));
	
	/**
	* @deprecated use client.addApiKey()
	*/
	Index.prototype.addUserKeyWithValidity = deprecate(function deprecatedAddUserKeyWithValidity(acls, params, callback) {
	  return this.addApiKey(acls, params, callback);
	}, deprecatedMessage('index.addUserKeyWithValidity()', 'client.addApiKey()'));
	
	/*
	* @deprecated see client.updateApiKey()
	*/
	Index.prototype.updateUserKey = deprecate(function(key, acls, params, callback) {
	  return this.updateApiKey(key, acls, params, callback);
	}, deprecatedMessage('index.updateUserKey()', 'client.updateApiKey()'));
	
	/**
	* Update an existing API key of this index
	* @param {string} key - The key to update
	* @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
	*   can contains the following values:
	*     - search: allow to search (https and http)
	*     - addObject: allows to add/update an object in the index (https only)
	*     - deleteObject : allows to delete an existing object (https only)
	*     - deleteIndex : allows to delete index content (https only)
	*     - settings : allows to get index settings (https only)
	*     - editSettings : allows to change index settings (https only)
	* @param {Object} [params] - Optionnal parameters to set for the key
	* @param {number} params.validity - Number of seconds after which the key will
	* be automatically removed (0 means no time limit for this key)
	* @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
	* @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
	* @param {string} params.description - A description for your key
	* @param {string[]} params.referers - A list of authorized referers
	* @param {Object} params.queryParameters - Force the key to use specific query parameters
	* @param {Function} callback - The result callback called with two arguments
	*   error: null or Error('message')
	*   content: the server answer with user keys list
	* @return {Promise|undefined} Returns a promise if no callback given
	* @example
	* index.updateApiKey('APIKEY', ['search'], {
	*   validity: 300,
	*   maxQueriesPerIPPerHour: 2000,
	*   maxHitsPerQuery: 3,
	*   description: 'Eat three fruits',
	*   referers: ['*.algolia.com'],
	*   queryParameters: {
	*     tagFilters: ['public'],
	*   }
	* })
	* @see {@link https://www.algolia.com/doc/rest_api#UpdateIndexKey|Algolia REST API Documentation}
	*
	* @deprecated see client.updateApiKey()
	*/
	Index.prototype.updateApiKey = deprecate(function(key, acls, params, callback) {
	  var isArray = __webpack_require__(14);
	  var usage = 'Usage: index.updateApiKey(key, arrayOfAcls[, params, callback])';
	
	  if (!isArray(acls)) {
	    throw new Error(usage);
	  }
	
	  if (arguments.length === 2 || typeof params === 'function') {
	    callback = params;
	    params = null;
	  }
	
	  var putObj = {
	    acl: acls
	  };
	
	  if (params) {
	    putObj.validity = params.validity;
	    putObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
	    putObj.maxHitsPerQuery = params.maxHitsPerQuery;
	    putObj.description = params.description;
	
	    if (params.queryParameters) {
	      putObj.queryParameters = this.as._getSearchParams(params.queryParameters, '');
	    }
	
	    putObj.referers = params.referers;
	  }
	
	  return this.as._jsonRequest({
	    method: 'PUT',
	    url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/keys/' + key,
	    body: putObj,
	    hostType: 'write',
	    callback: callback
	  });
	}, deprecatedMessage('index.updateApiKey()', 'client.updateApiKey()'));


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// This is the object returned by the `index.browseAll()` method
	
	module.exports = IndexBrowser;
	
	var inherits = __webpack_require__(62);
	var EventEmitter = __webpack_require__(397).EventEmitter;
	
	function IndexBrowser() {
	}
	
	inherits(IndexBrowser, EventEmitter);
	
	IndexBrowser.prototype.stop = function() {
	  this._stopped = true;
	  this._clean();
	};
	
	IndexBrowser.prototype._end = function() {
	  this.emit('end');
	  this._clean();
	};
	
	IndexBrowser.prototype._error = function(err) {
	  this.emit('error', err);
	  this._clean();
	};
	
	IndexBrowser.prototype._result = function(content) {
	  this.emit('result', content);
	};
	
	IndexBrowser.prototype._clean = function() {
	  this.removeAllListeners('stop');
	  this.removeAllListeners('end');
	  this.removeAllListeners('error');
	  this.removeAllListeners('result');
	};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(1055);
	var Promise = global.Promise || __webpack_require__(396).Promise;
	
	// This is the standalone browser build entry point
	// Browser implementation of the Algolia Search JavaScript client,
	// using XMLHttpRequest, XDomainRequest and JSONP as fallback
	module.exports = function createAlgoliasearch(AlgoliaSearch, uaSuffix) {
	  var inherits = __webpack_require__(62);
	  var errors = __webpack_require__(39);
	  var inlineHeaders = __webpack_require__(208);
	  var jsonpRequest = __webpack_require__(209);
	  var places = __webpack_require__(211);
	  uaSuffix = uaSuffix || '';
	
	  if (false) {
	    require('debug').enable('algoliasearch*');
	  }
	
	  function algoliasearch(applicationID, apiKey, opts) {
	    var cloneDeep = __webpack_require__(25);
	
	    opts = cloneDeep(opts || {});
	
	    opts._ua = opts._ua || algoliasearch.ua;
	
	    return new AlgoliaSearchBrowser(applicationID, apiKey, opts);
	  }
	
	  algoliasearch.version = __webpack_require__(213);
	
	  algoliasearch.ua =
	    'Algolia for JavaScript (' + algoliasearch.version + '); ' + uaSuffix;
	
	  algoliasearch.initPlaces = places(algoliasearch);
	
	  // we expose into window no matter how we are used, this will allow
	  // us to easily debug any website running algolia
	  global.__algolia = {
	    debug: __webpack_require__(77),
	    algoliasearch: algoliasearch
	  };
	
	  var support = {
	    hasXMLHttpRequest: 'XMLHttpRequest' in global,
	    hasXDomainRequest: 'XDomainRequest' in global
	  };
	
	  if (support.hasXMLHttpRequest) {
	    support.cors = 'withCredentials' in new XMLHttpRequest();
	  }
	
	  function AlgoliaSearchBrowser() {
	    // call AlgoliaSearch constructor
	    AlgoliaSearch.apply(this, arguments);
	  }
	
	  inherits(AlgoliaSearchBrowser, AlgoliaSearch);
	
	  AlgoliaSearchBrowser.prototype._request = function request(url, opts) {
	    return new Promise(function wrapRequest(resolve, reject) {
	      // no cors or XDomainRequest, no request
	      if (!support.cors && !support.hasXDomainRequest) {
	        // very old browser, not supported
	        reject(new errors.Network('CORS not supported'));
	        return;
	      }
	
	      url = inlineHeaders(url, opts.headers);
	
	      var body = opts.body;
	      var req = support.cors ? new XMLHttpRequest() : new XDomainRequest();
	      var reqTimeout;
	      var timedOut;
	      var connected = false;
	
	      reqTimeout = setTimeout(onTimeout, opts.timeouts.connect);
	      // we set an empty onprogress listener
	      // so that XDomainRequest on IE9 is not aborted
	      // refs:
	      //  - https://github.com/algolia/algoliasearch-client-js/issues/76
	      //  - https://social.msdn.microsoft.com/Forums/ie/en-US/30ef3add-767c-4436-b8a9-f1ca19b4812e/ie9-rtm-xdomainrequest-issued-requests-may-abort-if-all-event-handlers-not-specified?forum=iewebdevelopment
	      req.onprogress = onProgress;
	      if ('onreadystatechange' in req) req.onreadystatechange = onReadyStateChange;
	      req.onload = onLoad;
	      req.onerror = onError;
	
	      // do not rely on default XHR async flag, as some analytics code like hotjar
	      // breaks it and set it to false by default
	      if (req instanceof XMLHttpRequest) {
	        req.open(opts.method, url, true);
	
	        // The Analytics API never accepts Auth headers as query string
	        // this option exists specifically for them.
	        if (opts.forceAuthHeaders) {
	          req.setRequestHeader(
	            'x-algolia-application-id',
	            opts.headers['x-algolia-application-id']
	          );
	          req.setRequestHeader(
	            'x-algolia-api-key',
	            opts.headers['x-algolia-api-key']
	          );
	        }
	      } else {
	        req.open(opts.method, url);
	      }
	
	      // headers are meant to be sent after open
	      if (support.cors) {
	        if (body) {
	          if (opts.method === 'POST') {
	            // https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS#Simple_requests
	            req.setRequestHeader('content-type', 'application/x-www-form-urlencoded');
	          } else {
	            req.setRequestHeader('content-type', 'application/json');
	          }
	        }
	        req.setRequestHeader('accept', 'application/json');
	      }
	
	      if (body) {
	        req.send(body);
	      } else {
	        req.send();
	      }
	
	      // event object not received in IE8, at least
	      // but we do not use it, still important to note
	      function onLoad(/* event */) {
	        // When browser does not supports req.timeout, we can
	        // have both a load and timeout event, since handled by a dumb setTimeout
	        if (timedOut) {
	          return;
	        }
	
	        clearTimeout(reqTimeout);
	
	        var out;
	
	        try {
	          out = {
	            body: JSON.parse(req.responseText),
	            responseText: req.responseText,
	            statusCode: req.status,
	            // XDomainRequest does not have any response headers
	            headers: req.getAllResponseHeaders && req.getAllResponseHeaders() || {}
	          };
	        } catch (e) {
	          out = new errors.UnparsableJSON({
	            more: req.responseText
	          });
	        }
	
	        if (out instanceof errors.UnparsableJSON) {
	          reject(out);
	        } else {
	          resolve(out);
	        }
	      }
	
	      function onError(event) {
	        if (timedOut) {
	          return;
	        }
	
	        clearTimeout(reqTimeout);
	
	        // error event is trigerred both with XDR/XHR on:
	        //   - DNS error
	        //   - unallowed cross domain request
	        reject(
	          new errors.Network({
	            more: event
	          })
	        );
	      }
	
	      function onTimeout() {
	        timedOut = true;
	        req.abort();
	
	        reject(new errors.RequestTimeout());
	      }
	
	      function onConnect() {
	        connected = true;
	        clearTimeout(reqTimeout);
	        reqTimeout = setTimeout(onTimeout, opts.timeouts.complete);
	      }
	
	      function onProgress() {
	        if (!connected) onConnect();
	      }
	
	      function onReadyStateChange() {
	        if (!connected && req.readyState > 1) onConnect();
	      }
	    });
	  };
	
	  AlgoliaSearchBrowser.prototype._request.fallback = function requestFallback(url, opts) {
	    url = inlineHeaders(url, opts.headers);
	
	    return new Promise(function wrapJsonpRequest(resolve, reject) {
	      jsonpRequest(url, opts, function jsonpRequestDone(err, content) {
	        if (err) {
	          reject(err);
	          return;
	        }
	
	        resolve(content);
	      });
	    });
	  };
	
	  AlgoliaSearchBrowser.prototype._promise = {
	    reject: function rejectPromise(val) {
	      return Promise.reject(val);
	    },
	    resolve: function resolvePromise(val) {
	      return Promise.resolve(val);
	    },
	    delay: function delayPromise(ms) {
	      return new Promise(function resolveOnTimeout(resolve/* , reject*/) {
	        setTimeout(resolve, ms);
	      });
	    },
	    all: function all(promises) {
	      return Promise.all(promises);
	    }
	  };
	
	  return algoliasearch;
	};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = inlineHeaders;
	
	var encode = __webpack_require__(180);
	
	function inlineHeaders(url, headers) {
	  if (/\?/.test(url)) {
	    url += '&';
	  } else {
	    url += '?';
	  }
	
	  return url + encode(headers);
	}


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = jsonpRequest;
	
	var errors = __webpack_require__(39);
	
	var JSONPCounter = 0;
	
	function jsonpRequest(url, opts, cb) {
	  if (opts.method !== 'GET') {
	    cb(new Error('Method ' + opts.method + ' ' + url + ' is not supported by JSONP.'));
	    return;
	  }
	
	  opts.debug('JSONP: start');
	
	  var cbCalled = false;
	  var timedOut = false;
	
	  JSONPCounter += 1;
	  var head = document.getElementsByTagName('head')[0];
	  var script = document.createElement('script');
	  var cbName = 'algoliaJSONP_' + JSONPCounter;
	  var done = false;
	
	  window[cbName] = function(data) {
	    removeGlobals();
	
	    if (timedOut) {
	      opts.debug('JSONP: Late answer, ignoring');
	      return;
	    }
	
	    cbCalled = true;
	
	    clean();
	
	    cb(null, {
	      body: data,
	      responseText: JSON.stringify(data)/* ,
	      // We do not send the statusCode, there's no statusCode in JSONP, it will be
	      // computed using data.status && data.message like with XDR
	      statusCode*/
	    });
	  };
	
	  // add callback by hand
	  url += '&callback=' + cbName;
	
	  // add body params manually
	  if (opts.jsonBody && opts.jsonBody.params) {
	    url += '&' + opts.jsonBody.params;
	  }
	
	  var ontimeout = setTimeout(timeout, opts.timeouts.complete);
	
	  // script onreadystatechange needed only for
	  // <= IE8
	  // https://github.com/angular/angular.js/issues/4523
	  script.onreadystatechange = readystatechange;
	  script.onload = success;
	  script.onerror = error;
	
	  script.async = true;
	  script.defer = true;
	  script.src = url;
	  head.appendChild(script);
	
	  function success() {
	    opts.debug('JSONP: success');
	
	    if (done || timedOut) {
	      return;
	    }
	
	    done = true;
	
	    // script loaded but did not call the fn => script loading error
	    if (!cbCalled) {
	      opts.debug('JSONP: Fail. Script loaded but did not call the callback');
	      clean();
	      cb(new errors.JSONPScriptFail());
	    }
	  }
	
	  function readystatechange() {
	    if (this.readyState === 'loaded' || this.readyState === 'complete') {
	      success();
	    }
	  }
	
	  function clean() {
	    clearTimeout(ontimeout);
	    script.onload = null;
	    script.onreadystatechange = null;
	    script.onerror = null;
	    head.removeChild(script);
	  }
	
	  function removeGlobals() {
	    try {
	      delete window[cbName];
	      delete window[cbName + '_loaded'];
	    } catch (e) {
	      window[cbName] = window[cbName + '_loaded'] = undefined;
	    }
	  }
	
	  function timeout() {
	    opts.debug('JSONP: Script timeout');
	    timedOut = true;
	    clean();
	    cb(new errors.RequestTimeout());
	  }
	
	  function error() {
	    opts.debug('JSONP: Script error');
	
	    if (done || timedOut) {
	      return;
	    }
	
	    clean();
	    cb(new errors.JSONPScriptError());
	  }
	}


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = createAnalyticsClient;
	
	var algoliasearch = __webpack_require__(125);
	
	function createAnalyticsClient(appId, apiKey, opts) {
	  var analytics = {};
	
	  opts = opts || {};
	  // there need to be 4 hosts, like on the client, since if requests fail,
	  // the counter goes up by 1, so we need to have the same amount of hosts
	  // 4 because: -dsn, -1, -2, -3
	  // This is done because the APPID used for search will be the same for the analytics client created,
	  // and since the state of available hosts is shared by APPID globally for the module, we had issues
	  // where the hostIndex would be 1 while the array was only one entry (you got an empty host)
	  opts.hosts = opts.hosts || [
	    'analytics.algolia.com',
	    'analytics.algolia.com',
	    'analytics.algolia.com',
	    'analytics.algolia.com'
	  ];
	  opts.protocol = opts.protocol || 'https:';
	
	  analytics.as = algoliasearch(appId, apiKey, opts);
	
	  analytics.getABTests = function(_params, callback) {
	    var params = params || {};
	    var offset = params.offset || 0;
	    var limit = params.limit || 10;
	
	    return this.as._jsonRequest({
	      method: 'GET',
	      url: '/2/abtests?offset=' + encodeURIComponent(offset) + '&limit=' + encodeURIComponent(limit),
	      hostType: 'read',
	      forceAuthHeaders: true,
	      callback: callback
	    });
	  };
	
	  analytics.getABTest = function(abTestID, callback) {
	    return this.as._jsonRequest({
	      method: 'GET',
	      url: '/2/abtests/' + encodeURIComponent(abTestID),
	      hostType: 'read',
	      forceAuthHeaders: true,
	      callback: callback
	    });
	  };
	
	  analytics.addABTest = function(abTest, callback) {
	    return this.as._jsonRequest({
	      method: 'POST',
	      url: '/2/abtests',
	      body: abTest,
	      hostType: 'read',
	      forceAuthHeaders: true,
	      callback: callback
	    });
	  };
	
	  analytics.stopABTest = function(abTestID, callback) {
	    return this.as._jsonRequest({
	      method: 'POST',
	      url: '/2/abtests/' + encodeURIComponent(abTestID) + '/stop',
	      hostType: 'read',
	      forceAuthHeaders: true,
	      callback: callback
	    });
	  };
	
	  analytics.deleteABTest = function(abTestID, callback) {
	    return this.as._jsonRequest({
	      method: 'DELETE',
	      url: '/2/abtests/' + encodeURIComponent(abTestID),
	      hostType: 'write',
	      forceAuthHeaders: true,
	      callback: callback
	    });
	  };
	
	  analytics.waitTask = function(indexName, taskID, callback) {
	    return this.as.initIndex(indexName).waitTask(taskID, callback);
	  };
	
	  return analytics;
	}


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = createPlacesClient;
	
	var qs3 = __webpack_require__(1746);
	var buildSearchMethod = __webpack_require__(126);
	
	function createPlacesClient(algoliasearch) {
	  return function places(appID, apiKey, opts) {
	    var cloneDeep = __webpack_require__(25);
	
	    opts = opts && cloneDeep(opts) || {};
	    opts.hosts = opts.hosts || [
	      'places-dsn.algolia.net',
	      'places-1.algolianet.com',
	      'places-2.algolianet.com',
	      'places-3.algolianet.com'
	    ];
	
	    // allow initPlaces() no arguments => community rate limited
	    if (arguments.length === 0 || typeof appID === 'object' || appID === undefined) {
	      appID = '';
	      apiKey = '';
	      opts._allowEmptyCredentials = true;
	    }
	
	    var client = algoliasearch(appID, apiKey, opts);
	    var index = client.initIndex('places');
	    index.search = buildSearchMethod('query', '/1/places/query');
	    index.reverse = function(options, callback) {
	      var encoded = qs3.encode(options);
	
	      return this.as._jsonRequest({
	        method: 'GET',
	        url: '/1/places/reverse?' + encoded,
	        hostType: 'read',
	        callback: callback
	      });
	    };
	
	    index.getObject = function(objectID, callback) {
	      return this.as._jsonRequest({
	        method: 'GET',
	        url: '/1/places/' + encodeURIComponent(objectID),
	        hostType: 'read',
	        callback: callback
	      });
	    };
	    return index;
	  };
	}


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var debug = __webpack_require__(77)('algoliasearch:src/hostIndexState.js');
	var localStorageNamespace = 'algoliasearch-client-js';
	
	var store;
	var moduleStore = {
	  state: {},
	  set: function(key, data) {
	    this.state[key] = data;
	    return this.state[key];
	  },
	  get: function(key) {
	    return this.state[key] || null;
	  }
	};
	
	var localStorageStore = {
	  set: function(key, data) {
	    moduleStore.set(key, data); // always replicate localStorageStore to moduleStore in case of failure
	
	    try {
	      var namespace = JSON.parse(global.localStorage[localStorageNamespace]);
	      namespace[key] = data;
	      global.localStorage[localStorageNamespace] = JSON.stringify(namespace);
	      return namespace[key];
	    } catch (e) {
	      return localStorageFailure(key, e);
	    }
	  },
	  get: function(key) {
	    try {
	      return JSON.parse(global.localStorage[localStorageNamespace])[key] || null;
	    } catch (e) {
	      return localStorageFailure(key, e);
	    }
	  }
	};
	
	function localStorageFailure(key, e) {
	  debug('localStorage failed with', e);
	  cleanup();
	  store = moduleStore;
	  return store.get(key);
	}
	
	store = supportsLocalStorage() ? localStorageStore : moduleStore;
	
	module.exports = {
	  get: getOrSet,
	  set: getOrSet,
	  supportsLocalStorage: supportsLocalStorage
	};
	
	function getOrSet(key, data) {
	  if (arguments.length === 1) {
	    return store.get(key);
	  }
	
	  return store.set(key, data);
	}
	
	function supportsLocalStorage() {
	  try {
	    if ('localStorage' in global &&
	      global.localStorage !== null) {
	      if (!global.localStorage[localStorageNamespace]) {
	        // actual creation of the namespace
	        global.localStorage.setItem(localStorageNamespace, JSON.stringify({}));
	      }
	      return true;
	    }
	
	    return false;
	  } catch (_) {
	    return false;
	  }
	}
	
	// In case of any error on localStorage, we clean our own namespace, this should handle
	// quota errors when a lot of keys + data are used
	function cleanup() {
	  try {
	    global.localStorage.removeItem(localStorageNamespace);
	  } catch (_) {
	    // nothing to do
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = '3.35.1';


/***/ }),
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid\n    ", ";\n  &:first-child {\n    margin-top: -16px;\n  }\n"], ["\n  border-bottom: 1px solid\n    ", ";\n  &:first-child {\n    margin-top: -16px;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  align-items: center;\n  width: 100%;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  text-align: initial;\n  font-family: ", ";\n  appearance: none;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  &:not(:lang(ar)) {\n    padding-right: 0;\n    padding-left: 40px;\n  }\n  &:lang(ar) {\n    padding-right: 40px;\n    padding-left: 0;\n  }\n  &:hover {\n    span {\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n  }\n  &:active {\n    span {\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n  }\n"], ["\n  position: relative;\n  align-items: center;\n  width: 100%;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  text-align: initial;\n  font-family: ", ";\n  appearance: none;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  &:not(:lang(ar)) {\n    padding-right: 0;\n    padding-left: 40px;\n  }\n  &:lang(ar) {\n    padding-right: 40px;\n    padding-left: 0;\n  }\n  &:hover {\n    span {\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n  }\n  &:active {\n    span {\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 50%;\n  width: 32px;\n  height: 32px;\n  transform: translateY(-50%);\n  &:not(:lang(ar)) {\n    left: 0;\n  }\n  &:lang(ar) {\n    right: 0;\n  }\n"], ["\n  position: absolute;\n  top: 50%;\n  width: 32px;\n  height: 32px;\n  transform: translateY(-50%);\n  &:not(:lang(ar)) {\n    left: 0;\n  }\n  &:lang(ar) {\n    right: 0;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  ", ";\n  > span {\n    display: inline-block;\n    height: 100%;\n    transition: box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  }\n"], ["\n  ", ";\n  > span {\n    display: inline-block;\n    height: 100%;\n    transition: box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  /* transform: scaleY(0); */\n"], ["\n  /* transform: scaleY(0); */\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  padding-top: 16px;\n  padding-bottom: 32px;\n"], ["\n  padding-top: 16px;\n  padding-bottom: 32px;\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _prismicDom = __webpack_require__(10);
	
	var _polished = __webpack_require__(8);
	
	var _rebass = __webpack_require__(4);
	
	var _reactFeather = __webpack_require__(29);
	
	var _Article = __webpack_require__(84);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _ImageSlice = __webpack_require__(139);
	
	var _ImageSlice2 = _interopRequireDefault(_ImageSlice);
	
	var _BlockQuote = __webpack_require__(132);
	
	var _BlockQuote2 = _interopRequireDefault(_BlockQuote);
	
	var _H = __webpack_require__(54);
	
	var _H2 = _interopRequireDefault(_H);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.theme.colors.grey[1] && (0, _polished.shade)(0.875, props.theme.colors.grey[1]);
	});
	
	Wrapper.defaultProps = {};
	
	var ButtonContainer = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject2, function (props) {
	  return props.theme.fonts.sans;
	}, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.grey[1];
	});
	
	ButtonContainer.defaultProps = {
	  is: "button"
	};
	
	var IconContainer = (0, _styledComponents2.default)(_rebass.Box)(_templateObject3);
	
	var AccordionTitle = (0, _styledComponents2.default)(_H2.default)(_templateObject4, (0, _polished.ellipsis)());
	
	AccordionTitle.defaultProps = {
	  is: "h1"
	};
	
	var ContentContainer = (0, _styledComponents2.default)(_rebass.Box)(_templateObject5);
	
	var Content = (0, _styledComponents2.default)(_rebass.Box)(_templateObject6);
	
	Content.defaultProps = {
	  is: "article"
	};
	
	var linkResolver = function linkResolver(doc) {
	  return "/" + doc.type;
	};
	
	var Accordion = function (_React$Component) {
	  _inherits(Accordion, _React$Component);
	
	  function Accordion(props) {
	    _classCallCheck(this, Accordion);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.toggleOpen = function () {
	      _this.setState({ open: !_this.state.open });
	    };
	
	    _this.state = {
	      open: props.startOpen ? true : false
	    };
	    return _this;
	  }
	
	  Accordion.prototype.render = function render() {
	    var _React$createElement;
	
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(
	        ButtonContainer,
	        (_React$createElement = {
	          onClick: this.toggleOpen,
	          role: "tab",
	          "aria-controls": this.props.id,
	          "aria-expanded": this.state.open
	        }, _React$createElement["role"] = "tab", _React$createElement["aria-selected"] = this.state.open, _React$createElement),
	        _react2.default.createElement(
	          IconContainer,
	          null,
	          this.state.open && _react2.default.createElement(_reactFeather.ChevronDown, { size: 32, strokeWidth: 1.25, stroke: "#363636" }),
	          !this.state.open && _react2.default.createElement(_reactFeather.ChevronRight, { size: 32, strokeWidth: 1.25, stroke: "#363636" })
	        ),
	        _react2.default.createElement(
	          AccordionTitle,
	          { fontSize: [4, 5] },
	          _react2.default.createElement(
	            "span",
	            null,
	            this.props.title
	          )
	        )
	      ),
	      _react2.default.createElement(
	        ContentContainer,
	        { "aria-labelledby": this.props.id, role: "tabpanel" },
	        this.state.open && _react2.default.createElement(
	          Content,
	          null,
	          this.props.children,
	          this.props.data.map(function (slice, index) {
	            if (slice.slice_type === "text") {
	              return _react2.default.createElement(_Article2.default, {
	                is: "div",
	                dangerouslySetInnerHTML: {
	                  __html: _prismicDom.RichText.asHtml(slice.primary.text, linkResolver)
	                }
	              });
	            }
	            if (slice.slice_type === "image") {
	              return _react2.default.createElement(_ImageSlice2.default, {
	                imageSet: [slice.primary.image.url, slice.primary.image.half.url, slice.primary.image.quarter.url],
	                caption: slice.primary.caption,
	                alt: slice.primary.image.alt
	              });
	            }
	            if (slice.slice_type === "quote") {
	              return _react2.default.createElement(_BlockQuote2.default, {
	                quote: slice.primary.quote[0] ? slice.primary.quote[0].text : "",
	                attribution: slice.primary.name_of_the_author[0] ? slice.primary.name_of_the_author[0].text : ""
	              });
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return Accordion;
	}(_react2.default.Component);
	
	Accordion.defaultProps = {
	  title: "Overview",
	  id: "overview_tab"
	};
	
	exports.default = Accordion;
	module.exports = exports["default"];

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.PrimaryButton = exports.Button = undefined;
	
	var _Button2 = __webpack_require__(53);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _PrimaryButton2 = __webpack_require__(133);
	
	var _PrimaryButton3 = _interopRequireDefault(_PrimaryButton2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Button = _Button3.default;
	exports.PrimaryButton = _PrimaryButton3.default;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  @media (max-width: 40em) {\n    margin-right: -24px;\n    margin-left: -24px;\n  }\n\n  * {\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"], ["\n  @media (max-width: 40em) {\n    margin-right: -24px;\n    margin-left: -24px;\n  }\n\n  * {\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _prismicDom = __webpack_require__(10);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(4);
	
	var _GradientCard = __webpack_require__(134);
	
	var _GradientCard2 = _interopRequireDefault(_GradientCard);
	
	var _Article = __webpack_require__(84);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _PrimaryButton = __webpack_require__(133);
	
	var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var linkResolver = function linkResolver(doc) {
	  return "/" + doc.type;
	};
	
	var Card = (0, _styledComponents2.default)(_GradientCard2.default)(_templateObject, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.violet;
	});
	
	var CalloutCard = function CalloutCard(props) {
	  return _react2.default.createElement(
	    _rebass.Box,
	    { mb: 5 },
	    _react2.default.createElement(
	      Card,
	      {
	        callout: props.callout,
	        image: props.callout.callout_image.url ? props.callout.callout_image.half.url : ""
	      },
	      props.callout.callout && _react2.default.createElement(_Article2.default, {
	        dangerouslySetInnerHTML: {
	          __html: _prismicDom.RichText.asHtml(props.callout.callout, linkResolver)
	        }
	      }),
	      props.callout.button_text && _react2.default.createElement(
	        _rebass.Box,
	        { mt: 5 },
	        _react2.default.createElement(_PrimaryButton2.default, {
	          children: props.callout.button_text,
	          is: props.callout.button_file.url ? "a" : props.callout.button_link ? props.callout.button_link.indexOf("http") !== -1 || props.callout.button_link.indexOf("mailto") !== -1 ? "a" : _gatsbyLink2.default : _gatsbyLink2.default,
	          to: "/" + props.lang + "/" + props.callout.button_link,
	          href: props.callout.button_link ? props.callout.button_link : props.callout.button_file ? props.callout.button_file.url : "",
	          target: "_blank"
	        })
	      )
	    )
	  );
	};
	
	exports.default = CalloutCard;
	module.exports = exports["default"];

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  align-items: flex-start;\n\n  @media (max-width: 52em) {\n    flex-wrap: wrap;\n    > * {\n      width: 100%;\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:last-child {\n      margin-bottom: ", "px;\n    }\n  }\n  @media (min-width: 52em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(2n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:nth-last-child(-n + 2) {\n      margin-bottom: ", "px;\n    }\n  }\n"], ["\n  align-items: flex-start;\n\n  @media (max-width: 52em) {\n    flex-wrap: wrap;\n    > * {\n      width: 100%;\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:last-child {\n      margin-bottom: ", "px;\n    }\n  }\n  @media (min-width: 52em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(2n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:nth-last-child(-n + 2) {\n      margin-bottom: ", "px;\n    }\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CalloutContainer = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject, function (props) {
	  return props.theme.space[5];
	}, function (props) {
	  return props.theme.space[0];
	}, function (props) {
	  return "calc(" + 1 / 2 * 100 + "% - " + props.theme.space[6] / 2 + "px)";
	}, function (props) {
	  return props.theme.space[5];
	}, function (props) {
	  return props.theme.space[6];
	}, function (props) {
	  return props.theme.space[6];
	}, function (props) {
	  return props.theme.space[0];
	});
	
	exports.default = CalloutContainer;
	module.exports = exports["default"];

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  text-decoration: none;\n  opacity: 0;\n  animation: institution-card-fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n  will-change: opacity;\n\n  @keyframes institution-card-fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  * {\n    text-decoration: none;\n\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n\n  &:not(:last-child) {\n    > * {\n      margin-bottom: 32px;\n    }\n  }\n"], ["\n  text-decoration: none;\n  opacity: 0;\n  animation: institution-card-fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n  will-change: opacity;\n\n  @keyframes institution-card-fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  * {\n    text-decoration: none;\n\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n\n  &:not(:last-child) {\n    > * {\n      margin-bottom: 32px;\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  background-color: ", ";\n  &:not(:lang(ar)) {\n    &:before,\n    &:after {\n      right: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n  &:lang(ar) {\n    &:before,\n    &:after {\n      left: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n    filter: grayscale(1);\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    /* Fallback */\n    background-image: ", ";\n\n    /* Webkit fallback */\n    background-image: ", ";\n\n    /* Regular imageset */\n    background-image: ", ";\n\n    @media (min-width: 52em) {\n      /* Fallback */\n      background-image: ", ";\n\n      /* Webkit fallback */\n      background-image: ", ";\n\n      /* Regular imageset */\n      background-image: ", ";\n    }\n\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      background-image: ", ";\n    }\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n  }\n"], ["\n  position: relative;\n  background-color: ", ";\n  &:not(:lang(ar)) {\n    &:before,\n    &:after {\n      right: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n  &:lang(ar) {\n    &:before,\n    &:after {\n      left: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n    filter: grayscale(1);\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    /* Fallback */\n    background-image: ", ";\n\n    /* Webkit fallback */\n    background-image: ", ";\n\n    /* Regular imageset */\n    background-image: ", ";\n\n    @media (min-width: 52em) {\n      /* Fallback */\n      background-image: ", ";\n\n      /* Webkit fallback */\n      background-image: ", ";\n\n      /* Regular imageset */\n      background-image: ", ";\n    }\n\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      background-image: ", ";\n    }\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 640px;\n"], ["\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 640px;\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _polished = __webpack_require__(8);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(4);
	
	var _Text = __webpack_require__(17);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _H = __webpack_require__(54);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _Button = __webpack_require__(53);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _OverlayImage = __webpack_require__(42);
	
	var _OverlayImage2 = _interopRequireDefault(_OverlayImage);
	
	var _theme = __webpack_require__(13);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _invertTheme = __webpack_require__(12);
	
	var _invertTheme2 = _interopRequireDefault(_invertTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Action = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.theme.colors[props.cardColor] && (0, _polished.shade)(0.9375, props.theme.colors[props.cardColor]);
	}, function (props) {
	  return props.theme.colors.grey[2];
	});
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2, function (props) {
	  return props.theme.colors[props.cardColor];
	}, function (props) {
	  return props.theme.colors[props.cardColor] && "linear-gradient(to right, " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 1) + ", " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.75) + ")";
	}, function (props) {
	  return props.theme.colors[props.cardColor] && "linear-gradient(to left, " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 1) + ", " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.75) + ")";
	}, function (props) {
	  return "url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ")";
	}, function (props) {
	  return "-webkit-image-set(url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x)";
	}, function (props) {
	  return "image-set(url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x)";
	}, function (props) {
	  return "url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ")";
	}, function (props) {
	  return "-webkit-image-set(url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x, url(" + (props.backgroundImage ? props.backgroundImage[0] : "") + ") 3x)";
	}, function (props) {
	  return "image-set(url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x, url(" + (props.backgroundImage ? props.backgroundImage[0] : "") + ") 3x)";
	}, function (props) {
	  return props.theme.colors[props.imageColor] && "linear-gradient(to bottom, " + (props.imageColor ? (0, _polished.rgba)(props.theme.colors[props.imageColor], 0.66) : "") + ", " + (props.imageColor ? (0, _polished.rgba)(props.theme.colors[props.imageColor], 0.66) : "") + "), url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ")";
	});
	
	var Content = (0, _styledComponents2.default)(_rebass.Box)(_templateObject3);
	
	var CampaignCard = function CampaignCard(props) {
	  if (props.object) {
	    return _react2.default.createElement(
	      _styledComponents.ThemeProvider,
	      { theme: _invertTheme2.default },
	      _react2.default.createElement(
	        Action,
	        {
	          className: props.className,
	          style: props.style,
	          cardColor: props.cardColor
	        },
	        _react2.default.createElement(
	          Wrapper,
	          {
	            px: 4,
	            py: 5,
	            backgroundImage: props.object.data.header_image.url ? [props.object.data.header_image.half.url, props.object.data.header_image.quarter.url] : "",
	            cardColor: props.cardColor
	          },
	          _react2.default.createElement(
	            Content,
	            null,
	            _react2.default.createElement(_H2.default, {
	              children: props.object.data.title[0] ? props.object.data.title[0].text : "",
	              mb: 5
	            }),
	            _react2.default.createElement(_Text2.default, {
	              children: props.object.data.description[0] ? props.object.data.description[0].text : "",
	              mb: 6
	            }),
	            _react2.default.createElement(_Button2.default, {
	              is: _gatsbyLink2.default,
	              to: "/" + props.object.lang + "/campaign/" + props.object.uid,
	              children: props.object.lang === "en-us" ? "Learn more" : props.object.lang === "es-mx" ? "Aprende más" : "أعرف أكثر",
	              "aria-label": props.object.data.title[0] ? props.object.data.title[0].text : ""
	            })
	          )
	        )
	      )
	    );
	  } else {
	    return null;
	  }
	};
	
	CampaignCard.defaultProps = {
	  title: "Campaign Name",
	  cardColor: "ash",
	  image: "https://source.unsplash.com/random"
	};
	
	exports.default = CampaignCard;
	module.exports = exports["default"];

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  cursor: pointer;\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: transform;\n  opacity: 0;\n  animation: resource-card-fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n\n  @keyframes resource-card-fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  &:hover {\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n    transform: translateY(-4px);\n\n    ", " {\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n    }\n  }\n\n  &:active {\n    box-shadow: none;\n    transform: translateY(-2px);\n\n    ", " {\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n    }\n  }\n\n  *::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  position: relative;\n  cursor: pointer;\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: transform;\n  opacity: 0;\n  animation: resource-card-fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n\n  @keyframes resource-card-fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  &:hover {\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n    transform: translateY(-4px);\n\n    ", " {\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n    }\n  }\n\n  &:active {\n    box-shadow: none;\n    transform: translateY(-2px);\n\n    ", " {\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n    }\n  }\n\n  *::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  min-height: 36px;\n"], ["\n  position: relative;\n  min-height: 36px;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  min-height: none;\n\n  @media (min-width: 35em) {\n    min-height: 176px;\n  }\n"], ["\n  position: relative;\n  min-height: none;\n\n  @media (min-width: 35em) {\n    min-height: 176px;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 0.333;\n  /* background-color: ", "; */\n  background-color: ", ";\n\n  &:not(:lang(ar)) {\n    &:after {\n      /* background-image: ", "; */\n      background-image: ", ";\n    }\n  }\n\n  &:lang(ar) {\n    &:after {\n      /* background-image: ", "; */\n      background-image: ", ";\n    }\n  }\n\n  &:after {\n    position: absolute;\n    content: \"\";\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: rgba(0, 0, 0, 0.2);\n  }\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n    filter: grayscale(1);\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n\n    /* Fallback */\n    background-image: ", ";\n\n    /* Webkit fallback */\n    background-image: ", ";\n\n    /* Regular imageset */\n    background-image: ", ";\n\n    @media (min-width: 52em) {\n      /* Fallback */\n      background-image: ", ";\n\n      /* Webkit fallback */\n      background-image: ", ";\n\n      /* Regular imageset */\n      background-image: ", ";\n    }\n\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      /* background-image: ", "; */\n      background-image: ", ";\n    }\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  opacity: 0.333;\n  /* background-color: ", "; */\n  background-color: ", ";\n\n  &:not(:lang(ar)) {\n    &:after {\n      /* background-image: ", "; */\n      background-image: ", ";\n    }\n  }\n\n  &:lang(ar) {\n    &:after {\n      /* background-image: ", "; */\n      background-image: ", ";\n    }\n  }\n\n  &:after {\n    position: absolute;\n    content: \"\";\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: rgba(0, 0, 0, 0.2);\n  }\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n    filter: grayscale(1);\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n\n    /* Fallback */\n    background-image: ", ";\n\n    /* Webkit fallback */\n    background-image: ", ";\n\n    /* Regular imageset */\n    background-image: ", ";\n\n    @media (min-width: 52em) {\n      /* Fallback */\n      background-image: ", ";\n\n      /* Webkit fallback */\n      background-image: ", ";\n\n      /* Regular imageset */\n      background-image: ", ";\n    }\n\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      /* background-image: ", "; */\n      background-image: ", ";\n    }\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 5;\n  width: 100%;\n  height: 8px;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 5;\n  width: 100%;\n  height: 8px;\n  background-color: ", ";\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n"], ["\n  color: ", ";\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(8);
	
	var _theme = __webpack_require__(13);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _invertTheme = __webpack_require__(12);
	
	var _invertTheme2 = _interopRequireDefault(_invertTheme);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _OverlayImage = __webpack_require__(42);
	
	var _OverlayImage2 = _interopRequireDefault(_OverlayImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject, _components.Button, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors[props.color];
	}, function (props) {
	  return props.theme.colors[props.color];
	}, _components.Button, function (props) {
	  return props.theme.colors[props.color];
	}, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors[props.color] && (0, _polished.shade)(0.75, props.theme.colors[props.color]);
	}, function (props) {
	  return props.theme.colors.grey[0];
	});
	
	var Metadata = (0, _styledComponents2.default)(_components.H4)(_templateObject2);
	
	var Title = (0, _styledComponents2.default)(_components.H3)(_templateObject3);
	
	var ImageContainer = _styledComponents2.default.div(_templateObject4, function (props) {
	  return props.theme.colors[props.cardColor];
	}, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors[props.cardColor] && "linear-gradient(to right, " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.9) + ", " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.75) + ")";
	}, function (props) {
	  return props.theme.colors.grey[2] && "linear-gradient(to right, " + (0, _polished.rgba)(props.theme.colors.grey[2], 0.9) + ", " + (0, _polished.rgba)(props.theme.colors.grey[2], 0.75) + ")";
	}, function (props) {
	  return props.theme.colors[props.cardColor] && "linear-gradient(to left, " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.9) + ", " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.75) + ")";
	}, function (props) {
	  return props.theme.colors.grey[2] && "linear-gradient(to left, " + (0, _polished.rgba)(props.theme.colors.grey[2], 0.9) + ", " + (0, _polished.rgba)(props.theme.colors.grey[2], 0.75) + ")";
	}, function (props) {
	  return "url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ")";
	}, function (props) {
	  return "-webkit-image-set(url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x)";
	}, function (props) {
	  return "image-set(url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x)";
	}, function (props) {
	  return "url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ")";
	}, function (props) {
	  return "-webkit-image-set(url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x, url(" + (props.backgroundImage ? props.backgroundImage[0] : "") + ") 3x)";
	}, function (props) {
	  return "image-set(url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x, url(" + (props.backgroundImage ? props.backgroundImage[0] : "") + ") 3x)";
	}, function (props) {
	  return props.theme.colors[props.cardColor] && "linear-gradient(to bottom, " + (props.cardColor ? (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.66) : "") + ", " + (props.cardColor ? (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.66) : "") + "), url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ")";
	}, function (props) {
	  return props.theme.colors.grey[2] && "linear-gradient(to bottom, " + (props.cardColor ? (0, _polished.rgba)(props.theme.colors.grey[2], 0.66) : "") + ", " + (props.cardColor ? (0, _polished.rgba)(props.theme.colors.grey[2], 0.66) : "") + "), url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ")";
	});
	
	var TopBar = _styledComponents2.default.div(_templateObject5, function (props) {
	  return props.theme.colors[props.cardColor];
	});
	
	var ColorCoded = _styledComponents2.default.span(_templateObject6, function (props) {
	  return props.theme.colors[props.cardColor];
	});
	
	var determineLabel = function determineLabel(region) {
	  var label = "BIC";
	  if (region === "middle-east-and-north-africa") {
	    label = "Middle East and North Africa";
	  }
	  if (region === "oriente-medio-y-norte-de-africa") {
	    label = "Oriente Medio y Norte de África";
	  }
	  if (region === "الشرق-الاوسط-وشمات-افريقيا") {
	    label = "الشرق الأوسط وشمات أفريقيا";
	  }
	  if (region === "africa") {
	    label = "Africa";
	  }
	  if (region === "africa1") {
	    label = "África";
	  }
	  if (region === "افريقيا") {
	    label = "أفريقيا";
	  }
	  if (region === "latin-america") {
	    label = "Latin America";
	  }
	  if (region === "america-latina-y-el-caribe") {
	    label = "América Latina y el Caribe";
	  }
	  if (region === "امريكا-اللاتينية") {
	    label = "أمريكا  اللاتينية";
	  }
	  if (region === "asia") {
	    label = "Asia";
	  }
	  if (region === "asia1") {
	    label = "Asia";
	  }
	  if (region === "اسيا") {
	    label = "آسيا";
	  }
	  if (region === "europe--central-asia") {
	    label = "Europe & Central Asia";
	  }
	  if (region === "europa-y-asia-central") {
	    label = "Europa y Asia Central";
	  }
	  if (region === "اوروبا-واسيا-الوسطى") {
	    label = "أوروبا وآسيا الوسطى";
	  }
	  return label;
	};
	
	var determineColor = function determineColor(region) {
	  var color = "violet";
	  if (region === "middle-east-and-north-africa" || region === "oriente-medio-y-norte-de-africa" || region === "الشرق-الاوسط-وشمات-افريقيا") {
	    color = "orange";
	  }
	  if (region === "africa" || region === "africa1" || region === "افريقيا") {
	    color = "green";
	  }
	  if (region === "latin-america" || region === "america-latina-y-el-caribe" || region === "امريكا-اللاتينية") {
	    color = "blue";
	  }
	  if (region === "asia" || region === "asia1" || region === "اسيا") {
	    color = "pink";
	  }
	  if (region === "europe--central-asia" || region === "europa-y-asia-central" || region === "اوروبا-واسيا-الوسطى") {
	    color = "yellow";
	  }
	  return color;
	};
	
	var truncateText = function truncateText(text) {
	  if (text.length > 90) {
	    var textArray = text.split(" ");
	    var textBuildup = "";
	    var position = 0;
	    while (textBuildup.length < 90) {
	      textBuildup += textArray[position] + " ";
	      position++;
	    }
	    if (textBuildup[textBuildup.length - 2] !== "?" && textBuildup[textBuildup.length - 2] !== "!" && textBuildup[textBuildup.length - 2] !== ".") {
	      text = textBuildup.slice(0, textBuildup.length - 1) + "...";
	    }
	  }
	  return text;
	};
	
	var Card = function Card(props) {
	  if (props.object) {
	    var _React$createElement, _React$createElement2;
	
	    return _react2.default.createElement(
	      _styledComponents.ThemeProvider,
	      {
	        theme: determineColor(props.object.data.region ? props.object.data.region.uid : props.object.type) === "lightgrey" ? _theme2.default : _invertTheme2.default
	      },
	      _react2.default.createElement(
	        Container,
	        (_React$createElement2 = {
	          is: _gatsbyLink2.default,
	          to: props.object.type === "member" ? "/" + props.object.lang + "/team/" + props.object.uid : props.object.type === "update" ? "/" + props.object.lang + "/update/" + props.object.uid : props.object.type === "projec" ? "/" + props.object.lang + "/project/" + props.object.uid : props.object.type === "region" ? "/" + props.object.lang + "/region/" + props.object.uid : props.object.type === "institution" ? "/" + props.object.lang + "/institution/" + props.object.uid : "/" + props.object.lang + "/" + props.object.type
	          // onClick={() => {
	          //   if (props.object.type === "projec") {
	          //     document.body.style.background =
	          //       theme.colors[determineColor(props.object.data.region.uid)];
	          //   }
	          // }}
	          , bg: determineColor(props.object.data.region ? props.object.type === "update" ? props.object.type : props.object.data.region.uid : props.object.type === "region" ? props.object.uid : props.object.type)
	        }, _React$createElement2["bg"] = "grey.2", _React$createElement2.color = determineColor(props.object.data.region ? props.object.type === "update" ? props.object.type : props.object.data.region.uid : props.object.type === "region" ? props.object.uid : props.object.type), _React$createElement2.title = props.object.type === "update" ? "Update" : props.object.data.title ? props.object.data.title[0].text : "", _React$createElement2["aria-label"] = props.object.data.title ? props.object.data.title[0].text : "", _React$createElement2.flexDirection = "column", _React$createElement2.align = "flex-start", _React$createElement2.px = 4, _React$createElement2.py = 5, _React$createElement2),
	        _react2.default.createElement(TopBar, {
	          cardColor: determineColor(props.object.data.region ? props.object.type === "update" ? props.object.type : props.object.data.region.uid : props.object.type === "region" ? props.object.uid : props.object.type)
	        }),
	        _react2.default.createElement(ImageContainer, (_React$createElement = {
	          backgroundImage: props.object.data.header_image ? [props.object.data.header_image.half.url, props.object.data.header_image.quarter.url, props.object.data.header_image.quarter.url] : "",
	          cardColor: determineColor(props.object.data.region ? props.object.type === "update" ? props.object.type : props.object.data.region.uid : props.object.type === "region" ? props.object.uid : props.object.type),
	          bg: determineColor(props.object.data.region ? props.object.type === "update" ? props.object.type : props.object.data.region.uid : props.object.type === "region" ? props.object.uid : props.object.type)
	        }, _React$createElement["bg"] = "grey.2", _React$createElement)),
	        _react2.default.createElement(
	          Metadata,
	          { is: "div", mb: 5 },
	          _react2.default.createElement(ColorCoded, {
	            children: props.object.type === "update" || props.object.type === "region" ? "BIC" : determineLabel(props.object.data.region ? props.object.data.region.uid : ""),
	            cardColor: determineColor(props.object.data.region ? props.object.type === "update" ? props.object.type : props.object.data.region.uid : props.object.type === "region" ? props.object.uid : props.object.type)
	          }),
	          " | ",
	          props.object.type === "member" ? props.object.lang === "en-us" ? "Staff Feature" : props.object.lang === "es-mx" ? "Staff" : "تسليط الضوء على موظفي المركز" : props.object.type === "update" ? props.object.lang === "en-us" ? "Update" : props.object.lang === "es-mx" ? "Noticia" : "تحديث" : props.object.type === "projec" ? props.object.lang === "en-us" ? "Project" : props.object.lang === "es-mx" ? "Proyecto" : "مشروع" : props.object.type === "region" ? props.windowLang === "en-us" ? "Region" : props.windowLang === "es-mx" ? "Regione" : "مشروع" : props.object.type === "institution" ? props.windowLang === "en-us" ? "Institution" : props.windowLang === "es-mx" ? "Institucione" : "مؤسسات" : props.object.type === "team" ? props.object.lang === "en-us" ? "Team" : props.object.lang === "es-mx" ? "Equipo" : "الفريق" : props.object.type === "resources" ? props.object.lang === "en-us" ? "Resource" : props.object.lang === "es-mx" ? "Recurso" : "مورد" : props.object.type === "support" ? props.object.lang === "en-us" ? "Support" : props.object.lang === "es-mx" ? "Súmate" : "الدعم" : props.object.type === "careers" ? props.object.lang === "en-us" ? "Careers" : props.object.lang === "es-mx" ? "Empleo" : "وظائف" : props.object.type === "contact" ? props.object.lang === "en-us" ? "Contact" : props.object.lang === "es-mx" ? "Contacto" : "اتصل" : props.object.type === "about" ? props.object.lang === "en-us" ? "About" : props.object.lang === "es-mx" ? "Sobre BIC" : "عن نحن" : ""
	        ),
	        _react2.default.createElement(
	          _rebass.Box,
	          null,
	          _react2.default.createElement(Title, {
	            children: props.object.type === "member" ? props.object.data.description[0] ? truncateText(props.object.data.description[0].text) : "" : props.object.type === "update" ? props.object.data.title[0] ? truncateText(props.object.data.title[0].text) : "" : props.object.type === "projec" ? props.object.data.description[0] ? truncateText(props.object.data.description[0].text) : props.object.data.title[0].text : props.object.data.subtitle ? props.object.data.subtitle[0] ? props.object.data.subtitle[0].text : "" : "",
	            fontSize: 4,
	            is: "h1",
	            mb: 5
	          })
	        ),
	        _react2.default.createElement(_components.Button, {
	          children: props.object.type === "member" ? props.object.lang === "en-us" ? "Read more" : props.object.lang === "es-mx" ? "Lee mas" : "اقرأ أكثر" : props.object.type === "projec" ? props.object.data.description[0] ? props.object.lang === "en-us" ? "Let's find out" : props.object.lang === "es-mx" ? "Vamos a averiguar" : "هيا نكتشف" : props.object.lang === "en-us" ? "Learn more" : props.object.lang === "es-mx" ? "Aprende más" : "أعرف أكثر" : props.object.lang === "en-us" ? "Learn more" : props.object.lang === "es-mx" ? "Aprende más" : "أعرف أكثر",
	          is: "div",
	          mt: "auto",
	          style: { position: "relative" }
	        })
	      )
	    );
	  } else {
	    return null;
	  }
	};
	
	Card.defaultProps = {
	  to: "/",
	  color: "yellow"
	};
	
	exports.default = Card;
	module.exports = exports["default"];

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  align-items: stretch;\n\n  @media (max-width: 40em) {\n    flex-wrap: wrap;\n    > * {\n      width: 100%;\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:last-child {\n      margin-bottom: ", "px;\n    }\n  }\n  @media (min-width: 40em) and (max-width: 75em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(2n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    /* > *:nth-last-child(-n + 2) {\n      margin-bottom: ", "px;\n    } */\n  }\n  @media (min-width: 75em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(4n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    /* > *:nth-last-child(-n + 4) {\n      margin-bottom: ", "px;\n    } */\n  }\n"], ["\n  align-items: stretch;\n\n  @media (max-width: 40em) {\n    flex-wrap: wrap;\n    > * {\n      width: 100%;\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:last-child {\n      margin-bottom: ", "px;\n    }\n  }\n  @media (min-width: 40em) and (max-width: 75em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(2n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    /* > *:nth-last-child(-n + 2) {\n      margin-bottom: ", "px;\n    } */\n  }\n  @media (min-width: 75em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(4n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    /* > *:nth-last-child(-n + 4) {\n      margin-bottom: ", "px;\n    } */\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CardLayout = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject, function (props) {
	  return props.theme.space[1];
	}, function (props) {
	  return props.theme.space[0];
	}, function (props) {
	  return "calc(" + 1 / 2 * 100 + "% - " + props.theme.space[4] / 2 + "px)";
	}, function (props) {
	  return props.theme.space[5];
	}, function (props) {
	  return props.theme.space[4];
	}, function (props) {
	  return props.theme.space[4];
	}, function (props) {
	  return props.theme.space[0];
	}, function (props) {
	  return "calc(" + 1 / 4 * 100 + "% - " + props.theme.space[4] / (1 / 3 + 1) + "px)";
	}, function (props) {
	  return props.theme.space[5];
	}, function (props) {
	  return props.theme.space[4];
	}, function (props) {
	  return props.theme.space[4];
	}, function (props) {
	  return props.theme.space[0];
	});
	
	exports.default = CardLayout;
	module.exports = exports["default"];

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n\n  &:hover,\n  &.focused {\n    > div {\n      transform: scaleY(1);\n      opacity: 1;\n      z-index: 100;\n    }\n  }\n"], ["\n  position: relative;\n\n  &:hover,\n  &.focused {\n    > div {\n      transform: scaleY(1);\n      opacity: 1;\n      z-index: 100;\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: color;\n  user-select: none;\n\n  &:hover {\n    color: ", ";\n  }\n  &:active {\n    color: ", ";\n  }\n"], ["\n  cursor: pointer;\n  transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: color;\n  user-select: none;\n\n  &:hover {\n    color: ", ";\n  }\n  &:active {\n    color: ", ";\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 56px;\n  left: -16px;\n  width: max-content;\n  min-width: ", "px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n  transform: scaleY(0);\n  transform-origin: top;\n  opacity: 0;\n  background-color: ", ";\n  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n"], ["\n  position: absolute;\n  top: 56px;\n  left: -16px;\n  width: max-content;\n  min-width: ", "px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n  transform: scaleY(0);\n  transform-origin: top;\n  opacity: 0;\n  background-color: ", ";\n  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  max-width: ", "px;\n  background-color: ", ";\n  transition: background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n\n  &:last-child {\n    span {\n      border-bottom: none;\n    }\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n"], ["\n  max-width: ", "px;\n  background-color: ", ";\n  transition: background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n\n  &:last-child {\n    span {\n      border-bottom: none;\n    }\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  display: block;\n  color: ", ";\n  line-height: 1.5;\n  border-bottom: 1px solid;\n  border-color: ", ";\n"], ["\n  display: block;\n  color: ", ";\n  line-height: 1.5;\n  border-bottom: 1px solid;\n  border-color: ", ";\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(8);
	
	var _rebass = __webpack_require__(4);
	
	var _theme = __webpack_require__(13);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject);
	Wrapper.defaultProps = {
	  align: "center",
	  flexDirection: "column"
	};
	
	var Parent = (0, _styledComponents2.default)(_rebass.Text)(_templateObject2, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.text && (0, _polished.shade)(0.875, props.theme.colors.violet);
	});
	Parent.defaultProps = {
	  is: _gatsbyLink2.default,
	  m: 0,
	  px: 2,
	  py: 3,
	  color: "text",
	  fontSize: 16,
	  fontWeight: "bold",
	  lineHeight: 3
	};
	
	var Container = (0, _styledComponents2.default)(_rebass.Box)(_templateObject3, 16 * 10, function (props) {
	  return props.theme.colors.grey[2];
	});
	
	var Item = (0, _styledComponents2.default)(_rebass.Box)(_templateObject4, 16 * 15, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.grey[1];
	}, function (props) {
	  return props.theme.colors.grey[1] && (0, _polished.rgba)(props.theme.colors.grey[1], 0.5);
	});
	Item.defaultProps = {};
	
	var ItemContent = (0, _styledComponents2.default)(_rebass.Box)(_templateObject5, function (props) {
	  return props.theme.colors.text;
	}, function (props) {
	  return props.theme.colors.grey[1];
	});
	ItemContent.defaultProps = {
	  is: "span",
	  mx: 4,
	  py: 4
	};
	
	var MenuItem = function MenuItem(props) {
	  return _react2.default.createElement(
	    Item,
	    { is: _gatsbyLink2.default, to: props.to, onFocus: props.onFocus, onBlur: props.onBlur },
	    _react2.default.createElement(ItemContent, { children: props.children })
	  );
	};
	
	var DropdownMenu = function (_React$Component) {
	  _inherits(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    _classCallCheck(this, DropdownMenu);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onFocus = function () {
	      _this.setState({ focused: true });
	    };
	
	    _this.onBlur = function () {
	      _this.setState({ focused: false });
	    };
	
	    _this.state = {
	      focused: false
	    };
	    return _this;
	  }
	
	  DropdownMenu.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      Wrapper,
	      { className: this.state.focused ? "focused" : "" },
	      this.props.parent && _react2.default.createElement(Parent, {
	        children: this.props.parent,
	        to: this.props.parentTo,
	        onFocus: this.onFocus,
	        onBlur: this.onBlur
	      }),
	      this.props.items && _react2.default.createElement(
	        _styledComponents.ThemeProvider,
	        { theme: _theme2.default },
	        _react2.default.createElement(
	          Container,
	          null,
	          this.props.items.map(function (item, index) {
	            if (item.node.lang === _this2.props.lang) {
	              return _react2.default.createElement(MenuItem, {
	                key: item.node.data.title[0].text,
	                children: item.node.data.title[0].text,
	                onFocus: _this2.onFocus,
	                onBlur: _this2.onBlur,
	                to: "/" + _this2.props.lang + "/" + (_this2.props.linkType ? _this2.props.linkType + "/" : item.node.type === 'campaign' ? 'campaign/' : "") + item.node.uid
	              });
	            } else {
	              return null;
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return DropdownMenu;
	}(_react2.default.Component);
	
	exports.default = DropdownMenu;
	module.exports = exports["default"];

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  text-decoration: none;\n  cursor: pointer;\n  opacity: 0;\n  animation: update-card-fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n  will-change: opacity;\n\n  @keyframes update-card-fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  &:hover {\n    .update-card__tile {\n      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n      transform: translateY(-4px);\n    }\n    .update-card__title {\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n  }\n  &:active {\n    .update-card__tile {\n      box-shadow: none;\n      transform: translateY(-2px);\n    }\n    .update-card__title {\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n  }\n\n  * {\n    text-decoration: none;\n\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"], ["\n  text-decoration: none;\n  cursor: pointer;\n  opacity: 0;\n  animation: update-card-fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n  will-change: opacity;\n\n  @keyframes update-card-fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  &:hover {\n    .update-card__tile {\n      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n      transform: translateY(-4px);\n    }\n    .update-card__title {\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n  }\n  &:active {\n    .update-card__tile {\n      box-shadow: none;\n      transform: translateY(-2px);\n    }\n    .update-card__title {\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n  }\n\n  * {\n    text-decoration: none;\n\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  padding-bottom: ", ";\n  /* background-color: ", ";\n  background-color: ", "; */\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: transform;\n  user-select: none;\n  &:not(:lang(ar)) {\n    &:before,\n    &:after {\n      right: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n  &:lang(ar) {\n    &:before,\n    &:after {\n      left: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n"], ["\n  position: relative;\n  width: 100%;\n  padding-bottom: ", ";\n  /* background-color: ", ";\n  background-color: ", "; */\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: transform;\n  user-select: none;\n  &:not(:lang(ar)) {\n    &:before,\n    &:after {\n      right: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n  &:lang(ar) {\n    &:before,\n    &:after {\n      left: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n  padding-bottom: 8px;\n  font-size: 18px;\n\n  > span {\n    box-shadow: inset 0 -1px 0 transparent;\n    transition: box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: box-shadow;\n  }\n"], ["\n  margin-top: 8px;\n  padding-bottom: 8px;\n  font-size: 18px;\n\n  > span {\n    box-shadow: inset 0 -1px 0 transparent;\n    transition: box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: box-shadow;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose([""], [""]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(8);
	
	var _theme = __webpack_require__(13);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _moment = __webpack_require__(23);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Action = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.grey[1];
	}, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors[props.cardColor] && (0, _polished.shade)(0.9375, props.theme.colors[props.cardColor]);
	});
	
	Action.defaultProps = {
	  is: "a"
	};
	
	var ImageWrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2, 2 / 3 * 100 + "%", function (props) {
	  return props.theme.colors[props.cardColor];
	}, function (props) {
	  return props.theme.colors.grey[1];
	}, function (props) {
	  return props.noColor ? "" : props.theme.colors.grey[1] && "linear-gradient(to right, " + (0, _polished.rgba)(props.theme.colors.grey[1], 0.75) + ", " + (0, _polished.rgba)(props.theme.colors.grey[1], 0) + ")";
	}, function (props) {
	  return props.noColor ? "" : props.theme.colors.grey[1] && "linear-gradient(to left, " + (0, _polished.rgba)(props.theme.colors.grey[1], 0.75) + ", " + (0, _polished.rgba)(props.theme.colors.grey[1], 0) + ")";
	});
	
	var Title = (0, _styledComponents2.default)(_components.H3)(_templateObject3);
	
	var Metadata = (0, _styledComponents2.default)(_components.H4)(_templateObject4);
	
	var truncateText = function truncateText(text) {
	  if (text.length > 65) {
	    var textArray = text.split(" ");
	    var textBuildup = "";
	    var position = 0;
	    while (textBuildup.length < 65) {
	      textBuildup += textArray[position] + " ";
	      position++;
	    }
	    if (textBuildup[textBuildup.length - 2] !== "?" && textBuildup[textBuildup.length - 2] !== "!" && textBuildup[textBuildup.length - 2] !== ".") {
	      text = textBuildup.slice(0, textBuildup.length - 1) + "...";
	    }
	  }
	  return text;
	};
	
	var ExternalUpdateCard = function ExternalUpdateCard(props) {
	  if (props.title && props.link && props.date && props.image && props.image.url) {
	    return _react2.default.createElement(
	      _styledComponents.ThemeProvider,
	      { theme: _theme2.default },
	      _react2.default.createElement(
	        Action,
	        {
	          href: props.link,
	          target: "_blank",
	          rel: "noopener noreferrer",
	          "aria-label": props.title[0] ? props.title[0].text : ""
	        },
	        _react2.default.createElement(
	          ImageWrapper,
	          { className: "update-card__tile" },
	          _react2.default.createElement(_components.OverlayImage, {
	            imageColor: "grey.2",
	            backgroundImage: props.image ? [props.image.url, props.image.half ? props.image.half.url : "", props.image.quarter ? props.image.quarter.url : ""] : undefined
	          })
	        ),
	        _react2.default.createElement(
	          Title,
	          null,
	          _react2.default.createElement("span", {
	            className: "update-card__title",
	            children: props.title[0] ? truncateText(props.title[0].text) : ""
	          })
	        ),
	        _react2.default.createElement(
	          _rebass.Flex,
	          null,
	          _react2.default.createElement(
	            Metadata,
	            { mt: "3px", mr: 3 },
	            props.date ? (0, _moment2.default)(props.date).format("MMMM DD, YYYY") : ""
	          )
	        )
	      )
	    );
	  } else {
	    return null;
	  }
	};
	
	exports.default = ExternalUpdateCard;
	module.exports = exports["default"];

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  * {\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"], ["\n  * {\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  margin-bottom: 16px;\n\n  > * {\n    &:not(:lang(ar)) {\n      margin-left: 16px;\n    }\n    &:lang(ar) {\n      margin-right: 16px;\n    }\n\n    &:first-child {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n  }\n\n  @media only screen and (max-width: 40em) {\n    align-items: center;\n    flex-wrap: wrap;\n    width: 100%;\n    margin-bottom: 0;\n\n    > * {\n      width: calc(50% - 8px);\n      margin-bottom: 16px;\n      &:not(:lang(ar)) {\n        margin-left: 16px;\n      }\n      &:lang(ar) {\n        margin-right: 16px;\n      }\n\n      &:nth-child(2n + 1) {\n        &:not(:lang(ar)) {\n          margin-left: 0;\n        }\n        &:lang(ar) {\n          margin-right: 0;\n        }\n      }\n    }\n  }\n"], ["\n  align-items: center;\n  margin-bottom: 16px;\n\n  > * {\n    &:not(:lang(ar)) {\n      margin-left: 16px;\n    }\n    &:lang(ar) {\n      margin-right: 16px;\n    }\n\n    &:first-child {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n  }\n\n  @media only screen and (max-width: 40em) {\n    align-items: center;\n    flex-wrap: wrap;\n    width: 100%;\n    margin-bottom: 0;\n\n    > * {\n      width: calc(50% - 8px);\n      margin-bottom: 16px;\n      &:not(:lang(ar)) {\n        margin-left: 16px;\n      }\n      &:lang(ar) {\n        margin-right: 16px;\n      }\n\n      &:nth-child(2n + 1) {\n        &:not(:lang(ar)) {\n          margin-left: 0;\n        }\n        &:lang(ar) {\n          margin-right: 0;\n        }\n      }\n    }\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(4);
	
	var _H = __webpack_require__(41);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.violet;
	});
	
	var Container = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject2);
	
	var FilterBar = function FilterBar(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(_H2.default, {
	      children: props.lang === "en-us" ? "Sort results by" : props.lang === "es-mx" ? "Ordenar resultados por" : "ترتيب النتائج حسب",
	      mb: 3
	    }),
	    _react2.default.createElement(
	      Container,
	      null,
	      props.children
	    )
	  );
	};
	
	FilterBar.defaultProps = {};
	
	exports.default = FilterBar;
	module.exports = exports["default"];

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  * {\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"], ["\n  width: 100%;\n  * {\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  max-width: 90em;\n"], ["\n  max-width: 90em;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  @media (max-width: 35em) {\n    flex-wrap: wrap;\n    > * {\n      width: 100%;\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n  }\n  @media (min-width: 35em) and (max-width: 75em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(2n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n  }\n  @media (min-width: 75em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(4n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n  }\n"], ["\n  @media (max-width: 35em) {\n    flex-wrap: wrap;\n    > * {\n      width: 100%;\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n  }\n  @media (min-width: 35em) and (max-width: 75em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(2n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n  }\n  @media (min-width: 75em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(4n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  display: block;\n  cursor: pointer;\n  padding-bottom: 8px;\n  &:last-child {\n    padding-bottom: 0;\n  }\n  &:hover > span:first-child {\n    box-shadow: inset 0 -1px 0 ", ";\n  }\n  > span:first-child {\n    transition: box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: box-shadow;\n  }\n"], ["\n  display: block;\n  cursor: pointer;\n  padding-bottom: 8px;\n  &:last-child {\n    padding-bottom: 0;\n  }\n  &:hover > span:first-child {\n    box-shadow: inset 0 -1px 0 ", ";\n  }\n  > span:first-child {\n    transition: box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: box-shadow;\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _Icons = __webpack_require__(138);
	
	var _invertTheme = __webpack_require__(12);
	
	var _invertTheme2 = _interopRequireDefault(_invertTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.violet;
	});
	Wrapper.defaultProps = {
	  is: "footer",
	  bg: "grey.1",
	  mt: "-1px"
	};
	
	var Container = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2);
	Container.defaultProps = {
	  is: "section",
	  w: "100%",
	  mx: "auto",
	  px: [4, 5, 6, 8],
	  py: [4, 6]
	};
	
	var ItemLayout = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject3, function (props) {
	  return props.theme.space[6];
	}, function (props) {
	  return "calc(" + 1 / 2 * 100 + "% - " + props.theme.space[6] / 2 + "px)";
	}, function (props) {
	  return props.theme.space[6];
	}, function (props) {
	  return props.theme.space[6];
	}, function (props) {
	  return props.theme.space[6];
	}, function (props) {
	  return "calc(" + 1 / 4 * 100 + "% - " + props.theme.space[6] / (1 / 3 + 1) + "px)";
	}, function (props) {
	  return props.theme.space[6];
	}, function (props) {
	  return props.theme.space[6];
	}, function (props) {
	  return props.theme.space[6];
	});
	
	var LanguageContainer = (0, _styledComponents2.default)(_rebass.Box)(_templateObject4, function (props) {
	  return props.theme.colors.grey[0];
	});
	
	var LanguageItem = function LanguageItem(props) {
	  return _react2.default.createElement(
	    LanguageContainer,
	    {
	      lang: props.lang,
	      title: props.translation + " (" + props.native + ")",
	      onClick: props.onClick,
	      tabIndex: 0,
	      role: "button"
	    },
	    _react2.default.createElement(_components.Text, { children: props.translation, is: "span", fontSize: 1 }),
	    _react2.default.createElement(_components.Text, { children: " " + props.native, is: "span", color: "violet", fontSize: 1 })
	  );
	};
	
	var SocialMedia = function SocialMedia(props) {
	  return _react2.default.createElement(
	    _rebass.Flex,
	    { align: "center", mt: 3 },
	    _react2.default.createElement(
	      _rebass.Box,
	      {
	        is: "a",
	        href: "https://www.facebook.com/BankInformationCenter",
	        target: "_blank",
	        mr: 3
	      },
	      _react2.default.createElement(_Icons.FacebookIcon, null)
	    ),
	    _react2.default.createElement(
	      _rebass.Box,
	      { is: "a", href: "https://twitter.com/BIC_Updates", target: "_blank", mr: 3 },
	      _react2.default.createElement(_Icons.TwitterIcon, null)
	    ),
	    _react2.default.createElement(
	      _rebass.Box,
	      {
	        is: "a",
	        href: "https://plus.google.com/103958583605622125042",
	        target: "_blank",
	        mr: 3
	      },
	      _react2.default.createElement(_Icons.GooglePlusIcon, null)
	    ),
	    _react2.default.createElement(
	      _rebass.Box,
	      {
	        is: "a",
	        href: "https://www.youtube.com/channel/UCNV3weatySNjywBHOchHfZQ",
	        target: "_blank"
	      },
	      _react2.default.createElement(_Icons.YouTubeIcon, null)
	    )
	  );
	};
	
	var Footer = function Footer(props) {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      Wrapper,
	      { role: "contentinfo" },
	      _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(
	          ItemLayout,
	          { mt: 6 },
	          _react2.default.createElement(
	            _rebass.Box,
	            null,
	            _react2.default.createElement(_components.H4, {
	              children: props.windowLang === "en-us" ? "Languages" : props.windowLang === "es-mx" ? "Idiomas" : "لغات",
	              mb: 3
	            }),
	            _react2.default.createElement(LanguageItem, {
	              translation: "Arabic",
	              native: "\u0639\u0631\u0628\u064A",
	              onClick: function onClick() {
	                props.changeLang("Arabic");
	              }
	            }),
	            _react2.default.createElement(LanguageItem, {
	              translation: "English",
	              native: "English",
	              onClick: function onClick() {
	                props.changeLang("English");
	              }
	            }),
	            _react2.default.createElement(LanguageItem, {
	              translation: "Spanish",
	              native: "Espa\xF1ol",
	              onClick: function onClick() {
	                props.changeLang("Spanish");
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _rebass.Box,
	            null,
	            _react2.default.createElement(_components.H4, {
	              children: props.windowLang === "en-us" ? "Contact us" : props.windowLang === "es-mx" ? "Contáctenos" : "إتصل بنا",
	              mb: 3
	            }),
	            _react2.default.createElement(
	              _rebass.Box,
	              null,
	              _react2.default.createElement(
	                _components.Text,
	                { fontSize: 1 },
	                props.windowLang === "en-us" ? "Phone" : props.windowLang === "es-mx" ? "Teléfono" : "الهاتف",
	                " ",
	                _react2.default.createElement(
	                  "a",
	                  { href: "tel:+1 (202) 737-7752", target: "_blank" },
	                  " ",
	                  "+1 (202) 737-7752"
	                )
	              ),
	              _react2.default.createElement(
	                _components.Text,
	                { fontSize: 1 },
	                props.windowLang === "en-us" ? "Email" : props.windowLang === "es-mx" ? "E-mail" : "البريد الإلكتروني",
	                " ",
	                _react2.default.createElement(
	                  "a",
	                  { href: "mailto:info@bankinformationcenter.org", target: "_blank" },
	                  "info@bankinformationcenter.org"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _rebass.Box,
	              { mt: 3 },
	              props.windowLang && _react2.default.createElement(_components.PrimaryButton, {
	                children: props.windowLang === "en-us" ? "Newsletter Sign-up" : props.windowLang === "es-mx" ? "Inscríbase al boletín" : "الاشتراك في الرسائل الإخبارية",
	                is: "a",
	                target: "_blank",
	                rel: "noopener noreferrer",
	                href: "http://eepurl.com/g7_4oD"
	              })
	            ),
	            _react2.default.createElement(SocialMedia, null)
	          ),
	          _react2.default.createElement(
	            _rebass.Box,
	            null,
	            _react2.default.createElement(_components.H4, {
	              children: props.windowLang === "en-us" ? "Bank Information Center" : props.windowLang === "es-mx" ? "Centro de Información Bancaria" : "البنك معلومات مركز",
	              mb: 3
	            }),
	            _react2.default.createElement(
	              _rebass.Box,
	              { mb: 3 },
	              _react2.default.createElement(
	                _rebass.Box,
	                { mb: 3 },
	                _react2.default.createElement(
	                  _components.Text,
	                  { fontSize: 1 },
	                  "1023 15th St NW"
	                ),
	                _react2.default.createElement(
	                  _components.Text,
	                  { fontSize: 1 },
	                  "Washington DC, 20005"
	                )
	              ),
	              _react2.default.createElement(
	                _components.Text,
	                { fontSize: 1 },
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  props.windowLang === "en-us" ? "Except where otherwise noted, content on this site by BIC is licensed under a Creative Commons Attribution 3.0 Unported License." : props.windowLang === "es-mx" ? "" : ""
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _rebass.Box,
	            null,
	            _react2.default.createElement(_components.H4, {
	              children: props.windowLang === "en-us" ? "Support Us" : props.windowLang === "es-mx" ? "Apóyenos" : "ادعم مركز معلومات البنك",
	              mb: 3
	            }),
	            _react2.default.createElement(
	              _rebass.Box,
	              { mb: 3 },
	              _react2.default.createElement(
	                _components.Text,
	                { fontSize: 1, mb: 3 },
	                props.windowLang === "en-us" ? "The work we do is funded through generous donations of foundations and individuals." : props.windowLang === "es-mx" ? "El trabajo que hacemos se financia a través de donaciones generosas de fundaciones e individuos." : "تدعم المؤسسات الخاصة والافراد عملنا في مركز معلومات البنك من خلال التبرعات والمنح."
	              ),
	              _react2.default.createElement(
	                _components.Text,
	                { fontSize: 1 },
	                _react2.default.createElement(
	                  "em",
	                  null,
	                  props.windowLang === "en-us" ? "The Bank Information Center is a 501(c)(3) organization. Gifts are tax deductible to the full extent allowable under the law." : props.windowLang === "es-mx" ? "El trabajo que hacemos se financia a través de donaciones generosas de fundaciones e individuos. BIC es una organización 501 (c) (3). Los obsequios son deducibles de impuestos en la medida permitida por la ley." : "ان مركز معلومات البنك هو منظمة غير هادفة للربح معفاة من الضرائب وفقًا للبند 501 (C)(3)‎ التابع لمصلحة الضرائب الأمريكية. التبرعات الى المركز معفاة من الضرائب إلى أقصى حد مسموح به بموجب القانون."
	                )
	              )
	            ),
	            props.windowLang && _react2.default.createElement(_components.PrimaryButton, {
	              children: props.windowLang === "en-us" ? "Learn How" : props.windowLang === "es-mx" ? "Aprender cómo" : "تعلم كيف",
	              is: _gatsbyLink2.default,
	              to: "/" + props.windowLang + "/support"
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      Wrapper,
	      { bg: "grey.0" },
	      _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(
	          _rebass.Flex,
	          {
	            flexDirection: ["column", null, "row"],
	            alignItems: ["flex-start", null, "center"]
	          },
	          _react2.default.createElement(
	            _rebass.Flex,
	            { flex: 1, mb: [4, null, 0] },
	            _react2.default.createElement(
	              "svg",
	              {
	                width: "160px",
	                height: "17.355px",
	                viewBox: "0 0 1180 128",
	                fill: "none",
	                xmlns: "http://www.w3.org/2000/svg"
	              },
	              _react2.default.createElement("path", {
	                "fill-rule": "evenodd",
	                "clip-rule": "evenodd",
	                d: "M597.025 99.3882H608.135V27.1059H597.025V99.3882ZM602.674 15.0588C607.005 15.0588 610.583 11.6706 610.583 7.52941C610.583 3.38824 607.005 0 602.674 0C598.343 0 594.765 3.38824 594.765 7.52941C594.765 11.6706 598.343 15.0588 602.674 15.0588ZM313.764 99.3882H301.713L275.35 3.01176H287.213L307.362 81.5059H308.303L328.828 3.01176H342.01L362.535 81.5059H363.476L383.625 3.01176H395.488L369.125 99.3882H357.074L335.796 22.5882H335.042L313.764 99.3882ZM462.611 63.6235C462.611 86.0235 449.429 100.894 429.846 100.894C410.262 100.894 397.081 86.0235 397.081 63.6235C397.081 41.0353 410.262 26.1647 429.846 26.1647C449.429 26.1647 462.611 41.0353 462.611 63.6235ZM408.191 63.6235C408.191 78.1176 414.97 90.9176 429.846 90.9176C444.722 90.9176 451.501 78.1176 451.501 63.6235C451.501 49.1294 444.722 36.1412 429.846 36.1412C414.97 36.1412 408.191 49.1294 408.191 63.6235ZM478.244 99.3882H489.354V53.6471C489.354 43.8588 497.074 36.7059 507.619 36.7059C510.585 36.7059 513.645 37.2706 514.398 37.4588V26.1647C513.127 26.0706 510.209 25.9765 508.561 25.9765C499.899 25.9765 492.367 30.8706 489.731 38.0235H488.977V27.1059H478.244V99.3882ZM537.352 99.3882H526.242V3.01176H537.352V59.2941H538.67L570.305 27.1059H584.051L553.499 57.9765L586.311 99.3882H572.188L545.12 65.1294L537.352 72.3294V99.3882ZM656.722 36.1412C646.082 36.1412 638.268 43.2941 638.268 55.9059V99.3882H627.158V27.1059H637.891V38.4H638.833C642.222 31.0588 649.001 26.1647 659.923 26.1647C674.563 26.1647 684.402 35.0118 684.402 53.4588V99.3882H673.292V54.2118C673.292 42.8706 667.031 36.1412 656.722 36.1412ZM732.565 128C749.889 128 763.824 120.094 763.824 101.459V27.1059H753.09V38.5882H751.96C751.806 38.35 751.642 38.0922 751.469 37.8183L751.466 37.8129C748.898 33.7557 744.094 26.1647 730.87 26.1647C712.605 26.1647 699.989 40.6588 699.989 62.8706C699.989 85.4588 713.17 98.2588 730.682 98.2588C744.264 98.2588 748.964 90.5991 751.481 86.4963C751.581 86.3328 751.678 86.175 751.772 86.0235H752.714V100.706C752.714 112.753 744.24 118.212 732.565 118.212C719.898 118.212 715.157 111.778 712.175 107.732L712.001 107.496L711.852 107.294L703.001 113.506C707.521 121.082 716.418 128 732.565 128ZM732.189 88.2823C718.254 88.2823 711.099 77.7412 711.099 62.6824C711.099 48 718.066 36.1412 732.189 36.1412C745.746 36.1412 752.902 47.0588 752.902 62.6824C752.902 78.6824 745.558 88.2823 732.189 88.2823ZM888.089 87.6235C880.745 96.0471 872.224 100.706 859.467 100.706C833.857 100.706 816.534 81.6941 816.534 51.2C816.534 20.7059 834.422 1.69411 859.09 1.69411C879.427 1.69411 895.621 14.4941 899.199 33.1294H887.147C883.287 20.4235 872.978 12.6118 859.09 12.6118C841.954 12.6118 827.832 26.1647 827.832 51.2C827.832 76.2353 841.578 89.7882 859.467 89.7882C876.226 89.7882 887.901 78.0706 888.466 61.5529H862.103V51.2H899.764V99.3882H889.972L888.56 87.6235H888.089ZM916.892 99.3882H928.002V53.6471C928.002 43.8588 935.722 36.7059 946.267 36.7059C949.233 36.7059 952.293 37.2706 953.046 37.4588V26.1647C951.775 26.0706 948.856 25.9765 947.209 25.9765C938.547 25.9765 931.015 30.8706 928.378 38.0235H927.625V27.1059H916.892V99.3882ZM1024.83 63.6235C1024.83 86.0235 1011.65 100.894 992.065 100.894C972.481 100.894 959.3 86.0235 959.3 63.6235C959.3 41.0353 972.481 26.1647 992.065 26.1647C1011.65 26.1647 1024.83 41.0353 1024.83 63.6235ZM970.41 63.6235C970.41 78.1176 977.189 90.9176 992.065 90.9176C1006.94 90.9176 1013.72 78.1176 1013.72 63.6235C1013.72 49.1294 1006.94 36.1412 992.065 36.1412C977.189 36.1412 970.41 49.1294 970.41 63.6235ZM1086.03 69.8353C1086.03 83.3882 1075.68 89.6 1067.39 89.6C1058.16 89.6 1051.57 82.8235 1051.57 72.2824V27.1059H1040.46V73.0353C1040.46 91.4823 1050.25 100.329 1063.81 100.329C1074.73 100.329 1081.89 94.4941 1085.28 87.1529H1086.03V99.3882H1097.14V27.1059H1086.03V69.8353ZM1127.28 126.494H1116.17V27.1059H1126.9V38.5882H1128.22C1128.39 38.3158 1128.58 38.0177 1128.78 37.6991C1131.34 33.6156 1136.02 26.1647 1149.12 26.1647C1167.38 26.1647 1180 40.6588 1180 63.4353C1180 86.4 1167.38 100.894 1149.31 100.894C1135.95 100.894 1131.07 92.9337 1128.53 88.7937L1128.51 88.7589L1128.34 88.4809L1128.22 88.2823H1127.28V126.494ZM1147.8 36.1412C1134.24 36.1412 1127.09 47.0588 1127.09 63.2471C1127.09 79.6235 1134.43 90.9176 1147.8 90.9176C1161.73 90.9176 1168.89 78.6824 1168.89 63.2471C1168.89 48 1161.92 36.1412 1147.8 36.1412ZM0 2.76078H64.6258V20.1537H41.4268V81.9953H64.6258V99.3882H0V81.9953H23.199V20.1537H0V2.76078ZM143.751 2.76078H81.887V99.3882H100.115V59.6329H142.922V42.24H100.115V20.1537H143.751V2.76078ZM225.638 2.76078H161.012V20.1537H184.211V81.9953H161.012V99.3882H225.638V81.9953H202.439V20.1537H225.638V2.76078Z",
	                fill: "white"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { flex: 2, flexDirection: "column", mb: [4, null, 0] },
	            _react2.default.createElement(
	              _components.H4,
	              { color: "white" },
	              props.windowLang === "en-us" ? "Looking for the IFI Working Group?" : props.windowLang === "es-mx" ? "¿Busca el Grupo de Trabajo de las IFI?" : "هل تبحث عن مجموعة عمل IFI؟"
	            ),
	            _react2.default.createElement(
	              _components.Text,
	              { mt: 2, color: "white" },
	              props.windowLang === "en-us" ? "BIC co-chairs the IFI Working Group and administers their website." : props.windowLang === "es-mx" ? "BIC copreside el Grupo de Trabajo de IFI y administra su sitio web." : " رئاسة مجموعة عمل IFI ويدير م"
	            )
	          ),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { flex: 1, mb: [4, null, 0] },
	            _react2.default.createElement(
	              _rebass.Box,
	              { pl: [0, 0, 5] },
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "https://ifiworkinggroup.org/",
	                  target: "_blank",
	                  rel: "noopener noreferrer"
	                },
	                _react2.default.createElement(
	                  _styledComponents.ThemeProvider,
	                  { theme: _invertTheme2.default },
	                  _react2.default.createElement(
	                    _components.Button,
	                    null,
	                    props.windowLang === "en-us" ? "Learn more" : props.windowLang === "es-mx" ? "Aprende más" : "أعرف أكثر"
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(117);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Head = function Head(props) {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: props.source.meta_title[0] ? props.source.meta_title[0].text : "Bank Information Center",
	      meta: [{
	        name: "description",
	        content: props.source.meta_description[0] ? props.source.meta_description[0].text : "We partner with civil society to spotlight the risks associated with development, and work to improve transparency, accountability, and sustainability at the institutions that drive it."
	      }, { property: "og:type", content: "website" }, {
	        property: "og:title",
	        content: props.source.meta_title[0] ? props.source.meta_title[0].text : "Bank Information Center"
	      }, {
	        property: "og:description",
	        content: props.source.meta_description[0] ? props.source.meta_description[0].text : "We partner with civil society to spotlight the risks associated with development, and work to improve transparency, accountability, and sustainability at the institutions that drive it."
	      }, { property: "og:image:width", content: "1200" }, { property: "og:image:height", content: "630" }, {
	        property: "og:image",
	        content: props.source.social_sharing_image ? props.source.social_sharing_image.url : (0, _gatsbyLink.withPrefix)("/opengraph/bic_open-graph_01.png")
	      }, { property: "og:site_name", content: "Bank Information Center" }]
	    })
	  );
	};
	
	exports.default = Head;
	module.exports = exports["default"];

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 9999;\n  width: 100%;\n  background: #fff;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 9999;\n  width: 100%;\n  background: #fff;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  max-width: 90em;\n"], ["\n  position: relative;\n  max-width: 90em;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: 80px;\n"], ["\n  position: relative;\n  height: 80px;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  height: 80px;\n  user-select: none;\n\n  @media only screen and (max-width: 40rem) {\n    &:not(:lang(ar)) {\n      margin-left: 24px;\n    }\n    &:lang(ar) {\n      margin-right: 24px;\n    }\n  }\n"], ["\n  height: 80px;\n  user-select: none;\n\n  @media only screen and (max-width: 40rem) {\n    &:not(:lang(ar)) {\n      margin-left: 24px;\n    }\n    &:lang(ar) {\n      margin-right: 24px;\n    }\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  height: 40px;\n  z-index: ", ";\n"], ["\n  height: 40px;\n  z-index: ", ";\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  color: ", " !important;\n  height: 40px;\n  &:not(:lang(ar)) {\n    margin-left: 16px;\n  }\n  &:lang(ar) {\n    margin-right: 16px;\n  }\n  color: #fff;\n\n  @media (max-width: 30em) {\n    display: none;\n  }\n  @media (min-width: 30em) and (max-width: 72em) {\n    display: block;\n  }\n  @media (min-width: 72em) and (max-width: 85em) {\n    display: none;\n  }\n"], ["\n  color: ", " !important;\n  height: 40px;\n  &:not(:lang(ar)) {\n    margin-left: 16px;\n  }\n  &:lang(ar) {\n    margin-right: 16px;\n  }\n  color: #fff;\n\n  @media (max-width: 30em) {\n    display: none;\n  }\n  @media (min-width: 30em) and (max-width: 72em) {\n    display: block;\n  }\n  @media (min-width: 72em) and (max-width: 85em) {\n    display: none;\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n\n  @media (max-width: 40em) {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n  }\n"], ["\n  position: relative;\n  width: 100%;\n\n  @media (max-width: 40em) {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: color;\n  user-select: none;\n\n  &:hover {\n    color: ", ";\n  }\n  &:active {\n    color: ", ";\n  }\n"], ["\n  cursor: pointer;\n  transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: color;\n  user-select: none;\n\n  &:hover {\n    color: ", ";\n  }\n  &:active {\n    color: ", ";\n  }\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  @media (max-width: 72em) {\n    display: none;\n  }\n"], ["\n  @media (max-width: 72em) {\n    display: none;\n  }\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  top: 24px;\n  left: -2000px;\n  z-index: 9999;\n  &:focus {\n    left: 24px;\n  }\n"], ["\n  position: fixed;\n  top: 24px;\n  left: -2000px;\n  z-index: 9999;\n  &:focus {\n    left: 24px;\n  }\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  @media (min-width: 40em) and (max-width: 72em) {\n    &:not(:lang(ar)) {\n      margin-right: 32px;\n    }\n    &:lang(ar) {\n      margin-left: 32px;\n    }\n  }\n  @media (max-width: 45em) {\n    display: none;\n  }\n"], ["\n  @media (min-width: 40em) and (max-width: 72em) {\n    &:not(:lang(ar)) {\n      margin-right: 32px;\n    }\n    &:lang(ar) {\n      margin-left: 32px;\n    }\n  }\n  @media (max-width: 45em) {\n    display: none;\n  }\n"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 44px;\n  height: 44px;\n  text-decoration: none;\n  border: 0;\n  border-radius: 9999px;\n  background-color: transparent;\n  cursor: pointer;\n  user-select: none;\n  appearance: none;\n  transition: background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n\n  svg > g > g {\n    transition: stroke 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: stroke;\n  }\n\n  &:hover {\n    background-color: ", ";\n    svg > g > g {\n      stroke: #fff;\n    }\n  }\n  &:focus {\n    background-color: ", ";\n    box-shadow: 0 0 0 4px\n      ", ";\n    outline: none;\n    svg > g > g {\n      stroke: #fff;\n    }\n  }\n  &:active {\n    background-color: ", ";\n    svg > g > g {\n      stroke: #fff;\n    }\n  }\n"], ["\n  position: relative;\n  width: 44px;\n  height: 44px;\n  text-decoration: none;\n  border: 0;\n  border-radius: 9999px;\n  background-color: transparent;\n  cursor: pointer;\n  user-select: none;\n  appearance: none;\n  transition: background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n\n  svg > g > g {\n    transition: stroke 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: stroke;\n  }\n\n  &:hover {\n    background-color: ", ";\n    svg > g > g {\n      stroke: #fff;\n    }\n  }\n  &:focus {\n    background-color: ", ";\n    box-shadow: 0 0 0 4px\n      ", ";\n    outline: none;\n    svg > g > g {\n      stroke: #fff;\n    }\n  }\n  &:active {\n    background-color: ", ";\n    svg > g > g {\n      stroke: #fff;\n    }\n  }\n"]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 24px;\n  height: 24px;\n  transform: translate(-50%, -50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 24px;\n  height: 24px;\n  transform: translate(-50%, -50%);\n"]),
	    _templateObject14 = _taggedTemplateLiteralLoose(["\n  display: none;\n  @media (min-width: 40em) and (max-width: 72em) {\n    display: block;\n  }\n"], ["\n  display: none;\n  @media (min-width: 40em) and (max-width: 72em) {\n    display: block;\n  }\n"]),
	    _templateObject15 = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid;\n  border-color: ", ";\n  @media (min-width: 40em) {\n    display: none;\n  }\n"], ["\n  border-bottom: 1px solid;\n  border-color: ", ";\n  @media (min-width: 40em) {\n    display: none;\n  }\n"]),
	    _templateObject16 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 44px;\n  height: 44px;\n  text-decoration: none;\n  border: 0;\n  border-radius: 9999px;\n  background-color: transparent;\n  cursor: pointer;\n  user-select: none;\n  appearance: none;\n  transition: background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n\n  svg > g > g {\n    transition: stroke 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: stroke;\n  }\n\n  &:hover {\n    background-color: ", ";\n    svg > g > g {\n      stroke: #fff;\n    }\n  }\n  &:focus {\n    background-color: ", ";\n    box-shadow: 0 0 0 4px\n      ", ";\n    outline: none;\n    svg > g > g {\n      stroke: #fff;\n    }\n  }\n  &:active {\n    background-color: ", ";\n    svg > g > g {\n      stroke: #fff;\n    }\n  }\n  @media (min-width: 72em) {\n    display: none;\n  }\n"], ["\n  position: relative;\n  width: 44px;\n  height: 44px;\n  text-decoration: none;\n  border: 0;\n  border-radius: 9999px;\n  background-color: transparent;\n  cursor: pointer;\n  user-select: none;\n  appearance: none;\n  transition: background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n\n  svg > g > g {\n    transition: stroke 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: stroke;\n  }\n\n  &:hover {\n    background-color: ", ";\n    svg > g > g {\n      stroke: #fff;\n    }\n  }\n  &:focus {\n    background-color: ", ";\n    box-shadow: 0 0 0 4px\n      ", ";\n    outline: none;\n    svg > g > g {\n      stroke: #fff;\n    }\n  }\n  &:active {\n    background-color: ", ";\n    svg > g > g {\n      stroke: #fff;\n    }\n  }\n  @media (min-width: 72em) {\n    display: none;\n  }\n"]),
	    _templateObject17 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 24px;\n  height: 18px;\n  transform: translate(-50%, -50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 24px;\n  height: 18px;\n  transform: translate(-50%, -50%);\n"]),
	    _templateObject18 = _taggedTemplateLiteralLoose(["\n  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.2);\n  @media (min-width: 72em) {\n    display: none;\n  }\n"], ["\n  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.2);\n  @media (min-width: 72em) {\n    display: none;\n  }\n"]),
	    _templateObject19 = _taggedTemplateLiteralLoose(["\n  display: block;\n  color: ", ";\n  background: #fff;\n  border-top: 1px solid;\n  border-color: ", ";\n  transition: background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n\n  ", ";\n"], ["\n  display: block;\n  color: ", ";\n  background: #fff;\n  border-top: 1px solid;\n  border-color: ", ";\n  transition: background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n\n  ", ";\n"]),
	    _templateObject20 = _taggedTemplateLiteralLoose(["\n      padding-left: ", "px;\n      background: ", ";\n      border-color: ", ";\n    "], ["\n      padding-left: ", "px;\n      background: ", ";\n      border-color: ", ";\n    "]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(8);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _theme = __webpack_require__(13);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _invertTheme = __webpack_require__(12);
	
	var _invertTheme2 = _interopRequireDefault(_invertTheme);
	
	var _reactFeather = __webpack_require__(29);
	
	var Icon = _interopRequireWildcard(_reactFeather);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject);
	Wrapper.defaultProps = {
	  is: "header"
	};
	
	var Container = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2);
	Container.defaultProps = {
	  is: "section",
	  w: "100%",
	  mx: "auto",
	  px: [0, 5, 6, 8]
	};
	
	var HeaderContainer = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject3);
	HeaderContainer.defaultProps = {
	  // pr: [0, 4],
	  // bg: "grey.2"
	};
	
	var LogoPanel = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject4);
	LogoPanel.defaultProps = {
	  is: _gatsbyLink2.default,
	  title: "Bank Information Center",
	  align: "center",
	  py: 20
	};
	
	var LogoContainer = (0, _styledComponents2.default)(_rebass.Box)(_templateObject5, function (props) {
	  return props.open ? "9999" : "";
	});
	
	var LogoTitle = (0, _styledComponents2.default)(_components.H4)(_templateObject6, function (props) {
	  return props.theme.colors.violet;
	});
	LogoTitle.defaultProps = {
	  is: "span",
	  lineHeight: 2
	};
	
	var NavContainer = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject7);
	
	var NavItem = (0, _styledComponents2.default)(_rebass.Text)(_templateObject8, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.text && (0, _polished.shade)(0.875, props.theme.colors.violet);
	});
	NavItem.defaultProps = {
	  is: "span",
	  m: 0,
	  px: 2,
	  py: 3,
	  color: "text",
	  fontSize: 16,
	  fontWeight: "bold",
	  lineHeight: 3
	};
	
	var NavigationContainer = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject9);
	NavigationContainer.defaultProps = {
	  is: "nav",
	  flex: 1,
	  justify: "space-between",
	  px: 24
	};
	
	var NavSkip = (0, _styledComponents2.default)(_components.PrimaryButton)(_templateObject10);
	
	var Navigation = function Navigation(props) {
	  return _react2.default.createElement(
	    NavigationContainer,
	    null,
	    _react2.default.createElement(_components.DropdownMenu, {
	      parent: props.windowLang === "en-us" ? "About" : props.windowLang === "es-mx" ? "Sobre BIC" : "عن نحن",
	      parentTo: "/" + props.windowLang + "/" + "about",
	      items: [{
	        node: {
	          lang: props.windowLang,
	          uid: "team",
	          data: {
	            title: [{
	              text: props.windowLang === "en-us" ? "Team" : props.windowLang === "es-mx" ? "Equipo" : "الفريق"
	            }]
	          }
	        }
	      }, {
	        node: {
	          lang: props.windowLang,
	          uid: "contact",
	          data: {
	            title: [{
	              text: props.windowLang === "en-us" ? "Contact" : props.windowLang === "es-mx" ? "Contacto" : "اتصل"
	            }]
	          }
	        }
	      }, {
	        node: {
	          lang: props.windowLang,
	          uid: "support",
	          data: {
	            title: [{
	              text: props.windowLang === "en-us" ? "Support" : props.windowLang === "es-mx" ? "Súmate" : "الدعم"
	            }]
	          }
	        }
	      }, {
	        node: {
	          lang: props.windowLang,
	          uid: "careers",
	          data: {
	            title: [{
	              text: props.windowLang === "en-us" ? "Careers" : props.windowLang === "es-mx" ? "Empleo" : "وظائف"
	            }]
	          }
	        }
	      }, {
	        node: {
	          lang: props.windowLang,
	          uid: "reports",
	          data: {
	            title: [{
	              text: props.windowLang === "en-us" ? "Reports" : props.windowLang === "es-mx" ? "Informes" : "التقارير"
	            }]
	          }
	        }
	      }],
	      linkType: "",
	      lang: props.windowLang
	    }),
	    _react2.default.createElement(_components.DropdownMenu, {
	      parent: props.windowLang === "en-us" ? "Campaigns" : props.windowLang === "es-mx" ? "Campañas" : "حملات",
	      parentTo: "/" + props.windowLang + "/" + "campaigns",
	      items: [].concat(props.data.landing_pages.edges.filter(function (campaign) {
	        return campaign.node.data.show_in_navigation === "Show in navigation" ? true : false;
	      }), props.data.campaigns.edges.filter(function (campaign) {
	        return campaign.node.data.show_in_navigation !== "No" ? true : false;
	      }))
	      // linkType="campaign"
	      , lang: props.windowLang
	    }),
	    _react2.default.createElement(_components.DropdownMenu, {
	      parent: props.windowLang === "en-us" ? "Regions" : props.windowLang === "es-mx" ? "Regiones" : "مناطق",
	      parentTo: "/" + props.windowLang + "/" + "regions",
	      items: props.data.regions.edges,
	      linkType: "region",
	      lang: props.windowLang
	    }),
	    _react2.default.createElement(_components.DropdownMenu, {
	      parent: props.windowLang === "en-us" ? "Institutions" : props.windowLang === "es-mx" ? "Instituciones" : "مؤسسات",
	      parentTo: "/" + props.windowLang + "/" + "institutions",
	      items: props.data.institutions.edges,
	      linkType: "institution",
	      lang: props.windowLang
	    }),
	    _react2.default.createElement(NavItem, {
	      children: props.windowLang === "en-us" ? "Resources" : props.windowLang === "es-mx" ? "Recursos" : " مصادر",
	      is: _gatsbyLink2.default,
	      to: "/" + props.windowLang + "/" + "resources"
	    }),
	    _react2.default.createElement(NavItem, {
	      children: props.windowLang === "en-us" ? "Updates" : props.windowLang === "es-mx" ? "Noticias" : "تحديثات",
	      is: _gatsbyLink2.default,
	      to: "/" + props.windowLang + "/" + "updates"
	    })
	  );
	};
	
	var ButtonWrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject11);
	
	var SearchContainer = (0, _styledComponents2.default)(_rebass.Box)(_templateObject12, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.text && (0, _polished.rgba)(props.theme.colors.violet, 0.5);
	}, function (props) {
	  return props.theme.colors.text && (0, _polished.shade)(0.875, props.theme.colors.violet);
	});
	SearchContainer.defaultProps = {
	  is: "button",
	  mx: 3
	};
	
	var SearchIconContainer = (0, _styledComponents2.default)(_rebass.Box)(_templateObject13);
	
	var SearchButton = function SearchButton(props) {
	  return _react2.default.createElement(
	    SearchContainer,
	    props,
	    _react2.default.createElement(
	      SearchIconContainer,
	      null,
	      _react2.default.createElement(Icon.Search, { size: 24 })
	    )
	  );
	};
	
	var LanguageDesktopWrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject9);
	
	var LanguageTabletWrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject14);
	
	var LanguageMobileWrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject15, function (props) {
	  return props.theme.colors.grey[1] && (0, _polished.shade)(0.9, props.theme.colors.grey[1]);
	});
	
	var HamburgerMenuContainer = (0, _styledComponents2.default)(_rebass.Box)(_templateObject16, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.text && (0, _polished.rgba)(props.theme.colors.violet, 0.5);
	}, function (props) {
	  return props.theme.colors.text && (0, _polished.shade)(0.875, props.theme.colors.violet);
	});
	HamburgerMenuContainer.defaultProps = {
	  is: "button"
	};
	
	var HamburgerMenuIconContainer = (0, _styledComponents2.default)(_rebass.Box)(_templateObject17);
	
	var HamburgerMenu = function HamburgerMenu(props) {
	  return _react2.default.createElement(
	    HamburgerMenuContainer,
	    { onClick: props.onClick },
	    _react2.default.createElement(
	      HamburgerMenuIconContainer,
	      null,
	      _react2.default.createElement(_components.HamburgerMenuIcon, null)
	    )
	  );
	};
	
	var MobileMenu = (0, _styledComponents2.default)(_rebass.Box)(_templateObject18);
	MobileMenu.defaultProps = {
	  is: "nav",
	  w: "100%",
	  mx: "auto"
	};
	
	var MobileMenuItem = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject19, function (props) {
	  return props.theme.colors.text;
	}, function (props) {
	  return props.theme.colors.grey[1];
	}, function (props) {
	  return props.indented && (0, _styledComponents.css)(_templateObject20, 16 + 16, function (props) {
	    return props.theme.colors.grey[1];
	  }, function (props) {
	    return props.theme.colors.grey[1] && (0, _polished.shade)(0.9, props.theme.colors.grey[1]);
	  });
	});
	MobileMenuItem.defaultProps = {
	  is: _gatsbyLink2.default,
	  px: [3, 5, 8],
	  py: 3
	};
	
	var HeaderInnner = function HeaderInnner(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    { role: "banner" },
	    _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(NavSkip, {
	        children: "Skip to main content",
	        onClick: function onClick() {
	          document.getElementById("maincontent").focus();
	        }
	      }),
	      _react2.default.createElement(
	        HeaderContainer,
	        { align: "stretch", justify: "space-between" },
	        _react2.default.createElement(
	          LogoPanel,
	          {
	            to: props.windowLang === "en-us" ? "/" : props.windowLang === "es-mx" ? "es-mx" : "/ar-eg/",
	            onClick: props.closeMenu
	          },
	          _react2.default.createElement(
	            LogoContainer,
	            { open: !props.searchOpen },
	            _react2.default.createElement(_components.Logo, null)
	          ),
	          _react2.default.createElement(
	            LogoTitle,
	            null,
	            props.windowLang === "en-us" ? _react2.default.createElement(
	              "span",
	              null,
	              "Bank",
	              _react2.default.createElement("br", null),
	              "Information",
	              _react2.default.createElement("br", null),
	              "Center"
	            ) : props.windowLang === "es-mx" ? _react2.default.createElement(
	              "span",
	              null,
	              "Centro de",
	              _react2.default.createElement("br", null),
	              "Informaci\xF3n",
	              _react2.default.createElement("br", null),
	              "Bancaria"
	            ) : _react2.default.createElement(
	              "span",
	              null,
	              "\u0645\u0631\u0643\u0632",
	              _react2.default.createElement("br", null),
	              "\u0645\u0639\u0644\u0648\u0645\u0627\u062A",
	              _react2.default.createElement("br", null),
	              "\u0627\u0644\u0628\u0646\u0643"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          NavContainer,
	          { align: "center", justify: "flex-end" },
	          _react2.default.createElement(Navigation, _extends({ role: "navigation" }, props)),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { align: "center", justify: "flex-end", mr: [4, 0] },
	            _react2.default.createElement(
	              ButtonWrapper,
	              null,
	              _react2.default.createElement(_components.PrimaryButton, {
	                is: _gatsbyLink2.default,
	                to: "/" + props.windowLang + "/" + "support",
	                children: props.windowLang === "en-us" ? "Support us" : props.windowLang === "es-mx" ? "Apóyenos" : "ادعم مركز معلومات البنك",
	                onClick: props.closeMenu
	              })
	            ),
	            _react2.default.createElement(
	              LanguageTabletWrapper,
	              null,
	              _react2.default.createElement(
	                _components.Select,
	                {
	                  onChange: function onChange(event) {
	                    props.changeLang(event.target.value);
	                  },
	                  value: props.currentLang,
	                  "aria-label": "Language"
	                },
	                _react2.default.createElement("option", { children: "Arabic" }),
	                _react2.default.createElement("option", { children: "English" }),
	                _react2.default.createElement("option", { children: "Spanish" })
	              )
	            ),
	            _react2.default.createElement(
	              _rebass.Box,
	              { w: 44, mx: 3 },
	              _react2.default.createElement(_components.Search, {
	                searchOpen: props.searchOpen,
	                searchHasHappened: props.searchHasHappened,
	                toggleSearch: props.toggleSearch,
	                windowLang: props.windowLang
	              })
	            ),
	            _react2.default.createElement(HamburgerMenu, { onClick: props.toggleMenu })
	          ),
	          _react2.default.createElement(
	            LanguageDesktopWrapper,
	            null,
	            _react2.default.createElement(
	              _components.Select,
	              {
	                onChange: function onChange(event) {
	                  props.changeLang(event.target.value);
	                },
	                value: props.currentLang,
	                "aria-label": "Language"
	              },
	              _react2.default.createElement("option", { children: "Arabic" }),
	              _react2.default.createElement("option", { children: "English" }),
	              _react2.default.createElement("option", { children: "Spanish" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        LanguageMobileWrapper,
	        { py: 3, px: 3, bg: "grey.1" },
	        _react2.default.createElement(
	          _rebass.Box,
	          { w: "max-content" },
	          _react2.default.createElement(
	            _components.Select,
	            {
	              onChange: function onChange(event) {
	                props.changeLang(event.target.value);
	              },
	              value: props.currentLang,
	              "aria-label": "Language"
	            },
	            _react2.default.createElement("option", { children: "Arabic" }),
	            _react2.default.createElement("option", { children: "English" }),
	            _react2.default.createElement("option", { children: "Spanish" })
	          )
	        )
	      ),
	      props.menuOpen && _react2.default.createElement(
	        _rebass.Box,
	        { mx: [0, -5, -8] },
	        _react2.default.createElement(
	          MobileMenu,
	          null,
	          _react2.default.createElement(MobileMenuItem, {
	            children: props.windowLang === "en-us" ? "About" : props.windowLang === "es-mx" ? "Sobre BIC" : "عن نحن",
	            to: "/" + props.windowLang + "/" + "about",
	            onClick: props.closeMenu
	          }),
	          _react2.default.createElement(MobileMenuItem, {
	            children: props.windowLang === "en-us" ? "Team" : props.windowLang === "es-mx" ? "Equipo" : "الفريق",
	            to: "/" + props.windowLang + "/" + "team",
	            indented: "true",
	            onClick: props.closeMenu
	          }),
	          _react2.default.createElement(MobileMenuItem, {
	            children: props.windowLang === "en-us" ? "Contact" : props.windowLang === "es-mx" ? "Contacto" : "اتصل",
	            to: "/" + props.windowLang + "/" + "contact",
	            indented: "true",
	            onClick: props.closeMenu
	          }),
	          _react2.default.createElement(MobileMenuItem, {
	            children: props.windowLang === "en-us" ? "Support" : props.windowLang === "es-mx" ? "Súmate" : "الدعم",
	            to: "/" + props.windowLang + "/" + "support",
	            indented: "true",
	            onClick: props.closeMenu
	          }),
	          _react2.default.createElement(MobileMenuItem, {
	            children: props.windowLang === "en-us" ? "Careers" : props.windowLang === "es-mx" ? "Empleo" : "وظائف",
	            to: "/" + props.windowLang + "/" + "careers",
	            indented: "true",
	            onClick: props.closeMenu
	          }),
	          _react2.default.createElement(MobileMenuItem, {
	            children: props.windowLang === "en-us" ? "Reports" : props.windowLang === "es-mx" ? "Informes" : "التقارير",
	            to: "/" + props.windowLang + "/" + "reports",
	            indented: "true",
	            onClick: props.closeMenu
	          }),
	          _react2.default.createElement(MobileMenuItem, {
	            children: props.windowLang === "en-us" ? "Campaigns" : props.windowLang === "es-mx" ? "Campañas" : "حملات",
	            to: "/" + props.windowLang + "/" + "campaigns",
	            onClick: props.closeMenu
	          }),
	          props.data.landing_pages.edges.filter(function (campaign) {
	            return campaign.node.data.show_in_navigation === "Show in navigation" ? true : false;
	          }).map(function (campaign, index) {
	            if (campaign.node.lang === props.windowLang) {
	              return _react2.default.createElement(MobileMenuItem, {
	                children: campaign.node.data.title[0].text,
	                indented: "true",
	                key: "campaignheader" + index,
	                to: "/" + props.windowLang + "/" + campaign.node.uid,
	                onClick: props.closeMenu
	              });
	            } else {
	              return null;
	            }
	          }),
	          props.data.campaigns.edges.filter(function (campaign) {
	            return campaign.node.data.show_in_navigation !== "No" ? true : false;
	          }).map(function (campaign, index) {
	            if (campaign.node.lang === props.windowLang) {
	              return _react2.default.createElement(MobileMenuItem, {
	                children: campaign.node.data.title[0].text,
	                indented: "true",
	                key: "campaignheader" + index,
	                to: "/" + props.windowLang + "/" + "campaign/" + campaign.node.uid,
	                onClick: props.closeMenu
	              });
	            } else {
	              return null;
	            }
	          }),
	          _react2.default.createElement(MobileMenuItem, {
	            children: props.windowLang === "en-us" ? "Regions" : props.windowLang === "es-mx" ? "Regiones" : "مناطق",
	            to: "/" + props.windowLang + "/" + "regions",
	            onClick: props.closeMenu
	          }),
	          props.data.regions.edges.map(function (region, index) {
	            if (region.node.lang === props.windowLang) {
	              return _react2.default.createElement(MobileMenuItem, {
	                children: region.node.data.title[0].text,
	                indented: "true",
	                key: "regionheader" + index,
	                to: "/" + props.windowLang + "/" + "region/" + region.node.uid,
	                onClick: props.closeMenu
	              });
	            } else {
	              return null;
	            }
	          }),
	          _react2.default.createElement(MobileMenuItem, {
	            children: props.windowLang === "en-us" ? "Institutions" : props.windowLang === "es-mx" ? "Instituciones" : "مؤسسات",
	            to: "/" + props.windowLang + "/" + "institutions",
	            onClick: props.closeMenu
	          }),
	          props.data.institutions.edges.map(function (institution, index) {
	            if (institution.node.lang === props.windowLang) {
	              return _react2.default.createElement(MobileMenuItem, {
	                children: institution.node.data.title[0].text,
	                indented: "true",
	                key: "institutionheader" + index,
	                to: "/" + props.windowLang + "/" + "institution/" + institution.node.uid,
	                onClick: props.closeMenu
	              });
	            } else {
	              return null;
	            }
	          }),
	          _react2.default.createElement(MobileMenuItem, {
	            children: props.windowLang === "en-us" ? "Resources" : props.windowLang === "es-mx" ? "Recursos" : " مصادر",
	            to: "/" + props.windowLang + "/" + "resources",
	            onClick: props.closeMenu
	          }),
	          _react2.default.createElement(MobileMenuItem, {
	            children: props.windowLang === "en-us" ? "Updates" : props.windowLang === "es-mx" ? "Noticias" : "تحديثات",
	            to: "/" + props.windowLang + "/" + "updates",
	            onClick: props.closeMenu
	          }),
	          _react2.default.createElement(MobileMenuItem, {
	            children: props.windowLang === "en-us" ? "Support us" : props.windowLang === "es-mx" ? "Apóyenos" : "ادعم مركز معلومات البنك",
	            to: "/" + props.windowLang + "/" + "support",
	            onBlur: props.closeMenu
	          })
	        )
	      )
	    )
	  );
	};
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.toggleMenu = function () {
	      _this.setState({ menuOpen: !_this.state.menuOpen });
	    };
	
	    _this.openMenu = function () {
	      _this.setState({ menuOpen: true });
	    };
	
	    _this.closeMenu = function () {
	      _this.setState({ menuOpen: false });
	    };
	
	    _this.toggleSearch = function () {
	      _this.setState({
	        searchOpen: !_this.state.searchOpen,
	        searchHasHappened: true
	      });
	    };
	
	    _this.state = {
	      menuOpen: false,
	      searchOpen: false,
	      searchHasHappened: false
	    };
	    return _this;
	  }
	
	  Header.prototype.render = function render() {
	    return _react2.default.createElement(
	      _styledComponents.ThemeProvider
	      // theme={
	      //   this.props.props.location.pathname === "/ar-eg/" ||
	      //   this.props.props.location.pathname === "/es-mx/" ||
	      //   this.props.props.location.pathname === "/"
	      //     ? theme
	      //     : invertTheme
	      // }
	      ,
	      { theme: _theme2.default
	      },
	      _react2.default.createElement(HeaderInnner, _extends({}, this.props, {
	        data: this.props.props.data,
	        menuOpen: this.state.menuOpen,
	        toggleMenu: this.toggleMenu,
	        openMenu: this.openMenu,
	        closeMenu: this.closeMenu,
	        toggleSearch: this.toggleSearch,
	        searchOpen: this.state.searchOpen,
	        searchHasHappened: this.state.searchHasHappened
	      }))
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports["default"];

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.H4 = exports.H3 = exports.H2 = exports.H1 = undefined;
	
	var _H5 = __webpack_require__(136);
	
	var _H6 = _interopRequireDefault(_H5);
	
	var _H7 = __webpack_require__(54);
	
	var _H8 = _interopRequireDefault(_H7);
	
	var _H9 = __webpack_require__(137);
	
	var _H10 = _interopRequireDefault(_H9);
	
	var _H11 = __webpack_require__(41);
	
	var _H12 = _interopRequireDefault(_H11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.H1 = _H6.default;
	exports.H2 = _H8.default;
	exports.H3 = _H10.default;
	exports.H4 = _H12.default;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArrowRightIcon = function ArrowRightIcon(props) {
	  return _react2.default.createElement(
	    "svg",
	    {
	      width: "26px",
	      height: "24px",
	      viewBox: "0 0 26 24",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg"
	    },
	    _react2.default.createElement(
	      "title",
	      null,
	      "Arrow pointing right"
	    ),
	    _react2.default.createElement(
	      "desc",
	      null,
	      "Created with Sketch."
	    ),
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "arrow-right-icon",
	          transform: "translate(-12.000000, -12.000000)",
	          stroke: "#363636",
	          strokeWidth: "2"
	        },
	        _react2.default.createElement(
	          "g",
	          {
	            id: "Group",
	            transform: "translate(24.000000, 24.000000) rotate(-90.000000) translate(-24.000000, -24.000000) translate(13.000000, 12.000000)"
	          },
	          _react2.default.createElement("polyline", { id: "Line", points: "0 13 11 24 22 13" }),
	          _react2.default.createElement("path", { d: "M11,0 L11,24", id: "Line" })
	        )
	      )
	    )
	  );
	};
	
	exports.default = ArrowRightIcon;
	module.exports = exports["default"];

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChevronDownIcon = function ChevronDownIcon(props) {
	  return _react2.default.createElement(
	    "svg",
	    {
	      width: "18px",
	      height: "8px",
	      viewBox: "0 0 20 10",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      style: props.style,
	      className: props.className
	    },
	    _react2.default.createElement(
	      "desc",
	      null,
	      "Chevron down icon"
	    ),
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "2", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        { id: "Group", transform: "translate(1.000000, 0.000000)", stroke: "#363636" },
	        _react2.default.createElement("polyline", { id: "Line", points: "0 0 8 8 16 0" })
	      )
	    )
	  );
	};
	
	exports.default = ChevronDownIcon;
	module.exports = exports["default"];

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CloseIcon = function CloseIcon(props) {
	  return _react2.default.createElement(
	    "svg",
	    {
	      width: "20px",
	      height: "20px",
	      viewBox: "0 0 20 20",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg"
	    },
	    _react2.default.createElement(
	      "title",
	      null,
	      "Close"
	    ),
	    _react2.default.createElement(
	      "desc",
	      null,
	      "Created with Sketch."
	    ),
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "close-icon",
	          transform: "translate(-14.000000, -14.000000)",
	          stroke: "#363636",
	          strokeWidth: "2"
	        },
	        _react2.default.createElement(
	          "g",
	          { id: "Group", transform: "translate(15.000000, 15.000000)" },
	          _react2.default.createElement("path", { d: "M0,0 L17.9688311,17.9688311", id: "Line" }),
	          _react2.default.createElement("path", { d: "M0,17.9688311 L17.9688311,0", id: "Line" })
	        )
	      )
	    )
	  );
	};
	
	exports.default = CloseIcon;
	module.exports = exports["default"];

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FacebookIcon = function FacebookIcon(props) {
	  return _react2.default.createElement(
	    "svg",
	    {
	      width: "24px",
	      height: "24px",
	      viewBox: "0 0 24 24",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg"
	    },
	    _react2.default.createElement(
	      "title",
	      null,
	      "facebook"
	    ),
	    _react2.default.createElement(
	      "desc",
	      null,
	      "Created with Sketch."
	    ),
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "g",
	      {
	        id: "facebook",
	        stroke: "none",
	        strokeWidth: "1",
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      _react2.default.createElement(
	        "g",
	        { id: "flogo-RGB-HEX-Blk-144", fill: "#363636", fillRule: "nonzero" },
	        _react2.default.createElement("path", {
	          d: "M22.675,0 L1.33333333,0 C0.596953667,-4.50902501e-17 9.01805001e-17,0.596953667 0,1.33333333 L0,22.6833333 C0.0091239944,23.413196 0.603413605,24.000057 1.33333333,24 L12.8333333,24 L12.8333333,14.7183333 L9.70333333,14.7183333 L9.70333333,11.0866667 L12.82,11.0866667 L12.82,8.42 C12.82,5.32 14.7133333,3.63166667 17.4866667,3.63166667 C18.4202028,3.62859938 19.3532249,3.6758903 20.2816667,3.77333333 L20.2816667,7 L18.3666667,7 C16.8666667,7 16.57,7.715 16.57,8.76333333 L16.57,11.0866667 L20.1666667,11.0866667 L19.7,14.7183333 L16.57,14.7183333 L16.57,24 L22.675,24 C23.4048853,23.9954523 23.9954523,23.4048853 24,22.675 L24,1.33333333 C24.0000143,0.600195798 23.4081232,0.00458210946 22.675,0 Z",
	          id: "Shape"
	        })
	      )
	    )
	  );
	};
	
	exports.default = FacebookIcon;
	module.exports = exports["default"];

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GooglePlusIcon = function GooglePlusIcon(props) {
	  return _react2.default.createElement(
	    "svg",
	    {
	      width: "24px",
	      height: "24px",
	      viewBox: "0 0 24 24",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg"
	    },
	    _react2.default.createElement(
	      "title",
	      null,
	      "google-plus"
	    ),
	    _react2.default.createElement(
	      "desc",
	      null,
	      "Created with Sketch."
	    ),
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "g",
	      {
	        id: "google-plus",
	        stroke: "none",
	        strokeWidth: "1",
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "iconmonstr-google-plus-1",
	          transform: "translate(0.000000, 5.000000)",
	          fill: "#363636",
	          fillRule: "nonzero"
	        },
	        _react2.default.createElement("path", {
	          d: "M7,6 L7,8.4 L10.97,8.4 C10.81,9.429 9.77,11.42 7,11.42 C4.61,11.42 2.66,9.441 2.66,7 C2.66,4.56 4.61,2.58 7,2.58 C8.36,2.58 9.27,3.16 9.79,3.66 L11.69,1.83 C10.47,0.69 8.89,1.77635684e-15 7,1.77635684e-15 C3.13,1.77635684e-15 -8.8817842e-16,3.13 -8.8817842e-16,7 C-8.8817842e-16,10.87 3.13,14 7,14 C11.04,14 13.721,11.16 13.721,7.16 C13.721,6.7 13.67,6.35 13.61,6 L7,6 Z M7,6 L24,8 L21,8 L21,11 L19,11 L19,8 L16,8 L16,6 L19,6 L19,3 L21,3 L21,6 L24,6 L24,8 L7,6 Z",
	          id: "Shape"
	        })
	      )
	    )
	  );
	};
	
	exports.default = GooglePlusIcon;
	module.exports = exports["default"];

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HamburgerMenuIcon = function HamburgerMenuIcon(props) {
	  return _react2.default.createElement(
	    "svg",
	    {
	      width: "24px",
	      height: "18px",
	      viewBox: "0 0 24 18",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg"
	    },
	    _react2.default.createElement(
	      "title",
	      null,
	      "Menu"
	    ),
	    _react2.default.createElement(
	      "desc",
	      null,
	      "Created with Sketch."
	    ),
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "2", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "hamburger-menu-icon",
	          transform: "translate(-12.000000, -15.000000)",
	          stroke: "#363636"
	        },
	        _react2.default.createElement(
	          "g",
	          { id: "Group", transform: "translate(12.000000, 15.000000)" },
	          _react2.default.createElement("path", { d: "M0,1 L24,1", id: "Line" }),
	          _react2.default.createElement("path", { d: "M0,9 L24,9", id: "Line" }),
	          _react2.default.createElement("path", { d: "M0,17 L24,17", id: "Line" })
	        )
	      )
	    )
	  );
	};
	
	exports.default = HamburgerMenuIcon;
	module.exports = exports["default"];

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchIcon = function SearchIcon(props) {
	  return _react2.default.createElement(
	    "svg",
	    {
	      width: "24px",
	      height: "24px",
	      viewBox: "0 0 26 26",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg"
	    },
	    _react2.default.createElement(
	      "title",
	      null,
	      "Search"
	    ),
	    _react2.default.createElement(
	      "desc",
	      null,
	      "Created with Sketch."
	    ),
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "2", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "search-icon",
	          transform: "translate(-11.000000, -11.000000)",
	          stroke: "#363636",
	          strokeWidth: "2"
	        },
	        _react2.default.createElement(
	          "g",
	          { id: "Group-2", transform: "translate(12.000000, 12.000000)" },
	          _react2.default.createElement("circle", {
	            id: "Combined-Shape",
	            cx: "9.98653386",
	            cy: "9.98653386",
	            r: "9.98653386"
	          }),
	          _react2.default.createElement("path", { d: "M17.5,17.5 L23.5,23.5", id: "Line-2" })
	        )
	      )
	    )
	  );
	};
	
	exports.default = SearchIcon;
	module.exports = exports["default"];

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TwitterIcon = function TwitterIcon(props) {
	  return _react2.default.createElement(
	    "svg",
	    {
	      width: "24px",
	      height: "24px",
	      viewBox: "0 0 24 24",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg"
	    },
	    _react2.default.createElement(
	      "title",
	      null,
	      "twitter"
	    ),
	    _react2.default.createElement(
	      "desc",
	      null,
	      "Created with Sketch."
	    ),
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "g",
	      {
	        id: "twitter",
	        stroke: "none",
	        strokeWidth: "1",
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "iconmonstr-twitter-1",
	          transform: "translate(0.000000, 2.000000)",
	          fill: "#363636",
	          fillRule: "nonzero"
	        },
	        _react2.default.createElement("path", {
	          d: "M24,2.557 C23.117,2.949 22.168,3.213 21.172,3.332 C22.189,2.723 22.97,1.758 23.337,0.608 C22.386,1.172 21.332,1.582 20.21,1.803 C19.313,0.846 18.032,0.248 16.616,0.248 C13.437,0.248 11.101,3.214 11.819,6.293 C7.728,6.088 4.1,4.128 1.671,1.149 C0.381,3.362 1.002,6.257 3.194,7.723 C2.388,7.697 1.628,7.476 0.965,7.107 C0.911,9.388 2.546,11.522 4.914,11.997 C4.221,12.185 3.462,12.229 2.69,12.081 C3.316,14.037 5.134,15.46 7.29,15.5 C5.22,17.123 2.612,17.848 -1.77635684e-15,17.54 C2.179,18.937 4.768,19.752 7.548,19.752 C16.69,19.752 21.855,12.031 21.543,5.106 C22.505,4.411 23.34,3.544 24,2.557 Z",
	          id: "Shape"
	        })
	      )
	    )
	  );
	};
	
	exports.default = TwitterIcon;
	module.exports = exports["default"];

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YouTubeIcon = function YouTubeIcon(props) {
	  return _react2.default.createElement(
	    "svg",
	    {
	      width: "24px",
	      height: "24px",
	      viewBox: "0 0 24 24",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg"
	    },
	    _react2.default.createElement(
	      "title",
	      null,
	      "youtube"
	    ),
	    _react2.default.createElement(
	      "desc",
	      null,
	      "Created with Sketch."
	    ),
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "g",
	      {
	        id: "youtube",
	        stroke: "none",
	        strokeWidth: "1",
	        fill: "none",
	        fillRule: "evenodd"
	      },
	      _react2.default.createElement(
	        "g",
	        {
	          id: "iconmonstr-youtube-1",
	          transform: "translate(2.000000, 0.000000)",
	          fill: "#363636",
	          fillRule: "nonzero"
	        },
	        _react2.default.createElement("path", {
	          d: "M2.652,0 L4.092,0 L5.08,3.702 L5.996,0 L7.45,0 L5.785,5.505 L5.785,9.262 L4.354,9.262 L4.354,5.505 L2.652,0 Z M9.246,2.373 C8.127,2.373 7.385,3.113 7.385,4.208 L7.385,7.557 C7.385,8.761 8.014,9.388 9.246,9.388 C10.268,9.388 11.072,8.705 11.072,7.557 L11.072,4.208 C11.072,3.139 10.275,2.373 9.246,2.373 Z M9.777,7.5 C9.777,7.872 9.587,8.146 9.245,8.146 C8.894,8.146 8.691,7.859 8.691,7.5 L8.691,4.321 C8.691,3.947 8.863,3.67 9.22,3.67 C9.61,3.67 9.777,3.939 9.777,4.321 L9.777,7.5 Z M14.506,2.43 L14.506,7.616 C14.351,7.81 14.006,8.128 13.759,8.128 C13.488,8.128 13.421,7.942 13.421,7.668 L13.421,2.43 L12.151,2.43 L12.151,8.14 C12.151,8.815 12.357,9.36 13.038,9.36 C13.422,9.36 13.956,9.16 14.506,8.507 L14.506,9.261 L15.776,9.261 L15.776,2.43 L14.506,2.43 Z M16.709,16.288 C16.261,16.288 16.168,16.603 16.168,17.051 L16.168,17.71 L17.2370079,17.71 L17.237,17.05 C17.238,16.61 17.145,16.288 16.709,16.288 Z M12.006,16.328 C11.922,16.371 11.839,16.437 11.756,16.526 L11.756,20.581 C11.855,20.687 11.95,20.763 12.043,20.81 C12.24,20.91 12.528,20.917 12.662,20.743 C12.732,20.651 12.767,20.502 12.767,20.294 L12.767,16.935 C12.767,16.715 12.724,16.549 12.638,16.435 C12.491,16.242 12.218,16.221 12.006,16.328 Z M16.833,11.133 C14.229,10.956 5.767,10.956 3.167,11.133 C0.353,11.325 0.021,13.025 -1.77635684e-15,17.5 C0.021,21.967 0.35,23.675 3.167,23.867 C5.767,24.044 14.229,24.044 16.833,23.867 C19.647,23.675 19.979,21.974 20,17.5 C19.979,13.033 19.65,11.325 16.833,11.133 Z M4.509,21.819 L3.146,21.819 L3.146,14.279 L1.736,14.279 L1.736,12.999 L5.918,12.999 L5.918,14.279 L4.508,14.279 L4.508,21.819 L4.509,21.819 Z M9.355,21.819 L8.145,21.819 L8.145,21.101 C7.922,21.366 7.69,21.568 7.449,21.706 C6.797,22.08 5.902,22.071 5.902,20.751 L5.902,15.313 L7.111,15.313 L7.111,20.301 C7.111,20.563 7.174,20.739 7.433,20.739 C7.669,20.739 7.997,20.436 8.144,20.252 L8.144,15.313 L9.354,15.313 L9.354,21.819 L9.355,21.819 Z M14.012,20.471 C14.012,21.276 13.711,21.902 12.906,21.902 C12.463,21.902 12.094,21.74 11.757,21.319 L11.757,21.819 L10.536,21.819 L10.536,12.999 L11.757,12.999 L11.757,15.839 C12.03,15.506 12.401,15.231 12.833,15.231 C13.719,15.231 14.013,15.98 14.013,16.862 L14.013,20.471 L14.012,20.471 Z M18.483,18.719 L16.169,18.719 L16.169,19.947 C16.169,20.435 16.211,20.857 16.697,20.857 C17.208,20.857 17.238,20.513 17.238,19.947 L17.238,19.495 L18.483,19.495 L18.483,19.984 C18.483,21.237 17.945,21.997 16.67,21.997 C15.515,21.997 14.924,21.155 14.924,19.984 L14.924,17.063 C14.924,15.934 15.67,15.149 16.761,15.149 C17.922,15.149 18.482,15.887 18.482,17.063 L18.482,18.719 L18.483,18.719 Z",
	          id: "Shape"
	        })
	      )
	    )
	  );
	};
	
	exports.default = YouTubeIcon;
	module.exports = exports["default"];

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  background-color: ", ";\n  border-radius: 0;\n  border: 1px solid ", ";\n\n  /* Naked */\n  ", ";\n"], ["\n  position: relative;\n  width: 100%;\n  background-color: ", ";\n  border-radius: 0;\n  border: 1px solid ", ";\n\n  /* Naked */\n  ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n      background-color: transparent;\n      border-radius: 0;\n      border: none;\n    "], ["\n      background-color: transparent;\n      border-radius: 0;\n      border: none;\n    "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-width: none;\n  padding-top: 13px;\n  padding-right: 16px;\n  padding-bottom: 11px;\n  padding-left: ", "px;\n\n  font-weight: 400;\n  color: ", ";\n\n  background-color: transparent;\n  border: 0;\n\n  ", ";\n\n  /* Naked */\n  ", ";\n"], ["\n  width: 100%;\n  max-width: none;\n  padding-top: 13px;\n  padding-right: 16px;\n  padding-bottom: 11px;\n  padding-left: ", "px;\n\n  font-weight: 400;\n  color: ", ";\n\n  background-color: transparent;\n  border: 0;\n\n  ", ";\n\n  /* Naked */\n  ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n      padding-right: 0;\n      padding-left: ", "px;\n    "], ["\n      padding-right: 0;\n      padding-left: ", "px;\n    "]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(8);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var InnerWrapper = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return (0, _polished.rgba)(props.theme.colors.text, 1 / 5);
	}, function (props) {
	  return props.appearance === "naked" && css(_templateObject2);
	});
	
	var InputComp = _styledComponents2.default.input(_templateObject3, function (props) {
	  return props.icon ? 40 : 16;
	}, function (props) {
	  return props.theme.colors.text;
	}, (0, _polished.placeholder)({ color: "rgba(0, 0, 0, 0.333)" }), function (props) {
	  return props.appearance === "naked" && css(_templateObject4, function (props) {
	    return props.icon ? 24 : 0;
	  });
	});
	
	var Input = function Input(props) {
	  return _react2.default.createElement(
	    "div",
	    null,
	    props.label && _react2.default.createElement(_components.H4, {
	      children: props.label,
	      is: "label",
	      htmlFor: props.uid,
	      heading: 0,
	      mb: 1
	    }),
	    _react2.default.createElement(
	      InnerWrapper,
	      { maxWidth: props.maxWidth, appearance: props.appearance },
	      _react2.default.createElement(InputComp, _extends({
	        id: props.uid,
	        name: props.name,
	        appearance: props.appearance
	      }, props, {
	        "aria-labelledby": props.uid
	      }))
	    )
	  );
	};
	
	Input.defaultProps = {
	  type: "text"
	};
	
	exports.default = Input;
	module.exports = exports["default"];

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  text-decoration: none;\n  opacity: 0;\n  animation: institution-card-fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n  will-change: opacity;\n\n  @keyframes institution-card-fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  * {\n    text-decoration: none;\n\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n\n  &:not(:last-child) {\n    > * {\n      margin-bottom: 32px;\n    }\n  }\n"], ["\n  text-decoration: none;\n  opacity: 0;\n  animation: institution-card-fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n  will-change: opacity;\n\n  @keyframes institution-card-fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  * {\n    text-decoration: none;\n\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n\n  &:not(:last-child) {\n    > * {\n      margin-bottom: 32px;\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  background-color: ", ";\n  &:not(:lang(ar)) {\n    &:before,\n    &:after {\n      right: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n  &:lang(ar) {\n    &:before,\n    &:after {\n      left: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n    filter: grayscale(1);\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    /* Fallback */\n    background-image: ", ";\n\n    /* Webkit fallback */\n    background-image: ", ";\n\n    /* Regular imageset */\n    background-image: ", ";\n\n    @media (min-width: 52em) {\n      /* Fallback */\n      background-image: ", ";\n\n      /* Webkit fallback */\n      background-image: ", ";\n\n      /* Regular imageset */\n      background-image: ", ";\n    }\n\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      background-image: ", ";\n    }\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n  }\n"], ["\n  position: relative;\n  background-color: ", ";\n  &:not(:lang(ar)) {\n    &:before,\n    &:after {\n      right: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n  &:lang(ar) {\n    &:before,\n    &:after {\n      left: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n    filter: grayscale(1);\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    /* Fallback */\n    background-image: ", ";\n\n    /* Webkit fallback */\n    background-image: ", ";\n\n    /* Regular imageset */\n    background-image: ", ";\n\n    @media (min-width: 52em) {\n      /* Fallback */\n      background-image: ", ";\n\n      /* Webkit fallback */\n      background-image: ", ";\n\n      /* Regular imageset */\n      background-image: ", ";\n    }\n\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      background-image: ", ";\n    }\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 640px;\n"], ["\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 640px;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  &:hover {\n    color: ", ";\n  }\n  &:active {\n    color: ", ";\n  }\n"], ["\n  &:hover {\n    color: ", ";\n  }\n  &:active {\n    color: ", ";\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _polished = __webpack_require__(8);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(4);
	
	var _Text = __webpack_require__(17);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _H = __webpack_require__(54);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _Button = __webpack_require__(53);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _OverlayImage = __webpack_require__(42);
	
	var _OverlayImage2 = _interopRequireDefault(_OverlayImage);
	
	var _theme = __webpack_require__(13);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _invertTheme = __webpack_require__(12);
	
	var _invertTheme2 = _interopRequireDefault(_invertTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Action = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.theme.colors[props.cardColor] && (0, _polished.shade)(0.9375, props.theme.colors[props.cardColor]);
	}, function (props) {
	  return props.theme.colors.grey[0];
	});
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2, function (props) {
	  return props.theme.colors[props.cardColor];
	}, function (props) {
	  return props.theme.colors[props.cardColor] && "linear-gradient(to right, " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 1) + ", " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.75) + ")";
	}, function (props) {
	  return props.theme.colors[props.cardColor] && "linear-gradient(to left, " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 1) + ", " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.75) + ")";
	}, function (props) {
	  return "url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ")";
	}, function (props) {
	  return "-webkit-image-set(url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x)";
	}, function (props) {
	  return "image-set(url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x)";
	}, function (props) {
	  return "url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ")";
	}, function (props) {
	  return "-webkit-image-set(url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x, url(" + (props.backgroundImage ? props.backgroundImage[0] : "") + ") 3x)";
	}, function (props) {
	  return "image-set(url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x, url(" + (props.backgroundImage ? props.backgroundImage[0] : "") + ") 3x)";
	}, function (props) {
	  return props.theme.colors[props.imageColor] && "linear-gradient(to bottom, " + (props.imageColor ? (0, _polished.rgba)(props.theme.colors[props.imageColor], 0.66) : "") + ", " + (props.imageColor ? (0, _polished.rgba)(props.theme.colors[props.imageColor], 0.66) : "") + "), url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ")";
	});
	
	var Content = (0, _styledComponents2.default)(_rebass.Box)(_templateObject3);
	
	var CustomButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject4, function (props) {
	  return props.theme.colors[props.cardColor];
	}, function (props) {
	  return props.theme.colors[props.cardColor];
	});
	
	var determineColor = function determineColor(type) {
	  var color = "violet";
	  if (type === "update" || type === "institution" || type === null || type === undefined) {
	    color = "ash";
	  }
	  if (type === "middle-east-and-north-africa" || type === "oriente-medio-y-norte-de-africa" || type === "الشرق-الاوسط-وشمات-افريقيا") {
	    color = "orange";
	  }
	  if (type === "africa" || type === "africa1" || type === "افريقيا") {
	    color = "green";
	  }
	  if (type === "latin-america" || type === "america-latina-y-el-caribe" || type === "امريكا-اللاتينية") {
	    color = "blue";
	  }
	  if (type === "asia" || type === "asia1" || type === "اسيا") {
	    color = "pink";
	  }
	  if (type === "europe--central-asia" || type === "europa-y-asia-central" || type === "اوروبا-واسيا-الوسطى") {
	    color = "yellow";
	  }
	  return color;
	};
	
	var InstitutionCard = function InstitutionCard(props) {
	  if (props.object) {
	    return _react2.default.createElement(
	      _styledComponents.ThemeProvider,
	      { theme: _invertTheme2.default },
	      _react2.default.createElement(
	        Action,
	        {
	          className: props.className,
	          style: props.style,
	          cardColor: determineColor(props.object.type)
	        },
	        _react2.default.createElement(
	          Wrapper,
	          {
	            px: 4,
	            py: 5,
	            backgroundImage: props.object.data.header_image.url ? [props.object.data.header_image.half.url, props.object.data.header_image.quarter.url] : "",
	            cardColor: determineColor(props.object.type)
	          },
	          _react2.default.createElement(
	            Content,
	            null,
	            _react2.default.createElement(_H2.default, {
	              children: props.object.data.title[0] ? props.object.data.title[0].text : "",
	              mb: 5
	            }),
	            _react2.default.createElement(CustomButton, {
	              is: _gatsbyLink2.default,
	              to: "/" + props.object.lang + "/institution/" + props.object.uid,
	              children: props.object.lang === "en-us" ? "View projects" : props.object.lang === "es-mx" ? "Ver proyectos" : "انظر المشاريع",
	              cardColor: determineColor(props.object.type),
	              "aria-label": props.object.data.title[0] ? props.object.data.title[0].text : ""
	            })
	          )
	        )
	      )
	    );
	  } else {
	    return null;
	  }
	};
	
	InstitutionCard.defaultProps = {
	  title: "Institution Name",
	  cardColor: "grey.0"
	};
	
	exports.default = InstitutionCard;
	module.exports = exports["default"];

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { Watch } from "scrollmonitor-react";
	
	var LazyImage = function (_React$Component) {
	  _inherits(LazyImage, _React$Component);
	
	  function LazyImage(props) {
	    _classCallCheck(this, LazyImage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.loadImage = function () {
	      _this.setState({ imagesLoaded: true });
	    };
	
	    _this.state = {
	      src: "",
	      srcSet: "",
	      imageLoaded: false
	    };
	    return _this;
	  }
	
	  LazyImage.prototype.componentDidMount = function componentDidMount() {
	    this.setState({
	      src: this.props.blurSrc,
	      srcSet: this.props.blurSrc,
	      fullSrc: this.props.fullSrc[0],
	      fullSrcSet: this.props.fullSrc[2] + " 1000w, " + this.props.fullSrc[1] + " 2000w, " + this.props.fullSrc[0] + " 2500w"
	    });
	  };
	
	  LazyImage.prototype.render = function render() {
	    return _react2.default.createElement("img", {
	      src: this.state.imagesLoaded ? this.state.fullSrc ? this.state.fullSrc : this.state.src : this.state.src,
	      srcSet: this.state.imagesLoaded ? this.state.fullSrc ? this.state.fullSrcSet : this.state.srcSet : this.state.srcSet,
	      alt: this.props.alt,
	      onLoad: this.loadImage,
	      height: "auto",
	      width: "100%"
	    });
	  };
	
	  return LazyImage;
	}(_react2.default.Component);
	
	LazyImage.defaultProps = {};
	
	// export default Watch(LazyImage);
	exports.default = LazyImage;
	module.exports = exports["default"];

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo(props) {
	  return _react2.default.createElement(
	    "svg",
	    {
	      width: "120px",
	      height: "40px",
	      viewBox: "0 0 120 40",
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      alt: "Bank Information Center logo"
	    },
	    _react2.default.createElement(
	      "desc",
	      null,
	      "Bank Information Center logo"
	    ),
	    _react2.default.createElement("defs", null),
	    _react2.default.createElement(
	      "g",
	      { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement("path", {
	        d: "M13.7205066,11.5602818 C13.7205066,13.0080718 13.7326454,14.4558618 13.7139703,15.903185 C13.7079009,16.3808016 13.876444,16.5722217 14.3638651,16.5624173 C15.6136986,16.5386065 16.8653997,16.5834268 18.1138326,16.5344046 C19.5116666,16.4797798 20.8805542,16.2201954 21.9917248,15.292508 C23.6696859,13.8909389 23.9386079,12.0308953 23.4992753,10.0261193 C23.0912235,8.16514186 21.776027,7.16929017 20.001889,6.76870847 C18.0769492,6.33451153 16.1118579,6.60483414 14.1649748,6.56328196 C13.7219072,6.5539444 13.7205066,6.89850068 13.7205066,7.21737864 C13.7205066,8.66516866 13.7205066,10.1124918 13.7205066,11.5602818 M13.7205066,27.9374434 C13.7205066,29.4954167 13.7335792,31.0529231 13.7125696,32.6104296 C13.7060333,33.1183933 13.8829803,33.3168166 14.3993478,33.3074791 C15.8247277,33.280867 17.2533757,33.3392268 18.6764211,33.2715294 C20.247467,33.1968289 21.7984372,32.9316419 23.0174568,31.8144018 C24.7626483,30.2153432 24.9423965,28.176952 24.3765399,26.0554564 C23.8438316,24.0576836 22.2545774,23.1776178 20.3623191,22.812052 C18.4088998,22.4343473 16.4232658,22.6915973 14.4530388,22.6136286 C13.8591695,22.5902847 13.7018314,22.8456672 13.711169,23.3965838 C13.7368473,24.9097367 13.7200397,26.4238235 13.7205066,27.9374434 M29.6802788,17.9658539 C31.3834513,18.6278875 32.8564528,19.3431452 34.1795863,20.3445995 C37.003267,22.4829027 38.0668161,25.4139655 37.9127462,28.8319824 C37.7857553,31.6542625 36.7530202,34.1305857 34.6824143,36.1115509 C32.7546733,37.9561876 30.4076754,38.899282 27.7931562,39.2471065 C26.9639801,39.3577566 26.1320028,39.3689617 25.297691,39.3689617 C17.2426375,39.3647598 9.1875839,39.3666273 1.13253035,39.3661605 C0.00175079411,39.3661605 0.000350158822,39.3642929 0.000350158822,38.238649 C-0.000116719607,26.0134374 -0.000116719607,13.7882257 0.000350158822,1.5625471 C0.000350158822,0.47425348 0.00175079411,0.472852845 1.07883933,0.473319724 C8.67308387,0.477054751 16.2677953,0.442038869 23.8611061,0.504600578 C26.9121566,0.529812014 29.8306137,1.1988488 32.3498897,3.07850136 C36.1250687,5.89517893 36.8510646,11.9650654 33.4512559,15.4414422 C32.6178779,16.2939622 31.6491052,16.9774722 30.5790198,17.5101805 C30.3278392,17.6353039 30.0780593,17.7641624 29.6802788,17.9658539 Z M64.3573344,0.382341142 C57.6459569,-0.141496456 52.0294094,2.00801184 47.7630743,7.27580116 C44.7222951,11.0299706 43.4463164,15.4176941 43.9024566,20.1966617 C44.9141821,30.7859314 54.1420343,37.6163628 63.8152885,36.7218237 C74.1720527,35.7642561 82.5114352,25.8230137 79.820348,14.1249077 C81.748089,18.8231054 81.3358353,27.719007 74.9979607,34.0713549 C68.1595923,40.9255971 57.4260572,41.9681367 49.3845431,36.5107947 C41.4961652,31.1575666 38.4633229,20.7723228 42.222628,12.1448763 C46.1761545,3.07249466 55.6883357,-1.38899562 64.3573344,0.382341142 Z M58.9992515,32.6519337 C56.8100586,32.6650063 55.4439723,31.1635253 55.744642,29.0028119 C56.0378416,26.8971902 56.9029674,24.9601116 57.622427,22.984749 C58.1705423,21.4804667 58.7947588,20.0037302 59.3750887,18.5111198 C59.4563255,18.3010246 59.6514807,18.0517115 59.400767,17.8490862 C59.1481857,17.6459941 58.8615224,17.7244297 58.601938,17.8799002 C58.0398163,18.2169864 57.6859225,18.7571648 57.288609,19.2506553 C56.9403176,19.6829847 56.5528085,20.0630237 56.0793938,20.3524884 C55.7488439,20.5546467 55.4080226,20.703581 55.0373212,20.450066 C54.6675534,20.1974847 54.5802472,19.8463922 54.6437426,19.413129 C54.7632635,18.5965586 55.1671134,17.9335912 55.6951529,17.3294505 C58.3783032,14.2606586 61.8005221,12.7764521 65.8329511,12.6074421 C66.0500496,12.5981045 66.2704162,12.6284516 66.4875147,12.6559975 C68.706121,12.937992 69.3116623,13.8946259 68.6734395,16.0497368 C67.7504208,19.1684847 66.5271993,22.1765824 65.3403944,25.1982196 C65.1452392,25.6954451 64.8940586,26.337403 65.4295681,26.632937 C65.9291281,26.9088622 66.413281,26.3971634 66.739629,25.9975155 C67.1397438,25.5072931 67.4534861,24.9475059 67.8069131,24.4189995 C68.026346,24.0912508 68.2317725,23.7513633 68.4764168,23.4432236 C68.7794209,23.0627177 69.151523,22.7788556 69.6688243,23.04591 C70.1669836,23.3026932 70.2080689,23.7457608 70.0936837,24.23645 C69.9274749,24.9498403 69.6496823,25.6291484 69.2392961,26.2230178 C66.9655982,29.5135769 64.1274442,31.9987708 59.98063,32.558558 C59.6552157,32.6024446 59.3265333,32.6215866 58.9992515,32.6519337 Z M62.0948622,7.97253404 C62.0864584,6.11715916 63.7886971,4.27158872 65.8999214,3.83038861 C67.026499,3.59508188 68.09425,3.81124659 69.0933698,4.30286958 C70.5532987,5.02046173 71.1009471,6.55182298 70.5201503,8.09719058 C69.5551126,10.6682901 65.8546342,11.8929122 63.5398509,10.4073051 C62.5813495,9.79195928 62.099531,8.98052457 62.0948622,7.97253404 Z M119.590495,8.32859452 C119.590495,10.0191613 119.595164,11.7097281 119.587694,13.399828 C119.584892,14.0324483 119.50599,14.0735336 118.966279,13.7411162 C116.510498,12.2288969 113.900181,11.0990511 111.026544,10.7101414 C107.980162,10.2978877 104.974399,10.4155411 102.148851,11.8152426 C99.0109607,13.3704147 97.4992083,16.0026753 97.3320658,19.4183579 C97.0906897,24.3696036 99.9153042,28.0154573 104.768039,29.0692019 C109.167434,30.0239683 113.358135,29.3096443 117.375157,27.371165 C118.007777,27.0658265 118.630126,26.7399454 119.258078,26.4243356 C119.882294,26.1110602 119.956528,26.1502779 119.957928,26.8608669 C119.963064,29.6051783 119.890698,32.352291 119.993411,35.0928674 C120.036831,36.253994 119.627845,36.8100463 118.611918,37.2615177 C115.592615,38.6028594 112.453791,39.411026 109.173503,39.7649198 C105.830654,40.1248831 102.517218,40.0273055 99.2243241,39.3512656 C90.8251811,37.6270835 85.1773528,31.8882138 83.8584212,23.4666607 C83.0399833,18.2399567 83.9419925,13.3148561 86.9365507,8.87904419 C89.6500481,4.85968778 93.4933914,2.36609009 98.1098853,1.12839537 C105.111194,-0.748455918 112.016793,-0.237224037 118.789798,2.3137997 C119.398141,2.54257013 119.625978,2.86284874 119.606369,3.52114732 C119.558747,5.12207346 119.590495,6.72580087 119.590495,8.32859452 Z",
	        id: "Combined-Shape",
	        fill: "#7673c0"
	      })
	    )
	  );
	};
	
	exports.default = Logo;
	module.exports = exports["default"];

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose([""], [""]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Main = (0, _styledComponents2.default)(_rebass.Box)(_templateObject);
	
	Main.defaultProps = {
	  is: "main",
	  w: "100%"
	};
	
	var MainFinal = function MainFinal(props) {
	  return _react2.default.createElement(
	    Main,
	    null,
	    _react2.default.createElement("div", { id: "maincontent", tabIndex: -1 }),
	    props.children
	  );
	};
	
	exports.default = MainFinal;
	module.exports = exports["default"];

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  animation: fade-in 400ms ease forwards;\n  animation-delay: 200ms;\n  opacity: 0;\n  @keyframes fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n  a {\n    color: white !important;\n    box-shadow: inset 0 -1px 0 white !important;\n    &:hover {\n        color: ", " !important;\n        box-shadow: inset 0 -1.5em 0 white !important;\n      }\n  }\n}\n"], ["\n  animation: fade-in 400ms ease forwards;\n  animation-delay: 200ms;\n  opacity: 0;\n  @keyframes fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n  a {\n    color: white !important;\n    box-shadow: inset 0 -1px 0 white !important;\n    &:hover {\n        color: ", " !important;\n        box-shadow: inset 0 -1.5em 0 white !important;\n      }\n  }\n}\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  color: ", ";\n\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-width: 624px;\n\n  * {\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"], ["\n  width: 100%;\n  max-width: 624px;\n\n  * {\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _polished = __webpack_require__(8);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(4);
	
	var _GradientHeader = __webpack_require__(135);
	
	var _GradientHeader2 = _interopRequireDefault(_GradientHeader);
	
	var _H = __webpack_require__(136);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _invertTheme = __webpack_require__(12);
	
	var _invertTheme2 = _interopRequireDefault(_invertTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_GradientHeader2.default)(_templateObject, function (props) {
	  return props.theme.colors[props.color] && (0, _polished.shade)(0.5, props.theme.colors[props.color]);
	}, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.violet;
	});
	
	var Heading = (0, _styledComponents2.default)(_H2.default)(_templateObject2, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors[props.color] && (0, _polished.shade)(0.75, props.theme.colors[props.color]);
	}, function (props) {
	  return props.theme.colors.grey[0];
	});
	
	Heading.defaultProps = {
	  my: [3, 5],
	  fontSize: [5, 6]
	};
	
	// const Layout = styled(Flex)`
	//   align-items: flex-start;
	//   &::selection {
	//     color: ${props =>
	//       props.theme.colors[props.color] &&
	//       shade(0.75, props.theme.colors[props.color])};
	//     background-color: ${props => props.theme.colors.grey[0]};
	//   }
	
	//   > * {
	//     width: calc(50% - 8px);
	//     margin-left: 48px;
	//     margin-bottom: ${props => props.theme.space[5]}px;
	
	//     &:first-child {
	//       margin-left: 0;
	//     }
	//   }
	
	//   @media only screen and (max-width: 40em) {
	//     align-items: center;
	//     flex-wrap: wrap;
	//     width: 100%;
	
	//     > * {
	//       width: 100%;
	//       margin-bottom: 16px;
	//       margin-left: 0;
	//     }
	//   }
	
	//   * {
	//     &::selection {
	//       color: ${props =>
	//         props.theme.colors[props.color] &&
	//         shade(0.75, props.theme.colors[props.color])};
	//       background-color: ${props => props.theme.colors.grey[0]};
	//     }
	//   }
	// `;
	
	var Container = (0, _styledComponents2.default)(_rebass.Box)(_templateObject3, function (props) {
	  return props.theme.colors[props.color] && (0, _polished.shade)(0.75, props.theme.colors[props.color]);
	}, function (props) {
	  return props.theme.colors.grey[0];
	});
	
	var determineColor = function determineColor(page) {
	  var color = "violet";
	  if (page === "updates" || page === "institutions" || page === "about" || page === "pages" || page === "campaigns" || page === "resources" || page === "support" || page === "careers" || page === "reports" || page === "team" || page === "contact" || page === "member" || page === null || page === undefined) {
	    color = "violet";
	  }
	  if (page === "middle-east-and-north-africa" || page === "oriente-medio-y-norte-de-africa" || page === "الشرق-الاوسط-وشمات-افريقيا") {
	    color = "orange";
	  }
	  if (page === "africa" || page === "africa1" || page === "افريقيا") {
	    color = "green";
	  }
	  if (page === "latin-america" || page === "america-latina-y-el-caribe" || page === "امريكا-اللاتينية") {
	    color = "blue";
	  }
	  if (page === "asia" || page === "asia1" || page === "اسيا") {
	    color = "pink";
	  }
	  if (page === "europe--central-asia" || page === "europa-y-asia-central" || page === "اوروبا-واسيا-الوسطى") {
	    color = "yellow";
	  }
	  return color;
	};
	
	var PageHeader = function PageHeader(props) {
	  return _react2.default.createElement(
	    _styledComponents.ThemeProvider,
	    { theme: _invertTheme2.default },
	    _react2.default.createElement(
	      Wrapper,
	      {
	        image: props.image,
	        className: props.className,
	        style: props.style,
	        color: determineColor(props.color)
	      },
	      _react2.default.createElement(
	        Container,
	        { color: determineColor(props.color) },
	        _react2.default.createElement(Heading, { children: props.title, color: determineColor(props.color) }),
	        _react2.default.createElement(
	          _rebass.Box,
	          { mb: [3, 5] },
	          props.children
	        )
	      )
	    )
	  );
	};
	
	PageHeader.defaultProps = {
	  image: "https://source.unsplash.com/random"
	};
	
	exports.default = PageHeader;
	module.exports = exports["default"];

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose([""], [""]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  align-items: flex-start;\n  flex-direction: row;\n  max-width: 90rem;\n\n  ", ";\n\n  ", ";\n\n  @media only screen and (max-width: 64em) {\n    flex-direction: column;\n  }\n"], ["\n  align-items: flex-start;\n  flex-direction: row;\n  max-width: 90rem;\n\n  ", ";\n\n  ", ";\n\n  @media only screen and (max-width: 64em) {\n    flex-direction: column;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n      max-width: 60rem;\n    "], ["\n      max-width: 60rem;\n    "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n      flex-direction: column;\n    "], ["\n      flex-direction: column;\n    "]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  display: none;\n  width: 100%;\n  height: 1px;\n  margin-top: -48px;\n  padding-bottom: 48px;\n  border-top: 1px solid\n    ", ";\n  ", ";\n"], ["\n  display: none;\n  width: 100%;\n  height: 1px;\n  margin-top: -48px;\n  padding-bottom: 48px;\n  border-top: 1px solid\n    ", ";\n  ", ";\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n      display: block;\n    "], ["\n      display: block;\n    "]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _polished = __webpack_require__(8);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject);
	
	Wrapper.defaultProps = {
	  is: "section",
	  bg: "grey.2"
	};
	
	var Container = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject2, function (props) {
	  return props.skinny && (0, _styledComponents.css)(_templateObject3);
	}, function (props) {
	  return props.column && (0, _styledComponents.css)(_templateObject4);
	});
	
	Container.defaultProps = {
	  mx: "auto",
	  px: [4, 5, 6, 8],
	  py: [4, 4, 4, 5]
	};
	
	var BorderTop = (0, _styledComponents2.default)(_rebass.Box)(_templateObject5, function (props) {
	  return props.theme.colors.grey[1] && (0, _polished.shade)(0.875, props.theme.colors.grey[1]);
	}, function (props) {
	  return props.borderTop && (0, _styledComponents.css)(_templateObject6);
	});
	
	var PageSection = function PageSection(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    { className: props.className, style: props.style },
	    _react2.default.createElement(
	      Container,
	      { skinny: props.skinny, column: props.column },
	      _react2.default.createElement(BorderTop, { borderTop: props.borderTop }),
	      props.children
	    )
	  );
	};
	
	exports.default = PageSection;
	module.exports = exports["default"];

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  text-decoration: none;\n  opacity: 0;\n  animation: region-card-fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n  will-change: opacity;\n\n  @keyframes region-card-fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  * {\n    text-decoration: none;\n\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n\n  &:not(:last-child) {\n    > * {\n      margin-bottom: 32px;\n    }\n  }\n"], ["\n  text-decoration: none;\n  opacity: 0;\n  animation: region-card-fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n  will-change: opacity;\n\n  @keyframes region-card-fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  * {\n    text-decoration: none;\n\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n\n  &:not(:last-child) {\n    > * {\n      margin-bottom: 32px;\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  background-color: ", ";\n  &:not(:lang(ar)) {\n    &:before,\n    &:after {\n      right: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n  &:lang(ar) {\n    &:before,\n    &:after {\n      left: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n    filter: grayscale(1);\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n\n    /* Fallback */\n    background-image: ", ";\n\n    /* Webkit fallback */\n    background-image: ", ";\n\n    /* Regular imageset */\n    background-image: ", ";\n\n    @media (min-width: 52em) {\n      /* Fallback */\n      background-image: ", ";\n\n      /* Webkit fallback */\n      background-image: ", ";\n\n      /* Regular imageset */\n      background-image: ", ";\n    }\n\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      background-image: ", ";\n    }\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n  }\n"], ["\n  position: relative;\n  background-color: ", ";\n  &:not(:lang(ar)) {\n    &:before,\n    &:after {\n      right: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n  &:lang(ar) {\n    &:before,\n    &:after {\n      left: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n    filter: grayscale(1);\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n\n    /* Fallback */\n    background-image: ", ";\n\n    /* Webkit fallback */\n    background-image: ", ";\n\n    /* Regular imageset */\n    background-image: ", ";\n\n    @media (min-width: 52em) {\n      /* Fallback */\n      background-image: ", ";\n\n      /* Webkit fallback */\n      background-image: ", ";\n\n      /* Regular imageset */\n      background-image: ", ";\n    }\n\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      background-image: ", ";\n    }\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 640px;\n"], ["\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 640px;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  &:hover {\n    color: ", ";\n  }\n  &:active {\n    color: ", ";\n  }\n"], ["\n  &:hover {\n    color: ", ";\n  }\n  &:active {\n    color: ", ";\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _polished = __webpack_require__(8);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(4);
	
	var _Text = __webpack_require__(17);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _H = __webpack_require__(54);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _Button = __webpack_require__(53);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _OverlayImage = __webpack_require__(42);
	
	var _OverlayImage2 = _interopRequireDefault(_OverlayImage);
	
	var _theme = __webpack_require__(13);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _invertTheme = __webpack_require__(12);
	
	var _invertTheme2 = _interopRequireDefault(_invertTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Action = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.theme.colors[props.cardColor] && (0, _polished.shade)(0.9375, props.theme.colors[props.cardColor]);
	}, function (props) {
	  return props.theme.colors.grey[0];
	});
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2, function (props) {
	  return props.theme.colors[props.cardColor];
	}, function (props) {
	  return props.theme.colors[props.cardColor] && "linear-gradient(to right, " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 1) + ", " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.75) + ")";
	}, function (props) {
	  return props.theme.colors[props.cardColor] && "linear-gradient(to left, " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 1) + ", " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.75) + ")";
	}, function (props) {
	  return "url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ")";
	}, function (props) {
	  return "-webkit-image-set(url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x)";
	}, function (props) {
	  return "image-set(url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x)";
	}, function (props) {
	  return "url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ")";
	}, function (props) {
	  return "-webkit-image-set(url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x, url(" + (props.backgroundImage ? props.backgroundImage[0] : "") + ") 3x)";
	}, function (props) {
	  return "image-set(url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x, url(" + (props.backgroundImage ? props.backgroundImage[0] : "") + ") 3x)";
	}, function (props) {
	  return props.theme.colors[props.cardColor] && "linear-gradient(to bottom, " + (props.cardColor ? (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.66) : "") + ", " + (props.cardColor ? (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.66) : "") + "), url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ")";
	});
	
	var Content = (0, _styledComponents2.default)(_rebass.Box)(_templateObject3);
	
	var CustomButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject4, function (props) {
	  return props.theme.colors[props.cardColor];
	}, function (props) {
	  return props.theme.colors[props.cardColor];
	});
	
	var determineColor = function determineColor(region) {
	  var color = "violet";
	  if (region === "update" || region === "institution" || region === null || region === undefined) {
	    color = "ash";
	  }
	  if (region === "middle-east-and-north-africa" || region === "oriente-medio-y-norte-de-africa" || region === "الشرق-الاوسط-وشمات-افريقيا") {
	    color = "orange";
	  }
	  if (region === "africa" || region === "africa1" || region === "افريقيا") {
	    color = "green";
	  }
	  if (region === "latin-america" || region === "america-latina-y-el-caribe" || region === "امريكا-اللاتينية") {
	    color = "blue";
	  }
	  if (region === "asia" || region === "asia1" || region === "اسيا") {
	    color = "pink";
	  }
	  if (region === "europe--central-asia" || region === "europa-y-asia-central" || region === "اوروبا-واسيا-الوسطى") {
	    color = "yellow";
	  }
	  return color;
	};
	
	var RegionCard = function RegionCard(props) {
	  if (props.object) {
	    return _react2.default.createElement(
	      _styledComponents.ThemeProvider,
	      { theme: _invertTheme2.default },
	      _react2.default.createElement(
	        Action,
	        {
	          className: props.className,
	          style: props.style,
	          cardColor: determineColor(props.object.uid)
	        },
	        _react2.default.createElement(
	          Wrapper,
	          {
	            px: 4,
	            py: 5,
	            backgroundImage: props.object.data.header_image.url ? [props.object.data.header_image.half.url, props.object.data.header_image.quarter.url] : "",
	            cardColor: determineColor(props.object.uid)
	          },
	          _react2.default.createElement(
	            Content,
	            null,
	            _react2.default.createElement(_H2.default, {
	              children: props.object.data.title[0] ? props.object.data.title[0].text : "",
	              mb: 6
	            }),
	            _react2.default.createElement(CustomButton, {
	              is: _gatsbyLink2.default,
	              to: "/" + props.object.lang + "/region/" + props.object.uid,
	              children: props.object.lang === "en-us" ? "View projects" : props.object.lang === "es-mx" ? "Ver proyectos" : "انظر المشاريع",
	              cardColor: determineColor(props.object.uid),
	              "aria-label":  true ? props.object.data.title[0].text : "" + " Projects"
	            })
	          )
	        )
	      )
	    );
	  } else {
	    return null;
	  }
	};
	
	RegionCard.defaultProps = {
	  title: "Region Name",
	  cardColor: "green",
	  image: ["https://source.unsplash.com/random", "https://source.unsplash.com/random", "https://source.unsplash.com/random"]
	};
	
	exports.default = RegionCard;
	module.exports = exports["default"];

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  text-decoration: none;\n  cursor: pointer;\n  opacity: 0;\n  animation: resource-card-fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n  will-change: opacity;\n\n  @keyframes resource-card-fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  &:hover {\n    .resource-card__tile {\n      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n      transform: translateY(-4px);\n    }\n    .resource-card__title {\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n    .resource-card__corner-icon {\n      opacity: 0.5;\n      transform: translateY(0);\n    }\n  }\n  &:active {\n    .resource-card__tile {\n      box-shadow: none;\n      transform: translateY(-2px);\n    }\n    .resource-card__title {\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n  }\n\n  * {\n    text-decoration: none;\n\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"], ["\n  text-decoration: none;\n  cursor: pointer;\n  opacity: 0;\n  animation: resource-card-fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n  will-change: opacity;\n\n  @keyframes resource-card-fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  &:hover {\n    .resource-card__tile {\n      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n      transform: translateY(-4px);\n    }\n    .resource-card__title {\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n    .resource-card__corner-icon {\n      opacity: 0.5;\n      transform: translateY(0);\n    }\n  }\n  &:active {\n    .resource-card__tile {\n      box-shadow: none;\n      transform: translateY(-2px);\n    }\n    .resource-card__title {\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n  }\n\n  * {\n    text-decoration: none;\n\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose([""], [""]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  height: ", "px;\n  background-color: ", ";\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: transform;\n  user-select: none;\n"], ["\n  position: relative;\n  width: 100%;\n  height: ", "px;\n  background-color: ", ";\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: transform;\n  user-select: none;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 24px;\n  height: 24px;\n  background-color: ", ";\n  border-radius: 9999px;\n  opacity: 0;\n  transform: translateY(4px);\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n\n  svg {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    stroke: ", ";\n  }\n"], ["\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 24px;\n  height: 24px;\n  background-color: ", ";\n  border-radius: 9999px;\n  opacity: 0;\n  transform: translateY(4px);\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n\n  svg {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    stroke: ", ";\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  color: #fff;\n"], ["\n  text-align: center;\n  color: #fff;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  left: 50%;\n  width: 48px;\n  height: 48px;\n  transform: translateX(-50%);\n\n  > * {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n"], ["\n  position: relative;\n  left: 50%;\n  width: 48px;\n  height: 48px;\n  transform: translateX(-50%);\n\n  > * {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  margin-top: ", "px;\n"], ["\n  width: 100%;\n  margin-top: ", "px;\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  padding-bottom: 4px;\n  font-size: 18px;\n  font-weight: 600;\n\n  > span {\n    box-shadow: inset 0 -1px 0 transparent;\n    transition: box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: box-shadow;\n  }\n"], ["\n  padding-bottom: 4px;\n  font-size: 18px;\n  font-weight: 600;\n\n  > span {\n    box-shadow: inset 0 -1px 0 transparent;\n    transition: box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: box-shadow;\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _polished = __webpack_require__(8);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _Text = __webpack_require__(17);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _H = __webpack_require__(41);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _reactFeather = __webpack_require__(29);
	
	var _theme = __webpack_require__(13);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _invertTheme = __webpack_require__(12);
	
	var _invertTheme2 = _interopRequireDefault(_invertTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Action = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.grey[1];
	}, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors[props.cardColor] && (0, _polished.shade)(0.9375, props.theme.colors[props.cardColor]);
	});
	
	Action.defaultProps = {
	  is: "a"
	};
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2);
	
	var Tile = (0, _styledComponents2.default)(_rebass.Box)(_templateObject3, 96 + 24, function (props) {
	  return props.theme.colors[props.cardColor];
	});
	
	var CornerIcon = (0, _styledComponents2.default)(_rebass.Box)(_templateObject4, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors[props.cardColor];
	});
	
	var TileContent = (0, _styledComponents2.default)(_rebass.Box)(_templateObject5);
	
	var Type = (0, _styledComponents2.default)(_H2.default)(_templateObject6);
	
	Type.defaultProps = {
	  is: "div"
	};
	
	var Icon = (0, _styledComponents2.default)(_rebass.Box)(_templateObject7);
	
	var Content = (0, _styledComponents2.default)(_rebass.Box)(_templateObject8, function (props) {
	  return props.theme.space[2];
	});
	
	var Title = (0, _styledComponents2.default)(_Text2.default)(_templateObject9);
	
	var determineColor = function determineColor(region) {
	  var color = "violet";
	  if (region === "update" || region === "institution" || region === null || region === undefined) {
	    color = "ash";
	  }
	  if (region === "middle-east-and-north-africa" || region === "oriente-medio-y-norte-de-africa" || region === "الشرق-الاوسط-وشمات-افريقيا") {
	    color = "orange";
	  }
	  if (region === "africa" || region === "africa1" || region === "افريقيا") {
	    color = "green";
	  }
	  if (region === "latin-america" || region === "america-latina-y-el-caribe" || region === "امريكا-اللاتينية") {
	    color = "blue";
	  }
	  if (region === "asia" || region === "asia1" || region === "اسيا") {
	    color = "pink";
	  }
	  if (region === "europe--central-asia" || region === "europa-y-asia-central" || region === "اوروبا-واسيا-الوسطى") {
	    color = "yellow";
	  }
	  return color;
	};
	
	var translatedTitles = {
	  Newsletter: {
	    "en-us": "Newsletter",
	    "ar-eg": "نشرة إخبارية",
	    "es-mx": "Boletine"
	  },
	  "Partner Website": {
	    "en-us": "Partner Website",
	    "ar-eg": "موقع مشارك المركز",
	    "es-mx": "Página web"
	  },
	  Website: {
	    "en-us": "Partner Website",
	    "ar-eg": "موقع مشارك المركز",
	    "es-mx": "Página web"
	  },
	  Audio: {
	    "en-us": "Audio",
	    "ar-eg": "صوت",
	    "es-mx": "Audio"
	  },
	  Video: {
	    "en-us": "Video",
	    "ar-eg": "فيديو",
	    "es-mx": "Video"
	  },
	  Document: {
	    "en-us": "Document",
	    "ar-eg": "وثيقة",
	    "es-mx": "Documento"
	  }
	};
	
	var ResourceCard = function ResourceCard(props) {
	  if (props.object) {
	    return _react2.default.createElement(
	      _styledComponents.ThemeProvider,
	      { theme: _theme2.default },
	      _react2.default.createElement(
	        Action,
	        {
	          className: props.className,
	          style: props.style,
	          href: props.object.data.resource_link ? props.object.data.resource_link.url : "",
	          target: "_blank",
	          cardColor: determineColor(props.object.data.region ? props.object.data.region.uid : ""),
	          "aria-label": props.object.data.title[0] ? props.object.data.title[0].text : ""
	        },
	        _react2.default.createElement(
	          Wrapper,
	          null,
	          _react2.default.createElement(
	            Tile,
	            {
	              className: "resource-card__tile",
	              cardColor: determineColor(props.object.data.region ? props.object.data.region.uid : "")
	            },
	            _react2.default.createElement(
	              CornerIcon,
	              {
	                className: "resource-card__corner-icon",
	                cardColor: determineColor(props.object.data.region ? props.object.data.region.uid : "")
	              },
	              _react2.default.createElement(_reactFeather.ArrowUpRight, { size: 16, strokeWidth: 2, title: "External Link" })
	            ),
	            _react2.default.createElement(
	              TileContent,
	              null,
	              props.object.data.post_type === "Audio" && _react2.default.createElement(
	                Icon,
	                null,
	                _react2.default.createElement(_reactFeather.Volume2, {
	                  size: 32,
	                  color: "white",
	                  strokeWidth: 1.5,
	                  title: props.lang === "en-us" ? "Audio" : props.lang === "ar-eg" ? "موقع مشارك المركز" : "Audio"
	                })
	              ),
	              props.object.data.post_type === "Video" && _react2.default.createElement(
	                Icon,
	                null,
	                _react2.default.createElement(_reactFeather.Video, {
	                  size: 32,
	                  color: "white",
	                  strokeWidth: 1.5,
	                  title: props.lang === "en-us" ? "Video" : props.lang === "ar-eg" ? "موقع مشارك المركز" : "Video"
	                })
	              ),
	              props.object.data.post_type === "Document" && _react2.default.createElement(
	                Icon,
	                null,
	                _react2.default.createElement(_reactFeather.BookOpen, {
	                  size: 32,
	                  color: "white",
	                  strokeWidth: 1.5,
	                  title: props.lang === "en-us" ? "Document" : props.lang === "ar-eg" ? "موقع مشارك المركز" : "Documento"
	                })
	              ),
	              props.object.data.post_type === "Newsletter" && _react2.default.createElement(
	                Icon,
	                null,
	                _react2.default.createElement(_reactFeather.Book, {
	                  size: 32,
	                  color: "white",
	                  strokeWidth: 1.5,
	                  title: props.lang === "en-us" ? "Newsletter" : props.lang === "ar-eg" ? "موقع مشارك المركز" : "Boletine"
	                })
	              ),
	              (props.object.data.post_type === "Partner Website" || props.object.data.post_type === "Website") && _react2.default.createElement(
	                Icon,
	                null,
	                _react2.default.createElement(_reactFeather.Link, {
	                  size: 32,
	                  color: "white",
	                  strokeWidth: 1.5,
	                  title: props.lang === "en-us" ? "Partner Website" : props.lang === "ar-eg" ? "موقع مشارك المركز" : "Página web"
	                })
	              ),
	              _react2.default.createElement(Type, {
	                children: translatedTitles[props.object.data.post_type] ? translatedTitles[props.object.data.post_type][props.lang] : ""
	              })
	            )
	          ),
	          _react2.default.createElement(
	            Content,
	            null,
	            _react2.default.createElement(
	              Title,
	              null,
	              _react2.default.createElement("span", {
	                className: "resource-card__title",
	                children: props.object.data.title[0] ? props.object.data.title[0].text : ""
	              })
	            )
	          )
	        )
	      )
	    );
	  } else {
	    return null;
	  }
	};
	
	ResourceCard.defaultProps = {
	  title: "Resource Name",
	  cardColor: "yellow"
	};
	
	exports.default = ResourceCard;
	module.exports = exports["default"];

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  width: 44px;\n  background: #fff;\n  border-radius: 9999px;\n\n  @keyframes wrapper-in {\n    from {\n      width: 44px;\n      opacity: 0;\n    }\n    to {\n      width: 100%;\n      opacity: 1;\n    }\n  }\n\n  &.is-visible {\n    border-radius: 0;\n    position: absolute;\n    z-index: 1;\n    animation: wrapper-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n    animation-delay: 0s;\n  }\n  &.is-visible .search-search-button {\n    position: absolute;\n    top: ", "px;\n    animation: icon-track-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n    animation-delay: 0s;\n    &:hover {\n      > * {\n        background-color: transparent !important;\n      }\n      svg > g > g {\n        stroke: #363636;\n      }\n    }\n  }\n  &.is-visible .search-exit-button {\n    animation: exit-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n    animation-delay: 0.25s;\n  }\n  &.is-visible .search-input {\n    display: block;\n    animation: input-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n    animation-delay: 0s;\n  }\n  &.is-visible .search-underline {\n    animation: underline-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n    animation-delay: 0.25s;\n  }\n\n  &.is-hidden {\n    animation: wrapper-in 1s cubic-bezier(0.23, 1, 0.32, 1) backwards;\n    animation-delay: 0s;\n  }\n  &.is-hidden .search-search-button {\n    animation: icon-track-in 1s cubic-bezier(0.23, 1, 0.32, 1) backwards;\n    animation-delay: 0s;\n  }\n  &.is-hidden .search-exit-button {\n    animation: exit-in 1s cubic-bezier(0.23, 1, 0.32, 1) backwards;\n    animation-delay: 0.25s;\n  }\n  &.is-hidden .search-input {\n    animation: input-in 1s cubic-bezier(0.23, 1, 0.32, 1) backwards;\n    animation-delay: 0s;\n  }\n  &.is-hidden .search-underline {\n    animation: underline-in 1s cubic-bezier(0.23, 1, 0.32, 1) backwards;\n    animation-delay: 0.25s;\n  }\n"], ["\n  position: relative;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  width: 44px;\n  background: #fff;\n  border-radius: 9999px;\n\n  @keyframes wrapper-in {\n    from {\n      width: 44px;\n      opacity: 0;\n    }\n    to {\n      width: 100%;\n      opacity: 1;\n    }\n  }\n\n  &.is-visible {\n    border-radius: 0;\n    position: absolute;\n    z-index: 1;\n    animation: wrapper-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n    animation-delay: 0s;\n  }\n  &.is-visible .search-search-button {\n    position: absolute;\n    top: ", "px;\n    animation: icon-track-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n    animation-delay: 0s;\n    &:hover {\n      > * {\n        background-color: transparent !important;\n      }\n      svg > g > g {\n        stroke: #363636;\n      }\n    }\n  }\n  &.is-visible .search-exit-button {\n    animation: exit-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n    animation-delay: 0.25s;\n  }\n  &.is-visible .search-input {\n    display: block;\n    animation: input-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n    animation-delay: 0s;\n  }\n  &.is-visible .search-underline {\n    animation: underline-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n    animation-delay: 0.25s;\n  }\n\n  &.is-hidden {\n    animation: wrapper-in 1s cubic-bezier(0.23, 1, 0.32, 1) backwards;\n    animation-delay: 0s;\n  }\n  &.is-hidden .search-search-button {\n    animation: icon-track-in 1s cubic-bezier(0.23, 1, 0.32, 1) backwards;\n    animation-delay: 0s;\n  }\n  &.is-hidden .search-exit-button {\n    animation: exit-in 1s cubic-bezier(0.23, 1, 0.32, 1) backwards;\n    animation-delay: 0.25s;\n  }\n  &.is-hidden .search-input {\n    animation: input-in 1s cubic-bezier(0.23, 1, 0.32, 1) backwards;\n    animation-delay: 0s;\n  }\n  &.is-hidden .search-underline {\n    animation: underline-in 1s cubic-bezier(0.23, 1, 0.32, 1) backwards;\n    animation-delay: 0.25s;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  /* top: ", "px; */\n  top: initial;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  width: 44px;\n  height: 44px;\n  /* background: ", "; */\n  /* animation: icon-track-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards; */\n  animation-delay: 1s;\n\n  @keyframes icon-track-in {\n    from {\n      width: 44px;\n      opacity: 1;\n      pointer-events: none;\n    }\n    to {\n      width: calc(100% - 24px + 10px);\n      opacity: 0.5;\n    }\n  }\n  @media (max-width: 40em) {\n    &:not(:lang(ar)) {\n      left: 16px;\n    }\n    &:lang(ar) {\n      right: 16px;\n    }\n  }\n"], ["\n  position: relative;\n  /* top: ", "px; */\n  top: initial;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  width: 44px;\n  height: 44px;\n  /* background: ", "; */\n  /* animation: icon-track-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards; */\n  animation-delay: 1s;\n\n  @keyframes icon-track-in {\n    from {\n      width: 44px;\n      opacity: 1;\n      pointer-events: none;\n    }\n    to {\n      width: calc(100% - 24px + 10px);\n      opacity: 0.5;\n    }\n  }\n  @media (max-width: 40em) {\n    &:not(:lang(ar)) {\n      left: 16px;\n    }\n    &:lang(ar) {\n      right: 16px;\n    }\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 44px;\n  height: 44px;\n  text-decoration: none;\n  border: 0;\n  border-radius: 9999px;\n  background-color: transparent;\n  cursor: pointer;\n  user-select: none;\n  appearance: none;\n  transition: background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n\n  svg {\n    transition: stroke 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: stroke;\n    stroke: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n    svg {\n      stroke: #fff;\n    }\n  }\n  &:focus {\n    background-color: ", ";\n    box-shadow: 0 0 0 4px\n      ", ";\n    outline: none;\n    svg {\n      stroke: #fff;\n    }\n  }\n  &:active {\n    background-color: ", ";\n    svg {\n      stroke: #fff;\n    }\n  }\n"], ["\n  position: relative;\n  width: 44px;\n  height: 44px;\n  text-decoration: none;\n  border: 0;\n  border-radius: 9999px;\n  background-color: transparent;\n  cursor: pointer;\n  user-select: none;\n  appearance: none;\n  transition: background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n\n  svg {\n    transition: stroke 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: stroke;\n    stroke: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n    svg {\n      stroke: #fff;\n    }\n  }\n  &:focus {\n    background-color: ", ";\n    box-shadow: 0 0 0 4px\n      ", ";\n    outline: none;\n    svg {\n      stroke: #fff;\n    }\n  }\n  &:active {\n    background-color: ", ";\n    svg {\n      stroke: #fff;\n    }\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 24px;\n  height: 24px;\n  transform: translate(-50%, -50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 24px;\n  height: 24px;\n  transform: translate(-50%, -50%);\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: ", "px;\n  &:not(:lang(ar)) {\n    right: 0;\n  }\n  &:lang(ar) {\n    left: 0;\n  }\n  z-index: 3;\n  width: 44px;\n  height: 44px;\n  text-decoration: none;\n  border: 0;\n  border-radius: 9999px;\n  background-color: transparent;\n  cursor: pointer;\n  user-select: none;\n  appearance: none;\n  transition: background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  transform: scale(0);\n  transform-origin: center;\n  /* animation: exit-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards; */\n  animation-delay: 1s;\n\n  @keyframes exit-in {\n    from {\n      transform: scale(0);\n    }\n    to {\n      transform: scale(1);\n    }\n  }\n\n  svg {\n    stroke: ", ";\n    transition: stroke 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: stroke;\n  }\n\n  &:hover {\n    background-color: ", ";\n    svg {\n      stroke: #fff;\n    }\n  }\n  &:focus {\n    background-color: ", ";\n    box-shadow: 0 0 0 4px\n      ", ";\n    outline: none;\n    svg {\n      stroke: #fff;\n    }\n  }\n  &:active {\n    background-color: ", ";\n    svg {\n      stroke: #fff;\n    }\n  }\n  @media (max-width: 40em) {\n    &:not(:lang(ar)) {\n      right: 16px;\n    }\n    &:lang(ar) {\n      left: 16px;\n    }\n  }\n"], ["\n  position: absolute;\n  top: ", "px;\n  &:not(:lang(ar)) {\n    right: 0;\n  }\n  &:lang(ar) {\n    left: 0;\n  }\n  z-index: 3;\n  width: 44px;\n  height: 44px;\n  text-decoration: none;\n  border: 0;\n  border-radius: 9999px;\n  background-color: transparent;\n  cursor: pointer;\n  user-select: none;\n  appearance: none;\n  transition: background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  transform: scale(0);\n  transform-origin: center;\n  /* animation: exit-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards; */\n  animation-delay: 1s;\n\n  @keyframes exit-in {\n    from {\n      transform: scale(0);\n    }\n    to {\n      transform: scale(1);\n    }\n  }\n\n  svg {\n    stroke: ", ";\n    transition: stroke 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: stroke;\n  }\n\n  &:hover {\n    background-color: ", ";\n    svg {\n      stroke: #fff;\n    }\n  }\n  &:focus {\n    background-color: ", ";\n    box-shadow: 0 0 0 4px\n      ", ";\n    outline: none;\n    svg {\n      stroke: #fff;\n    }\n  }\n  &:active {\n    background-color: ", ";\n    svg {\n      stroke: #fff;\n    }\n  }\n  @media (max-width: 40em) {\n    &:not(:lang(ar)) {\n      right: 16px;\n    }\n    &:lang(ar) {\n      left: 16px;\n    }\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: none;\n  width: 100%;\n  height: 100%;\n  padding-right: ", "px;\n  padding-left: ", "px;\n  font-size: ", "px;\n  color: ", ";\n  border: none;\n  /* border-right: 1px solid ", ";\n  border-left: 1px solid ", "; */\n  background: transparent;\n  ", ";\n  transform: scaleX(0);\n  transform-origin: right;\n  /* animation: input-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards; */\n  animation-delay: 1s;\n\n  &:focus {\n    outline: none;\n    /* box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25); */\n  }\n\n  @keyframes input-in {\n    from {\n      transform: scaleX(0);\n      opacity: 0;\n    }\n    to {\n      transform: scaleX(1);\n      opacity: 1;\n    }\n  }\n  @media (max-width: 40em) {\n    padding-right: ", "px;\n    padding-left: ", "px;\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: none;\n  width: 100%;\n  height: 100%;\n  padding-right: ", "px;\n  padding-left: ", "px;\n  font-size: ", "px;\n  color: ", ";\n  border: none;\n  /* border-right: 1px solid ", ";\n  border-left: 1px solid ", "; */\n  background: transparent;\n  ", ";\n  transform: scaleX(0);\n  transform-origin: right;\n  /* animation: input-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards; */\n  animation-delay: 1s;\n\n  &:focus {\n    outline: none;\n    /* box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25); */\n  }\n\n  @keyframes input-in {\n    from {\n      transform: scaleX(0);\n      opacity: 0;\n    }\n    to {\n      transform: scaleX(1);\n      opacity: 1;\n    }\n  }\n  @media (max-width: 40em) {\n    padding-right: ", "px;\n    padding-left: ", "px;\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background: ", ";\n  transform: scaleX(0);\n  transform-origin: right;\n  /* animation: underline-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards; */\n  animation-delay: 1s;\n\n  @keyframes underline-in {\n    from {\n      transform: scaleX(0);\n    }\n    to {\n      transform: scaleX(1);\n    }\n  }\n"], ["\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background: ", ";\n  transform: scaleX(0);\n  transform-origin: right;\n  /* animation: underline-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards; */\n  animation-delay: 1s;\n\n  @keyframes underline-in {\n    from {\n      transform: scaleX(0);\n    }\n    to {\n      transform: scaleX(1);\n    }\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 100%;\n  right: 0;\n  left: 0;\n  z-index: 100;\n  max-height: ", "px;\n  max-height: 50vh;\n  overflow: scroll;\n  background-color: ", ";\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n"], ["\n  position: absolute;\n  top: 100%;\n  right: 0;\n  left: 0;\n  z-index: 100;\n  max-height: ", "px;\n  max-height: 50vh;\n  overflow: scroll;\n  background-color: ", ";\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(61);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(8);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _theme = __webpack_require__(13);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _reactFeather = __webpack_require__(29);
	
	var Icon = _interopRequireWildcard(_reactFeather);
	
	var _SearchResult = __webpack_require__(143);
	
	var _SearchResult2 = _interopRequireDefault(_SearchResult);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, (80 - 44) / 2);
	
	var IconTrack = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2, (80 - 44) / 2, function (props) {
	  return props.theme.colors.grey[1];
	});
	
	var SearchContainer = (0, _styledComponents2.default)(_rebass.Box)(_templateObject3, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.text && (0, _polished.rgba)(props.theme.colors.violet, 0.5);
	}, function (props) {
	  return props.theme.colors.text && (0, _polished.shade)(0.875, props.theme.colors.violet);
	});
	SearchContainer.defaultProps = {
	  is: "button"
	};
	
	var SearchIconContainer = (0, _styledComponents2.default)(_rebass.Box)(_templateObject4);
	
	var SearchButton = function SearchButton(props) {
	  return _react2.default.createElement(
	    IconTrack,
	    {
	      className: props.className,
	      "aria-label": props.ariaLabel,
	      role: props.role
	    },
	    _react2.default.createElement(
	      SearchContainer,
	      { onClick: props.onClick },
	      _react2.default.createElement(
	        SearchIconContainer,
	        null,
	        _react2.default.createElement(Icon.Search, { size: 24, strokeWidth: 1.5 })
	      )
	    )
	  );
	};
	
	var ExitContainer = (0, _styledComponents2.default)(_rebass.Box)(_templateObject5, (80 - 44) / 2, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.text && (0, _polished.rgba)(props.theme.colors.violet, 0.5);
	}, function (props) {
	  return props.theme.colors.text && (0, _polished.shade)(0.875, props.theme.colors.violet);
	});
	ExitContainer.defaultProps = {
	  is: "button"
	};
	
	var ExitButtonContainer = (0, _styledComponents2.default)(_rebass.Box)(_templateObject4);
	
	var ExitButton = function ExitButton(props) {
	  return _react2.default.createElement(
	    ExitContainer,
	    {
	      className: props.className,
	      onClick: props.onClick,
	      role: props.role,
	      "aria-label": props.ariaLabel
	    },
	    _react2.default.createElement(
	      ExitButtonContainer,
	      null,
	      _react2.default.createElement(Icon.X, { size: 24, strokeWidth: 1.5 })
	    )
	  );
	};
	
	var Input = _styledComponents2.default.input(_templateObject6, 48 + 8, 48 + 16, function (props) {
	  return props.theme.fontSizes[3];
	}, function (props) {
	  return props.theme.colors.text;
	}, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.grey[0];
	}, (0, _polished.placeholder)({ color: "rgba(0, 0, 0, 0.5)" }), 48 + 16, 48 + 16);
	
	var Underline = (0, _styledComponents2.default)(_rebass.Box)(_templateObject7, function (props) {
	  return props.theme.colors.grey[0];
	});
	
	var Results = (0, _styledComponents2.default)(_rebass.Box)(_templateObject8, 256, function (props) {
	  return props.theme.colors.grey[2];
	});
	
	var Search = function (_React$Component) {
	  _inherits(Search, _React$Component);
	
	  function Search(props) {
	    _classCallCheck(this, Search);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.setInputRef = function (element) {
	      _this.inputRef = _reactDom2.default.findDOMNode(element);
	    };
	
	    _this.setSearchRef = function (element) {
	      _this.searchRef = _reactDom2.default.findDOMNode(element);
	    };
	
	    _this.autocompleteUpdate = function (event) {
	      if (event.target.value !== "") {
	        _this.getAutocomplete(event.target.value);
	        //if (event.target.value.length > this.state.longestValue) {
	        //this.setState({ longestValue: event.target.value.length });
	        //}
	      } else {
	        _this.setState({ results: [] });
	      } //else if (this.state.longestValue > 3) {
	      //this.props.toggleSearch();
	      //}
	      _this.setState({ value: event.target.value });
	    };
	
	    _this.handleKeyDown = function (e) {
	      if (e.keyCode === 27) {
	        _this.props.toggleSearch();
	      }
	      if (e.keyCode === 13 && _this.state.searchIndex === 0) {
	        _this.changeSearchIndex(1);
	      }
	      if (e.keyCode === 38) {
	        _this.changeSearchIndex(-1);
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      if (e.keyCode === 40) {
	        _this.changeSearchIndex(1);
	        e.stopPropagation();
	        e.preventDefault();
	      }
	    };
	
	    _this.changeSearchIndex = function (amount) {
	      if (_this.state.searchIndex + amount !== _this.state.results.length + 1 && _this.state.searchIndex + amount != -1) {
	        _this.setState({ searchIndex: _this.state.searchIndex + amount }, function () {
	          if (_this.state.searchIndex === 0) {
	            _this.inputRef.focus();
	          } else {
	            _this.searchRef.childNodes[_this.state.searchIndex].focus();
	          }
	        });
	      } else {
	        _this.inputRef.focus();
	      }
	    };
	
	    _this.getAutocomplete = function (change) {
	      _this.state.autocomplete.search(change, {
	        hitsPerPage: 20,
	        filters: "lang:" + _this.props.windowLang
	      }, function (err, content) {
	        if (err) {
	          return;
	        }
	        _this.setState({ results: content.hits, searchIndex: 0 });
	      });
	    };
	
	    _this.state = {
	      results: [],
	      value: "",
	      longestValue: 0,
	      searchIndex: 0,
	      autocomplete: undefined
	    };
	    _this.searchRef = null;
	    _this.inputRef = null;
	    return _this;
	  }
	
	  Search.prototype.componentDidMount = function componentDidMount() {
	    var algoliasearch = __webpack_require__(125);
	    var client = algoliasearch("4AG971959W", "3b12490ed715fb5c60bb0a8bb6c11544");
	    var index = client.initIndex("primary_index");
	    this.setState({ autocomplete: index });
	  };
	
	  Search.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      _styledComponents.ThemeProvider,
	      { theme: _theme2.default },
	      _react2.default.createElement(
	        Wrapper,
	        {
	          className: this.props.searchOpen ? "is-visible" : this.props.searchHasHappened ? "" : ""
	        },
	        _react2.default.createElement(SearchButton, {
	          ariaLabel: "Open search",
	          role: "button",
	          className: "search-search-button",
	          onClick: function onClick() {
	            _this2.props.toggleSearch();
	            _this2.setState({ value: "", results: [] });
	          }
	        }),
	        this.props.searchOpen && _react2.default.createElement(ExitButton, {
	          ariaLabel: "Exit search",
	          role: "button",
	          className: "search-exit-button",
	          onClick: function onClick() {
	            _this2.props.toggleSearch();
	            _this2.setState({ value: "", results: [] });
	          }
	        }),
	        this.props.searchOpen && _react2.default.createElement(Input, {
	          "aria-label": "Search",
	          "aria-autocomplete": "list",
	          "aria-controls": "autocomplete-results",
	          role: "combobox",
	          className: "search-input",
	          autoFocus: "autofocus",
	          placeholder: this.props.windowLang === "en-us" ? "Search..." : this.props.windowLang === "es-mx" ? "Buscar..." : "بحث",
	          value: this.state.value,
	          onChange: this.autocompleteUpdate,
	          onKeyDown: this.handleKeyDown,
	          ref: this.setInputRef
	        }),
	        this.props.searchOpen && _react2.default.createElement(
	          Results,
	          {
	            ref: this.setSearchRef,
	            id: "autocomplete-results",
	            role: "listbox"
	          },
	          this.state.value !== "" && _react2.default.createElement(_SearchResult2.default, {
	            result: { name: "", type: "Algolia" },
	            onClick: function onClick() {
	              _this2.props.toggleSearch();
	              _this2.setState({
	                value: "",
	                results: [],
	                longestValue: 0
	              });
	            },
	            onKeyDown: this.handleKeyDown
	          }),
	          this.state.results.length === 0 && this.state.value !== "" && _react2.default.createElement(_SearchResult2.default, {
	            result: {
	              name: this.props.windowLang === "en-us" ? "No results found" : this.props.windowLang === "es-mx" ? "No se encuentra resultados" : "لم يتم العثور على اي نتائج",
	              type: "noresults"
	            },
	            onClick: function onClick() {
	              _this2.props.toggleSearch();
	              _this2.setState({
	                value: "",
	                results: [],
	                longestValue: 0
	              });
	            },
	            onKeyDown: this.handleKeyDown
	          }),
	          this.state.results.map(function (result, index) {
	            return _react2.default.createElement(_SearchResult2.default, {
	              key: "result" + index,
	              result: _extends({}, result, { index: index }),
	              windowLang: _this2.props.windowLang,
	              onClick: function onClick() {
	                _this2.props.toggleSearch();
	                _this2.setState({
	                  value: "",
	                  results: [],
	                  longestValue: 0
	                });
	              },
	              onKeyDown: _this2.handleKeyDown
	            });
	          })
	        )
	      )
	    );
	  };
	
	  return Search;
	}(_react2.default.Component);
	
	exports.default = Search;
	module.exports = exports["default"];

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  user-select: none;\n"], ["\n  position: relative;\n  user-select: none;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: 24px;\n\n  svg {\n    stroke: ", ";\n    transition: stroke 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: stroke;\n  }\n\n  &:hover {\n    select {\n      color: ", ";\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n    svg {\n      stroke: ", ";\n    }\n  }\n  &:active {\n  }\n"], ["\n  position: relative;\n  height: 24px;\n\n  svg {\n    stroke: ", ";\n    transition: stroke 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: stroke;\n  }\n\n  &:hover {\n    select {\n      color: ", ";\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n    svg {\n      stroke: ", ";\n    }\n  }\n  &:active {\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  display: block;\n  margin-bottom: 4px;\n  color: ", ";\n  ", ";\n  text-transform: uppercase;\n"], ["\n  display: block;\n  margin-bottom: 4px;\n  color: ", ";\n  ", ";\n  text-transform: uppercase;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  margin: 0;\n  padding-top: 0;\n  padding-right: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  color: ", ";\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: ", ";\n  border: 0;\n  border-radius: 0;\n  background-color: transparent;\n  box-shadow: inset 0 -1px 0 ", ";\n  cursor: pointer;\n  appearance: none;\n  transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    outline 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: color, box-shadow;\n  ", ";\n  outline-color: ", ";\n\n  &:not(:lang(ar)) {\n    padding-right: 20px;\n  }\n  &:lang(ar) {\n    padding-left: 20px;\n  }\n\n  &:focus {\n    background-color: ", ";\n    outline-style: solid;\n    outline-width: 8px;\n    outline-offset: 0px;\n  }\n"], ["\n  position: relative;\n  width: 100%;\n  margin: 0;\n  padding-top: 0;\n  padding-right: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  color: ", ";\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: ", ";\n  border: 0;\n  border-radius: 0;\n  background-color: transparent;\n  box-shadow: inset 0 -1px 0 ", ";\n  cursor: pointer;\n  appearance: none;\n  transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    outline 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    background-color 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: color, box-shadow;\n  ", ";\n  outline-color: ", ";\n\n  &:not(:lang(ar)) {\n    padding-right: 20px;\n  }\n  &:lang(ar) {\n    padding-left: 20px;\n  }\n\n  &:focus {\n    background-color: ", ";\n    outline-style: solid;\n    outline-width: 8px;\n    outline-offset: 0px;\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 50%;\n  width: 20px;\n  height: 24px;\n  pointer-events: none;\n  transform: translateY(-50%);\n\n  &:not(:lang(ar)) {\n    right: 0;\n  }\n  &:lang(ar) {\n    left: 0;\n  }\n\n  > * {\n  }\n"], ["\n  position: absolute;\n  top: 50%;\n  width: 20px;\n  height: 24px;\n  pointer-events: none;\n  transform: translateY(-50%);\n\n  &:not(:lang(ar)) {\n    right: 0;\n  }\n  &:lang(ar) {\n    left: 0;\n  }\n\n  > * {\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(8);
	
	var _styledSystem = __webpack_require__(11);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _reactFeather = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject);
	
	var Container = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	}, function (props) {
	  return props.theme.colors.violet;
	});
	
	var Title = (0, _styledComponents2.default)(_rebass.Text)(_templateObject3, function (props) {
	  return props.theme.colors.grey[0];
	}, _styledSystem.letterSpacing);
	
	Title.defaultProps = {
	  is: "label",
	  m: 0,
	  color: "text",
	  fontSize: 0,
	  fontWeight: "bold",
	  lineHeight: 3,
	  letterSpacing: "caps"
	};
	
	var SelectContainer = _styledComponents2.default.select(_templateObject4, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.fonts.sans;
	}, function (props) {
	  return props.theme.lineHeights[3];
	}, function (props) {
	  return props.theme.colors.grey[0];
	}, (0, _polished.ellipsis)(), function (props) {
	  return props.theme.colors.grey[1];
	}, function (props) {
	  return props.theme.colors.grey[1];
	});
	
	var Icon = (0, _styledComponents2.default)(_rebass.Box)(_templateObject5);
	
	var Select = function (_React$Component) {
	  _inherits(Select, _React$Component);
	
	  function Select() {
	    _classCallCheck(this, Select);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Select.prototype.render = function render() {
	    var options = this.props.options.map(function (option, index) {
	      return _react2.default.createElement(
	        "option",
	        { key: option.label + index, value: option.value },
	        option.label
	      );
	    });
	    return _react2.default.createElement(
	      Wrapper,
	      this.props,
	      this.props.header && _react2.default.createElement(Title, { children: this.props.header }),
	      _react2.default.createElement(
	        Container,
	        null,
	        _react2.default.createElement(
	          SelectContainer,
	          _extends({
	            id: this.props.id,
	            name: this.props.name,
	            value: this.props.value,
	            onChange: this.props.onChange
	          }, this.props),
	          options,
	          this.props.children
	        ),
	        _react2.default.createElement(
	          Icon,
	          null,
	          _react2.default.createElement(_reactFeather.ChevronDown, { size: 24, strokeWidth: 1.5 })
	        )
	      )
	    );
	  };
	
	  return Select;
	}(_react2.default.Component);
	
	Select.defaultProps = {
	  options: []
	};
	
	exports.default = Select;
	module.exports = exports["default"];

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SliceZone = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SliceZone = exports.SliceZone = function (_React$Component) {
	  _inherits(SliceZone, _React$Component);
	
	  function SliceZone() {
	    _classCallCheck(this, SliceZone);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SliceZone.prototype.render = function render() {
	    var _this2 = this;
	
	    if (this.props.content && this.props.slices) {
	      return this.props.content.map(function (contentItem, index) {
	        if (contentItem && contentItem.slice_type && _this2.props.slices[contentItem.slice_type]) {
	          return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _this2.props.divider && _this2.props.divider,
	            _react2.default.createElement(_this2.props.slices[contentItem.slice_type], _extends({
	              key: "slice" + index
	            }, _this2.props.sliceProps, contentItem))
	          );
	        } else {
	          return null;
	        }
	      });
	    } else {
	      return null;
	    }
	  };
	
	  return SliceZone;
	}(_react2.default.Component);

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _SliceZone = __webpack_require__(256);
	
	Object.keys(_SliceZone).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SliceZone[key];
	    }
	  });
	});

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  max-width: 128px;\n  /* background-color: ", "; */\n  background-color: ", ";\n"], ["\n  display: inline-block;\n  max-width: 128px;\n  /* background-color: ", "; */\n  background-color: ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  font-size: 11px;\n  font-weight: 600;\n  color: ", ";\n  ", ";\n  line-height: 2;\n\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  font-size: 11px;\n  font-weight: 600;\n  color: ", ";\n  ", ";\n  line-height: 2;\n\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _polished = __webpack_require__(8);
	
	var _rebass = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Text = __webpack_require__(17);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.theme.colors.grey[1];
	}, function (props) {
	  return props.backgroundColor ? props.theme.colors[props.backgroundColor] : props.theme.colors.grey[1];
	});
	
	Wrapper.defaultProps = {
	  px: 2
	};
	
	var Content = (0, _styledComponents2.default)(_Text2.default)(_templateObject2, function (props) {
	  return props.color ? props.color : props.theme.colors.grey[0];
	}, (0, _polished.ellipsis)(), function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.violet;
	});
	
	var Tag = function Tag(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    { backgroundColor: props.backgroundColor },
	    _react2.default.createElement(Content, { children: props.children, color: props.color })
	  );
	};
	
	Tag.defaultProps = {
	  children: "Lorem ipsum dolor amet"
	};
	
	exports.default = Tag;
	module.exports = exports["default"];

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  flex-wrap: wrap;\n\n  > * {\n    margin-right: 2px;\n    margin-bottom: 2px;\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"], ["\n  flex-wrap: wrap;\n\n  > * {\n    margin-right: 2px;\n    margin-bottom: 2px;\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var TagList = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject);
	
	TagList.defaultProps = {};
	
	exports.default = TagList;
	module.exports = exports["default"];

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  background-color: ", ";\n  border-radius: 0;\n  border: 1px solid ", ";\n\n  /* Naked */\n  ", ";\n"], ["\n  position: relative;\n  width: 100%;\n  background-color: ", ";\n  border-radius: 0;\n  border: 1px solid ", ";\n\n  /* Naked */\n  ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n      background-color: transparent;\n      border-radius: 0;\n      border: none;\n    "], ["\n      background-color: transparent;\n      border-radius: 0;\n      border: none;\n    "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-width: none;\n  padding-top: 13px;\n  padding-right: 16px;\n  padding-bottom: 11px;\n  padding-left: ", "px;\n\n  font-weight: 400;\n  color: ", ";\n\n  background-color: transparent;\n  border: 0;\n\n  ", ";\n\n  /* Naked */\n  ", ";\n"], ["\n  width: 100%;\n  max-width: none;\n  padding-top: 13px;\n  padding-right: 16px;\n  padding-bottom: 11px;\n  padding-left: ", "px;\n\n  font-weight: 400;\n  color: ", ";\n\n  background-color: transparent;\n  border: 0;\n\n  ", ";\n\n  /* Naked */\n  ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n      padding-right: 0;\n      padding-left: ", "px;\n    "], ["\n      padding-right: 0;\n      padding-left: ", "px;\n    "]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(8);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var InnerWrapper = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return (0, _polished.rgba)(props.theme.colors.text, 1 / 5);
	}, function (props) {
	  return props.appearance === "naked" && css(_templateObject2);
	});
	
	var TextFieldComp = _styledComponents2.default.textarea(_templateObject3, function (props) {
	  return props.icon ? 40 : 16;
	}, function (props) {
	  return props.theme.colors.text;
	}, (0, _polished.placeholder)({ color: "rgba(0, 0, 0, 0.333)" }), function (props) {
	  return props.appearance === "naked" && css(_templateObject4, function (props) {
	    return props.icon ? 24 : 0;
	  });
	});
	
	var Textarea = function Textarea(props) {
	  return _react2.default.createElement(
	    "div",
	    null,
	    props.label && _react2.default.createElement(_components.H4, {
	      children: props.label,
	      is: "label",
	      "for": props.uid,
	      heading: 0,
	      mb: 1
	    }),
	    _react2.default.createElement(
	      InnerWrapper,
	      { maxWidth: props.maxWidth, appearance: props.appearance },
	      _react2.default.createElement(TextFieldComp, _extends({
	        id: props.uid,
	        appearance: props.appearance,
	        onChange: props.onChange
	      }, props))
	    )
	  );
	};
	
	exports.default = Textarea;
	module.exports = exports["default"];

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: block;\n  text-decoration: none;\n  opacity: 0;\n  animation: tiny-tile-fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n  will-change: opacity;\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n\n  @keyframes tiny-tile-fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  * {\n    text-decoration: none;\n\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n\n  &:not(:last-child) {\n    > * {\n      margin-bottom: 4px;\n    }\n  }\n  &:hover {\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n    transform: translateY(-2px);\n    .tiny-tile__corner-icon {\n      opacity: 0.5;\n      transform: translateY(0);\n    }\n  }\n"], ["\n  position: relative;\n  display: block;\n  text-decoration: none;\n  opacity: 0;\n  animation: tiny-tile-fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n  will-change: opacity;\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n\n  @keyframes tiny-tile-fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  * {\n    text-decoration: none;\n\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n\n  &:not(:last-child) {\n    > * {\n      margin-bottom: 4px;\n    }\n  }\n  &:hover {\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n    transform: translateY(-2px);\n    .tiny-tile__corner-icon {\n      opacity: 0.5;\n      transform: translateY(0);\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  background-color: ", ";\n  &:not(:lang(ar)) {\n    &:before,\n    &:after {\n      right: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n  &:lang(ar) {\n    &:before,\n    &:after {\n      left: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n    filter: grayscale(1);\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n\n    /* Fallback */\n    background-image: ", ";\n\n    /* Webkit fallback */\n    background-image: ", ";\n\n    /* Regular imageset */\n    background-image: ", ";\n\n    @media (min-width: 52em) {\n      /* Fallback */\n      background-image: ", ";\n\n      /* Webkit fallback */\n      background-image: ", ";\n\n      /* Regular imageset */\n      background-image: ", ";\n    }\n\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      background-image: ", ";\n    }\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n  }\n"], ["\n  position: relative;\n  background-color: ", ";\n  &:not(:lang(ar)) {\n    &:before,\n    &:after {\n      right: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n  &:lang(ar) {\n    &:before,\n    &:after {\n      left: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n    filter: grayscale(1);\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n\n    /* Fallback */\n    background-image: ", ";\n\n    /* Webkit fallback */\n    background-image: ", ";\n\n    /* Regular imageset */\n    background-image: ", ";\n\n    @media (min-width: 52em) {\n      /* Fallback */\n      background-image: ", ";\n\n      /* Webkit fallback */\n      background-image: ", ";\n\n      /* Regular imageset */\n      background-image: ", ";\n    }\n\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      background-image: ", ";\n    }\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n    max-width: 672px;\n    height: 100%;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 640px;\n"], ["\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 640px;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  z-index: 1;\n  width: 24px;\n  height: 24px;\n  background-color: ", ";\n  border-radius: 9999px;\n  opacity: 0;\n  transform: translateY(4px);\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n\n  svg {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    stroke: ", ";\n  }\n"], ["\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  z-index: 1;\n  width: 24px;\n  height: 24px;\n  background-color: ", ";\n  border-radius: 9999px;\n  opacity: 0;\n  transform: translateY(4px);\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n\n  svg {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    stroke: ", ";\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _polished = __webpack_require__(8);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(4);
	
	var _Text = __webpack_require__(17);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _H = __webpack_require__(41);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _H3 = __webpack_require__(137);
	
	var _H4 = _interopRequireDefault(_H3);
	
	var _Button = __webpack_require__(53);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _OverlayImage = __webpack_require__(42);
	
	var _OverlayImage2 = _interopRequireDefault(_OverlayImage);
	
	var _theme = __webpack_require__(13);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _invertTheme = __webpack_require__(12);
	
	var _invertTheme2 = _interopRequireDefault(_invertTheme);
	
	var _reactFeather = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Action = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.theme.colors[props.cardColor] && (0, _polished.shade)(0.9375, props.theme.colors[props.cardColor]);
	}, function (props) {
	  return props.theme.colors.grey[0];
	});
	
	Action.defaultProps = {
	  is: _gatsbyLink2.default,
	  to: "/"
	};
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2, function (props) {
	  return props.theme.colors[props.cardColor];
	}, function (props) {
	  return props.theme.colors[props.cardColor] && "linear-gradient(to right, " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 1) + ", " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.75) + ")";
	}, function (props) {
	  return props.theme.colors[props.cardColor] && "linear-gradient(to left, " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 1) + ", " + (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.75) + ")";
	}, function (props) {
	  return "url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ")";
	}, function (props) {
	  return "-webkit-image-set(url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x)";
	}, function (props) {
	  return "image-set(url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x)";
	}, function (props) {
	  return "url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ")";
	}, function (props) {
	  return "-webkit-image-set(url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x, url(" + (props.backgroundImage ? props.backgroundImage[0] : "") + ") 3x)";
	}, function (props) {
	  return "image-set(url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 1x, url(" + (props.backgroundImage ? props.backgroundImage[1] : "") + ") 2x, url(" + (props.backgroundImage ? props.backgroundImage[0] : "") + ") 3x)";
	}, function (props) {
	  return props.theme.colors[props.cardColor] && "linear-gradient(to bottom, " + (props.cardColor ? (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.66) : "") + ", " + (props.cardColor ? (0, _polished.rgba)(props.theme.colors[props.cardColor], 0.66) : "") + "), url(" + (props.backgroundImage ? props.backgroundImage[2] : "") + ")";
	});
	
	var Content = (0, _styledComponents2.default)(_rebass.Box)(_templateObject3);
	
	var CornerIcon = (0, _styledComponents2.default)(_rebass.Box)(_templateObject4, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors[props.cardColor];
	});
	
	var determineColor = function determineColor(region) {
	  var color = "violet";
	  if (region === "middle-east-and-north-africa" || region === "oriente-medio-y-norte-de-africa" || region === "الشرق-الاوسط-وشمات-افريقيا") {
	    color = "orange";
	  }
	  if (region === "africa" || region === "africa1" || region === "افريقيا") {
	    color = "green";
	  }
	  if (region === "latin-america" || region === "america-latina-y-el-caribe" || region === "امريكا-اللاتينية") {
	    color = "blue";
	  }
	  if (region === "asia" || region === "asia1" || region === "اسيا") {
	    color = "pink";
	  }
	  if (region === "europe--central-asia" || region === "europa-y-asia-central" || region === "اوروبا-واسيا-الوسطى") {
	    color = "yellow";
	  }
	  return color;
	};
	
	var TinyTile = function TinyTile(props) {
	  return _react2.default.createElement(
	    _styledComponents.ThemeProvider,
	    { theme: _invertTheme2.default },
	    _react2.default.createElement(
	      Action,
	      {
	        className: props.className,
	        style: props.style,
	        cardColor: props.cardColor,
	        to: props.to,
	        "aria-label": props.title
	      },
	      _react2.default.createElement(
	        CornerIcon,
	        {
	          className: "tiny-tile__corner-icon",
	          cardColor: props.cardColor
	        },
	        _react2.default.createElement(_reactFeather.ArrowRight, { size: 16, strokeWidth: 2, title: "Internal Link" })
	      ),
	      _react2.default.createElement(
	        Wrapper,
	        {
	          px: 4,
	          py: 4,
	          backgroundImage: props.image,
	          cardColor: props.cardColor
	        },
	        _react2.default.createElement(
	          Content,
	          null,
	          _react2.default.createElement(_H2.default, { children: props.type, mb: 2 }),
	          _react2.default.createElement(_Text2.default, { children: props.title, fontWeight: "600" })
	        )
	      )
	    )
	  );
	};
	
	TinyTile.defaultProps = {
	  title: "Region Name",
	  cardColor: "green"
	};
	
	exports.default = TinyTile;
	module.exports = exports["default"];

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  text-decoration: none;\n  cursor: pointer;\n  opacity: 0;\n  animation: update-card-fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n  will-change: opacity;\n\n  @keyframes update-card-fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  &:hover {\n    .update-card__tile {\n      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n      transform: translateY(-4px);\n    }\n    .update-card__title {\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n  }\n  &:active {\n    .update-card__tile {\n      box-shadow: none;\n      transform: translateY(-2px);\n    }\n    .update-card__title {\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n  }\n\n  * {\n    text-decoration: none;\n\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"], ["\n  text-decoration: none;\n  cursor: pointer;\n  opacity: 0;\n  animation: update-card-fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;\n  will-change: opacity;\n\n  @keyframes update-card-fade-in {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  &:hover {\n    .update-card__tile {\n      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n      transform: translateY(-4px);\n    }\n    .update-card__title {\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n  }\n  &:active {\n    .update-card__tile {\n      box-shadow: none;\n      transform: translateY(-2px);\n    }\n    .update-card__title {\n      box-shadow: inset 0 -1px 0 ", ";\n    }\n  }\n\n  * {\n    text-decoration: none;\n\n    &::selection {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  padding-bottom: ", ";\n  /* background-color: ", ";\n  background-color: ", "; */\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: transform;\n  user-select: none;\n  &:not(:lang(ar)) {\n    &:before,\n    &:after {\n      right: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n  &:lang(ar) {\n    &:before,\n    &:after {\n      left: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n"], ["\n  position: relative;\n  width: 100%;\n  padding-bottom: ", ";\n  /* background-color: ", ";\n  background-color: ", "; */\n  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1),\n    box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n  will-change: transform;\n  user-select: none;\n  &:not(:lang(ar)) {\n    &:before,\n    &:after {\n      right: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n  &:lang(ar) {\n    &:before,\n    &:after {\n      left: 0;\n    }\n    &:after {\n      background: ", ";\n    }\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  margin-top: 8px;\n  padding-bottom: 8px;\n  font-size: 18px;\n\n  > span {\n    box-shadow: inset 0 -1px 0 transparent;\n    transition: box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: box-shadow;\n  }\n"], ["\n  margin-top: 8px;\n  padding-bottom: 8px;\n  font-size: 18px;\n\n  > span {\n    box-shadow: inset 0 -1px 0 transparent;\n    transition: box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);\n    will-change: box-shadow;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n"], ["\n  flex: 1;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose([""], [""]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(8);
	
	var _theme = __webpack_require__(13);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _invertTheme = __webpack_require__(12);
	
	var _invertTheme2 = _interopRequireDefault(_invertTheme);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _moment = __webpack_require__(23);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Action = (0, _styledComponents2.default)(_rebass.Box)(_templateObject, function (props) {
	  return props.theme.colors.grey[0];
	}, function (props) {
	  return props.theme.colors.grey[1];
	}, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors[props.cardColor] && (0, _polished.shade)(0.9375, props.theme.colors[props.cardColor]);
	});
	
	Action.defaultProps = {
	  is: _gatsbyLink2.default
	};
	
	var ImageWrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2, 2 / 3 * 100 + "%", function (props) {
	  return props.theme.colors[props.cardColor];
	}, function (props) {
	  return props.theme.colors.grey[1];
	}, function (props) {
	  return props.noColor ? "" : props.theme.colors.grey[1] && "linear-gradient(to right, " + (0, _polished.rgba)(props.theme.colors.grey[1], 0.75) + ", " + (0, _polished.rgba)(props.theme.colors.grey[1], 0) + ")";
	}, function (props) {
	  return props.noColor ? "" : props.theme.colors.grey[1] && "linear-gradient(to left, " + (0, _polished.rgba)(props.theme.colors.grey[1], 0.75) + ", " + (0, _polished.rgba)(props.theme.colors.grey[1], 0) + ")";
	});
	
	var Title = (0, _styledComponents2.default)(_components.H3)(_templateObject3);
	
	var Layout = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject4);
	
	var Metadata = (0, _styledComponents2.default)(_components.H4)(_templateObject5);
	
	var determineColor = function determineColor(region) {
	  var color = "violet";
	  if (region === "update" || region === "institution" || region === null || region === undefined) {
	    color = "ash";
	  }
	  if (region === "middle-east-and-north-africa") {
	    color = "orange";
	  }
	  if (region === "africa") {
	    color = "green";
	  }
	  if (region === "latin-america") {
	    color = "blue";
	  }
	  if (region === "asia") {
	    color = "pink";
	  }
	  if (region === "europe--central-asia") {
	    color = "yellow";
	  }
	  return color;
	};
	
	var determineLabel = function determineLabel(region) {
	  var label = "BIC";
	  if (region === "middle-east-and-north-africa") {
	    label = "Middle East and North Africa";
	  }
	  if (region === "oriente-medio-y-norte-de-africa") {
	    label = "Oriente Medio y Norte de África";
	  }
	  if (region === "الشرق-الاوسط-وشمات-افريقيا") {
	    label = "الشرق الأوسط وشمات أفريقيا";
	  }
	  if (region === "africa") {
	    label = "Africa";
	  }
	  if (region === "africa1") {
	    label = "África";
	  }
	  if (region === "افريقيا") {
	    label = "أفريقيا";
	  }
	  if (region === "latin-america") {
	    label = "Latin America";
	  }
	  if (region === "america-latina-y-el-caribe") {
	    label = "América Latina y el Caribe";
	  }
	  if (region === "امريكا-اللاتينية") {
	    label = "أمريكا  اللاتينية";
	  }
	  if (region === "asia") {
	    label = "Asia";
	  }
	  if (region === "asia1") {
	    label = "Asia";
	  }
	  if (region === "اسيا") {
	    label = "آسيا";
	  }
	  if (region === "europe--central-asia") {
	    label = "Europe & Central Asia";
	  }
	  if (region === "europa-y-asia-central") {
	    label = "Europa y Asia Central";
	  }
	  if (region === "اوروبا-واسيا-الوسطى") {
	    label = "أوروبا وآسيا الوسطى";
	  }
	  return label;
	};
	
	var truncateText = function truncateText(text) {
	  if (text.length > 65) {
	    var textArray = text.split(" ");
	    var textBuildup = "";
	    var position = 0;
	    while (textBuildup.length < 65) {
	      textBuildup += textArray[position] + " ";
	      position++;
	    }
	    if (textBuildup[textBuildup.length - 2] !== "?" && textBuildup[textBuildup.length - 2] !== "!" && textBuildup[textBuildup.length - 2] !== ".") {
	      text = textBuildup.slice(0, textBuildup.length - 1) + "...";
	    }
	  }
	  return text;
	};
	
	var UpdateCard = function UpdateCard(props) {
	  if (props.object) {
	    var _React$createElement;
	
	    return _react2.default.createElement(
	      _styledComponents.ThemeProvider,
	      { theme: _theme2.default },
	      _react2.default.createElement(
	        Action,
	        {
	          to: "/" + props.object.lang + "/update/" + props.object.uid,
	          cardColor: determineColor(props.object.data.region ? props.object.data.region.uid : "violet"),
	          "aria-label": props.object.data.title[0] ? props.object.data.title[0].text : ""
	          // onClick={() => {
	          //   document.body.style.background =
	          //     theme.colors[determineColor(props.object.data.region.uid)];
	          // }}
	        },
	        _react2.default.createElement(
	          ImageWrapper,
	          {
	            className: "update-card__tile",
	            cardColor: determineColor(props.object.data.region ? props.object.data.region.uid : "violet")
	          },
	          _react2.default.createElement(_components.OverlayImage, (_React$createElement = {
	            imageColor: determineColor(props.object.data.region ? props.object.data.region.uid : "violet")
	          }, _React$createElement["imageColor"] = "grey.2", _React$createElement.backgroundImage = props.object.data.header_image ? [props.object.data.header_image.url, props.object.data.header_image.half ? props.object.data.header_image.half.url : "", props.object.data.header_image.quarter ? props.object.data.header_image.quarter.url : ""] : undefined, _React$createElement))
	        ),
	        _react2.default.createElement(
	          Title,
	          null,
	          _react2.default.createElement("span", {
	            className: "update-card__title",
	            children: props.object.data.title[0] ? truncateText(props.object.data.title[0].text) : ""
	          })
	        ),
	        _react2.default.createElement(
	          _rebass.Flex,
	          null,
	          _react2.default.createElement(
	            Metadata,
	            { mt: "3px", mr: 3 },
	            props.object.data.publish_date ? (0, _moment2.default)(props.object.data.publish_date).format("MMMM DD, YYYY") : ""
	          ),
	          _react2.default.createElement(
	            Layout,
	            null,
	            _react2.default.createElement(
	              _components.TagList,
	              null,
	              props.object.data.region && _react2.default.createElement(_components.Tag, {
	                children: determineLabel(props.object.data.region ? props.object.data.region.uid : "violet"),
	                backgroundColor: determineColor(props.object.data.region ? props.object.data.region.uid : "violet"),
	                color: "white"
	              }),
	              props.object.data.institution && _react2.default.createElement(
	                _rebass.Box,
	                null,
	                props.institutions.map(function (institution, index) {
	                  if (institution.node.uid === props.object.data.institution.uid) {
	                    return _react2.default.createElement(_components.Tag, {
	                      children: institution.node.data.title[0].text,
	                      key: "institutionTag" + props.object.uid
	                    });
	                  } else {
	                    return null;
	                  }
	                })
	              ),
	              props.object.data.campaign && _react2.default.createElement(
	                _rebass.Box,
	                null,
	                props.campaigns.map(function (campaign, index) {
	                  if (campaign.node.uid === props.object.data.campaign.uid) {
	                    return _react2.default.createElement(_components.Tag, {
	                      children: campaign.node.data.title[0].text,
	                      key: "campaignTag" + props.object.uid
	                    });
	                  } else {
	                    return null;
	                  }
	                })
	              )
	            )
	          )
	        )
	      )
	    );
	  } else {
	    return null;
	  }
	};
	
	UpdateCard.defaultProps = {
	  to: "/"
	};
	
	exports.default = UpdateCard;
	module.exports = exports["default"];

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose([""], [""]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  padding-top: 24px;\n  border-top: 1px solid\n    ", ";\n  > * {\n    margin-top: 16px;\n    &:last-child {\n      margin-top: 0;\n    }\n  }\n"], ["\n  padding-top: 24px;\n  border-top: 1px solid\n    ", ";\n  > * {\n    margin-top: 16px;\n    &:last-child {\n      margin-top: 0;\n    }\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  font-weight: 600;\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  font-weight: 600;\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  font-weight: 500;\n  font-size: 12px;\n  opacity: 0.66;\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  font-weight: 500;\n  font-size: 12px;\n  opacity: 0.66;\n  &::selection {\n    color: ", ";\n    background-color: ", ";\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _polished = __webpack_require__(8);
	
	var _rebass = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Text = __webpack_require__(17);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _H = __webpack_require__(41);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _StaffProfile = __webpack_require__(144);
	
	var _StaffProfile2 = _interopRequireDefault(_StaffProfile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_rebass.Box)(_templateObject);
	
	Wrapper.defaultProps = {
	  px: 4,
	  py: 5,
	  bg: "grey.1"
	};
	
	var StaffBox = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2, function (props) {
	  return props.theme.colors.grey[1] && (0, _polished.shade)(0.875, props.theme.colors.grey[1]);
	});
	
	var Date = (0, _styledComponents2.default)(_Text2.default)(_templateObject3, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.violet;
	});
	
	var SubDate = (0, _styledComponents2.default)(_Text2.default)(_templateObject4, function (props) {
	  return props.theme.colors.grey[2];
	}, function (props) {
	  return props.theme.colors.violet;
	});
	
	var UpdateMeta = function UpdateMeta(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    props.publishDate && _react2.default.createElement(
	      _rebass.Box,
	      { mb: 1 },
	      _react2.default.createElement(Date, { children: props.publishDate })
	    ),
	    props.updateDate && _react2.default.createElement(
	      _rebass.Box,
	      { mb: 4 },
	      _react2.default.createElement(SubDate, { children: props.updateText + ": " + props.updateDate })
	    ),
	    _react2.default.createElement(
	      StaffBox,
	      null,
	      _react2.default.createElement(_StaffProfile2.default, {
	        attributionText: props.attributionText,
	        image: props.staffImage,
	        name: props.staffName,
	        to: props.to
	      }),
	      props.secondaryTo && props.secondaryStaffImage && props.secondaryStaffName && _react2.default.createElement(
	        _rebass.Box,
	        { pt: 2 },
	        _react2.default.createElement(_StaffProfile2.default, {
	          attributionText: props.attributionText,
	          image: props.secondaryStaffImage,
	          name: props.secondaryStaffName,
	          to: props.secondaryTo
	        })
	      )
	    )
	  );
	};
	
	UpdateMeta.defaultProps = {
	  staffImage: "https://sidewalklabs.com/assets/uploads/2016/10/eric-jaffe-e1515012031659.png",
	  staffName: "Jane Doe"
	};
	
	exports.default = UpdateMeta;
	module.exports = exports["default"];

/***/ }),
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(316), __esModule: true };

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(317), __esModule: true };

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(318), __esModule: true };

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(319), __esModule: true };

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(320), __esModule: true };

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(321), __esModule: true };

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(322), __esModule: true };

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(307);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(379);
	__webpack_require__(381);
	__webpack_require__(384);
	__webpack_require__(380);
	__webpack_require__(382);
	__webpack_require__(383);
	module.exports = __webpack_require__(34).Promise;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(22);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(342);
	module.exports = __webpack_require__(22).Object.assign;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(343);
	var $Object = __webpack_require__(22).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(344);
	module.exports = __webpack_require__(22).Object.keys;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(345);
	module.exports = __webpack_require__(22).Object.setPrototypeOf;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(348);
	__webpack_require__(346);
	__webpack_require__(349);
	__webpack_require__(350);
	module.exports = __webpack_require__(22).Symbol;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(347);
	__webpack_require__(351);
	module.exports = __webpack_require__(98).f('iterator');


/***/ }),
/* 323 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 324 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(48);
	var toLength = __webpack_require__(340);
	var toAbsoluteIndex = __webpack_require__(339);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(56);
	var gOPS = __webpack_require__(91);
	var pIE = __webpack_require__(67);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(26).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(146);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(90);
	var descriptor = __webpack_require__(68);
	var setToStringTag = __webpack_require__(92);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(45)(IteratorPrototype, __webpack_require__(49)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 330 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(70)('meta');
	var isObject = __webpack_require__(46);
	var has = __webpack_require__(32);
	var setDesc = __webpack_require__(47).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(44)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(31);
	var getKeys = __webpack_require__(56);
	var gOPS = __webpack_require__(91);
	var pIE = __webpack_require__(67);
	var toObject = __webpack_require__(69);
	var IObject = __webpack_require__(150);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(44)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(47);
	var anObject = __webpack_require__(55);
	var getKeys = __webpack_require__(56);
	
	module.exports = __webpack_require__(31) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(48);
	var gOPN = __webpack_require__(153).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(32);
	var toObject = __webpack_require__(69);
	var IE_PROTO = __webpack_require__(93)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(43);
	var core = __webpack_require__(22);
	var fails = __webpack_require__(44);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(46);
	var anObject = __webpack_require__(55);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(147)(Function.call, __webpack_require__(152).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(95);
	var defined = __webpack_require__(87);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(95);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(95);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(324);
	var step = __webpack_require__(330);
	var Iterators = __webpack_require__(89);
	var toIObject = __webpack_require__(48);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(151)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(43);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(332) });


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(43);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(90) });


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(69);
	var $keys = __webpack_require__(56);
	
	__webpack_require__(336)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(43);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(337).set });


/***/ }),
/* 346 */
/***/ (function(module, exports) {



/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(338)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(151)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(26);
	var has = __webpack_require__(32);
	var DESCRIPTORS = __webpack_require__(31);
	var $export = __webpack_require__(43);
	var redefine = __webpack_require__(155);
	var META = __webpack_require__(331).KEY;
	var $fails = __webpack_require__(44);
	var shared = __webpack_require__(94);
	var setToStringTag = __webpack_require__(92);
	var uid = __webpack_require__(70);
	var wks = __webpack_require__(49);
	var wksExt = __webpack_require__(98);
	var wksDefine = __webpack_require__(97);
	var enumKeys = __webpack_require__(326);
	var isArray = __webpack_require__(328);
	var anObject = __webpack_require__(55);
	var isObject = __webpack_require__(46);
	var toObject = __webpack_require__(69);
	var toIObject = __webpack_require__(48);
	var toPrimitive = __webpack_require__(96);
	var createDesc = __webpack_require__(68);
	var _create = __webpack_require__(90);
	var gOPNExt = __webpack_require__(334);
	var $GOPD = __webpack_require__(152);
	var $GOPS = __webpack_require__(91);
	var $DP = __webpack_require__(47);
	var $keys = __webpack_require__(56);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(153).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(67).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(66)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(45)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('asyncIterator');


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(97)('observable');


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(341);
	var global = __webpack_require__(26);
	var hide = __webpack_require__(45);
	var Iterators = __webpack_require__(89);
	var TO_STRING_TAG = __webpack_require__(49)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(19)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(50)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 353 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(108);
	var toLength = __webpack_require__(166);
	var toAbsoluteIndex = __webpack_require__(373);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(73);
	var call = __webpack_require__(361);
	var isArrayIter = __webpack_require__(360);
	var anObject = __webpack_require__(33);
	var toLength = __webpack_require__(166);
	var getIterFn = __webpack_require__(377);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(106)('native-function-to-string', Function.toString);


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(57) && !__webpack_require__(157)(function () {
	  return Object.defineProperty(__webpack_require__(101)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 358 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(72);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(59);
	var ITERATOR = __webpack_require__(19)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(33);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(366);
	var descriptor = __webpack_require__(163);
	var setToStringTag = __webpack_require__(104);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(50)(IteratorPrototype, __webpack_require__(19)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(19)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 364 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var macrotask = __webpack_require__(165).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(72)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(33);
	var dPs = __webpack_require__(367);
	var enumBugKeys = __webpack_require__(156);
	var IE_PROTO = __webpack_require__(105)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(101)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(158).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(76);
	var anObject = __webpack_require__(33);
	var getKeys = __webpack_require__(160);
	
	module.exports = __webpack_require__(57) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(75);
	var toObject = __webpack_require__(374);
	var IE_PROTO = __webpack_require__(105)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(75);
	var toIObject = __webpack_require__(108);
	var arrayIndexOf = __webpack_require__(354)(false);
	var IE_PROTO = __webpack_require__(105)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(60);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(18);
	var dP = __webpack_require__(76);
	var DESCRIPTORS = __webpack_require__(57);
	var SPECIES = __webpack_require__(19)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(107);
	var defined = __webpack_require__(100);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(107);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(100);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(58);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(99);
	var ITERATOR = __webpack_require__(19)('iterator');
	var Iterators = __webpack_require__(59);
	module.exports = __webpack_require__(34).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(352);
	var step = __webpack_require__(364);
	var Iterators = __webpack_require__(59);
	var toIObject = __webpack_require__(108);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(159)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(99);
	var test = {};
	test[__webpack_require__(19)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(60)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(102);
	var global = __webpack_require__(18);
	var ctx = __webpack_require__(73);
	var classof = __webpack_require__(99);
	var $export = __webpack_require__(74);
	var isObject = __webpack_require__(58);
	var aFunction = __webpack_require__(71);
	var anInstance = __webpack_require__(353);
	var forOf = __webpack_require__(355);
	var speciesConstructor = __webpack_require__(164);
	var task = __webpack_require__(165).set;
	var microtask = __webpack_require__(365)();
	var newPromiseCapabilityModule = __webpack_require__(103);
	var perform = __webpack_require__(161);
	var userAgent = __webpack_require__(376);
	var promiseResolve = __webpack_require__(162);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(19)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(370)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(104)($Promise, PROMISE);
	__webpack_require__(371)(PROMISE);
	Wrapper = __webpack_require__(34)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(363)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(372)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(159)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(74);
	var core = __webpack_require__(34);
	var global = __webpack_require__(18);
	var speciesConstructor = __webpack_require__(164);
	var promiseResolve = __webpack_require__(162);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(74);
	var newPromiseCapability = __webpack_require__(103);
	var perform = __webpack_require__(161);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(378);
	var getKeys = __webpack_require__(160);
	var redefine = __webpack_require__(60);
	var global = __webpack_require__(18);
	var hide = __webpack_require__(50);
	var Iterators = __webpack_require__(59);
	var wks = __webpack_require__(19);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 385 */
/***/ (function(module, exports) {

	(function(self) {
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob();
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  };
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ];
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    };
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    };
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift();
	        return {done: value === undefined, value: value}
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      };
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1]);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var oldValue = this.map[name];
	    this.map[name] = oldValue ? oldValue+','+value : value;
	  };
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name);
	    return this.has(name) ? this.map[name] : null
	  };
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  };
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value);
	  };
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this);
	      }
	    }
	  };
	
	  Headers.prototype.keys = function() {
	    var items = [];
	    this.forEach(function(value, name) { items.push(name); });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.values = function() {
	    var items = [];
	    this.forEach(function(value) { items.push(value); });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.entries = function() {
	    var items = [];
	    this.forEach(function(value, name) { items.push([name, value]); });
	    return iteratorFor(items)
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result);
	      };
	      reader.onerror = function() {
	        reject(reader.error);
	      };
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsArrayBuffer(blob);
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsText(blob);
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf);
	    var chars = new Array(view.length);
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i]);
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength);
	      view.set(new Uint8Array(buf));
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function(body) {
	      this._bodyInit = body;
	      if (!body) {
	        this._bodyText = '';
	      } else if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer);
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer]);
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body);
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      };
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      };
	    }
	
	    this.text = function() {
	      var rejected = consumed(this);
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    };
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      };
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    };
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {};
	    var body = options.body;
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = String(input);
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body);
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=');
	        var name = split.shift().replace(/\+/g, ' ');
	        var value = split.join('=').replace(/\+/g, ' ');
	        form.append(decodeURIComponent(name), decodeURIComponent(value));
	      }
	    });
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers();
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':');
	      var key = parts.shift().trim();
	      if (key) {
	        var value = parts.join(':').trim();
	        headers.append(key, value);
	      }
	    });
	    return headers
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = options.status === undefined ? 200 : options.status;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = 'statusText' in options ? options.statusText : 'OK';
	    this.headers = new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  };
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''});
	    response.type = 'error';
	    return response
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  };
	
	  self.Headers = Headers;
	  self.Request = Request;
	  self.Response = Response;
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init);
	      var xhr = new XMLHttpRequest();
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        };
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options));
	      };
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.open(request.method, request.url, true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false;
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob';
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value);
	      });
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    })
	  };
	  self.fetch.polyfill = true;
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(1691);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(388));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 388 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(110));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(110));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(167));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(167));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(110));
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	/* https://github.com/component/raf */
	
	
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	
	var _default = compatRaf;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 395 */,
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   v4.2.8+1e68dce6
	 */
	
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ES6Promise = factory());
	}(this, (function () { 'use strict';
	
	function objectOrFunction(x) {
	  var type = typeof x;
	  return x !== null && (type === 'object' || type === 'function');
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	
	
	var _isArray = void 0;
	if (Array.isArray) {
	  _isArray = Array.isArray;
	} else {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	}
	
	var isArray = _isArray;
	
	var len = 0;
	var vertxNext = void 0;
	var customSchedulerFn = void 0;
	
	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};
	
	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}
	
	function setAsap(asapFn) {
	  asap = asapFn;
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  if (typeof vertxNext !== 'undefined') {
	    return function () {
	      vertxNext(flush);
	    };
	  }
	
	  return useSetTimeout();
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}
	
	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];
	
	    callback(arg);
	
	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertx() {
	  try {
	    var vertx = Function('return this')().require('vertx');
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush = void 0;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}
	
	function then(onFulfillment, onRejection) {
	  var parent = this;
	
	  var child = new this.constructor(noop);
	
	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }
	
	  var _state = parent._state;
	
	
	  if (_state) {
	    var callback = arguments[_state - 1];
	    asap(function () {
	      return invokeCallback(_state, child, callback, parent._result);
	    });
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }
	
	  return child;
	}
	
	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve$1(object) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop);
	  resolve(promise, object);
	  return promise;
	}
	
	var PROMISE_ID = Math.random().toString(36).substring(2);
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}
	
	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then$$1.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then$$1) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then$$1, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return resolve(promise, value);
	    }, function (reason) {
	      return reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$1) {
	  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$1 === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$1)) {
	      handleForeignThenable(promise, maybeThenable, then$$1);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}
	
	function resolve(promise, value) {
	  if (promise === value) {
	    reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    var then$$1 = void 0;
	    try {
	      then$$1 = value.then;
	    } catch (error) {
	      reject(promise, error);
	      return;
	    }
	    handleMaybeThenable(promise, value, then$$1);
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}
	
	function reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	
	  asap(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;
	
	
	  parent._onerror = null;
	
	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = void 0,
	      callback = void 0,
	      detail = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = void 0,
	      error = void 0,
	      succeeded = true;
	
	  if (hasCallback) {
	    try {
	      value = callback(detail);
	    } catch (e) {
	      succeeded = false;
	      error = e;
	    }
	
	    if (promise === value) {
	      reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	    resolve(promise, value);
	  } else if (succeeded === false) {
	    reject(promise, error);
	  } else if (settled === FULFILLED) {
	    fulfill(promise, value);
	  } else if (settled === REJECTED) {
	    reject(promise, value);
	  }
	}
	
	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      resolve(promise, value);
	    }, function rejectPromise(reason) {
	      reject(promise, reason);
	    });
	  } catch (e) {
	    reject(promise, e);
	  }
	}
	
	var id = 0;
	function nextId() {
	  return id++;
	}
	
	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}
	
	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	}
	
	var Enumerator = function () {
	  function Enumerator(Constructor, input) {
	    this._instanceConstructor = Constructor;
	    this.promise = new Constructor(noop);
	
	    if (!this.promise[PROMISE_ID]) {
	      makePromise(this.promise);
	    }
	
	    if (isArray(input)) {
	      this.length = input.length;
	      this._remaining = input.length;
	
	      this._result = new Array(this.length);
	
	      if (this.length === 0) {
	        fulfill(this.promise, this._result);
	      } else {
	        this.length = this.length || 0;
	        this._enumerate(input);
	        if (this._remaining === 0) {
	          fulfill(this.promise, this._result);
	        }
	      }
	    } else {
	      reject(this.promise, validationError());
	    }
	  }
	
	  Enumerator.prototype._enumerate = function _enumerate(input) {
	    for (var i = 0; this._state === PENDING && i < input.length; i++) {
	      this._eachEntry(input[i], i);
	    }
	  };
	
	  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
	    var c = this._instanceConstructor;
	    var resolve$$1 = c.resolve;
	
	
	    if (resolve$$1 === resolve$1) {
	      var _then = void 0;
	      var error = void 0;
	      var didError = false;
	      try {
	        _then = entry.then;
	      } catch (e) {
	        didError = true;
	        error = e;
	      }
	
	      if (_then === then && entry._state !== PENDING) {
	        this._settledAt(entry._state, i, entry._result);
	      } else if (typeof _then !== 'function') {
	        this._remaining--;
	        this._result[i] = entry;
	      } else if (c === Promise$1) {
	        var promise = new c(noop);
	        if (didError) {
	          reject(promise, error);
	        } else {
	          handleMaybeThenable(promise, entry, _then);
	        }
	        this._willSettleAt(promise, i);
	      } else {
	        this._willSettleAt(new c(function (resolve$$1) {
	          return resolve$$1(entry);
	        }), i);
	      }
	    } else {
	      this._willSettleAt(resolve$$1(entry), i);
	    }
	  };
	
	  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
	    var promise = this.promise;
	
	
	    if (promise._state === PENDING) {
	      this._remaining--;
	
	      if (state === REJECTED) {
	        reject(promise, value);
	      } else {
	        this._result[i] = value;
	      }
	    }
	
	    if (this._remaining === 0) {
	      fulfill(promise, this._result);
	    }
	  };
	
	  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
	    var enumerator = this;
	
	    subscribe(promise, undefined, function (value) {
	      return enumerator._settledAt(FULFILLED, i, value);
	    }, function (reason) {
	      return enumerator._settledAt(REJECTED, i, reason);
	    });
	  };
	
	  return Enumerator;
	}();
	
	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all(entries) {
	  return new Enumerator(this, entries).promise;
	}
	
	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}
	
	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject$1(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  reject(promise, reason);
	  return promise;
	}
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {Function} resolver
	  Useful for tooling.
	  @constructor
	*/
	
	var Promise$1 = function () {
	  function Promise(resolver) {
	    this[PROMISE_ID] = nextId();
	    this._result = this._state = undefined;
	    this._subscribers = [];
	
	    if (noop !== resolver) {
	      typeof resolver !== 'function' && needsResolver();
	      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	    }
	  }
	
	  /**
	  The primary way of interacting with a promise is through its `then` method,
	  which registers callbacks to receive either a promise's eventual value or the
	  reason why the promise cannot be fulfilled.
	   ```js
	  findUser().then(function(user){
	    // user is available
	  }, function(reason){
	    // user is unavailable, and you are given the reason why
	  });
	  ```
	   Chaining
	  --------
	   The return value of `then` is itself a promise.  This second, 'downstream'
	  promise is resolved with the return value of the first promise's fulfillment
	  or rejection handler, or rejected if the handler throws an exception.
	   ```js
	  findUser().then(function (user) {
	    return user.name;
	  }, function (reason) {
	    return 'default name';
	  }).then(function (userName) {
	    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	    // will be `'default name'`
	  });
	   findUser().then(function (user) {
	    throw new Error('Found user, but still unhappy');
	  }, function (reason) {
	    throw new Error('`findUser` rejected and we're unhappy');
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	  });
	  ```
	  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	   ```js
	  findUser().then(function (user) {
	    throw new PedagogicalException('Upstream error');
	  }).then(function (value) {
	    // never reached
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // The `PedgagocialException` is propagated all the way down to here
	  });
	  ```
	   Assimilation
	  ------------
	   Sometimes the value you want to propagate to a downstream promise can only be
	  retrieved asynchronously. This can be achieved by returning a promise in the
	  fulfillment or rejection handler. The downstream promise will then be pending
	  until the returned promise is settled. This is called *assimilation*.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // The user's comments are now available
	  });
	  ```
	   If the assimliated promise rejects, then the downstream promise will also reject.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // If `findCommentsByAuthor` fulfills, we'll have the value here
	  }, function (reason) {
	    // If `findCommentsByAuthor` rejects, we'll have the reason here
	  });
	  ```
	   Simple Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let result;
	   try {
	    result = findResult();
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	  findResult(function(result, err){
	    if (err) {
	      // failure
	    } else {
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findResult().then(function(result){
	    // success
	  }, function(reason){
	    // failure
	  });
	  ```
	   Advanced Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let author, books;
	   try {
	    author = findAuthor();
	    books  = findBooksByAuthor(author);
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	   function foundBooks(books) {
	   }
	   function failure(reason) {
	   }
	   findAuthor(function(author, err){
	    if (err) {
	      failure(err);
	      // failure
	    } else {
	      try {
	        findBoooksByAuthor(author, function(books, err) {
	          if (err) {
	            failure(err);
	          } else {
	            try {
	              foundBooks(books);
	            } catch(reason) {
	              failure(reason);
	            }
	          }
	        });
	      } catch(error) {
	        failure(err);
	      }
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findAuthor().
	    then(findBooksByAuthor).
	    then(function(books){
	      // found books
	  }).catch(function(reason){
	    // something went wrong
	  });
	  ```
	   @method then
	  @param {Function} onFulfilled
	  @param {Function} onRejected
	  Useful for tooling.
	  @return {Promise}
	  */
	
	  /**
	  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	  as the catch block of a try/catch statement.
	  ```js
	  function findAuthor(){
	  throw new Error('couldn't find that author');
	  }
	  // synchronous
	  try {
	  findAuthor();
	  } catch(reason) {
	  // something went wrong
	  }
	  // async with promises
	  findAuthor().catch(function(reason){
	  // something went wrong
	  });
	  ```
	  @method catch
	  @param {Function} onRejection
	  Useful for tooling.
	  @return {Promise}
	  */
	
	
	  Promise.prototype.catch = function _catch(onRejection) {
	    return this.then(null, onRejection);
	  };
	
	  /**
	    `finally` will be invoked regardless of the promise's fate just as native
	    try/catch/finally behaves
	  
	    Synchronous example:
	  
	    ```js
	    findAuthor() {
	      if (Math.random() > 0.5) {
	        throw new Error();
	      }
	      return new Author();
	    }
	  
	    try {
	      return findAuthor(); // succeed or fail
	    } catch(error) {
	      return findOtherAuther();
	    } finally {
	      // always runs
	      // doesn't affect the return value
	    }
	    ```
	  
	    Asynchronous example:
	  
	    ```js
	    findAuthor().catch(function(reason){
	      return findOtherAuther();
	    }).finally(function(){
	      // author was either found, or not
	    });
	    ```
	  
	    @method finally
	    @param {Function} callback
	    @return {Promise}
	  */
	
	
	  Promise.prototype.finally = function _finally(callback) {
	    var promise = this;
	    var constructor = promise.constructor;
	
	    if (isFunction(callback)) {
	      return promise.then(function (value) {
	        return constructor.resolve(callback()).then(function () {
	          return value;
	        });
	      }, function (reason) {
	        return constructor.resolve(callback()).then(function () {
	          throw reason;
	        });
	      });
	    }
	
	    return promise.then(callback, callback);
	  };
	
	  return Promise;
	}();
	
	Promise$1.prototype.then = then;
	Promise$1.all = all;
	Promise$1.race = race;
	Promise$1.resolve = resolve$1;
	Promise$1.reject = reject$1;
	Promise$1._setScheduler = setScheduler;
	Promise$1._setAsap = setAsap;
	Promise$1._asap = asap;
	
	/*global self*/
	function polyfill() {
	  var local = void 0;
	
	  if (typeof global !== 'undefined') {
	    local = global;
	  } else if (typeof self !== 'undefined') {
	    local = self;
	  } else {
	    try {
	      local = Function('return this')();
	    } catch (e) {
	      throw new Error('polyfill failed because global object is unavailable in this environment');
	    }
	  }
	
	  var P = local.Promise;
	
	  if (P) {
	    var promiseToString = null;
	    try {
	      promiseToString = Object.prototype.toString.call(P.resolve());
	    } catch (e) {
	      // silently ignored
	    }
	
	    if (promiseToString === '[object Promise]' && !P.cast) {
	      return;
	    }
	  }
	
	  local.Promise = Promise$1;
	}
	
	// Strange compat..
	Promise$1.polyfill = polyfill;
	Promise$1.Promise = Promise$1;
	
	return Promise$1;
	
	})));
	
	
	
	//# sourceMappingURL=es6-promise.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78), (function() { return this; }())))

/***/ }),
/* 397 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(2),n=__webpack_require__(112),r=__webpack_require__(2106);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
	function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
	function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
	function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
	function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
	Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
	C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
	function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
	60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
	var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
	null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
	break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
	jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
	function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
	10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
	Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(112),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(65);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(86);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(85);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(79);
	
	var _scrollBehavior = __webpack_require__(2107);
	
	var _scrollBehavior2 = _interopRequireDefault(_scrollBehavior);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StateStorage = __webpack_require__(1052);
	
	var _StateStorage2 = _interopRequireDefault(_StateStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  shouldUpdateScroll: _propTypes2.default.func,
	  children: _propTypes2.default.element.isRequired,
	  location: _propTypes2.default.object.isRequired,
	  history: _propTypes2.default.object.isRequired
	};
	
	var childContextTypes = {
	  scrollBehavior: _propTypes2.default.object.isRequired
	};
	
	var ScrollContext = function (_React$Component) {
	  (0, _inherits3.default)(ScrollContext, _React$Component);
	
	  function ScrollContext(props, context) {
	    (0, _classCallCheck3.default)(this, ScrollContext);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	      var shouldUpdateScroll = _this.props.shouldUpdateScroll;
	
	      if (!shouldUpdateScroll) {
	        return true;
	      }
	
	      // Hack to allow accessing scrollBehavior._stateStorage.
	      return shouldUpdateScroll.call(_this.scrollBehavior, prevRouterProps, routerProps);
	    };
	
	    _this.registerElement = function (key, element, shouldUpdateScroll) {
	      _this.scrollBehavior.registerElement(key, element, shouldUpdateScroll, _this.getRouterProps());
	    };
	
	    _this.unregisterElement = function (key) {
	      _this.scrollBehavior.unregisterElement(key);
	    };
	
	    var history = props.history;
	
	
	    _this.scrollBehavior = new _scrollBehavior2.default({
	      addTransitionHook: history.listen,
	      stateStorage: new _StateStorage2.default(),
	      getCurrentLocation: function getCurrentLocation() {
	        return _this.props.location;
	      },
	      shouldUpdateScroll: _this.shouldUpdateScroll
	    });
	
	    _this.scrollBehavior.updateScroll(null, _this.getRouterProps());
	    return _this;
	  }
	
	  ScrollContext.prototype.getChildContext = function getChildContext() {
	    return {
	      scrollBehavior: this
	    };
	  };
	
	  ScrollContext.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _props = this.props,
	        location = _props.location,
	        history = _props.history;
	
	    var prevLocation = prevProps.location;
	
	    if (location === prevLocation) {
	      return;
	    }
	
	    var prevRouterProps = {
	      history: prevProps.history,
	      location: prevProps.location
	
	      // The "scroll-behavior" package expects the "action" to be on the location
	      // object so let's copy it over.
	    };location.action = history.action;
	    this.scrollBehavior.updateScroll(prevRouterProps, { history: history, location: location });
	  };
	
	  ScrollContext.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.scrollBehavior.stop();
	  };
	
	  ScrollContext.prototype.getRouterProps = function getRouterProps() {
	    var _props2 = this.props,
	        history = _props2.history,
	        location = _props2.location;
	
	    return { history: history, location: location };
	  };
	
	  ScrollContext.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return ScrollContext;
	}(_react2.default.Component);
	
	ScrollContext.propTypes = propTypes;
	ScrollContext.childContextTypes = childContextTypes;
	
	exports.default = (0, _reactRouterDom.withRouter)(ScrollContext);

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(65);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(86);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(85);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(61);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(1054);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  scrollKey: _propTypes2.default.string.isRequired,
	  shouldUpdateScroll: _propTypes2.default.func,
	  children: _propTypes2.default.element.isRequired
	};
	
	var contextTypes = {
	  // This is necessary when rendering on the client. However, when rendering on
	  // the server, this container will do nothing, and thus does not require the
	  // scroll behavior context.
	  scrollBehavior: _propTypes2.default.object
	
	  /* eslint-disable react/no-deprecated */
	};
	var ScrollContainer = function (_React$Component) {
	  (0, _inherits3.default)(ScrollContainer, _React$Component);
	
	  function ScrollContainer(props, context) {
	    (0, _classCallCheck3.default)(this, ScrollContainer);
	
	    // We don't re-register if the scroll key changes, so make sure we
	    // unregister with the initial scroll key just in case the user changes it.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	      var shouldUpdateScroll = _this.props.shouldUpdateScroll;
	
	      if (!shouldUpdateScroll) {
	        return true;
	      }
	
	      // Hack to allow accessing scrollBehavior._stateStorage.
	      return shouldUpdateScroll.call(_this.context.scrollBehavior.scrollBehavior, prevRouterProps, routerProps);
	    };
	
	    _this.scrollKey = props.scrollKey;
	    return _this;
	  }
	
	  ScrollContainer.prototype.componentDidMount = function componentDidMount() {
	    this.context.scrollBehavior.registerElement(this.props.scrollKey, _reactDom2.default.findDOMNode(this), // eslint-disable-line react/no-find-dom-node
	    this.shouldUpdateScroll);
	
	    // Only keep around the current DOM node in development, as this is only
	    // for emitting the appropriate warning.
	    if (false) {
	      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
	    }
	  };
	
	  ScrollContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	     false ? (0, _warning2.default)(nextProps.scrollKey === this.props.scrollKey, "<ScrollContainer> does not support changing scrollKey.") : void 0;
	  };
	
	  ScrollContainer.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (false) {
	      var prevDomNode = this.domNode;
	      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
	
	      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(this.domNode === prevDomNode, "<ScrollContainer> does not support changing DOM node.") : void 0;
	    }
	  };
	
	  ScrollContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.context.scrollBehavior.unregisterElement(this.scrollKey);
	  };
	
	  ScrollContainer.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return ScrollContainer;
	}(_react2.default.Component);
	/* eslint-enable */
	
	ScrollContainer.propTypes = propTypes;
	ScrollContainer.contextTypes = contextTypes;
	
	exports.default = ScrollContainer;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _stringify = __webpack_require__(306);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(65);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATE_KEY_PREFIX = "@@scroll|";
	var GATSBY_ROUTER_SCROLL_STATE = "___GATSBY_REACT_ROUTER_SCROLL";
	
	var SessionStorage = function () {
	  function SessionStorage() {
	    (0, _classCallCheck3.default)(this, SessionStorage);
	  }
	
	  SessionStorage.prototype.read = function read(location, key) {
	    var stateKey = this.getStateKey(location, key);
	
	    try {
	      var value = window.sessionStorage.getItem(stateKey);
	      return JSON.parse(value);
	    } catch (e) {
	      console.warn("[gatsby-react-router-scroll] Unable to access sessionStorage; sessionStorage is not available.");
	
	      if (window && window[GATSBY_ROUTER_SCROLL_STATE] && window[GATSBY_ROUTER_SCROLL_STATE][stateKey]) {
	        return window[GATSBY_ROUTER_SCROLL_STATE][stateKey];
	      }
	
	      return {};
	    }
	  };
	
	  SessionStorage.prototype.save = function save(location, key, value) {
	    var stateKey = this.getStateKey(location, key);
	    var storedValue = (0, _stringify2.default)(value);
	
	    try {
	      window.sessionStorage.setItem(stateKey, storedValue);
	    } catch (e) {
	      if (window && window[GATSBY_ROUTER_SCROLL_STATE]) {
	        window[GATSBY_ROUTER_SCROLL_STATE][stateKey] = JSON.parse(storedValue);
	      } else {
	        window[GATSBY_ROUTER_SCROLL_STATE] = {};
	        window[GATSBY_ROUTER_SCROLL_STATE][stateKey] = JSON.parse(storedValue);
	      }
	
	      console.warn("[gatsby-react-router-scroll] Unable to save state in sessionStorage; sessionStorage is not available.");
	    }
	  };
	
	  SessionStorage.prototype.getStateKey = function getStateKey(location, key) {
	    var stateKeyBase = "" + STATE_KEY_PREFIX + location.pathname;
	    return key === null || typeof key === "undefined" ? stateKeyBase : stateKeyBase + "|" + key;
	  };
	
	  return SessionStorage;
	}();
	
	exports.default = SessionStorage;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ScrollBehaviorContext = __webpack_require__(1050);
	
	var _ScrollBehaviorContext2 = _interopRequireDefault(_ScrollBehaviorContext);
	
	var _ScrollContainer = __webpack_require__(1051);
	
	var _ScrollContainer2 = _interopRequireDefault(_ScrollContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ScrollContainer = _ScrollContainer2.default;
	exports.ScrollContext = _ScrollBehaviorContext2.default;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 1055 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var win;
	
	if (typeof window !== "undefined") {
	    win = window;
	} else if (typeof global !== "undefined") {
	    win = global;
	} else if (typeof self !== "undefined"){
	    win = self;
	} else {
	    win = {};
	}
	
	module.exports = win;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(2104)),valueEqual=_interopDefault(__webpack_require__(2118));__webpack_require__(2116);var invariant=_interopDefault(__webpack_require__(2115));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(format, subs) {
	    var index = 0;
	    var message =
	      'Warning: ' +
	      (subs.length > 0
	        ? format.replace(/%s/g, function() {
	            return subs[index++];
	          })
	        : format);
	
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	
	    try {
	      // --- Welcome to debugging history ---
	      // This error was thrown as a convenience so that you can use the
	      // stack trace to find the callsite that triggered this warning.
	      throw new Error(message);
	    } catch (e) {}
	  };
	}
	
	module.exports = function(member) {
	  printWarning(
	    'Please use `require("history").%s` instead of `require("history/%s")`. ' +
	      'Support for the latter will be removed in the next major release.',
	    [member, member]
	  );
	};


/***/ }),
/* 1058 */,
/* 1059 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Returns the object type of the given payload
	 *
	 * @param {*} payload
	 * @returns {string}
	 */
	function getType(payload) {
	    return Object.prototype.toString.call(payload).slice(8, -1);
	}
	/**
	 * Returns whether the payload is undefined
	 *
	 * @param {*} payload
	 * @returns {payload is undefined}
	 */
	function isUndefined(payload) {
	    return getType(payload) === 'Undefined';
	}
	/**
	 * Returns whether the payload is null
	 *
	 * @param {*} payload
	 * @returns {payload is null}
	 */
	function isNull(payload) {
	    return getType(payload) === 'Null';
	}
	/**
	 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
	 *
	 * @param {*} payload
	 * @returns {payload is PlainObject}
	 */
	function isPlainObject(payload) {
	    if (getType(payload) !== 'Object')
	        return false;
	    return payload.constructor === Object && Object.getPrototypeOf(payload) === Object.prototype;
	}
	/**
	 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
	 *
	 * @param {*} payload
	 * @returns {payload is PlainObject}
	 */
	function isObject(payload) {
	    return isPlainObject(payload);
	}
	/**
	 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
	 *
	 * @param {*} payload
	 * @returns {payload is { [K in any]: never }}
	 */
	function isEmptyObject(payload) {
	    return isPlainObject(payload) && Object.keys(payload).length === 0;
	}
	/**
	 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
	 *
	 * @param {*} payload
	 * @returns {payload is PlainObject}
	 */
	function isFullObject(payload) {
	    return isPlainObject(payload) && Object.keys(payload).length > 0;
	}
	/**
	 * Returns whether the payload is an any kind of object (including special classes or objects with different prototypes)
	 *
	 * @param {*} payload
	 * @returns {payload is PlainObject}
	 */
	function isAnyObject(payload) {
	    return getType(payload) === 'Object';
	}
	/**
	 * Returns whether the payload is an object like a type passed in < >
	 *
	 * Usage: isObjectLike<{id: any}>(payload) // will make sure it's an object and has an `id` prop.
	 *
	 * @template T this must be passed in < >
	 * @param {*} payload
	 * @returns {payload is T}
	 */
	function isObjectLike(payload) {
	    return isAnyObject(payload);
	}
	/**
	 * Returns whether the payload is a function (regular or async)
	 *
	 * @param {*} payload
	 * @returns {payload is AnyFunction}
	 */
	function isFunction(payload) {
	    return typeof payload === 'function';
	}
	/**
	 * Returns whether the payload is an array
	 *
	 * @param {any} payload
	 * @returns {payload is any[]}
	 */
	function isArray(payload) {
	    return getType(payload) === 'Array';
	}
	/**
	 * Returns whether the payload is a an array with at least 1 item
	 *
	 * @param {*} payload
	 * @returns {payload is any[]}
	 */
	function isFullArray(payload) {
	    return isArray(payload) && payload.length > 0;
	}
	/**
	 * Returns whether the payload is a an empty array
	 *
	 * @param {*} payload
	 * @returns {payload is []}
	 */
	function isEmptyArray(payload) {
	    return isArray(payload) && payload.length === 0;
	}
	/**
	 * Returns whether the payload is a string
	 *
	 * @param {*} payload
	 * @returns {payload is string}
	 */
	function isString(payload) {
	    return getType(payload) === 'String';
	}
	/**
	 * Returns whether the payload is a string, BUT returns false for ''
	 *
	 * @param {*} payload
	 * @returns {payload is string}
	 */
	function isFullString(payload) {
	    return isString(payload) && payload !== '';
	}
	/**
	 * Returns whether the payload is ''
	 *
	 * @param {*} payload
	 * @returns {payload is string}
	 */
	function isEmptyString(payload) {
	    return payload === '';
	}
	/**
	 * Returns whether the payload is a number (but not NaN)
	 *
	 * This will return `false` for `NaN`!!
	 *
	 * @param {*} payload
	 * @returns {payload is number}
	 */
	function isNumber(payload) {
	    return getType(payload) === 'Number' && !isNaN(payload);
	}
	/**
	 * Returns whether the payload is a boolean
	 *
	 * @param {*} payload
	 * @returns {payload is boolean}
	 */
	function isBoolean(payload) {
	    return getType(payload) === 'Boolean';
	}
	/**
	 * Returns whether the payload is a regular expression (RegExp)
	 *
	 * @param {*} payload
	 * @returns {payload is RegExp}
	 */
	function isRegExp(payload) {
	    return getType(payload) === 'RegExp';
	}
	/**
	 * Returns whether the payload is a Map
	 *
	 * @param {*} payload
	 * @returns {payload is Map<any, any>}
	 */
	function isMap(payload) {
	    return getType(payload) === 'Map';
	}
	/**
	 * Returns whether the payload is a WeakMap
	 *
	 * @param {*} payload
	 * @returns {payload is WeakMap<any, any>}
	 */
	function isWeakMap(payload) {
	    return getType(payload) === 'WeakMap';
	}
	/**
	 * Returns whether the payload is a Set
	 *
	 * @param {*} payload
	 * @returns {payload is Set<any>}
	 */
	function isSet(payload) {
	    return getType(payload) === 'Set';
	}
	/**
	 * Returns whether the payload is a WeakSet
	 *
	 * @param {*} payload
	 * @returns {payload is WeakSet<any>}
	 */
	function isWeakSet(payload) {
	    return getType(payload) === 'WeakSet';
	}
	/**
	 * Returns whether the payload is a Symbol
	 *
	 * @param {*} payload
	 * @returns {payload is symbol}
	 */
	function isSymbol(payload) {
	    return getType(payload) === 'Symbol';
	}
	/**
	 * Returns whether the payload is a Date, and that the date is valid
	 *
	 * @param {*} payload
	 * @returns {payload is Date}
	 */
	function isDate(payload) {
	    return getType(payload) === 'Date' && !isNaN(payload);
	}
	/**
	 * Returns whether the payload is a Blob
	 *
	 * @param {*} payload
	 * @returns {payload is Blob}
	 */
	function isBlob(payload) {
	    return getType(payload) === 'Blob';
	}
	/**
	 * Returns whether the payload is a File
	 *
	 * @param {*} payload
	 * @returns {payload is File}
	 */
	function isFile(payload) {
	    return getType(payload) === 'File';
	}
	/**
	 * Returns whether the payload is a Promise
	 *
	 * @param {*} payload
	 * @returns {payload is Promise<any>}
	 */
	function isPromise(payload) {
	    return getType(payload) === 'Promise';
	}
	/**
	 * Returns whether the payload is an Error
	 *
	 * @param {*} payload
	 * @returns {payload is Error}
	 */
	function isError(payload) {
	    return getType(payload) === 'Error';
	}
	/**
	 * Returns whether the payload is literally the value `NaN` (it's `NaN` and also a `number`)
	 *
	 * @param {*} payload
	 * @returns {payload is typeof NaN}
	 */
	function isNaNValue(payload) {
	    return getType(payload) === 'Number' && isNaN(payload);
	}
	/**
	 * Returns whether the payload is a primitive type (eg. Boolean | Null | Undefined | Number | String | Symbol)
	 *
	 * @param {*} payload
	 * @returns {(payload is boolean | null | undefined | number | string | symbol)}
	 */
	function isPrimitive(payload) {
	    return (isBoolean(payload) ||
	        isNull(payload) ||
	        isUndefined(payload) ||
	        isNumber(payload) ||
	        isString(payload) ||
	        isSymbol(payload));
	}
	/**
	 * Returns true whether the payload is null or undefined
	 *
	 * @param {*} payload
	 * @returns {(payload is null | undefined)}
	 */
	var isNullOrUndefined = isOneOf(isNull, isUndefined);
	function isOneOf(a, b, c, d, e) {
	    return function (value) {
	        return a(value) || b(value) || (!!c && c(value)) || (!!d && d(value)) || (!!e && e(value));
	    };
	}
	/**
	 * Does a generic check to check that the given payload is of a given type.
	 * In cases like Number, it will return true for NaN as NaN is a Number (thanks javascript!);
	 * It will, however, differentiate between object and null
	 *
	 * @template T
	 * @param {*} payload
	 * @param {T} type
	 * @throws {TypeError} Will throw type error if type is an invalid type
	 * @returns {payload is T}
	 */
	function isType(payload, type) {
	    if (!(type instanceof Function)) {
	        throw new TypeError('Type must be a function');
	    }
	    if (!Object.prototype.hasOwnProperty.call(type, 'prototype')) {
	        throw new TypeError('Type is not a class');
	    }
	    // Classes usually have names (as functions usually have names)
	    var name = type.name;
	    return getType(payload) === name || Boolean(payload && payload.constructor === type);
	}
	
	exports.getType = getType;
	exports.isAnyObject = isAnyObject;
	exports.isArray = isArray;
	exports.isBlob = isBlob;
	exports.isBoolean = isBoolean;
	exports.isDate = isDate;
	exports.isEmptyArray = isEmptyArray;
	exports.isEmptyObject = isEmptyObject;
	exports.isEmptyString = isEmptyString;
	exports.isError = isError;
	exports.isFile = isFile;
	exports.isFullArray = isFullArray;
	exports.isFullObject = isFullObject;
	exports.isFullString = isFullString;
	exports.isFunction = isFunction;
	exports.isMap = isMap;
	exports.isNaNValue = isNaNValue;
	exports.isNull = isNull;
	exports.isNullOrUndefined = isNullOrUndefined;
	exports.isNumber = isNumber;
	exports.isObject = isObject;
	exports.isObjectLike = isObjectLike;
	exports.isOneOf = isOneOf;
	exports.isPlainObject = isPlainObject;
	exports.isPrimitive = isPrimitive;
	exports.isPromise = isPromise;
	exports.isRegExp = isRegExp;
	exports.isSet = isSet;
	exports.isString = isString;
	exports.isSymbol = isSymbol;
	exports.isType = isType;
	exports.isUndefined = isUndefined;
	exports.isWeakMap = isWeakMap;
	exports.isWeakSet = isWeakSet;


/***/ }),
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */
/***/ (function(module, exports) {

	'use strict';
	
	var safeIsNaN = Number.isNaN ||
	    function ponyfill(value) {
	        return typeof value === 'number' && value !== value;
	    };
	function isEqual(first, second) {
	    if (first === second) {
	        return true;
	    }
	    if (safeIsNaN(first) && safeIsNaN(second)) {
	        return true;
	    }
	    return false;
	}
	function areInputsEqual(newInputs, lastInputs) {
	    if (newInputs.length !== lastInputs.length) {
	        return false;
	    }
	    for (var i = 0; i < newInputs.length; i++) {
	        if (!isEqual(newInputs[i], lastInputs[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function memoizeOne(resultFn, isEqual) {
	    if (isEqual === void 0) { isEqual = areInputsEqual; }
	    var lastThis;
	    var lastArgs = [];
	    var lastResult;
	    var calledOnce = false;
	    function memoized() {
	        var newArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            newArgs[_i] = arguments[_i];
	        }
	        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
	            return lastResult;
	        }
	        lastResult = resultFn.apply(this, newArgs);
	        calledOnce = true;
	        lastThis = this;
	        lastArgs = newArgs;
	        return lastResult;
	    }
	    return memoized;
	}
	
	module.exports = memoizeOne;


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var isWhat = __webpack_require__(1059);
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	
	function __spreadArrays() {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	}
	
	function assignProp(carry, key, newVal, originalObject) {
	    var propType = originalObject.propertyIsEnumerable(key)
	        ? 'enumerable'
	        : 'nonenumerable';
	    if (propType === 'enumerable')
	        carry[key] = newVal;
	    if (propType === 'nonenumerable') {
	        Object.defineProperty(carry, key, {
	            value: newVal,
	            enumerable: false,
	            writable: true,
	            configurable: true
	        });
	    }
	}
	function mergeRecursively(origin, newComer, extensions) {
	    // work directly on newComer if its not an object
	    if (!isWhat.isPlainObject(newComer)) {
	        // extend merge rules
	        if (extensions && isWhat.isArray(extensions)) {
	            extensions.forEach(function (extend) {
	                newComer = extend(origin, newComer);
	            });
	        }
	        return newComer;
	    }
	    // define newObject to merge all values upon
	    var newObject = {};
	    if (isWhat.isPlainObject(origin)) {
	        var props_1 = Object.getOwnPropertyNames(origin);
	        var symbols_1 = Object.getOwnPropertySymbols(origin);
	        newObject = __spreadArrays(props_1, symbols_1).reduce(function (carry, key) {
	            // @ts-ignore
	            var targetVal = origin[key];
	            if ((!isWhat.isSymbol(key) && !Object.getOwnPropertyNames(newComer).includes(key)) ||
	                (isWhat.isSymbol(key) && !Object.getOwnPropertySymbols(newComer).includes(key))) {
	                assignProp(carry, key, targetVal, origin);
	            }
	            return carry;
	        }, {});
	    }
	    var props = Object.getOwnPropertyNames(newComer);
	    var symbols = Object.getOwnPropertySymbols(newComer);
	    var result = __spreadArrays(props, symbols).reduce(function (carry, key) {
	        // re-define the origin and newComer as targetVal and newVal
	        var newVal = newComer[key];
	        var targetVal = (isWhat.isPlainObject(origin))
	            // @ts-ignore
	            ? origin[key]
	            : undefined;
	        // extend merge rules
	        if (extensions && isWhat.isArray(extensions)) {
	            extensions.forEach(function (extend) {
	                newVal = extend(targetVal, newVal);
	            });
	        }
	        // When newVal is an object do the merge recursively
	        if (targetVal !== undefined && isWhat.isPlainObject(newVal)) {
	            newVal = mergeRecursively(targetVal, newVal, extensions);
	        }
	        assignProp(carry, key, newVal, newComer);
	        return carry;
	    }, newObject);
	    return result;
	}
	/**
	 * Merge anything recursively.
	 * Objects get merged, special objects (classes etc.) are re-assigned "as is".
	 * Basic types overwrite objects or other basic types.
	 *
	 * @param {(IConfig | any)} origin
	 * @param {...any[]} newComers
	 * @returns the result
	 */
	function merge(origin) {
	    var newComers = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        newComers[_i - 1] = arguments[_i];
	    }
	    var extensions = null;
	    var base = origin;
	    if (isWhat.isPlainObject(origin) && origin.extensions && Object.keys(origin).length === 1) {
	        base = {};
	        extensions = origin.extensions;
	    }
	    return newComers.reduce(function (result, newComer) {
	        return mergeRecursively(result, newComer, extensions);
	    }, base);
	}
	
	function concatArrays(originVal, newVal) {
	    if (isWhat.isArray(originVal) && isWhat.isArray(newVal)) {
	        // concat logic
	        return originVal.concat(newVal);
	    }
	    return newVal; // always return newVal as fallback!!
	}
	
	exports.concatArrays = concatArrays;
	exports.default = merge;
	exports.merge = merge;


/***/ }),
/* 1690 */,
/* 1691 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var w = d * 7;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function (val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isFinite(val)) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'weeks':
	    case 'week':
	    case 'w':
	      return n * w;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  var msAbs = Math.abs(ms);
	  if (msAbs >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (msAbs >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (msAbs >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (msAbs >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  var msAbs = Math.abs(ms);
	  if (msAbs >= d) {
	    return plural(ms, msAbs, d, 'day');
	  }
	  if (msAbs >= h) {
	    return plural(ms, msAbs, h, 'hour');
	  }
	  if (msAbs >= m) {
	    return plural(ms, msAbs, m, 'minute');
	  }
	  if (msAbs >= s) {
	    return plural(ms, msAbs, s, 'second');
	  }
	  return ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, msAbs, n, name) {
	  var isPlural = msAbs >= n * 1.5;
	  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
	}


/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(169); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(169);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1692);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(21);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(20);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _curry = /*#__PURE__*/__webpack_require__(15);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Changes the hue of the color. Hue is a number between 0 to 360. The first
	 * argument for adjustHue is the amount of degrees the color is rotated along
	 * the color wheel.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: adjustHue(180, '#448'),
	 *   background: adjustHue(180, 'rgba(101,100,205,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${adjustHue(180, '#448')};
	 *   background: ${adjustHue(180, 'rgba(101,100,205,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#888844";
	 *   background: "rgba(136,136,68,0.7)";
	 * }
	 */
	function adjustHue(degree, color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    hue: (hslColor.hue + degree) % 360
	  }));
	}
	
	var curriedAdjustHue = /*#__PURE__*/(0, _curry2.default)(adjustHue);
	exports.default = curriedAdjustHue;
	module.exports = exports['default'];

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(21);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(20);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: complement('#448'),
	 *   background: complement('rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${complement('#448')};
	 *   background: ${complement('rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#884";
	 *   background: "rgba(153,153,153,0.7)";
	 * }
	 */
	function complement(color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    hue: (hslColor.hue + 180) % 360
	  }));
	}
	
	exports.default = complement;
	module.exports = exports['default'];

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(21);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(20);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _guard = /*#__PURE__*/__webpack_require__(52);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(15);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the darkened color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: darken(0.2, '#FFCD64'),
	 *   background: darken(0.2, 'rgba(255,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${darken(0.2, '#FFCD64')};
	 *   background: ${darken(0.2, 'rgba(255,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#ffbd31";
	 *   background: "rgba(255,189,49,0.7)";
	 * }
	 */
	function darken(amount, color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    lightness: (0, _guard2.default)(0, 1, hslColor.lightness - amount)
	  }));
	}
	
	var curriedDarken = /*#__PURE__*/(0, _curry2.default)(darken);
	exports.default = curriedDarken;
	module.exports = exports['default'];

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(21);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(20);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _guard = /*#__PURE__*/__webpack_require__(52);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(15);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Decreases the intensity of a color. Its range is between 0 to 1. The first
	 * argument of the desaturate function is the amount by how much the color
	 * intensity should be decreased.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: desaturate(0.2, '#CCCD64'),
	 *   background: desaturate(0.2, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${desaturate(0.2, '#CCCD64')};
	 *   background: ${desaturate(0.2, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#b8b979";
	 *   background: "rgba(184,185,121,0.7)";
	 * }
	 */
	function desaturate(amount, color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    saturation: (0, _guard2.default)(0, 1, hslColor.saturation - amount)
	  }));
	}
	
	var curriedDesaturate = /*#__PURE__*/(0, _curry2.default)(desaturate);
	exports.default = curriedDesaturate;
	module.exports = exports['default'];

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(21);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(20);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts the color to a grayscale, by reducing its saturation to 0.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: grayscale('#CCCD64'),
	 *   background: grayscale('rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${grayscale('#CCCD64')};
	 *   background: ${grayscale('rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#999";
	 *   background: "rgba(153,153,153,0.7)";
	 * }
	 */
	function grayscale(color) {
	  return (0, _toColorString2.default)(_extends({}, (0, _parseToHsl2.default)(color), {
	    saturation: 0
	  }));
	}
	
	exports.default = grayscale;
	module.exports = exports['default'];

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(28);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(20);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Inverts the red, green and blue values of a color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: invert('#CCCD64'),
	 *   background: invert('rgba(101,100,205,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${invert('#CCCD64')};
	 *   background: ${invert('rgba(101,100,205,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#33329b";
	 *   background: "rgba(154,155,50,0.7)";
	 * }
	 */
	function invert(color) {
	  // parse color string to rgb
	  var value = (0, _parseToRgb2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, value, {
	    red: 255 - value.red,
	    green: 255 - value.green,
	    blue: 255 - value.blue
	  }));
	}
	
	exports.default = invert;
	module.exports = exports['default'];

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(21);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(20);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _guard = /*#__PURE__*/__webpack_require__(52);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(15);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the lightened color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: lighten(0.2, '#CCCD64'),
	 *   background: lighten(0.2, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${lighten(0.2, '#FFCD64')};
	 *   background: ${lighten(0.2, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#e5e6b1";
	 *   background: "rgba(229,230,177,0.7)";
	 * }
	 */
	function lighten(amount, color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    lightness: (0, _guard2.default)(0, 1, hslColor.lightness + amount)
	  }));
	}
	
	var curriedLighten = /*#__PURE__*/(0, _curry2.default)(lighten);
	exports.default = curriedLighten;
	module.exports = exports['default'];

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rgba = /*#__PURE__*/__webpack_require__(63);
	
	var _rgba2 = /*#__PURE__*/_interopRequireDefault(_rgba);
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(28);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _guard = /*#__PURE__*/__webpack_require__(52);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(15);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
	 *
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
	 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
	 *   background: opacify(0.5, 'rgba(255, 0, 0, 0.2)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
	 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
	 *   background: ${opacify(0.5, 'rgba(255, 0, 0, 0.2)')},
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#fff";
	 *   background: "rgba(255,255,255,0.7)";
	 *   background: "rgba(255,0,0,0.7)";
	 * }
	 */
	function opacify(amount, color) {
	  var parsedColor = (0, _parseToRgb2.default)(color);
	  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
	  var colorWithAlpha = _extends({}, parsedColor, {
	    alpha: (0, _guard2.default)(0, 1, (alpha * 100 + amount * 100) / 100)
	  });
	  return (0, _rgba2.default)(colorWithAlpha);
	}
	
	var curriedOpacify = /*#__PURE__*/(0, _curry2.default)(opacify);
	exports.default = curriedOpacify;
	module.exports = exports['default'];

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getLuminance = /*#__PURE__*/__webpack_require__(170);
	
	var _getLuminance2 = /*#__PURE__*/_interopRequireDefault(_getLuminance);
	
	var _curry = /*#__PURE__*/__webpack_require__(15);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Selects black or white for best contrast depending on the luminosity of the given color.
	 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   color: readableColor('#000'),
	 *   color: readableColor('papayawhip'),
	 *   color: readableColor('rgb(255,0,0)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   color: ${readableColor('#000')};
	 *   color: ${readableColor('papayawhip')};
	 *   color: ${readableColor('rgb(255,0,0)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   color: "#fff";
	 *   color: "#fff";
	 *   color: "#000";
	 * }
	 */
	
	function readableColor(color) {
	  return (0, _getLuminance2.default)(color) > 0.179 ? '#000' : '#fff';
	}
	
	var curriedReadableColor = /*#__PURE__*/(0, _curry2.default)(readableColor);
	exports.default = curriedReadableColor;
	module.exports = exports['default'];

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(21);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(20);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _guard = /*#__PURE__*/__webpack_require__(52);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(15);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Increases the intensity of a color. Its range is between 0 to 1. The first
	 * argument of the saturate function is the amount by how much the color
	 * intensity should be increased.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: saturate(0.2, '#CCCD64'),
	 *   background: saturate(0.2, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${saturate(0.2, '#FFCD64')};
	 *   background: ${saturate(0.2, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#e0e250";
	 *   background: "rgba(224,226,80,0.7)";
	 * }
	 */
	function saturate(amount, color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    saturation: (0, _guard2.default)(0, 1, hslColor.saturation + amount)
	  }));
	}
	
	var curriedSaturate = /*#__PURE__*/(0, _curry2.default)(saturate);
	exports.default = curriedSaturate;
	module.exports = exports['default'];

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(21);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(20);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _curry = /*#__PURE__*/__webpack_require__(15);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sets the hue of a color to the provided value. The hue range can be
	 * from 0 and 359.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: setHue(42, '#CCCD64'),
	 *   background: setHue(244, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${setHue(42, '#CCCD64')};
	 *   background: ${setHue(244, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#cdae64";
	 *   background: "rgba(107,100,205,0.7)";
	 * }
	 */
	function setHue(hue, color) {
	  return (0, _toColorString2.default)(_extends({}, (0, _parseToHsl2.default)(color), {
	    hue: hue
	  }));
	}
	
	var curriedSetHue = /*#__PURE__*/(0, _curry2.default)(setHue);
	exports.default = curriedSetHue;
	module.exports = exports['default'];

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(21);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(20);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _curry = /*#__PURE__*/__webpack_require__(15);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sets the lightness of a color to the provided value. The lightness range can be
	 * from 0 and 1.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: setLightness(0.2, '#CCCD64'),
	 *   background: setLightness(0.75, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${setLightness(0.2, '#CCCD64')};
	 *   background: ${setLightness(0.75, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#4d4d19";
	 *   background: "rgba(223,224,159,0.7)";
	 * }
	 */
	function setLightness(lightness, color) {
	  return (0, _toColorString2.default)(_extends({}, (0, _parseToHsl2.default)(color), {
	    lightness: lightness
	  }));
	}
	
	var curriedSetLightness = /*#__PURE__*/(0, _curry2.default)(setLightness);
	exports.default = curriedSetLightness;
	module.exports = exports['default'];

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(21);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(20);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _curry = /*#__PURE__*/__webpack_require__(15);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sets the saturation of a color to the provided value. The lightness range can be
	 * from 0 and 1.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: setSaturation(0.2, '#CCCD64'),
	 *   background: setSaturation(0.75, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${setSaturation(0.2, '#CCCD64')};
	 *   background: ${setSaturation(0.75, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#adad84";
	 *   background: "rgba(228,229,76,0.7)";
	 * }
	 */
	function setSaturation(saturation, color) {
	  return (0, _toColorString2.default)(_extends({}, (0, _parseToHsl2.default)(color), {
	    saturation: saturation
	  }));
	}
	
	var curriedSetSaturation = /*#__PURE__*/(0, _curry2.default)(setSaturation);
	exports.default = curriedSetSaturation;
	module.exports = exports['default'];

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mix = /*#__PURE__*/__webpack_require__(113);
	
	var _mix2 = /*#__PURE__*/_interopRequireDefault(_mix);
	
	var _curry = /*#__PURE__*/__webpack_require__(15);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shades a color by mixing it with black. `shade` can produce
	 * hue shifts, where as `darken` manipulates the luminance channel and therefore
	 * doesn't produce hue shifts.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: shade(0.25, '#00f')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${shade(0.25, '#00f')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#00003f";
	 * }
	 */
	
	function shade(percentage, color) {
	  if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) {
	    throw new Error('Passed an incorrect argument to shade, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
	  }
	  if (typeof color !== 'string') {
	    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
	  }
	  return (0, _mix2.default)(percentage, color, 'rgb(0, 0, 0)');
	}
	
	var curriedShade = /*#__PURE__*/(0, _curry2.default)(shade);
	exports.default = curriedShade;
	module.exports = exports['default'];

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mix = /*#__PURE__*/__webpack_require__(113);
	
	var _mix2 = /*#__PURE__*/_interopRequireDefault(_mix);
	
	var _curry = /*#__PURE__*/__webpack_require__(15);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Tints a color by mixing it with white. `tint` can produce
	 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
	 * doesn't produce hue shifts.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: tint(0.25, '#00f')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${tint(0.25, '#00f')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#bfbfff";
	 * }
	 */
	
	function tint(percentage, color) {
	  if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) {
	    throw new Error('Passed an incorrect argument to tint, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
	  }
	  if (typeof color !== 'string') {
	    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
	  }
	  return (0, _mix2.default)(percentage, color, 'rgb(255, 255, 255)');
	}
	
	var curriedTint = /*#__PURE__*/(0, _curry2.default)(tint);
	exports.default = curriedTint;
	module.exports = exports['default'];

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rgba = /*#__PURE__*/__webpack_require__(63);
	
	var _rgba2 = /*#__PURE__*/_interopRequireDefault(_rgba);
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(28);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _guard = /*#__PURE__*/__webpack_require__(52);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(15);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
	 *
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: transparentize(0.1, '#fff');
	 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
	 *   background: transparentize(0.5, 'rgba(255, 0, 0, 0.8)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${transparentize(0.1, '#fff')};
	 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
	 *   background: ${transparentize(0.5, 'rgba(255, 0, 0, 0.8)')},
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "rgba(255,255,255,0.9)";
	 *   background: "rgba(255,255,255,0.8)";
	 *   background: "rgba(255,0,0,0.3)";
	 * }
	 */
	function transparentize(amount, color) {
	  var parsedColor = (0, _parseToRgb2.default)(color);
	  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
	  var colorWithAlpha = _extends({}, parsedColor, {
	    alpha: (0, _guard2.default)(0, 1, (alpha * 100 - amount * 100) / 100)
	  });
	  return (0, _rgba2.default)(colorWithAlpha);
	}
	
	var curriedTransparentize = /*#__PURE__*/(0, _curry2.default)(transparentize);
	exports.default = curriedTransparentize;
	module.exports = exports['default'];

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pxto = /*#__PURE__*/__webpack_require__(176);
	
	var _pxto2 = /*#__PURE__*/_interopRequireDefault(_pxto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
	 * second argument to the function.
	 * @function
	 * @param {string|number} pxval
	 * @param {string|number} [base='16px']
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   'height': em('16px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   height: ${em('16px')}
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   'height': '1em'
	 * }
	 */
	
	var em = /*#__PURE__*/(0, _pxto2.default)('em');
	exports.default = em;
	module.exports = exports['default'];

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ratioNames = undefined;
	
	var _stripUnit = /*#__PURE__*/__webpack_require__(115);
	
	var _stripUnit2 = /*#__PURE__*/_interopRequireDefault(_stripUnit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ratioNames = {
	  minorSecond: 1.067,
	  majorSecond: 1.125,
	  minorThird: 1.2,
	  majorThird: 1.25,
	  perfectFourth: 1.333,
	  augFourth: 1.414,
	  perfectFifth: 1.5,
	  minorSixth: 1.6,
	  goldenSection: 1.618,
	  majorSixth: 1.667,
	  minorSeventh: 1.778,
	  majorSeventh: 1.875,
	  octave: 2,
	  majorTenth: 2.5,
	  majorEleventh: 2.667,
	  majorTwelfth: 3,
	  doubleOctave: 4
	
	  /** */
	};
	
	/**
	 * Establish consistent measurements and spacial relationships throughout your projects by incrementing up or down a defined scale. We provide a list of commonly used scales as pre-defined variables, see below.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *    // Increment two steps up the default scale
	 *   'fontSize': modularScale(2)
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *    // Increment two steps up the default scale
	 *   fontSize: ${modularScale(2)}
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   'fontSize': '1.77689em'
	 * }
	 */
	function modularScale(steps) {
	  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1em';
	  var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'perfectFourth';
	
	  if (typeof steps !== 'number') {
	    throw new Error('Please provide a number of steps to the modularScale helper.');
	  }
	  if (typeof ratio === 'string' && !ratioNames[ratio]) {
	    throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
	  }
	
	  var realBase = typeof base === 'string' ? (0, _stripUnit2.default)(base) : base;
	  var realRatio = typeof ratio === 'string' ? ratioNames[ratio] : ratio;
	
	  if (typeof realBase === 'string') {
	    throw new Error('Invalid value passed as base to modularScale, expected number or em string but got "' + base + '"');
	  }
	
	  return realBase * Math.pow(realRatio, steps) + 'em';
	}
	
	exports.ratioNames = ratioNames;
	exports.default = modularScale;

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pxto = /*#__PURE__*/__webpack_require__(176);
	
	var _pxto2 = /*#__PURE__*/_interopRequireDefault(_pxto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
	 * second argument to the function.
	 * @function
	 * @param {string|number} pxval
	 * @param {string|number} [base='16px']
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   'height': rem('16px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   height: ${rem('16px')}
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   'height': '1rem'
	 * }
	 */
	
	var rem = /*#__PURE__*/(0, _pxto2.default)('rem');
	
	exports.default = rem;
	module.exports = exports['default'];

/***/ }),
/* 1713 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (string, suffix) {
	  return string.substr(-suffix.length) === suffix;
	};
	
	module.exports = exports["default"];

/***/ }),
/* 1714 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var namedColorMap = {
	  aliceblue: 'f0f8ff',
	  antiquewhite: 'faebd7',
	  aqua: '00ffff',
	  aquamarine: '7fffd4',
	  azure: 'f0ffff',
	  beige: 'f5f5dc',
	  bisque: 'ffe4c4',
	  black: '000',
	  blanchedalmond: 'ffebcd',
	  blue: '0000ff',
	  blueviolet: '8a2be2',
	  brown: 'a52a2a',
	  burlywood: 'deb887',
	  cadetblue: '5f9ea0',
	  chartreuse: '7fff00',
	  chocolate: 'd2691e',
	  coral: 'ff7f50',
	  cornflowerblue: '6495ed',
	  cornsilk: 'fff8dc',
	  crimson: 'dc143c',
	  cyan: '00ffff',
	  darkblue: '00008b',
	  darkcyan: '008b8b',
	  darkgoldenrod: 'b8860b',
	  darkgray: 'a9a9a9',
	  darkgreen: '006400',
	  darkgrey: 'a9a9a9',
	  darkkhaki: 'bdb76b',
	  darkmagenta: '8b008b',
	  darkolivegreen: '556b2f',
	  darkorange: 'ff8c00',
	  darkorchid: '9932cc',
	  darkred: '8b0000',
	  darksalmon: 'e9967a',
	  darkseagreen: '8fbc8f',
	  darkslateblue: '483d8b',
	  darkslategray: '2f4f4f',
	  darkslategrey: '2f4f4f',
	  darkturquoise: '00ced1',
	  darkviolet: '9400d3',
	  deeppink: 'ff1493',
	  deepskyblue: '00bfff',
	  dimgray: '696969',
	  dimgrey: '696969',
	  dodgerblue: '1e90ff',
	  firebrick: 'b22222',
	  floralwhite: 'fffaf0',
	  forestgreen: '228b22',
	  fuchsia: 'ff00ff',
	  gainsboro: 'dcdcdc',
	  ghostwhite: 'f8f8ff',
	  gold: 'ffd700',
	  goldenrod: 'daa520',
	  gray: '808080',
	  green: '008000',
	  greenyellow: 'adff2f',
	  grey: '808080',
	  honeydew: 'f0fff0',
	  hotpink: 'ff69b4',
	  indianred: 'cd5c5c',
	  indigo: '4b0082',
	  ivory: 'fffff0',
	  khaki: 'f0e68c',
	  lavender: 'e6e6fa',
	  lavenderblush: 'fff0f5',
	  lawngreen: '7cfc00',
	  lemonchiffon: 'fffacd',
	  lightblue: 'add8e6',
	  lightcoral: 'f08080',
	  lightcyan: 'e0ffff',
	  lightgoldenrodyellow: 'fafad2',
	  lightgray: 'd3d3d3',
	  lightgreen: '90ee90',
	  lightgrey: 'd3d3d3',
	  lightpink: 'ffb6c1',
	  lightsalmon: 'ffa07a',
	  lightseagreen: '20b2aa',
	  lightskyblue: '87cefa',
	  lightslategray: '789',
	  lightslategrey: '789',
	  lightsteelblue: 'b0c4de',
	  lightyellow: 'ffffe0',
	  lime: '0f0',
	  limegreen: '32cd32',
	  linen: 'faf0e6',
	  magenta: 'f0f',
	  maroon: '800000',
	  mediumaquamarine: '66cdaa',
	  mediumblue: '0000cd',
	  mediumorchid: 'ba55d3',
	  mediumpurple: '9370db',
	  mediumseagreen: '3cb371',
	  mediumslateblue: '7b68ee',
	  mediumspringgreen: '00fa9a',
	  mediumturquoise: '48d1cc',
	  mediumvioletred: 'c71585',
	  midnightblue: '191970',
	  mintcream: 'f5fffa',
	  mistyrose: 'ffe4e1',
	  moccasin: 'ffe4b5',
	  navajowhite: 'ffdead',
	  navy: '000080',
	  oldlace: 'fdf5e6',
	  olive: '808000',
	  olivedrab: '6b8e23',
	  orange: 'ffa500',
	  orangered: 'ff4500',
	  orchid: 'da70d6',
	  palegoldenrod: 'eee8aa',
	  palegreen: '98fb98',
	  paleturquoise: 'afeeee',
	  palevioletred: 'db7093',
	  papayawhip: 'ffefd5',
	  peachpuff: 'ffdab9',
	  peru: 'cd853f',
	  pink: 'ffc0cb',
	  plum: 'dda0dd',
	  powderblue: 'b0e0e6',
	  purple: '800080',
	  rebeccapurple: '639',
	  red: 'f00',
	  rosybrown: 'bc8f8f',
	  royalblue: '4169e1',
	  saddlebrown: '8b4513',
	  salmon: 'fa8072',
	  sandybrown: 'f4a460',
	  seagreen: '2e8b57',
	  seashell: 'fff5ee',
	  sienna: 'a0522d',
	  silver: 'c0c0c0',
	  skyblue: '87ceeb',
	  slateblue: '6a5acd',
	  slategray: '708090',
	  slategrey: '708090',
	  snow: 'fffafa',
	  springgreen: '00ff7f',
	  steelblue: '4682b4',
	  tan: 'd2b48c',
	  teal: '008080',
	  thistle: 'd8bfd8',
	  tomato: 'ff6347',
	  turquoise: '40e0d0',
	  violet: 'ee82ee',
	  wheat: 'f5deb3',
	  white: 'fff',
	  whitesmoke: 'f5f5f5',
	  yellow: 'ff0',
	  yellowgreen: '9acd32'
	
	  /**
	   * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
	   * @private
	   */
	};function nameToHex(color) {
	  if (typeof color !== 'string') return color;
	  var normalizedColorName = color.toLowerCase();
	  return namedColorMap[normalizedColorName] ? '#' + namedColorMap[normalizedColorName] : color;
	}
	
	exports.default = nameToHex;
	module.exports = exports['default'];

/***/ }),
/* 1715 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function rgbToHsl(color) {
	  // make sure rgb are contained in a set of [0, 255]
	  var red = color.red / 255;
	  var green = color.green / 255;
	  var blue = color.blue / 255;
	
	  var max = Math.max(red, green, blue);
	  var min = Math.min(red, green, blue);
	  var lightness = (max + min) / 2;
	
	  if (max === min) {
	    // achromatic
	    if (color.alpha !== undefined) {
	      return {
	        hue: 0,
	        saturation: 0,
	        lightness: lightness,
	        alpha: color.alpha
	      };
	    } else {
	      return { hue: 0, saturation: 0, lightness: lightness };
	    }
	  }
	
	  var hue = void 0;
	  var delta = max - min;
	  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
	  switch (max) {
	    case red:
	      hue = (green - blue) / delta + (green < blue ? 6 : 0);
	      break;
	    case green:
	      hue = (blue - red) / delta + 2;
	      break;
	    default:
	      // blue case
	      hue = (red - green) / delta + 4;
	      break;
	  }
	
	  hue *= 60;
	  if (color.alpha !== undefined) {
	    return {
	      hue: hue,
	      saturation: saturation,
	      lightness: lightness,
	      alpha: color.alpha
	    };
	  }
	  return { hue: hue, saturation: saturation, lightness: lightness };
	}
	
	exports.default = rgbToHsl;
	module.exports = exports['default'];

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * CSS to contain a float (credit to CSSMojo).
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *    ...clearFix(),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${clearFix()}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * '&::after': {
	 *   'clear': 'both',
	 *   'content': '""',
	 *   'display': 'table'
	 * }
	 */
	
	function clearFix() {
	  var _ref;
	
	  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '&';
	
	  var pseudoSelector = parent + '::after';
	  return _ref = {}, _ref[pseudoSelector] = {
	    clear: 'both',
	    content: '""',
	    display: 'table'
	  }, _ref;
	}
	
	exports.default = clearFix;
	module.exports = exports['default'];

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * CSS to represent truncated text with an ellipsis.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...ellipsis('250px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${ellipsis('250px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div: {
	 *   'display': 'inline-block',
	 *   'maxWidth': '250px',
	 *   'overflow': 'hidden',
	 *   'textOverflow': 'ellipsis',
	 *   'whiteSpace': 'nowrap',
	 *   'wordWrap': 'normal'
	 * }
	 */
	
	function ellipsis() {
	  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
	
	  return {
	    display: 'inline-block',
	    maxWidth: width,
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap',
	    wordWrap: 'normal'
	  };
	}
	
	exports.default = ellipsis;
	module.exports = exports['default'];

/***/ }),
/* 1718 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function generateFileReferences(fontFilePath, fileFormats) {
	  var fileFontReferences = fileFormats.map(function (format) {
	    return 'url("' + fontFilePath + '.' + format + '")';
	  });
	  return fileFontReferences.join(', ');
	}
	
	/** */
	
	
	function generateLocalReferences(localFonts) {
	  var localFontReferences = localFonts.map(function (font) {
	    return 'local("' + font + '")';
	  });
	  return localFontReferences.join(', ');
	}
	
	function generateSources(fontFilePath, localFonts, fileFormats) {
	  var fontReferences = [];
	  if (localFonts) fontReferences.push(generateLocalReferences(localFonts));
	  if (fontFilePath) {
	    fontReferences.push(generateFileReferences(fontFilePath, fileFormats));
	  }
	  return fontReferences.join(', ');
	}
	
	/**
	 * CSS for a @font-face declaration.
	 *
	 * @example
	 * // Styles as object basic usage
	 * const styles = {
	 *    ...fontFace({
	 *      'fontFamily': 'Sans-Pro'
	 *      'fontFilePath': 'path/to/file'
	 *    })
	 * }
	 *
	 * // styled-components basic usage
	 * injectGlobal`${
	 *   fontFace({
	 *     'fontFamily': 'Sans-Pro'
	 *     'fontFilePath': 'path/to/file'
	 *   }
	 * )}`
	 *
	 * // CSS as JS Output
	 *
	 * '@font-face': {
	 *   'fontFamily': 'Sans-Pro',
	 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
	 * }
	 */
	
	function fontFace(_ref) {
	  var fontFamily = _ref.fontFamily,
	      fontFilePath = _ref.fontFilePath,
	      fontStretch = _ref.fontStretch,
	      fontStyle = _ref.fontStyle,
	      fontVariant = _ref.fontVariant,
	      fontWeight = _ref.fontWeight,
	      _ref$fileFormats = _ref.fileFormats,
	      fileFormats = _ref$fileFormats === undefined ? ['eot', 'woff2', 'woff', 'ttf', 'svg'] : _ref$fileFormats,
	      localFonts = _ref.localFonts,
	      unicodeRange = _ref.unicodeRange;
	
	  // Error Handling
	  if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
	  if (!fontFilePath && !localFonts) {
	    throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
	  }
	  if (localFonts && !Array.isArray(localFonts)) {
	    throw new Error('fontFace expects localFonts to be an array.');
	  }
	  if (!Array.isArray(fileFormats)) {
	    throw new Error('fontFace expects fileFormats to be an array.');
	  }
	
	  var fontFaceDeclaration = {
	    '@font-face': {
	      fontFamily: fontFamily,
	      src: generateSources(fontFilePath, localFonts, fileFormats),
	      unicodeRange: unicodeRange,
	      fontStretch: fontStretch,
	      fontStyle: fontStyle,
	      fontVariant: fontVariant,
	      fontWeight: fontWeight
	    }
	
	    // Removes undefined fields for cleaner css object.
	  };return JSON.parse(JSON.stringify(fontFaceDeclaration));
	}
	
	exports.default = fontFace;
	module.exports = exports['default'];

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * CSS to hide text to show a background image in a SEO-friendly way.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   'backgroundImage': 'url(logo.png)',
	 *   ...hideText(),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   backgroundImage: url(logo.png);
	 *   ${hideText()};
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * 'div': {
	 *   'backgroundImage': 'url(logo.png)',
	 *   'textIndent': '101%',
	 *   'overflow': 'hidden',
	 *   'whiteSpace': 'nowrap',
	 * }
	 */
	
	function hideText() {
	  return {
	    textIndent: '101%',
	    overflow: 'hidden',
	    whiteSpace: 'nowrap'
	  };
	}
	
	exports.default = hideText;
	module.exports = exports['default'];

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * CSS to hide content visually but remain accessible to screen readers.
	 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...hideVisually(),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${hideVisually()};
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * 'div': {
	 *   'border': '0',
	 *   'clip': 'rect(0 0 0 0)',
	 *   'clipPath': 'inset(50%)',
	 *   'height': '1px',
	 *   'margin': '-1px',
	 *   'overflow': 'hidden',
	 *   'padding': '0',
	 *   'position': 'absolute',
	 *   'whiteSpace': 'nowrap',
	 *   'width': '1px',
	 * }
	 */
	
	function hideVisually() {
	  return {
	    border: '0',
	    clip: 'rect(0 0 0 0)',
	    clipPath: 'inset(50%)',
	    height: '1px',
	    margin: '-1px',
	    overflow: 'hidden',
	    padding: '0',
	    position: 'absolute',
	    whiteSpace: 'nowrap',
	    width: '1px'
	  };
	}
	
	exports.default = hideVisually;
	module.exports = exports['default'];

/***/ }),
/* 1721 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _opinionatedRules, _abbrTitle, _unopinionatedRules;
	
	var opinionatedRules = (_opinionatedRules = {
	  html: {
	    fontFamily: 'sans-serif'
	  },
	
	  body: {
	    margin: '0'
	  }
	
	}, _opinionatedRules['a:active,\n  a:hover'] = {
	  outlineWidth: '0'
	}, _opinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
	  fontFamily: 'sans-serif',
	  fontSize: '100%',
	  lineHeight: '1.15'
	}, _opinionatedRules);
	
	var unopinionatedRules = (_unopinionatedRules = {
	  html: {
	    lineHeight: '1.15',
	    textSizeAdjust: '100%'
	  }
	
	}, _unopinionatedRules['article,\n  aside,\n  footer,\n  header,\n  nav,\n  section'] = {
	  display: 'block'
	}, _unopinionatedRules.h1 = {
	  fontSize: '2em',
	  margin: '0.67em 0'
	}, _unopinionatedRules['figcaption,\n  figure,\n  main'] = {
	  display: 'block'
	}, _unopinionatedRules.figure = {
	  margin: '1em 40px'
	}, _unopinionatedRules.hr = {
	  boxSizing: 'content-box',
	  height: '0',
	  overflow: 'visible'
	}, _unopinionatedRules.pre = {
	  fontFamily: 'monospace, monospace',
	  fontSize: '1em'
	}, _unopinionatedRules.a = {
	  'background-color': 'transparent',
	  '-webkit-text-decoration-skip': 'objects'
	}, _unopinionatedRules['abbr[title]'] = (_abbrTitle = {
	  borderBottom: 'none',
	  textDecoration: 'underline'
	}, _abbrTitle['textDecoration'] = 'underline dotted', _abbrTitle), _unopinionatedRules['b,\n  strong'] = {
	  fontWeight: 'inherit'
	}, _unopinionatedRules['code,\n  kbd,\n  samp'] = {
	  fontFamily: 'monospace, monospace',
	  fontSize: '1em'
	}, _unopinionatedRules.dfn = {
	  fontStyle: 'italic'
	}, _unopinionatedRules.mark = {
	  backgroundColor: '#ff0',
	  color: '#000'
	}, _unopinionatedRules.small = {
	  fontSize: '80%'
	}, _unopinionatedRules['sub,\n  sup'] = {
	  fontSize: '75%',
	  lineHeight: '0',
	  position: 'relative',
	  verticalAlign: 'baseline'
	}, _unopinionatedRules.sub = {
	  bottom: '-0.25em'
	}, _unopinionatedRules.sup = {
	  top: '-0.5em'
	}, _unopinionatedRules['audio,\n  video'] = {
	  display: 'inline-block'
	}, _unopinionatedRules['audio:not([controls])'] = {
	  display: 'none',
	  height: '0'
	}, _unopinionatedRules.img = {
	  borderStyle: 'none'
	}, _unopinionatedRules['svg:not(:root)'] = {
	  overflow: 'hidden'
	}, _unopinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
	  margin: '0'
	}, _unopinionatedRules['button,\n  input'] = {
	  overflow: 'visible'
	}, _unopinionatedRules['button,\n  select'] = {
	  textTransform: 'none'
	}, _unopinionatedRules['button,\n  html [type="button"],\n  [type="reset"],\n  [type="submit"]'] = {
	  '-webkit-appearance': 'button'
	}, _unopinionatedRules['button::-moz-focus-inner,\n  [type="button"]::-moz-focus-inner,\n  [type="reset"]::-moz-focus-inner,\n  [type="submit"]::-moz-focus-inner'] = {
	  borderStyle: 'none',
	  padding: '0'
	}, _unopinionatedRules['button:-moz-focusring,\n  [type="button"]:-moz-focusring,\n  [type="reset"]:-moz-focusring,\n  [type="submit"]:-moz-focusring'] = {
	  outline: '1px dotted ButtonText'
	}, _unopinionatedRules.fieldset = {
	  border: '1px solid #c0c0c0',
	  margin: '0 2px',
	  padding: '0.35em 0.625em 0.75em'
	}, _unopinionatedRules.legend = {
	  boxSizing: 'border-box',
	  color: 'inherit',
	  display: 'table',
	  maxWidth: '100%',
	  padding: '0',
	  whiteSpace: 'normal'
	}, _unopinionatedRules.progress = {
	  display: 'inline-block',
	  verticalAlign: 'baseline'
	}, _unopinionatedRules.textarea = {
	  overflow: 'auto'
	}, _unopinionatedRules['[type="checkbox"],\n  [type="radio"]'] = {
	  boxSizing: 'border-box',
	  padding: '0'
	}, _unopinionatedRules['[type="number"]::-webkit-inner-spin-button,\n  [type="number"]::-webkit-outer-spin-button'] = {
	  height: 'auto'
	}, _unopinionatedRules['[type="search"]'] = {
	  '-webkit-appearance': 'textfield',
	  outlineOffset: '-2px'
	}, _unopinionatedRules['[type="search"]::-webkit-search-cancel-button,\n  [type="search"]::-webkit-search-decoration'] = {
	  '-webkit-appearance': 'none'
	}, _unopinionatedRules['::-webkit-file-upload-button'] = {
	  '-webkit-appearance': 'button',
	  font: 'inherit'
	}, _unopinionatedRules['details,\n  menu'] = {
	  display: 'block'
	}, _unopinionatedRules.summary = {
	  display: 'list-item'
	}, _unopinionatedRules.canvas = {
	  display: 'inline-block'
	}, _unopinionatedRules.template = {
	  display: 'none'
	}, _unopinionatedRules['[hidden]'] = {
	  display: 'none'
	}, _unopinionatedRules);
	
	function mergeRules(baseRules, additionalRules) {
	  var mergedRules = _extends({}, baseRules);
	  Object.keys(additionalRules).forEach(function (key) {
	    if (mergedRules[key]) {
	      mergedRules[key] = _extends({}, mergedRules[key], additionalRules[key]);
	    } else {
	      mergedRules[key] = _extends({}, additionalRules[key]);
	    }
	  });
	  return mergedRules;
	}
	
	/**
	 * CSS to normalize abnormalities across browsers (normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css)
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *    ...normalize(),
	 * }
	 *
	 * // styled-components usage
	 * injectGlobal`${normalize()}`
	 *
	 * // CSS as JS Output
	 *
	 * html {
	 *   fontFamily: 'sans-serif',
	 *   lineHeight: 1.15,
	 *   textSizeAdjust: 100%,
	 * } ...
	 */
	function normalize(excludeOpinionated) {
	  if (excludeOpinionated) return unopinionatedRules;
	  return mergeRules(unopinionatedRules, opinionatedRules);
	}
	
	exports.default = normalize;
	module.exports = exports['default'];

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * CSS to style the placeholder pseudo-element.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...placeholder({'color': 'blue'})
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.input`
	 *    ${placeholder({'color': 'blue'})}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * 'input': {
	 *   '&:-moz-placeholder': {
	 *     'color': 'blue',
	 *   },
	 *   '&:-ms-input-placeholder': {
	 *     'color': 'blue',
	 *   },
	 *   '&::-moz-placeholder': {
	 *     'color': 'blue',
	 *   },
	 *   '&::-webkit-input-placeholder': {
	 *     'color': 'blue',
	 *   },
	 * },
	 */
	
	function placeholder(styles) {
	  var _ref;
	
	  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';
	
	  return _ref = {}, _ref[parent + '::-webkit-input-placeholder'] = _extends({}, styles), _ref[parent + ':-moz-placeholder'] = _extends({}, styles), _ref[parent + '::-moz-placeholder'] = _extends({}, styles), _ref[parent + ':-ms-input-placeholder'] = _extends({}, styles), _ref;
	}
	
	exports.default = placeholder;
	module.exports = exports['default'];

/***/ }),
/* 1723 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = /*#__PURE__*/ _taggedTemplateLiteralLoose(['radial-gradient(', '', '', '', ')'], ['radial-gradient(', '', '', '', ')']);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function parseFallback(colorStops) {
	  return colorStops[0].split(' ')[0];
	}
	
	/** */
	
	
	function constructGradientValue(literals) {
	  var template = '';
	  for (var i = 0; i < literals.length; i += 1) {
	    template += literals[i];
	    // Adds leading coma if properties preceed color-stops
	    if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
	      template = template.slice(0, -1);
	      template += ', ' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
	      // No trailing space if color-stops is the only param provided
	    } else if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) {
	      template += '' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
	      // Only adds substitution if it is defined
	    } else if (arguments.length <= i + 1 ? undefined : arguments[i + 1]) {
	      template += (arguments.length <= i + 1 ? undefined : arguments[i + 1]) + ' ';
	    }
	  }
	  return template.trim();
	}
	
	/**
	 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...radialGradient({
	 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
	 *     extent: 'farthest-corner at 45px 45px',
	 *     position: 'center',
	 *     shape: 'ellipse',
	 *   })
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${radialGradient({
	 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
	 *     extent: 'farthest-corner at 45px 45px',
	 *     position: 'center',
	 *     shape: 'ellipse',
	 *   })}
	 *`
	 *
	 * // CSS as JS Output
	 *
	 * div: {
	 *   'backgroundColor': '#00FFFF',
	 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
	 * }
	 */
	
	function radialGradient(_ref) {
	  var colorStops = _ref.colorStops,
	      extent = _ref.extent,
	      fallback = _ref.fallback,
	      position = _ref.position,
	      shape = _ref.shape;
	
	  if (!colorStops || colorStops.length < 2) {
	    throw new Error('radialGradient requries at least 2 color-stops to properly render.');
	  }
	  return {
	    backgroundColor: fallback || parseFallback(colorStops),
	    backgroundImage: constructGradientValue(_templateObject, position, shape, extent, colorStops.join(', '))
	  };
	}
	
	exports.default = radialGradient;
	module.exports = exports['default'];

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hiDPI = /*#__PURE__*/__webpack_require__(179);
	
	var _hiDPI2 = /*#__PURE__*/_interopRequireDefault(_hiDPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A helper to generate a retina background image and non-retina
	 * background image. The retina background image will output to a HiDPI media query. The mixin uses
	 * a _2x.png filename suffix by default.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *  ...retinaImage('my-img')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${retinaImage('my-img')}
	 * `
	 *
	 * // CSS as JS Output
	 * div {
	 *   backgroundImage: 'url(my-img.png)',
	 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
	 *    only screen and (min--moz-device-pixel-ratio: 1.3),
	 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
	 *    only screen and (min-resolution: 144dpi),
	 *    only screen and (min-resolution: 1.5dppx)': {
	 *     backgroundImage: 'url(my-img_2x.png)',
	 *   }
	 * }
	 */
	function retinaImage(filename, backgroundSize) {
	  var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'png';
	
	  var _ref;
	
	  var retinaFilename = arguments[3];
	  var retinaSuffix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '_2x';
	
	  if (!filename) {
	    throw new Error('Please supply a filename to retinaImage() as the first argument.');
	  }
	  // Replace the dot at the beginning of the passed extension if one exists
	  var ext = extension.replace(/^\./, '');
	  var rFilename = retinaFilename ? retinaFilename + '.' + ext : '' + filename + retinaSuffix + '.' + ext;
	
	  return _ref = {
	    backgroundImage: 'url(' + filename + '.' + ext + ')'
	  }, _ref[(0, _hiDPI2.default)()] = {
	    backgroundImage: 'url(' + rFilename + ')',
	    backgroundSize: backgroundSize
	  }, _ref;
	}
	
	exports.default = retinaImage;
	module.exports = exports['default'];

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * CSS to style the selection pseudo-element.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...selection({
	 *     'backgroundColor': 'blue'
	 *   }, 'section')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${selection({'backgroundColor': 'blue'}, 'section')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * 'div': {
	 *   'section::-moz-selection': {
	 *     'backgroundColor':'blue',
	 *   },
	 *   'section::selection': {
	 *     'backgroundColor': 'blue',
	 *   }
	 * }
	 */
	
	function selection(styles) {
	  var _ref;
	
	  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  return _ref = {}, _ref[parent + '::-moz-selection'] = _extends({}, styles), _ref[parent + '::selection'] = _extends({}, styles), _ref;
	}
	
	exports.default = selection;
	module.exports = exports['default'];

/***/ }),
/* 1726 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/* eslint-disable key-spacing */
	var functionsMap = {
	  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
	  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
	  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
	  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
	  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
	  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
	  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
	  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
	
	  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
	  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
	  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
	  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
	  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
	  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
	  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
	  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
	
	  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
	  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
	  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
	  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
	  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
	  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
	  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
	  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
	  /* eslint-enable key-spacing */
	
	  /** */
	};
	
	/**
	 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   'transitionTimingFunction': timingFunctions('easeInQuad')
	 * }
	 *
	 * // styled-components usage
	 *  const div = styled.div`
	 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * 'div': {
	 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
	 * }
	 */
	
	function timingFunctions(timingFunction) {
	  return functionsMap[timingFunction];
	}
	
	exports.default = timingFunctions;
	module.exports = exports['default'];

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/** */
	var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
	  switch (pointingDirection) {
	    case 'top':
	      return '0 ' + width / 2 + 'px ' + height + 'px ' + width / 2 + 'px';
	    case 'left':
	      return height / 2 + 'px ' + width + 'px ' + height / 2 + 'px 0';
	    case 'bottom':
	      return height + 'px ' + width / 2 + 'px 0 ' + width / 2 + 'px';
	    case 'right':
	      return height / 2 + 'px 0 ' + height / 2 + 'px ' + width + 'px';
	
	    default:
	      throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
	  }
	};
	
	// needed for border-color
	var reverseDirection = {
	  left: 'Right',
	  right: 'Left',
	  top: 'Bottom',
	  bottom: 'Top'
	
	  /**
	   * CSS to represent triangle with any pointing direction with an optional background color. Accepts number or px values for height and width.
	   *
	   * @example
	   * // Styles as object usage
	   *
	   * const styles = {
	   *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
	   * }
	   *
	   *
	   * // styled-components usage
	   * const div = styled.div`
	   *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
	   *
	   *
	   * // CSS as JS Output
	   *
	   * div: {
	   *  'borderColor': 'transparent',
	   *  'borderLeftColor': 'red !important',
	   *  'borderStyle': 'solid',
	   *  'borderWidth': '50px 0 50px 100px',
	   *  'height': '0',
	   *  'width': '0',
	   * }
	   */
	
	};function triangle(_ref) {
	  var _ref2;
	
	  var pointingDirection = _ref.pointingDirection,
	      height = _ref.height,
	      width = _ref.width,
	      foregroundColor = _ref.foregroundColor,
	      _ref$backgroundColor = _ref.backgroundColor,
	      backgroundColor = _ref$backgroundColor === undefined ? 'transparent' : _ref$backgroundColor;
	
	  var unitlessHeight = parseFloat(height);
	  var unitlessWidth = parseFloat(width);
	  if (isNaN(unitlessHeight) || isNaN(unitlessWidth)) {
	    throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
	  }
	
	  return _ref2 = {
	    borderColor: backgroundColor,
	    width: '0',
	    height: '0',
	    borderWidth: getBorderWidth(pointingDirection, unitlessHeight, unitlessWidth),
	    borderStyle: 'solid'
	  }, _ref2['border' + reverseDirection[pointingDirection] + 'Color'] = foregroundColor + ' !important', _ref2;
	}
	
	exports.default = triangle;
	module.exports = exports['default'];

/***/ }),
/* 1728 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Provides an easy way to change the `wordWrap` property.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...wordWrap('break-word')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${wordWrap('break-word')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * const styles = {
	 *   overflowWrap: 'break-word',
	 *   wordWrap: 'break-word',
	 *   wordBreak: 'break-all',
	 * }
	 */
	
	function wordWrap() {
	  var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'break-word';
	
	  var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
	  return {
	    overflowWrap: wrap,
	    wordWrap: wrap,
	    wordBreak: wordBreak
	  };
	}
	
	exports.default = wordWrap;
	module.exports = exports['default'];

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
	 * or a single animation spread over the arguments.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
	 * }
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...animation('rotate', '1s', 'ease-in-out')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${animation('rotate', '1s', 'ease-in-out')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'animation': 'rotate 1s ease-in-out'
	 * }
	 */
	function animation() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  // Allow single or multiple animations passed
	  var multiMode = Array.isArray(args[0]);
	  if (!multiMode && args.length > 8) {
	    throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
	  }
	  var code = args.map(function (arg) {
	    if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) {
	      throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
	    }
	    if (Array.isArray(arg) && arg.length > 8) {
	      throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
	    }
	
	    return Array.isArray(arg) ? arg.join(' ') : arg;
	  }).join(', ');
	
	  return {
	    animation: code
	  };
	}
	
	/** */
	exports.default = animation;
	module.exports = exports['default'];

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
	 * }
	 */
	
	function backgroundImages() {
	  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
	    properties[_key] = arguments[_key];
	  }
	
	  return {
	    backgroundImage: properties.join(', ')
	  };
	}
	
	exports.default = backgroundImages;
	module.exports = exports['default'];

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
	 * }
	 */
	function backgrounds() {
	  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
	    properties[_key] = arguments[_key];
	  }
	
	  return {
	    background: properties.join(', ')
	  };
	}
	
	exports.default = backgrounds;
	module.exports = exports['default'];

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(35);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...borderColor('red', 'green', 'blue', 'yellow')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${borderColor('red', 'green', 'blue', 'yellow')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'borderTopColor': 'red',
	 *   'borderRightColor': 'green',
	 *   'borderBottomColor': 'blue',
	 *   'borderLeftColor': 'yellow'
	 * }
	 */
	
	function borderColor() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty2.default.apply(undefined, ['borderColor'].concat(values));
	}
	exports.default = borderColor;
	module.exports = exports['default'];

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _capitalizeString = /*#__PURE__*/__webpack_require__(173);
	
	var _capitalizeString2 = /*#__PURE__*/_interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...borderRadius('top', '5px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${borderRadius('top', '5px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'borderTopRightRadius': '5px',
	 *   'borderTopLeftRadius': '5px',
	 * }
	 */
	
	function borderRadius(side, radius) {
	  var uppercaseSide = (0, _capitalizeString2.default)(side);
	  if (!radius && radius !== 0) {
	    throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
	  }
	  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
	    var _ref;
	
	    return _ref = {}, _ref['border' + uppercaseSide + 'RightRadius'] = radius, _ref['border' + uppercaseSide + 'LeftRadius'] = radius, _ref;
	  }
	
	  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
	    var _ref2;
	
	    return _ref2 = {}, _ref2['borderTop' + uppercaseSide + 'Radius'] = radius, _ref2['borderBottom' + uppercaseSide + 'Radius'] = radius, _ref2;
	  }
	
	  throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
	}
	exports.default = borderRadius;
	module.exports = exports['default'];

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(35);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'borderTopStyle': 'solid',
	 *   'borderRightStyle': 'dashed',
	 *   'borderBottomStyle': 'dotted',
	 *   'borderLeftStyle': 'double'
	 * }
	 */
	
	function borderStyle() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty2.default.apply(undefined, ['borderStyle'].concat(values));
	}
	exports.default = borderStyle;
	module.exports = exports['default'];

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(35);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...borderWidth('12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${borderWidth('12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'borderTopWidth': '12px',
	 *   'borderRightWidth': '24px',
	 *   'borderBottomWidth': '36px',
	 *   'borderLeftWidth': '48px'
	 * }
	 */
	function borderWidth() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty2.default.apply(undefined, ['borderWidth'].concat(values));
	}
	exports.default = borderWidth;
	module.exports = exports['default'];

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _statefulSelectors = /*#__PURE__*/__webpack_require__(178);
	
	var _statefulSelectors2 = /*#__PURE__*/_interopRequireDefault(_statefulSelectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stateMap = [undefined, null, 'active', 'focus', 'hover'];
	
	
	function template(state) {
	  return 'button' + state + ',\n  input[type="button"]' + state + ',\n  input[type="reset"]' + state + ',\n  input[type="submit"]' + state;
	}
	
	/**
	 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   [buttons('active')]: {
	 *     'border': 'none'
	 *   }
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   > ${buttons('active')} {
	 *     border: none;
	 *   }
	 * `
	 *
	 * // CSS in JS Output
	 *
	 *  'button:active,
	 *  'input[type="button"]:active,
	 *  'input[type=\"reset\"]:active,
	 *  'input[type=\"submit\"]:active: {
	 *   'border': 'none'
	 * }
	 */
	
	function buttons() {
	  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
	    states[_key] = arguments[_key];
	  }
	
	  return (0, _statefulSelectors2.default)(states, template, stateMap);
	}
	
	exports.default = buttons;
	module.exports = exports['default'];

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(35);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...margin('12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${margin('12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'marginTop': '12px',
	 *   'marginRight': '24px',
	 *   'marginBottom': '36px',
	 *   'marginLeft': '48px'
	 * }
	 */
	
	function margin() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty2.default.apply(undefined, ['margin'].concat(values));
	}
	exports.default = margin;
	module.exports = exports['default'];

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(35);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...padding('12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${padding('12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'paddingTop': '12px',
	 *   'paddingRight': '24px',
	 *   'paddingBottom': '36px',
	 *   'paddingLeft': '48px'
	 * }
	 */
	
	function padding() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty2.default.apply(undefined, ['padding'].concat(values));
	}
	exports.default = padding;
	module.exports = exports['default'];

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(35);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var positionMap = ['absolute', 'fixed', 'relative', 'static', 'sticky'];
	
	/**
	 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...position('12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${position('12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'top': '12px',
	 *   'right': '24px',
	 *   'bottom': '36px',
	 *   'left': '48px'
	 * }
	 *
	 * // Styles as object usage
	 * const styles = {
	 *   ...position('absolute', '12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${position('absolute', '12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'position': 'absolute',
	 *   'top': '12px',
	 *   'right': '24px',
	 *   'bottom': '36px',
	 *   'left': '48px'
	 * }
	 */
	
	function position(positionKeyword) {
	  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    values[_key - 1] = arguments[_key];
	  }
	
	  if (positionMap.indexOf(positionKeyword) >= 0) {
	    return _extends({
	      position: positionKeyword
	    }, _directionalProperty2.default.apply(undefined, [''].concat(values)));
	  } else {
	    var firstValue = positionKeyword; // in this case position is actually the first value
	    return _directionalProperty2.default.apply(undefined, ['', firstValue].concat(values));
	  }
	}
	
	exports.default = position;
	module.exports = exports['default'];

/***/ }),
/* 1740 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Shorthand to set the height and width properties in a single statement.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...size('300px', '250px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${size('300px', '250px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'height': '300px',
	 *   'width': '250px',
	 * }
	 */
	
	function size(height) {
	  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;
	
	  return {
	    height: height,
	    width: width
	  };
	}
	
	exports.default = size;
	module.exports = exports["default"];

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _statefulSelectors = /*#__PURE__*/__webpack_require__(178);
	
	var _statefulSelectors2 = /*#__PURE__*/_interopRequireDefault(_statefulSelectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stateMap = [undefined, null, 'active', 'focus', 'hover'];
	
	
	function template(state) {
	  return 'input[type="color"]' + state + ',\n    input[type="date"]' + state + ',\n    input[type="datetime"]' + state + ',\n    input[type="datetime-local"]' + state + ',\n    input[type="email"]' + state + ',\n    input[type="month"]' + state + ',\n    input[type="number"]' + state + ',\n    input[type="password"]' + state + ',\n    input[type="search"]' + state + ',\n    input[type="tel"]' + state + ',\n    input[type="text"]' + state + ',\n    input[type="time"]' + state + ',\n    input[type="url"]' + state + ',\n    input[type="week"]' + state + ',\n    input:not([type])' + state + ',\n    textarea' + state;
	}
	
	/**
	 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   [textInputs('active')]: {
	 *     'border': 'none'
	 *   }
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   > ${textInputs('active')} {
	 *     border: none;
	 *   }
	 * `
	 *
	 * // CSS in JS Output
	 *
	 *  'input[type="color"]:active,
	 *  input[type="date"]:active,
	 *  input[type="datetime"]:active,
	 *  input[type="datetime-local"]:active,
	 *  input[type="email"]:active,
	 *  input[type="month"]:active,
	 *  input[type="number"]:active,
	 *  input[type="password"]:active,
	 *  input[type="search"]:active,
	 *  input[type="tel"]:active,
	 *  input[type="text"]:active,
	 *  input[type="time"]:active,
	 *  input[type="url"]:active,
	 *  input[type="week"]:active,
	 *  input:not([type]):active,
	 *  textarea:active': {
	 *   'border': 'none'
	 * }
	 */
	
	function textInputs() {
	  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
	    states[_key] = arguments[_key];
	  }
	
	  return (0, _statefulSelectors2.default)(states, template, stateMap);
	}
	
	exports.default = textInputs;
	module.exports = exports['default'];

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Shorthand that accepts any number of transition values as parameters for creating a single transition statement.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
	 * }
	 */
	
	function transitions() {
	  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
	    properties[_key] = arguments[_key];
	  }
	
	  return {
	    transition: properties.join(', ')
	  };
	}
	
	exports.default = transitions;
	module.exports = exports['default'];

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(1744);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1744 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 1745 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};
	
	var isArray = Array.isArray || function (xs) {
	  return Object.prototype.toString.call(xs) === '[object Array]';
	};


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(1745);
	exports.encode = exports.stringify = __webpack_require__(180);


/***/ }),
/* 1747 */,
/* 1748 */
/***/ (function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal
	
	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;
	
	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare
	
	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Activity = function Activity(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '22 12 18 12 15 21 9 3 6 12 2 12' })
	  );
	};
	
	Activity.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Activity.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Activity;

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Airplay = function Airplay(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1' }),
	    _react2.default.createElement('polygon', { points: '12 15 17 21 7 21 12 15' })
	  );
	};
	
	Airplay.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Airplay.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Airplay;

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var AlertCircle = function AlertCircle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('line', { x1: '12', y1: '8', x2: '12', y2: '12' }),
	    _react2.default.createElement('line', { x1: '12', y1: '16', x2: '12', y2: '16' })
	  );
	};
	
	AlertCircle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	AlertCircle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = AlertCircle;

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var AlertOctagon = function AlertOctagon(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2' }),
	    _react2.default.createElement('line', { x1: '12', y1: '8', x2: '12', y2: '12' }),
	    _react2.default.createElement('line', { x1: '12', y1: '16', x2: '12', y2: '16' })
	  );
	};
	
	AlertOctagon.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	AlertOctagon.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = AlertOctagon;

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var AlertTriangle = function AlertTriangle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z' }),
	    _react2.default.createElement('line', { x1: '12', y1: '9', x2: '12', y2: '13' }),
	    _react2.default.createElement('line', { x1: '12', y1: '17', x2: '12', y2: '17' })
	  );
	};
	
	AlertTriangle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	AlertTriangle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = AlertTriangle;

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var AlignCenter = function AlignCenter(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '18', y1: '10', x2: '6', y2: '10' }),
	    _react2.default.createElement('line', { x1: '21', y1: '6', x2: '3', y2: '6' }),
	    _react2.default.createElement('line', { x1: '21', y1: '14', x2: '3', y2: '14' }),
	    _react2.default.createElement('line', { x1: '18', y1: '18', x2: '6', y2: '18' })
	  );
	};
	
	AlignCenter.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	AlignCenter.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = AlignCenter;

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var AlignJustify = function AlignJustify(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '21', y1: '10', x2: '3', y2: '10' }),
	    _react2.default.createElement('line', { x1: '21', y1: '6', x2: '3', y2: '6' }),
	    _react2.default.createElement('line', { x1: '21', y1: '14', x2: '3', y2: '14' }),
	    _react2.default.createElement('line', { x1: '21', y1: '18', x2: '3', y2: '18' })
	  );
	};
	
	AlignJustify.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	AlignJustify.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = AlignJustify;

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var AlignLeft = function AlignLeft(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '17', y1: '10', x2: '3', y2: '10' }),
	    _react2.default.createElement('line', { x1: '21', y1: '6', x2: '3', y2: '6' }),
	    _react2.default.createElement('line', { x1: '21', y1: '14', x2: '3', y2: '14' }),
	    _react2.default.createElement('line', { x1: '17', y1: '18', x2: '3', y2: '18' })
	  );
	};
	
	AlignLeft.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	AlignLeft.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = AlignLeft;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var AlignRight = function AlignRight(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '21', y1: '10', x2: '7', y2: '10' }),
	    _react2.default.createElement('line', { x1: '21', y1: '6', x2: '3', y2: '6' }),
	    _react2.default.createElement('line', { x1: '21', y1: '14', x2: '3', y2: '14' }),
	    _react2.default.createElement('line', { x1: '21', y1: '18', x2: '7', y2: '18' })
	  );
	};
	
	AlignRight.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	AlignRight.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = AlignRight;

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Anchor = function Anchor(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '5', r: '3' }),
	    _react2.default.createElement('line', { x1: '12', y1: '22', x2: '12', y2: '8' }),
	    _react2.default.createElement('path', { d: 'M5 12H2a10 10 0 0 0 20 0h-3' })
	  );
	};
	
	Anchor.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Anchor.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Anchor;

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Aperture = function Aperture(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('line', { x1: '14.31', y1: '8', x2: '20.05', y2: '17.94' }),
	    _react2.default.createElement('line', { x1: '9.69', y1: '8', x2: '21.17', y2: '8' }),
	    _react2.default.createElement('line', { x1: '7.38', y1: '12', x2: '13.12', y2: '2.06' }),
	    _react2.default.createElement('line', { x1: '9.69', y1: '16', x2: '3.95', y2: '6.06' }),
	    _react2.default.createElement('line', { x1: '14.31', y1: '16', x2: '2.83', y2: '16' }),
	    _react2.default.createElement('line', { x1: '16.62', y1: '12', x2: '10.88', y2: '21.94' })
	  );
	};
	
	Aperture.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Aperture.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Aperture;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Archive = function Archive(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '21 8 21 21 3 21 3 8' }),
	    _react2.default.createElement('rect', { x: '1', y: '3', width: '22', height: '5' }),
	    _react2.default.createElement('line', { x1: '10', y1: '12', x2: '14', y2: '12' })
	  );
	};
	
	Archive.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Archive.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Archive;

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ArrowDownCircle = function ArrowDownCircle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('polyline', { points: '8 12 12 16 16 12' }),
	    _react2.default.createElement('line', { x1: '12', y1: '8', x2: '12', y2: '16' })
	  );
	};
	
	ArrowDownCircle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ArrowDownCircle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ArrowDownCircle;

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ArrowDownLeft = function ArrowDownLeft(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '17', y1: '7', x2: '7', y2: '17' }),
	    _react2.default.createElement('polyline', { points: '17 17 7 17 7 7' })
	  );
	};
	
	ArrowDownLeft.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ArrowDownLeft.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ArrowDownLeft;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ArrowDownRight = function ArrowDownRight(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '7', y1: '7', x2: '17', y2: '17' }),
	    _react2.default.createElement('polyline', { points: '17 7 17 17 7 17' })
	  );
	};
	
	ArrowDownRight.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ArrowDownRight.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ArrowDownRight;

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ArrowDown = function ArrowDown(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '12', y1: '5', x2: '12', y2: '19' }),
	    _react2.default.createElement('polyline', { points: '19 12 12 19 5 12' })
	  );
	};
	
	ArrowDown.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ArrowDown.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ArrowDown;

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ArrowLeftCircle = function ArrowLeftCircle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('polyline', { points: '12 8 8 12 12 16' }),
	    _react2.default.createElement('line', { x1: '16', y1: '12', x2: '8', y2: '12' })
	  );
	};
	
	ArrowLeftCircle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ArrowLeftCircle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ArrowLeftCircle;

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ArrowLeft = function ArrowLeft(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '19', y1: '12', x2: '5', y2: '12' }),
	    _react2.default.createElement('polyline', { points: '12 19 5 12 12 5' })
	  );
	};
	
	ArrowLeft.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ArrowLeft.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ArrowLeft;

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ArrowRightCircle = function ArrowRightCircle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('polyline', { points: '12 16 16 12 12 8' }),
	    _react2.default.createElement('line', { x1: '8', y1: '12', x2: '16', y2: '12' })
	  );
	};
	
	ArrowRightCircle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ArrowRightCircle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ArrowRightCircle;

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ArrowRight = function ArrowRight(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '5', y1: '12', x2: '19', y2: '12' }),
	    _react2.default.createElement('polyline', { points: '12 5 19 12 12 19' })
	  );
	};
	
	ArrowRight.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ArrowRight.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ArrowRight;

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ArrowUpCircle = function ArrowUpCircle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('polyline', { points: '16 12 12 8 8 12' }),
	    _react2.default.createElement('line', { x1: '12', y1: '16', x2: '12', y2: '8' })
	  );
	};
	
	ArrowUpCircle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ArrowUpCircle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ArrowUpCircle;

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ArrowUpLeft = function ArrowUpLeft(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '17', y1: '17', x2: '7', y2: '7' }),
	    _react2.default.createElement('polyline', { points: '7 17 7 7 17 7' })
	  );
	};
	
	ArrowUpLeft.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ArrowUpLeft.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ArrowUpLeft;

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ArrowUpRight = function ArrowUpRight(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '7', y1: '17', x2: '17', y2: '7' }),
	    _react2.default.createElement('polyline', { points: '7 7 17 7 17 17' })
	  );
	};
	
	ArrowUpRight.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ArrowUpRight.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ArrowUpRight;

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ArrowUp = function ArrowUp(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '12', y1: '19', x2: '12', y2: '5' }),
	    _react2.default.createElement('polyline', { points: '5 12 12 5 19 12' })
	  );
	};
	
	ArrowUp.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ArrowUp.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ArrowUp;

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var AtSign = function AtSign(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '4' }),
	    _react2.default.createElement('path', { d: 'M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94' })
	  );
	};
	
	AtSign.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	AtSign.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = AtSign;

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Award = function Award(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '8', r: '7' }),
	    _react2.default.createElement('polyline', { points: '8.21 13.89 7 23 12 20 17 23 15.79 13.88' })
	  );
	};
	
	Award.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Award.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Award;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var BarChart2 = function BarChart2(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '18', y1: '20', x2: '18', y2: '10' }),
	    _react2.default.createElement('line', { x1: '12', y1: '20', x2: '12', y2: '4' }),
	    _react2.default.createElement('line', { x1: '6', y1: '20', x2: '6', y2: '14' })
	  );
	};
	
	BarChart2.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	BarChart2.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = BarChart2;

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var BarChart = function BarChart(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '12', y1: '20', x2: '12', y2: '10' }),
	    _react2.default.createElement('line', { x1: '18', y1: '20', x2: '18', y2: '4' }),
	    _react2.default.createElement('line', { x1: '6', y1: '20', x2: '6', y2: '16' })
	  );
	};
	
	BarChart.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	BarChart.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = BarChart;

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var BatteryCharging = function BatteryCharging(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19' }),
	    _react2.default.createElement('line', { x1: '23', y1: '13', x2: '23', y2: '11' }),
	    _react2.default.createElement('polyline', { points: '11 6 7 12 13 12 9 18' })
	  );
	};
	
	BatteryCharging.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	BatteryCharging.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = BatteryCharging;

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Battery = function Battery(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '1', y: '6', width: '18', height: '12', rx: '2', ry: '2' }),
	    _react2.default.createElement('line', { x1: '23', y1: '13', x2: '23', y2: '11' })
	  );
	};
	
	Battery.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Battery.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Battery;

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var BellOff = function BellOff(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M8.56 2.9A7 7 0 0 1 19 9v4m-2 4H2a3 3 0 0 0 3-3V9a7 7 0 0 1 .78-3.22M13.73 21a2 2 0 0 1-3.46 0' }),
	    _react2.default.createElement('line', { x1: '1', y1: '1', x2: '23', y2: '23' })
	  );
	};
	
	BellOff.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	BellOff.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = BellOff;

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Bell = function Bell(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M22 17H2a3 3 0 0 0 3-3V9a7 7 0 0 1 14 0v5a3 3 0 0 0 3 3zm-8.27 4a2 2 0 0 1-3.46 0' })
	  );
	};
	
	Bell.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Bell.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Bell;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Bluetooth = function Bluetooth(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5' })
	  );
	};
	
	Bluetooth.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Bluetooth.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Bluetooth;

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Bold = function Bold(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z' }),
	    _react2.default.createElement('path', { d: 'M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z' })
	  );
	};
	
	Bold.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Bold.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Bold;

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var BookOpen = function BookOpen(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z' }),
	    _react2.default.createElement('path', { d: 'M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z' })
	  );
	};
	
	BookOpen.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	BookOpen.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = BookOpen;

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Book = function Book(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M4 19.5A2.5 2.5 0 0 1 6.5 17H20' }),
	    _react2.default.createElement('path', { d: 'M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z' })
	  );
	};
	
	Book.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Book.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Book;

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Bookmark = function Bookmark(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z' })
	  );
	};
	
	Bookmark.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Bookmark.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Bookmark;

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Box = function Box(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M12.89 1.45l8 4A2 2 0 0 1 22 7.24v9.53a2 2 0 0 1-1.11 1.79l-8 4a2 2 0 0 1-1.79 0l-8-4a2 2 0 0 1-1.1-1.8V7.24a2 2 0 0 1 1.11-1.79l8-4a2 2 0 0 1 1.78 0z' }),
	    _react2.default.createElement('polyline', { points: '2.32 6.16 12 11 21.68 6.16' }),
	    _react2.default.createElement('line', { x1: '12', y1: '22.76', x2: '12', y2: '11' })
	  );
	};
	
	Box.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Box.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Box;

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Briefcase = function Briefcase(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '2', y: '7', width: '20', height: '14', rx: '2', ry: '2' }),
	    _react2.default.createElement('path', { d: 'M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16' })
	  );
	};
	
	Briefcase.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Briefcase.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Briefcase;

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Calendar = function Calendar(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '3', y: '4', width: '18', height: '18', rx: '2', ry: '2' }),
	    _react2.default.createElement('line', { x1: '16', y1: '2', x2: '16', y2: '6' }),
	    _react2.default.createElement('line', { x1: '8', y1: '2', x2: '8', y2: '6' }),
	    _react2.default.createElement('line', { x1: '3', y1: '10', x2: '21', y2: '10' })
	  );
	};
	
	Calendar.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Calendar.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Calendar;

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CameraOff = function CameraOff(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '1', y1: '1', x2: '23', y2: '23' }),
	    _react2.default.createElement('path', { d: 'M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56' })
	  );
	};
	
	CameraOff.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	CameraOff.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = CameraOff;

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Camera = function Camera(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z' }),
	    _react2.default.createElement('circle', { cx: '12', cy: '13', r: '4' })
	  );
	};
	
	Camera.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Camera.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Camera;

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Cast = function Cast(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6' }),
	    _react2.default.createElement('line', { x1: '2', y1: '20', x2: '2', y2: '20' })
	  );
	};
	
	Cast.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Cast.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Cast;

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CheckCircle = function CheckCircle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M22 11.08V12a10 10 0 1 1-5.93-9.14' }),
	    _react2.default.createElement('polyline', { points: '22 4 12 14.01 9 11.01' })
	  );
	};
	
	CheckCircle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	CheckCircle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = CheckCircle;

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CheckSquare = function CheckSquare(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '9 11 12 14 22 4' }),
	    _react2.default.createElement('path', { d: 'M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11' })
	  );
	};
	
	CheckSquare.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	CheckSquare.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = CheckSquare;

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Check = function Check(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '20 6 9 17 4 12' })
	  );
	};
	
	Check.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Check.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Check;

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ChevronDown = function ChevronDown(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '6 9 12 15 18 9' })
	  );
	};
	
	ChevronDown.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ChevronDown.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ChevronDown;

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ChevronLeft = function ChevronLeft(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '15 18 9 12 15 6' })
	  );
	};
	
	ChevronLeft.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ChevronLeft.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ChevronLeft;

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ChevronRight = function ChevronRight(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '9 18 15 12 9 6' })
	  );
	};
	
	ChevronRight.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ChevronRight.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ChevronRight;

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ChevronUp = function ChevronUp(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '18 15 12 9 6 15' })
	  );
	};
	
	ChevronUp.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ChevronUp.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ChevronUp;

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ChevronsDown = function ChevronsDown(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '7 13 12 18 17 13' }),
	    _react2.default.createElement('polyline', { points: '7 6 12 11 17 6' })
	  );
	};
	
	ChevronsDown.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ChevronsDown.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ChevronsDown;

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ChevronsLeft = function ChevronsLeft(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '11 17 6 12 11 7' }),
	    _react2.default.createElement('polyline', { points: '18 17 13 12 18 7' })
	  );
	};
	
	ChevronsLeft.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ChevronsLeft.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ChevronsLeft;

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ChevronsRight = function ChevronsRight(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '13 17 18 12 13 7' }),
	    _react2.default.createElement('polyline', { points: '6 17 11 12 6 7' })
	  );
	};
	
	ChevronsRight.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ChevronsRight.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ChevronsRight;

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ChevronsUp = function ChevronsUp(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '17 11 12 6 7 11' }),
	    _react2.default.createElement('polyline', { points: '17 18 12 13 7 18' })
	  );
	};
	
	ChevronsUp.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ChevronsUp.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ChevronsUp;

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Chrome = function Chrome(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '4' }),
	    _react2.default.createElement('line', { x1: '21.17', y1: '8', x2: '12', y2: '8' }),
	    _react2.default.createElement('line', { x1: '3.95', y1: '6.06', x2: '8.54', y2: '14' }),
	    _react2.default.createElement('line', { x1: '10.88', y1: '21.94', x2: '15.46', y2: '14' })
	  );
	};
	
	Chrome.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Chrome.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Chrome;

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Circle = function Circle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' })
	  );
	};
	
	Circle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Circle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Circle;

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Clipboard = function Clipboard(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2' }),
	    _react2.default.createElement('rect', { x: '8', y: '2', width: '8', height: '4', rx: '1', ry: '1' })
	  );
	};
	
	Clipboard.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Clipboard.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Clipboard;

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Clock = function Clock(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('polyline', { points: '12 6 12 12 16 14' })
	  );
	};
	
	Clock.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Clock.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Clock;

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CloudDrizzle = function CloudDrizzle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '8', y1: '19', x2: '8', y2: '21' }),
	    _react2.default.createElement('line', { x1: '8', y1: '13', x2: '8', y2: '15' }),
	    _react2.default.createElement('line', { x1: '16', y1: '19', x2: '16', y2: '21' }),
	    _react2.default.createElement('line', { x1: '16', y1: '13', x2: '16', y2: '15' }),
	    _react2.default.createElement('line', { x1: '12', y1: '21', x2: '12', y2: '23' }),
	    _react2.default.createElement('line', { x1: '12', y1: '15', x2: '12', y2: '17' }),
	    _react2.default.createElement('path', { d: 'M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25' })
	  );
	};
	
	CloudDrizzle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	CloudDrizzle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = CloudDrizzle;

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CloudLightning = function CloudLightning(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9' }),
	    _react2.default.createElement('polyline', { points: '13 11 9 17 15 17 11 23' })
	  );
	};
	
	CloudLightning.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	CloudLightning.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = CloudLightning;

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CloudOff = function CloudOff(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3' }),
	    _react2.default.createElement('line', { x1: '1', y1: '1', x2: '23', y2: '23' })
	  );
	};
	
	CloudOff.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	CloudOff.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = CloudOff;

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CloudRain = function CloudRain(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '16', y1: '13', x2: '16', y2: '21' }),
	    _react2.default.createElement('line', { x1: '8', y1: '13', x2: '8', y2: '21' }),
	    _react2.default.createElement('line', { x1: '12', y1: '15', x2: '12', y2: '23' }),
	    _react2.default.createElement('path', { d: 'M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25' })
	  );
	};
	
	CloudRain.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	CloudRain.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = CloudRain;

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CloudSnow = function CloudSnow(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25' }),
	    _react2.default.createElement('line', { x1: '8', y1: '16', x2: '8', y2: '16' }),
	    _react2.default.createElement('line', { x1: '8', y1: '20', x2: '8', y2: '20' }),
	    _react2.default.createElement('line', { x1: '12', y1: '18', x2: '12', y2: '18' }),
	    _react2.default.createElement('line', { x1: '12', y1: '22', x2: '12', y2: '22' }),
	    _react2.default.createElement('line', { x1: '16', y1: '16', x2: '16', y2: '16' }),
	    _react2.default.createElement('line', { x1: '16', y1: '20', x2: '16', y2: '20' })
	  );
	};
	
	CloudSnow.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	CloudSnow.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = CloudSnow;

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Cloud = function Cloud(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z' })
	  );
	};
	
	Cloud.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Cloud.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Cloud;

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Code = function Code(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '16 18 22 12 16 6' }),
	    _react2.default.createElement('polyline', { points: '8 6 2 12 8 18' })
	  );
	};
	
	Code.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Code.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Code;

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Codepen = function Codepen(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2' }),
	    _react2.default.createElement('line', { x1: '12', y1: '22', x2: '12', y2: '15.5' }),
	    _react2.default.createElement('polyline', { points: '22 8.5 12 15.5 2 8.5' }),
	    _react2.default.createElement('polyline', { points: '2 15.5 12 8.5 22 15.5' }),
	    _react2.default.createElement('line', { x1: '12', y1: '2', x2: '12', y2: '8.5' })
	  );
	};
	
	Codepen.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Codepen.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Codepen;

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Coffee = function Coffee(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      viewBox: '0 0 24 24',
	      width: size,
	      height: size,
	      xmlns: 'http://www.w3.org/2000/svg',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M18 8h1a4 4 0 0 1 0 8h-1' }),
	    _react2.default.createElement('path', { d: 'M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z' }),
	    _react2.default.createElement('line', { x1: '6', y1: '1', x2: '6', y2: '4' }),
	    _react2.default.createElement('line', { x1: '10', y1: '1', x2: '10', y2: '4' }),
	    _react2.default.createElement('line', { x1: '14', y1: '1', x2: '14', y2: '4' })
	  );
	};
	
	Coffee.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Coffee.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Coffee;

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Command = function Command(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z' })
	  );
	};
	
	Command.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Command.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Command;

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Compass = function Compass(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('polygon', { points: '16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76' })
	  );
	};
	
	Compass.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Compass.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Compass;

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Copy = function Copy(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '9', y: '9', width: '13', height: '13', rx: '2', ry: '2' }),
	    _react2.default.createElement('path', { d: 'M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1' })
	  );
	};
	
	Copy.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Copy.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Copy;

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CornerDownLeft = function CornerDownLeft(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '9 10 4 15 9 20' }),
	    _react2.default.createElement('path', { d: 'M20 4v7a4 4 0 0 1-4 4H4' })
	  );
	};
	
	CornerDownLeft.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	CornerDownLeft.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = CornerDownLeft;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CornerDownRight = function CornerDownRight(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '15 10 20 15 15 20' }),
	    _react2.default.createElement('path', { d: 'M4 4v7a4 4 0 0 0 4 4h12' })
	  );
	};
	
	CornerDownRight.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	CornerDownRight.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = CornerDownRight;

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CornerLeftDown = function CornerLeftDown(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '14 15 9 20 4 15' }),
	    _react2.default.createElement('path', { d: 'M20 4h-7a4 4 0 0 0-4 4v12' })
	  );
	};
	
	CornerLeftDown.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	CornerLeftDown.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = CornerLeftDown;

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CornerLeftUp = function CornerLeftUp(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '14 9 9 4 4 9' }),
	    _react2.default.createElement('path', { d: 'M20 20h-7a4 4 0 0 1-4-4V4' })
	  );
	};
	
	CornerLeftUp.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	CornerLeftUp.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = CornerLeftUp;

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CornerRightDown = function CornerRightDown(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '10 15 15 20 20 15' }),
	    _react2.default.createElement('path', { d: 'M4 4h7a4 4 0 0 1 4 4v12' })
	  );
	};
	
	CornerRightDown.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	CornerRightDown.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = CornerRightDown;

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CornerRightUp = function CornerRightUp(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '10 9 15 4 20 9' }),
	    _react2.default.createElement('path', { d: 'M4 20h7a4 4 0 0 0 4-4V4' })
	  );
	};
	
	CornerRightUp.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	CornerRightUp.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = CornerRightUp;

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CornerUpLeft = function CornerUpLeft(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '9 14 4 9 9 4' }),
	    _react2.default.createElement('path', { d: 'M20 20v-7a4 4 0 0 0-4-4H4' })
	  );
	};
	
	CornerUpLeft.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	CornerUpLeft.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = CornerUpLeft;

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CornerUpRight = function CornerUpRight(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '15 14 20 9 15 4' }),
	    _react2.default.createElement('path', { d: 'M4 20v-7a4 4 0 0 1 4-4h12' })
	  );
	};
	
	CornerUpRight.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	CornerUpRight.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = CornerUpRight;

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Cpu = function Cpu(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '4', y: '4', width: '16', height: '16', rx: '2', ry: '2' }),
	    _react2.default.createElement('rect', { x: '9', y: '9', width: '6', height: '6' }),
	    _react2.default.createElement('line', { x1: '9', y1: '1', x2: '9', y2: '4' }),
	    _react2.default.createElement('line', { x1: '15', y1: '1', x2: '15', y2: '4' }),
	    _react2.default.createElement('line', { x1: '9', y1: '20', x2: '9', y2: '23' }),
	    _react2.default.createElement('line', { x1: '15', y1: '20', x2: '15', y2: '23' }),
	    _react2.default.createElement('line', { x1: '20', y1: '9', x2: '23', y2: '9' }),
	    _react2.default.createElement('line', { x1: '20', y1: '14', x2: '23', y2: '14' }),
	    _react2.default.createElement('line', { x1: '1', y1: '9', x2: '4', y2: '9' }),
	    _react2.default.createElement('line', { x1: '1', y1: '14', x2: '4', y2: '14' })
	  );
	};
	
	Cpu.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Cpu.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Cpu;

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CreditCard = function CreditCard(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '1', y: '4', width: '22', height: '16', rx: '2', ry: '2' }),
	    _react2.default.createElement('line', { x1: '1', y1: '10', x2: '23', y2: '10' })
	  );
	};
	
	CreditCard.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	CreditCard.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = CreditCard;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Crop = function Crop(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M6.13 1L6 16a2 2 0 0 0 2 2h15' }),
	    _react2.default.createElement('path', { d: 'M1 6.13L16 6a2 2 0 0 1 2 2v15' })
	  );
	};
	
	Crop.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Crop.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Crop;

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Crosshair = function Crosshair(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('line', { x1: '22', y1: '12', x2: '18', y2: '12' }),
	    _react2.default.createElement('line', { x1: '6', y1: '12', x2: '2', y2: '12' }),
	    _react2.default.createElement('line', { x1: '12', y1: '6', x2: '12', y2: '2' }),
	    _react2.default.createElement('line', { x1: '12', y1: '22', x2: '12', y2: '18' })
	  );
	};
	
	Crosshair.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Crosshair.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Crosshair;

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Database = function Database(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('ellipse', { cx: '12', cy: '5', rx: '9', ry: '3' }),
	    _react2.default.createElement('path', { d: 'M21 12c0 1.66-4 3-9 3s-9-1.34-9-3' }),
	    _react2.default.createElement('path', { d: 'M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5' })
	  );
	};
	
	Database.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Database.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Database;

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Delete = function Delete(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z' }),
	    _react2.default.createElement('line', { x1: '18', y1: '9', x2: '12', y2: '15' }),
	    _react2.default.createElement('line', { x1: '12', y1: '9', x2: '18', y2: '15' })
	  );
	};
	
	Delete.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Delete.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Delete;

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Disc = function Disc(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '3' })
	  );
	};
	
	Disc.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Disc.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Disc;

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DollarSign = function DollarSign(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '12', y1: '1', x2: '12', y2: '23' }),
	    _react2.default.createElement('path', { d: 'M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6' })
	  );
	};
	
	DollarSign.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	DollarSign.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = DollarSign;

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DownloadCloud = function DownloadCloud(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '8 17 12 21 16 17' }),
	    _react2.default.createElement('line', { x1: '12', y1: '12', x2: '12', y2: '21' }),
	    _react2.default.createElement('path', { d: 'M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29' })
	  );
	};
	
	DownloadCloud.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	DownloadCloud.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = DownloadCloud;

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Download = function Download(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' }),
	    _react2.default.createElement('polyline', { points: '7 10 12 15 17 10' }),
	    _react2.default.createElement('line', { x1: '12', y1: '15', x2: '12', y2: '3' })
	  );
	};
	
	Download.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Download.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Download;

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Droplet = function Droplet(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z' })
	  );
	};
	
	Droplet.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Droplet.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Droplet;

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Edit2 = function Edit2(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '16 3 21 8 8 21 3 21 3 16 16 3' })
	  );
	};
	
	Edit2.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Edit2.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Edit2;

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Edit3 = function Edit3(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '14 2 18 6 7 17 3 17 3 13 14 2' }),
	    _react2.default.createElement('line', { x1: '3', y1: '22', x2: '21', y2: '22' })
	  );
	};
	
	Edit3.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Edit3.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Edit3;

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Edit = function Edit(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34' }),
	    _react2.default.createElement('polygon', { points: '18 2 22 6 12 16 8 16 8 12 18 2' })
	  );
	};
	
	Edit.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Edit.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Edit;

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ExternalLink = function ExternalLink(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6' }),
	    _react2.default.createElement('polyline', { points: '15 3 21 3 21 9' }),
	    _react2.default.createElement('line', { x1: '10', y1: '14', x2: '21', y2: '3' })
	  );
	};
	
	ExternalLink.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ExternalLink.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ExternalLink;

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var EyeOff = function EyeOff(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24' }),
	    _react2.default.createElement('line', { x1: '1', y1: '1', x2: '23', y2: '23' })
	  );
	};
	
	EyeOff.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	EyeOff.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = EyeOff;

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Eye = function Eye(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z' }),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '3' })
	  );
	};
	
	Eye.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Eye.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Eye;

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Facebook = function Facebook(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z' })
	  );
	};
	
	Facebook.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Facebook.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Facebook;

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FastForward = function FastForward(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '13 19 22 12 13 5 13 19' }),
	    _react2.default.createElement('polygon', { points: '2 19 11 12 2 5 2 19' })
	  );
	};
	
	FastForward.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	FastForward.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = FastForward;

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Feather = function Feather(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z' }),
	    _react2.default.createElement('line', { x1: '16', y1: '8', x2: '2', y2: '22' }),
	    _react2.default.createElement('line', { x1: '17.5', y1: '15', x2: '9', y2: '15' })
	  );
	};
	
	Feather.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Feather.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Feather;

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FileMinus = function FileMinus(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' }),
	    _react2.default.createElement('polyline', { points: '14 2 14 8 20 8' }),
	    _react2.default.createElement('line', { x1: '9', y1: '15', x2: '15', y2: '15' })
	  );
	};
	
	FileMinus.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	FileMinus.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = FileMinus;

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FilePlus = function FilePlus(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' }),
	    _react2.default.createElement('polyline', { points: '14 2 14 8 20 8' }),
	    _react2.default.createElement('line', { x1: '12', y1: '18', x2: '12', y2: '12' }),
	    _react2.default.createElement('line', { x1: '9', y1: '15', x2: '15', y2: '15' })
	  );
	};
	
	FilePlus.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	FilePlus.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = FilePlus;

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FileText = function FileText(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' }),
	    _react2.default.createElement('polyline', { points: '14 2 14 8 20 8' }),
	    _react2.default.createElement('line', { x1: '16', y1: '13', x2: '8', y2: '13' }),
	    _react2.default.createElement('line', { x1: '16', y1: '17', x2: '8', y2: '17' }),
	    _react2.default.createElement('polyline', { points: '10 9 9 9 8 9' })
	  );
	};
	
	FileText.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	FileText.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = FileText;

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var File = function File(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z' }),
	    _react2.default.createElement('polyline', { points: '13 2 13 9 20 9' })
	  );
	};
	
	File.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	File.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = File;

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Film = function Film(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '2', y: '2', width: '20', height: '20', rx: '2.18', ry: '2.18' }),
	    _react2.default.createElement('line', { x1: '7', y1: '2', x2: '7', y2: '22' }),
	    _react2.default.createElement('line', { x1: '17', y1: '2', x2: '17', y2: '22' }),
	    _react2.default.createElement('line', { x1: '2', y1: '12', x2: '22', y2: '12' }),
	    _react2.default.createElement('line', { x1: '2', y1: '7', x2: '7', y2: '7' }),
	    _react2.default.createElement('line', { x1: '2', y1: '17', x2: '7', y2: '17' }),
	    _react2.default.createElement('line', { x1: '17', y1: '17', x2: '22', y2: '17' }),
	    _react2.default.createElement('line', { x1: '17', y1: '7', x2: '22', y2: '7' })
	  );
	};
	
	Film.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Film.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Film;

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Filter = function Filter(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3' })
	  );
	};
	
	Filter.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Filter.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Filter;

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Flag = function Flag(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z' }),
	    _react2.default.createElement('line', { x1: '4', y1: '22', x2: '4', y2: '15' })
	  );
	};
	
	Flag.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Flag.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Flag;

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FolderMinus = function FolderMinus(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z' }),
	    _react2.default.createElement('line', { x1: '9', y1: '14', x2: '15', y2: '14' })
	  );
	};
	
	FolderMinus.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	FolderMinus.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = FolderMinus;

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FolderPlus = function FolderPlus(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z' }),
	    _react2.default.createElement('line', { x1: '12', y1: '11', x2: '12', y2: '17' }),
	    _react2.default.createElement('line', { x1: '9', y1: '14', x2: '15', y2: '14' })
	  );
	};
	
	FolderPlus.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	FolderPlus.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = FolderPlus;

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Folder = function Folder(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z' })
	  );
	};
	
	Folder.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Folder.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Folder;

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Frown = function Frown(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      viewBox: '0 0 24 24',
	      width: size,
	      height: size,
	      xmlns: 'http://www.w3.org/2000/svg',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('path', { d: 'M16 16s-1.5-2-4-2-4 2-4 2' }),
	    _react2.default.createElement('line', { x1: '9', y1: '9', x2: '9.01', y2: '9' }),
	    _react2.default.createElement('line', { x1: '15', y1: '9', x2: '15.01', y2: '9' })
	  );
	};
	
	Frown.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Frown.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Frown;

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Gift = function Gift(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '20 12 20 22 4 22 4 12' }),
	    _react2.default.createElement('rect', { x: '2', y: '7', width: '20', height: '5' }),
	    _react2.default.createElement('line', { x1: '12', y1: '22', x2: '12', y2: '7' }),
	    _react2.default.createElement('path', { d: 'M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z' }),
	    _react2.default.createElement('path', { d: 'M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z' })
	  );
	};
	
	Gift.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Gift.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Gift;

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var GitBranch = function GitBranch(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '6', y1: '3', x2: '6', y2: '15' }),
	    _react2.default.createElement('circle', { cx: '18', cy: '6', r: '3' }),
	    _react2.default.createElement('circle', { cx: '6', cy: '18', r: '3' }),
	    _react2.default.createElement('path', { d: 'M18 9a9 9 0 0 1-9 9' })
	  );
	};
	
	GitBranch.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	GitBranch.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = GitBranch;

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var GitCommit = function GitCommit(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '4' }),
	    _react2.default.createElement('line', { x1: '1.05', y1: '12', x2: '7', y2: '12' }),
	    _react2.default.createElement('line', { x1: '17.01', y1: '12', x2: '22.96', y2: '12' })
	  );
	};
	
	GitCommit.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	GitCommit.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = GitCommit;

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var GitMerge = function GitMerge(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '18', cy: '18', r: '3' }),
	    _react2.default.createElement('circle', { cx: '6', cy: '6', r: '3' }),
	    _react2.default.createElement('path', { d: 'M6 21V9a9 9 0 0 0 9 9' })
	  );
	};
	
	GitMerge.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	GitMerge.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = GitMerge;

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var GitPullRequest = function GitPullRequest(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '18', cy: '18', r: '3' }),
	    _react2.default.createElement('circle', { cx: '6', cy: '6', r: '3' }),
	    _react2.default.createElement('path', { d: 'M13 6h3a2 2 0 0 1 2 2v7' }),
	    _react2.default.createElement('line', { x1: '6', y1: '9', x2: '6', y2: '21' })
	  );
	};
	
	GitPullRequest.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	GitPullRequest.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = GitPullRequest;

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var GitHub = function GitHub(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22' })
	  );
	};
	
	GitHub.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	GitHub.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = GitHub;

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Gitlab = function Gitlab(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z' })
	  );
	};
	
	Gitlab.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Gitlab.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Gitlab;

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Globe = function Globe(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('line', { x1: '2', y1: '12', x2: '22', y2: '12' }),
	    _react2.default.createElement('path', { d: 'M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z' })
	  );
	};
	
	Globe.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Globe.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Globe;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Grid = function Grid(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '3', y: '3', width: '7', height: '7' }),
	    _react2.default.createElement('rect', { x: '14', y: '3', width: '7', height: '7' }),
	    _react2.default.createElement('rect', { x: '14', y: '14', width: '7', height: '7' }),
	    _react2.default.createElement('rect', { x: '3', y: '14', width: '7', height: '7' })
	  );
	};
	
	Grid.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Grid.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Grid;

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var HardDrive = function HardDrive(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '22', y1: '12', x2: '2', y2: '12' }),
	    _react2.default.createElement('path', { d: 'M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z' }),
	    _react2.default.createElement('line', { x1: '6', y1: '16', x2: '6', y2: '16' }),
	    _react2.default.createElement('line', { x1: '10', y1: '16', x2: '10', y2: '16' })
	  );
	};
	
	HardDrive.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	HardDrive.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = HardDrive;

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Hash = function Hash(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '4', y1: '9', x2: '20', y2: '9' }),
	    _react2.default.createElement('line', { x1: '4', y1: '15', x2: '20', y2: '15' }),
	    _react2.default.createElement('line', { x1: '10', y1: '3', x2: '8', y2: '21' }),
	    _react2.default.createElement('line', { x1: '16', y1: '3', x2: '14', y2: '21' })
	  );
	};
	
	Hash.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Hash.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Hash;

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Headphones = function Headphones(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M3 18v-6a9 9 0 0 1 18 0v6' }),
	    _react2.default.createElement('path', { d: 'M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z' })
	  );
	};
	
	Headphones.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Headphones.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Headphones;

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Heart = function Heart(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z' })
	  );
	};
	
	Heart.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Heart.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Heart;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var HelpCircle = function HelpCircle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('path', { d: 'M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3' }),
	    _react2.default.createElement('line', { x1: '12', y1: '17', x2: '12', y2: '17' })
	  );
	};
	
	HelpCircle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	HelpCircle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = HelpCircle;

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Home = function Home(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z' }),
	    _react2.default.createElement('polyline', { points: '9 22 9 12 15 12 15 22' })
	  );
	};
	
	Home.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Home.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Home;

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Image = function Image(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }),
	    _react2.default.createElement('circle', { cx: '8.5', cy: '8.5', r: '1.5' }),
	    _react2.default.createElement('polyline', { points: '21 15 16 10 5 21' })
	  );
	};
	
	Image.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Image.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Image;

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Inbox = function Inbox(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '22 12 16 12 14 15 10 15 8 12 2 12' }),
	    _react2.default.createElement('path', { d: 'M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z' })
	  );
	};
	
	Inbox.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Inbox.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Inbox;

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Info = function Info(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('line', { x1: '12', y1: '16', x2: '12', y2: '12' }),
	    _react2.default.createElement('line', { x1: '12', y1: '8', x2: '12', y2: '8' })
	  );
	};
	
	Info.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Info.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Info;

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Instagram = function Instagram(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '2', y: '2', width: '20', height: '20', rx: '5', ry: '5' }),
	    _react2.default.createElement('path', { d: 'M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z' }),
	    _react2.default.createElement('line', { x1: '17.5', y1: '6.5', x2: '17.5', y2: '6.5' })
	  );
	};
	
	Instagram.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Instagram.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Instagram;

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Italic = function Italic(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '19', y1: '4', x2: '10', y2: '4' }),
	    _react2.default.createElement('line', { x1: '14', y1: '20', x2: '5', y2: '20' }),
	    _react2.default.createElement('line', { x1: '15', y1: '4', x2: '9', y2: '20' })
	  );
	};
	
	Italic.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Italic.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Italic;

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Key = function Key(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      xmlns: 'http://www.w3.org/2000/svg',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4' })
	  );
	};
	
	Key.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Key.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Key;

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Layers = function Layers(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '12 2 2 7 12 12 22 7 12 2' }),
	    _react2.default.createElement('polyline', { points: '2 17 12 22 22 17' }),
	    _react2.default.createElement('polyline', { points: '2 12 12 17 22 12' })
	  );
	};
	
	Layers.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Layers.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Layers;

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Layout = function Layout(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }),
	    _react2.default.createElement('line', { x1: '3', y1: '9', x2: '21', y2: '9' }),
	    _react2.default.createElement('line', { x1: '9', y1: '21', x2: '9', y2: '9' })
	  );
	};
	
	Layout.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Layout.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Layout;

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var LifeBuoy = function LifeBuoy(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '4' }),
	    _react2.default.createElement('line', { x1: '4.93', y1: '4.93', x2: '9.17', y2: '9.17' }),
	    _react2.default.createElement('line', { x1: '14.83', y1: '14.83', x2: '19.07', y2: '19.07' }),
	    _react2.default.createElement('line', { x1: '14.83', y1: '9.17', x2: '19.07', y2: '4.93' }),
	    _react2.default.createElement('line', { x1: '14.83', y1: '9.17', x2: '18.36', y2: '5.64' }),
	    _react2.default.createElement('line', { x1: '4.93', y1: '19.07', x2: '9.17', y2: '14.83' })
	  );
	};
	
	LifeBuoy.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	LifeBuoy.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = LifeBuoy;

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Link2 = function Link2(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3' }),
	    _react2.default.createElement('line', { x1: '8', y1: '12', x2: '16', y2: '12' })
	  );
	};
	
	Link2.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Link2.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Link2;

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Link = function Link(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71' }),
	    _react2.default.createElement('path', { d: 'M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71' })
	  );
	};
	
	Link.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Link.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Link;

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Linkedin = function Linkedin(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z' }),
	    _react2.default.createElement('rect', { x: '2', y: '9', width: '4', height: '12' }),
	    _react2.default.createElement('circle', { cx: '4', cy: '4', r: '2' })
	  );
	};
	
	Linkedin.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Linkedin.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Linkedin;

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var List = function List(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '8', y1: '6', x2: '21', y2: '6' }),
	    _react2.default.createElement('line', { x1: '8', y1: '12', x2: '21', y2: '12' }),
	    _react2.default.createElement('line', { x1: '8', y1: '18', x2: '21', y2: '18' }),
	    _react2.default.createElement('line', { x1: '3', y1: '6', x2: '3', y2: '6' }),
	    _react2.default.createElement('line', { x1: '3', y1: '12', x2: '3', y2: '12' }),
	    _react2.default.createElement('line', { x1: '3', y1: '18', x2: '3', y2: '18' })
	  );
	};
	
	List.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	List.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = List;

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Loader = function Loader(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '12', y1: '2', x2: '12', y2: '6' }),
	    _react2.default.createElement('line', { x1: '12', y1: '18', x2: '12', y2: '22' }),
	    _react2.default.createElement('line', { x1: '4.93', y1: '4.93', x2: '7.76', y2: '7.76' }),
	    _react2.default.createElement('line', { x1: '16.24', y1: '16.24', x2: '19.07', y2: '19.07' }),
	    _react2.default.createElement('line', { x1: '2', y1: '12', x2: '6', y2: '12' }),
	    _react2.default.createElement('line', { x1: '18', y1: '12', x2: '22', y2: '12' }),
	    _react2.default.createElement('line', { x1: '4.93', y1: '19.07', x2: '7.76', y2: '16.24' }),
	    _react2.default.createElement('line', { x1: '16.24', y1: '7.76', x2: '19.07', y2: '4.93' })
	  );
	};
	
	Loader.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Loader.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Loader;

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Lock = function Lock(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '3', y: '11', width: '18', height: '11', rx: '2', ry: '2' }),
	    _react2.default.createElement('path', { d: 'M7 11V7a5 5 0 0 1 10 0v4' })
	  );
	};
	
	Lock.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Lock.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Lock;

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var LogIn = function LogIn(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4' }),
	    _react2.default.createElement('polyline', { points: '10 17 15 12 10 7' }),
	    _react2.default.createElement('line', { x1: '15', y1: '12', x2: '3', y2: '12' })
	  );
	};
	
	LogIn.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	LogIn.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = LogIn;

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var LogOut = function LogOut(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4' }),
	    _react2.default.createElement('polyline', { points: '16 17 21 12 16 7' }),
	    _react2.default.createElement('line', { x1: '21', y1: '12', x2: '9', y2: '12' })
	  );
	};
	
	LogOut.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	LogOut.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = LogOut;

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Mail = function Mail(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z' }),
	    _react2.default.createElement('polyline', { points: '22,6 12,13 2,6' })
	  );
	};
	
	Mail.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Mail.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Mail;

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MapPin = function MapPin(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z' }),
	    _react2.default.createElement('circle', { cx: '12', cy: '10', r: '3' })
	  );
	};
	
	MapPin.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	MapPin.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = MapPin;

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Map = function Map(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6' }),
	    _react2.default.createElement('line', { x1: '8', y1: '2', x2: '8', y2: '18' }),
	    _react2.default.createElement('line', { x1: '16', y1: '6', x2: '16', y2: '22' })
	  );
	};
	
	Map.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Map.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Map;

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Maximize2 = function Maximize2(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '15 3 21 3 21 9' }),
	    _react2.default.createElement('polyline', { points: '9 21 3 21 3 15' }),
	    _react2.default.createElement('line', { x1: '21', y1: '3', x2: '14', y2: '10' }),
	    _react2.default.createElement('line', { x1: '3', y1: '21', x2: '10', y2: '14' })
	  );
	};
	
	Maximize2.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Maximize2.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Maximize2;

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Maximize = function Maximize(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3' })
	  );
	};
	
	Maximize.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Maximize.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Maximize;

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Meh = function Meh(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      viewBox: '0 0 24 24',
	      width: size,
	      height: size,
	      xmlns: 'http://www.w3.org/2000/svg',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('line', { x1: '8', y1: '15', x2: '16', y2: '15' }),
	    _react2.default.createElement('line', { x1: '9', y1: '9', x2: '9.01', y2: '9' }),
	    _react2.default.createElement('line', { x1: '15', y1: '9', x2: '15.01', y2: '9' })
	  );
	};
	
	Meh.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Meh.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Meh;

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Menu = function Menu(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '3', y1: '12', x2: '21', y2: '12' }),
	    _react2.default.createElement('line', { x1: '3', y1: '6', x2: '21', y2: '6' }),
	    _react2.default.createElement('line', { x1: '3', y1: '18', x2: '21', y2: '18' })
	  );
	};
	
	Menu.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Menu.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Menu;

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MessageCircle = function MessageCircle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z' })
	  );
	};
	
	MessageCircle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	MessageCircle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = MessageCircle;

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MessageSquare = function MessageSquare(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z' })
	  );
	};
	
	MessageSquare.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	MessageSquare.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = MessageSquare;

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MicOff = function MicOff(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '1', y1: '1', x2: '23', y2: '23' }),
	    _react2.default.createElement('path', { d: 'M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6' }),
	    _react2.default.createElement('path', { d: 'M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23' }),
	    _react2.default.createElement('line', { x1: '12', y1: '19', x2: '12', y2: '23' }),
	    _react2.default.createElement('line', { x1: '8', y1: '23', x2: '16', y2: '23' })
	  );
	};
	
	MicOff.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	MicOff.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = MicOff;

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Mic = function Mic(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z' }),
	    _react2.default.createElement('path', { d: 'M19 10v2a7 7 0 0 1-14 0v-2' }),
	    _react2.default.createElement('line', { x1: '12', y1: '19', x2: '12', y2: '23' }),
	    _react2.default.createElement('line', { x1: '8', y1: '23', x2: '16', y2: '23' })
	  );
	};
	
	Mic.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Mic.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Mic;

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Minimize2 = function Minimize2(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '4 14 10 14 10 20' }),
	    _react2.default.createElement('polyline', { points: '20 10 14 10 14 4' }),
	    _react2.default.createElement('line', { x1: '14', y1: '10', x2: '21', y2: '3' }),
	    _react2.default.createElement('line', { x1: '3', y1: '21', x2: '10', y2: '14' })
	  );
	};
	
	Minimize2.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Minimize2.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Minimize2;

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Minimize = function Minimize(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3' })
	  );
	};
	
	Minimize.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Minimize.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Minimize;

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MinusCircle = function MinusCircle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('line', { x1: '8', y1: '12', x2: '16', y2: '12' })
	  );
	};
	
	MinusCircle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	MinusCircle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = MinusCircle;

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MinusSquare = function MinusSquare(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }),
	    _react2.default.createElement('line', { x1: '8', y1: '12', x2: '16', y2: '12' })
	  );
	};
	
	MinusSquare.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	MinusSquare.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = MinusSquare;

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Minus = function Minus(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '5', y1: '12', x2: '19', y2: '12' })
	  );
	};
	
	Minus.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Minus.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Minus;

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Monitor = function Monitor(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '2', y: '3', width: '20', height: '14', rx: '2', ry: '2' }),
	    _react2.default.createElement('line', { x1: '8', y1: '21', x2: '16', y2: '21' }),
	    _react2.default.createElement('line', { x1: '12', y1: '17', x2: '12', y2: '21' })
	  );
	};
	
	Monitor.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Monitor.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Monitor;

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Moon = function Moon(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z' })
	  );
	};
	
	Moon.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Moon.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Moon;

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MoreHorizontal = function MoreHorizontal(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '1' }),
	    _react2.default.createElement('circle', { cx: '19', cy: '12', r: '1' }),
	    _react2.default.createElement('circle', { cx: '5', cy: '12', r: '1' })
	  );
	};
	
	MoreHorizontal.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	MoreHorizontal.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = MoreHorizontal;

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MoreVertical = function MoreVertical(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '1' }),
	    _react2.default.createElement('circle', { cx: '12', cy: '5', r: '1' }),
	    _react2.default.createElement('circle', { cx: '12', cy: '19', r: '1' })
	  );
	};
	
	MoreVertical.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	MoreVertical.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = MoreVertical;

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Move = function Move(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '5 9 2 12 5 15' }),
	    _react2.default.createElement('polyline', { points: '9 5 12 2 15 5' }),
	    _react2.default.createElement('polyline', { points: '15 19 12 22 9 19' }),
	    _react2.default.createElement('polyline', { points: '19 9 22 12 19 15' }),
	    _react2.default.createElement('line', { x1: '2', y1: '12', x2: '22', y2: '12' }),
	    _react2.default.createElement('line', { x1: '12', y1: '2', x2: '12', y2: '22' })
	  );
	};
	
	Move.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Move.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Move;

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Music = function Music(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M9 17H5a2 2 0 0 0-2 2 2 2 0 0 0 2 2h2a2 2 0 0 0 2-2zm12-2h-4a2 2 0 0 0-2 2 2 2 0 0 0 2 2h2a2 2 0 0 0 2-2z' }),
	    _react2.default.createElement('polyline', { points: '9 17 9 5 21 3 21 15' })
	  );
	};
	
	Music.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Music.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Music;

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Navigation2 = function Navigation2(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '12 2 19 21 12 17 5 21 12 2' })
	  );
	};
	
	Navigation2.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Navigation2.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Navigation2;

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Navigation = function Navigation(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '3 11 22 2 13 21 11 13 3 11' })
	  );
	};
	
	Navigation.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Navigation.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Navigation;

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Octagon = function Octagon(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2' })
	  );
	};
	
	Octagon.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Octagon.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Octagon;

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Package = function Package(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M12.89 1.45l8 4A2 2 0 0 1 22 7.24v9.53a2 2 0 0 1-1.11 1.79l-8 4a2 2 0 0 1-1.79 0l-8-4a2 2 0 0 1-1.1-1.8V7.24a2 2 0 0 1 1.11-1.79l8-4a2 2 0 0 1 1.78 0z' }),
	    _react2.default.createElement('polyline', { points: '2.32 6.16 12 11 21.68 6.16' }),
	    _react2.default.createElement('line', { x1: '12', y1: '22.76', x2: '12', y2: '11' }),
	    _react2.default.createElement('line', { x1: '7', y1: '3.5', x2: '17', y2: '8.5' })
	  );
	};
	
	Package.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Package.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Package;

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Paperclip = function Paperclip(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48' })
	  );
	};
	
	Paperclip.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Paperclip.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Paperclip;

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PauseCircle = function PauseCircle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('line', { x1: '10', y1: '15', x2: '10', y2: '9' }),
	    _react2.default.createElement('line', { x1: '14', y1: '15', x2: '14', y2: '9' })
	  );
	};
	
	PauseCircle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	PauseCircle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = PauseCircle;

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Pause = function Pause(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '6', y: '4', width: '4', height: '16' }),
	    _react2.default.createElement('rect', { x: '14', y: '4', width: '4', height: '16' })
	  );
	};
	
	Pause.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Pause.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Pause;

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Percent = function Percent(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '19', y1: '5', x2: '5', y2: '19' }),
	    _react2.default.createElement('circle', { cx: '6.5', cy: '6.5', r: '2.5' }),
	    _react2.default.createElement('circle', { cx: '17.5', cy: '17.5', r: '2.5' })
	  );
	};
	
	Percent.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Percent.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Percent;

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PhoneCall = function PhoneCall(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z' })
	  );
	};
	
	PhoneCall.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	PhoneCall.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = PhoneCall;

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PhoneForwarded = function PhoneForwarded(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '19 1 23 5 19 9' }),
	    _react2.default.createElement('line', { x1: '15', y1: '5', x2: '23', y2: '5' }),
	    _react2.default.createElement('path', { d: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z' })
	  );
	};
	
	PhoneForwarded.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	PhoneForwarded.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = PhoneForwarded;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PhoneIncoming = function PhoneIncoming(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '16 2 16 8 22 8' }),
	    _react2.default.createElement('line', { x1: '23', y1: '1', x2: '16', y2: '8' }),
	    _react2.default.createElement('path', { d: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z' })
	  );
	};
	
	PhoneIncoming.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	PhoneIncoming.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = PhoneIncoming;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PhoneMissed = function PhoneMissed(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '23', y1: '1', x2: '17', y2: '7' }),
	    _react2.default.createElement('line', { x1: '17', y1: '1', x2: '23', y2: '7' }),
	    _react2.default.createElement('path', { d: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z' })
	  );
	};
	
	PhoneMissed.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	PhoneMissed.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = PhoneMissed;

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PhoneOff = function PhoneOff(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91' }),
	    _react2.default.createElement('line', { x1: '23', y1: '1', x2: '1', y2: '23' })
	  );
	};
	
	PhoneOff.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	PhoneOff.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = PhoneOff;

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PhoneOutgoing = function PhoneOutgoing(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '23 7 23 1 17 1' }),
	    _react2.default.createElement('line', { x1: '16', y1: '8', x2: '23', y2: '1' }),
	    _react2.default.createElement('path', { d: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z' })
	  );
	};
	
	PhoneOutgoing.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	PhoneOutgoing.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = PhoneOutgoing;

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Phone = function Phone(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z' })
	  );
	};
	
	Phone.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Phone.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Phone;

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PieChart = function PieChart(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M21.21 15.89A10 10 0 1 1 8 2.83' }),
	    _react2.default.createElement('path', { d: 'M22 12A10 10 0 0 0 12 2v10z' })
	  );
	};
	
	PieChart.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	PieChart.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = PieChart;

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PlayCircle = function PlayCircle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('polygon', { points: '10 8 16 12 10 16 10 8' })
	  );
	};
	
	PlayCircle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	PlayCircle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = PlayCircle;

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Play = function Play(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '5 3 19 12 5 21 5 3' })
	  );
	};
	
	Play.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Play.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Play;

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PlusCircle = function PlusCircle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('line', { x1: '12', y1: '8', x2: '12', y2: '16' }),
	    _react2.default.createElement('line', { x1: '8', y1: '12', x2: '16', y2: '12' })
	  );
	};
	
	PlusCircle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	PlusCircle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = PlusCircle;

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PlusSquare = function PlusSquare(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }),
	    _react2.default.createElement('line', { x1: '12', y1: '8', x2: '12', y2: '16' }),
	    _react2.default.createElement('line', { x1: '8', y1: '12', x2: '16', y2: '12' })
	  );
	};
	
	PlusSquare.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	PlusSquare.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = PlusSquare;

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Plus = function Plus(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '12', y1: '5', x2: '12', y2: '19' }),
	    _react2.default.createElement('line', { x1: '5', y1: '12', x2: '19', y2: '12' })
	  );
	};
	
	Plus.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Plus.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Plus;

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Pocket = function Pocket(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z' }),
	    _react2.default.createElement('polyline', { points: '8 10 12 14 16 10' })
	  );
	};
	
	Pocket.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Pocket.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Pocket;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Power = function Power(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M18.36 6.64a9 9 0 1 1-12.73 0' }),
	    _react2.default.createElement('line', { x1: '12', y1: '2', x2: '12', y2: '12' })
	  );
	};
	
	Power.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Power.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Power;

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Printer = function Printer(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '6 9 6 2 18 2 18 9' }),
	    _react2.default.createElement('path', { d: 'M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2' }),
	    _react2.default.createElement('rect', { x: '6', y: '14', width: '12', height: '8' })
	  );
	};
	
	Printer.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Printer.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Printer;

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Radio = function Radio(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '2' }),
	    _react2.default.createElement('path', { d: 'M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14' })
	  );
	};
	
	Radio.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Radio.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Radio;

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var RefreshCcw = function RefreshCcw(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '1 4 1 10 7 10' }),
	    _react2.default.createElement('polyline', { points: '23 20 23 14 17 14' }),
	    _react2.default.createElement('path', { d: 'M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15' })
	  );
	};
	
	RefreshCcw.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	RefreshCcw.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = RefreshCcw;

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var RefreshCw = function RefreshCw(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '23 4 23 10 17 10' }),
	    _react2.default.createElement('polyline', { points: '1 20 1 14 7 14' }),
	    _react2.default.createElement('path', { d: 'M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15' })
	  );
	};
	
	RefreshCw.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	RefreshCw.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = RefreshCw;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Repeat = function Repeat(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '17 1 21 5 17 9' }),
	    _react2.default.createElement('path', { d: 'M3 11V9a4 4 0 0 1 4-4h14' }),
	    _react2.default.createElement('polyline', { points: '7 23 3 19 7 15' }),
	    _react2.default.createElement('path', { d: 'M21 13v2a4 4 0 0 1-4 4H3' })
	  );
	};
	
	Repeat.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Repeat.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Repeat;

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Rewind = function Rewind(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '11 19 2 12 11 5 11 19' }),
	    _react2.default.createElement('polygon', { points: '22 19 13 12 22 5 22 19' })
	  );
	};
	
	Rewind.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Rewind.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Rewind;

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var RotateCcw = function RotateCcw(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '1 4 1 10 7 10' }),
	    _react2.default.createElement('path', { d: 'M3.51 15a9 9 0 1 0 2.13-9.36L1 10' })
	  );
	};
	
	RotateCcw.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	RotateCcw.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = RotateCcw;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var RotateCw = function RotateCw(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '23 4 23 10 17 10' }),
	    _react2.default.createElement('path', { d: 'M20.49 15a9 9 0 1 1-2.12-9.36L23 10' })
	  );
	};
	
	RotateCw.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	RotateCw.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = RotateCw;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Rss = function Rss(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M4 11a9 9 0 0 1 9 9' }),
	    _react2.default.createElement('path', { d: 'M4 4a16 16 0 0 1 16 16' }),
	    _react2.default.createElement('circle', { cx: '5', cy: '19', r: '1' })
	  );
	};
	
	Rss.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Rss.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Rss;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Save = function Save(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z' }),
	    _react2.default.createElement('polyline', { points: '17 21 17 13 7 13 7 21' }),
	    _react2.default.createElement('polyline', { points: '7 3 7 8 15 8' })
	  );
	};
	
	Save.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Save.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Save;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Scissors = function Scissors(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '6', cy: '6', r: '3' }),
	    _react2.default.createElement('circle', { cx: '6', cy: '18', r: '3' }),
	    _react2.default.createElement('line', { x1: '20', y1: '4', x2: '8.12', y2: '15.88' }),
	    _react2.default.createElement('line', { x1: '14.47', y1: '14.48', x2: '20', y2: '20' }),
	    _react2.default.createElement('line', { x1: '8.12', y1: '8.12', x2: '12', y2: '12' })
	  );
	};
	
	Scissors.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Scissors.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Scissors;

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Search = function Search(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '11', cy: '11', r: '8' }),
	    _react2.default.createElement('line', { x1: '21', y1: '21', x2: '16.65', y2: '16.65' })
	  );
	};
	
	Search.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Search.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Search;

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Send = function Send(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '22', y1: '2', x2: '11', y2: '13' }),
	    _react2.default.createElement('polygon', { points: '22 2 15 22 11 13 2 9 22 2' })
	  );
	};
	
	Send.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Send.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Send;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Server = function Server(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '2', y: '2', width: '20', height: '8', rx: '2', ry: '2' }),
	    _react2.default.createElement('rect', { x: '2', y: '14', width: '20', height: '8', rx: '2', ry: '2' }),
	    _react2.default.createElement('line', { x1: '6', y1: '6', x2: '6', y2: '6' }),
	    _react2.default.createElement('line', { x1: '6', y1: '18', x2: '6', y2: '18' })
	  );
	};
	
	Server.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Server.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Server;

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Settings = function Settings(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '3' }),
	    _react2.default.createElement('path', { d: 'M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z' })
	  );
	};
	
	Settings.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Settings.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Settings;

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Share2 = function Share2(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '18', cy: '5', r: '3' }),
	    _react2.default.createElement('circle', { cx: '6', cy: '12', r: '3' }),
	    _react2.default.createElement('circle', { cx: '18', cy: '19', r: '3' }),
	    _react2.default.createElement('line', { x1: '8.59', y1: '13.51', x2: '15.42', y2: '17.49' }),
	    _react2.default.createElement('line', { x1: '15.41', y1: '6.51', x2: '8.59', y2: '10.49' })
	  );
	};
	
	Share2.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Share2.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Share2;

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Share = function Share(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8' }),
	    _react2.default.createElement('polyline', { points: '16 6 12 2 8 6' }),
	    _react2.default.createElement('line', { x1: '12', y1: '2', x2: '12', y2: '15' })
	  );
	};
	
	Share.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Share.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Share;

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ShieldOff = function ShieldOff(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18' }),
	    _react2.default.createElement('path', { d: 'M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38' }),
	    _react2.default.createElement('line', { x1: '1', y1: '1', x2: '23', y2: '23' })
	  );
	};
	
	ShieldOff.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ShieldOff.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ShieldOff;

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Shield = function Shield(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' })
	  );
	};
	
	Shield.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Shield.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Shield;

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ShoppingBag = function ShoppingBag(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z' }),
	    _react2.default.createElement('line', { x1: '3', y1: '6', x2: '21', y2: '6' }),
	    _react2.default.createElement('path', { d: 'M16 10a4 4 0 0 1-8 0' })
	  );
	};
	
	ShoppingBag.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ShoppingBag.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ShoppingBag;

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ShoppingCart = function ShoppingCart(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '9', cy: '21', r: '1' }),
	    _react2.default.createElement('circle', { cx: '20', cy: '21', r: '1' }),
	    _react2.default.createElement('path', { d: 'M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6' })
	  );
	};
	
	ShoppingCart.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ShoppingCart.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ShoppingCart;

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Shuffle = function Shuffle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '16 3 21 3 21 8' }),
	    _react2.default.createElement('line', { x1: '4', y1: '20', x2: '21', y2: '3' }),
	    _react2.default.createElement('polyline', { points: '21 16 21 21 16 21' }),
	    _react2.default.createElement('line', { x1: '15', y1: '15', x2: '21', y2: '21' }),
	    _react2.default.createElement('line', { x1: '4', y1: '4', x2: '9', y2: '9' })
	  );
	};
	
	Shuffle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Shuffle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Shuffle;

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Sidebar = function Sidebar(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }),
	    _react2.default.createElement('line', { x1: '9', y1: '3', x2: '9', y2: '21' })
	  );
	};
	
	Sidebar.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Sidebar.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Sidebar;

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var SkipBack = function SkipBack(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '19 20 9 12 19 4 19 20' }),
	    _react2.default.createElement('line', { x1: '5', y1: '19', x2: '5', y2: '5' })
	  );
	};
	
	SkipBack.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	SkipBack.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = SkipBack;

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var SkipForward = function SkipForward(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '5 4 15 12 5 20 5 4' }),
	    _react2.default.createElement('line', { x1: '19', y1: '5', x2: '19', y2: '19' })
	  );
	};
	
	SkipForward.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	SkipForward.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = SkipForward;

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Slack = function Slack(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z' }),
	    _react2.default.createElement('path', { d: 'M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' }),
	    _react2.default.createElement('path', { d: 'M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z' }),
	    _react2.default.createElement('path', { d: 'M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z' }),
	    _react2.default.createElement('path', { d: 'M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z' }),
	    _react2.default.createElement('path', { d: 'M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z' }),
	    _react2.default.createElement('path', { d: 'M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z' }),
	    _react2.default.createElement('path', { d: 'M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z' })
	  );
	};
	
	Slack.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Slack.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Slack;

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Slash = function Slash(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('line', { x1: '4.93', y1: '4.93', x2: '19.07', y2: '19.07' })
	  );
	};
	
	Slash.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Slash.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Slash;

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Sliders = function Sliders(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '4', y1: '21', x2: '4', y2: '14' }),
	    _react2.default.createElement('line', { x1: '4', y1: '10', x2: '4', y2: '3' }),
	    _react2.default.createElement('line', { x1: '12', y1: '21', x2: '12', y2: '12' }),
	    _react2.default.createElement('line', { x1: '12', y1: '8', x2: '12', y2: '3' }),
	    _react2.default.createElement('line', { x1: '20', y1: '21', x2: '20', y2: '16' }),
	    _react2.default.createElement('line', { x1: '20', y1: '12', x2: '20', y2: '3' }),
	    _react2.default.createElement('line', { x1: '1', y1: '14', x2: '7', y2: '14' }),
	    _react2.default.createElement('line', { x1: '9', y1: '8', x2: '15', y2: '8' }),
	    _react2.default.createElement('line', { x1: '17', y1: '16', x2: '23', y2: '16' })
	  );
	};
	
	Sliders.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Sliders.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Sliders;

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Smartphone = function Smartphone(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '5', y: '2', width: '14', height: '20', rx: '2', ry: '2' }),
	    _react2.default.createElement('line', { x1: '12', y1: '18', x2: '12', y2: '18' })
	  );
	};
	
	Smartphone.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Smartphone.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Smartphone;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Smile = function Smile(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      viewBox: '0 0 24 24',
	      width: size,
	      height: size,
	      xmlns: 'http://www.w3.org/2000/svg',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('path', { d: 'M8 14s1.5 2 4 2 4-2 4-2' }),
	    _react2.default.createElement('line', { x1: '9', y1: '9', x2: '9.01', y2: '9' }),
	    _react2.default.createElement('line', { x1: '15', y1: '9', x2: '15.01', y2: '9' })
	  );
	};
	
	Smile.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Smile.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Smile;

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Speaker = function Speaker(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '4', y: '2', width: '16', height: '20', rx: '2', ry: '2' }),
	    _react2.default.createElement('circle', { cx: '12', cy: '14', r: '4' }),
	    _react2.default.createElement('line', { x1: '12', y1: '6', x2: '12', y2: '6' })
	  );
	};
	
	Speaker.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Speaker.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Speaker;

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Square = function Square(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' })
	  );
	};
	
	Square.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Square.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Square;

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Star = function Star(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2' })
	  );
	};
	
	Star.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Star.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Star;

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var StopCircle = function StopCircle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('rect', { x: '9', y: '9', width: '6', height: '6' })
	  );
	};
	
	StopCircle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	StopCircle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = StopCircle;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Sun = function Sun(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '5' }),
	    _react2.default.createElement('line', { x1: '12', y1: '1', x2: '12', y2: '3' }),
	    _react2.default.createElement('line', { x1: '12', y1: '21', x2: '12', y2: '23' }),
	    _react2.default.createElement('line', { x1: '4.22', y1: '4.22', x2: '5.64', y2: '5.64' }),
	    _react2.default.createElement('line', { x1: '18.36', y1: '18.36', x2: '19.78', y2: '19.78' }),
	    _react2.default.createElement('line', { x1: '1', y1: '12', x2: '3', y2: '12' }),
	    _react2.default.createElement('line', { x1: '21', y1: '12', x2: '23', y2: '12' }),
	    _react2.default.createElement('line', { x1: '4.22', y1: '19.78', x2: '5.64', y2: '18.36' }),
	    _react2.default.createElement('line', { x1: '18.36', y1: '5.64', x2: '19.78', y2: '4.22' })
	  );
	};
	
	Sun.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Sun.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Sun;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Sunrise = function Sunrise(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M17 18a5 5 0 0 0-10 0' }),
	    _react2.default.createElement('line', { x1: '12', y1: '2', x2: '12', y2: '9' }),
	    _react2.default.createElement('line', { x1: '4.22', y1: '10.22', x2: '5.64', y2: '11.64' }),
	    _react2.default.createElement('line', { x1: '1', y1: '18', x2: '3', y2: '18' }),
	    _react2.default.createElement('line', { x1: '21', y1: '18', x2: '23', y2: '18' }),
	    _react2.default.createElement('line', { x1: '18.36', y1: '11.64', x2: '19.78', y2: '10.22' }),
	    _react2.default.createElement('line', { x1: '23', y1: '22', x2: '1', y2: '22' }),
	    _react2.default.createElement('polyline', { points: '8 6 12 2 16 6' })
	  );
	};
	
	Sunrise.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Sunrise.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Sunrise;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Sunset = function Sunset(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M17 18a5 5 0 0 0-10 0' }),
	    _react2.default.createElement('line', { x1: '12', y1: '9', x2: '12', y2: '2' }),
	    _react2.default.createElement('line', { x1: '4.22', y1: '10.22', x2: '5.64', y2: '11.64' }),
	    _react2.default.createElement('line', { x1: '1', y1: '18', x2: '3', y2: '18' }),
	    _react2.default.createElement('line', { x1: '21', y1: '18', x2: '23', y2: '18' }),
	    _react2.default.createElement('line', { x1: '18.36', y1: '11.64', x2: '19.78', y2: '10.22' }),
	    _react2.default.createElement('line', { x1: '23', y1: '22', x2: '1', y2: '22' }),
	    _react2.default.createElement('polyline', { points: '16 5 12 9 8 5' })
	  );
	};
	
	Sunset.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Sunset.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Sunset;

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Tablet = function Tablet(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', {
	      x: '4',
	      y: '2',
	      width: '16',
	      height: '20',
	      rx: '2',
	      ry: '2',
	      transform: 'rotate(180 12 12)'
	    }),
	    _react2.default.createElement('line', { x1: '12', y1: '18', x2: '12', y2: '18' })
	  );
	};
	
	Tablet.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Tablet.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Tablet;

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Tag = function Tag(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z' }),
	    _react2.default.createElement('line', { x1: '7', y1: '7', x2: '7', y2: '7' })
	  );
	};
	
	Tag.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Tag.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Tag;

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Target = function Target(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '6' }),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '2' })
	  );
	};
	
	Target.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Target.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Target;

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Terminal = function Terminal(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '4 17 10 11 4 5' }),
	    _react2.default.createElement('line', { x1: '12', y1: '19', x2: '20', y2: '19' })
	  );
	};
	
	Terminal.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Terminal.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Terminal;

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Thermometer = function Thermometer(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z' })
	  );
	};
	
	Thermometer.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Thermometer.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Thermometer;

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ThumbsDown = function ThumbsDown(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17' })
	  );
	};
	
	ThumbsDown.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ThumbsDown.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ThumbsDown;

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ThumbsUp = function ThumbsUp(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3' })
	  );
	};
	
	ThumbsUp.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ThumbsUp.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ThumbsUp;

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ToggleLeft = function ToggleLeft(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '1', y: '5', width: '22', height: '14', rx: '7', ry: '7' }),
	    _react2.default.createElement('circle', { cx: '8', cy: '12', r: '3' })
	  );
	};
	
	ToggleLeft.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ToggleLeft.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ToggleLeft;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ToggleRight = function ToggleRight(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '1', y: '5', width: '22', height: '14', rx: '7', ry: '7' }),
	    _react2.default.createElement('circle', { cx: '16', cy: '12', r: '3' })
	  );
	};
	
	ToggleRight.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ToggleRight.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ToggleRight;

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Trash2 = function Trash2(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '3 6 5 6 21 6' }),
	    _react2.default.createElement('path', { d: 'M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2' }),
	    _react2.default.createElement('line', { x1: '10', y1: '11', x2: '10', y2: '17' }),
	    _react2.default.createElement('line', { x1: '14', y1: '11', x2: '14', y2: '17' })
	  );
	};
	
	Trash2.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Trash2.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Trash2;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Trash = function Trash(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '3 6 5 6 21 6' }),
	    _react2.default.createElement('path', { d: 'M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2' })
	  );
	};
	
	Trash.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Trash.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Trash;

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Trello = function Trello(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      viewBox: '0 0 24 24',
	      width: size,
	      height: size,
	      xmlns: 'http://www.w3.org/2000/svg',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }),
	    _react2.default.createElement('rect', { x: '7', y: '7', width: '3', height: '9' }),
	    _react2.default.createElement('rect', { x: '14', y: '7', width: '3', height: '5' })
	  );
	};
	
	Trello.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Trello.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Trello;

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TrendingDown = function TrendingDown(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '23 18 13.5 8.5 8.5 13.5 1 6' }),
	    _react2.default.createElement('polyline', { points: '17 18 23 18 23 12' })
	  );
	};
	
	TrendingDown.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	TrendingDown.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = TrendingDown;

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TrendingUp = function TrendingUp(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '23 6 13.5 15.5 8.5 10.5 1 18' }),
	    _react2.default.createElement('polyline', { points: '17 6 23 6 23 12' })
	  );
	};
	
	TrendingUp.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	TrendingUp.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = TrendingUp;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Triangle = function Triangle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z' })
	  );
	};
	
	Triangle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Triangle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Triangle;

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Truck = function Truck(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '1', y: '3', width: '15', height: '13' }),
	    _react2.default.createElement('polygon', { points: '16 8 20 8 23 11 23 16 16 16 16 8' }),
	    _react2.default.createElement('circle', { cx: '5.5', cy: '18.5', r: '2.5' }),
	    _react2.default.createElement('circle', { cx: '18.5', cy: '18.5', r: '2.5' })
	  );
	};
	
	Truck.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Truck.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Truck;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Tv = function Tv(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '2', y: '7', width: '20', height: '15', rx: '2', ry: '2' }),
	    _react2.default.createElement('polyline', { points: '17 2 12 7 7 2' })
	  );
	};
	
	Tv.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Tv.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Tv;

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Twitter = function Twitter(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z' })
	  );
	};
	
	Twitter.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Twitter.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Twitter;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Type = function Type(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '4 7 4 4 20 4 20 7' }),
	    _react2.default.createElement('line', { x1: '9', y1: '20', x2: '15', y2: '20' }),
	    _react2.default.createElement('line', { x1: '12', y1: '4', x2: '12', y2: '20' })
	  );
	};
	
	Type.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Type.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Type;

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Umbrella = function Umbrella(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7' })
	  );
	};
	
	Umbrella.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Umbrella.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Umbrella;

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Underline = function Underline(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3' }),
	    _react2.default.createElement('line', { x1: '4', y1: '21', x2: '20', y2: '21' })
	  );
	};
	
	Underline.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Underline.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Underline;

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Unlock = function Unlock(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '3', y: '11', width: '18', height: '11', rx: '2', ry: '2' }),
	    _react2.default.createElement('path', { d: 'M7 11V7a5 5 0 0 1 9.9-1' })
	  );
	};
	
	Unlock.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Unlock.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Unlock;

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var UploadCloud = function UploadCloud(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '16 16 12 12 8 16' }),
	    _react2.default.createElement('line', { x1: '12', y1: '12', x2: '12', y2: '21' }),
	    _react2.default.createElement('path', { d: 'M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3' }),
	    _react2.default.createElement('polyline', { points: '16 16 12 12 8 16' })
	  );
	};
	
	UploadCloud.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	UploadCloud.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = UploadCloud;

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Upload = function Upload(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' }),
	    _react2.default.createElement('polyline', { points: '17 8 12 3 7 8' }),
	    _react2.default.createElement('line', { x1: '12', y1: '3', x2: '12', y2: '15' })
	  );
	};
	
	Upload.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Upload.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Upload;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var UserCheck = function UserCheck(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' }),
	    _react2.default.createElement('circle', { cx: '8.5', cy: '7', r: '4' }),
	    _react2.default.createElement('polyline', { points: '17 11 19 13 23 9' })
	  );
	};
	
	UserCheck.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	UserCheck.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = UserCheck;

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var UserMinus = function UserMinus(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' }),
	    _react2.default.createElement('circle', { cx: '8.5', cy: '7', r: '4' }),
	    _react2.default.createElement('line', { x1: '23', y1: '11', x2: '17', y2: '11' })
	  );
	};
	
	UserMinus.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	UserMinus.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = UserMinus;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var UserPlus = function UserPlus(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' }),
	    _react2.default.createElement('circle', { cx: '8.5', cy: '7', r: '4' }),
	    _react2.default.createElement('line', { x1: '20', y1: '8', x2: '20', y2: '14' }),
	    _react2.default.createElement('line', { x1: '23', y1: '11', x2: '17', y2: '11' })
	  );
	};
	
	UserPlus.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	UserPlus.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = UserPlus;

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var UserX = function UserX(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' }),
	    _react2.default.createElement('circle', { cx: '8.5', cy: '7', r: '4' }),
	    _react2.default.createElement('line', { x1: '18', y1: '8', x2: '23', y2: '13' }),
	    _react2.default.createElement('line', { x1: '23', y1: '8', x2: '18', y2: '13' })
	  );
	};
	
	UserX.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	UserX.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = UserX;

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var User = function User(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2' }),
	    _react2.default.createElement('circle', { cx: '12', cy: '7', r: '4' })
	  );
	};
	
	User.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	User.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = User;

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Users = function Users(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' }),
	    _react2.default.createElement('circle', { cx: '9', cy: '7', r: '4' }),
	    _react2.default.createElement('path', { d: 'M23 21v-2a4 4 0 0 0-3-3.87' }),
	    _react2.default.createElement('path', { d: 'M16 3.13a4 4 0 0 1 0 7.75' })
	  );
	};
	
	Users.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Users.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Users;

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var VideoOff = function VideoOff(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10' }),
	    _react2.default.createElement('line', { x1: '1', y1: '1', x2: '23', y2: '23' })
	  );
	};
	
	VideoOff.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	VideoOff.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = VideoOff;

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Video = function Video(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '23 7 16 12 23 17 23 7' }),
	    _react2.default.createElement('rect', { x: '1', y: '5', width: '15', height: '14', rx: '2', ry: '2' })
	  );
	};
	
	Video.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Video.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Video;

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Voicemail = function Voicemail(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '5.5', cy: '11.5', r: '4.5' }),
	    _react2.default.createElement('circle', { cx: '18.5', cy: '11.5', r: '4.5' }),
	    _react2.default.createElement('line', { x1: '5.5', y1: '16', x2: '18.5', y2: '16' })
	  );
	};
	
	Voicemail.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Voicemail.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Voicemail;

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Volume1 = function Volume1(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '11 5 6 9 2 9 2 15 6 15 11 19 11 5' }),
	    _react2.default.createElement('path', { d: 'M15.54 8.46a5 5 0 0 1 0 7.07' })
	  );
	};
	
	Volume1.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Volume1.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Volume1;

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Volume2 = function Volume2(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '11 5 6 9 2 9 2 15 6 15 11 19 11 5' }),
	    _react2.default.createElement('path', { d: 'M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07' })
	  );
	};
	
	Volume2.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Volume2.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Volume2;

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var VolumeX = function VolumeX(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '11 5 6 9 2 9 2 15 6 15 11 19 11 5' }),
	    _react2.default.createElement('line', { x1: '23', y1: '9', x2: '17', y2: '15' }),
	    _react2.default.createElement('line', { x1: '17', y1: '9', x2: '23', y2: '15' })
	  );
	};
	
	VolumeX.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	VolumeX.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = VolumeX;

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Volume = function Volume(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '11 5 6 9 2 9 2 15 6 15 11 19 11 5' })
	  );
	};
	
	Volume.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Volume.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Volume;

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Watch = function Watch(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '7' }),
	    _react2.default.createElement('polyline', { points: '12 9 12 12 13.5 13.5' }),
	    _react2.default.createElement('path', { d: 'M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83' })
	  );
	};
	
	Watch.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Watch.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Watch;

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var WifiOff = function WifiOff(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '1', y1: '1', x2: '23', y2: '23' }),
	    _react2.default.createElement('path', { d: 'M16.72 11.06A10.94 10.94 0 0 1 19 12.55' }),
	    _react2.default.createElement('path', { d: 'M5 12.55a10.94 10.94 0 0 1 5.17-2.39' }),
	    _react2.default.createElement('path', { d: 'M10.71 5.05A16 16 0 0 1 22.58 9' }),
	    _react2.default.createElement('path', { d: 'M1.42 9a15.91 15.91 0 0 1 4.7-2.88' }),
	    _react2.default.createElement('path', { d: 'M8.53 16.11a6 6 0 0 1 6.95 0' }),
	    _react2.default.createElement('line', { x1: '12', y1: '20', x2: '12', y2: '20' })
	  );
	};
	
	WifiOff.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	WifiOff.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = WifiOff;

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Wifi = function Wifi(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M5 12.55a11 11 0 0 1 14.08 0' }),
	    _react2.default.createElement('path', { d: 'M1.42 9a16 16 0 0 1 21.16 0' }),
	    _react2.default.createElement('path', { d: 'M8.53 16.11a6 6 0 0 1 6.95 0' }),
	    _react2.default.createElement('line', { x1: '12', y1: '20', x2: '12', y2: '20' })
	  );
	};
	
	Wifi.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Wifi.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Wifi;

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Wind = function Wind(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2' })
	  );
	};
	
	Wind.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Wind.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Wind;

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var XCircle = function XCircle(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	    _react2.default.createElement('line', { x1: '15', y1: '9', x2: '9', y2: '15' }),
	    _react2.default.createElement('line', { x1: '9', y1: '9', x2: '15', y2: '15' })
	  );
	};
	
	XCircle.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	XCircle.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = XCircle;

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var XSquare = function XSquare(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }),
	    _react2.default.createElement('line', { x1: '9', y1: '9', x2: '15', y2: '15' }),
	    _react2.default.createElement('line', { x1: '15', y1: '9', x2: '9', y2: '15' })
	  );
	};
	
	XSquare.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	XSquare.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = XSquare;

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var X = function X(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('line', { x1: '18', y1: '6', x2: '6', y2: '18' }),
	    _react2.default.createElement('line', { x1: '6', y1: '6', x2: '18', y2: '18' })
	  );
	};
	
	X.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	X.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = X;

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Youtube = function Youtube(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('path', { d: 'M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z' }),
	    _react2.default.createElement('polygon', { points: '9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02' })
	  );
	};
	
	Youtube.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Youtube.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Youtube;

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ZapOff = function ZapOff(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polyline', { points: '12.41 6.75 13 2 10.57 4.92' }),
	    _react2.default.createElement('polyline', { points: '18.57 12.91 21 10 15.66 10' }),
	    _react2.default.createElement('polyline', { points: '8 8 3 14 12 14 11 22 16 16' }),
	    _react2.default.createElement('line', { x1: '1', y1: '1', x2: '23', y2: '23' })
	  );
	};
	
	ZapOff.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ZapOff.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ZapOff;

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Zap = function Zap(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('polygon', { points: '13 2 3 14 12 14 11 22 21 10 12 10 13 2' })
	  );
	};
	
	Zap.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Zap.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = Zap;

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ZoomIn = function ZoomIn(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '11', cy: '11', r: '8' }),
	    _react2.default.createElement('line', { x1: '21', y1: '21', x2: '16.65', y2: '16.65' }),
	    _react2.default.createElement('line', { x1: '11', y1: '8', x2: '11', y2: '14' }),
	    _react2.default.createElement('line', { x1: '8', y1: '11', x2: '14', y2: '11' })
	  );
	};
	
	ZoomIn.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ZoomIn.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ZoomIn;

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ZoomOut = function ZoomOut(props) {
	  var color = props.color,
	      size = props.size,
	      otherProps = _objectWithoutProperties(props, ['color', 'size']);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      xmlns: 'http://www.w3.org/2000/svg',
	      width: size,
	      height: size,
	      viewBox: '0 0 24 24',
	      fill: 'none',
	      stroke: color,
	      strokeWidth: '2',
	      strokeLinecap: 'round',
	      strokeLinejoin: 'round'
	    }, otherProps),
	    _react2.default.createElement('circle', { cx: '11', cy: '11', r: '8' }),
	    _react2.default.createElement('line', { x1: '21', y1: '21', x2: '16.65', y2: '16.65' }),
	    _react2.default.createElement('line', { x1: '8', y1: '11', x2: '14', y2: '11' })
	  );
	};
	
	ZoomOut.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	ZoomOut.defaultProps = {
	  color: 'currentColor',
	  size: '24'
	};
	
	exports.default = ZoomOut;

/***/ }),
/* 2021 */,
/* 2022 */,
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(112);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2024 */
/***/ (function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(30);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(24);
	
	var _Router = __webpack_require__(118);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createBrowserHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(30);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(24);
	
	var _Router = __webpack_require__(118);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createHashHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(["hashbang", "noslash", "slash"]),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(2036);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(186);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(185);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref["aria-current"],
	      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);
	
	  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;
	
	  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
	  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
	
	  return _react2.default.createElement(_Route2.default, {
	    path: escapedPath,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(" ") : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        "aria-current": isActive && ariaCurrent || null
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  "aria-current": _propTypes2.default.oneOf(["page", "step", "location", "date", "time", "true"])
	};
	
	NavLink.defaultProps = {
	  activeClassName: "active",
	  "aria-current": "page"
	};
	
	exports.default = NavLink;

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(2037);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(2038);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(2039);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(2040);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _generatePath = __webpack_require__(188);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _generatePath2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(120);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(2042);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(30);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(24);
	
	var _Router = __webpack_require__(119);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createMemoryHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(27);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Prompt> outside a <Router>");
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(30);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(27);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(24);
	
	var _generatePath = __webpack_require__(188);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Redirect> outside a <Router>");
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.computeTo = function computeTo(_ref) {
	    var computedMatch = _ref.computedMatch,
	        to = _ref.to;
	
	    if (computedMatch) {
	      if (typeof to === "string") {
	        return (0, _generatePath2.default)(to, computedMatch.params);
	      } else {
	        return _extends({}, to, {
	          pathname: (0, _generatePath2.default)(to.pathname, computedMatch.params)
	        });
	      }
	    }
	
	    return to;
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var push = this.props.push;
	
	    var to = this.computeTo(this.props);
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(30);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(27);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(24);
	
	var _Router = __webpack_require__(119);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === "/" ? path : "/" + path;
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: addLeadingSlash(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = addLeadingSlash(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createURL = function createURL(location) {
	  return typeof location === "string" ? location : (0, _history.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, "You cannot %s with <StaticRouter>", methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return addLeadingSlash(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = "PUSH";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = "REPLACE";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);
	
	    var history = {
	      createHref: this.createHref,
	      action: "POP",
	      location: stripBasename(basename, (0, _history.createLocation)(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler("go"),
	      goBack: staticHandler("goBack"),
	      goForward: staticHandler("goForward"),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: "",
	  location: "/"
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(30);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(27);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(120);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Switch> outside a <Router>");
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (match == null && _react2.default.isValidElement(element)) {
	        var _element$props = element.props,
	            pathProp = _element$props.path,
	            exact = _element$props.exact,
	            strict = _element$props.strict,
	            sensitive = _element$props.sensitive,
	            from = _element$props.from;
	
	        var path = pathProp || from;
	
	        child = element;
	        match = (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ }),
/* 2041 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(2041);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(187);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);
	
	    return _react2.default.createElement(_Route2.default, {
	      children: function children(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
	          ref: wrappedComponentRef
	        }));
	      }
	    });
	  };
	
	  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(2110));
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(SideEffect, _Component);
	
	      function SideEffect() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      _proto.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Arrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Arrow = exports.Arrow = (0, _components2.default)({
	  direction: 'down'
	}, function (props) {
	  var borderTop = props.direction === 'down' ? { borderTop: '.4375em solid' } : null;
	  var borderBottom = props.direction === 'up' ? { borderBottom: '.4375em solid' } : null;
	  return _extends({
	    display: 'inline-block',
	    width: 0,
	    height: 0,
	    verticalAlign: 'middle',
	    borderRight: '.3125em solid transparent',
	    borderLeft: '.3125em solid transparent'
	  }, borderTop, borderBottom);
	}, 'space', 'color');
	
	Arrow.displayName = 'Arrow';
	
	exports.default = Arrow;

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Avatar = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Avatar = exports.Avatar = (0, _components2.default)({
	  is: 'img',
	  size: 48,
	  borderRadius: '99999px'
	}, {
	  display: 'inline-block'
	}, 'borderRadius', 'space', 'color', 'size');
	
	Avatar.displayName = 'Avatar';
	
	exports.default = Avatar;

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BackgroundImage = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _styledSystem = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bgImage = (0, _styledSystem.style)({
	  prop: 'image',
	  alias: 'src',
	  cssProperty: 'backgroundImage',
	  getter: function getter(n) {
	    return 'url(' + n + ')';
	  }
	});
	
	var BackgroundImage = exports.BackgroundImage = (0, _components2.default)({
	  width: 1,
	  ratio: 3 / 4,
	  backgroundSize: 'cover',
	  backgroundPosition: 'center'
	}, bgImage, 'width', 'ratio', 'backgroundSize', 'backgroundPosition', 'space', 'color');
	
	BackgroundImage.displayName = 'BackgroundImage';
	
	exports.default = BackgroundImage;

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Banner = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _grid = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Banner = exports.Banner = (0, _components2.default)({
	  extend: _grid.Flex,
	  p: [3, 4],
	  flexDirection: 'column',
	  alignItems: 'center',
	  justifyContent: 'center',
	  backgroundSize: 'cover',
	  backgroundPosition: 'center',
	  minHeight: '80vh',
	  color: 'white',
	  bg: 'black'
	}, 'minHeight', 'backgroundSize', 'backgroundPosition', 'backgroundImage');
	
	Banner.displayName = 'Banner';
	
	exports.default = Banner;

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Base = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var css = function css(props) {
	  return props.css;
	};
	
	var Base = exports.Base = (0, _components2.default)({}, 'space', 'color', 'fontSize', css);
	
	Base.displayName = 'Base';
	
	exports.default = Base;

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BlockLink = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlockLink = exports.BlockLink = (0, _components2.default)({
	  is: 'a',
	  color: 'inherit'
	}, {
	  display: 'block',
	  textDecoration: 'none'
	}, 'space', 'color', 'width');
	
	BlockLink.displayName = 'BlockLink';
	
	exports.default = BlockLink;

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Blockquote = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _Text = __webpack_require__(37);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Blockquote = exports.Blockquote = (0, _components2.default)({
	  is: 'blockquote',
	  extend: _Text2.default,
	  fontSize: 3,
	  m: 0
	});
	
	Blockquote.displayName = 'Blockquote';
	
	exports.default = Blockquote;

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Border = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Border = exports.Border = (0, _components2.default)({
	  border: 1,
	  borderColor: 'gray'
	}, 'space', 'width', 'color', 'borders', 'borderColor');
	
	Border.displayName = 'Border';
	
	exports.default = Border;

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ButtonCircle = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _Button = __webpack_require__(80);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonCircle = exports.ButtonCircle = (0, _components2.default)({
	  extend: _Button2.default,
	  px: 3,
	  borderRadius: 9999
	});
	
	ButtonCircle.displayName = 'ButtonCircle';
	
	exports.default = ButtonCircle;

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ButtonOutline = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _styledSystem = __webpack_require__(11);
	
	var _Button = __webpack_require__(80);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonOutline = exports.ButtonOutline = (0, _components2.default)({
	  extend: _Button2.default,
	  color: 'blue',
	  bg: 'transparent'
	}, function (props) {
	  return {
	    boxShadow: 'inset 0 0 0 2px ' + (0, _styledSystem.themeGet)('colors.' + props.color, props.color)(props)
	  };
	});
	
	ButtonOutline.displayName = 'ButtonOutline';
	
	exports.default = ButtonOutline;

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CSS = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CSS = exports.CSS = function CSS(_ref) {
	  var css = _ref.css;
	  return _react2.default.createElement('style', {
	    dangerouslySetInnerHTML: {
	      __html: css
	    }
	  });
	};
	
	CSS.defaultProps = {
	  css: '*{box-sizing:border-box}body{margin:0}'
	};
	
	CSS.displayName = 'CSS';
	
	exports.default = CSS;

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Caps = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _Text = __webpack_require__(37);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Caps = exports.Caps = (0, _components2.default)({
	  extend: _Text2.default,
	  fontSize: 0,
	  letterSpacing: '0.2em'
	}, {
	  textTransform: 'uppercase'
	}, 'letterSpacing');
	
	Caps.displayName = 'Caps';
	
	exports.default = Caps;

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Card = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = exports.Card = (0, _components2.default)({
	  p: 2,
	  bg: 'white',
	  borderRadius: 2,
	  boxShadow: 2
	}, {
	  overflow: 'hidden'
	}, 'space', 'width', 'color', 'borderRadius', 'boxShadow');
	
	Card.displayName = 'Card';
	
	exports.default = Card;

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Carousel = exports.carouselIndex = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _grid = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var carouselIndex = exports.carouselIndex = function carouselIndex(_ref) {
	  var index = _ref.index;
	  return {
	    '& > div:first-child': {
	      marginLeft: index * -100 + '%',
	      transitionProperty: 'margin',
	      transitionDuration: '.2s',
	      transitionTimingFunction: 'ease-out'
	    }
	  };
	};
	
	var Carousel = exports.Carousel = (0, _components2.default)({
	  extend: _grid.Flex,
	  width: 1
	}, {
	  overflow: 'hidden',
	  whiteSpace: 'nowrap',
	  '& > div': {
	    flex: 'none',
	    width: '100%'
	  }
	}, carouselIndex, 'space', 'color');
	
	Carousel.displayName = 'Carousel';
	
	exports.default = Carousel;

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Checkbox = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Checkbox = exports.Checkbox = (0, _components2.default)({
	  is: 'input',
	  type: 'checkbox',
	  m: 0,
	  mr: 2
	}, 'space', 'color');
	
	Checkbox.displayName = 'Checkbox';
	
	exports.default = Checkbox;

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Circle = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _Badge = __webpack_require__(193);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Circle = exports.Circle = (0, _components2.default)({
	  extend: _Badge2.default,
	  size: 24,
	  align: 'center',
	  borderRadius: '99999px'
	}, 'textAlign', 'borderRadius', 'size');
	
	Circle.displayName = 'Circle';
	
	exports.default = Circle;

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Close = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _ButtonTransparent = __webpack_require__(194);
	
	var _ButtonTransparent2 = _interopRequireDefault(_ButtonTransparent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Close = exports.Close = (0, _components2.default)({
	  extend: _ButtonTransparent2.default,
	  p: 0,
	  fontSize: 3,
	  lineHeight: 1,
	  children: '×'
	}, {
	  width: '24px',
	  height: '24px'
	}, 'lineHeight');
	
	Close.displayName = 'Close';
	
	exports.default = Close;

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Column = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _grid = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Column = exports.Column = (0, _components2.default)({
	  extend: _grid.Box,
	  px: 3,
	  mb: 4,
	  flex: '1 1 auto'
	}, 'flex');
	
	Column.displayName = 'Column';
	
	exports.default = Column;

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Container = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _grid = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Container = exports.Container = (0, _components2.default)({
	  extend: _grid.Box,
	  px: 3,
	  mx: 'auto',
	  maxWidth: 1024
	}, 'maxWidth');
	
	Container.displayName = 'Container';
	
	exports.default = Container;

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DarkMode = exports.invertTheme = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _grid = __webpack_require__(16);
	
	var _colors = __webpack_require__(121);
	
	var _theme = __webpack_require__(122);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var invertTheme = function invertTheme() {
	  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _theme2.default;
	
	  var _theme$colors = theme.colors,
	      colors = _theme$colors === undefined ? {} : _theme$colors,
	      rest = _objectWithoutProperties(theme, ['colors']);
	
	  var next = Object.keys(colors).reduce(function (a, key) {
	    a[key] = (0, _colors.invertLuminance)(colors[key]);
	    return a;
	  }, {});
	
	  return _extends({}, rest, {
	    colors: next
	  });
	};
	
	exports.invertTheme = invertTheme;
	
	var DarkMode = exports.DarkMode = function (_React$Component) {
	  _inherits(DarkMode, _React$Component);
	
	  function DarkMode() {
	    _classCallCheck(this, DarkMode);
	
	    return _possibleConstructorReturn(this, (DarkMode.__proto__ || Object.getPrototypeOf(DarkMode)).apply(this, arguments));
	  }
	
	  _createClass(DarkMode, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _styledComponents.ThemeProvider,
	        { theme: invertTheme },
	        _react2.default.createElement(_grid.Box, this.props)
	      );
	    }
	  }]);
	
	  return DarkMode;
	}(_react2.default.Component);
	
	DarkMode.defaultProps = {
	  color: 'black',
	  bg: 'white'
	};
	exports.default = DarkMode;

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Divider = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Divider = exports.Divider = (0, _components2.default)({
	  is: 'hr',
	  mx: 0,
	  my: 3,
	  border: 0,
	  borderBottom: 1,
	  borderColor: 'gray'
	}, 'borders', 'borderColor', 'space', 'color');
	
	Divider.displayName = 'Divider';
	
	exports.default = Divider;

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Donut = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DonutBase = function DonutBase(props) {
	  var R = 16 - props.strokeWidth;
	  var C = 2 * Math.PI * R;
	  return _react2.default.createElement(
	    'svg',
	    _extends({}, props, {
	      viewBox: '0 0 32 32',
	      width: props.size || 128,
	      height: props.size || 128 }),
	    _react2.default.createElement('circle', {
	      cx: 16,
	      cy: 16,
	      r: R,
	      fill: 'none',
	      stroke: 'currentcolor',
	      strokeWidth: props.strokeWidth,
	      opacity: '0.125'
	    }),
	    _react2.default.createElement('circle', {
	      cx: 16,
	      cy: 16,
	      r: R,
	      fill: 'none',
	      stroke: 'currentcolor',
	      strokeWidth: props.strokeWidth,
	      strokeDasharray: C,
	      strokeDashoffset: C - props.value * C,
	      transform: 'rotate(-90 16 16)'
	    })
	  );
	};
	
	var Donut = exports.Donut = (0, _components2.default)({
	  extend: DonutBase,
	  color: 'blue',
	  strokeWidth: 2,
	  value: 1
	}, 'space', 'color');
	
	Donut.displayName = 'Donut';
	
	exports.default = Donut;

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dot = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dot = exports.Dot = (0, _components2.default)({
	  is: 'button',
	  m: 0,
	  p: 0,
	  size: 16,
	  bg: 'darken',
	  borderRadius: 99999,
	  border: 4,
	  borderColor: 'transparent'
	}, {
	  appearance: 'none',
	  backgroundClip: 'padding-box'
	}, 'size', 'borderRadius', 'borders', 'borderColor', 'space', 'color');
	
	Dot.displayName = 'Dot';
	
	exports.default = Dot;

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Drawer = exports.transform = exports.side = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _styledSystem = __webpack_require__(11);
	
	var _grid = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transforms = {
	  left: 'translateX(-100%)',
	  right: 'translateX(100%)',
	  top: 'translateY(-100%)',
	  bottom: 'translateY(100%)'
	};
	var side = exports.side = function side(_ref) {
	  var side = _ref.side;
	
	  if (!transforms[side]) return {
	    top: 0,
	    left: 0,
	    bottom: 0
	  };
	  var h = /^(left|right)$/.test(side) ? 1 : 0;
	  var top = /^(top|left|right)$/.test(side) ? 0 : null;
	  var bottom = /^(bottom|left|right)$/.test(side) ? 0 : null;
	  var left = /^(left|top|bottom)$/.test(side) ? 0 : null;
	  var right = /^(right|top|bottom)$/.test(side) ? 0 : null;
	
	  return {
	    top: top,
	    bottom: bottom,
	    left: left,
	    right: right
	  };
	};
	
	var transform = exports.transform = function transform(_ref2) {
	  var open = _ref2.open,
	      side = _ref2.side;
	  return {
	    transform: open ? null : transforms[side] || transforms.left
	  };
	};
	
	var Drawer = exports.Drawer = (0, _components2.default)({
	  extend: _grid.Box,
	  blacklist: ['side', 'open'],
	  position: 'fixed',
	  color: 'white',
	  bg: 'black',
	  open: false,
	  side: 'bottom',
	  width: 320
	}, side, transform, 'position', 'zIndex', 'height', {
	  overflowX: 'hidden',
	  overflowY: 'auto',
	  transitionProperty: 'transform',
	  transitionDuration: '.2s',
	  transitionTimingFunction: 'ease-out'
	});
	
	Drawer.displayName = 'Drawer';
	
	exports.default = Drawer;

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Embed = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Embed = exports.Embed = (0, _components2.default)({
	  ratio: 9 / 16
	}, 'ratio', 'space', 'color', function (props) {
	  return {
	    position: 'relative',
	    overflow: 'hidden',
	    '& > iframe': {
	      position: 'absolute',
	      width: '100%',
	      height: '100%',
	      top: 0,
	      bottom: 0,
	      left: 0,
	      border: 0
	    }
	  };
	});
	
	Embed.displayName = 'Embed';
	
	exports.default = Embed;

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Group = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _grid = __webpack_require__(16);
	
	var _styledSystem = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Group = exports.Group = (0, _components2.default)({
	  extend: _grid.Flex
	}, function (props) {
	  var radius = (0, _styledSystem.themeGet)('radii.2', 4)(props) + 'px';
	  return {
	    '& > *': {
	      borderRadius: 0
	    },
	    '& > *:first-child': {
	      borderRadius: radius + ' 0 0 ' + radius
	
	    },
	    '& > *:last-child': {
	      borderRadius: '0 ' + radius + ' ' + radius + ' 0'
	    }
	  };
	});
	
	Group.displayName = 'Group';
	
	exports.default = Group;

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hide = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _grid = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var withHidden = function withHidden(Component) {
	  return function (_ref) {
	    var xs = _ref.xs,
	        sm = _ref.sm,
	        md = _ref.md,
	        lg = _ref.lg,
	        xl = _ref.xl,
	        xsmall = _ref.xsmall,
	        small = _ref.small,
	        medium = _ref.medium,
	        large = _ref.large,
	        xlarge = _ref.xlarge,
	        display = _ref.display,
	        props = _objectWithoutProperties(_ref, ['xs', 'sm', 'md', 'lg', 'xl', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'display']);
	
	    var Hidden = _react2.default.createElement(Component, _extends({}, props, {
	      display: display || [xs || xsmall, sm || small, md || medium, lg || large, xl || xlarge].map(function (n) {
	        return n ? 'none' : 'block';
	      })
	    }));
	    return Hidden;
	  };
	};
	
	var Hide = exports.Hide = withHidden((0, _components2.default)({
	  extend: _grid.Box
	}, 'display'));
	
	Hide.displayName = 'Hide';
	
	exports.default = Hide;

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Image = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Image = exports.Image = (0, _components2.default)({
	  is: 'img'
	}, {
	  display: 'block',
	  maxWidth: '100%',
	  height: 'auto'
	}, 'space', 'width', 'color');
	
	Image.displayName = 'Image';
	
	exports.default = Image;

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Input = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _styledSystem = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Input = exports.Input = (0, _components2.default)({
	  is: 'input',
	  type: 'text',
	  fontSize: 'inherit',
	  lineHeight: 'inherit',
	  px: 1,
	  py: 2,
	  m: 0,
	  width: 1,
	  border: 0,
	  borderColor: 'gray',
	  boxShadow: 1,
	  borderRadius: 2,
	  color: 'inherit',
	  bg: 'transparent'
	}, 'fontSize', 'lineHeight', 'width', 'borders', 'borderColor', 'boxShadow', 'borderRadius', 'space', 'color', function (props) {
	  return {
	    fontFamily: 'inherit',
	    display: 'inline-block',
	    verticalAlign: 'middle',
	    border: 0,
	    appearance: 'none',
	    '&:focus': {
	      outline: 'none',
	      boxShadow: 'inset 0 0 0 1px ' + (0, _styledSystem.themeGet)('colors.blue')(props)
	    },
	    '&:disabled': {
	      opacity: 1 / 4
	    }
	  };
	});
	
	Input.displayName = 'Input';
	
	exports.default = Input;

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Label = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Label = exports.Label = (0, _components2.default)({
	  is: 'label',
	  fontSize: 1,
	  mb: 1,
	  alignItems: 'center'
	}, {
	  display: 'flex'
	}, 'alignItems', 'fontSize', 'space', 'color');
	
	Label.displayName = 'Label';
	
	exports.default = Label;

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Lead = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _Text = __webpack_require__(37);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Lead = exports.Lead = (0, _components2.default)({
	  extend: _Text2.default,
	  fontSize: 3,
	  lineHeight: 1.25
	});
	
	Lead.displayName = 'Lead';
	
	exports.default = Lead;

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Link = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Link = exports.Link = (0, _components2.default)({
	  is: 'a',
	  color: 'blue'
	}, 'space', 'color');
	
	Link.displayName = 'Link';
	
	exports.default = Link;

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Measure = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _Text = __webpack_require__(37);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Measure = exports.Measure = (0, _components2.default)({
	  extend: _Text2.default,
	  maxWidth: '32em'
	}, 'maxWidth');
	
	Measure.displayName = 'Measure';
	
	exports.default = Measure;

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Message = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _grid = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Message = exports.Message = (0, _components2.default)({
	  extend: _grid.Flex,
	  px: 3,
	  py: 2,
	  fontWeight: 'bold',
	  color: 'white',
	  bg: 'blue',
	  alignItems: 'center',
	  minHeight: '48px'
	}, 'minHeight', 'fontWeight', {
	  WebkitFontSmoothing: 'antialiased'
	});
	
	Message.displayName = 'Message';
	
	exports.default = Message;

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Modal = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _styledSystem = __webpack_require__(11);
	
	var _index = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modal = exports.Modal = (0, _components2.default)({
	  extend: _index.Fixed,
	  top: '50%',
	  left: '50%',
	  p: 3,
	  bg: 'white',
	  borderRadius: 2,
	  maxWidth: '100vw',
	  maxHeight: '100vh'
	}, function (props) {
	  return {
	    boxShadow: '0 0 0 60vmax ' + (0, _styledSystem.themeGet)('colors.darken')(props) + ', 0 0 32px ' + (0, _styledSystem.themeGet)('colors.darken')(props),
	    overflow: 'auto',
	    transform: 'translate(-50%, -50%)'
	  };
	}, 'borderRadius', 'width', 'maxWidth', 'maxHeight');
	Modal.displayName = 'Modal';
	
	exports.default = Modal;

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NavLink = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _styledSystem = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavLink = exports.NavLink = (0, _components2.default)({
	  is: 'a',
	  color: 'inherit',
	  bg: 'transparent',
	  fontSize: 1,
	  fontWeight: 'bold',
	  p: 2
	}, function (props) {
	  return {
	    display: 'inline-flex',
	    alignItems: 'center',
	    alignSelf: 'stretch',
	    textDecoration: 'none',
	    whiteSpace: 'nowrap',
	    cursor: 'pointer',
	    '&:disabled': {
	      opacity: 1 / 4
	    }
	  };
	}, 'width', 'fontSize', 'fontWeight', 'space', 'color');
	
	NavLink.displayName = 'NavLink';
	
	exports.default = NavLink;

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Panel = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Panel = exports.Panel = (0, _components2.default)({
	  bg: 'white',
	  borderRadius: 2,
	  border: 1,
	  borderColor: 'gray'
	}, {
	  overflow: 'hidden'
	}, 'space', 'color', 'borders', 'borderColor', 'borderRadius');
	
	Panel.displayName = 'Panel';
	
	Panel.Header = (0, _components2.default)({
	  is: 'header',
	  fontSize: 2,
	  p: 2,
	  bg: 'white',
	  borderBottom: 1,
	  borderColor: 'gray'
	}, 'space', 'color', 'fontSize', 'borders', 'borderColor');
	
	Panel.Header.displayName = 'Panel.Header';
	
	Panel.Footer = (0, _components2.default)({
	  is: 'footer',
	  fontSize: 1,
	  p: 2,
	  bg: 'white',
	  borderTop: 1,
	  borderColor: 'gray'
	}, 'space', 'colors', 'fontSize', 'borders', 'borderColor');
	
	Panel.Footer.displayName = 'Panel.Footer';
	
	exports.default = Panel;

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Sticky = exports.Fixed = exports.Absolute = exports.Relative = exports.Position = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Position = exports.Position = (0, _components2.default)({}, 'space', 'color', 'zIndex', 'top', 'right', 'bottom', 'left');
	
	Position.displayName = 'Position';
	
	var Relative = exports.Relative = (0, _components2.default)({
	  extend: Position
	}, {
	  position: 'relative'
	});
	Relative.displayName = 'Relative';
	
	var Absolute = exports.Absolute = (0, _components2.default)({
	  extend: Position
	}, {
	  position: 'absolute'
	});
	Absolute.displayName = 'Absolute';
	
	var Fixed = exports.Fixed = (0, _components2.default)({
	  extend: Position
	}, {
	  position: 'fixed'
	});
	Fixed.displayName = 'Fixed';
	
	var Sticky = exports.Sticky = (0, _components2.default)({
	  extend: Position
	}, {
	  position: 'sticky'
	});
	Sticky.displayName = 'Sticky';
	
	exports.default = Position;

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Pre = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pre = exports.Pre = (0, _components2.default)({
	  is: 'pre',
	  fontSize: 1,
	  fontFamily: 'mono',
	  m: 0
	}, {
	  overflow: 'auto'
	}, 'fontFamily', 'fontSize', 'space', 'color');
	
	Pre.displayName = 'Pre';
	
	exports.default = Pre;

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Progress = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _styledSystem = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Progress = exports.Progress = (0, _components2.default)({
	  is: 'progress',
	  width: 1,
	  m: 0,
	  px: 0,
	  color: 'blue',
	  bg: 'gray',
	  borderRadius: 2
	}, 'width', 'borderRadius', 'space', 'color', function (props) {
	  return {
	    boxSizing: 'border-box',
	    diplay: 'block',
	    height: '4px',
	    overflow: 'hidden',
	    appearance: 'none',
	    '&::-webkit-progress-bar': {
	      backgroundColor: (0, _styledSystem.themeGet)('colors.gray')(props)
	    },
	    '&::-webkit-progress-value': {
	      backgroundColor: 'currentcolor'
	    },
	    '&::-moz-progress-bar': {
	      backgroundColor: 'currentcolor'
	    }
	  };
	});
	
	Progress.displayName = 'Progress';
	
	exports.default = Progress;

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Provider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _Root = __webpack_require__(197);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	var _theme = __webpack_require__(122);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Provider = exports.Provider = function (_React$Component) {
	  _inherits(Provider, _React$Component);
	
	  function Provider() {
	    _classCallCheck(this, Provider);
	
	    return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
	  }
	
	  _createClass(Provider, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          theme = _props.theme,
	          props = _objectWithoutProperties(_props, ['theme']);
	
	      return _react2.default.createElement(
	        _styledComponents.ThemeProvider,
	        { theme: _extends({}, _theme2.default, theme) },
	        _react2.default.createElement(_Root2.default, props)
	      );
	    }
	  }]);
	
	  return Provider;
	}(_react2.default.Component);
	
	Provider.defaultProps = {
	  theme: {}
	};
	
	Provider.displayName = 'Rebass.Provider';
	
	exports.default = Provider;

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Radio = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Radio = exports.Radio = (0, _components2.default)({
	  is: 'input',
	  type: 'radio',
	  m: 0,
	  mr: 2
	}, 'space', 'color');
	
	Radio.displayName = 'Radio';
	
	exports.default = Radio;

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Row = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _grid = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Row = exports.Row = (0, _components2.default)({
	  extend: _grid.Flex,
	  mx: -3
	});
	
	Row.displayName = 'Row';
	
	exports.default = Row;

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Samp = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _Code = __webpack_require__(195);
	
	var _Code2 = _interopRequireDefault(_Code);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Samp = exports.Samp = (0, _components2.default)({
	  is: 'samp',
	  extend: _Code2.default
	});
	
	Samp.displayName = 'Samp';
	
	exports.default = Samp;

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Select = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _styledSystem = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrow = encodeURI('data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'32\' height=\'32\' viewbox=\'0 0 32 32\' fill=\'currentcolor\'> <path d=\'M0 6 L32 6 L16 28 z\' /> </svg>');
	
	var Select = exports.Select = (0, _components2.default)({
	  is: 'select',
	  m: 0,
	  px: 1,
	  py: 2,
	  width: 1,
	  border: 0,
	  borderColor: 'gray',
	  boxShadow: 1,
	  borderRadius: 2,
	  color: 'inherit',
	  bg: 'transparent'
	}, 'space', 'color', 'width', 'borders', 'borderColor', 'boxShadow', 'borderRadius', {
	  fontFamily: 'inherit',
	  fontSize: 'inherit',
	  lineHeight: 'inherit',
	  appearance: 'none',
	  border: 0,
	  backgroundImage: 'url("' + arrow + '")',
	  backgroundPosition: 'calc(100% - 8px) center',
	  backgroundRepeat: 'no-repeat',
	  backgroundSize: '8px 8px',
	  '&:disabled': {
	    opacity: 1 / 4
	  }
	}, function (props) {
	  return {
	    '&:focus': {
	      outline: 'none',
	      boxShadow: 'inset 0 0 0 1px ' + (0, _styledSystem.themeGet)('colors.blue')(props)
	    }
	  };
	});
	
	Select.displayName = 'Select';
	
	exports.default = Select;

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Slider = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Slider = exports.Slider = (0, _components2.default)({
	  is: 'input',
	  type: 'range',
	  width: 1,
	  mx: 0,
	  my: 2,
	  color: 'inherit',
	  bg: 'gray',
	  borderRadius: 99999
	}, 'width', 'space', 'color', 'borderRadius', function (props) {
	  return {
	    display: 'block',
	    height: '4px',
	    cursor: 'pointer',
	    appearance: 'none',
	    '&::-webkit-slider-thumb': {
	      width: '16px',
	      height: '16px',
	      backgroundColor: 'currentcolor',
	      border: 0,
	      borderRadius: '99999px',
	      appearance: 'none'
	    }
	  };
	});
	
	Slider.displayName = 'Slider';
	
	exports.default = Slider;

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Small = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _Text = __webpack_require__(37);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Small = exports.Small = (0, _components2.default)({
	  is: 'small',
	  extend: _Text2.default,
	  fontSize: 0
	});
	
	Small.displayName = 'Small';
	
	exports.default = Small;

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Subhead = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _Heading = __webpack_require__(196);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Subhead = exports.Subhead = (0, _components2.default)({
	  is: 'h3',
	  extend: _Heading2.default,
	  fontSize: 4
	});
	
	Subhead.displayName = 'Subhead';
	
	exports.default = Subhead;

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Switch = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _styledSystem = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Switch = exports.Switch = (0, _components2.default)({
	  role: 'checkbox',
	  color: 'blue',
	  borderRadius: '99999px'
	}, 'space', 'color', 'borderRadius', function (props) {
	  return {
	    display: 'inline-flex',
	    width: '40px',
	    height: '24px',
	    backgroundColor: props.checked ? (0, _styledSystem.themeGet)('colors.' + props.color)(props) : 'transparent',
	    boxShadow: 'inset 0 0 0 2px',
	    transitionProperty: 'background-color',
	    transitionDuration: '.2s',
	    transitionTimingFunction: 'ease-out',
	    userSelect: 'none',
	    '&::after': {
	      content: '" "',
	      width: '16px',
	      height: '16px',
	      margin: '4px',
	      borderRadius: '99999px',
	      transitionProperty: 'transform, color',
	      transitionDuration: '.1s',
	      transitionTimingFunction: 'ease-out',
	      transform: props.checked ? 'translateX(16px)' : 'translateX(0)',
	      backgroundColor: props.checked ? (0, _styledSystem.themeGet)('colors.white')(props) : (0, _styledSystem.themeGet)('colors.' + props.color)(props)
	    }
	  };
	});
	
	Switch.displayName = 'Switch';
	
	exports.default = Switch;

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tab = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tab = exports.Tab = (0, _components2.default)({
	  is: 'a',
	  fontSize: 1,
	  fontWeight: 'bold',
	  mr: 3,
	  py: 2,
	  color: 'inherit',
	  borderBottom: 2,
	  borderColor: 'transparent'
	}, {
	  textDecoration: 'none'
	}, 'space', 'color', 'fontSize', 'fontWeight', 'borders', 'borderColor');
	
	Tab.displayName = 'Tab';
	
	exports.default = Tab;

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tabs = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _grid = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tabs = exports.Tabs = (0, _components2.default)({
	  extend: _grid.Flex,
	  borderBottom: 1,
	  borderColor: 'gray'
	}, 'borders', 'borderColor');
	
	Tabs.displayName = 'Tabs';
	
	exports.default = Tabs;

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Textarea = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _styledSystem = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Textarea = exports.Textarea = (0, _components2.default)({
	  is: 'textarea',
	  px: 1,
	  py: 2,
	  m: 0,
	  width: 1,
	  fontSize: 'inherit',
	  color: 'inherit',
	  bg: 'transparent',
	  border: 0,
	  borderColor: 'gray',
	  boxShadow: 1,
	  borderRadius: 2
	}, function (props) {
	  return {
	    fontFamily: 'inherit',
	    appearance: 'none',
	    '&:focus': {
	      outline: 'none',
	      boxShadow: 'inset 0 0 0 1px' + (0, _styledSystem.themeGet)('colors.blue')(props)
	    },
	    '&:disabled': {
	      opacity: 1 / 4
	    }
	  };
	}, 'space', 'color', 'width', 'fontSize', 'borders', 'borderColor', 'boxShadow', 'borderRadius');
	
	Textarea.displayName = 'Textarea';
	
	exports.default = Textarea;

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Toolbar = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _grid = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Toolbar = exports.Toolbar = (0, _components2.default)({
	  extend: _grid.Flex,
	  px: 2,
	  color: 'white',
	  bg: 'black',
	  alignItems: 'center',
	  minHeight: '48px'
	}, 'minHeight', {
	  WebkitFontSmoothing: 'antialiased'
	});
	
	Toolbar.displayName = 'Toolbar';
	
	exports.default = Toolbar;

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tooltip = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _styledSystem = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tooltip = exports.Tooltip = (0, _components2.default)({
	  color: 'white',
	  bg: 'black'
	}, function (props) {
	  return {
	    display: 'inline-block',
	    position: 'relative',
	    color: 'inherit',
	    backgroundColor: 'transparent',
	    '&::before': {
	      display: 'none',
	      content: '"' + props.text + '"',
	      position: 'absolute',
	      bottom: '100%',
	      left: '50%',
	      transform: 'translate(-50%, -4px)',
	      whiteSpace: 'nowrap',
	      fontSize: (0, _styledSystem.themeGet)('fontSizes.0', '10px')(props),
	      paddingTop: '4px',
	      paddingBottom: '4px',
	      paddingLeft: '8px',
	      paddingRight: '8px',
	      color: (0, _styledSystem.themeGet)('colors.' + props.color)(props),
	      backgroundColor: (0, _styledSystem.themeGet)('colors.' + props.bg)(props),
	      borderRadius: (0, _styledSystem.themeGet)('radii.1')(props) + 'px'
	    },
	    '&::after': {
	      display: 'none',
	      position: 'absolute',
	      bottom: '100%',
	      left: '50%',
	      transform: 'translate(-50%, 8px)',
	      content: '" "',
	      borderWidth: '6px',
	      borderStyle: 'solid',
	      borderColor: 'transparent',
	      borderTopColor: (0, _styledSystem.themeGet)('colors.' + props.bg)(props)
	    },
	    '&:hover': {
	      '&::before, &::after': {
	        display: 'block'
	      }
	    }
	  };
	}, 'space', 'color');
	
	Tooltip.displayName = 'Tooltip';
	
	exports.default = Tooltip;

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Truncate = undefined;
	
	var _components = __webpack_require__(6);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _Text = __webpack_require__(37);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Truncate = exports.Truncate = (0, _components2.default)({
	  extend: _Text2.default
	}, {
	  overflow: 'hidden',
	  whiteSpace: 'nowrap',
	  textOverflow: 'ellipsis'
	});
	
	Truncate.displayName = 'Truncate';
	
	exports.default = Truncate;

/***/ }),
/* 2103 */
/***/ (function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2103);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ }),
/* 2105 */
/***/ (function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2105);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _off = _interopRequireDefault(__webpack_require__(390));
	
	var _on = _interopRequireDefault(__webpack_require__(391));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(392));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(393));
	
	var _requestAnimationFrame = _interopRequireDefault(__webpack_require__(394));
	
	var _invariant = _interopRequireDefault(__webpack_require__(27));
	
	var _utils = __webpack_require__(2108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/* eslint-disable no-underscore-dangle */
	// Try at most this many times to scroll, to avoid getting stuck.
	var MAX_SCROLL_ATTEMPTS = 2;
	
	var ScrollBehavior = /*#__PURE__*/function () {
	  function ScrollBehavior(_ref) {
	    var _this = this;
	
	    var addTransitionHook = _ref.addTransitionHook,
	        stateStorage = _ref.stateStorage,
	        getCurrentLocation = _ref.getCurrentLocation,
	        shouldUpdateScroll = _ref.shouldUpdateScroll;
	
	    this._restoreScrollRestoration = function () {
	      /* istanbul ignore if: not supported by any browsers on Travis */
	      if (_this._oldScrollRestoration) {
	        try {
	          window.history.scrollRestoration = _this._oldScrollRestoration;
	        } catch (e) {
	          /* silence */
	        }
	      }
	    };
	
	    this._onWindowScroll = function () {
	      if (_this._ignoreScrollEvents) {
	        // Don't save the scroll position until the transition is complete
	        return;
	      } // It's possible that this scroll operation was triggered by what will be a
	      // `POP` transition. Instead of updating the saved location immediately, we
	      // have to enqueue the update, then potentially cancel it if we observe a
	      // location update.
	
	
	      if (!_this._saveWindowPositionHandle) {
	        _this._saveWindowPositionHandle = (0, _requestAnimationFrame["default"])(_this._saveWindowPosition);
	      }
	
	      if (_this._windowScrollTarget) {
	        var _this$_windowScrollTa = _this._windowScrollTarget,
	            xTarget = _this$_windowScrollTa[0],
	            yTarget = _this$_windowScrollTa[1];
	        var x = (0, _scrollLeft["default"])(window);
	        var y = (0, _scrollTop["default"])(window);
	
	        if (x === xTarget && y === yTarget) {
	          _this._windowScrollTarget = null;
	
	          _this._cancelCheckWindowScroll();
	        }
	      }
	    };
	
	    this._saveWindowPosition = function () {
	      _this._saveWindowPositionHandle = null;
	
	      _this._savePosition(null, window);
	    };
	
	    this._checkWindowScrollPosition = function () {
	      _this._checkWindowScrollHandle = null; // We can only get here if scrollTarget is set. Every code path that unsets
	      // scroll target also cancels the handle to avoid calling this handler.
	      // Still, check anyway just in case.
	
	      /* istanbul ignore if: paranoid guard */
	
	      if (!_this._windowScrollTarget) {
	        return Promise.resolve();
	      }
	
	      _this.scrollToTarget(window, _this._windowScrollTarget);
	
	      ++_this._numWindowScrollAttempts;
	      /* istanbul ignore if: paranoid guard */
	
	      if (_this._numWindowScrollAttempts >= MAX_SCROLL_ATTEMPTS) {
	        // This might happen if the scroll position was already set to the target
	        _this._windowScrollTarget = null;
	        return Promise.resolve();
	      }
	
	      return new Promise(function (resolve) {
	        _this._checkWindowScrollHandle = (0, _requestAnimationFrame["default"])(function () {
	          return resolve(_this._checkWindowScrollPosition());
	        });
	      });
	    };
	
	    this._stateStorage = stateStorage;
	    this._getCurrentLocation = getCurrentLocation;
	    this._shouldUpdateScroll = shouldUpdateScroll; // This helps avoid some jankiness in fighting against the browser's
	    // default scroll behavior on `POP` transitions.
	
	    /* istanbul ignore else: Travis browsers all support this */
	
	    if ('scrollRestoration' in window.history && // Unfortunately, Safari on iOS freezes for 2-6s after the user swipes to
	    // navigate through history with scrollRestoration being 'manual', so we
	    // need to detect this browser and exclude it from the following code
	    // until this bug is fixed by Apple.
	    !(0, _utils.isMobileSafari)()) {
	      this._oldScrollRestoration = window.history.scrollRestoration;
	
	      try {
	        window.history.scrollRestoration = 'manual'; // Scroll restoration persists across page reloads. We want to reset
	        // this to the original value, so that we can let the browser handle
	        // restoring the initial scroll position on server-rendered pages.
	
	        (0, _on["default"])(window, 'beforeunload', this._restoreScrollRestoration);
	      } catch (e) {
	        this._oldScrollRestoration = null;
	      }
	    } else {
	      this._oldScrollRestoration = null;
	    }
	
	    this._saveWindowPositionHandle = null;
	    this._checkWindowScrollHandle = null;
	    this._windowScrollTarget = null;
	    this._numWindowScrollAttempts = 0;
	    this._ignoreScrollEvents = false;
	    this._scrollElements = {}; // We have to listen to each window scroll update rather than to just
	    // location updates, because some browsers will update scroll position
	    // before emitting the location change.
	
	    (0, _on["default"])(window, 'scroll', this._onWindowScroll);
	    this._removeTransitionHook = addTransitionHook(function () {
	      _requestAnimationFrame["default"].cancel(_this._saveWindowPositionHandle);
	
	      _this._saveWindowPositionHandle = null;
	      Object.keys(_this._scrollElements).forEach(function (key) {
	        var scrollElement = _this._scrollElements[key];
	
	        _requestAnimationFrame["default"].cancel(scrollElement.savePositionHandle);
	
	        scrollElement.savePositionHandle = null; // It's fine to save element scroll positions here, though; the browser
	        // won't modify them.
	
	        if (!_this._ignoreScrollEvents) {
	          _this._saveElementPosition(key);
	        }
	      });
	    });
	  }
	
	  var _proto = ScrollBehavior.prototype;
	
	  _proto.registerElement = function registerElement(key, element, shouldUpdateScroll, context) {
	    var _this2 = this;
	
	    !!this._scrollElements[key] ?  false ? (0, _invariant["default"])(false, 'ScrollBehavior: There is already an element registered for `%s`.', key) : invariant(false) : void 0;
	
	    var saveElementPosition = function saveElementPosition() {
	      _this2._saveElementPosition(key);
	    };
	
	    var scrollElement = {
	      element: element,
	      shouldUpdateScroll: shouldUpdateScroll,
	      savePositionHandle: null,
	      onScroll: function onScroll() {
	        if (!scrollElement.savePositionHandle && !_this2._ignoreScrollEvents) {
	          scrollElement.savePositionHandle = (0, _requestAnimationFrame["default"])(saveElementPosition);
	        }
	      }
	    }; // In case no scrolling occurs, save the initial position
	
	    if (!scrollElement.savePositionHandle && !this._ignoreScrollEvents) {
	      scrollElement.savePositionHandle = (0, _requestAnimationFrame["default"])(saveElementPosition);
	    }
	
	    this._scrollElements[key] = scrollElement;
	    (0, _on["default"])(element, 'scroll', scrollElement.onScroll);
	
	    this._updateElementScroll(key, null, context);
	  };
	
	  _proto.unregisterElement = function unregisterElement(key) {
	    !this._scrollElements[key] ?  false ? (0, _invariant["default"])(false, 'ScrollBehavior: There is no element registered for `%s`.', key) : invariant(false) : void 0;
	    var _this$_scrollElements = this._scrollElements[key],
	        element = _this$_scrollElements.element,
	        onScroll = _this$_scrollElements.onScroll,
	        savePositionHandle = _this$_scrollElements.savePositionHandle;
	    (0, _off["default"])(element, 'scroll', onScroll);
	
	    _requestAnimationFrame["default"].cancel(savePositionHandle);
	
	    delete this._scrollElements[key];
	  };
	
	  _proto.updateScroll = function updateScroll(prevContext, context) {
	    var _this3 = this;
	
	    this._updateWindowScroll(prevContext, context).then(function () {
	      // Save the position immediately after a transition so that if no
	      // scrolling occurs, there is still a saved position
	      if (!_this3._saveWindowPositionHandle) {
	        _this3._saveWindowPositionHandle = (0, _requestAnimationFrame["default"])(_this3._saveWindowPosition);
	      }
	    });
	
	    Object.keys(this._scrollElements).forEach(function (key) {
	      _this3._updateElementScroll(key, prevContext, context);
	    });
	  };
	
	  _proto.stop = function stop() {
	    this._restoreScrollRestoration();
	
	    (0, _off["default"])(window, 'scroll', this._onWindowScroll);
	
	    this._cancelCheckWindowScroll();
	
	    this._removeTransitionHook();
	  };
	
	  _proto.startIgnoringScrollEvents = function startIgnoringScrollEvents() {
	    this._ignoreScrollEvents = true;
	  };
	
	  _proto.stopIgnoringScrollEvents = function stopIgnoringScrollEvents() {
	    this._ignoreScrollEvents = false;
	  };
	
	  _proto._cancelCheckWindowScroll = function _cancelCheckWindowScroll() {
	    _requestAnimationFrame["default"].cancel(this._checkWindowScrollHandle);
	
	    this._checkWindowScrollHandle = null;
	  };
	
	  _proto._saveElementPosition = function _saveElementPosition(key) {
	    var scrollElement = this._scrollElements[key];
	    scrollElement.savePositionHandle = null;
	
	    this._savePosition(key, scrollElement.element);
	  };
	
	  _proto._savePosition = function _savePosition(key, element) {
	    this._stateStorage.save(this._getCurrentLocation(), key, [(0, _scrollLeft["default"])(element), (0, _scrollTop["default"])(element)]);
	  };
	
	  _proto._updateWindowScroll = function _updateWindowScroll(prevContext, context) {
	    // Whatever we were doing before isn't relevant any more.
	    this._cancelCheckWindowScroll();
	
	    this._windowScrollTarget = this._getScrollTarget(null, this._shouldUpdateScroll, prevContext, context); // Updating the window scroll position is really flaky. Just trying to
	    // scroll it isn't enough. Instead, try to scroll a few times until it
	    // works.
	
	    this._numWindowScrollAttempts = 0;
	    return this._checkWindowScrollPosition();
	  };
	
	  _proto._updateElementScroll = function _updateElementScroll(key, prevContext, context) {
	    var _this$_scrollElements2 = this._scrollElements[key],
	        element = _this$_scrollElements2.element,
	        shouldUpdateScroll = _this$_scrollElements2.shouldUpdateScroll;
	
	    var scrollTarget = this._getScrollTarget(key, shouldUpdateScroll, prevContext, context);
	
	    if (!scrollTarget) {
	      return;
	    } // Unlike with the window, there shouldn't be any flakiness to deal with
	    // here.
	
	
	    this.scrollToTarget(element, scrollTarget);
	  };
	
	  _proto._getDefaultScrollTarget = function _getDefaultScrollTarget(location) {
	    var hash = location.hash;
	
	    if (hash && hash !== '#') {
	      return hash.charAt(0) === '#' ? hash.slice(1) : hash;
	    }
	
	    return [0, 0];
	  };
	
	  _proto._getScrollTarget = function _getScrollTarget(key, shouldUpdateScroll, prevContext, context) {
	    var scrollTarget = shouldUpdateScroll ? shouldUpdateScroll.call(this, prevContext, context) : true;
	
	    if (!scrollTarget || Array.isArray(scrollTarget) || typeof scrollTarget === 'string') {
	      return scrollTarget;
	    }
	
	    var location = this._getCurrentLocation();
	
	    return this._getSavedScrollTarget(key, location) || this._getDefaultScrollTarget(location);
	  };
	
	  _proto._getSavedScrollTarget = function _getSavedScrollTarget(key, location) {
	    if (location.action === 'PUSH') {
	      return null;
	    }
	
	    return this._stateStorage.read(location, key);
	  };
	
	  _proto.scrollToTarget = function scrollToTarget(element, target) {
	    if (typeof target === 'string') {
	      var targetElement = document.getElementById(target) || document.getElementsByName(target)[0];
	
	      if (targetElement) {
	        targetElement.scrollIntoView();
	        return;
	      } // Fallback to scrolling to top when target fragment doesn't exist.
	
	
	      target = [0, 0]; // eslint-disable-line no-param-reassign
	    }
	
	    var _target = target,
	        left = _target[0],
	        top = _target[1];
	    (0, _scrollLeft["default"])(element, left);
	    (0, _scrollTop["default"])(element, top);
	  };
	
	  return ScrollBehavior;
	}();
	
	exports["default"] = ScrollBehavior;
	module.exports = exports.default;

/***/ }),
/* 2108 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isMobileSafari = isMobileSafari;
	
	function isMobileSafari() {
	  return /iPad|iPhone|iPod/.test(window.navigator.platform) && /^((?!CriOS).)*Safari/.test(window.navigator.userAgent);
	}

/***/ }),
/* 2109 */,
/* 2110 */
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.space = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _util = __webpack_require__(123);
	
	var _constants = __webpack_require__(198);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var REG = /^[mp][trblxy]?$/;
	
	var space = exports.space = function space(props) {
	  var keys = Object.keys(props).filter(function (key) {
	    return REG.test(key);
	  }).sort();
	  var bp = (0, _util.breaks)(props);
	  var sc = (0, _util.get)(props, 'theme.space', _constants2.default.space);
	
	  return keys.map(function (key) {
	    var val = props[key];
	    var p = getProperties(key);
	
	    if (!Array.isArray(val)) {
	      return p.reduce(function (a, b) {
	        return Object.assign(a, _defineProperty({}, b, mx(sc)(val)));
	      }, {});
	    }
	
	    return (0, _util.arr)(val).map(mx(sc)).map((0, _util.dec)(p)).map((0, _util.media)(bp)).reduce(_util.merge, {});
	  }).reduce(_util.merge, {});
	};
	
	var mx = function mx(scale) {
	  return function (n) {
	    if (!(0, _util.num)(n)) {
	      return scale[n] || n;
	    }
	
	    var value = scale[Math.abs(n)] || Math.abs(n);
	    if (!(0, _util.num)(value)) {
	      return (0, _util.neg)(n) ? '-' + value : value;
	    }
	
	    return (0, _util.px)(value * ((0, _util.neg)(n) ? -1 : 1));
	  };
	};
	
	var getProperties = function getProperties(key) {
	  var _key$split = key.split(''),
	      _key$split2 = _slicedToArray(_key$split, 2),
	      a = _key$split2[0],
	      b = _key$split2[1];
	
	  var prop = properties[a];
	  var dirs = directions[b] || [''];
	  return dirs.map(function (dir) {
	    return prop + dir;
	  });
	};
	
	var properties = {
	  m: 'margin',
	  p: 'padding'
	};
	
	var directions = {
	  t: ['Top'],
	  r: ['Right'],
	  b: ['Bottom'],
	  l: ['Left'],
	  x: ['Left', 'Right'],
	  y: ['Top', 'Bottom']
	};
	
	var responsive = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]);
	
	space.propTypes = {
	  m: responsive,
	  mt: responsive,
	  mr: responsive,
	  mb: responsive,
	  ml: responsive,
	  mx: responsive,
	  my: responsive,
	  p: responsive,
	  pt: responsive,
	  pr: responsive,
	  pb: responsive,
	  pl: responsive,
	  px: responsive,
	  py: responsive
	};
	
	var meta = function meta(prop) {
	  return {
	    prop: prop,
	    responsive: true,
	    styleType: 'responsive',
	    themeKey: 'space'
	  };
	};
	Object.keys(space.propTypes).forEach(function (prop) {
	  space.propTypes[prop].meta = meta(prop);
	});
	
	exports.default = space;

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.borderWidth = exports.buttonStyle = exports.colorStyle = exports.textStyle = exports.disabled = exports.active = exports.focus = exports.hover = exports.left = exports.bottom = exports.right = exports.top = exports.zIndex = exports.position = exports.backgroundRepeat = exports.backgroundPosition = exports.backgroundSize = exports.backgroundImage = exports.background = exports.boxShadow = exports.borderRadius = exports.borderColor = exports.borders = exports.borderLeft = exports.borderBottom = exports.borderRight = exports.borderTop = exports.border = exports.gridTemplateRows = exports.gridTemplateColumns = exports.gridAutoRows = exports.gridAutoColumns = exports.gridAutoFlow = exports.gridRow = exports.gridColumn = exports.gridRowGap = exports.gridColumnGap = exports.gridGap = exports.order = exports.alignSelf = exports.justifySelf = exports.flex = exports.flexDirection = exports.flexBasis = exports.flexWrap = exports.justifyContent = exports.alignContent = exports.alignItems = exports.verticalAlign = exports.ratio = exports.ratioPadding = exports.size = exports.sizeHeight = exports.sizeWidth = exports.minHeight = exports.maxHeight = exports.height = exports.minWidth = exports.maxWidth = exports.display = exports.letterSpacing = exports.fontWeight = exports.lineHeight = exports.textAlign = exports.fontFamily = exports.opacity = exports.color = exports.bgColor = exports.textColor = exports.fontSize = exports.width = exports.space = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _space = __webpack_require__(2111);
	
	Object.defineProperty(exports, 'space', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_space).default;
	  }
	});
	
	var _util = __webpack_require__(123);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var width = exports.width = (0, _util.responsiveStyle)({
	  prop: 'width',
	  alias: 'w',
	  getter: _util.getWidth
	});
	
	var fontSize = exports.fontSize = (0, _util.responsiveStyle)({
	  prop: 'fontSize',
	  alias: 'f',
	  key: 'fontSizes',
	  numberToPx: true
	});
	
	var textColor = exports.textColor = (0, _util.responsiveStyle)({
	  prop: 'color',
	  key: 'colors'
	});
	
	var bgColor = exports.bgColor = (0, _util.responsiveStyle)({
	  prop: 'bg',
	  cssProperty: 'backgroundColor',
	  key: 'colors'
	});
	
	var color = exports.color = function color(props) {
	  return _extends({}, textColor(props), bgColor(props));
	};
	color.propTypes = _extends({}, textColor.propTypes, bgColor.propTypes);
	
	var opacity = exports.opacity = (0, _util.responsiveStyle)({
	  prop: 'opacity'
	});
	
	// typography
	var fontFamily = exports.fontFamily = (0, _util.style)({
	  prop: 'fontFamily',
	  alias: 'font',
	  key: 'fonts'
	});
	
	var textAlign = exports.textAlign = (0, _util.responsiveStyle)({
	  prop: 'textAlign',
	  // for backwards compatibility - will cause bugs when used with alignItems
	  alias: 'align'
	});
	
	var lineHeight = exports.lineHeight = (0, _util.responsiveStyle)({
	  prop: 'lineHeight',
	  key: 'lineHeights'
	});
	
	var fontWeight = exports.fontWeight = (0, _util.style)({
	  prop: 'fontWeight',
	  key: 'fontWeights'
	});
	
	var letterSpacing = exports.letterSpacing = (0, _util.style)({
	  prop: 'letterSpacing',
	  key: 'letterSpacings',
	  numberToPx: true
	});
	
	// layout
	var display = exports.display = (0, _util.responsiveStyle)({
	  prop: 'display'
	});
	
	var maxWidth = exports.maxWidth = (0, _util.responsiveStyle)({
	  prop: 'maxWidth',
	  key: 'maxWidths',
	  numberToPx: true
	});
	
	var minWidth = exports.minWidth = (0, _util.responsiveStyle)({
	  prop: 'minWidth',
	  key: 'minWidths',
	  numberToPx: true
	});
	
	var height = exports.height = (0, _util.responsiveStyle)({
	  prop: 'height',
	  key: 'heights',
	  numberToPx: true
	});
	
	var maxHeight = exports.maxHeight = (0, _util.responsiveStyle)({
	  prop: 'maxHeight',
	  key: 'maxHeights',
	  numberToPx: true
	});
	
	var minHeight = exports.minHeight = (0, _util.responsiveStyle)({
	  prop: 'minHeight',
	  key: 'minHeights',
	  numberToPx: true
	});
	
	var sizeWidth = exports.sizeWidth = (0, _util.responsiveStyle)({
	  prop: 'size',
	  cssProperty: 'width',
	  numberToPx: true
	});
	
	var sizeHeight = exports.sizeHeight = (0, _util.responsiveStyle)({
	  prop: 'size',
	  cssProperty: 'height',
	  numberToPx: true
	});
	
	var size = exports.size = function size(props) {
	  return (0, _util.merge)(sizeHeight(props), sizeWidth(props));
	};
	
	size.propTypes = _extends({}, sizeWidth.propTypes, sizeHeight.propTypes);
	
	var ratioPadding = exports.ratioPadding = (0, _util.style)({
	  prop: 'ratio',
	  cssProperty: 'paddingBottom',
	  getter: function getter(n) {
	    return n * 100 + '%';
	  }
	});
	
	var ratio = exports.ratio = function ratio(props) {
	  return props.ratio ? _extends({
	    height: 0
	  }, ratioPadding(props)) : null;
	};
	ratio.propTypes = _extends({}, ratioPadding.propTypes);
	
	var verticalAlign = exports.verticalAlign = (0, _util.style)({
	  prop: 'verticalAlign'
	});
	
	// flexbox
	var alignItems = exports.alignItems = (0, _util.responsiveStyle)({
	  prop: 'alignItems',
	  // for backwards compatibility - will cause bugs when used with textAlign
	  alias: 'align'
	});
	
	var alignContent = exports.alignContent = (0, _util.responsiveStyle)({
	  prop: 'alignContent'
	});
	
	var justifyContent = exports.justifyContent = (0, _util.responsiveStyle)({
	  prop: 'justifyContent',
	  // for backwards compatibility
	  alias: 'justify'
	});
	
	// for backwards compatibility
	var flexWrapShim = function flexWrapShim(n) {
	  return n === true ? 'wrap' : n;
	};
	var flexWrap = exports.flexWrap = (0, _util.responsiveStyle)({
	  prop: 'flexWrap',
	  alias: 'wrap',
	  getter: flexWrapShim
	});
	
	var flexBasis = exports.flexBasis = (0, _util.responsiveStyle)({
	  prop: 'flexBasis',
	  getter: _util.getWidth
	});
	
	var flexDirection = exports.flexDirection = (0, _util.responsiveStyle)({
	  prop: 'flexDirection'
	});
	
	var flex = exports.flex = (0, _util.responsiveStyle)({
	  prop: 'flex'
	});
	
	var justifySelf = exports.justifySelf = (0, _util.responsiveStyle)({
	  prop: 'justifySelf'
	});
	
	var alignSelf = exports.alignSelf = (0, _util.responsiveStyle)({
	  prop: 'alignSelf'
	});
	
	var order = exports.order = (0, _util.responsiveStyle)({
	  prop: 'order'
	});
	
	// grid
	var gridGap = exports.gridGap = (0, _util.responsiveStyle)({
	  prop: 'gridGap',
	  numberToPx: true,
	  key: 'space'
	});
	
	var gridColumnGap = exports.gridColumnGap = (0, _util.responsiveStyle)({
	  prop: 'gridColumnGap',
	  numberToPx: true,
	  key: 'space'
	});
	
	var gridRowGap = exports.gridRowGap = (0, _util.responsiveStyle)({
	  prop: 'gridRowGap',
	  numberToPx: true,
	  key: 'space'
	});
	
	var gridColumn = exports.gridColumn = (0, _util.responsiveStyle)({
	  prop: 'gridColumn'
	});
	
	var gridRow = exports.gridRow = (0, _util.responsiveStyle)({
	  prop: 'gridRow'
	});
	
	var gridAutoFlow = exports.gridAutoFlow = (0, _util.style)({
	  prop: 'gridAutoFlow'
	});
	
	var gridAutoColumns = exports.gridAutoColumns = (0, _util.style)({
	  prop: 'gridAutoColumns'
	});
	
	var gridAutoRows = exports.gridAutoRows = (0, _util.style)({
	  prop: 'gridAutoRows'
	});
	
	var gridTemplateColumns = exports.gridTemplateColumns = (0, _util.responsiveStyle)({
	  prop: 'gridTemplateColumns'
	});
	
	var gridTemplateRows = exports.gridTemplateRows = (0, _util.responsiveStyle)({
	  prop: 'gridTemplateRows'
	});
	
	// borders
	var getBorder = function getBorder(n) {
	  return util.num(n) && n > 0 ? n + 'px solid' : n;
	};
	
	var border = exports.border = (0, _util.responsiveStyle)({
	  prop: 'border',
	  key: 'borders',
	  getter: getBorder
	});
	
	var borderTop = exports.borderTop = (0, _util.responsiveStyle)({
	  prop: 'borderTop',
	  key: 'borders',
	  getter: getBorder
	});
	
	var borderRight = exports.borderRight = (0, _util.responsiveStyle)({
	  prop: 'borderRight',
	  key: 'borders',
	  getter: getBorder
	});
	
	var borderBottom = exports.borderBottom = (0, _util.responsiveStyle)({
	  prop: 'borderBottom',
	  key: 'borders',
	  getter: getBorder
	});
	
	var borderLeft = exports.borderLeft = (0, _util.responsiveStyle)({
	  prop: 'borderLeft',
	  key: 'borders',
	  getter: getBorder
	});
	
	var borders = exports.borders = function borders(props) {
	  return _extends({}, border(props), borderTop(props), borderRight(props), borderBottom(props), borderLeft(props));
	};
	borders.propTypes = _extends({}, border.propTypes, borderTop.propTypes, borderRight.propTypes, borderBottom.propTypes, borderLeft.propTypes);
	
	var borderColor = exports.borderColor = (0, _util.style)({
	  prop: 'borderColor',
	  key: 'colors'
	});
	
	var borderRadius = exports.borderRadius = (0, _util.style)({
	  prop: 'borderRadius',
	  key: 'radii',
	  numberToPx: true
	});
	
	var boxShadow = exports.boxShadow = (0, _util.style)({
	  prop: 'boxShadow',
	  key: 'shadows'
	});
	
	// backgrounds
	var background = exports.background = (0, _util.style)({
	  prop: 'background'
	});
	
	var backgroundImage = exports.backgroundImage = (0, _util.style)({
	  prop: 'backgroundImage',
	  alias: 'bgImage',
	  getter: function getter(n) {
	    return 'url(' + n + ')';
	  }
	});
	
	var backgroundSize = exports.backgroundSize = (0, _util.style)({
	  prop: 'backgroundSize',
	  alias: 'bgSize'
	});
	
	var backgroundPosition = exports.backgroundPosition = (0, _util.style)({
	  prop: 'backgroundPosition',
	  alias: 'bgPosition'
	});
	
	var backgroundRepeat = exports.backgroundRepeat = (0, _util.style)({
	  prop: 'backgroundRepeat',
	  alias: 'bgRepeat'
	});
	
	// position
	var position = exports.position = (0, _util.responsiveStyle)({
	  prop: 'position'
	});
	
	var zIndex = exports.zIndex = (0, _util.style)({
	  prop: 'zIndex'
	});
	
	var top = exports.top = (0, _util.responsiveStyle)({
	  prop: 'top',
	  numberToPx: true
	});
	
	var right = exports.right = (0, _util.responsiveStyle)({
	  prop: 'right',
	  numberToPx: true
	});
	
	var bottom = exports.bottom = (0, _util.responsiveStyle)({
	  prop: 'bottom',
	  numberToPx: true
	});
	
	var left = exports.left = (0, _util.responsiveStyle)({
	  prop: 'left',
	  numberToPx: true
	});
	
	// pseudos
	var hover = exports.hover = (0, _util.pseudoStyle)({
	  prop: 'hover',
	  pseudoclass: 'hover',
	  keys: {
	    color: 'colors',
	    backgroundColor: 'colors',
	    borderColor: 'colors',
	    boxShadow: 'shadows'
	  }
	});
	
	var focus = exports.focus = (0, _util.pseudoStyle)({
	  prop: 'focus',
	  keys: {
	    color: 'colors',
	    backgroundColor: 'colors',
	    borderColor: 'colors',
	    boxShadow: 'shadows'
	  }
	});
	
	var active = exports.active = (0, _util.pseudoStyle)({
	  prop: 'active',
	  keys: {
	    color: 'colors',
	    backgroundColor: 'colors',
	    borderColor: 'colors',
	    boxShadow: 'shadows'
	  }
	});
	
	var disabled = exports.disabled = (0, _util.pseudoStyle)({
	  prop: 'disabledStyle',
	  pseudoclass: 'disabled',
	  keys: {
	    color: 'colors',
	    backgroundColor: 'colors',
	    borderColor: 'colors',
	    boxShadow: 'shadows'
	  }
	});
	
	var textStyle = exports.textStyle = (0, _util.complexStyle)({
	  prop: 'textStyle',
	  key: 'textStyles'
	});
	
	var colorStyle = exports.colorStyle = (0, _util.complexStyle)({
	  prop: 'colors',
	  key: 'colorStyles'
	});
	
	var buttonStyle = exports.buttonStyle = (0, _util.complexStyle)({
	  prop: 'buttonStyle',
	  key: 'buttons'
	});
	
	// for backwards-compatibility
	// these will be removed in v3
	var __DEV__ = ("production") !== 'production';
	
	var borderWidth = exports.borderWidth = (0, _util.style)({
	  prop: 'borderWidth',
	  cssProperty: 'border',
	  key: 'borderWidths',
	  getter: function getter(v) {
	    if (__DEV__) {
	      console.warn('borderWidth is deprecated. Please use the `borders` utility instead');
	    }
	    return getBorder(v);
	  }
	});

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							return insertRule(content+';'), ''
						break
					// selector
					case 2:
						if (ns === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (ns) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + (at === 0 ? delimiter : '')
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(199)(module)))

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e){ true?module.exports=e(null):"function"==typeof define&&define.amd?define(e(null)):window.stylis=e(null)}(function e(a){"use strict";var r=/^\0+/g,c=/[\0\r\f]/g,s=/: */g,t=/zoo|gra/,i=/([,: ])(transform)/g,f=/,+\s*(?![^(]*[)])/g,n=/ +\s*(?![^(]*[)])/g,l=/ *[\0] */g,o=/,\r+?/g,h=/([\t\r\n ])*\f?&/g,u=/:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,d=/\W+/g,b=/@(k\w+)\s*(\S*)\s*/,p=/::(place)/g,k=/:(read-only)/g,g=/\s+(?=[{\];=:>])/g,A=/([[}=:>])\s+/g,C=/(\{[^{]+?);(?=\})/g,w=/\s{2,}/g,v=/([^\(])(:+) */g,m=/[svh]\w+-[tblr]{2}/,x=/\(\s*(.*)\s*\)/g,$=/([\s\S]*?);/g,y=/-self|flex-/g,O=/[^]*?(:[rp][el]a[\w-]+)[^]*/,j=/stretch|:\s*\w+\-(?:conte|avail)/,z=/([^-])(image-set\()/,N="-webkit-",S="-moz-",F="-ms-",W=59,q=125,B=123,D=40,E=41,G=91,H=93,I=10,J=13,K=9,L=64,M=32,P=38,Q=45,R=95,T=42,U=44,V=58,X=39,Y=34,Z=47,_=62,ee=43,ae=126,re=0,ce=12,se=11,te=107,ie=109,fe=115,ne=112,le=111,oe=105,he=99,ue=100,de=112,be=1,pe=1,ke=0,ge=1,Ae=1,Ce=1,we=0,ve=0,me=0,xe=[],$e=[],ye=0,Oe=null,je=-2,ze=-1,Ne=0,Se=1,Fe=2,We=3,qe=0,Be=1,De="",Ee="",Ge="";function He(e,a,s,t,i){for(var f,n,o=0,h=0,u=0,d=0,g=0,A=0,C=0,w=0,m=0,$=0,y=0,O=0,j=0,z=0,R=0,we=0,$e=0,Oe=0,je=0,ze=s.length,Je=ze-1,Re="",Te="",Ue="",Ve="",Xe="",Ye="";R<ze;){if(C=s.charCodeAt(R),R===Je)if(h+d+u+o!==0){if(0!==h)C=h===Z?I:Z;d=u=o=0,ze++,Je++}if(h+d+u+o===0){if(R===Je){if(we>0)Te=Te.replace(c,"");if(Te.trim().length>0){switch(C){case M:case K:case W:case J:case I:break;default:Te+=s.charAt(R)}C=W}}if(1===$e)switch(C){case B:case q:case W:case Y:case X:case D:case E:case U:$e=0;case K:case J:case I:case M:break;default:for($e=0,je=R,g=C,R--,C=W;je<ze;)switch(s.charCodeAt(je++)){case I:case J:case W:++R,C=g,je=ze;break;case V:if(we>0)++R,C=g;case B:je=ze}}switch(C){case B:for(g=(Te=Te.trim()).charCodeAt(0),y=1,je=++R;R<ze;){switch(C=s.charCodeAt(R)){case B:y++;break;case q:y--;break;case Z:switch(A=s.charCodeAt(R+1)){case T:case Z:R=Qe(A,R,Je,s)}break;case G:C++;case D:C++;case Y:case X:for(;R++<Je&&s.charCodeAt(R)!==C;);}if(0===y)break;R++}if(Ue=s.substring(je,R),g===re)g=(Te=Te.replace(r,"").trim()).charCodeAt(0);switch(g){case L:if(we>0)Te=Te.replace(c,"");switch(A=Te.charCodeAt(1)){case ue:case ie:case fe:case Q:f=a;break;default:f=xe}if(je=(Ue=He(a,f,Ue,A,i+1)).length,me>0&&0===je)je=Te.length;if(ye>0)if(f=Ie(xe,Te,Oe),n=Pe(We,Ue,f,a,pe,be,je,A,i,t),Te=f.join(""),void 0!==n)if(0===(je=(Ue=n.trim()).length))A=0,Ue="";if(je>0)switch(A){case fe:Te=Te.replace(x,Me);case ue:case ie:case Q:Ue=Te+"{"+Ue+"}";break;case te:if(Ue=(Te=Te.replace(b,"$1 $2"+(Be>0?De:"")))+"{"+Ue+"}",1===Ae||2===Ae&&Le("@"+Ue,3))Ue="@"+N+Ue+"@"+Ue;else Ue="@"+Ue;break;default:if(Ue=Te+Ue,t===de)Ve+=Ue,Ue=""}else Ue="";break;default:Ue=He(a,Ie(a,Te,Oe),Ue,t,i+1)}Xe+=Ue,O=0,$e=0,z=0,we=0,Oe=0,j=0,Te="",Ue="",C=s.charCodeAt(++R);break;case q:case W:if((je=(Te=(we>0?Te.replace(c,""):Te).trim()).length)>1){if(0===z)if((g=Te.charCodeAt(0))===Q||g>96&&g<123)je=(Te=Te.replace(" ",":")).length;if(ye>0)if(void 0!==(n=Pe(Se,Te,a,e,pe,be,Ve.length,t,i,t)))if(0===(je=(Te=n.trim()).length))Te="\0\0";switch(g=Te.charCodeAt(0),A=Te.charCodeAt(1),g){case re:break;case L:if(A===oe||A===he){Ye+=Te+s.charAt(R);break}default:if(Te.charCodeAt(je-1)===V)break;Ve+=Ke(Te,g,A,Te.charCodeAt(2))}}O=0,$e=0,z=0,we=0,Oe=0,Te="",C=s.charCodeAt(++R)}}switch(C){case J:case I:if(h+d+u+o+ve===0)switch($){case E:case X:case Y:case L:case ae:case _:case T:case ee:case Z:case Q:case V:case U:case W:case B:case q:break;default:if(z>0)$e=1}if(h===Z)h=0;else if(ge+O===0&&t!==te&&Te.length>0)we=1,Te+="\0";if(ye*qe>0)Pe(Ne,Te,a,e,pe,be,Ve.length,t,i,t);be=1,pe++;break;case W:case q:if(h+d+u+o===0){be++;break}default:switch(be++,Re=s.charAt(R),C){case K:case M:if(d+o+h===0)switch(w){case U:case V:case K:case M:Re="";break;default:if(C!==M)Re=" "}break;case re:Re="\\0";break;case ce:Re="\\f";break;case se:Re="\\v";break;case P:if(d+h+o===0&&ge>0)Oe=1,we=1,Re="\f"+Re;break;case 108:if(d+h+o+ke===0&&z>0)switch(R-z){case 2:if(w===ne&&s.charCodeAt(R-3)===V)ke=w;case 8:if(m===le)ke=m}break;case V:if(d+h+o===0)z=R;break;case U:if(h+u+d+o===0)we=1,Re+="\r";break;case Y:case X:if(0===h)d=d===C?0:0===d?C:d;break;case G:if(d+h+u===0)o++;break;case H:if(d+h+u===0)o--;break;case E:if(d+h+o===0)u--;break;case D:if(d+h+o===0){if(0===O)switch(2*w+3*m){case 533:break;default:y=0,O=1}u++}break;case L:if(h+u+d+o+z+j===0)j=1;break;case T:case Z:if(d+o+u>0)break;switch(h){case 0:switch(2*C+3*s.charCodeAt(R+1)){case 235:h=Z;break;case 220:je=R,h=T}break;case T:if(C===Z&&w===T&&je+2!==R){if(33===s.charCodeAt(je+2))Ve+=s.substring(je,R+1);Re="",h=0}}}if(0===h){if(ge+d+o+j===0&&t!==te&&C!==W)switch(C){case U:case ae:case _:case ee:case E:case D:if(0===O){switch(w){case K:case M:case I:case J:Re+="\0";break;default:Re="\0"+Re+(C===U?"":"\0")}we=1}else switch(C){case D:if(z+7===R&&108===w)z=0;O=++y;break;case E:if(0==(O=--y))we=1,Re+="\0"}break;case K:case M:switch(w){case re:case B:case q:case W:case U:case ce:case K:case M:case I:case J:break;default:if(0===O)we=1,Re+="\0"}}if(Te+=Re,C!==M&&C!==K)$=C}}m=w,w=C,R++}if(je=Ve.length,me>0)if(0===je&&0===Xe.length&&0===a[0].length==false)if(t!==ie||1===a.length&&(ge>0?Ee:Ge)===a[0])je=a.join(",").length+2;if(je>0){if(f=0===ge&&t!==te?function(e){for(var a,r,s=0,t=e.length,i=Array(t);s<t;++s){for(var f=e[s].split(l),n="",o=0,h=0,u=0,d=0,b=f.length;o<b;++o){if(0===(h=(r=f[o]).length)&&b>1)continue;if(u=n.charCodeAt(n.length-1),d=r.charCodeAt(0),a="",0!==o)switch(u){case T:case ae:case _:case ee:case M:case D:break;default:a=" "}switch(d){case P:r=a+Ee;case ae:case _:case ee:case M:case E:case D:break;case G:r=a+r+Ee;break;case V:switch(2*r.charCodeAt(1)+3*r.charCodeAt(2)){case 530:if(Ce>0){r=a+r.substring(8,h-1);break}default:if(o<1||f[o-1].length<1)r=a+Ee+r}break;case U:a="";default:if(h>1&&r.indexOf(":")>0)r=a+r.replace(v,"$1"+Ee+"$2");else r=a+r+Ee}n+=r}i[s]=n.replace(c,"").trim()}return i}(a):a,ye>0)if(void 0!==(n=Pe(Fe,Ve,f,e,pe,be,je,t,i,t))&&0===(Ve=n).length)return Ye+Ve+Xe;if(Ve=f.join(",")+"{"+Ve+"}",Ae*ke!=0){if(2===Ae&&!Le(Ve,2))ke=0;switch(ke){case le:Ve=Ve.replace(k,":"+S+"$1")+Ve;break;case ne:Ve=Ve.replace(p,"::"+N+"input-$1")+Ve.replace(p,"::"+S+"$1")+Ve.replace(p,":"+F+"input-$1")+Ve}ke=0}}return Ye+Ve+Xe}function Ie(e,a,r){var c=a.trim().split(o),s=c,t=c.length,i=e.length;switch(i){case 0:case 1:for(var f=0,n=0===i?"":e[0]+" ";f<t;++f)s[f]=Je(n,s[f],r,i).trim();break;default:f=0;var l=0;for(s=[];f<t;++f)for(var h=0;h<i;++h)s[l++]=Je(e[h]+" ",c[f],r,i).trim()}return s}function Je(e,a,r,c){var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);switch(t){case P:switch(ge+c){case 0:case 1:if(0===e.trim().length)break;default:return s.replace(h,"$1"+e.trim())}break;case V:switch(s.charCodeAt(1)){case 103:if(Ce>0&&ge>0)return s.replace(u,"$1").replace(h,"$1"+Ge);break;default:return e.trim()+s.replace(h,"$1"+e.trim())}default:if(r*ge>0&&s.indexOf("\f")>0)return s.replace(h,(e.charCodeAt(0)===V?"":"$1")+e.trim())}return e+s}function Ke(e,a,r,c){var l,o=0,h=e+";",u=2*a+3*r+4*c;if(944===u)return function(e){var a=e.length,r=e.indexOf(":",9)+1,c=e.substring(0,r).trim(),s=e.substring(r,a-1).trim();switch(e.charCodeAt(9)*Be){case 0:break;case Q:if(110!==e.charCodeAt(10))break;default:for(var t=s.split((s="",f)),i=0,r=0,a=t.length;i<a;r=0,++i){for(var l=t[i],o=l.split(n);l=o[r];){var h=l.charCodeAt(0);if(1===Be&&(h>L&&h<90||h>96&&h<123||h===R||h===Q&&l.charCodeAt(1)!==Q))switch(isNaN(parseFloat(l))+(-1!==l.indexOf("("))){case 1:switch(l){case"infinite":case"alternate":case"backwards":case"running":case"normal":case"forwards":case"both":case"none":case"linear":case"ease":case"ease-in":case"ease-out":case"ease-in-out":case"paused":case"reverse":case"alternate-reverse":case"inherit":case"initial":case"unset":case"step-start":case"step-end":break;default:l+=De}}o[r++]=l}s+=(0===i?"":",")+o.join(" ")}}if(s=c+s+";",1===Ae||2===Ae&&Le(s,1))return N+s+s;return s}(h);else if(0===Ae||2===Ae&&!Le(h,1))return h;switch(u){case 1015:return 97===h.charCodeAt(10)?N+h+h:h;case 951:return 116===h.charCodeAt(3)?N+h+h:h;case 963:return 110===h.charCodeAt(5)?N+h+h:h;case 1009:if(100!==h.charCodeAt(4))break;case 969:case 942:return N+h+h;case 978:return N+h+S+h+h;case 1019:case 983:return N+h+S+h+F+h+h;case 883:if(h.charCodeAt(8)===Q)return N+h+h;if(h.indexOf("image-set(",11)>0)return h.replace(z,"$1"+N+"$2")+h;return h;case 932:if(h.charCodeAt(4)===Q)switch(h.charCodeAt(5)){case 103:return N+"box-"+h.replace("-grow","")+N+h+F+h.replace("grow","positive")+h;case 115:return N+h+F+h.replace("shrink","negative")+h;case 98:return N+h+F+h.replace("basis","preferred-size")+h}return N+h+F+h+h;case 964:return N+h+F+"flex-"+h+h;case 1023:if(99!==h.charCodeAt(8))break;return l=h.substring(h.indexOf(":",15)).replace("flex-","").replace("space-between","justify"),N+"box-pack"+l+N+h+F+"flex-pack"+l+h;case 1005:return t.test(h)?h.replace(s,":"+N)+h.replace(s,":"+S)+h:h;case 1e3:switch(o=(l=h.substring(13).trim()).indexOf("-")+1,l.charCodeAt(0)+l.charCodeAt(o)){case 226:l=h.replace(m,"tb");break;case 232:l=h.replace(m,"tb-rl");break;case 220:l=h.replace(m,"lr");break;default:return h}return N+h+F+l+h;case 1017:if(-1===h.indexOf("sticky",9))return h;case 975:switch(o=(h=e).length-10,u=(l=(33===h.charCodeAt(o)?h.substring(0,o):h).substring(e.indexOf(":",7)+1).trim()).charCodeAt(0)+(0|l.charCodeAt(7))){case 203:if(l.charCodeAt(8)<111)break;case 115:h=h.replace(l,N+l)+";"+h;break;case 207:case 102:h=h.replace(l,N+(u>102?"inline-":"")+"box")+";"+h.replace(l,N+l)+";"+h.replace(l,F+l+"box")+";"+h}return h+";";case 938:if(h.charCodeAt(5)===Q)switch(h.charCodeAt(6)){case 105:return l=h.replace("-items",""),N+h+N+"box-"+l+F+"flex-"+l+h;case 115:return N+h+F+"flex-item-"+h.replace(y,"")+h;default:return N+h+F+"flex-line-pack"+h.replace("align-content","").replace(y,"")+h}break;case 973:case 989:if(h.charCodeAt(3)!==Q||122===h.charCodeAt(4))break;case 931:case 953:if(true===j.test(e))if(115===(l=e.substring(e.indexOf(":")+1)).charCodeAt(0))return Ke(e.replace("stretch","fill-available"),a,r,c).replace(":fill-available",":stretch");else return h.replace(l,N+l)+h.replace(l,S+l.replace("fill-",""))+h;break;case 962:if(h=N+h+(102===h.charCodeAt(5)?F+h:"")+h,r+c===211&&105===h.charCodeAt(13)&&h.indexOf("transform",10)>0)return h.substring(0,h.indexOf(";",27)+1).replace(i,"$1"+N+"$2")+h}return h}function Le(e,a){var r=e.indexOf(1===a?":":"{"),c=e.substring(0,3!==a?r:10),s=e.substring(r+1,e.length-1);return Oe(2!==a?c:c.replace(O,"$1"),s,a)}function Me(e,a){var r=Ke(a,a.charCodeAt(0),a.charCodeAt(1),a.charCodeAt(2));return r!==a+";"?r.replace($," or ($1)").substring(4):"("+a+")"}function Pe(e,a,r,c,s,t,i,f,n,l){for(var o,h=0,u=a;h<ye;++h)switch(o=$e[h].call(Te,e,u,r,c,s,t,i,f,n,l)){case void 0:case false:case true:case null:break;default:u=o}if(u!==a)return u}function Qe(e,a,r,c){for(var s=a+1;s<r;++s)switch(c.charCodeAt(s)){case Z:if(e===T)if(c.charCodeAt(s-1)===T&&a+2!==s)return s+1;break;case I:if(e===Z)return s+1}return s}function Re(e){for(var a in e){var r=e[a];switch(a){case"keyframe":Be=0|r;break;case"global":Ce=0|r;break;case"cascade":ge=0|r;break;case"compress":we=0|r;break;case"semicolon":ve=0|r;break;case"preserve":me=0|r;break;case"prefix":if(Oe=null,!r)Ae=0;else if("function"!=typeof r)Ae=1;else Ae=2,Oe=r}}return Re}function Te(a,r){if(void 0!==this&&this.constructor===Te)return e(a);var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);if(Be>0)De=s.replace(d,t===G?"":"-");if(t=1,1===ge)Ge=s;else Ee=s;var i,f=[Ge];if(ye>0)if(void 0!==(i=Pe(ze,r,f,f,pe,be,0,0,0,0))&&"string"==typeof i)r=i;var n=He(xe,f,r,0,0);if(ye>0)if(void 0!==(i=Pe(je,n,f,f,pe,be,n.length,0,0,0))&&"string"!=typeof(n=i))t=0;return De="",Ge="",Ee="",ke=0,pe=1,be=1,we*t==0?n:n.replace(c,"").replace(g,"").replace(A,"$1").replace(C,"$1").replace(w," ")}if(Te.use=function e(a){switch(a){case void 0:case null:ye=$e.length=0;break;default:if("function"==typeof a)$e[ye++]=a;else if("object"==typeof a)for(var r=0,c=a.length;r<c;++r)e(a[r]);else qe=0|!!a}return e},Te.set=Re,void 0!==a)Re(a);return Te});
	//# sourceMappingURL=stylis.min.js.map

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    var provided = typeof message === 'function' ? message() : message;
	    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
	    throw new Error(value);
	}
	
	module.exports = invariant;


/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),
/* 2117 */
/***/ (function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2117);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// commons-cc7906da72be8054550c.js